(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("vTYgb", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $05fe50070110e0ee$export$ffb0004e005737fa; }, function (v) { return $05fe50070110e0ee$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $05fe50070110e0ee$export$34b9dba7ce09269b; }, function (v) { return $05fe50070110e0ee$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $05fe50070110e0ee$export$25062201e9e25d76; }, function (v) { return $05fe50070110e0ee$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $05fe50070110e0ee$export$ffb0004e005737fa;
var $05fe50070110e0ee$export$34b9dba7ce09269b;
var $05fe50070110e0ee$export$25062201e9e25d76;
'use strict';

var $5pP8j = parcelRequire("5pP8j");
var $05fe50070110e0ee$var$k = Symbol.for("react.element"), $05fe50070110e0ee$var$l = Symbol.for("react.fragment"), $05fe50070110e0ee$var$m = Object.prototype.hasOwnProperty, $05fe50070110e0ee$var$n = $5pP8j.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $05fe50070110e0ee$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $05fe50070110e0ee$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$05fe50070110e0ee$var$m.call(a, b) && !$05fe50070110e0ee$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $05fe50070110e0ee$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $05fe50070110e0ee$var$n.current
    };
}
$05fe50070110e0ee$export$ffb0004e005737fa = $05fe50070110e0ee$var$l;
$05fe50070110e0ee$export$34b9dba7ce09269b = $05fe50070110e0ee$var$q;
$05fe50070110e0ee$export$25062201e9e25d76 = $05fe50070110e0ee$var$q;

});
parcelRegister("5pP8j", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2xt9A"));

});
parcelRegister("2xt9A", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $1d95471fd36e8c0c$export$dca3b0875bd9a954; }, function (v) { return $1d95471fd36e8c0c$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $1d95471fd36e8c0c$export$16fa2f45be04daa8; }, function (v) { return $1d95471fd36e8c0c$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1d95471fd36e8c0c$export$ffb0004e005737fa; }, function (v) { return $1d95471fd36e8c0c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $1d95471fd36e8c0c$export$e2c29f18771995cb; }, function (v) { return $1d95471fd36e8c0c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $1d95471fd36e8c0c$export$221d75b3f55bb0bd; }, function (v) { return $1d95471fd36e8c0c$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1d95471fd36e8c0c$export$5f8d39834fd61797; }, function (v) { return $1d95471fd36e8c0c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1d95471fd36e8c0c$export$74bf444e3cd11ea5; }, function (v) { return $1d95471fd36e8c0c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $1d95471fd36e8c0c$export$ae55be85d98224ed; }, function (v) { return $1d95471fd36e8c0c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $1d95471fd36e8c0c$export$e530037191fcd5d7; }, function (v) { return $1d95471fd36e8c0c$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $1d95471fd36e8c0c$export$fd42f52fd3ae1109; }, function (v) { return $1d95471fd36e8c0c$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $1d95471fd36e8c0c$export$c8a8987d4410bf2d; }, function (v) { return $1d95471fd36e8c0c$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $1d95471fd36e8c0c$export$d38cd72104c1f0e9; }, function (v) { return $1d95471fd36e8c0c$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $1d95471fd36e8c0c$export$7d1e3a5e95ceca43; }, function (v) { return $1d95471fd36e8c0c$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $1d95471fd36e8c0c$export$257a8862b851cb5b; }, function (v) { return $1d95471fd36e8c0c$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $1d95471fd36e8c0c$export$a8257692ac88316c; }, function (v) { return $1d95471fd36e8c0c$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $1d95471fd36e8c0c$export$488013bae63b21da; }, function (v) { return $1d95471fd36e8c0c$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $1d95471fd36e8c0c$export$7c73462e0d25e514; }, function (v) { return $1d95471fd36e8c0c$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $1d95471fd36e8c0c$export$7568632d0d33d16d; }, function (v) { return $1d95471fd36e8c0c$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $1d95471fd36e8c0c$export$88948ce120ea2619; }, function (v) { return $1d95471fd36e8c0c$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $1d95471fd36e8c0c$export$35808ee640e87ca7; }, function (v) { return $1d95471fd36e8c0c$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $1d95471fd36e8c0c$export$fae74005e78b1a27; }, function (v) { return $1d95471fd36e8c0c$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $1d95471fd36e8c0c$export$dc8fbce3eb94dc1e; }, function (v) { return $1d95471fd36e8c0c$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $1d95471fd36e8c0c$export$6a7bc4e911dc01cf; }, function (v) { return $1d95471fd36e8c0c$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $1d95471fd36e8c0c$export$6d9c69b0de29b591; }, function (v) { return $1d95471fd36e8c0c$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $1d95471fd36e8c0c$export$f680877a34711e37; }, function (v) { return $1d95471fd36e8c0c$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $1d95471fd36e8c0c$export$d5a552a76deda3c2; }, function (v) { return $1d95471fd36e8c0c$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $1d95471fd36e8c0c$export$aaabe4eda9ed9969; }, function (v) { return $1d95471fd36e8c0c$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $1d95471fd36e8c0c$export$e5c5a5f917a5871c; }, function (v) { return $1d95471fd36e8c0c$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $1d95471fd36e8c0c$export$1538c33de8887b59; }, function (v) { return $1d95471fd36e8c0c$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $1d95471fd36e8c0c$export$13e3392192263954; }, function (v) { return $1d95471fd36e8c0c$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $1d95471fd36e8c0c$export$b8f5890fc79d6aca; }, function (v) { return $1d95471fd36e8c0c$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $1d95471fd36e8c0c$export$60241385465d0a34; }, function (v) { return $1d95471fd36e8c0c$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $1d95471fd36e8c0c$export$306c0aa65ff9ec16; }, function (v) { return $1d95471fd36e8c0c$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $1d95471fd36e8c0c$export$7b286972b8d8ccbf; }, function (v) { return $1d95471fd36e8c0c$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $1d95471fd36e8c0c$export$83d89fbfd8236492; }, function (v) { return $1d95471fd36e8c0c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1d95471fd36e8c0c$export$dca3b0875bd9a954;
var $1d95471fd36e8c0c$export$16fa2f45be04daa8;
var $1d95471fd36e8c0c$export$ffb0004e005737fa;
var $1d95471fd36e8c0c$export$e2c29f18771995cb;
var $1d95471fd36e8c0c$export$221d75b3f55bb0bd;
var $1d95471fd36e8c0c$export$5f8d39834fd61797;
var $1d95471fd36e8c0c$export$74bf444e3cd11ea5;
var $1d95471fd36e8c0c$export$ae55be85d98224ed;
var $1d95471fd36e8c0c$export$e530037191fcd5d7;
var $1d95471fd36e8c0c$export$fd42f52fd3ae1109;
var $1d95471fd36e8c0c$export$c8a8987d4410bf2d;
var $1d95471fd36e8c0c$export$d38cd72104c1f0e9;
var $1d95471fd36e8c0c$export$7d1e3a5e95ceca43;
var $1d95471fd36e8c0c$export$257a8862b851cb5b;
var $1d95471fd36e8c0c$export$a8257692ac88316c;
var $1d95471fd36e8c0c$export$488013bae63b21da;
var $1d95471fd36e8c0c$export$7c73462e0d25e514;
var $1d95471fd36e8c0c$export$7568632d0d33d16d;
var $1d95471fd36e8c0c$export$88948ce120ea2619;
var $1d95471fd36e8c0c$export$35808ee640e87ca7;
var $1d95471fd36e8c0c$export$fae74005e78b1a27;
var $1d95471fd36e8c0c$export$dc8fbce3eb94dc1e;
var $1d95471fd36e8c0c$export$6a7bc4e911dc01cf;
var $1d95471fd36e8c0c$export$6d9c69b0de29b591;
var $1d95471fd36e8c0c$export$f680877a34711e37;
var $1d95471fd36e8c0c$export$d5a552a76deda3c2;
var $1d95471fd36e8c0c$export$aaabe4eda9ed9969;
var $1d95471fd36e8c0c$export$e5c5a5f917a5871c;
var $1d95471fd36e8c0c$export$1538c33de8887b59;
var $1d95471fd36e8c0c$export$13e3392192263954;
var $1d95471fd36e8c0c$export$b8f5890fc79d6aca;
var $1d95471fd36e8c0c$export$60241385465d0a34;
var $1d95471fd36e8c0c$export$306c0aa65ff9ec16;
var $1d95471fd36e8c0c$export$7b286972b8d8ccbf;
var $1d95471fd36e8c0c$export$83d89fbfd8236492;
'use strict';
var $1d95471fd36e8c0c$var$l = Symbol.for("react.element"), $1d95471fd36e8c0c$var$n = Symbol.for("react.portal"), $1d95471fd36e8c0c$var$p = Symbol.for("react.fragment"), $1d95471fd36e8c0c$var$q = Symbol.for("react.strict_mode"), $1d95471fd36e8c0c$var$r = Symbol.for("react.profiler"), $1d95471fd36e8c0c$var$t = Symbol.for("react.provider"), $1d95471fd36e8c0c$var$u = Symbol.for("react.context"), $1d95471fd36e8c0c$var$v = Symbol.for("react.forward_ref"), $1d95471fd36e8c0c$var$w = Symbol.for("react.suspense"), $1d95471fd36e8c0c$var$x = Symbol.for("react.memo"), $1d95471fd36e8c0c$var$y = Symbol.for("react.lazy"), $1d95471fd36e8c0c$var$z = Symbol.iterator;
function $1d95471fd36e8c0c$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1d95471fd36e8c0c$var$z && a[$1d95471fd36e8c0c$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1d95471fd36e8c0c$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1d95471fd36e8c0c$var$C = Object.assign, $1d95471fd36e8c0c$var$D = {};
function $1d95471fd36e8c0c$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1d95471fd36e8c0c$var$D;
    this.updater = e || $1d95471fd36e8c0c$var$B;
}
$1d95471fd36e8c0c$var$E.prototype.isReactComponent = {};
$1d95471fd36e8c0c$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1d95471fd36e8c0c$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1d95471fd36e8c0c$var$F() {}
$1d95471fd36e8c0c$var$F.prototype = $1d95471fd36e8c0c$var$E.prototype;
function $1d95471fd36e8c0c$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1d95471fd36e8c0c$var$D;
    this.updater = e || $1d95471fd36e8c0c$var$B;
}
var $1d95471fd36e8c0c$var$H = $1d95471fd36e8c0c$var$G.prototype = new $1d95471fd36e8c0c$var$F;
$1d95471fd36e8c0c$var$H.constructor = $1d95471fd36e8c0c$var$G;
$1d95471fd36e8c0c$var$C($1d95471fd36e8c0c$var$H, $1d95471fd36e8c0c$var$E.prototype);
$1d95471fd36e8c0c$var$H.isPureReactComponent = !0;
var $1d95471fd36e8c0c$var$I = Array.isArray, $1d95471fd36e8c0c$var$J = Object.prototype.hasOwnProperty, $1d95471fd36e8c0c$var$K = {
    current: null
}, $1d95471fd36e8c0c$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1d95471fd36e8c0c$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1d95471fd36e8c0c$var$J.call(b, d) && !$1d95471fd36e8c0c$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1d95471fd36e8c0c$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1d95471fd36e8c0c$var$K.current
    };
}
function $1d95471fd36e8c0c$var$N(a, b) {
    return {
        $$typeof: $1d95471fd36e8c0c$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1d95471fd36e8c0c$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1d95471fd36e8c0c$var$l;
}
function $1d95471fd36e8c0c$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1d95471fd36e8c0c$var$P = /\/+/g;
function $1d95471fd36e8c0c$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1d95471fd36e8c0c$var$escape("" + a.key) : b.toString(36);
}
function $1d95471fd36e8c0c$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1d95471fd36e8c0c$var$l:
                case $1d95471fd36e8c0c$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1d95471fd36e8c0c$var$Q(h, 0) : d, $1d95471fd36e8c0c$var$I(c) ? (e = "", null != a && (e = a.replace($1d95471fd36e8c0c$var$P, "$&/") + "/"), $1d95471fd36e8c0c$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1d95471fd36e8c0c$var$O(c) && (c = $1d95471fd36e8c0c$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1d95471fd36e8c0c$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1d95471fd36e8c0c$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1d95471fd36e8c0c$var$Q(k, g);
        h += $1d95471fd36e8c0c$var$R(k, b, e, f, c);
    }
    else if (f = $1d95471fd36e8c0c$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1d95471fd36e8c0c$var$Q(k, g++), h += $1d95471fd36e8c0c$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1d95471fd36e8c0c$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1d95471fd36e8c0c$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1d95471fd36e8c0c$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1d95471fd36e8c0c$var$U = {
    current: null
}, $1d95471fd36e8c0c$var$V = {
    transition: null
}, $1d95471fd36e8c0c$var$W = {
    ReactCurrentDispatcher: $1d95471fd36e8c0c$var$U,
    ReactCurrentBatchConfig: $1d95471fd36e8c0c$var$V,
    ReactCurrentOwner: $1d95471fd36e8c0c$var$K
};
$1d95471fd36e8c0c$export$dca3b0875bd9a954 = {
    map: $1d95471fd36e8c0c$var$S,
    forEach: function(a, b, e) {
        $1d95471fd36e8c0c$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1d95471fd36e8c0c$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1d95471fd36e8c0c$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1d95471fd36e8c0c$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1d95471fd36e8c0c$export$16fa2f45be04daa8 = $1d95471fd36e8c0c$var$E;
$1d95471fd36e8c0c$export$ffb0004e005737fa = $1d95471fd36e8c0c$var$p;
$1d95471fd36e8c0c$export$e2c29f18771995cb = $1d95471fd36e8c0c$var$r;
$1d95471fd36e8c0c$export$221d75b3f55bb0bd = $1d95471fd36e8c0c$var$G;
$1d95471fd36e8c0c$export$5f8d39834fd61797 = $1d95471fd36e8c0c$var$q;
$1d95471fd36e8c0c$export$74bf444e3cd11ea5 = $1d95471fd36e8c0c$var$w;
$1d95471fd36e8c0c$export$ae55be85d98224ed = $1d95471fd36e8c0c$var$W;
$1d95471fd36e8c0c$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1d95471fd36e8c0c$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1d95471fd36e8c0c$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1d95471fd36e8c0c$var$J.call(b, f) && !$1d95471fd36e8c0c$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1d95471fd36e8c0c$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1d95471fd36e8c0c$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1d95471fd36e8c0c$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1d95471fd36e8c0c$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1d95471fd36e8c0c$export$c8a8987d4410bf2d = $1d95471fd36e8c0c$var$M;
$1d95471fd36e8c0c$export$d38cd72104c1f0e9 = function(a) {
    var b = $1d95471fd36e8c0c$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1d95471fd36e8c0c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1d95471fd36e8c0c$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1d95471fd36e8c0c$var$v,
        render: a
    };
};
$1d95471fd36e8c0c$export$a8257692ac88316c = $1d95471fd36e8c0c$var$O;
$1d95471fd36e8c0c$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1d95471fd36e8c0c$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1d95471fd36e8c0c$var$T
    };
};
$1d95471fd36e8c0c$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1d95471fd36e8c0c$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1d95471fd36e8c0c$export$7568632d0d33d16d = function(a) {
    var b = $1d95471fd36e8c0c$var$V.transition;
    $1d95471fd36e8c0c$var$V.transition = {};
    try {
        a();
    } finally{
        $1d95471fd36e8c0c$var$V.transition = b;
    }
};
$1d95471fd36e8c0c$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1d95471fd36e8c0c$export$35808ee640e87ca7 = function(a, b) {
    return $1d95471fd36e8c0c$var$U.current.useCallback(a, b);
};
$1d95471fd36e8c0c$export$fae74005e78b1a27 = function(a) {
    return $1d95471fd36e8c0c$var$U.current.useContext(a);
};
$1d95471fd36e8c0c$export$dc8fbce3eb94dc1e = function() {};
$1d95471fd36e8c0c$export$6a7bc4e911dc01cf = function(a) {
    return $1d95471fd36e8c0c$var$U.current.useDeferredValue(a);
};
$1d95471fd36e8c0c$export$6d9c69b0de29b591 = function(a, b) {
    return $1d95471fd36e8c0c$var$U.current.useEffect(a, b);
};
$1d95471fd36e8c0c$export$f680877a34711e37 = function() {
    return $1d95471fd36e8c0c$var$U.current.useId();
};
$1d95471fd36e8c0c$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1d95471fd36e8c0c$var$U.current.useImperativeHandle(a, b, e);
};
$1d95471fd36e8c0c$export$aaabe4eda9ed9969 = function(a, b) {
    return $1d95471fd36e8c0c$var$U.current.useInsertionEffect(a, b);
};
$1d95471fd36e8c0c$export$e5c5a5f917a5871c = function(a, b) {
    return $1d95471fd36e8c0c$var$U.current.useLayoutEffect(a, b);
};
$1d95471fd36e8c0c$export$1538c33de8887b59 = function(a, b) {
    return $1d95471fd36e8c0c$var$U.current.useMemo(a, b);
};
$1d95471fd36e8c0c$export$13e3392192263954 = function(a, b, e) {
    return $1d95471fd36e8c0c$var$U.current.useReducer(a, b, e);
};
$1d95471fd36e8c0c$export$b8f5890fc79d6aca = function(a) {
    return $1d95471fd36e8c0c$var$U.current.useRef(a);
};
$1d95471fd36e8c0c$export$60241385465d0a34 = function(a) {
    return $1d95471fd36e8c0c$var$U.current.useState(a);
};
$1d95471fd36e8c0c$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1d95471fd36e8c0c$var$U.current.useSyncExternalStore(a, b, e);
};
$1d95471fd36e8c0c$export$7b286972b8d8ccbf = function() {
    return $1d95471fd36e8c0c$var$U.current.useTransition();
};
$1d95471fd36e8c0c$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("bzs0j", function(module, exports) {
'use strict';
function $86c8af9b570b43fc$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($86c8af9b570b43fc$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$86c8af9b570b43fc$var$checkDCE();

module.exports = (parcelRequire("1RB9T"));

});
parcelRegister("1RB9T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $15b790985f0a6986$export$ae55be85d98224ed; }, function (v) { return $15b790985f0a6986$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $15b790985f0a6986$export$d39a5bbd09211389; }, function (v) { return $15b790985f0a6986$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $15b790985f0a6986$export$882461b6382ed46c; }, function (v) { return $15b790985f0a6986$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $15b790985f0a6986$export$466bfc07425424d5; }, function (v) { return $15b790985f0a6986$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $15b790985f0a6986$export$cd75ccfd720a3cd4; }, function (v) { return $15b790985f0a6986$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $15b790985f0a6986$export$fa8d919ba61d84db; }, function (v) { return $15b790985f0a6986$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $15b790985f0a6986$export$757ceba2d55c277e; }, function (v) { return $15b790985f0a6986$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $15b790985f0a6986$export$b3890eb0ae9dca99; }, function (v) { return $15b790985f0a6986$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $15b790985f0a6986$export$502457920280e6be; }, function (v) { return $15b790985f0a6986$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $15b790985f0a6986$export$c78a37762a8d58e1; }, function (v) { return $15b790985f0a6986$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $15b790985f0a6986$export$dc54d992c10e8a18; }, function (v) { return $15b790985f0a6986$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $15b790985f0a6986$export$83d89fbfd8236492; }, function (v) { return $15b790985f0a6986$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $15b790985f0a6986$export$ae55be85d98224ed;
var $15b790985f0a6986$export$d39a5bbd09211389;
var $15b790985f0a6986$export$882461b6382ed46c;
var $15b790985f0a6986$export$466bfc07425424d5;
var $15b790985f0a6986$export$cd75ccfd720a3cd4;
var $15b790985f0a6986$export$fa8d919ba61d84db;
var $15b790985f0a6986$export$757ceba2d55c277e;
var $15b790985f0a6986$export$b3890eb0ae9dca99;
var $15b790985f0a6986$export$502457920280e6be;
var $15b790985f0a6986$export$c78a37762a8d58e1;
var $15b790985f0a6986$export$dc54d992c10e8a18;
var $15b790985f0a6986$export$83d89fbfd8236492;
'use strict';

var $5pP8j = parcelRequire("5pP8j");

var $aqnAF = parcelRequire("aqnAF");
function $15b790985f0a6986$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $15b790985f0a6986$var$da = new Set, $15b790985f0a6986$var$ea = {};
function $15b790985f0a6986$var$fa(a, b) {
    $15b790985f0a6986$var$ha(a, b);
    $15b790985f0a6986$var$ha(a + "Capture", b);
}
function $15b790985f0a6986$var$ha(a, b) {
    $15b790985f0a6986$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$15b790985f0a6986$var$da.add(b[a]);
}
var $15b790985f0a6986$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $15b790985f0a6986$var$ja = Object.prototype.hasOwnProperty, $15b790985f0a6986$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $15b790985f0a6986$var$la = {}, $15b790985f0a6986$var$ma = {};
function $15b790985f0a6986$var$oa(a) {
    if ($15b790985f0a6986$var$ja.call($15b790985f0a6986$var$ma, a)) return !0;
    if ($15b790985f0a6986$var$ja.call($15b790985f0a6986$var$la, a)) return !1;
    if ($15b790985f0a6986$var$ka.test(a)) return $15b790985f0a6986$var$ma[a] = !0;
    $15b790985f0a6986$var$la[a] = !0;
    return !1;
}
function $15b790985f0a6986$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $15b790985f0a6986$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $15b790985f0a6986$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $15b790985f0a6986$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $15b790985f0a6986$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $15b790985f0a6986$var$z[a] = new $15b790985f0a6986$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $15b790985f0a6986$var$z[b] = new $15b790985f0a6986$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $15b790985f0a6986$var$z[a] = new $15b790985f0a6986$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $15b790985f0a6986$var$z[a] = new $15b790985f0a6986$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $15b790985f0a6986$var$z[a] = new $15b790985f0a6986$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $15b790985f0a6986$var$z[a] = new $15b790985f0a6986$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $15b790985f0a6986$var$z[a] = new $15b790985f0a6986$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $15b790985f0a6986$var$z[a] = new $15b790985f0a6986$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $15b790985f0a6986$var$z[a] = new $15b790985f0a6986$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $15b790985f0a6986$var$ra = /[\-:]([a-z])/g;
function $15b790985f0a6986$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($15b790985f0a6986$var$ra, $15b790985f0a6986$var$sa);
    $15b790985f0a6986$var$z[b] = new $15b790985f0a6986$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($15b790985f0a6986$var$ra, $15b790985f0a6986$var$sa);
    $15b790985f0a6986$var$z[b] = new $15b790985f0a6986$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($15b790985f0a6986$var$ra, $15b790985f0a6986$var$sa);
    $15b790985f0a6986$var$z[b] = new $15b790985f0a6986$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $15b790985f0a6986$var$z[a] = new $15b790985f0a6986$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$15b790985f0a6986$var$z.xlinkHref = new $15b790985f0a6986$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $15b790985f0a6986$var$z[a] = new $15b790985f0a6986$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $15b790985f0a6986$var$ta(a, b, c, d) {
    var e = $15b790985f0a6986$var$z.hasOwnProperty(b) ? $15b790985f0a6986$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $15b790985f0a6986$var$qa(b, c, e, d) && (c = null), d || null === e ? $15b790985f0a6986$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $15b790985f0a6986$var$ua = $5pP8j.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $15b790985f0a6986$var$va = Symbol.for("react.element"), $15b790985f0a6986$var$wa = Symbol.for("react.portal"), $15b790985f0a6986$var$ya = Symbol.for("react.fragment"), $15b790985f0a6986$var$za = Symbol.for("react.strict_mode"), $15b790985f0a6986$var$Aa = Symbol.for("react.profiler"), $15b790985f0a6986$var$Ba = Symbol.for("react.provider"), $15b790985f0a6986$var$Ca = Symbol.for("react.context"), $15b790985f0a6986$var$Da = Symbol.for("react.forward_ref"), $15b790985f0a6986$var$Ea = Symbol.for("react.suspense"), $15b790985f0a6986$var$Fa = Symbol.for("react.suspense_list"), $15b790985f0a6986$var$Ga = Symbol.for("react.memo"), $15b790985f0a6986$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $15b790985f0a6986$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $15b790985f0a6986$var$Ja = Symbol.iterator;
function $15b790985f0a6986$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $15b790985f0a6986$var$Ja && a[$15b790985f0a6986$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $15b790985f0a6986$var$A = Object.assign, $15b790985f0a6986$var$La;
function $15b790985f0a6986$var$Ma(a) {
    if (void 0 === $15b790985f0a6986$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $15b790985f0a6986$var$La = b && b[1] || "";
    }
    return "\n" + $15b790985f0a6986$var$La + a;
}
var $15b790985f0a6986$var$Na = !1;
function $15b790985f0a6986$var$Oa(a, b) {
    if (!a || $15b790985f0a6986$var$Na) return "";
    $15b790985f0a6986$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $15b790985f0a6986$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $15b790985f0a6986$var$Ma(a) : "";
}
function $15b790985f0a6986$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $15b790985f0a6986$var$Ma(a.type);
        case 16:
            return $15b790985f0a6986$var$Ma("Lazy");
        case 13:
            return $15b790985f0a6986$var$Ma("Suspense");
        case 19:
            return $15b790985f0a6986$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $15b790985f0a6986$var$Oa(a.type, !1), a;
        case 11:
            return a = $15b790985f0a6986$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $15b790985f0a6986$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $15b790985f0a6986$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $15b790985f0a6986$var$ya:
            return "Fragment";
        case $15b790985f0a6986$var$wa:
            return "Portal";
        case $15b790985f0a6986$var$Aa:
            return "Profiler";
        case $15b790985f0a6986$var$za:
            return "StrictMode";
        case $15b790985f0a6986$var$Ea:
            return "Suspense";
        case $15b790985f0a6986$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $15b790985f0a6986$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $15b790985f0a6986$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $15b790985f0a6986$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $15b790985f0a6986$var$Ga:
            return b = a.displayName || null, null !== b ? b : $15b790985f0a6986$var$Qa(a.type) || "Memo";
        case $15b790985f0a6986$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $15b790985f0a6986$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $15b790985f0a6986$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $15b790985f0a6986$var$Qa(b);
        case 8:
            return b === $15b790985f0a6986$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $15b790985f0a6986$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $15b790985f0a6986$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $15b790985f0a6986$var$Ua(a) {
    var b = $15b790985f0a6986$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $15b790985f0a6986$var$Va(a) {
    a._valueTracker || (a._valueTracker = $15b790985f0a6986$var$Ua(a));
}
function $15b790985f0a6986$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $15b790985f0a6986$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $15b790985f0a6986$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $15b790985f0a6986$var$Ya(a, b) {
    var c = b.checked;
    return $15b790985f0a6986$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $15b790985f0a6986$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $15b790985f0a6986$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $15b790985f0a6986$var$ab(a, b) {
    b = b.checked;
    null != b && $15b790985f0a6986$var$ta(a, "checked", b, !1);
}
function $15b790985f0a6986$var$bb(a, b) {
    $15b790985f0a6986$var$ab(a, b);
    var c = $15b790985f0a6986$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $15b790985f0a6986$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $15b790985f0a6986$var$cb(a, b.type, $15b790985f0a6986$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $15b790985f0a6986$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $15b790985f0a6986$var$cb(a, b, c) {
    if ("number" !== b || $15b790985f0a6986$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $15b790985f0a6986$var$eb = Array.isArray;
function $15b790985f0a6986$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $15b790985f0a6986$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $15b790985f0a6986$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($15b790985f0a6986$var$p(91));
    return $15b790985f0a6986$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $15b790985f0a6986$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($15b790985f0a6986$var$p(92));
            if ($15b790985f0a6986$var$eb(c)) {
                if (1 < c.length) throw Error($15b790985f0a6986$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $15b790985f0a6986$var$Sa(c)
    };
}
function $15b790985f0a6986$var$ib(a, b) {
    var c = $15b790985f0a6986$var$Sa(b.value), d = $15b790985f0a6986$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $15b790985f0a6986$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $15b790985f0a6986$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $15b790985f0a6986$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $15b790985f0a6986$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $15b790985f0a6986$var$mb, $15b790985f0a6986$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $15b790985f0a6986$var$mb = $15b790985f0a6986$var$mb || document.createElement("div");
        $15b790985f0a6986$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $15b790985f0a6986$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $15b790985f0a6986$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $15b790985f0a6986$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $15b790985f0a6986$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($15b790985f0a6986$var$pb).forEach(function(a) {
    $15b790985f0a6986$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $15b790985f0a6986$var$pb[b] = $15b790985f0a6986$var$pb[a];
    });
});
function $15b790985f0a6986$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $15b790985f0a6986$var$pb.hasOwnProperty(a) && $15b790985f0a6986$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $15b790985f0a6986$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $15b790985f0a6986$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $15b790985f0a6986$var$tb = $15b790985f0a6986$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $15b790985f0a6986$var$ub(a, b) {
    if (b) {
        if ($15b790985f0a6986$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($15b790985f0a6986$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($15b790985f0a6986$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($15b790985f0a6986$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($15b790985f0a6986$var$p(62));
    }
}
function $15b790985f0a6986$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $15b790985f0a6986$var$wb = null;
function $15b790985f0a6986$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $15b790985f0a6986$var$yb = null, $15b790985f0a6986$var$zb = null, $15b790985f0a6986$var$Ab = null;
function $15b790985f0a6986$var$Bb(a) {
    if (a = $15b790985f0a6986$var$Cb(a)) {
        if ("function" !== typeof $15b790985f0a6986$var$yb) throw Error($15b790985f0a6986$var$p(280));
        var b = a.stateNode;
        b && (b = $15b790985f0a6986$var$Db(b), $15b790985f0a6986$var$yb(a.stateNode, a.type, b));
    }
}
function $15b790985f0a6986$var$Eb(a) {
    $15b790985f0a6986$var$zb ? $15b790985f0a6986$var$Ab ? $15b790985f0a6986$var$Ab.push(a) : $15b790985f0a6986$var$Ab = [
        a
    ] : $15b790985f0a6986$var$zb = a;
}
function $15b790985f0a6986$var$Fb() {
    if ($15b790985f0a6986$var$zb) {
        var a = $15b790985f0a6986$var$zb, b = $15b790985f0a6986$var$Ab;
        $15b790985f0a6986$var$Ab = $15b790985f0a6986$var$zb = null;
        $15b790985f0a6986$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$15b790985f0a6986$var$Bb(b[a]);
    }
}
function $15b790985f0a6986$var$Gb(a, b) {
    return a(b);
}
function $15b790985f0a6986$var$Hb() {}
var $15b790985f0a6986$var$Ib = !1;
function $15b790985f0a6986$var$Jb(a, b, c) {
    if ($15b790985f0a6986$var$Ib) return a(b, c);
    $15b790985f0a6986$var$Ib = !0;
    try {
        return $15b790985f0a6986$var$Gb(a, b, c);
    } finally{
        if ($15b790985f0a6986$var$Ib = !1, null !== $15b790985f0a6986$var$zb || null !== $15b790985f0a6986$var$Ab) $15b790985f0a6986$var$Hb(), $15b790985f0a6986$var$Fb();
    }
}
function $15b790985f0a6986$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $15b790985f0a6986$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($15b790985f0a6986$var$p(231, b, typeof c));
    return c;
}
var $15b790985f0a6986$var$Lb = !1;
if ($15b790985f0a6986$var$ia) try {
    var $15b790985f0a6986$var$Mb = {};
    Object.defineProperty($15b790985f0a6986$var$Mb, "passive", {
        get: function() {
            $15b790985f0a6986$var$Lb = !0;
        }
    });
    window.addEventListener("test", $15b790985f0a6986$var$Mb, $15b790985f0a6986$var$Mb);
    window.removeEventListener("test", $15b790985f0a6986$var$Mb, $15b790985f0a6986$var$Mb);
} catch (a) {
    $15b790985f0a6986$var$Lb = !1;
}
function $15b790985f0a6986$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $15b790985f0a6986$var$Ob = !1, $15b790985f0a6986$var$Pb = null, $15b790985f0a6986$var$Qb = !1, $15b790985f0a6986$var$Rb = null, $15b790985f0a6986$var$Sb = {
    onError: function(a) {
        $15b790985f0a6986$var$Ob = !0;
        $15b790985f0a6986$var$Pb = a;
    }
};
function $15b790985f0a6986$var$Tb(a, b, c, d, e, f, g, h, k) {
    $15b790985f0a6986$var$Ob = !1;
    $15b790985f0a6986$var$Pb = null;
    $15b790985f0a6986$var$Nb.apply($15b790985f0a6986$var$Sb, arguments);
}
function $15b790985f0a6986$var$Ub(a, b, c, d, e, f, g, h, k) {
    $15b790985f0a6986$var$Tb.apply(this, arguments);
    if ($15b790985f0a6986$var$Ob) {
        if ($15b790985f0a6986$var$Ob) {
            var l = $15b790985f0a6986$var$Pb;
            $15b790985f0a6986$var$Ob = !1;
            $15b790985f0a6986$var$Pb = null;
        } else throw Error($15b790985f0a6986$var$p(198));
        $15b790985f0a6986$var$Qb || ($15b790985f0a6986$var$Qb = !0, $15b790985f0a6986$var$Rb = l);
    }
}
function $15b790985f0a6986$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $15b790985f0a6986$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $15b790985f0a6986$var$Xb(a) {
    if ($15b790985f0a6986$var$Vb(a) !== a) throw Error($15b790985f0a6986$var$p(188));
}
function $15b790985f0a6986$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $15b790985f0a6986$var$Vb(a);
        if (null === b) throw Error($15b790985f0a6986$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $15b790985f0a6986$var$Xb(e), a;
                if (f === d) return $15b790985f0a6986$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($15b790985f0a6986$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($15b790985f0a6986$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($15b790985f0a6986$var$p(190));
    }
    if (3 !== c.tag) throw Error($15b790985f0a6986$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $15b790985f0a6986$var$Zb(a) {
    a = $15b790985f0a6986$var$Yb(a);
    return null !== a ? $15b790985f0a6986$var$$b(a) : null;
}
function $15b790985f0a6986$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $15b790985f0a6986$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $15b790985f0a6986$var$ac = $aqnAF.unstable_scheduleCallback, $15b790985f0a6986$var$bc = $aqnAF.unstable_cancelCallback, $15b790985f0a6986$var$cc = $aqnAF.unstable_shouldYield, $15b790985f0a6986$var$dc = $aqnAF.unstable_requestPaint, $15b790985f0a6986$var$B = $aqnAF.unstable_now, $15b790985f0a6986$var$ec = $aqnAF.unstable_getCurrentPriorityLevel, $15b790985f0a6986$var$fc = $aqnAF.unstable_ImmediatePriority, $15b790985f0a6986$var$gc = $aqnAF.unstable_UserBlockingPriority, $15b790985f0a6986$var$hc = $aqnAF.unstable_NormalPriority, $15b790985f0a6986$var$ic = $aqnAF.unstable_LowPriority, $15b790985f0a6986$var$jc = $aqnAF.unstable_IdlePriority, $15b790985f0a6986$var$kc = null, $15b790985f0a6986$var$lc = null;
function $15b790985f0a6986$var$mc(a) {
    if ($15b790985f0a6986$var$lc && "function" === typeof $15b790985f0a6986$var$lc.onCommitFiberRoot) try {
        $15b790985f0a6986$var$lc.onCommitFiberRoot($15b790985f0a6986$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $15b790985f0a6986$var$oc = Math.clz32 ? Math.clz32 : $15b790985f0a6986$var$nc, $15b790985f0a6986$var$pc = Math.log, $15b790985f0a6986$var$qc = Math.LN2;
function $15b790985f0a6986$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($15b790985f0a6986$var$pc(a) / $15b790985f0a6986$var$qc | 0) | 0;
}
var $15b790985f0a6986$var$rc = 64, $15b790985f0a6986$var$sc = 4194304;
function $15b790985f0a6986$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $15b790985f0a6986$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $15b790985f0a6986$var$tc(h) : (f &= g, 0 !== f && (d = $15b790985f0a6986$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $15b790985f0a6986$var$tc(g) : 0 !== f && (d = $15b790985f0a6986$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $15b790985f0a6986$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $15b790985f0a6986$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $15b790985f0a6986$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $15b790985f0a6986$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $15b790985f0a6986$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $15b790985f0a6986$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $15b790985f0a6986$var$yc() {
    var a = $15b790985f0a6986$var$rc;
    $15b790985f0a6986$var$rc <<= 1;
    0 === ($15b790985f0a6986$var$rc & 4194240) && ($15b790985f0a6986$var$rc = 64);
    return a;
}
function $15b790985f0a6986$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $15b790985f0a6986$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $15b790985f0a6986$var$oc(b);
    a[b] = c;
}
function $15b790985f0a6986$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $15b790985f0a6986$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $15b790985f0a6986$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $15b790985f0a6986$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $15b790985f0a6986$var$C = 0;
function $15b790985f0a6986$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $15b790985f0a6986$var$Ec, $15b790985f0a6986$var$Fc, $15b790985f0a6986$var$Gc, $15b790985f0a6986$var$Hc, $15b790985f0a6986$var$Ic, $15b790985f0a6986$var$Jc = !1, $15b790985f0a6986$var$Kc = [], $15b790985f0a6986$var$Lc = null, $15b790985f0a6986$var$Mc = null, $15b790985f0a6986$var$Nc = null, $15b790985f0a6986$var$Oc = new Map, $15b790985f0a6986$var$Pc = new Map, $15b790985f0a6986$var$Qc = [], $15b790985f0a6986$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $15b790985f0a6986$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $15b790985f0a6986$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $15b790985f0a6986$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $15b790985f0a6986$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $15b790985f0a6986$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $15b790985f0a6986$var$Pc.delete(b.pointerId);
    }
}
function $15b790985f0a6986$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $15b790985f0a6986$var$Cb(b), null !== b && $15b790985f0a6986$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $15b790985f0a6986$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $15b790985f0a6986$var$Lc = $15b790985f0a6986$var$Tc($15b790985f0a6986$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $15b790985f0a6986$var$Mc = $15b790985f0a6986$var$Tc($15b790985f0a6986$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $15b790985f0a6986$var$Nc = $15b790985f0a6986$var$Tc($15b790985f0a6986$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $15b790985f0a6986$var$Oc.set(f, $15b790985f0a6986$var$Tc($15b790985f0a6986$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $15b790985f0a6986$var$Pc.set(f, $15b790985f0a6986$var$Tc($15b790985f0a6986$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $15b790985f0a6986$var$Vc(a) {
    var b = $15b790985f0a6986$var$Wc(a.target);
    if (null !== b) {
        var c = $15b790985f0a6986$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $15b790985f0a6986$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $15b790985f0a6986$var$Ic(a.priority, function() {
                        $15b790985f0a6986$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $15b790985f0a6986$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $15b790985f0a6986$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $15b790985f0a6986$var$wb = d;
            c.target.dispatchEvent(d);
            $15b790985f0a6986$var$wb = null;
        } else return b = $15b790985f0a6986$var$Cb(c), null !== b && $15b790985f0a6986$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $15b790985f0a6986$var$Zc(a, b, c) {
    $15b790985f0a6986$var$Xc(a) && c.delete(b);
}
function $15b790985f0a6986$var$$c() {
    $15b790985f0a6986$var$Jc = !1;
    null !== $15b790985f0a6986$var$Lc && $15b790985f0a6986$var$Xc($15b790985f0a6986$var$Lc) && ($15b790985f0a6986$var$Lc = null);
    null !== $15b790985f0a6986$var$Mc && $15b790985f0a6986$var$Xc($15b790985f0a6986$var$Mc) && ($15b790985f0a6986$var$Mc = null);
    null !== $15b790985f0a6986$var$Nc && $15b790985f0a6986$var$Xc($15b790985f0a6986$var$Nc) && ($15b790985f0a6986$var$Nc = null);
    $15b790985f0a6986$var$Oc.forEach($15b790985f0a6986$var$Zc);
    $15b790985f0a6986$var$Pc.forEach($15b790985f0a6986$var$Zc);
}
function $15b790985f0a6986$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $15b790985f0a6986$var$Jc || ($15b790985f0a6986$var$Jc = !0, $aqnAF.unstable_scheduleCallback($aqnAF.unstable_NormalPriority, $15b790985f0a6986$var$$c)));
}
function $15b790985f0a6986$var$bd(a) {
    function b(b) {
        return $15b790985f0a6986$var$ad(b, a);
    }
    if (0 < $15b790985f0a6986$var$Kc.length) {
        $15b790985f0a6986$var$ad($15b790985f0a6986$var$Kc[0], a);
        for(var c = 1; c < $15b790985f0a6986$var$Kc.length; c++){
            var d = $15b790985f0a6986$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $15b790985f0a6986$var$Lc && $15b790985f0a6986$var$ad($15b790985f0a6986$var$Lc, a);
    null !== $15b790985f0a6986$var$Mc && $15b790985f0a6986$var$ad($15b790985f0a6986$var$Mc, a);
    null !== $15b790985f0a6986$var$Nc && $15b790985f0a6986$var$ad($15b790985f0a6986$var$Nc, a);
    $15b790985f0a6986$var$Oc.forEach(b);
    $15b790985f0a6986$var$Pc.forEach(b);
    for(c = 0; c < $15b790985f0a6986$var$Qc.length; c++)d = $15b790985f0a6986$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $15b790985f0a6986$var$Qc.length && (c = $15b790985f0a6986$var$Qc[0], null === c.blockedOn);)$15b790985f0a6986$var$Vc(c), null === c.blockedOn && $15b790985f0a6986$var$Qc.shift();
}
var $15b790985f0a6986$var$cd = $15b790985f0a6986$var$ua.ReactCurrentBatchConfig, $15b790985f0a6986$var$dd = !0;
function $15b790985f0a6986$var$ed(a, b, c, d) {
    var e = $15b790985f0a6986$var$C, f = $15b790985f0a6986$var$cd.transition;
    $15b790985f0a6986$var$cd.transition = null;
    try {
        $15b790985f0a6986$var$C = 1, $15b790985f0a6986$var$fd(a, b, c, d);
    } finally{
        $15b790985f0a6986$var$C = e, $15b790985f0a6986$var$cd.transition = f;
    }
}
function $15b790985f0a6986$var$gd(a, b, c, d) {
    var e = $15b790985f0a6986$var$C, f = $15b790985f0a6986$var$cd.transition;
    $15b790985f0a6986$var$cd.transition = null;
    try {
        $15b790985f0a6986$var$C = 4, $15b790985f0a6986$var$fd(a, b, c, d);
    } finally{
        $15b790985f0a6986$var$C = e, $15b790985f0a6986$var$cd.transition = f;
    }
}
function $15b790985f0a6986$var$fd(a, b, c, d) {
    if ($15b790985f0a6986$var$dd) {
        var e = $15b790985f0a6986$var$Yc(a, b, c, d);
        if (null === e) $15b790985f0a6986$var$hd(a, b, d, $15b790985f0a6986$var$id, c), $15b790985f0a6986$var$Sc(a, d);
        else if ($15b790985f0a6986$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($15b790985f0a6986$var$Sc(a, d), b & 4 && -1 < $15b790985f0a6986$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $15b790985f0a6986$var$Cb(e);
                null !== f && $15b790985f0a6986$var$Ec(f);
                f = $15b790985f0a6986$var$Yc(a, b, c, d);
                null === f && $15b790985f0a6986$var$hd(a, b, d, $15b790985f0a6986$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $15b790985f0a6986$var$hd(a, b, d, null, c);
    }
}
var $15b790985f0a6986$var$id = null;
function $15b790985f0a6986$var$Yc(a, b, c, d) {
    $15b790985f0a6986$var$id = null;
    a = $15b790985f0a6986$var$xb(d);
    a = $15b790985f0a6986$var$Wc(a);
    if (null !== a) {
        if (b = $15b790985f0a6986$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $15b790985f0a6986$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $15b790985f0a6986$var$id = a;
    return null;
}
function $15b790985f0a6986$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($15b790985f0a6986$var$ec()){
                case $15b790985f0a6986$var$fc:
                    return 1;
                case $15b790985f0a6986$var$gc:
                    return 4;
                case $15b790985f0a6986$var$hc:
                case $15b790985f0a6986$var$ic:
                    return 16;
                case $15b790985f0a6986$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $15b790985f0a6986$var$kd = null, $15b790985f0a6986$var$ld = null, $15b790985f0a6986$var$md = null;
function $15b790985f0a6986$var$nd() {
    if ($15b790985f0a6986$var$md) return $15b790985f0a6986$var$md;
    var a, b = $15b790985f0a6986$var$ld, c = b.length, d, e = "value" in $15b790985f0a6986$var$kd ? $15b790985f0a6986$var$kd.value : $15b790985f0a6986$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $15b790985f0a6986$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $15b790985f0a6986$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $15b790985f0a6986$var$pd() {
    return !0;
}
function $15b790985f0a6986$var$qd() {
    return !1;
}
function $15b790985f0a6986$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $15b790985f0a6986$var$pd : $15b790985f0a6986$var$qd;
        this.isPropagationStopped = $15b790985f0a6986$var$qd;
        return this;
    }
    $15b790985f0a6986$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $15b790985f0a6986$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $15b790985f0a6986$var$pd);
        },
        persist: function() {},
        isPersistent: $15b790985f0a6986$var$pd
    });
    return b;
}
var $15b790985f0a6986$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $15b790985f0a6986$var$td = $15b790985f0a6986$var$rd($15b790985f0a6986$var$sd), $15b790985f0a6986$var$ud = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$sd, {
    view: 0,
    detail: 0
}), $15b790985f0a6986$var$vd = $15b790985f0a6986$var$rd($15b790985f0a6986$var$ud), $15b790985f0a6986$var$wd, $15b790985f0a6986$var$xd, $15b790985f0a6986$var$yd, $15b790985f0a6986$var$Ad = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $15b790985f0a6986$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $15b790985f0a6986$var$yd && ($15b790985f0a6986$var$yd && "mousemove" === a.type ? ($15b790985f0a6986$var$wd = a.screenX - $15b790985f0a6986$var$yd.screenX, $15b790985f0a6986$var$xd = a.screenY - $15b790985f0a6986$var$yd.screenY) : $15b790985f0a6986$var$xd = $15b790985f0a6986$var$wd = 0, $15b790985f0a6986$var$yd = a);
        return $15b790985f0a6986$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $15b790985f0a6986$var$xd;
    }
}), $15b790985f0a6986$var$Bd = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Ad), $15b790985f0a6986$var$Cd = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$Ad, {
    dataTransfer: 0
}), $15b790985f0a6986$var$Dd = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Cd), $15b790985f0a6986$var$Ed = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$ud, {
    relatedTarget: 0
}), $15b790985f0a6986$var$Fd = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Ed), $15b790985f0a6986$var$Gd = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $15b790985f0a6986$var$Hd = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Gd), $15b790985f0a6986$var$Id = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $15b790985f0a6986$var$Jd = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Id), $15b790985f0a6986$var$Kd = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$sd, {
    data: 0
}), $15b790985f0a6986$var$Ld = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Kd), $15b790985f0a6986$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $15b790985f0a6986$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $15b790985f0a6986$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $15b790985f0a6986$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $15b790985f0a6986$var$Od[a]) ? !!b[a] : !1;
}
function $15b790985f0a6986$var$zd() {
    return $15b790985f0a6986$var$Pd;
}
var $15b790985f0a6986$var$Qd = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $15b790985f0a6986$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $15b790985f0a6986$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $15b790985f0a6986$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $15b790985f0a6986$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $15b790985f0a6986$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $15b790985f0a6986$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $15b790985f0a6986$var$Rd = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Qd), $15b790985f0a6986$var$Sd = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $15b790985f0a6986$var$Td = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Sd), $15b790985f0a6986$var$Ud = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $15b790985f0a6986$var$zd
}), $15b790985f0a6986$var$Vd = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Ud), $15b790985f0a6986$var$Wd = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $15b790985f0a6986$var$Xd = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Wd), $15b790985f0a6986$var$Yd = $15b790985f0a6986$var$A({}, $15b790985f0a6986$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $15b790985f0a6986$var$Zd = $15b790985f0a6986$var$rd($15b790985f0a6986$var$Yd), $15b790985f0a6986$var$$d = [
    9,
    13,
    27,
    32
], $15b790985f0a6986$var$ae = $15b790985f0a6986$var$ia && "CompositionEvent" in window, $15b790985f0a6986$var$be = null;
$15b790985f0a6986$var$ia && "documentMode" in document && ($15b790985f0a6986$var$be = document.documentMode);
var $15b790985f0a6986$var$ce = $15b790985f0a6986$var$ia && "TextEvent" in window && !$15b790985f0a6986$var$be, $15b790985f0a6986$var$de = $15b790985f0a6986$var$ia && (!$15b790985f0a6986$var$ae || $15b790985f0a6986$var$be && 8 < $15b790985f0a6986$var$be && 11 >= $15b790985f0a6986$var$be), $15b790985f0a6986$var$ee = String.fromCharCode(32), $15b790985f0a6986$var$fe = !1;
function $15b790985f0a6986$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $15b790985f0a6986$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $15b790985f0a6986$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $15b790985f0a6986$var$ie = !1;
function $15b790985f0a6986$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $15b790985f0a6986$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $15b790985f0a6986$var$fe = !0;
            return $15b790985f0a6986$var$ee;
        case "textInput":
            return a = b.data, a === $15b790985f0a6986$var$ee && $15b790985f0a6986$var$fe ? null : a;
        default:
            return null;
    }
}
function $15b790985f0a6986$var$ke(a, b) {
    if ($15b790985f0a6986$var$ie) return "compositionend" === a || !$15b790985f0a6986$var$ae && $15b790985f0a6986$var$ge(a, b) ? (a = $15b790985f0a6986$var$nd(), $15b790985f0a6986$var$md = $15b790985f0a6986$var$ld = $15b790985f0a6986$var$kd = null, $15b790985f0a6986$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $15b790985f0a6986$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $15b790985f0a6986$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $15b790985f0a6986$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$15b790985f0a6986$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $15b790985f0a6986$var$ne(a, b, c, d) {
    $15b790985f0a6986$var$Eb(d);
    b = $15b790985f0a6986$var$oe(b, "onChange");
    0 < b.length && (c = new $15b790985f0a6986$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $15b790985f0a6986$var$pe = null, $15b790985f0a6986$var$qe = null;
function $15b790985f0a6986$var$re(a) {
    $15b790985f0a6986$var$se(a, 0);
}
function $15b790985f0a6986$var$te(a) {
    var b = $15b790985f0a6986$var$ue(a);
    if ($15b790985f0a6986$var$Wa(b)) return a;
}
function $15b790985f0a6986$var$ve(a, b) {
    if ("change" === a) return b;
}
var $15b790985f0a6986$var$we = !1;
if ($15b790985f0a6986$var$ia) {
    var $15b790985f0a6986$var$xe;
    if ($15b790985f0a6986$var$ia) {
        var $15b790985f0a6986$var$ye = "oninput" in document;
        if (!$15b790985f0a6986$var$ye) {
            var $15b790985f0a6986$var$ze = document.createElement("div");
            $15b790985f0a6986$var$ze.setAttribute("oninput", "return;");
            $15b790985f0a6986$var$ye = "function" === typeof $15b790985f0a6986$var$ze.oninput;
        }
        $15b790985f0a6986$var$xe = $15b790985f0a6986$var$ye;
    } else $15b790985f0a6986$var$xe = !1;
    $15b790985f0a6986$var$we = $15b790985f0a6986$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $15b790985f0a6986$var$Ae() {
    $15b790985f0a6986$var$pe && ($15b790985f0a6986$var$pe.detachEvent("onpropertychange", $15b790985f0a6986$var$Be), $15b790985f0a6986$var$qe = $15b790985f0a6986$var$pe = null);
}
function $15b790985f0a6986$var$Be(a) {
    if ("value" === a.propertyName && $15b790985f0a6986$var$te($15b790985f0a6986$var$qe)) {
        var b = [];
        $15b790985f0a6986$var$ne(b, $15b790985f0a6986$var$qe, a, $15b790985f0a6986$var$xb(a));
        $15b790985f0a6986$var$Jb($15b790985f0a6986$var$re, b);
    }
}
function $15b790985f0a6986$var$Ce(a, b, c) {
    "focusin" === a ? ($15b790985f0a6986$var$Ae(), $15b790985f0a6986$var$pe = b, $15b790985f0a6986$var$qe = c, $15b790985f0a6986$var$pe.attachEvent("onpropertychange", $15b790985f0a6986$var$Be)) : "focusout" === a && $15b790985f0a6986$var$Ae();
}
function $15b790985f0a6986$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $15b790985f0a6986$var$te($15b790985f0a6986$var$qe);
}
function $15b790985f0a6986$var$Ee(a, b) {
    if ("click" === a) return $15b790985f0a6986$var$te(b);
}
function $15b790985f0a6986$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $15b790985f0a6986$var$te(b);
}
function $15b790985f0a6986$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $15b790985f0a6986$var$He = "function" === typeof Object.is ? Object.is : $15b790985f0a6986$var$Ge;
function $15b790985f0a6986$var$Ie(a, b) {
    if ($15b790985f0a6986$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$15b790985f0a6986$var$ja.call(b, e) || !$15b790985f0a6986$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $15b790985f0a6986$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $15b790985f0a6986$var$Ke(a, b) {
    var c = $15b790985f0a6986$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $15b790985f0a6986$var$Je(c);
    }
}
function $15b790985f0a6986$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $15b790985f0a6986$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $15b790985f0a6986$var$Me() {
    for(var a = window, b = $15b790985f0a6986$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $15b790985f0a6986$var$Xa(a.document);
    }
    return b;
}
function $15b790985f0a6986$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $15b790985f0a6986$var$Oe(a) {
    var b = $15b790985f0a6986$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $15b790985f0a6986$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $15b790985f0a6986$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $15b790985f0a6986$var$Ke(c, f);
                var g = $15b790985f0a6986$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $15b790985f0a6986$var$Pe = $15b790985f0a6986$var$ia && "documentMode" in document && 11 >= document.documentMode, $15b790985f0a6986$var$Qe = null, $15b790985f0a6986$var$Re = null, $15b790985f0a6986$var$Se = null, $15b790985f0a6986$var$Te = !1;
function $15b790985f0a6986$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $15b790985f0a6986$var$Te || null == $15b790985f0a6986$var$Qe || $15b790985f0a6986$var$Qe !== $15b790985f0a6986$var$Xa(d) || (d = $15b790985f0a6986$var$Qe, "selectionStart" in d && $15b790985f0a6986$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $15b790985f0a6986$var$Se && $15b790985f0a6986$var$Ie($15b790985f0a6986$var$Se, d) || ($15b790985f0a6986$var$Se = d, d = $15b790985f0a6986$var$oe($15b790985f0a6986$var$Re, "onSelect"), 0 < d.length && (b = new $15b790985f0a6986$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $15b790985f0a6986$var$Qe)));
}
function $15b790985f0a6986$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $15b790985f0a6986$var$We = {
    animationend: $15b790985f0a6986$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $15b790985f0a6986$var$Ve("Animation", "AnimationIteration"),
    animationstart: $15b790985f0a6986$var$Ve("Animation", "AnimationStart"),
    transitionend: $15b790985f0a6986$var$Ve("Transition", "TransitionEnd")
}, $15b790985f0a6986$var$Xe = {}, $15b790985f0a6986$var$Ye = {};
$15b790985f0a6986$var$ia && ($15b790985f0a6986$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $15b790985f0a6986$var$We.animationend.animation, delete $15b790985f0a6986$var$We.animationiteration.animation, delete $15b790985f0a6986$var$We.animationstart.animation), "TransitionEvent" in window || delete $15b790985f0a6986$var$We.transitionend.transition);
function $15b790985f0a6986$var$Ze(a) {
    if ($15b790985f0a6986$var$Xe[a]) return $15b790985f0a6986$var$Xe[a];
    if (!$15b790985f0a6986$var$We[a]) return a;
    var b = $15b790985f0a6986$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $15b790985f0a6986$var$Ye) return $15b790985f0a6986$var$Xe[a] = b[c];
    return a;
}
var $15b790985f0a6986$var$$e = $15b790985f0a6986$var$Ze("animationend"), $15b790985f0a6986$var$af = $15b790985f0a6986$var$Ze("animationiteration"), $15b790985f0a6986$var$bf = $15b790985f0a6986$var$Ze("animationstart"), $15b790985f0a6986$var$cf = $15b790985f0a6986$var$Ze("transitionend"), $15b790985f0a6986$var$df = new Map, $15b790985f0a6986$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $15b790985f0a6986$var$ff(a, b) {
    $15b790985f0a6986$var$df.set(a, b);
    $15b790985f0a6986$var$fa(b, [
        a
    ]);
}
for(var $15b790985f0a6986$var$gf = 0; $15b790985f0a6986$var$gf < $15b790985f0a6986$var$ef.length; $15b790985f0a6986$var$gf++){
    var $15b790985f0a6986$var$hf = $15b790985f0a6986$var$ef[$15b790985f0a6986$var$gf], $15b790985f0a6986$var$jf = $15b790985f0a6986$var$hf.toLowerCase(), $15b790985f0a6986$var$kf = $15b790985f0a6986$var$hf[0].toUpperCase() + $15b790985f0a6986$var$hf.slice(1);
    $15b790985f0a6986$var$ff($15b790985f0a6986$var$jf, "on" + $15b790985f0a6986$var$kf);
}
$15b790985f0a6986$var$ff($15b790985f0a6986$var$$e, "onAnimationEnd");
$15b790985f0a6986$var$ff($15b790985f0a6986$var$af, "onAnimationIteration");
$15b790985f0a6986$var$ff($15b790985f0a6986$var$bf, "onAnimationStart");
$15b790985f0a6986$var$ff("dblclick", "onDoubleClick");
$15b790985f0a6986$var$ff("focusin", "onFocus");
$15b790985f0a6986$var$ff("focusout", "onBlur");
$15b790985f0a6986$var$ff($15b790985f0a6986$var$cf, "onTransitionEnd");
$15b790985f0a6986$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$15b790985f0a6986$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$15b790985f0a6986$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$15b790985f0a6986$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$15b790985f0a6986$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$15b790985f0a6986$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$15b790985f0a6986$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$15b790985f0a6986$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$15b790985f0a6986$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$15b790985f0a6986$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $15b790985f0a6986$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $15b790985f0a6986$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($15b790985f0a6986$var$lf));
function $15b790985f0a6986$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $15b790985f0a6986$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $15b790985f0a6986$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $15b790985f0a6986$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $15b790985f0a6986$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($15b790985f0a6986$var$Qb) throw a = $15b790985f0a6986$var$Rb, $15b790985f0a6986$var$Qb = !1, $15b790985f0a6986$var$Rb = null, a;
}
function $15b790985f0a6986$var$D(a, b) {
    var c = b[$15b790985f0a6986$var$of];
    void 0 === c && (c = b[$15b790985f0a6986$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($15b790985f0a6986$var$pf(b, a, 2, !1), c.add(d));
}
function $15b790985f0a6986$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $15b790985f0a6986$var$pf(c, a, d, b);
}
var $15b790985f0a6986$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $15b790985f0a6986$var$sf(a) {
    if (!a[$15b790985f0a6986$var$rf]) {
        a[$15b790985f0a6986$var$rf] = !0;
        $15b790985f0a6986$var$da.forEach(function(b) {
            "selectionchange" !== b && ($15b790985f0a6986$var$mf.has(b) || $15b790985f0a6986$var$qf(b, !1, a), $15b790985f0a6986$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$15b790985f0a6986$var$rf] || (b[$15b790985f0a6986$var$rf] = !0, $15b790985f0a6986$var$qf("selectionchange", !1, b));
    }
}
function $15b790985f0a6986$var$pf(a, b, c, d) {
    switch($15b790985f0a6986$var$jd(b)){
        case 1:
            var e = $15b790985f0a6986$var$ed;
            break;
        case 4:
            e = $15b790985f0a6986$var$gd;
            break;
        default:
            e = $15b790985f0a6986$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$15b790985f0a6986$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $15b790985f0a6986$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $15b790985f0a6986$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $15b790985f0a6986$var$Jb(function() {
        var d = f, e = $15b790985f0a6986$var$xb(c), g = [];
        a: {
            var h = $15b790985f0a6986$var$df.get(a);
            if (void 0 !== h) {
                var k = $15b790985f0a6986$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $15b790985f0a6986$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $15b790985f0a6986$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $15b790985f0a6986$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $15b790985f0a6986$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $15b790985f0a6986$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $15b790985f0a6986$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $15b790985f0a6986$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $15b790985f0a6986$var$Vd;
                        break;
                    case $15b790985f0a6986$var$$e:
                    case $15b790985f0a6986$var$af:
                    case $15b790985f0a6986$var$bf:
                        k = $15b790985f0a6986$var$Hd;
                        break;
                    case $15b790985f0a6986$var$cf:
                        k = $15b790985f0a6986$var$Xd;
                        break;
                    case "scroll":
                        k = $15b790985f0a6986$var$vd;
                        break;
                    case "wheel":
                        k = $15b790985f0a6986$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $15b790985f0a6986$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $15b790985f0a6986$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $15b790985f0a6986$var$Kb(w, x), null != F && t.push($15b790985f0a6986$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $15b790985f0a6986$var$wb && (n = c.relatedTarget || c.fromElement) && ($15b790985f0a6986$var$Wc(n) || n[$15b790985f0a6986$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $15b790985f0a6986$var$Wc(n) : null, null !== n && (J = $15b790985f0a6986$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $15b790985f0a6986$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $15b790985f0a6986$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $15b790985f0a6986$var$ue(k);
                        u = null == n ? h : $15b790985f0a6986$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $15b790985f0a6986$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $15b790985f0a6986$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $15b790985f0a6986$var$vf(F))u++;
                            for(; 0 < w - u;)t = $15b790985f0a6986$var$vf(t), w--;
                            for(; 0 < u - w;)x = $15b790985f0a6986$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $15b790985f0a6986$var$vf(t);
                                x = $15b790985f0a6986$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $15b790985f0a6986$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $15b790985f0a6986$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $15b790985f0a6986$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $15b790985f0a6986$var$ve;
                else if ($15b790985f0a6986$var$me(h)) {
                    if ($15b790985f0a6986$var$we) na = $15b790985f0a6986$var$Fe;
                    else {
                        na = $15b790985f0a6986$var$De;
                        var xa = $15b790985f0a6986$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $15b790985f0a6986$var$Ee);
                if (na && (na = na(a, d))) {
                    $15b790985f0a6986$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $15b790985f0a6986$var$cb(h, "number", h.value);
            }
            xa = d ? $15b790985f0a6986$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($15b790985f0a6986$var$me(xa) || "true" === xa.contentEditable) $15b790985f0a6986$var$Qe = xa, $15b790985f0a6986$var$Re = d, $15b790985f0a6986$var$Se = null;
                    break;
                case "focusout":
                    $15b790985f0a6986$var$Se = $15b790985f0a6986$var$Re = $15b790985f0a6986$var$Qe = null;
                    break;
                case "mousedown":
                    $15b790985f0a6986$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $15b790985f0a6986$var$Te = !1;
                    $15b790985f0a6986$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($15b790985f0a6986$var$Pe) break;
                case "keydown":
                case "keyup":
                    $15b790985f0a6986$var$Ue(g, c, e);
            }
            var $a;
            if ($15b790985f0a6986$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $15b790985f0a6986$var$ie ? $15b790985f0a6986$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($15b790985f0a6986$var$de && "ko" !== c.locale && ($15b790985f0a6986$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $15b790985f0a6986$var$ie && ($a = $15b790985f0a6986$var$nd()) : ($15b790985f0a6986$var$kd = e, $15b790985f0a6986$var$ld = "value" in $15b790985f0a6986$var$kd ? $15b790985f0a6986$var$kd.value : $15b790985f0a6986$var$kd.textContent, $15b790985f0a6986$var$ie = !0)), xa = $15b790985f0a6986$var$oe(d, ba), 0 < xa.length && (ba = new $15b790985f0a6986$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $15b790985f0a6986$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $15b790985f0a6986$var$ce ? $15b790985f0a6986$var$je(a, c) : $15b790985f0a6986$var$ke(a, c)) d = $15b790985f0a6986$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $15b790985f0a6986$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $15b790985f0a6986$var$se(g, b);
    });
}
function $15b790985f0a6986$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $15b790985f0a6986$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $15b790985f0a6986$var$Kb(a, c), null != f && d.unshift($15b790985f0a6986$var$tf(a, f, e)), f = $15b790985f0a6986$var$Kb(a, b), null != f && d.push($15b790985f0a6986$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $15b790985f0a6986$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $15b790985f0a6986$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $15b790985f0a6986$var$Kb(c, f), null != k && g.unshift($15b790985f0a6986$var$tf(c, k, h))) : e || (k = $15b790985f0a6986$var$Kb(c, f), null != k && g.push($15b790985f0a6986$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $15b790985f0a6986$var$xf = /\r\n?/g, $15b790985f0a6986$var$yf = /\u0000|\uFFFD/g;
function $15b790985f0a6986$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($15b790985f0a6986$var$xf, "\n").replace($15b790985f0a6986$var$yf, "");
}
function $15b790985f0a6986$var$Af(a, b, c) {
    b = $15b790985f0a6986$var$zf(b);
    if ($15b790985f0a6986$var$zf(a) !== b && c) throw Error($15b790985f0a6986$var$p(425));
}
function $15b790985f0a6986$var$Bf() {}
var $15b790985f0a6986$var$Cf = null, $15b790985f0a6986$var$Df = null;
function $15b790985f0a6986$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $15b790985f0a6986$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $15b790985f0a6986$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $15b790985f0a6986$var$Hf = "function" === typeof Promise ? Promise : void 0, $15b790985f0a6986$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $15b790985f0a6986$var$Hf ? function(a) {
    return $15b790985f0a6986$var$Hf.resolve(null).then(a).catch($15b790985f0a6986$var$If);
} : $15b790985f0a6986$var$Ff;
function $15b790985f0a6986$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $15b790985f0a6986$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $15b790985f0a6986$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $15b790985f0a6986$var$bd(b);
}
function $15b790985f0a6986$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $15b790985f0a6986$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $15b790985f0a6986$var$Nf = Math.random().toString(36).slice(2), $15b790985f0a6986$var$Of = "__reactFiber$" + $15b790985f0a6986$var$Nf, $15b790985f0a6986$var$Pf = "__reactProps$" + $15b790985f0a6986$var$Nf, $15b790985f0a6986$var$uf = "__reactContainer$" + $15b790985f0a6986$var$Nf, $15b790985f0a6986$var$of = "__reactEvents$" + $15b790985f0a6986$var$Nf, $15b790985f0a6986$var$Qf = "__reactListeners$" + $15b790985f0a6986$var$Nf, $15b790985f0a6986$var$Rf = "__reactHandles$" + $15b790985f0a6986$var$Nf;
function $15b790985f0a6986$var$Wc(a) {
    var b = a[$15b790985f0a6986$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$15b790985f0a6986$var$uf] || c[$15b790985f0a6986$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $15b790985f0a6986$var$Mf(a); null !== a;){
                if (c = a[$15b790985f0a6986$var$Of]) return c;
                a = $15b790985f0a6986$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $15b790985f0a6986$var$Cb(a) {
    a = a[$15b790985f0a6986$var$Of] || a[$15b790985f0a6986$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $15b790985f0a6986$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($15b790985f0a6986$var$p(33));
}
function $15b790985f0a6986$var$Db(a) {
    return a[$15b790985f0a6986$var$Pf] || null;
}
var $15b790985f0a6986$var$Sf = [], $15b790985f0a6986$var$Tf = -1;
function $15b790985f0a6986$var$Uf(a) {
    return {
        current: a
    };
}
function $15b790985f0a6986$var$E(a) {
    0 > $15b790985f0a6986$var$Tf || (a.current = $15b790985f0a6986$var$Sf[$15b790985f0a6986$var$Tf], $15b790985f0a6986$var$Sf[$15b790985f0a6986$var$Tf] = null, $15b790985f0a6986$var$Tf--);
}
function $15b790985f0a6986$var$G(a, b) {
    $15b790985f0a6986$var$Tf++;
    $15b790985f0a6986$var$Sf[$15b790985f0a6986$var$Tf] = a.current;
    a.current = b;
}
var $15b790985f0a6986$var$Vf = {}, $15b790985f0a6986$var$H = $15b790985f0a6986$var$Uf($15b790985f0a6986$var$Vf), $15b790985f0a6986$var$Wf = $15b790985f0a6986$var$Uf(!1), $15b790985f0a6986$var$Xf = $15b790985f0a6986$var$Vf;
function $15b790985f0a6986$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $15b790985f0a6986$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $15b790985f0a6986$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $15b790985f0a6986$var$$f() {
    $15b790985f0a6986$var$E($15b790985f0a6986$var$Wf);
    $15b790985f0a6986$var$E($15b790985f0a6986$var$H);
}
function $15b790985f0a6986$var$ag(a, b, c) {
    if ($15b790985f0a6986$var$H.current !== $15b790985f0a6986$var$Vf) throw Error($15b790985f0a6986$var$p(168));
    $15b790985f0a6986$var$G($15b790985f0a6986$var$H, b);
    $15b790985f0a6986$var$G($15b790985f0a6986$var$Wf, c);
}
function $15b790985f0a6986$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($15b790985f0a6986$var$p(108, $15b790985f0a6986$var$Ra(a) || "Unknown", e));
    return $15b790985f0a6986$var$A({}, c, d);
}
function $15b790985f0a6986$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $15b790985f0a6986$var$Vf;
    $15b790985f0a6986$var$Xf = $15b790985f0a6986$var$H.current;
    $15b790985f0a6986$var$G($15b790985f0a6986$var$H, a);
    $15b790985f0a6986$var$G($15b790985f0a6986$var$Wf, $15b790985f0a6986$var$Wf.current);
    return !0;
}
function $15b790985f0a6986$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($15b790985f0a6986$var$p(169));
    c ? (a = $15b790985f0a6986$var$bg(a, b, $15b790985f0a6986$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $15b790985f0a6986$var$E($15b790985f0a6986$var$Wf), $15b790985f0a6986$var$E($15b790985f0a6986$var$H), $15b790985f0a6986$var$G($15b790985f0a6986$var$H, a)) : $15b790985f0a6986$var$E($15b790985f0a6986$var$Wf);
    $15b790985f0a6986$var$G($15b790985f0a6986$var$Wf, c);
}
var $15b790985f0a6986$var$eg = null, $15b790985f0a6986$var$fg = !1, $15b790985f0a6986$var$gg = !1;
function $15b790985f0a6986$var$hg(a) {
    null === $15b790985f0a6986$var$eg ? $15b790985f0a6986$var$eg = [
        a
    ] : $15b790985f0a6986$var$eg.push(a);
}
function $15b790985f0a6986$var$ig(a) {
    $15b790985f0a6986$var$fg = !0;
    $15b790985f0a6986$var$hg(a);
}
function $15b790985f0a6986$var$jg() {
    if (!$15b790985f0a6986$var$gg && null !== $15b790985f0a6986$var$eg) {
        $15b790985f0a6986$var$gg = !0;
        var a = 0, b = $15b790985f0a6986$var$C;
        try {
            var c = $15b790985f0a6986$var$eg;
            for($15b790985f0a6986$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $15b790985f0a6986$var$eg = null;
            $15b790985f0a6986$var$fg = !1;
        } catch (e) {
            throw null !== $15b790985f0a6986$var$eg && ($15b790985f0a6986$var$eg = $15b790985f0a6986$var$eg.slice(a + 1)), $15b790985f0a6986$var$ac($15b790985f0a6986$var$fc, $15b790985f0a6986$var$jg), e;
        } finally{
            $15b790985f0a6986$var$C = b, $15b790985f0a6986$var$gg = !1;
        }
    }
    return null;
}
var $15b790985f0a6986$var$kg = [], $15b790985f0a6986$var$lg = 0, $15b790985f0a6986$var$mg = null, $15b790985f0a6986$var$ng = 0, $15b790985f0a6986$var$og = [], $15b790985f0a6986$var$pg = 0, $15b790985f0a6986$var$qg = null, $15b790985f0a6986$var$rg = 1, $15b790985f0a6986$var$sg = "";
function $15b790985f0a6986$var$tg(a, b) {
    $15b790985f0a6986$var$kg[$15b790985f0a6986$var$lg++] = $15b790985f0a6986$var$ng;
    $15b790985f0a6986$var$kg[$15b790985f0a6986$var$lg++] = $15b790985f0a6986$var$mg;
    $15b790985f0a6986$var$mg = a;
    $15b790985f0a6986$var$ng = b;
}
function $15b790985f0a6986$var$ug(a, b, c) {
    $15b790985f0a6986$var$og[$15b790985f0a6986$var$pg++] = $15b790985f0a6986$var$rg;
    $15b790985f0a6986$var$og[$15b790985f0a6986$var$pg++] = $15b790985f0a6986$var$sg;
    $15b790985f0a6986$var$og[$15b790985f0a6986$var$pg++] = $15b790985f0a6986$var$qg;
    $15b790985f0a6986$var$qg = a;
    var d = $15b790985f0a6986$var$rg;
    a = $15b790985f0a6986$var$sg;
    var e = 32 - $15b790985f0a6986$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $15b790985f0a6986$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $15b790985f0a6986$var$rg = 1 << 32 - $15b790985f0a6986$var$oc(b) + e | c << e | d;
        $15b790985f0a6986$var$sg = f + a;
    } else $15b790985f0a6986$var$rg = 1 << f | c << e | d, $15b790985f0a6986$var$sg = a;
}
function $15b790985f0a6986$var$vg(a) {
    null !== a.return && ($15b790985f0a6986$var$tg(a, 1), $15b790985f0a6986$var$ug(a, 1, 0));
}
function $15b790985f0a6986$var$wg(a) {
    for(; a === $15b790985f0a6986$var$mg;)$15b790985f0a6986$var$mg = $15b790985f0a6986$var$kg[--$15b790985f0a6986$var$lg], $15b790985f0a6986$var$kg[$15b790985f0a6986$var$lg] = null, $15b790985f0a6986$var$ng = $15b790985f0a6986$var$kg[--$15b790985f0a6986$var$lg], $15b790985f0a6986$var$kg[$15b790985f0a6986$var$lg] = null;
    for(; a === $15b790985f0a6986$var$qg;)$15b790985f0a6986$var$qg = $15b790985f0a6986$var$og[--$15b790985f0a6986$var$pg], $15b790985f0a6986$var$og[$15b790985f0a6986$var$pg] = null, $15b790985f0a6986$var$sg = $15b790985f0a6986$var$og[--$15b790985f0a6986$var$pg], $15b790985f0a6986$var$og[$15b790985f0a6986$var$pg] = null, $15b790985f0a6986$var$rg = $15b790985f0a6986$var$og[--$15b790985f0a6986$var$pg], $15b790985f0a6986$var$og[$15b790985f0a6986$var$pg] = null;
}
var $15b790985f0a6986$var$xg = null, $15b790985f0a6986$var$yg = null, $15b790985f0a6986$var$I = !1, $15b790985f0a6986$var$zg = null;
function $15b790985f0a6986$var$Ag(a, b) {
    var c = $15b790985f0a6986$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $15b790985f0a6986$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $15b790985f0a6986$var$xg = a, $15b790985f0a6986$var$yg = $15b790985f0a6986$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $15b790985f0a6986$var$xg = a, $15b790985f0a6986$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $15b790985f0a6986$var$qg ? {
                id: $15b790985f0a6986$var$rg,
                overflow: $15b790985f0a6986$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $15b790985f0a6986$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $15b790985f0a6986$var$xg = a, $15b790985f0a6986$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $15b790985f0a6986$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $15b790985f0a6986$var$Eg(a) {
    if ($15b790985f0a6986$var$I) {
        var b = $15b790985f0a6986$var$yg;
        if (b) {
            var c = b;
            if (!$15b790985f0a6986$var$Cg(a, b)) {
                if ($15b790985f0a6986$var$Dg(a)) throw Error($15b790985f0a6986$var$p(418));
                b = $15b790985f0a6986$var$Lf(c.nextSibling);
                var d = $15b790985f0a6986$var$xg;
                b && $15b790985f0a6986$var$Cg(a, b) ? $15b790985f0a6986$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $15b790985f0a6986$var$I = !1, $15b790985f0a6986$var$xg = a);
            }
        } else {
            if ($15b790985f0a6986$var$Dg(a)) throw Error($15b790985f0a6986$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $15b790985f0a6986$var$I = !1;
            $15b790985f0a6986$var$xg = a;
        }
    }
}
function $15b790985f0a6986$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $15b790985f0a6986$var$xg = a;
}
function $15b790985f0a6986$var$Gg(a) {
    if (a !== $15b790985f0a6986$var$xg) return !1;
    if (!$15b790985f0a6986$var$I) return $15b790985f0a6986$var$Fg(a), $15b790985f0a6986$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$15b790985f0a6986$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $15b790985f0a6986$var$yg)) {
        if ($15b790985f0a6986$var$Dg(a)) throw $15b790985f0a6986$var$Hg(), Error($15b790985f0a6986$var$p(418));
        for(; b;)$15b790985f0a6986$var$Ag(a, b), b = $15b790985f0a6986$var$Lf(b.nextSibling);
    }
    $15b790985f0a6986$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($15b790985f0a6986$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $15b790985f0a6986$var$yg = $15b790985f0a6986$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $15b790985f0a6986$var$yg = null;
        }
    } else $15b790985f0a6986$var$yg = $15b790985f0a6986$var$xg ? $15b790985f0a6986$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $15b790985f0a6986$var$Hg() {
    for(var a = $15b790985f0a6986$var$yg; a;)a = $15b790985f0a6986$var$Lf(a.nextSibling);
}
function $15b790985f0a6986$var$Ig() {
    $15b790985f0a6986$var$yg = $15b790985f0a6986$var$xg = null;
    $15b790985f0a6986$var$I = !1;
}
function $15b790985f0a6986$var$Jg(a) {
    null === $15b790985f0a6986$var$zg ? $15b790985f0a6986$var$zg = [
        a
    ] : $15b790985f0a6986$var$zg.push(a);
}
var $15b790985f0a6986$var$Kg = $15b790985f0a6986$var$ua.ReactCurrentBatchConfig;
function $15b790985f0a6986$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $15b790985f0a6986$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $15b790985f0a6986$var$Mg = $15b790985f0a6986$var$Uf(null), $15b790985f0a6986$var$Ng = null, $15b790985f0a6986$var$Og = null, $15b790985f0a6986$var$Pg = null;
function $15b790985f0a6986$var$Qg() {
    $15b790985f0a6986$var$Pg = $15b790985f0a6986$var$Og = $15b790985f0a6986$var$Ng = null;
}
function $15b790985f0a6986$var$Rg(a) {
    var b = $15b790985f0a6986$var$Mg.current;
    $15b790985f0a6986$var$E($15b790985f0a6986$var$Mg);
    a._currentValue = b;
}
function $15b790985f0a6986$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $15b790985f0a6986$var$Tg(a, b) {
    $15b790985f0a6986$var$Ng = a;
    $15b790985f0a6986$var$Pg = $15b790985f0a6986$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($15b790985f0a6986$var$Ug = !0), a.firstContext = null);
}
function $15b790985f0a6986$var$Vg(a) {
    var b = a._currentValue;
    if ($15b790985f0a6986$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $15b790985f0a6986$var$Og) {
            if (null === $15b790985f0a6986$var$Ng) throw Error($15b790985f0a6986$var$p(308));
            $15b790985f0a6986$var$Og = a;
            $15b790985f0a6986$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $15b790985f0a6986$var$Og = $15b790985f0a6986$var$Og.next = a;
    }
    return b;
}
var $15b790985f0a6986$var$Wg = null;
function $15b790985f0a6986$var$Xg(a) {
    null === $15b790985f0a6986$var$Wg ? $15b790985f0a6986$var$Wg = [
        a
    ] : $15b790985f0a6986$var$Wg.push(a);
}
function $15b790985f0a6986$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $15b790985f0a6986$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $15b790985f0a6986$var$Zg(a, d);
}
function $15b790985f0a6986$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $15b790985f0a6986$var$$g = !1;
function $15b790985f0a6986$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $15b790985f0a6986$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $15b790985f0a6986$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $15b790985f0a6986$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($15b790985f0a6986$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $15b790985f0a6986$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $15b790985f0a6986$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $15b790985f0a6986$var$Zg(a, c);
}
function $15b790985f0a6986$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $15b790985f0a6986$var$Cc(a, c);
    }
}
function $15b790985f0a6986$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $15b790985f0a6986$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $15b790985f0a6986$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $15b790985f0a6986$var$A({}, q, r);
                            break a;
                        case 2:
                            $15b790985f0a6986$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $15b790985f0a6986$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $15b790985f0a6986$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($15b790985f0a6986$var$p(191, e));
            e.call(d);
        }
    }
}
var $15b790985f0a6986$var$jh = (new $5pP8j.Component).refs;
function $15b790985f0a6986$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $15b790985f0a6986$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $15b790985f0a6986$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $15b790985f0a6986$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $15b790985f0a6986$var$L(), e = $15b790985f0a6986$var$lh(a), f = $15b790985f0a6986$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $15b790985f0a6986$var$dh(a, f, e);
        null !== b && ($15b790985f0a6986$var$mh(b, a, e, d), $15b790985f0a6986$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $15b790985f0a6986$var$L(), e = $15b790985f0a6986$var$lh(a), f = $15b790985f0a6986$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $15b790985f0a6986$var$dh(a, f, e);
        null !== b && ($15b790985f0a6986$var$mh(b, a, e, d), $15b790985f0a6986$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $15b790985f0a6986$var$L(), d = $15b790985f0a6986$var$lh(a), e = $15b790985f0a6986$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $15b790985f0a6986$var$dh(a, e, d);
        null !== b && ($15b790985f0a6986$var$mh(b, a, d, c), $15b790985f0a6986$var$eh(b, a, d));
    }
};
function $15b790985f0a6986$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$15b790985f0a6986$var$Ie(c, d) || !$15b790985f0a6986$var$Ie(e, f) : !0;
}
function $15b790985f0a6986$var$ph(a, b, c) {
    var d = !1, e = $15b790985f0a6986$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $15b790985f0a6986$var$Vg(f) : (e = $15b790985f0a6986$var$Zf(b) ? $15b790985f0a6986$var$Xf : $15b790985f0a6986$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $15b790985f0a6986$var$Yf(a, e) : $15b790985f0a6986$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $15b790985f0a6986$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $15b790985f0a6986$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $15b790985f0a6986$var$nh.enqueueReplaceState(b, b.state, null);
}
function $15b790985f0a6986$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $15b790985f0a6986$var$jh;
    $15b790985f0a6986$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $15b790985f0a6986$var$Vg(f) : (f = $15b790985f0a6986$var$Zf(b) ? $15b790985f0a6986$var$Xf : $15b790985f0a6986$var$H.current, e.context = $15b790985f0a6986$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($15b790985f0a6986$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $15b790985f0a6986$var$nh.enqueueReplaceState(e, e.state, null), $15b790985f0a6986$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $15b790985f0a6986$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($15b790985f0a6986$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($15b790985f0a6986$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $15b790985f0a6986$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($15b790985f0a6986$var$p(284));
        if (!c._owner) throw Error($15b790985f0a6986$var$p(290, a));
    }
    return a;
}
function $15b790985f0a6986$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($15b790985f0a6986$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $15b790985f0a6986$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $15b790985f0a6986$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $15b790985f0a6986$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $15b790985f0a6986$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $15b790985f0a6986$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $15b790985f0a6986$var$Ha && $15b790985f0a6986$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $15b790985f0a6986$var$sh(a, b, c), d.return = a, d;
        d = $15b790985f0a6986$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $15b790985f0a6986$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $15b790985f0a6986$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $15b790985f0a6986$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $15b790985f0a6986$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $15b790985f0a6986$var$va:
                    return c = $15b790985f0a6986$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $15b790985f0a6986$var$sh(a, null, b), c.return = a, c;
                case $15b790985f0a6986$var$wa:
                    return b = $15b790985f0a6986$var$zh(b, a.mode, c), b.return = a, b;
                case $15b790985f0a6986$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($15b790985f0a6986$var$eb(b) || $15b790985f0a6986$var$Ka(b)) return b = $15b790985f0a6986$var$Ah(b, a.mode, c, null), b.return = a, b;
            $15b790985f0a6986$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $15b790985f0a6986$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $15b790985f0a6986$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $15b790985f0a6986$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($15b790985f0a6986$var$eb(c) || $15b790985f0a6986$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $15b790985f0a6986$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $15b790985f0a6986$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $15b790985f0a6986$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $15b790985f0a6986$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($15b790985f0a6986$var$eb(d) || $15b790985f0a6986$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $15b790985f0a6986$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $15b790985f0a6986$var$I && $15b790985f0a6986$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $15b790985f0a6986$var$I && $15b790985f0a6986$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $15b790985f0a6986$var$I && $15b790985f0a6986$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $15b790985f0a6986$var$Ka(h);
        if ("function" !== typeof l) throw Error($15b790985f0a6986$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($15b790985f0a6986$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $15b790985f0a6986$var$I && $15b790985f0a6986$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $15b790985f0a6986$var$I && $15b790985f0a6986$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $15b790985f0a6986$var$I && $15b790985f0a6986$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $15b790985f0a6986$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $15b790985f0a6986$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $15b790985f0a6986$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $15b790985f0a6986$var$Ha && $15b790985f0a6986$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $15b790985f0a6986$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $15b790985f0a6986$var$ya ? (d = $15b790985f0a6986$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $15b790985f0a6986$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $15b790985f0a6986$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $15b790985f0a6986$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $15b790985f0a6986$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $15b790985f0a6986$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($15b790985f0a6986$var$eb(f)) return n(a, d, f, h);
            if ($15b790985f0a6986$var$Ka(f)) return t(a, d, f, h);
            $15b790985f0a6986$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $15b790985f0a6986$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $15b790985f0a6986$var$Bh = $15b790985f0a6986$var$vh(!0), $15b790985f0a6986$var$Ch = $15b790985f0a6986$var$vh(!1), $15b790985f0a6986$var$Dh = {}, $15b790985f0a6986$var$Eh = $15b790985f0a6986$var$Uf($15b790985f0a6986$var$Dh), $15b790985f0a6986$var$Fh = $15b790985f0a6986$var$Uf($15b790985f0a6986$var$Dh), $15b790985f0a6986$var$Gh = $15b790985f0a6986$var$Uf($15b790985f0a6986$var$Dh);
function $15b790985f0a6986$var$Hh(a) {
    if (a === $15b790985f0a6986$var$Dh) throw Error($15b790985f0a6986$var$p(174));
    return a;
}
function $15b790985f0a6986$var$Ih(a, b) {
    $15b790985f0a6986$var$G($15b790985f0a6986$var$Gh, b);
    $15b790985f0a6986$var$G($15b790985f0a6986$var$Fh, a);
    $15b790985f0a6986$var$G($15b790985f0a6986$var$Eh, $15b790985f0a6986$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $15b790985f0a6986$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $15b790985f0a6986$var$lb(b, a);
    }
    $15b790985f0a6986$var$E($15b790985f0a6986$var$Eh);
    $15b790985f0a6986$var$G($15b790985f0a6986$var$Eh, b);
}
function $15b790985f0a6986$var$Jh() {
    $15b790985f0a6986$var$E($15b790985f0a6986$var$Eh);
    $15b790985f0a6986$var$E($15b790985f0a6986$var$Fh);
    $15b790985f0a6986$var$E($15b790985f0a6986$var$Gh);
}
function $15b790985f0a6986$var$Kh(a) {
    $15b790985f0a6986$var$Hh($15b790985f0a6986$var$Gh.current);
    var b = $15b790985f0a6986$var$Hh($15b790985f0a6986$var$Eh.current);
    var c = $15b790985f0a6986$var$lb(b, a.type);
    b !== c && ($15b790985f0a6986$var$G($15b790985f0a6986$var$Fh, a), $15b790985f0a6986$var$G($15b790985f0a6986$var$Eh, c));
}
function $15b790985f0a6986$var$Lh(a) {
    $15b790985f0a6986$var$Fh.current === a && ($15b790985f0a6986$var$E($15b790985f0a6986$var$Eh), $15b790985f0a6986$var$E($15b790985f0a6986$var$Fh));
}
var $15b790985f0a6986$var$M = $15b790985f0a6986$var$Uf(0);
function $15b790985f0a6986$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $15b790985f0a6986$var$Nh = [];
function $15b790985f0a6986$var$Oh() {
    for(var a = 0; a < $15b790985f0a6986$var$Nh.length; a++)$15b790985f0a6986$var$Nh[a]._workInProgressVersionPrimary = null;
    $15b790985f0a6986$var$Nh.length = 0;
}
var $15b790985f0a6986$var$Ph = $15b790985f0a6986$var$ua.ReactCurrentDispatcher, $15b790985f0a6986$var$Qh = $15b790985f0a6986$var$ua.ReactCurrentBatchConfig, $15b790985f0a6986$var$Rh = 0, $15b790985f0a6986$var$N = null, $15b790985f0a6986$var$O = null, $15b790985f0a6986$var$P = null, $15b790985f0a6986$var$Sh = !1, $15b790985f0a6986$var$Th = !1, $15b790985f0a6986$var$Uh = 0, $15b790985f0a6986$var$Vh = 0;
function $15b790985f0a6986$var$Q() {
    throw Error($15b790985f0a6986$var$p(321));
}
function $15b790985f0a6986$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$15b790985f0a6986$var$He(a[c], b[c])) return !1;
    return !0;
}
function $15b790985f0a6986$var$Xh(a, b, c, d, e, f) {
    $15b790985f0a6986$var$Rh = f;
    $15b790985f0a6986$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $15b790985f0a6986$var$Ph.current = null === a || null === a.memoizedState ? $15b790985f0a6986$var$Yh : $15b790985f0a6986$var$Zh;
    a = c(d, e);
    if ($15b790985f0a6986$var$Th) {
        f = 0;
        do {
            $15b790985f0a6986$var$Th = !1;
            $15b790985f0a6986$var$Uh = 0;
            if (25 <= f) throw Error($15b790985f0a6986$var$p(301));
            f += 1;
            $15b790985f0a6986$var$P = $15b790985f0a6986$var$O = null;
            b.updateQueue = null;
            $15b790985f0a6986$var$Ph.current = $15b790985f0a6986$var$$h;
            a = c(d, e);
        }while ($15b790985f0a6986$var$Th);
    }
    $15b790985f0a6986$var$Ph.current = $15b790985f0a6986$var$ai;
    b = null !== $15b790985f0a6986$var$O && null !== $15b790985f0a6986$var$O.next;
    $15b790985f0a6986$var$Rh = 0;
    $15b790985f0a6986$var$P = $15b790985f0a6986$var$O = $15b790985f0a6986$var$N = null;
    $15b790985f0a6986$var$Sh = !1;
    if (b) throw Error($15b790985f0a6986$var$p(300));
    return a;
}
function $15b790985f0a6986$var$bi() {
    var a = 0 !== $15b790985f0a6986$var$Uh;
    $15b790985f0a6986$var$Uh = 0;
    return a;
}
function $15b790985f0a6986$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $15b790985f0a6986$var$P ? $15b790985f0a6986$var$N.memoizedState = $15b790985f0a6986$var$P = a : $15b790985f0a6986$var$P = $15b790985f0a6986$var$P.next = a;
    return $15b790985f0a6986$var$P;
}
function $15b790985f0a6986$var$di() {
    if (null === $15b790985f0a6986$var$O) {
        var a = $15b790985f0a6986$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $15b790985f0a6986$var$O.next;
    var b = null === $15b790985f0a6986$var$P ? $15b790985f0a6986$var$N.memoizedState : $15b790985f0a6986$var$P.next;
    if (null !== b) $15b790985f0a6986$var$P = b, $15b790985f0a6986$var$O = a;
    else {
        if (null === a) throw Error($15b790985f0a6986$var$p(310));
        $15b790985f0a6986$var$O = a;
        a = {
            memoizedState: $15b790985f0a6986$var$O.memoizedState,
            baseState: $15b790985f0a6986$var$O.baseState,
            baseQueue: $15b790985f0a6986$var$O.baseQueue,
            queue: $15b790985f0a6986$var$O.queue,
            next: null
        };
        null === $15b790985f0a6986$var$P ? $15b790985f0a6986$var$N.memoizedState = $15b790985f0a6986$var$P = a : $15b790985f0a6986$var$P = $15b790985f0a6986$var$P.next = a;
    }
    return $15b790985f0a6986$var$P;
}
function $15b790985f0a6986$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $15b790985f0a6986$var$fi(a) {
    var b = $15b790985f0a6986$var$di(), c = b.queue;
    if (null === c) throw Error($15b790985f0a6986$var$p(311));
    c.lastRenderedReducer = a;
    var d = $15b790985f0a6986$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($15b790985f0a6986$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $15b790985f0a6986$var$N.lanes |= m;
                $15b790985f0a6986$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $15b790985f0a6986$var$He(d, b.memoizedState) || ($15b790985f0a6986$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $15b790985f0a6986$var$N.lanes |= f, $15b790985f0a6986$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $15b790985f0a6986$var$gi(a) {
    var b = $15b790985f0a6986$var$di(), c = b.queue;
    if (null === c) throw Error($15b790985f0a6986$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $15b790985f0a6986$var$He(f, b.memoizedState) || ($15b790985f0a6986$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $15b790985f0a6986$var$hi() {}
function $15b790985f0a6986$var$ii(a, b) {
    var c = $15b790985f0a6986$var$N, d = $15b790985f0a6986$var$di(), e = b(), f = !$15b790985f0a6986$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $15b790985f0a6986$var$Ug = !0);
    d = d.queue;
    $15b790985f0a6986$var$ji($15b790985f0a6986$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $15b790985f0a6986$var$P && $15b790985f0a6986$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $15b790985f0a6986$var$li(9, $15b790985f0a6986$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $15b790985f0a6986$var$R) throw Error($15b790985f0a6986$var$p(349));
        0 !== ($15b790985f0a6986$var$Rh & 30) || $15b790985f0a6986$var$ni(c, b, e);
    }
    return e;
}
function $15b790985f0a6986$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $15b790985f0a6986$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $15b790985f0a6986$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $15b790985f0a6986$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $15b790985f0a6986$var$oi(b) && $15b790985f0a6986$var$pi(a);
}
function $15b790985f0a6986$var$ki(a, b, c) {
    return c(function() {
        $15b790985f0a6986$var$oi(b) && $15b790985f0a6986$var$pi(a);
    });
}
function $15b790985f0a6986$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$15b790985f0a6986$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $15b790985f0a6986$var$pi(a) {
    var b = $15b790985f0a6986$var$Zg(a, 1);
    null !== b && $15b790985f0a6986$var$mh(b, a, 1, -1);
}
function $15b790985f0a6986$var$qi(a) {
    var b = $15b790985f0a6986$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $15b790985f0a6986$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $15b790985f0a6986$var$ri.bind(null, $15b790985f0a6986$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $15b790985f0a6986$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $15b790985f0a6986$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $15b790985f0a6986$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $15b790985f0a6986$var$si() {
    return $15b790985f0a6986$var$di().memoizedState;
}
function $15b790985f0a6986$var$ti(a, b, c, d) {
    var e = $15b790985f0a6986$var$ci();
    $15b790985f0a6986$var$N.flags |= a;
    e.memoizedState = $15b790985f0a6986$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $15b790985f0a6986$var$ui(a, b, c, d) {
    var e = $15b790985f0a6986$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $15b790985f0a6986$var$O) {
        var g = $15b790985f0a6986$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $15b790985f0a6986$var$Wh(d, g.deps)) {
            e.memoizedState = $15b790985f0a6986$var$li(b, c, f, d);
            return;
        }
    }
    $15b790985f0a6986$var$N.flags |= a;
    e.memoizedState = $15b790985f0a6986$var$li(1 | b, c, f, d);
}
function $15b790985f0a6986$var$vi(a, b) {
    return $15b790985f0a6986$var$ti(8390656, 8, a, b);
}
function $15b790985f0a6986$var$ji(a, b) {
    return $15b790985f0a6986$var$ui(2048, 8, a, b);
}
function $15b790985f0a6986$var$wi(a, b) {
    return $15b790985f0a6986$var$ui(4, 2, a, b);
}
function $15b790985f0a6986$var$xi(a, b) {
    return $15b790985f0a6986$var$ui(4, 4, a, b);
}
function $15b790985f0a6986$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $15b790985f0a6986$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $15b790985f0a6986$var$ui(4, 4, $15b790985f0a6986$var$yi.bind(null, b, a), c);
}
function $15b790985f0a6986$var$Ai() {}
function $15b790985f0a6986$var$Bi(a, b) {
    var c = $15b790985f0a6986$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $15b790985f0a6986$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $15b790985f0a6986$var$Ci(a, b) {
    var c = $15b790985f0a6986$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $15b790985f0a6986$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $15b790985f0a6986$var$Di(a, b, c) {
    if (0 === ($15b790985f0a6986$var$Rh & 21)) return a.baseState && (a.baseState = !1, $15b790985f0a6986$var$Ug = !0), a.memoizedState = c;
    $15b790985f0a6986$var$He(c, b) || (c = $15b790985f0a6986$var$yc(), $15b790985f0a6986$var$N.lanes |= c, $15b790985f0a6986$var$hh |= c, a.baseState = !0);
    return b;
}
function $15b790985f0a6986$var$Ei(a, b) {
    var c = $15b790985f0a6986$var$C;
    $15b790985f0a6986$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $15b790985f0a6986$var$Qh.transition;
    $15b790985f0a6986$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $15b790985f0a6986$var$C = c, $15b790985f0a6986$var$Qh.transition = d;
    }
}
function $15b790985f0a6986$var$Fi() {
    return $15b790985f0a6986$var$di().memoizedState;
}
function $15b790985f0a6986$var$Gi(a, b, c) {
    var d = $15b790985f0a6986$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($15b790985f0a6986$var$Hi(a)) $15b790985f0a6986$var$Ii(b, c);
    else if (c = $15b790985f0a6986$var$Yg(a, b, c, d), null !== c) {
        var e = $15b790985f0a6986$var$L();
        $15b790985f0a6986$var$mh(c, a, d, e);
        $15b790985f0a6986$var$Ji(c, b, d);
    }
}
function $15b790985f0a6986$var$ri(a, b, c) {
    var d = $15b790985f0a6986$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($15b790985f0a6986$var$Hi(a)) $15b790985f0a6986$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($15b790985f0a6986$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $15b790985f0a6986$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $15b790985f0a6986$var$Yg(a, b, e, d);
        null !== c && (e = $15b790985f0a6986$var$L(), $15b790985f0a6986$var$mh(c, a, d, e), $15b790985f0a6986$var$Ji(c, b, d));
    }
}
function $15b790985f0a6986$var$Hi(a) {
    var b = a.alternate;
    return a === $15b790985f0a6986$var$N || null !== b && b === $15b790985f0a6986$var$N;
}
function $15b790985f0a6986$var$Ii(a, b) {
    $15b790985f0a6986$var$Th = $15b790985f0a6986$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $15b790985f0a6986$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $15b790985f0a6986$var$Cc(a, c);
    }
}
var $15b790985f0a6986$var$ai = {
    readContext: $15b790985f0a6986$var$Vg,
    useCallback: $15b790985f0a6986$var$Q,
    useContext: $15b790985f0a6986$var$Q,
    useEffect: $15b790985f0a6986$var$Q,
    useImperativeHandle: $15b790985f0a6986$var$Q,
    useInsertionEffect: $15b790985f0a6986$var$Q,
    useLayoutEffect: $15b790985f0a6986$var$Q,
    useMemo: $15b790985f0a6986$var$Q,
    useReducer: $15b790985f0a6986$var$Q,
    useRef: $15b790985f0a6986$var$Q,
    useState: $15b790985f0a6986$var$Q,
    useDebugValue: $15b790985f0a6986$var$Q,
    useDeferredValue: $15b790985f0a6986$var$Q,
    useTransition: $15b790985f0a6986$var$Q,
    useMutableSource: $15b790985f0a6986$var$Q,
    useSyncExternalStore: $15b790985f0a6986$var$Q,
    useId: $15b790985f0a6986$var$Q,
    unstable_isNewReconciler: !1
}, $15b790985f0a6986$var$Yh = {
    readContext: $15b790985f0a6986$var$Vg,
    useCallback: function(a, b) {
        $15b790985f0a6986$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $15b790985f0a6986$var$Vg,
    useEffect: $15b790985f0a6986$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $15b790985f0a6986$var$ti(4194308, 4, $15b790985f0a6986$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $15b790985f0a6986$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $15b790985f0a6986$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $15b790985f0a6986$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $15b790985f0a6986$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $15b790985f0a6986$var$Gi.bind(null, $15b790985f0a6986$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $15b790985f0a6986$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $15b790985f0a6986$var$qi,
    useDebugValue: $15b790985f0a6986$var$Ai,
    useDeferredValue: function(a) {
        return $15b790985f0a6986$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $15b790985f0a6986$var$qi(!1), b = a[0];
        a = $15b790985f0a6986$var$Ei.bind(null, a[1]);
        $15b790985f0a6986$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $15b790985f0a6986$var$N, e = $15b790985f0a6986$var$ci();
        if ($15b790985f0a6986$var$I) {
            if (void 0 === c) throw Error($15b790985f0a6986$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $15b790985f0a6986$var$R) throw Error($15b790985f0a6986$var$p(349));
            0 !== ($15b790985f0a6986$var$Rh & 30) || $15b790985f0a6986$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $15b790985f0a6986$var$vi($15b790985f0a6986$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $15b790985f0a6986$var$li(9, $15b790985f0a6986$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $15b790985f0a6986$var$ci(), b = $15b790985f0a6986$var$R.identifierPrefix;
        if ($15b790985f0a6986$var$I) {
            var c = $15b790985f0a6986$var$sg;
            var d = $15b790985f0a6986$var$rg;
            c = (d & ~(1 << 32 - $15b790985f0a6986$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $15b790985f0a6986$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $15b790985f0a6986$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $15b790985f0a6986$var$Zh = {
    readContext: $15b790985f0a6986$var$Vg,
    useCallback: $15b790985f0a6986$var$Bi,
    useContext: $15b790985f0a6986$var$Vg,
    useEffect: $15b790985f0a6986$var$ji,
    useImperativeHandle: $15b790985f0a6986$var$zi,
    useInsertionEffect: $15b790985f0a6986$var$wi,
    useLayoutEffect: $15b790985f0a6986$var$xi,
    useMemo: $15b790985f0a6986$var$Ci,
    useReducer: $15b790985f0a6986$var$fi,
    useRef: $15b790985f0a6986$var$si,
    useState: function() {
        return $15b790985f0a6986$var$fi($15b790985f0a6986$var$ei);
    },
    useDebugValue: $15b790985f0a6986$var$Ai,
    useDeferredValue: function(a) {
        var b = $15b790985f0a6986$var$di();
        return $15b790985f0a6986$var$Di(b, $15b790985f0a6986$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $15b790985f0a6986$var$fi($15b790985f0a6986$var$ei)[0], b = $15b790985f0a6986$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $15b790985f0a6986$var$hi,
    useSyncExternalStore: $15b790985f0a6986$var$ii,
    useId: $15b790985f0a6986$var$Fi,
    unstable_isNewReconciler: !1
}, $15b790985f0a6986$var$$h = {
    readContext: $15b790985f0a6986$var$Vg,
    useCallback: $15b790985f0a6986$var$Bi,
    useContext: $15b790985f0a6986$var$Vg,
    useEffect: $15b790985f0a6986$var$ji,
    useImperativeHandle: $15b790985f0a6986$var$zi,
    useInsertionEffect: $15b790985f0a6986$var$wi,
    useLayoutEffect: $15b790985f0a6986$var$xi,
    useMemo: $15b790985f0a6986$var$Ci,
    useReducer: $15b790985f0a6986$var$gi,
    useRef: $15b790985f0a6986$var$si,
    useState: function() {
        return $15b790985f0a6986$var$gi($15b790985f0a6986$var$ei);
    },
    useDebugValue: $15b790985f0a6986$var$Ai,
    useDeferredValue: function(a) {
        var b = $15b790985f0a6986$var$di();
        return null === $15b790985f0a6986$var$O ? b.memoizedState = a : $15b790985f0a6986$var$Di(b, $15b790985f0a6986$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $15b790985f0a6986$var$gi($15b790985f0a6986$var$ei)[0], b = $15b790985f0a6986$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $15b790985f0a6986$var$hi,
    useSyncExternalStore: $15b790985f0a6986$var$ii,
    useId: $15b790985f0a6986$var$Fi,
    unstable_isNewReconciler: !1
};
function $15b790985f0a6986$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $15b790985f0a6986$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $15b790985f0a6986$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $15b790985f0a6986$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $15b790985f0a6986$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $15b790985f0a6986$var$Oi(a, b, c) {
    c = $15b790985f0a6986$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $15b790985f0a6986$var$Pi || ($15b790985f0a6986$var$Pi = !0, $15b790985f0a6986$var$Qi = d);
        $15b790985f0a6986$var$Mi(a, b);
    };
    return c;
}
function $15b790985f0a6986$var$Ri(a, b, c) {
    c = $15b790985f0a6986$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $15b790985f0a6986$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $15b790985f0a6986$var$Mi(a, b);
        "function" !== typeof d && (null === $15b790985f0a6986$var$Si ? $15b790985f0a6986$var$Si = new Set([
            this
        ]) : $15b790985f0a6986$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $15b790985f0a6986$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $15b790985f0a6986$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $15b790985f0a6986$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $15b790985f0a6986$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $15b790985f0a6986$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $15b790985f0a6986$var$ch(-1, 1), b.tag = 2, $15b790985f0a6986$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $15b790985f0a6986$var$Xi = $15b790985f0a6986$var$ua.ReactCurrentOwner, $15b790985f0a6986$var$Ug = !1;
function $15b790985f0a6986$var$Yi(a, b, c, d) {
    b.child = null === a ? $15b790985f0a6986$var$Ch(b, null, c, d) : $15b790985f0a6986$var$Bh(b, a.child, c, d);
}
function $15b790985f0a6986$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $15b790985f0a6986$var$Tg(b, e);
    d = $15b790985f0a6986$var$Xh(a, b, c, d, f, e);
    c = $15b790985f0a6986$var$bi();
    if (null !== a && !$15b790985f0a6986$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $15b790985f0a6986$var$$i(a, b, e);
    $15b790985f0a6986$var$I && c && $15b790985f0a6986$var$vg(b);
    b.flags |= 1;
    $15b790985f0a6986$var$Yi(a, b, d, e);
    return b.child;
}
function $15b790985f0a6986$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$15b790985f0a6986$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $15b790985f0a6986$var$cj(a, b, f, d, e);
        a = $15b790985f0a6986$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $15b790985f0a6986$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $15b790985f0a6986$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $15b790985f0a6986$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $15b790985f0a6986$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($15b790985f0a6986$var$Ie(f, d) && a.ref === b.ref) {
            if ($15b790985f0a6986$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($15b790985f0a6986$var$Ug = !0);
            else return b.lanes = a.lanes, $15b790985f0a6986$var$$i(a, b, e);
        }
    }
    return $15b790985f0a6986$var$dj(a, b, c, d, e);
}
function $15b790985f0a6986$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $15b790985f0a6986$var$G($15b790985f0a6986$var$fj, $15b790985f0a6986$var$gj), $15b790985f0a6986$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $15b790985f0a6986$var$G($15b790985f0a6986$var$fj, $15b790985f0a6986$var$gj), $15b790985f0a6986$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $15b790985f0a6986$var$G($15b790985f0a6986$var$fj, $15b790985f0a6986$var$gj);
            $15b790985f0a6986$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $15b790985f0a6986$var$G($15b790985f0a6986$var$fj, $15b790985f0a6986$var$gj), $15b790985f0a6986$var$gj |= d;
    $15b790985f0a6986$var$Yi(a, b, e, c);
    return b.child;
}
function $15b790985f0a6986$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $15b790985f0a6986$var$dj(a, b, c, d, e) {
    var f = $15b790985f0a6986$var$Zf(c) ? $15b790985f0a6986$var$Xf : $15b790985f0a6986$var$H.current;
    f = $15b790985f0a6986$var$Yf(b, f);
    $15b790985f0a6986$var$Tg(b, e);
    c = $15b790985f0a6986$var$Xh(a, b, c, d, f, e);
    d = $15b790985f0a6986$var$bi();
    if (null !== a && !$15b790985f0a6986$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $15b790985f0a6986$var$$i(a, b, e);
    $15b790985f0a6986$var$I && d && $15b790985f0a6986$var$vg(b);
    b.flags |= 1;
    $15b790985f0a6986$var$Yi(a, b, c, e);
    return b.child;
}
function $15b790985f0a6986$var$ij(a, b, c, d, e) {
    if ($15b790985f0a6986$var$Zf(c)) {
        var f = !0;
        $15b790985f0a6986$var$cg(b);
    } else f = !1;
    $15b790985f0a6986$var$Tg(b, e);
    if (null === b.stateNode) $15b790985f0a6986$var$jj(a, b), $15b790985f0a6986$var$ph(b, c, d), $15b790985f0a6986$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $15b790985f0a6986$var$Vg(l) : (l = $15b790985f0a6986$var$Zf(c) ? $15b790985f0a6986$var$Xf : $15b790985f0a6986$var$H.current, l = $15b790985f0a6986$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $15b790985f0a6986$var$qh(b, g, d, l);
        $15b790985f0a6986$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $15b790985f0a6986$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $15b790985f0a6986$var$Wf.current || $15b790985f0a6986$var$$g ? ("function" === typeof m && ($15b790985f0a6986$var$kh(b, c, m, d), k = b.memoizedState), (h = $15b790985f0a6986$var$$g || $15b790985f0a6986$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $15b790985f0a6986$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $15b790985f0a6986$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $15b790985f0a6986$var$Vg(k) : (k = $15b790985f0a6986$var$Zf(c) ? $15b790985f0a6986$var$Xf : $15b790985f0a6986$var$H.current, k = $15b790985f0a6986$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $15b790985f0a6986$var$qh(b, g, d, k);
        $15b790985f0a6986$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $15b790985f0a6986$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $15b790985f0a6986$var$Wf.current || $15b790985f0a6986$var$$g ? ("function" === typeof y && ($15b790985f0a6986$var$kh(b, c, y, d), n = b.memoizedState), (l = $15b790985f0a6986$var$$g || $15b790985f0a6986$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $15b790985f0a6986$var$kj(a, b, c, d, f, e);
}
function $15b790985f0a6986$var$kj(a, b, c, d, e, f) {
    $15b790985f0a6986$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $15b790985f0a6986$var$dg(b, c, !1), $15b790985f0a6986$var$$i(a, b, f);
    d = b.stateNode;
    $15b790985f0a6986$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $15b790985f0a6986$var$Bh(b, a.child, null, f), b.child = $15b790985f0a6986$var$Bh(b, null, h, f)) : $15b790985f0a6986$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $15b790985f0a6986$var$dg(b, c, !0);
    return b.child;
}
function $15b790985f0a6986$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $15b790985f0a6986$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $15b790985f0a6986$var$ag(a, b.context, !1);
    $15b790985f0a6986$var$Ih(a, b.containerInfo);
}
function $15b790985f0a6986$var$mj(a, b, c, d, e) {
    $15b790985f0a6986$var$Ig();
    $15b790985f0a6986$var$Jg(e);
    b.flags |= 256;
    $15b790985f0a6986$var$Yi(a, b, c, d);
    return b.child;
}
var $15b790985f0a6986$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $15b790985f0a6986$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $15b790985f0a6986$var$pj(a, b, c) {
    var d = b.pendingProps, e = $15b790985f0a6986$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $15b790985f0a6986$var$G($15b790985f0a6986$var$M, e & 1);
    if (null === a) {
        $15b790985f0a6986$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $15b790985f0a6986$var$qj(g, d, 0, null), a = $15b790985f0a6986$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $15b790985f0a6986$var$oj(c), b.memoizedState = $15b790985f0a6986$var$nj, a) : $15b790985f0a6986$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $15b790985f0a6986$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $15b790985f0a6986$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $15b790985f0a6986$var$wh(h, f) : (f = $15b790985f0a6986$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $15b790985f0a6986$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $15b790985f0a6986$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $15b790985f0a6986$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $15b790985f0a6986$var$rj(a, b) {
    b = $15b790985f0a6986$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $15b790985f0a6986$var$tj(a, b, c, d) {
    null !== d && $15b790985f0a6986$var$Jg(d);
    $15b790985f0a6986$var$Bh(b, a.child, null, c);
    a = $15b790985f0a6986$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $15b790985f0a6986$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $15b790985f0a6986$var$Li(Error($15b790985f0a6986$var$p(422))), $15b790985f0a6986$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $15b790985f0a6986$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $15b790985f0a6986$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $15b790985f0a6986$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $15b790985f0a6986$var$oj(g);
        b.memoizedState = $15b790985f0a6986$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $15b790985f0a6986$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($15b790985f0a6986$var$p(419));
        d = $15b790985f0a6986$var$Li(f, d, void 0);
        return $15b790985f0a6986$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($15b790985f0a6986$var$Ug || h) {
        d = $15b790985f0a6986$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $15b790985f0a6986$var$Zg(a, e), $15b790985f0a6986$var$mh(d, a, e, -1));
        }
        $15b790985f0a6986$var$uj();
        d = $15b790985f0a6986$var$Li(Error($15b790985f0a6986$var$p(421)));
        return $15b790985f0a6986$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $15b790985f0a6986$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $15b790985f0a6986$var$yg = $15b790985f0a6986$var$Lf(e.nextSibling);
    $15b790985f0a6986$var$xg = b;
    $15b790985f0a6986$var$I = !0;
    $15b790985f0a6986$var$zg = null;
    null !== a && ($15b790985f0a6986$var$og[$15b790985f0a6986$var$pg++] = $15b790985f0a6986$var$rg, $15b790985f0a6986$var$og[$15b790985f0a6986$var$pg++] = $15b790985f0a6986$var$sg, $15b790985f0a6986$var$og[$15b790985f0a6986$var$pg++] = $15b790985f0a6986$var$qg, $15b790985f0a6986$var$rg = a.id, $15b790985f0a6986$var$sg = a.overflow, $15b790985f0a6986$var$qg = b);
    b = $15b790985f0a6986$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $15b790985f0a6986$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $15b790985f0a6986$var$Sg(a.return, b, c);
}
function $15b790985f0a6986$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $15b790985f0a6986$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $15b790985f0a6986$var$Yi(a, b, d.children, c);
    d = $15b790985f0a6986$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $15b790985f0a6986$var$wj(a, c, b);
            else if (19 === a.tag) $15b790985f0a6986$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $15b790985f0a6986$var$G($15b790985f0a6986$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $15b790985f0a6986$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $15b790985f0a6986$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $15b790985f0a6986$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $15b790985f0a6986$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $15b790985f0a6986$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $15b790985f0a6986$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $15b790985f0a6986$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $15b790985f0a6986$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($15b790985f0a6986$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $15b790985f0a6986$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $15b790985f0a6986$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $15b790985f0a6986$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $15b790985f0a6986$var$lj(b);
            $15b790985f0a6986$var$Ig();
            break;
        case 5:
            $15b790985f0a6986$var$Kh(b);
            break;
        case 1:
            $15b790985f0a6986$var$Zf(b.type) && $15b790985f0a6986$var$cg(b);
            break;
        case 4:
            $15b790985f0a6986$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $15b790985f0a6986$var$G($15b790985f0a6986$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $15b790985f0a6986$var$G($15b790985f0a6986$var$M, $15b790985f0a6986$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $15b790985f0a6986$var$pj(a, b, c);
                $15b790985f0a6986$var$G($15b790985f0a6986$var$M, $15b790985f0a6986$var$M.current & 1);
                a = $15b790985f0a6986$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $15b790985f0a6986$var$G($15b790985f0a6986$var$M, $15b790985f0a6986$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $15b790985f0a6986$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $15b790985f0a6986$var$G($15b790985f0a6986$var$M, $15b790985f0a6986$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $15b790985f0a6986$var$ej(a, b, c);
    }
    return $15b790985f0a6986$var$$i(a, b, c);
}
var $15b790985f0a6986$var$Aj, $15b790985f0a6986$var$Bj, $15b790985f0a6986$var$Cj, $15b790985f0a6986$var$Dj;
$15b790985f0a6986$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$15b790985f0a6986$var$Bj = function() {};
$15b790985f0a6986$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $15b790985f0a6986$var$Hh($15b790985f0a6986$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $15b790985f0a6986$var$Ya(a, e);
                d = $15b790985f0a6986$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $15b790985f0a6986$var$A({}, e, {
                    value: void 0
                });
                d = $15b790985f0a6986$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $15b790985f0a6986$var$gb(a, e);
                d = $15b790985f0a6986$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $15b790985f0a6986$var$Bf);
        }
        $15b790985f0a6986$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($15b790985f0a6986$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($15b790985f0a6986$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $15b790985f0a6986$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$15b790985f0a6986$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $15b790985f0a6986$var$Ej(a, b) {
    if (!$15b790985f0a6986$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $15b790985f0a6986$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $15b790985f0a6986$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $15b790985f0a6986$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $15b790985f0a6986$var$S(b), null;
        case 1:
            return $15b790985f0a6986$var$Zf(b.type) && $15b790985f0a6986$var$$f(), $15b790985f0a6986$var$S(b), null;
        case 3:
            d = b.stateNode;
            $15b790985f0a6986$var$Jh();
            $15b790985f0a6986$var$E($15b790985f0a6986$var$Wf);
            $15b790985f0a6986$var$E($15b790985f0a6986$var$H);
            $15b790985f0a6986$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $15b790985f0a6986$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $15b790985f0a6986$var$zg && ($15b790985f0a6986$var$Gj($15b790985f0a6986$var$zg), $15b790985f0a6986$var$zg = null));
            $15b790985f0a6986$var$Bj(a, b);
            $15b790985f0a6986$var$S(b);
            return null;
        case 5:
            $15b790985f0a6986$var$Lh(b);
            var e = $15b790985f0a6986$var$Hh($15b790985f0a6986$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $15b790985f0a6986$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($15b790985f0a6986$var$p(166));
                    $15b790985f0a6986$var$S(b);
                    return null;
                }
                a = $15b790985f0a6986$var$Hh($15b790985f0a6986$var$Eh.current);
                if ($15b790985f0a6986$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$15b790985f0a6986$var$Of] = b;
                    d[$15b790985f0a6986$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $15b790985f0a6986$var$D("cancel", d);
                            $15b790985f0a6986$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $15b790985f0a6986$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $15b790985f0a6986$var$lf.length; e++)$15b790985f0a6986$var$D($15b790985f0a6986$var$lf[e], d);
                            break;
                        case "source":
                            $15b790985f0a6986$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $15b790985f0a6986$var$D("error", d);
                            $15b790985f0a6986$var$D("load", d);
                            break;
                        case "details":
                            $15b790985f0a6986$var$D("toggle", d);
                            break;
                        case "input":
                            $15b790985f0a6986$var$Za(d, f);
                            $15b790985f0a6986$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $15b790985f0a6986$var$D("invalid", d);
                            break;
                        case "textarea":
                            $15b790985f0a6986$var$hb(d, f), $15b790985f0a6986$var$D("invalid", d);
                    }
                    $15b790985f0a6986$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $15b790985f0a6986$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $15b790985f0a6986$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $15b790985f0a6986$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $15b790985f0a6986$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $15b790985f0a6986$var$Va(d);
                            $15b790985f0a6986$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $15b790985f0a6986$var$Va(d);
                            $15b790985f0a6986$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $15b790985f0a6986$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $15b790985f0a6986$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$15b790985f0a6986$var$Of] = b;
                    a[$15b790985f0a6986$var$Pf] = d;
                    $15b790985f0a6986$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $15b790985f0a6986$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $15b790985f0a6986$var$D("cancel", a);
                                $15b790985f0a6986$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $15b790985f0a6986$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $15b790985f0a6986$var$lf.length; e++)$15b790985f0a6986$var$D($15b790985f0a6986$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $15b790985f0a6986$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $15b790985f0a6986$var$D("error", a);
                                $15b790985f0a6986$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $15b790985f0a6986$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $15b790985f0a6986$var$Za(a, d);
                                e = $15b790985f0a6986$var$Ya(a, d);
                                $15b790985f0a6986$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $15b790985f0a6986$var$A({}, d, {
                                    value: void 0
                                });
                                $15b790985f0a6986$var$D("invalid", a);
                                break;
                            case "textarea":
                                $15b790985f0a6986$var$hb(a, d);
                                e = $15b790985f0a6986$var$gb(a, d);
                                $15b790985f0a6986$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $15b790985f0a6986$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $15b790985f0a6986$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $15b790985f0a6986$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $15b790985f0a6986$var$ob(a, k) : "number" === typeof k && $15b790985f0a6986$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($15b790985f0a6986$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $15b790985f0a6986$var$D("scroll", a) : null != k && $15b790985f0a6986$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $15b790985f0a6986$var$Va(a);
                                $15b790985f0a6986$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $15b790985f0a6986$var$Va(a);
                                $15b790985f0a6986$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $15b790985f0a6986$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $15b790985f0a6986$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $15b790985f0a6986$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $15b790985f0a6986$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $15b790985f0a6986$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $15b790985f0a6986$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($15b790985f0a6986$var$p(166));
                c = $15b790985f0a6986$var$Hh($15b790985f0a6986$var$Gh.current);
                $15b790985f0a6986$var$Hh($15b790985f0a6986$var$Eh.current);
                if ($15b790985f0a6986$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$15b790985f0a6986$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $15b790985f0a6986$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $15b790985f0a6986$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $15b790985f0a6986$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$15b790985f0a6986$var$Of] = b, b.stateNode = d;
            }
            $15b790985f0a6986$var$S(b);
            return null;
        case 13:
            $15b790985f0a6986$var$E($15b790985f0a6986$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($15b790985f0a6986$var$I && null !== $15b790985f0a6986$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $15b790985f0a6986$var$Hg(), $15b790985f0a6986$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $15b790985f0a6986$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($15b790985f0a6986$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($15b790985f0a6986$var$p(317));
                        f[$15b790985f0a6986$var$Of] = b;
                    } else $15b790985f0a6986$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $15b790985f0a6986$var$S(b);
                    f = !1;
                } else null !== $15b790985f0a6986$var$zg && ($15b790985f0a6986$var$Gj($15b790985f0a6986$var$zg), $15b790985f0a6986$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($15b790985f0a6986$var$M.current & 1) ? 0 === $15b790985f0a6986$var$T && ($15b790985f0a6986$var$T = 3) : $15b790985f0a6986$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $15b790985f0a6986$var$S(b);
            return null;
        case 4:
            return $15b790985f0a6986$var$Jh(), $15b790985f0a6986$var$Bj(a, b), null === a && $15b790985f0a6986$var$sf(b.stateNode.containerInfo), $15b790985f0a6986$var$S(b), null;
        case 10:
            return $15b790985f0a6986$var$Rg(b.type._context), $15b790985f0a6986$var$S(b), null;
        case 17:
            return $15b790985f0a6986$var$Zf(b.type) && $15b790985f0a6986$var$$f(), $15b790985f0a6986$var$S(b), null;
        case 19:
            $15b790985f0a6986$var$E($15b790985f0a6986$var$M);
            f = b.memoizedState;
            if (null === f) return $15b790985f0a6986$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $15b790985f0a6986$var$Ej(f, !1);
                else {
                    if (0 !== $15b790985f0a6986$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $15b790985f0a6986$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $15b790985f0a6986$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $15b790985f0a6986$var$G($15b790985f0a6986$var$M, $15b790985f0a6986$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $15b790985f0a6986$var$B() > $15b790985f0a6986$var$Hj && (b.flags |= 128, d = !0, $15b790985f0a6986$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $15b790985f0a6986$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $15b790985f0a6986$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$15b790985f0a6986$var$I) return $15b790985f0a6986$var$S(b), null;
                    } else 2 * $15b790985f0a6986$var$B() - f.renderingStartTime > $15b790985f0a6986$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $15b790985f0a6986$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $15b790985f0a6986$var$B(), b.sibling = null, c = $15b790985f0a6986$var$M.current, $15b790985f0a6986$var$G($15b790985f0a6986$var$M, d ? c & 1 | 2 : c & 1), b;
            $15b790985f0a6986$var$S(b);
            return null;
        case 22:
        case 23:
            return $15b790985f0a6986$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($15b790985f0a6986$var$gj & 1073741824) && ($15b790985f0a6986$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $15b790985f0a6986$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($15b790985f0a6986$var$p(156, b.tag));
}
function $15b790985f0a6986$var$Jj(a, b) {
    $15b790985f0a6986$var$wg(b);
    switch(b.tag){
        case 1:
            return $15b790985f0a6986$var$Zf(b.type) && $15b790985f0a6986$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $15b790985f0a6986$var$Jh(), $15b790985f0a6986$var$E($15b790985f0a6986$var$Wf), $15b790985f0a6986$var$E($15b790985f0a6986$var$H), $15b790985f0a6986$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $15b790985f0a6986$var$Lh(b), null;
        case 13:
            $15b790985f0a6986$var$E($15b790985f0a6986$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($15b790985f0a6986$var$p(340));
                $15b790985f0a6986$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $15b790985f0a6986$var$E($15b790985f0a6986$var$M), null;
        case 4:
            return $15b790985f0a6986$var$Jh(), null;
        case 10:
            return $15b790985f0a6986$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $15b790985f0a6986$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $15b790985f0a6986$var$Kj = !1, $15b790985f0a6986$var$U = !1, $15b790985f0a6986$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $15b790985f0a6986$var$V = null;
function $15b790985f0a6986$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $15b790985f0a6986$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $15b790985f0a6986$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $15b790985f0a6986$var$W(a, b, d);
    }
}
var $15b790985f0a6986$var$Oj = !1;
function $15b790985f0a6986$var$Pj(a, b) {
    $15b790985f0a6986$var$Cf = $15b790985f0a6986$var$dd;
    a = $15b790985f0a6986$var$Me();
    if ($15b790985f0a6986$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $15b790985f0a6986$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $15b790985f0a6986$var$dd = !1;
    for($15b790985f0a6986$var$V = b; null !== $15b790985f0a6986$var$V;)if (b = $15b790985f0a6986$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $15b790985f0a6986$var$V = a;
    else for(; null !== $15b790985f0a6986$var$V;){
        b = $15b790985f0a6986$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $15b790985f0a6986$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($15b790985f0a6986$var$p(163));
            }
        } catch (F) {
            $15b790985f0a6986$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $15b790985f0a6986$var$V = a;
            break;
        }
        $15b790985f0a6986$var$V = b.return;
    }
    n = $15b790985f0a6986$var$Oj;
    $15b790985f0a6986$var$Oj = !1;
    return n;
}
function $15b790985f0a6986$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $15b790985f0a6986$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $15b790985f0a6986$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $15b790985f0a6986$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $15b790985f0a6986$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $15b790985f0a6986$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$15b790985f0a6986$var$Of], delete b[$15b790985f0a6986$var$Pf], delete b[$15b790985f0a6986$var$of], delete b[$15b790985f0a6986$var$Qf], delete b[$15b790985f0a6986$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $15b790985f0a6986$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $15b790985f0a6986$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $15b790985f0a6986$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $15b790985f0a6986$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $15b790985f0a6986$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($15b790985f0a6986$var$Wj(a, b, c), a = a.sibling; null !== a;)$15b790985f0a6986$var$Wj(a, b, c), a = a.sibling;
}
function $15b790985f0a6986$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($15b790985f0a6986$var$Xj(a, b, c), a = a.sibling; null !== a;)$15b790985f0a6986$var$Xj(a, b, c), a = a.sibling;
}
var $15b790985f0a6986$var$X = null, $15b790985f0a6986$var$Yj = !1;
function $15b790985f0a6986$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$15b790985f0a6986$var$ak(a, b, c), c = c.sibling;
}
function $15b790985f0a6986$var$ak(a, b, c) {
    if ($15b790985f0a6986$var$lc && "function" === typeof $15b790985f0a6986$var$lc.onCommitFiberUnmount) try {
        $15b790985f0a6986$var$lc.onCommitFiberUnmount($15b790985f0a6986$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $15b790985f0a6986$var$U || $15b790985f0a6986$var$Mj(c, b);
        case 6:
            var d = $15b790985f0a6986$var$X, e = $15b790985f0a6986$var$Yj;
            $15b790985f0a6986$var$X = null;
            $15b790985f0a6986$var$Zj(a, b, c);
            $15b790985f0a6986$var$X = d;
            $15b790985f0a6986$var$Yj = e;
            null !== $15b790985f0a6986$var$X && ($15b790985f0a6986$var$Yj ? (a = $15b790985f0a6986$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $15b790985f0a6986$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $15b790985f0a6986$var$X && ($15b790985f0a6986$var$Yj ? (a = $15b790985f0a6986$var$X, c = c.stateNode, 8 === a.nodeType ? $15b790985f0a6986$var$Kf(a.parentNode, c) : 1 === a.nodeType && $15b790985f0a6986$var$Kf(a, c), $15b790985f0a6986$var$bd(a)) : $15b790985f0a6986$var$Kf($15b790985f0a6986$var$X, c.stateNode));
            break;
        case 4:
            d = $15b790985f0a6986$var$X;
            e = $15b790985f0a6986$var$Yj;
            $15b790985f0a6986$var$X = c.stateNode.containerInfo;
            $15b790985f0a6986$var$Yj = !0;
            $15b790985f0a6986$var$Zj(a, b, c);
            $15b790985f0a6986$var$X = d;
            $15b790985f0a6986$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$15b790985f0a6986$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $15b790985f0a6986$var$Nj(c, b, g) : 0 !== (f & 4) && $15b790985f0a6986$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $15b790985f0a6986$var$Zj(a, b, c);
            break;
        case 1:
            if (!$15b790985f0a6986$var$U && ($15b790985f0a6986$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $15b790985f0a6986$var$W(c, b, h);
            }
            $15b790985f0a6986$var$Zj(a, b, c);
            break;
        case 21:
            $15b790985f0a6986$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($15b790985f0a6986$var$U = (d = $15b790985f0a6986$var$U) || null !== c.memoizedState, $15b790985f0a6986$var$Zj(a, b, c), $15b790985f0a6986$var$U = d) : $15b790985f0a6986$var$Zj(a, b, c);
            break;
        default:
            $15b790985f0a6986$var$Zj(a, b, c);
    }
}
function $15b790985f0a6986$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $15b790985f0a6986$var$Lj);
        b.forEach(function(b) {
            var d = $15b790985f0a6986$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $15b790985f0a6986$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $15b790985f0a6986$var$X = h.stateNode;
                        $15b790985f0a6986$var$Yj = !1;
                        break a;
                    case 3:
                        $15b790985f0a6986$var$X = h.stateNode.containerInfo;
                        $15b790985f0a6986$var$Yj = !0;
                        break a;
                    case 4:
                        $15b790985f0a6986$var$X = h.stateNode.containerInfo;
                        $15b790985f0a6986$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $15b790985f0a6986$var$X) throw Error($15b790985f0a6986$var$p(160));
            $15b790985f0a6986$var$ak(f, g, e);
            $15b790985f0a6986$var$X = null;
            $15b790985f0a6986$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $15b790985f0a6986$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$15b790985f0a6986$var$ek(b, a), b = b.sibling;
}
function $15b790985f0a6986$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $15b790985f0a6986$var$dk(b, a);
            $15b790985f0a6986$var$fk(a);
            if (d & 4) {
                try {
                    $15b790985f0a6986$var$Qj(3, a, a.return), $15b790985f0a6986$var$Rj(3, a);
                } catch (t) {
                    $15b790985f0a6986$var$W(a, a.return, t);
                }
                try {
                    $15b790985f0a6986$var$Qj(5, a, a.return);
                } catch (t) {
                    $15b790985f0a6986$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $15b790985f0a6986$var$dk(b, a);
            $15b790985f0a6986$var$fk(a);
            d & 512 && null !== c && $15b790985f0a6986$var$Mj(c, c.return);
            break;
        case 5:
            $15b790985f0a6986$var$dk(b, a);
            $15b790985f0a6986$var$fk(a);
            d & 512 && null !== c && $15b790985f0a6986$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $15b790985f0a6986$var$ob(e, "");
                } catch (t) {
                    $15b790985f0a6986$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $15b790985f0a6986$var$ab(e, f);
                    $15b790985f0a6986$var$vb(h, g);
                    var l = $15b790985f0a6986$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $15b790985f0a6986$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $15b790985f0a6986$var$nb(e, q) : "children" === m ? $15b790985f0a6986$var$ob(e, q) : $15b790985f0a6986$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $15b790985f0a6986$var$bb(e, f);
                            break;
                        case "textarea":
                            $15b790985f0a6986$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $15b790985f0a6986$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $15b790985f0a6986$var$fb(e, !!f.multiple, f.defaultValue, !0) : $15b790985f0a6986$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$15b790985f0a6986$var$Pf] = f;
                } catch (t) {
                    $15b790985f0a6986$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $15b790985f0a6986$var$dk(b, a);
            $15b790985f0a6986$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($15b790985f0a6986$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $15b790985f0a6986$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $15b790985f0a6986$var$dk(b, a);
            $15b790985f0a6986$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $15b790985f0a6986$var$bd(b.containerInfo);
            } catch (t) {
                $15b790985f0a6986$var$W(a, a.return, t);
            }
            break;
        case 4:
            $15b790985f0a6986$var$dk(b, a);
            $15b790985f0a6986$var$fk(a);
            break;
        case 13:
            $15b790985f0a6986$var$dk(b, a);
            $15b790985f0a6986$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($15b790985f0a6986$var$gk = $15b790985f0a6986$var$B()));
            d & 4 && $15b790985f0a6986$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($15b790985f0a6986$var$U = (l = $15b790985f0a6986$var$U) || m, $15b790985f0a6986$var$dk(b, a), $15b790985f0a6986$var$U = l) : $15b790985f0a6986$var$dk(b, a);
            $15b790985f0a6986$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($15b790985f0a6986$var$V = a, m = a.child; null !== m;){
                    for(q = $15b790985f0a6986$var$V = m; null !== $15b790985f0a6986$var$V;){
                        r = $15b790985f0a6986$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $15b790985f0a6986$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $15b790985f0a6986$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $15b790985f0a6986$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $15b790985f0a6986$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $15b790985f0a6986$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $15b790985f0a6986$var$V = y) : $15b790985f0a6986$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $15b790985f0a6986$var$rb("display", g));
                            } catch (t) {
                                $15b790985f0a6986$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $15b790985f0a6986$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $15b790985f0a6986$var$dk(b, a);
            $15b790985f0a6986$var$fk(a);
            d & 4 && $15b790985f0a6986$var$bk(a);
            break;
        case 21:
            break;
        default:
            $15b790985f0a6986$var$dk(b, a), $15b790985f0a6986$var$fk(a);
    }
}
function $15b790985f0a6986$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($15b790985f0a6986$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($15b790985f0a6986$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($15b790985f0a6986$var$ob(e, ""), d.flags &= -33);
                    var f = $15b790985f0a6986$var$Vj(a);
                    $15b790985f0a6986$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $15b790985f0a6986$var$Vj(a);
                    $15b790985f0a6986$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($15b790985f0a6986$var$p(161));
            }
        } catch (k) {
            $15b790985f0a6986$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $15b790985f0a6986$var$ik(a, b, c) {
    $15b790985f0a6986$var$V = a;
    $15b790985f0a6986$var$jk(a, b, c);
}
function $15b790985f0a6986$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $15b790985f0a6986$var$V;){
        var e = $15b790985f0a6986$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $15b790985f0a6986$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $15b790985f0a6986$var$U;
                h = $15b790985f0a6986$var$Kj;
                var l = $15b790985f0a6986$var$U;
                $15b790985f0a6986$var$Kj = g;
                if (($15b790985f0a6986$var$U = k) && !l) for($15b790985f0a6986$var$V = e; null !== $15b790985f0a6986$var$V;)g = $15b790985f0a6986$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $15b790985f0a6986$var$kk(e) : null !== k ? (k.return = g, $15b790985f0a6986$var$V = k) : $15b790985f0a6986$var$kk(e);
                for(; null !== f;)$15b790985f0a6986$var$V = f, $15b790985f0a6986$var$jk(f, b, c), f = f.sibling;
                $15b790985f0a6986$var$V = e;
                $15b790985f0a6986$var$Kj = h;
                $15b790985f0a6986$var$U = l;
            }
            $15b790985f0a6986$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $15b790985f0a6986$var$V = f) : $15b790985f0a6986$var$lk(a, b, c);
    }
}
function $15b790985f0a6986$var$lk(a) {
    for(; null !== $15b790985f0a6986$var$V;){
        var b = $15b790985f0a6986$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $15b790985f0a6986$var$U || $15b790985f0a6986$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$15b790985f0a6986$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $15b790985f0a6986$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $15b790985f0a6986$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $15b790985f0a6986$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $15b790985f0a6986$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($15b790985f0a6986$var$p(163));
                }
                $15b790985f0a6986$var$U || b.flags & 512 && $15b790985f0a6986$var$Sj(b);
            } catch (r) {
                $15b790985f0a6986$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $15b790985f0a6986$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $15b790985f0a6986$var$V = c;
            break;
        }
        $15b790985f0a6986$var$V = b.return;
    }
}
function $15b790985f0a6986$var$hk(a) {
    for(; null !== $15b790985f0a6986$var$V;){
        var b = $15b790985f0a6986$var$V;
        if (b === a) {
            $15b790985f0a6986$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $15b790985f0a6986$var$V = c;
            break;
        }
        $15b790985f0a6986$var$V = b.return;
    }
}
function $15b790985f0a6986$var$kk(a) {
    for(; null !== $15b790985f0a6986$var$V;){
        var b = $15b790985f0a6986$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $15b790985f0a6986$var$Rj(4, b);
                    } catch (k) {
                        $15b790985f0a6986$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $15b790985f0a6986$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $15b790985f0a6986$var$Sj(b);
                    } catch (k) {
                        $15b790985f0a6986$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $15b790985f0a6986$var$Sj(b);
                    } catch (k) {
                        $15b790985f0a6986$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $15b790985f0a6986$var$W(b, b.return, k);
        }
        if (b === a) {
            $15b790985f0a6986$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $15b790985f0a6986$var$V = h;
            break;
        }
        $15b790985f0a6986$var$V = b.return;
    }
}
var $15b790985f0a6986$var$mk = Math.ceil, $15b790985f0a6986$var$nk = $15b790985f0a6986$var$ua.ReactCurrentDispatcher, $15b790985f0a6986$var$ok = $15b790985f0a6986$var$ua.ReactCurrentOwner, $15b790985f0a6986$var$pk = $15b790985f0a6986$var$ua.ReactCurrentBatchConfig, $15b790985f0a6986$var$K = 0, $15b790985f0a6986$var$R = null, $15b790985f0a6986$var$Y = null, $15b790985f0a6986$var$Z = 0, $15b790985f0a6986$var$gj = 0, $15b790985f0a6986$var$fj = $15b790985f0a6986$var$Uf(0), $15b790985f0a6986$var$T = 0, $15b790985f0a6986$var$qk = null, $15b790985f0a6986$var$hh = 0, $15b790985f0a6986$var$rk = 0, $15b790985f0a6986$var$sk = 0, $15b790985f0a6986$var$tk = null, $15b790985f0a6986$var$uk = null, $15b790985f0a6986$var$gk = 0, $15b790985f0a6986$var$Hj = Infinity, $15b790985f0a6986$var$vk = null, $15b790985f0a6986$var$Pi = !1, $15b790985f0a6986$var$Qi = null, $15b790985f0a6986$var$Si = null, $15b790985f0a6986$var$wk = !1, $15b790985f0a6986$var$xk = null, $15b790985f0a6986$var$yk = 0, $15b790985f0a6986$var$zk = 0, $15b790985f0a6986$var$Ak = null, $15b790985f0a6986$var$Bk = -1, $15b790985f0a6986$var$Ck = 0;
function $15b790985f0a6986$var$L() {
    return 0 !== ($15b790985f0a6986$var$K & 6) ? $15b790985f0a6986$var$B() : -1 !== $15b790985f0a6986$var$Bk ? $15b790985f0a6986$var$Bk : $15b790985f0a6986$var$Bk = $15b790985f0a6986$var$B();
}
function $15b790985f0a6986$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($15b790985f0a6986$var$K & 2) && 0 !== $15b790985f0a6986$var$Z) return $15b790985f0a6986$var$Z & -$15b790985f0a6986$var$Z;
    if (null !== $15b790985f0a6986$var$Kg.transition) return 0 === $15b790985f0a6986$var$Ck && ($15b790985f0a6986$var$Ck = $15b790985f0a6986$var$yc()), $15b790985f0a6986$var$Ck;
    a = $15b790985f0a6986$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $15b790985f0a6986$var$jd(a.type);
    return a;
}
function $15b790985f0a6986$var$mh(a, b, c, d) {
    if (50 < $15b790985f0a6986$var$zk) throw $15b790985f0a6986$var$zk = 0, $15b790985f0a6986$var$Ak = null, Error($15b790985f0a6986$var$p(185));
    $15b790985f0a6986$var$Ac(a, c, d);
    if (0 === ($15b790985f0a6986$var$K & 2) || a !== $15b790985f0a6986$var$R) a === $15b790985f0a6986$var$R && (0 === ($15b790985f0a6986$var$K & 2) && ($15b790985f0a6986$var$rk |= c), 4 === $15b790985f0a6986$var$T && $15b790985f0a6986$var$Dk(a, $15b790985f0a6986$var$Z)), $15b790985f0a6986$var$Ek(a, d), 1 === c && 0 === $15b790985f0a6986$var$K && 0 === (b.mode & 1) && ($15b790985f0a6986$var$Hj = $15b790985f0a6986$var$B() + 500, $15b790985f0a6986$var$fg && $15b790985f0a6986$var$jg());
}
function $15b790985f0a6986$var$Ek(a, b) {
    var c = a.callbackNode;
    $15b790985f0a6986$var$wc(a, b);
    var d = $15b790985f0a6986$var$uc(a, a === $15b790985f0a6986$var$R ? $15b790985f0a6986$var$Z : 0);
    if (0 === d) null !== c && $15b790985f0a6986$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $15b790985f0a6986$var$bc(c);
        if (1 === b) 0 === a.tag ? $15b790985f0a6986$var$ig($15b790985f0a6986$var$Fk.bind(null, a)) : $15b790985f0a6986$var$hg($15b790985f0a6986$var$Fk.bind(null, a)), $15b790985f0a6986$var$Jf(function() {
            0 === ($15b790985f0a6986$var$K & 6) && $15b790985f0a6986$var$jg();
        }), c = null;
        else {
            switch($15b790985f0a6986$var$Dc(d)){
                case 1:
                    c = $15b790985f0a6986$var$fc;
                    break;
                case 4:
                    c = $15b790985f0a6986$var$gc;
                    break;
                case 16:
                    c = $15b790985f0a6986$var$hc;
                    break;
                case 536870912:
                    c = $15b790985f0a6986$var$jc;
                    break;
                default:
                    c = $15b790985f0a6986$var$hc;
            }
            c = $15b790985f0a6986$var$Gk(c, $15b790985f0a6986$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $15b790985f0a6986$var$Hk(a, b) {
    $15b790985f0a6986$var$Bk = -1;
    $15b790985f0a6986$var$Ck = 0;
    if (0 !== ($15b790985f0a6986$var$K & 6)) throw Error($15b790985f0a6986$var$p(327));
    var c = a.callbackNode;
    if ($15b790985f0a6986$var$Ik() && a.callbackNode !== c) return null;
    var d = $15b790985f0a6986$var$uc(a, a === $15b790985f0a6986$var$R ? $15b790985f0a6986$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $15b790985f0a6986$var$Jk(a, d);
    else {
        b = d;
        var e = $15b790985f0a6986$var$K;
        $15b790985f0a6986$var$K |= 2;
        var f = $15b790985f0a6986$var$Kk();
        if ($15b790985f0a6986$var$R !== a || $15b790985f0a6986$var$Z !== b) $15b790985f0a6986$var$vk = null, $15b790985f0a6986$var$Hj = $15b790985f0a6986$var$B() + 500, $15b790985f0a6986$var$Lk(a, b);
        for(;;)try {
            $15b790985f0a6986$var$Mk();
            break;
        } catch (h) {
            $15b790985f0a6986$var$Nk(a, h);
        }
        $15b790985f0a6986$var$Qg();
        $15b790985f0a6986$var$nk.current = f;
        $15b790985f0a6986$var$K = e;
        null !== $15b790985f0a6986$var$Y ? b = 0 : ($15b790985f0a6986$var$R = null, $15b790985f0a6986$var$Z = 0, b = $15b790985f0a6986$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $15b790985f0a6986$var$xc(a), 0 !== e && (d = e, b = $15b790985f0a6986$var$Ok(a, e)));
        if (1 === b) throw c = $15b790985f0a6986$var$qk, $15b790985f0a6986$var$Lk(a, 0), $15b790985f0a6986$var$Dk(a, d), $15b790985f0a6986$var$Ek(a, $15b790985f0a6986$var$B()), c;
        if (6 === b) $15b790985f0a6986$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$15b790985f0a6986$var$Pk(e) && (b = $15b790985f0a6986$var$Jk(a, d), 2 === b && (f = $15b790985f0a6986$var$xc(a), 0 !== f && (d = f, b = $15b790985f0a6986$var$Ok(a, f))), 1 === b)) throw c = $15b790985f0a6986$var$qk, $15b790985f0a6986$var$Lk(a, 0), $15b790985f0a6986$var$Dk(a, d), $15b790985f0a6986$var$Ek(a, $15b790985f0a6986$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($15b790985f0a6986$var$p(345));
                case 2:
                    $15b790985f0a6986$var$Qk(a, $15b790985f0a6986$var$uk, $15b790985f0a6986$var$vk);
                    break;
                case 3:
                    $15b790985f0a6986$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $15b790985f0a6986$var$gk + 500 - $15b790985f0a6986$var$B(), 10 < b)) {
                        if (0 !== $15b790985f0a6986$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $15b790985f0a6986$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $15b790985f0a6986$var$Ff($15b790985f0a6986$var$Qk.bind(null, a, $15b790985f0a6986$var$uk, $15b790985f0a6986$var$vk), b);
                        break;
                    }
                    $15b790985f0a6986$var$Qk(a, $15b790985f0a6986$var$uk, $15b790985f0a6986$var$vk);
                    break;
                case 4:
                    $15b790985f0a6986$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $15b790985f0a6986$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $15b790985f0a6986$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $15b790985f0a6986$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $15b790985f0a6986$var$Ff($15b790985f0a6986$var$Qk.bind(null, a, $15b790985f0a6986$var$uk, $15b790985f0a6986$var$vk), d);
                        break;
                    }
                    $15b790985f0a6986$var$Qk(a, $15b790985f0a6986$var$uk, $15b790985f0a6986$var$vk);
                    break;
                case 5:
                    $15b790985f0a6986$var$Qk(a, $15b790985f0a6986$var$uk, $15b790985f0a6986$var$vk);
                    break;
                default:
                    throw Error($15b790985f0a6986$var$p(329));
            }
        }
    }
    $15b790985f0a6986$var$Ek(a, $15b790985f0a6986$var$B());
    return a.callbackNode === c ? $15b790985f0a6986$var$Hk.bind(null, a) : null;
}
function $15b790985f0a6986$var$Ok(a, b) {
    var c = $15b790985f0a6986$var$tk;
    a.current.memoizedState.isDehydrated && ($15b790985f0a6986$var$Lk(a, b).flags |= 256);
    a = $15b790985f0a6986$var$Jk(a, b);
    2 !== a && (b = $15b790985f0a6986$var$uk, $15b790985f0a6986$var$uk = c, null !== b && $15b790985f0a6986$var$Gj(b));
    return a;
}
function $15b790985f0a6986$var$Gj(a) {
    null === $15b790985f0a6986$var$uk ? $15b790985f0a6986$var$uk = a : $15b790985f0a6986$var$uk.push.apply($15b790985f0a6986$var$uk, a);
}
function $15b790985f0a6986$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$15b790985f0a6986$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $15b790985f0a6986$var$Dk(a, b) {
    b &= ~$15b790985f0a6986$var$sk;
    b &= ~$15b790985f0a6986$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $15b790985f0a6986$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $15b790985f0a6986$var$Fk(a) {
    if (0 !== ($15b790985f0a6986$var$K & 6)) throw Error($15b790985f0a6986$var$p(327));
    $15b790985f0a6986$var$Ik();
    var b = $15b790985f0a6986$var$uc(a, 0);
    if (0 === (b & 1)) return $15b790985f0a6986$var$Ek(a, $15b790985f0a6986$var$B()), null;
    var c = $15b790985f0a6986$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $15b790985f0a6986$var$xc(a);
        0 !== d && (b = d, c = $15b790985f0a6986$var$Ok(a, d));
    }
    if (1 === c) throw c = $15b790985f0a6986$var$qk, $15b790985f0a6986$var$Lk(a, 0), $15b790985f0a6986$var$Dk(a, b), $15b790985f0a6986$var$Ek(a, $15b790985f0a6986$var$B()), c;
    if (6 === c) throw Error($15b790985f0a6986$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $15b790985f0a6986$var$Qk(a, $15b790985f0a6986$var$uk, $15b790985f0a6986$var$vk);
    $15b790985f0a6986$var$Ek(a, $15b790985f0a6986$var$B());
    return null;
}
function $15b790985f0a6986$var$Rk(a, b) {
    var c = $15b790985f0a6986$var$K;
    $15b790985f0a6986$var$K |= 1;
    try {
        return a(b);
    } finally{
        $15b790985f0a6986$var$K = c, 0 === $15b790985f0a6986$var$K && ($15b790985f0a6986$var$Hj = $15b790985f0a6986$var$B() + 500, $15b790985f0a6986$var$fg && $15b790985f0a6986$var$jg());
    }
}
function $15b790985f0a6986$var$Sk(a) {
    null !== $15b790985f0a6986$var$xk && 0 === $15b790985f0a6986$var$xk.tag && 0 === ($15b790985f0a6986$var$K & 6) && $15b790985f0a6986$var$Ik();
    var b = $15b790985f0a6986$var$K;
    $15b790985f0a6986$var$K |= 1;
    var c = $15b790985f0a6986$var$pk.transition, d = $15b790985f0a6986$var$C;
    try {
        if ($15b790985f0a6986$var$pk.transition = null, $15b790985f0a6986$var$C = 1, a) return a();
    } finally{
        $15b790985f0a6986$var$C = d, $15b790985f0a6986$var$pk.transition = c, $15b790985f0a6986$var$K = b, 0 === ($15b790985f0a6986$var$K & 6) && $15b790985f0a6986$var$jg();
    }
}
function $15b790985f0a6986$var$Ij() {
    $15b790985f0a6986$var$gj = $15b790985f0a6986$var$fj.current;
    $15b790985f0a6986$var$E($15b790985f0a6986$var$fj);
}
function $15b790985f0a6986$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $15b790985f0a6986$var$Gf(c));
    if (null !== $15b790985f0a6986$var$Y) for(c = $15b790985f0a6986$var$Y.return; null !== c;){
        var d = c;
        $15b790985f0a6986$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $15b790985f0a6986$var$$f();
                break;
            case 3:
                $15b790985f0a6986$var$Jh();
                $15b790985f0a6986$var$E($15b790985f0a6986$var$Wf);
                $15b790985f0a6986$var$E($15b790985f0a6986$var$H);
                $15b790985f0a6986$var$Oh();
                break;
            case 5:
                $15b790985f0a6986$var$Lh(d);
                break;
            case 4:
                $15b790985f0a6986$var$Jh();
                break;
            case 13:
                $15b790985f0a6986$var$E($15b790985f0a6986$var$M);
                break;
            case 19:
                $15b790985f0a6986$var$E($15b790985f0a6986$var$M);
                break;
            case 10:
                $15b790985f0a6986$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $15b790985f0a6986$var$Ij();
        }
        c = c.return;
    }
    $15b790985f0a6986$var$R = a;
    $15b790985f0a6986$var$Y = a = $15b790985f0a6986$var$wh(a.current, null);
    $15b790985f0a6986$var$Z = $15b790985f0a6986$var$gj = b;
    $15b790985f0a6986$var$T = 0;
    $15b790985f0a6986$var$qk = null;
    $15b790985f0a6986$var$sk = $15b790985f0a6986$var$rk = $15b790985f0a6986$var$hh = 0;
    $15b790985f0a6986$var$uk = $15b790985f0a6986$var$tk = null;
    if (null !== $15b790985f0a6986$var$Wg) {
        for(b = 0; b < $15b790985f0a6986$var$Wg.length; b++)if (c = $15b790985f0a6986$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $15b790985f0a6986$var$Wg = null;
    }
    return a;
}
function $15b790985f0a6986$var$Nk(a, b) {
    do {
        var c = $15b790985f0a6986$var$Y;
        try {
            $15b790985f0a6986$var$Qg();
            $15b790985f0a6986$var$Ph.current = $15b790985f0a6986$var$ai;
            if ($15b790985f0a6986$var$Sh) {
                for(var d = $15b790985f0a6986$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $15b790985f0a6986$var$Sh = !1;
            }
            $15b790985f0a6986$var$Rh = 0;
            $15b790985f0a6986$var$P = $15b790985f0a6986$var$O = $15b790985f0a6986$var$N = null;
            $15b790985f0a6986$var$Th = !1;
            $15b790985f0a6986$var$Uh = 0;
            $15b790985f0a6986$var$ok.current = null;
            if (null === c || null === c.return) {
                $15b790985f0a6986$var$T = 1;
                $15b790985f0a6986$var$qk = b;
                $15b790985f0a6986$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $15b790985f0a6986$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $15b790985f0a6986$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $15b790985f0a6986$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $15b790985f0a6986$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $15b790985f0a6986$var$Ti(f, l, b);
                            $15b790985f0a6986$var$uj();
                            break a;
                        }
                        k = Error($15b790985f0a6986$var$p(426));
                    }
                } else if ($15b790985f0a6986$var$I && h.mode & 1) {
                    var J = $15b790985f0a6986$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $15b790985f0a6986$var$Wi(J, g, h, f, b);
                        $15b790985f0a6986$var$Jg($15b790985f0a6986$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $15b790985f0a6986$var$Ki(k, h);
                4 !== $15b790985f0a6986$var$T && ($15b790985f0a6986$var$T = 2);
                null === $15b790985f0a6986$var$tk ? $15b790985f0a6986$var$tk = [
                    f
                ] : $15b790985f0a6986$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $15b790985f0a6986$var$Oi(f, k, b);
                            $15b790985f0a6986$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $15b790985f0a6986$var$Si || !$15b790985f0a6986$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $15b790985f0a6986$var$Ri(f, h, b);
                                $15b790985f0a6986$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $15b790985f0a6986$var$Tk(c);
        } catch (na) {
            b = na;
            $15b790985f0a6986$var$Y === c && null !== c && ($15b790985f0a6986$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $15b790985f0a6986$var$Kk() {
    var a = $15b790985f0a6986$var$nk.current;
    $15b790985f0a6986$var$nk.current = $15b790985f0a6986$var$ai;
    return null === a ? $15b790985f0a6986$var$ai : a;
}
function $15b790985f0a6986$var$uj() {
    if (0 === $15b790985f0a6986$var$T || 3 === $15b790985f0a6986$var$T || 2 === $15b790985f0a6986$var$T) $15b790985f0a6986$var$T = 4;
    null === $15b790985f0a6986$var$R || 0 === ($15b790985f0a6986$var$hh & 268435455) && 0 === ($15b790985f0a6986$var$rk & 268435455) || $15b790985f0a6986$var$Dk($15b790985f0a6986$var$R, $15b790985f0a6986$var$Z);
}
function $15b790985f0a6986$var$Jk(a, b) {
    var c = $15b790985f0a6986$var$K;
    $15b790985f0a6986$var$K |= 2;
    var d = $15b790985f0a6986$var$Kk();
    if ($15b790985f0a6986$var$R !== a || $15b790985f0a6986$var$Z !== b) $15b790985f0a6986$var$vk = null, $15b790985f0a6986$var$Lk(a, b);
    for(;;)try {
        $15b790985f0a6986$var$Uk();
        break;
    } catch (e) {
        $15b790985f0a6986$var$Nk(a, e);
    }
    $15b790985f0a6986$var$Qg();
    $15b790985f0a6986$var$K = c;
    $15b790985f0a6986$var$nk.current = d;
    if (null !== $15b790985f0a6986$var$Y) throw Error($15b790985f0a6986$var$p(261));
    $15b790985f0a6986$var$R = null;
    $15b790985f0a6986$var$Z = 0;
    return $15b790985f0a6986$var$T;
}
function $15b790985f0a6986$var$Uk() {
    for(; null !== $15b790985f0a6986$var$Y;)$15b790985f0a6986$var$Vk($15b790985f0a6986$var$Y);
}
function $15b790985f0a6986$var$Mk() {
    for(; null !== $15b790985f0a6986$var$Y && !$15b790985f0a6986$var$cc();)$15b790985f0a6986$var$Vk($15b790985f0a6986$var$Y);
}
function $15b790985f0a6986$var$Vk(a) {
    var b = $15b790985f0a6986$var$Wk(a.alternate, a, $15b790985f0a6986$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $15b790985f0a6986$var$Tk(a) : $15b790985f0a6986$var$Y = b;
    $15b790985f0a6986$var$ok.current = null;
}
function $15b790985f0a6986$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $15b790985f0a6986$var$Fj(c, b, $15b790985f0a6986$var$gj), null !== c) {
                $15b790985f0a6986$var$Y = c;
                return;
            }
        } else {
            c = $15b790985f0a6986$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $15b790985f0a6986$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $15b790985f0a6986$var$T = 6;
                $15b790985f0a6986$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $15b790985f0a6986$var$Y = b;
            return;
        }
        $15b790985f0a6986$var$Y = b = a;
    }while (null !== b);
    0 === $15b790985f0a6986$var$T && ($15b790985f0a6986$var$T = 5);
}
function $15b790985f0a6986$var$Qk(a, b, c) {
    var d = $15b790985f0a6986$var$C, e = $15b790985f0a6986$var$pk.transition;
    try {
        $15b790985f0a6986$var$pk.transition = null, $15b790985f0a6986$var$C = 1, $15b790985f0a6986$var$Xk(a, b, c, d);
    } finally{
        $15b790985f0a6986$var$pk.transition = e, $15b790985f0a6986$var$C = d;
    }
    return null;
}
function $15b790985f0a6986$var$Xk(a, b, c, d) {
    do $15b790985f0a6986$var$Ik();
    while (null !== $15b790985f0a6986$var$xk);
    if (0 !== ($15b790985f0a6986$var$K & 6)) throw Error($15b790985f0a6986$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($15b790985f0a6986$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $15b790985f0a6986$var$Bc(a, f);
    a === $15b790985f0a6986$var$R && ($15b790985f0a6986$var$Y = $15b790985f0a6986$var$R = null, $15b790985f0a6986$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $15b790985f0a6986$var$wk || ($15b790985f0a6986$var$wk = !0, $15b790985f0a6986$var$Gk($15b790985f0a6986$var$hc, function() {
        $15b790985f0a6986$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $15b790985f0a6986$var$pk.transition;
        $15b790985f0a6986$var$pk.transition = null;
        var g = $15b790985f0a6986$var$C;
        $15b790985f0a6986$var$C = 1;
        var h = $15b790985f0a6986$var$K;
        $15b790985f0a6986$var$K |= 4;
        $15b790985f0a6986$var$ok.current = null;
        $15b790985f0a6986$var$Pj(a, c);
        $15b790985f0a6986$var$ek(c, a);
        $15b790985f0a6986$var$Oe($15b790985f0a6986$var$Df);
        $15b790985f0a6986$var$dd = !!$15b790985f0a6986$var$Cf;
        $15b790985f0a6986$var$Df = $15b790985f0a6986$var$Cf = null;
        a.current = c;
        $15b790985f0a6986$var$ik(c, a, e);
        $15b790985f0a6986$var$dc();
        $15b790985f0a6986$var$K = h;
        $15b790985f0a6986$var$C = g;
        $15b790985f0a6986$var$pk.transition = f;
    } else a.current = c;
    $15b790985f0a6986$var$wk && ($15b790985f0a6986$var$wk = !1, $15b790985f0a6986$var$xk = a, $15b790985f0a6986$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($15b790985f0a6986$var$Si = null);
    $15b790985f0a6986$var$mc(c.stateNode, d);
    $15b790985f0a6986$var$Ek(a, $15b790985f0a6986$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($15b790985f0a6986$var$Pi) throw $15b790985f0a6986$var$Pi = !1, a = $15b790985f0a6986$var$Qi, $15b790985f0a6986$var$Qi = null, a;
    0 !== ($15b790985f0a6986$var$yk & 1) && 0 !== a.tag && $15b790985f0a6986$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $15b790985f0a6986$var$Ak ? $15b790985f0a6986$var$zk++ : ($15b790985f0a6986$var$zk = 0, $15b790985f0a6986$var$Ak = a) : $15b790985f0a6986$var$zk = 0;
    $15b790985f0a6986$var$jg();
    return null;
}
function $15b790985f0a6986$var$Ik() {
    if (null !== $15b790985f0a6986$var$xk) {
        var a = $15b790985f0a6986$var$Dc($15b790985f0a6986$var$yk), b = $15b790985f0a6986$var$pk.transition, c = $15b790985f0a6986$var$C;
        try {
            $15b790985f0a6986$var$pk.transition = null;
            $15b790985f0a6986$var$C = 16 > a ? 16 : a;
            if (null === $15b790985f0a6986$var$xk) var d = !1;
            else {
                a = $15b790985f0a6986$var$xk;
                $15b790985f0a6986$var$xk = null;
                $15b790985f0a6986$var$yk = 0;
                if (0 !== ($15b790985f0a6986$var$K & 6)) throw Error($15b790985f0a6986$var$p(331));
                var e = $15b790985f0a6986$var$K;
                $15b790985f0a6986$var$K |= 4;
                for($15b790985f0a6986$var$V = a.current; null !== $15b790985f0a6986$var$V;){
                    var f = $15b790985f0a6986$var$V, g = f.child;
                    if (0 !== ($15b790985f0a6986$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($15b790985f0a6986$var$V = l; null !== $15b790985f0a6986$var$V;){
                                    var m = $15b790985f0a6986$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $15b790985f0a6986$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $15b790985f0a6986$var$V = q;
                                    else for(; null !== $15b790985f0a6986$var$V;){
                                        m = $15b790985f0a6986$var$V;
                                        var r = m.sibling, y = m.return;
                                        $15b790985f0a6986$var$Tj(m);
                                        if (m === l) {
                                            $15b790985f0a6986$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $15b790985f0a6986$var$V = r;
                                            break;
                                        }
                                        $15b790985f0a6986$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $15b790985f0a6986$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $15b790985f0a6986$var$V = g;
                    else b: for(; null !== $15b790985f0a6986$var$V;){
                        f = $15b790985f0a6986$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $15b790985f0a6986$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $15b790985f0a6986$var$V = x;
                            break b;
                        }
                        $15b790985f0a6986$var$V = f.return;
                    }
                }
                var w = a.current;
                for($15b790985f0a6986$var$V = w; null !== $15b790985f0a6986$var$V;){
                    g = $15b790985f0a6986$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $15b790985f0a6986$var$V = u;
                    else b: for(g = w; null !== $15b790985f0a6986$var$V;){
                        h = $15b790985f0a6986$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $15b790985f0a6986$var$Rj(9, h);
                            }
                        } catch (na) {
                            $15b790985f0a6986$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $15b790985f0a6986$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $15b790985f0a6986$var$V = F;
                            break b;
                        }
                        $15b790985f0a6986$var$V = h.return;
                    }
                }
                $15b790985f0a6986$var$K = e;
                $15b790985f0a6986$var$jg();
                if ($15b790985f0a6986$var$lc && "function" === typeof $15b790985f0a6986$var$lc.onPostCommitFiberRoot) try {
                    $15b790985f0a6986$var$lc.onPostCommitFiberRoot($15b790985f0a6986$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $15b790985f0a6986$var$C = c, $15b790985f0a6986$var$pk.transition = b;
        }
    }
    return !1;
}
function $15b790985f0a6986$var$Yk(a, b, c) {
    b = $15b790985f0a6986$var$Ki(c, b);
    b = $15b790985f0a6986$var$Oi(a, b, 1);
    a = $15b790985f0a6986$var$dh(a, b, 1);
    b = $15b790985f0a6986$var$L();
    null !== a && ($15b790985f0a6986$var$Ac(a, 1, b), $15b790985f0a6986$var$Ek(a, b));
}
function $15b790985f0a6986$var$W(a, b, c) {
    if (3 === a.tag) $15b790985f0a6986$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $15b790985f0a6986$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $15b790985f0a6986$var$Si || !$15b790985f0a6986$var$Si.has(d))) {
                a = $15b790985f0a6986$var$Ki(c, a);
                a = $15b790985f0a6986$var$Ri(b, a, 1);
                b = $15b790985f0a6986$var$dh(b, a, 1);
                a = $15b790985f0a6986$var$L();
                null !== b && ($15b790985f0a6986$var$Ac(b, 1, a), $15b790985f0a6986$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $15b790985f0a6986$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $15b790985f0a6986$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $15b790985f0a6986$var$R === a && ($15b790985f0a6986$var$Z & c) === c && (4 === $15b790985f0a6986$var$T || 3 === $15b790985f0a6986$var$T && ($15b790985f0a6986$var$Z & 130023424) === $15b790985f0a6986$var$Z && 500 > $15b790985f0a6986$var$B() - $15b790985f0a6986$var$gk ? $15b790985f0a6986$var$Lk(a, 0) : $15b790985f0a6986$var$sk |= c);
    $15b790985f0a6986$var$Ek(a, b);
}
function $15b790985f0a6986$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $15b790985f0a6986$var$sc, $15b790985f0a6986$var$sc <<= 1, 0 === ($15b790985f0a6986$var$sc & 130023424) && ($15b790985f0a6986$var$sc = 4194304)));
    var c = $15b790985f0a6986$var$L();
    a = $15b790985f0a6986$var$Zg(a, b);
    null !== a && ($15b790985f0a6986$var$Ac(a, b, c), $15b790985f0a6986$var$Ek(a, c));
}
function $15b790985f0a6986$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $15b790985f0a6986$var$Zk(a, c);
}
function $15b790985f0a6986$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($15b790985f0a6986$var$p(314));
    }
    null !== d && d.delete(b);
    $15b790985f0a6986$var$Zk(a, c);
}
var $15b790985f0a6986$var$Wk;
$15b790985f0a6986$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $15b790985f0a6986$var$Wf.current) $15b790985f0a6986$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $15b790985f0a6986$var$Ug = !1, $15b790985f0a6986$var$zj(a, b, c);
            $15b790985f0a6986$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $15b790985f0a6986$var$Ug = !1, $15b790985f0a6986$var$I && 0 !== (b.flags & 1048576) && $15b790985f0a6986$var$ug(b, $15b790985f0a6986$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $15b790985f0a6986$var$jj(a, b);
            a = b.pendingProps;
            var e = $15b790985f0a6986$var$Yf(b, $15b790985f0a6986$var$H.current);
            $15b790985f0a6986$var$Tg(b, c);
            e = $15b790985f0a6986$var$Xh(null, b, d, a, e, c);
            var f = $15b790985f0a6986$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $15b790985f0a6986$var$Zf(d) ? (f = !0, $15b790985f0a6986$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $15b790985f0a6986$var$ah(b), e.updater = $15b790985f0a6986$var$nh, b.stateNode = e, e._reactInternals = b, $15b790985f0a6986$var$rh(b, d, a, c), b = $15b790985f0a6986$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $15b790985f0a6986$var$I && f && $15b790985f0a6986$var$vg(b), $15b790985f0a6986$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $15b790985f0a6986$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $15b790985f0a6986$var$$k(d);
                a = $15b790985f0a6986$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $15b790985f0a6986$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $15b790985f0a6986$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $15b790985f0a6986$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $15b790985f0a6986$var$aj(null, b, d, $15b790985f0a6986$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($15b790985f0a6986$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $15b790985f0a6986$var$Lg(d, e), $15b790985f0a6986$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $15b790985f0a6986$var$Lg(d, e), $15b790985f0a6986$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $15b790985f0a6986$var$lj(b);
                if (null === a) throw Error($15b790985f0a6986$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $15b790985f0a6986$var$bh(a, b);
                $15b790985f0a6986$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $15b790985f0a6986$var$Ki(Error($15b790985f0a6986$var$p(423)), b);
                        b = $15b790985f0a6986$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $15b790985f0a6986$var$Ki(Error($15b790985f0a6986$var$p(424)), b);
                        b = $15b790985f0a6986$var$mj(a, b, d, c, e);
                        break a;
                    } else for($15b790985f0a6986$var$yg = $15b790985f0a6986$var$Lf(b.stateNode.containerInfo.firstChild), $15b790985f0a6986$var$xg = b, $15b790985f0a6986$var$I = !0, $15b790985f0a6986$var$zg = null, c = $15b790985f0a6986$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $15b790985f0a6986$var$Ig();
                    if (d === e) {
                        b = $15b790985f0a6986$var$$i(a, b, c);
                        break a;
                    }
                    $15b790985f0a6986$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $15b790985f0a6986$var$Kh(b), null === a && $15b790985f0a6986$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $15b790985f0a6986$var$Ef(d, e) ? g = null : null !== f && $15b790985f0a6986$var$Ef(d, f) && (b.flags |= 32), $15b790985f0a6986$var$hj(a, b), $15b790985f0a6986$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $15b790985f0a6986$var$Eg(b), null;
        case 13:
            return $15b790985f0a6986$var$pj(a, b, c);
        case 4:
            return $15b790985f0a6986$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $15b790985f0a6986$var$Bh(b, null, d, c) : $15b790985f0a6986$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $15b790985f0a6986$var$Lg(d, e), $15b790985f0a6986$var$Zi(a, b, d, e, c);
        case 7:
            return $15b790985f0a6986$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $15b790985f0a6986$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $15b790985f0a6986$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $15b790985f0a6986$var$G($15b790985f0a6986$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($15b790985f0a6986$var$He(f.value, g)) {
                        if (f.children === e.children && !$15b790985f0a6986$var$Wf.current) {
                            b = $15b790985f0a6986$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $15b790985f0a6986$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $15b790985f0a6986$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($15b790985f0a6986$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $15b790985f0a6986$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $15b790985f0a6986$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $15b790985f0a6986$var$Tg(b, c), e = $15b790985f0a6986$var$Vg(e), d = d(e), b.flags |= 1, $15b790985f0a6986$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $15b790985f0a6986$var$Lg(d, b.pendingProps), e = $15b790985f0a6986$var$Lg(d.type, e), $15b790985f0a6986$var$aj(a, b, d, e, c);
        case 15:
            return $15b790985f0a6986$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $15b790985f0a6986$var$Lg(d, e), $15b790985f0a6986$var$jj(a, b), b.tag = 1, $15b790985f0a6986$var$Zf(d) ? (a = !0, $15b790985f0a6986$var$cg(b)) : a = !1, $15b790985f0a6986$var$Tg(b, c), $15b790985f0a6986$var$ph(b, d, e), $15b790985f0a6986$var$rh(b, d, e, c), $15b790985f0a6986$var$kj(null, b, d, !0, a, c);
        case 19:
            return $15b790985f0a6986$var$yj(a, b, c);
        case 22:
            return $15b790985f0a6986$var$ej(a, b, c);
    }
    throw Error($15b790985f0a6986$var$p(156, b.tag));
};
function $15b790985f0a6986$var$Gk(a, b) {
    return $15b790985f0a6986$var$ac(a, b);
}
function $15b790985f0a6986$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $15b790985f0a6986$var$Bg(a, b, c, d) {
    return new $15b790985f0a6986$var$al(a, b, c, d);
}
function $15b790985f0a6986$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $15b790985f0a6986$var$$k(a) {
    if ("function" === typeof a) return $15b790985f0a6986$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $15b790985f0a6986$var$Da) return 11;
        if (a === $15b790985f0a6986$var$Ga) return 14;
    }
    return 2;
}
function $15b790985f0a6986$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $15b790985f0a6986$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $15b790985f0a6986$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $15b790985f0a6986$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $15b790985f0a6986$var$ya:
            return $15b790985f0a6986$var$Ah(c.children, e, f, b);
        case $15b790985f0a6986$var$za:
            g = 8;
            e |= 8;
            break;
        case $15b790985f0a6986$var$Aa:
            return a = $15b790985f0a6986$var$Bg(12, c, b, e | 2), a.elementType = $15b790985f0a6986$var$Aa, a.lanes = f, a;
        case $15b790985f0a6986$var$Ea:
            return a = $15b790985f0a6986$var$Bg(13, c, b, e), a.elementType = $15b790985f0a6986$var$Ea, a.lanes = f, a;
        case $15b790985f0a6986$var$Fa:
            return a = $15b790985f0a6986$var$Bg(19, c, b, e), a.elementType = $15b790985f0a6986$var$Fa, a.lanes = f, a;
        case $15b790985f0a6986$var$Ia:
            return $15b790985f0a6986$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $15b790985f0a6986$var$Ba:
                    g = 10;
                    break a;
                case $15b790985f0a6986$var$Ca:
                    g = 9;
                    break a;
                case $15b790985f0a6986$var$Da:
                    g = 11;
                    break a;
                case $15b790985f0a6986$var$Ga:
                    g = 14;
                    break a;
                case $15b790985f0a6986$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($15b790985f0a6986$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $15b790985f0a6986$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $15b790985f0a6986$var$Ah(a, b, c, d) {
    a = $15b790985f0a6986$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $15b790985f0a6986$var$qj(a, b, c, d) {
    a = $15b790985f0a6986$var$Bg(22, a, d, b);
    a.elementType = $15b790985f0a6986$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $15b790985f0a6986$var$xh(a, b, c) {
    a = $15b790985f0a6986$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $15b790985f0a6986$var$zh(a, b, c) {
    b = $15b790985f0a6986$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $15b790985f0a6986$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $15b790985f0a6986$var$zc(0);
    this.expirationTimes = $15b790985f0a6986$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $15b790985f0a6986$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $15b790985f0a6986$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $15b790985f0a6986$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $15b790985f0a6986$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $15b790985f0a6986$var$ah(f);
    return a;
}
function $15b790985f0a6986$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $15b790985f0a6986$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $15b790985f0a6986$var$el(a) {
    if (!a) return $15b790985f0a6986$var$Vf;
    a = a._reactInternals;
    a: {
        if ($15b790985f0a6986$var$Vb(a) !== a || 1 !== a.tag) throw Error($15b790985f0a6986$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($15b790985f0a6986$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($15b790985f0a6986$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($15b790985f0a6986$var$Zf(c)) return $15b790985f0a6986$var$bg(a, c, b);
    }
    return b;
}
function $15b790985f0a6986$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $15b790985f0a6986$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $15b790985f0a6986$var$el(null);
    c = a.current;
    d = $15b790985f0a6986$var$L();
    e = $15b790985f0a6986$var$lh(c);
    f = $15b790985f0a6986$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $15b790985f0a6986$var$dh(c, f, e);
    a.current.lanes = e;
    $15b790985f0a6986$var$Ac(a, e, d);
    $15b790985f0a6986$var$Ek(a, d);
    return a;
}
function $15b790985f0a6986$var$gl(a, b, c, d) {
    var e = b.current, f = $15b790985f0a6986$var$L(), g = $15b790985f0a6986$var$lh(e);
    c = $15b790985f0a6986$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $15b790985f0a6986$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $15b790985f0a6986$var$dh(e, b, g);
    null !== a && ($15b790985f0a6986$var$mh(a, e, g, f), $15b790985f0a6986$var$eh(a, e, g));
    return g;
}
function $15b790985f0a6986$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $15b790985f0a6986$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $15b790985f0a6986$var$jl(a, b) {
    $15b790985f0a6986$var$il(a, b);
    (a = a.alternate) && $15b790985f0a6986$var$il(a, b);
}
function $15b790985f0a6986$var$kl() {
    return null;
}
var $15b790985f0a6986$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $15b790985f0a6986$var$ml(a) {
    this._internalRoot = a;
}
$15b790985f0a6986$var$nl.prototype.render = $15b790985f0a6986$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($15b790985f0a6986$var$p(409));
    $15b790985f0a6986$var$gl(a, b, null, null);
};
$15b790985f0a6986$var$nl.prototype.unmount = $15b790985f0a6986$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $15b790985f0a6986$var$Sk(function() {
            $15b790985f0a6986$var$gl(null, a, null, null);
        });
        b[$15b790985f0a6986$var$uf] = null;
    }
};
function $15b790985f0a6986$var$nl(a) {
    this._internalRoot = a;
}
$15b790985f0a6986$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $15b790985f0a6986$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $15b790985f0a6986$var$Qc.length && 0 !== b && b < $15b790985f0a6986$var$Qc[c].priority; c++);
        $15b790985f0a6986$var$Qc.splice(c, 0, a);
        0 === c && $15b790985f0a6986$var$Vc(a);
    }
};
function $15b790985f0a6986$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $15b790985f0a6986$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $15b790985f0a6986$var$ql() {}
function $15b790985f0a6986$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $15b790985f0a6986$var$hl(g);
                f.call(a);
            };
        }
        var g = $15b790985f0a6986$var$fl(b, d, a, 0, null, !1, !1, "", $15b790985f0a6986$var$ql);
        a._reactRootContainer = g;
        a[$15b790985f0a6986$var$uf] = g.current;
        $15b790985f0a6986$var$sf(8 === a.nodeType ? a.parentNode : a);
        $15b790985f0a6986$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $15b790985f0a6986$var$hl(k);
            h.call(a);
        };
    }
    var k = $15b790985f0a6986$var$cl(a, 0, !1, null, null, !1, !1, "", $15b790985f0a6986$var$ql);
    a._reactRootContainer = k;
    a[$15b790985f0a6986$var$uf] = k.current;
    $15b790985f0a6986$var$sf(8 === a.nodeType ? a.parentNode : a);
    $15b790985f0a6986$var$Sk(function() {
        $15b790985f0a6986$var$gl(b, k, c, d);
    });
    return k;
}
function $15b790985f0a6986$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $15b790985f0a6986$var$hl(g);
                h.call(a);
            };
        }
        $15b790985f0a6986$var$gl(b, g, a, e);
    } else g = $15b790985f0a6986$var$rl(c, b, a, e, d);
    return $15b790985f0a6986$var$hl(g);
}
$15b790985f0a6986$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $15b790985f0a6986$var$tc(b.pendingLanes);
                0 !== c && ($15b790985f0a6986$var$Cc(b, c | 1), $15b790985f0a6986$var$Ek(b, $15b790985f0a6986$var$B()), 0 === ($15b790985f0a6986$var$K & 6) && ($15b790985f0a6986$var$Hj = $15b790985f0a6986$var$B() + 500, $15b790985f0a6986$var$jg()));
            }
            break;
        case 13:
            $15b790985f0a6986$var$Sk(function() {
                var b = $15b790985f0a6986$var$Zg(a, 1);
                if (null !== b) {
                    var c = $15b790985f0a6986$var$L();
                    $15b790985f0a6986$var$mh(b, a, 1, c);
                }
            }), $15b790985f0a6986$var$jl(a, 1);
    }
};
$15b790985f0a6986$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $15b790985f0a6986$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $15b790985f0a6986$var$L();
            $15b790985f0a6986$var$mh(b, a, 134217728, c);
        }
        $15b790985f0a6986$var$jl(a, 134217728);
    }
};
$15b790985f0a6986$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $15b790985f0a6986$var$lh(a), c = $15b790985f0a6986$var$Zg(a, b);
        if (null !== c) {
            var d = $15b790985f0a6986$var$L();
            $15b790985f0a6986$var$mh(c, a, b, d);
        }
        $15b790985f0a6986$var$jl(a, b);
    }
};
$15b790985f0a6986$var$Hc = function() {
    return $15b790985f0a6986$var$C;
};
$15b790985f0a6986$var$Ic = function(a, b) {
    var c = $15b790985f0a6986$var$C;
    try {
        return $15b790985f0a6986$var$C = a, b();
    } finally{
        $15b790985f0a6986$var$C = c;
    }
};
$15b790985f0a6986$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $15b790985f0a6986$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $15b790985f0a6986$var$Db(d);
                        if (!e) throw Error($15b790985f0a6986$var$p(90));
                        $15b790985f0a6986$var$Wa(d);
                        $15b790985f0a6986$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $15b790985f0a6986$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $15b790985f0a6986$var$fb(a, !!c.multiple, b, !1);
    }
};
$15b790985f0a6986$var$Gb = $15b790985f0a6986$var$Rk;
$15b790985f0a6986$var$Hb = $15b790985f0a6986$var$Sk;
var $15b790985f0a6986$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $15b790985f0a6986$var$Cb,
        $15b790985f0a6986$var$ue,
        $15b790985f0a6986$var$Db,
        $15b790985f0a6986$var$Eb,
        $15b790985f0a6986$var$Fb,
        $15b790985f0a6986$var$Rk
    ]
}, $15b790985f0a6986$var$ul = {
    findFiberByHostInstance: $15b790985f0a6986$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $15b790985f0a6986$var$vl = {
    bundleType: $15b790985f0a6986$var$ul.bundleType,
    version: $15b790985f0a6986$var$ul.version,
    rendererPackageName: $15b790985f0a6986$var$ul.rendererPackageName,
    rendererConfig: $15b790985f0a6986$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $15b790985f0a6986$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $15b790985f0a6986$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $15b790985f0a6986$var$ul.findFiberByHostInstance || $15b790985f0a6986$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $15b790985f0a6986$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$15b790985f0a6986$var$wl.isDisabled && $15b790985f0a6986$var$wl.supportsFiber) try {
        $15b790985f0a6986$var$kc = $15b790985f0a6986$var$wl.inject($15b790985f0a6986$var$vl), $15b790985f0a6986$var$lc = $15b790985f0a6986$var$wl;
    } catch (a) {}
}
$15b790985f0a6986$export$ae55be85d98224ed = $15b790985f0a6986$var$tl;
$15b790985f0a6986$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$15b790985f0a6986$var$ol(b)) throw Error($15b790985f0a6986$var$p(200));
    return $15b790985f0a6986$var$dl(a, b, null, c);
};
$15b790985f0a6986$export$882461b6382ed46c = function(a, b) {
    if (!$15b790985f0a6986$var$ol(a)) throw Error($15b790985f0a6986$var$p(299));
    var c = !1, d = "", e = $15b790985f0a6986$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $15b790985f0a6986$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$15b790985f0a6986$var$uf] = b.current;
    $15b790985f0a6986$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $15b790985f0a6986$var$ml(b);
};
$15b790985f0a6986$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($15b790985f0a6986$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($15b790985f0a6986$var$p(268, a));
    }
    a = $15b790985f0a6986$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$15b790985f0a6986$export$cd75ccfd720a3cd4 = function(a) {
    return $15b790985f0a6986$var$Sk(a);
};
$15b790985f0a6986$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$15b790985f0a6986$var$pl(b)) throw Error($15b790985f0a6986$var$p(200));
    return $15b790985f0a6986$var$sl(null, a, b, !0, c);
};
$15b790985f0a6986$export$757ceba2d55c277e = function(a, b, c) {
    if (!$15b790985f0a6986$var$ol(a)) throw Error($15b790985f0a6986$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $15b790985f0a6986$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $15b790985f0a6986$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$15b790985f0a6986$var$uf] = b.current;
    $15b790985f0a6986$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $15b790985f0a6986$var$nl(b);
};
$15b790985f0a6986$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$15b790985f0a6986$var$pl(b)) throw Error($15b790985f0a6986$var$p(200));
    return $15b790985f0a6986$var$sl(null, a, b, !1, c);
};
$15b790985f0a6986$export$502457920280e6be = function(a) {
    if (!$15b790985f0a6986$var$pl(a)) throw Error($15b790985f0a6986$var$p(40));
    return a._reactRootContainer ? ($15b790985f0a6986$var$Sk(function() {
        $15b790985f0a6986$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$15b790985f0a6986$var$uf] = null;
        });
    }), !0) : !1;
};
$15b790985f0a6986$export$c78a37762a8d58e1 = $15b790985f0a6986$var$Rk;
$15b790985f0a6986$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$15b790985f0a6986$var$pl(c)) throw Error($15b790985f0a6986$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($15b790985f0a6986$var$p(38));
    return $15b790985f0a6986$var$sl(a, b, c, !1, d);
};
$15b790985f0a6986$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("aqnAF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5JeDz"));

});
parcelRegister("5JeDz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $42bc82632ea60a67$export$c4744153514ff05d; }, function (v) { return $42bc82632ea60a67$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $42bc82632ea60a67$export$3e506c1ccc9cc1a7; }, function (v) { return $42bc82632ea60a67$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $42bc82632ea60a67$export$e26fe2ed2fa76875; }, function (v) { return $42bc82632ea60a67$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $42bc82632ea60a67$export$502329bbf4b505b1; }, function (v) { return $42bc82632ea60a67$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $42bc82632ea60a67$export$6e3807111c4874c4; }, function (v) { return $42bc82632ea60a67$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $42bc82632ea60a67$export$c27134553091fb3a; }, function (v) { return $42bc82632ea60a67$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $42bc82632ea60a67$export$33ee1acdc04fd2a2; }, function (v) { return $42bc82632ea60a67$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $42bc82632ea60a67$export$b00a404bbd5edef2; }, function (v) { return $42bc82632ea60a67$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $42bc82632ea60a67$export$8352ce38b91d0c62; }, function (v) { return $42bc82632ea60a67$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $42bc82632ea60a67$export$d66a1c1c77bd778b; }, function (v) { return $42bc82632ea60a67$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $42bc82632ea60a67$export$d3dfb8e4810cb555; }, function (v) { return $42bc82632ea60a67$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $42bc82632ea60a67$export$839f9183b0465a69; }, function (v) { return $42bc82632ea60a67$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $42bc82632ea60a67$export$72fdf0e06517287b; }, function (v) { return $42bc82632ea60a67$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $42bc82632ea60a67$export$4b844e58a3e414b4; }, function (v) { return $42bc82632ea60a67$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $42bc82632ea60a67$export$816d2913ae6b83b1; }, function (v) { return $42bc82632ea60a67$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $42bc82632ea60a67$export$61bcfe829111a1d0; }, function (v) { return $42bc82632ea60a67$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $42bc82632ea60a67$export$7ee8c9beb337bc3f; }, function (v) { return $42bc82632ea60a67$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $42bc82632ea60a67$export$b5836b71941fa3ed; }, function (v) { return $42bc82632ea60a67$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $42bc82632ea60a67$export$cf845f2c119da08a; }, function (v) { return $42bc82632ea60a67$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $42bc82632ea60a67$export$c4744153514ff05d;
var $42bc82632ea60a67$export$3e506c1ccc9cc1a7;
var $42bc82632ea60a67$export$e26fe2ed2fa76875;
var $42bc82632ea60a67$export$502329bbf4b505b1;
var $42bc82632ea60a67$export$6e3807111c4874c4;
var $42bc82632ea60a67$export$c27134553091fb3a;
var $42bc82632ea60a67$export$33ee1acdc04fd2a2;
var $42bc82632ea60a67$export$b00a404bbd5edef2;
var $42bc82632ea60a67$export$8352ce38b91d0c62;
var $42bc82632ea60a67$export$d66a1c1c77bd778b;
var $42bc82632ea60a67$export$d3dfb8e4810cb555;
var $42bc82632ea60a67$export$839f9183b0465a69;
var $42bc82632ea60a67$export$72fdf0e06517287b;
var $42bc82632ea60a67$export$4b844e58a3e414b4;
var $42bc82632ea60a67$export$816d2913ae6b83b1;
var $42bc82632ea60a67$export$61bcfe829111a1d0;
var $42bc82632ea60a67$export$7ee8c9beb337bc3f;
var $42bc82632ea60a67$export$b5836b71941fa3ed;
var $42bc82632ea60a67$export$cf845f2c119da08a;
'use strict';
function $42bc82632ea60a67$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $42bc82632ea60a67$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $42bc82632ea60a67$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $42bc82632ea60a67$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $42bc82632ea60a67$var$g(C, c)) n < e && 0 > $42bc82632ea60a67$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $42bc82632ea60a67$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $42bc82632ea60a67$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $42bc82632ea60a67$var$l = performance;
    $42bc82632ea60a67$export$c4744153514ff05d = function() {
        return $42bc82632ea60a67$var$l.now();
    };
} else {
    var $42bc82632ea60a67$var$p = Date, $42bc82632ea60a67$var$q = $42bc82632ea60a67$var$p.now();
    $42bc82632ea60a67$export$c4744153514ff05d = function() {
        return $42bc82632ea60a67$var$p.now() - $42bc82632ea60a67$var$q;
    };
}
var $42bc82632ea60a67$var$r = [], $42bc82632ea60a67$var$t = [], $42bc82632ea60a67$var$u = 1, $42bc82632ea60a67$var$v = null, $42bc82632ea60a67$var$y = 3, $42bc82632ea60a67$var$z = !1, $42bc82632ea60a67$var$A = !1, $42bc82632ea60a67$var$B = !1, $42bc82632ea60a67$var$D = "function" === typeof setTimeout ? setTimeout : null, $42bc82632ea60a67$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $42bc82632ea60a67$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $42bc82632ea60a67$var$G(a) {
    for(var b = $42bc82632ea60a67$var$h($42bc82632ea60a67$var$t); null !== b;){
        if (null === b.callback) $42bc82632ea60a67$var$k($42bc82632ea60a67$var$t);
        else if (b.startTime <= a) $42bc82632ea60a67$var$k($42bc82632ea60a67$var$t), b.sortIndex = b.expirationTime, $42bc82632ea60a67$var$f($42bc82632ea60a67$var$r, b);
        else break;
        b = $42bc82632ea60a67$var$h($42bc82632ea60a67$var$t);
    }
}
function $42bc82632ea60a67$var$H(a) {
    $42bc82632ea60a67$var$B = !1;
    $42bc82632ea60a67$var$G(a);
    if (!$42bc82632ea60a67$var$A) {
        if (null !== $42bc82632ea60a67$var$h($42bc82632ea60a67$var$r)) $42bc82632ea60a67$var$A = !0, $42bc82632ea60a67$var$I($42bc82632ea60a67$var$J);
        else {
            var b = $42bc82632ea60a67$var$h($42bc82632ea60a67$var$t);
            null !== b && $42bc82632ea60a67$var$K($42bc82632ea60a67$var$H, b.startTime - a);
        }
    }
}
function $42bc82632ea60a67$var$J(a, b) {
    $42bc82632ea60a67$var$A = !1;
    $42bc82632ea60a67$var$B && ($42bc82632ea60a67$var$B = !1, $42bc82632ea60a67$var$E($42bc82632ea60a67$var$L), $42bc82632ea60a67$var$L = -1);
    $42bc82632ea60a67$var$z = !0;
    var c = $42bc82632ea60a67$var$y;
    try {
        $42bc82632ea60a67$var$G(b);
        for($42bc82632ea60a67$var$v = $42bc82632ea60a67$var$h($42bc82632ea60a67$var$r); null !== $42bc82632ea60a67$var$v && (!($42bc82632ea60a67$var$v.expirationTime > b) || a && !$42bc82632ea60a67$var$M());){
            var d = $42bc82632ea60a67$var$v.callback;
            if ("function" === typeof d) {
                $42bc82632ea60a67$var$v.callback = null;
                $42bc82632ea60a67$var$y = $42bc82632ea60a67$var$v.priorityLevel;
                var e = d($42bc82632ea60a67$var$v.expirationTime <= b);
                b = $42bc82632ea60a67$export$c4744153514ff05d();
                "function" === typeof e ? $42bc82632ea60a67$var$v.callback = e : $42bc82632ea60a67$var$v === $42bc82632ea60a67$var$h($42bc82632ea60a67$var$r) && $42bc82632ea60a67$var$k($42bc82632ea60a67$var$r);
                $42bc82632ea60a67$var$G(b);
            } else $42bc82632ea60a67$var$k($42bc82632ea60a67$var$r);
            $42bc82632ea60a67$var$v = $42bc82632ea60a67$var$h($42bc82632ea60a67$var$r);
        }
        if (null !== $42bc82632ea60a67$var$v) var w = !0;
        else {
            var m = $42bc82632ea60a67$var$h($42bc82632ea60a67$var$t);
            null !== m && $42bc82632ea60a67$var$K($42bc82632ea60a67$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $42bc82632ea60a67$var$v = null, $42bc82632ea60a67$var$y = c, $42bc82632ea60a67$var$z = !1;
    }
}
var $42bc82632ea60a67$var$N = !1, $42bc82632ea60a67$var$O = null, $42bc82632ea60a67$var$L = -1, $42bc82632ea60a67$var$P = 5, $42bc82632ea60a67$var$Q = -1;
function $42bc82632ea60a67$var$M() {
    return $42bc82632ea60a67$export$c4744153514ff05d() - $42bc82632ea60a67$var$Q < $42bc82632ea60a67$var$P ? !1 : !0;
}
function $42bc82632ea60a67$var$R() {
    if (null !== $42bc82632ea60a67$var$O) {
        var a = $42bc82632ea60a67$export$c4744153514ff05d();
        $42bc82632ea60a67$var$Q = a;
        var b = !0;
        try {
            b = $42bc82632ea60a67$var$O(!0, a);
        } finally{
            b ? $42bc82632ea60a67$var$S() : ($42bc82632ea60a67$var$N = !1, $42bc82632ea60a67$var$O = null);
        }
    } else $42bc82632ea60a67$var$N = !1;
}
var $42bc82632ea60a67$var$S;
if ("function" === typeof $42bc82632ea60a67$var$F) $42bc82632ea60a67$var$S = function() {
    $42bc82632ea60a67$var$F($42bc82632ea60a67$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $42bc82632ea60a67$var$T = new MessageChannel, $42bc82632ea60a67$var$U = $42bc82632ea60a67$var$T.port2;
    $42bc82632ea60a67$var$T.port1.onmessage = $42bc82632ea60a67$var$R;
    $42bc82632ea60a67$var$S = function() {
        $42bc82632ea60a67$var$U.postMessage(null);
    };
} else $42bc82632ea60a67$var$S = function() {
    $42bc82632ea60a67$var$D($42bc82632ea60a67$var$R, 0);
};
function $42bc82632ea60a67$var$I(a) {
    $42bc82632ea60a67$var$O = a;
    $42bc82632ea60a67$var$N || ($42bc82632ea60a67$var$N = !0, $42bc82632ea60a67$var$S());
}
function $42bc82632ea60a67$var$K(a, b) {
    $42bc82632ea60a67$var$L = $42bc82632ea60a67$var$D(function() {
        a($42bc82632ea60a67$export$c4744153514ff05d());
    }, b);
}
$42bc82632ea60a67$export$3e506c1ccc9cc1a7 = 5;
$42bc82632ea60a67$export$e26fe2ed2fa76875 = 1;
$42bc82632ea60a67$export$502329bbf4b505b1 = 4;
$42bc82632ea60a67$export$6e3807111c4874c4 = 3;
$42bc82632ea60a67$export$c27134553091fb3a = null;
$42bc82632ea60a67$export$33ee1acdc04fd2a2 = 2;
$42bc82632ea60a67$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$42bc82632ea60a67$export$8352ce38b91d0c62 = function() {
    $42bc82632ea60a67$var$A || $42bc82632ea60a67$var$z || ($42bc82632ea60a67$var$A = !0, $42bc82632ea60a67$var$I($42bc82632ea60a67$var$J));
};
$42bc82632ea60a67$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $42bc82632ea60a67$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$42bc82632ea60a67$export$d3dfb8e4810cb555 = function() {
    return $42bc82632ea60a67$var$y;
};
$42bc82632ea60a67$export$839f9183b0465a69 = function() {
    return $42bc82632ea60a67$var$h($42bc82632ea60a67$var$r);
};
$42bc82632ea60a67$export$72fdf0e06517287b = function(a) {
    switch($42bc82632ea60a67$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $42bc82632ea60a67$var$y;
    }
    var c = $42bc82632ea60a67$var$y;
    $42bc82632ea60a67$var$y = b;
    try {
        return a();
    } finally{
        $42bc82632ea60a67$var$y = c;
    }
};
$42bc82632ea60a67$export$4b844e58a3e414b4 = function() {};
$42bc82632ea60a67$export$816d2913ae6b83b1 = function() {};
$42bc82632ea60a67$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $42bc82632ea60a67$var$y;
    $42bc82632ea60a67$var$y = a;
    try {
        return b();
    } finally{
        $42bc82632ea60a67$var$y = c;
    }
};
$42bc82632ea60a67$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $42bc82632ea60a67$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $42bc82632ea60a67$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $42bc82632ea60a67$var$f($42bc82632ea60a67$var$t, a), null === $42bc82632ea60a67$var$h($42bc82632ea60a67$var$r) && a === $42bc82632ea60a67$var$h($42bc82632ea60a67$var$t) && ($42bc82632ea60a67$var$B ? ($42bc82632ea60a67$var$E($42bc82632ea60a67$var$L), $42bc82632ea60a67$var$L = -1) : $42bc82632ea60a67$var$B = !0, $42bc82632ea60a67$var$K($42bc82632ea60a67$var$H, c - d))) : (a.sortIndex = e, $42bc82632ea60a67$var$f($42bc82632ea60a67$var$r, a), $42bc82632ea60a67$var$A || $42bc82632ea60a67$var$z || ($42bc82632ea60a67$var$A = !0, $42bc82632ea60a67$var$I($42bc82632ea60a67$var$J)));
    return a;
};
$42bc82632ea60a67$export$b5836b71941fa3ed = $42bc82632ea60a67$var$M;
$42bc82632ea60a67$export$cf845f2c119da08a = function(a) {
    var b = $42bc82632ea60a67$var$y;
    return function() {
        var c = $42bc82632ea60a67$var$y;
        $42bc82632ea60a67$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $42bc82632ea60a67$var$y = c;
        }
    };
};

});




parcelRegister("1lj2q", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0fa6852ba501f822$var$ReactIs, $0fa6852ba501f822$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("leYpR"))();

});
parcelRegister("leYpR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $jHnAo = parcelRequire("jHnAo");
function $f769c525c008a4cf$var$emptyFunction() {}
function $f769c525c008a4cf$var$emptyFunctionWithReset() {}
$f769c525c008a4cf$var$emptyFunctionWithReset.resetWarningCache = $f769c525c008a4cf$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $jHnAo) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f769c525c008a4cf$var$emptyFunctionWithReset,
        resetWarningCache: $f769c525c008a4cf$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("jHnAo", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $e5745426157d311e$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $e5745426157d311e$var$ReactPropTypesSecret;

});



parcelRegister("5v15z", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $4010b139a3f895bb$export$2b8d127b894957b9; }, function (v) { return $4010b139a3f895bb$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $4010b139a3f895bb$export$cea3a54a6425200c; }, function (v) { return $4010b139a3f895bb$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $4010b139a3f895bb$export$a7c73072b1a182ae; }, function (v) { return $4010b139a3f895bb$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $4010b139a3f895bb$export$9f27bc3417b4524d; }, function (v) { return $4010b139a3f895bb$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $4010b139a3f895bb$export$db77ccec0bb4ccac; }, function (v) { return $4010b139a3f895bb$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $4010b139a3f895bb$export$8392c0c9d3dcbd35; }, function (v) { return $4010b139a3f895bb$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4010b139a3f895bb$export$ffb0004e005737fa; }, function (v) { return $4010b139a3f895bb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $4010b139a3f895bb$export$b624eff549462981; }, function (v) { return $4010b139a3f895bb$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $4010b139a3f895bb$export$7897aa7841a5380c; }, function (v) { return $4010b139a3f895bb$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $4010b139a3f895bb$export$602eac185826482c; }, function (v) { return $4010b139a3f895bb$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $4010b139a3f895bb$export$e2c29f18771995cb; }, function (v) { return $4010b139a3f895bb$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4010b139a3f895bb$export$5f8d39834fd61797; }, function (v) { return $4010b139a3f895bb$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4010b139a3f895bb$export$74bf444e3cd11ea5; }, function (v) { return $4010b139a3f895bb$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $4010b139a3f895bb$export$92387174baf9b227; }, function (v) { return $4010b139a3f895bb$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $4010b139a3f895bb$export$ec112efeb987d9c6; }, function (v) { return $4010b139a3f895bb$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $4010b139a3f895bb$export$b706b080d889d2c9; }, function (v) { return $4010b139a3f895bb$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $4010b139a3f895bb$export$5be5a87408f70ddc; }, function (v) { return $4010b139a3f895bb$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $4010b139a3f895bb$export$45a5e7f76e0caa8d; }, function (v) { return $4010b139a3f895bb$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $4010b139a3f895bb$export$455c2e768291efa6; }, function (v) { return $4010b139a3f895bb$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $4010b139a3f895bb$export$9522e17588c12572; }, function (v) { return $4010b139a3f895bb$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $4010b139a3f895bb$export$2110ac352bb060b9; }, function (v) { return $4010b139a3f895bb$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $4010b139a3f895bb$export$56885ab8b9c456ab; }, function (v) { return $4010b139a3f895bb$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $4010b139a3f895bb$export$d927fcb6adf8f9de; }, function (v) { return $4010b139a3f895bb$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $4010b139a3f895bb$export$b82d16f27459e05a; }, function (v) { return $4010b139a3f895bb$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $4010b139a3f895bb$export$522c17b4f5e123e8; }, function (v) { return $4010b139a3f895bb$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $4010b139a3f895bb$export$1aabd8a0274ecfd6; }, function (v) { return $4010b139a3f895bb$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $4010b139a3f895bb$export$9b621391a187a31a; }, function (v) { return $4010b139a3f895bb$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $4010b139a3f895bb$export$f5bbd400c2f4426f; }, function (v) { return $4010b139a3f895bb$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4010b139a3f895bb$export$2b8d127b894957b9;
var $4010b139a3f895bb$export$cea3a54a6425200c;
var $4010b139a3f895bb$export$a7c73072b1a182ae;
var $4010b139a3f895bb$export$9f27bc3417b4524d;
var $4010b139a3f895bb$export$db77ccec0bb4ccac;
var $4010b139a3f895bb$export$8392c0c9d3dcbd35;
var $4010b139a3f895bb$export$ffb0004e005737fa;
var $4010b139a3f895bb$export$b624eff549462981;
var $4010b139a3f895bb$export$7897aa7841a5380c;
var $4010b139a3f895bb$export$602eac185826482c;
var $4010b139a3f895bb$export$e2c29f18771995cb;
var $4010b139a3f895bb$export$5f8d39834fd61797;
var $4010b139a3f895bb$export$74bf444e3cd11ea5;
var $4010b139a3f895bb$export$92387174baf9b227;
var $4010b139a3f895bb$export$ec112efeb987d9c6;
var $4010b139a3f895bb$export$b706b080d889d2c9;
var $4010b139a3f895bb$export$5be5a87408f70ddc;
var $4010b139a3f895bb$export$45a5e7f76e0caa8d;
var $4010b139a3f895bb$export$455c2e768291efa6;
var $4010b139a3f895bb$export$9522e17588c12572;
var $4010b139a3f895bb$export$2110ac352bb060b9;
var $4010b139a3f895bb$export$56885ab8b9c456ab;
var $4010b139a3f895bb$export$d927fcb6adf8f9de;
var $4010b139a3f895bb$export$b82d16f27459e05a;
var $4010b139a3f895bb$export$522c17b4f5e123e8;
var $4010b139a3f895bb$export$1aabd8a0274ecfd6;
var $4010b139a3f895bb$export$9b621391a187a31a;
var $4010b139a3f895bb$export$f5bbd400c2f4426f;
'use strict';
var $4010b139a3f895bb$var$b = "function" === typeof Symbol && Symbol.for, $4010b139a3f895bb$var$c = $4010b139a3f895bb$var$b ? Symbol.for("react.element") : 60103, $4010b139a3f895bb$var$d = $4010b139a3f895bb$var$b ? Symbol.for("react.portal") : 60106, $4010b139a3f895bb$var$e = $4010b139a3f895bb$var$b ? Symbol.for("react.fragment") : 60107, $4010b139a3f895bb$var$f = $4010b139a3f895bb$var$b ? Symbol.for("react.strict_mode") : 60108, $4010b139a3f895bb$var$g = $4010b139a3f895bb$var$b ? Symbol.for("react.profiler") : 60114, $4010b139a3f895bb$var$h = $4010b139a3f895bb$var$b ? Symbol.for("react.provider") : 60109, $4010b139a3f895bb$var$k = $4010b139a3f895bb$var$b ? Symbol.for("react.context") : 60110, $4010b139a3f895bb$var$l = $4010b139a3f895bb$var$b ? Symbol.for("react.async_mode") : 60111, $4010b139a3f895bb$var$m = $4010b139a3f895bb$var$b ? Symbol.for("react.concurrent_mode") : 60111, $4010b139a3f895bb$var$n = $4010b139a3f895bb$var$b ? Symbol.for("react.forward_ref") : 60112, $4010b139a3f895bb$var$p = $4010b139a3f895bb$var$b ? Symbol.for("react.suspense") : 60113, $4010b139a3f895bb$var$q = $4010b139a3f895bb$var$b ? Symbol.for("react.suspense_list") : 60120, $4010b139a3f895bb$var$r = $4010b139a3f895bb$var$b ? Symbol.for("react.memo") : 60115, $4010b139a3f895bb$var$t = $4010b139a3f895bb$var$b ? Symbol.for("react.lazy") : 60116, $4010b139a3f895bb$var$v = $4010b139a3f895bb$var$b ? Symbol.for("react.block") : 60121, $4010b139a3f895bb$var$w = $4010b139a3f895bb$var$b ? Symbol.for("react.fundamental") : 60117, $4010b139a3f895bb$var$x = $4010b139a3f895bb$var$b ? Symbol.for("react.responder") : 60118, $4010b139a3f895bb$var$y = $4010b139a3f895bb$var$b ? Symbol.for("react.scope") : 60119;
function $4010b139a3f895bb$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $4010b139a3f895bb$var$c:
                switch(a = a.type, a){
                    case $4010b139a3f895bb$var$l:
                    case $4010b139a3f895bb$var$m:
                    case $4010b139a3f895bb$var$e:
                    case $4010b139a3f895bb$var$g:
                    case $4010b139a3f895bb$var$f:
                    case $4010b139a3f895bb$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $4010b139a3f895bb$var$k:
                            case $4010b139a3f895bb$var$n:
                            case $4010b139a3f895bb$var$t:
                            case $4010b139a3f895bb$var$r:
                            case $4010b139a3f895bb$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $4010b139a3f895bb$var$d:
                return u;
        }
    }
}
function $4010b139a3f895bb$var$A(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$m;
}
$4010b139a3f895bb$export$2b8d127b894957b9 = $4010b139a3f895bb$var$l;
$4010b139a3f895bb$export$cea3a54a6425200c = $4010b139a3f895bb$var$m;
$4010b139a3f895bb$export$a7c73072b1a182ae = $4010b139a3f895bb$var$k;
$4010b139a3f895bb$export$9f27bc3417b4524d = $4010b139a3f895bb$var$h;
$4010b139a3f895bb$export$db77ccec0bb4ccac = $4010b139a3f895bb$var$c;
$4010b139a3f895bb$export$8392c0c9d3dcbd35 = $4010b139a3f895bb$var$n;
$4010b139a3f895bb$export$ffb0004e005737fa = $4010b139a3f895bb$var$e;
$4010b139a3f895bb$export$b624eff549462981 = $4010b139a3f895bb$var$t;
$4010b139a3f895bb$export$7897aa7841a5380c = $4010b139a3f895bb$var$r;
$4010b139a3f895bb$export$602eac185826482c = $4010b139a3f895bb$var$d;
$4010b139a3f895bb$export$e2c29f18771995cb = $4010b139a3f895bb$var$g;
$4010b139a3f895bb$export$5f8d39834fd61797 = $4010b139a3f895bb$var$f;
$4010b139a3f895bb$export$74bf444e3cd11ea5 = $4010b139a3f895bb$var$p;
$4010b139a3f895bb$export$92387174baf9b227 = function(a) {
    return $4010b139a3f895bb$var$A(a) || $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$l;
};
$4010b139a3f895bb$export$ec112efeb987d9c6 = $4010b139a3f895bb$var$A;
$4010b139a3f895bb$export$b706b080d889d2c9 = function(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$k;
};
$4010b139a3f895bb$export$5be5a87408f70ddc = function(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$h;
};
$4010b139a3f895bb$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4010b139a3f895bb$var$c;
};
$4010b139a3f895bb$export$455c2e768291efa6 = function(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$n;
};
$4010b139a3f895bb$export$9522e17588c12572 = function(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$e;
};
$4010b139a3f895bb$export$2110ac352bb060b9 = function(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$t;
};
$4010b139a3f895bb$export$56885ab8b9c456ab = function(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$r;
};
$4010b139a3f895bb$export$d927fcb6adf8f9de = function(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$d;
};
$4010b139a3f895bb$export$b82d16f27459e05a = function(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$g;
};
$4010b139a3f895bb$export$522c17b4f5e123e8 = function(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$f;
};
$4010b139a3f895bb$export$1aabd8a0274ecfd6 = function(a) {
    return $4010b139a3f895bb$var$z(a) === $4010b139a3f895bb$var$p;
};
$4010b139a3f895bb$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $4010b139a3f895bb$var$e || a === $4010b139a3f895bb$var$m || a === $4010b139a3f895bb$var$g || a === $4010b139a3f895bb$var$f || a === $4010b139a3f895bb$var$p || a === $4010b139a3f895bb$var$q || "object" === typeof a && null !== a && (a.$$typeof === $4010b139a3f895bb$var$t || a.$$typeof === $4010b139a3f895bb$var$r || a.$$typeof === $4010b139a3f895bb$var$h || a.$$typeof === $4010b139a3f895bb$var$k || a.$$typeof === $4010b139a3f895bb$var$n || a.$$typeof === $4010b139a3f895bb$var$w || a.$$typeof === $4010b139a3f895bb$var$x || a.$$typeof === $4010b139a3f895bb$var$y || a.$$typeof === $4010b139a3f895bb$var$v);
};
$4010b139a3f895bb$export$f5bbd400c2f4426f = $4010b139a3f895bb$var$z;

});

parcelRegister("b9KbE", function(module, exports) {

var $lAA3U = parcelRequire("lAA3U");

var $i4tlR = parcelRequire("i4tlR");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $lAA3U.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $i4tlR;
module.exports = isBuffer;

});
parcelRegister("lAA3U", function(module, exports) {

var $e1k8u = parcelRequire("e1k8u");
/** Detect free variable `self`. */ var $fb78eef220b471a7$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $fb78eef220b471a7$var$root = $e1k8u || $fb78eef220b471a7$var$freeSelf || Function('return this')();
module.exports = $fb78eef220b471a7$var$root;

});
parcelRegister("e1k8u", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $a350c742a13a39e5$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $a350c742a13a39e5$var$freeGlobal;

});


parcelRegister("i4tlR", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $036526aeb273039f$var$stubFalse() {
    return false;
}
module.exports = $036526aeb273039f$var$stubFalse;

});


parcelRegister("8xkF4", function(module, exports) {

var $e1k8u = parcelRequire("e1k8u");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $e1k8u.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("e80qp", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("hyOQr"));

});
parcelRegister("hyOQr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $9sVWU.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $9sVWU.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $kD2j0.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $kD2j0.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $kPb3d.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $kPb3d.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $kPb3d.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $kPb3d.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $cc8d0d61db22c297$var$_symbol.symbolsStroke;
    }
});

var $cc8d0d61db22c297$var$_arc = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("38F7h")));

var $cc8d0d61db22c297$var$_area = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("6DxEi")));

var $cc8d0d61db22c297$var$_line = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("4GVSg")));

var $cc8d0d61db22c297$var$_pie = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("aczxg")));

var $cc8d0d61db22c297$var$_areaRadial = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("femx9")));

var $cc8d0d61db22c297$var$_lineRadial = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("fVRyJ")));

var $cc8d0d61db22c297$var$_pointRadial = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("iB3kk")));

var $kPb3d = parcelRequire("kPb3d");

var $cc8d0d61db22c297$var$_symbol = $cc8d0d61db22c297$var$_interopRequireWildcard((parcelRequire("7M2E1")));

var $cc8d0d61db22c297$var$_asterisk = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("kEtuQ")));

var $cc8d0d61db22c297$var$_circle = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("bNo29")));

var $cc8d0d61db22c297$var$_cross = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("7Z6Yk")));

var $cc8d0d61db22c297$var$_diamond = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("PiW8f")));

var $cc8d0d61db22c297$var$_diamond2 = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("atdAI")));

var $cc8d0d61db22c297$var$_plus = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("bjvHG")));

var $cc8d0d61db22c297$var$_square = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("d0XgR")));

var $cc8d0d61db22c297$var$_square2 = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("1I1UW")));

var $cc8d0d61db22c297$var$_star = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("46umI")));

var $cc8d0d61db22c297$var$_triangle = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("kRKEh")));

var $cc8d0d61db22c297$var$_triangle2 = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("iQe2h")));

var $cc8d0d61db22c297$var$_wye = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("g8j4V")));

var $cc8d0d61db22c297$var$_x = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("kt2kr")));

var $cc8d0d61db22c297$var$_basisClosed = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("l6ND4")));

var $cc8d0d61db22c297$var$_basisOpen = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("9DfCK")));

var $cc8d0d61db22c297$var$_basis = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("5BVju")));

var $9sVWU = parcelRequire("9sVWU");

var $cc8d0d61db22c297$var$_bundle = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("3KhMk")));

var $cc8d0d61db22c297$var$_cardinalClosed = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("avZBL")));

var $cc8d0d61db22c297$var$_cardinalOpen = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("kl6Lw")));

var $cc8d0d61db22c297$var$_cardinal = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("hoF7M")));

var $cc8d0d61db22c297$var$_catmullRomClosed = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("hUIrC")));

var $cc8d0d61db22c297$var$_catmullRomOpen = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("8dwwA")));

var $cc8d0d61db22c297$var$_catmullRom = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("8uCUC")));

var $cc8d0d61db22c297$var$_linearClosed = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("eLMRy")));

var $cc8d0d61db22c297$var$_linear = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("MXslM")));

var $kD2j0 = parcelRequire("kD2j0");

var $cc8d0d61db22c297$var$_natural = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("fSTbn")));

var $cc8d0d61db22c297$var$_step = $cc8d0d61db22c297$var$_interopRequireWildcard((parcelRequire("2YBU3")));

var $cc8d0d61db22c297$var$_stack = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("4iVum")));

var $cc8d0d61db22c297$var$_expand = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("g0sra")));

var $cc8d0d61db22c297$var$_diverging = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("lXHNO")));

var $cc8d0d61db22c297$var$_none = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("9SHyD")));

var $cc8d0d61db22c297$var$_silhouette = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("cidns")));

var $cc8d0d61db22c297$var$_wiggle = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("1Sge1")));

var $cc8d0d61db22c297$var$_appearance = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("3euJK")));

var $cc8d0d61db22c297$var$_ascending = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("k0Mqh")));

var $cc8d0d61db22c297$var$_descending = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("avBc5")));

var $cc8d0d61db22c297$var$_insideOut = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("iagvH")));

var $cc8d0d61db22c297$var$_none2 = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("63kfx")));

var $cc8d0d61db22c297$var$_reverse = $cc8d0d61db22c297$var$_interopRequireDefault((parcelRequire("5Kx7I")));
function $cc8d0d61db22c297$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cc8d0d61db22c297$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cc8d0d61db22c297$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cc8d0d61db22c297$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cc8d0d61db22c297$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("38F7h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $249203547299d623$var$_default;

var $97HR3 = parcelRequire("97HR3");

var $249203547299d623$var$_constant = $249203547299d623$var$_interopRequireDefault((parcelRequire("40Sp7")));

var $b9QWH = parcelRequire("b9QWH");
function $249203547299d623$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $249203547299d623$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $249203547299d623$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $249203547299d623$var$arcStartAngle(d) {
    return d.startAngle;
}
function $249203547299d623$var$arcEndAngle(d) {
    return d.endAngle;
}
function $249203547299d623$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $249203547299d623$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $b9QWH.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $249203547299d623$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $b9QWH.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $b9QWH.sqrt)((0, $b9QWH.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $249203547299d623$var$_default() {
    var innerRadius = $249203547299d623$var$arcInnerRadius, outerRadius = $249203547299d623$var$arcOuterRadius, cornerRadius = (0, $249203547299d623$var$_constant.default)(0), padRadius = null, startAngle = $249203547299d623$var$arcStartAngle, endAngle = $249203547299d623$var$arcEndAngle, padAngle = $249203547299d623$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $b9QWH.halfPi, a1 = endAngle.apply(this, arguments) - $b9QWH.halfPi, da = (0, $b9QWH.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $97HR3.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $b9QWH.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $b9QWH.tau - $b9QWH.epsilon) {
            context.moveTo(r1 * (0, $b9QWH.cos)(a0), r1 * (0, $b9QWH.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $b9QWH.epsilon) {
                context.moveTo(r0 * (0, $b9QWH.cos)(a1), r0 * (0, $b9QWH.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $b9QWH.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $b9QWH.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $b9QWH.min)((0, $b9QWH.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $b9QWH.epsilon) {
                var p0 = (0, $b9QWH.asin)(rp / r0 * (0, $b9QWH.sin)(ap)), p1 = (0, $b9QWH.asin)(rp / r1 * (0, $b9QWH.sin)(ap));
                if ((da0 -= p0 * 2) > $b9QWH.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $b9QWH.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $b9QWH.cos)(a01), y01 = r1 * (0, $b9QWH.sin)(a01), x10 = r0 * (0, $b9QWH.cos)(a10), y10 = r0 * (0, $b9QWH.sin)(a10); // Apply rounded corners?
            if (rc > $b9QWH.epsilon) {
                var x11 = r1 * (0, $b9QWH.cos)(a11), y11 = r1 * (0, $b9QWH.sin)(a11), x00 = r0 * (0, $b9QWH.cos)(a00), y00 = r0 * (0, $b9QWH.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $b9QWH.pi && (oc = $249203547299d623$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $b9QWH.sin)((0, $b9QWH.acos)((ax * bx + ay * by) / ((0, $b9QWH.sqrt)(ax * ax + ay * ay) * (0, $b9QWH.sqrt)(bx * bx + by * by))) / 2), lc = (0, $b9QWH.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $b9QWH.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $b9QWH.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $b9QWH.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $b9QWH.epsilon) {
                t0 = $249203547299d623$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $249203547299d623$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $b9QWH.atan2)(t0.y01, t0.x01), (0, $b9QWH.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $b9QWH.atan2)(t0.y01, t0.x01), (0, $b9QWH.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $b9QWH.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $b9QWH.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $b9QWH.atan2)(t1.y11, t1.x11), (0, $b9QWH.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $b9QWH.epsilon) || !(da0 > $b9QWH.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $b9QWH.epsilon) {
                t0 = $249203547299d623$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $249203547299d623$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $b9QWH.atan2)(t0.y01, t0.x01), (0, $b9QWH.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $b9QWH.atan2)(t0.y01, t0.x01), (0, $b9QWH.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $b9QWH.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $b9QWH.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $b9QWH.atan2)(t1.y11, t1.x11), (0, $b9QWH.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $b9QWH.pi / 2;
        return [
            (0, $b9QWH.cos)(a) * r,
            (0, $b9QWH.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $249203547299d623$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $249203547299d623$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $249203547299d623$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $249203547299d623$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $249203547299d623$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $249203547299d623$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $249203547299d623$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("97HR3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $6a46c91daa67b7e8$var$_path.default;
    }
});

var $6a46c91daa67b7e8$var$_path = $6a46c91daa67b7e8$var$_interopRequireDefault((parcelRequire("gOjad")));
function $6a46c91daa67b7e8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("gOjad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $c3d02e5bb9fdcb39$var$pi = Math.PI, $c3d02e5bb9fdcb39$var$tau = 2 * $c3d02e5bb9fdcb39$var$pi, $c3d02e5bb9fdcb39$var$epsilon = 1e-6, $c3d02e5bb9fdcb39$var$tauEpsilon = $c3d02e5bb9fdcb39$var$tau - $c3d02e5bb9fdcb39$var$epsilon;
function $c3d02e5bb9fdcb39$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $c3d02e5bb9fdcb39$var$path() {
    return new $c3d02e5bb9fdcb39$var$Path();
}
$c3d02e5bb9fdcb39$var$Path.prototype = $c3d02e5bb9fdcb39$var$path.prototype = {
    constructor: $c3d02e5bb9fdcb39$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $c3d02e5bb9fdcb39$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c3d02e5bb9fdcb39$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c3d02e5bb9fdcb39$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c3d02e5bb9fdcb39$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $c3d02e5bb9fdcb39$var$epsilon || Math.abs(this._y1 - y0) > $c3d02e5bb9fdcb39$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c3d02e5bb9fdcb39$var$tau + $c3d02e5bb9fdcb39$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c3d02e5bb9fdcb39$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $c3d02e5bb9fdcb39$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $c3d02e5bb9fdcb39$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $c3d02e5bb9fdcb39$var$_default = $c3d02e5bb9fdcb39$var$path;
module.exports.default = $c3d02e5bb9fdcb39$var$_default;

});


parcelRegister("40Sp7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ec15d0bc85c6c3b$var$_default;
function $2ec15d0bc85c6c3b$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("b9QWH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $81f99ae99b36aa0f$var$acos;
module.exports.asin = $81f99ae99b36aa0f$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $81f99ae99b36aa0f$var$abs = Math.abs;
module.exports.abs = $81f99ae99b36aa0f$var$abs;
const $81f99ae99b36aa0f$var$atan2 = Math.atan2;
module.exports.atan2 = $81f99ae99b36aa0f$var$atan2;
const $81f99ae99b36aa0f$var$cos = Math.cos;
module.exports.cos = $81f99ae99b36aa0f$var$cos;
const $81f99ae99b36aa0f$var$max = Math.max;
module.exports.max = $81f99ae99b36aa0f$var$max;
const $81f99ae99b36aa0f$var$min = Math.min;
module.exports.min = $81f99ae99b36aa0f$var$min;
const $81f99ae99b36aa0f$var$sin = Math.sin;
module.exports.sin = $81f99ae99b36aa0f$var$sin;
const $81f99ae99b36aa0f$var$sqrt = Math.sqrt;
module.exports.sqrt = $81f99ae99b36aa0f$var$sqrt;
const $81f99ae99b36aa0f$var$epsilon = 1e-12;
module.exports.epsilon = $81f99ae99b36aa0f$var$epsilon;
const $81f99ae99b36aa0f$var$pi = Math.PI;
module.exports.pi = $81f99ae99b36aa0f$var$pi;
const $81f99ae99b36aa0f$var$halfPi = $81f99ae99b36aa0f$var$pi / 2;
module.exports.halfPi = $81f99ae99b36aa0f$var$halfPi;
const $81f99ae99b36aa0f$var$tau = 2 * $81f99ae99b36aa0f$var$pi;
module.exports.tau = $81f99ae99b36aa0f$var$tau;
function $81f99ae99b36aa0f$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $81f99ae99b36aa0f$var$pi : Math.acos(x);
}
function $81f99ae99b36aa0f$var$asin(x) {
    return x >= 1 ? $81f99ae99b36aa0f$var$halfPi : x <= -1 ? -$81f99ae99b36aa0f$var$halfPi : Math.asin(x);
}

});


parcelRegister("6DxEi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d507c961e08f2a9$var$_default;

var $97HR3 = parcelRequire("97HR3");

var $4d507c961e08f2a9$var$_array = $4d507c961e08f2a9$var$_interopRequireDefault((parcelRequire("jnGbx")));

var $4d507c961e08f2a9$var$_constant = $4d507c961e08f2a9$var$_interopRequireDefault((parcelRequire("40Sp7")));

var $4d507c961e08f2a9$var$_linear = $4d507c961e08f2a9$var$_interopRequireDefault((parcelRequire("MXslM")));

var $4d507c961e08f2a9$var$_line = $4d507c961e08f2a9$var$_interopRequireDefault((parcelRequire("4GVSg")));

var $cghsf = parcelRequire("cghsf");
function $4d507c961e08f2a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d507c961e08f2a9$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $4d507c961e08f2a9$var$_constant.default)(true), context = null, curve = $4d507c961e08f2a9$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $cghsf.x : (0, $4d507c961e08f2a9$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $4d507c961e08f2a9$var$_constant.default)(0) : (0, $4d507c961e08f2a9$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $cghsf.y : (0, $4d507c961e08f2a9$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $4d507c961e08f2a9$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $97HR3.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $4d507c961e08f2a9$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $4d507c961e08f2a9$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $4d507c961e08f2a9$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $4d507c961e08f2a9$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $4d507c961e08f2a9$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $4d507c961e08f2a9$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $4d507c961e08f2a9$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $4d507c961e08f2a9$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("jnGbx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e1c0e366d20c17be$var$_default;
module.exports.slice = void 0;
var $e1c0e366d20c17be$var$slice = Array.prototype.slice;
module.exports.slice = $e1c0e366d20c17be$var$slice;
function $e1c0e366d20c17be$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("MXslM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $09329a95cb18653b$var$_default;
function $09329a95cb18653b$var$Linear(context) {
    this._context = context;
}
$09329a95cb18653b$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $09329a95cb18653b$var$_default(context) {
    return new $09329a95cb18653b$var$Linear(context);
}

});

parcelRegister("4GVSg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36a7fa491e9e8b7f$var$_default;

var $97HR3 = parcelRequire("97HR3");

var $36a7fa491e9e8b7f$var$_array = $36a7fa491e9e8b7f$var$_interopRequireDefault((parcelRequire("jnGbx")));

var $36a7fa491e9e8b7f$var$_constant = $36a7fa491e9e8b7f$var$_interopRequireDefault((parcelRequire("40Sp7")));

var $36a7fa491e9e8b7f$var$_linear = $36a7fa491e9e8b7f$var$_interopRequireDefault((parcelRequire("MXslM")));

var $cghsf = parcelRequire("cghsf");
function $36a7fa491e9e8b7f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36a7fa491e9e8b7f$var$_default(x, y) {
    var defined = (0, $36a7fa491e9e8b7f$var$_constant.default)(true), context = null, curve = $36a7fa491e9e8b7f$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $cghsf.x : (0, $36a7fa491e9e8b7f$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $cghsf.y : (0, $36a7fa491e9e8b7f$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $36a7fa491e9e8b7f$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $97HR3.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $36a7fa491e9e8b7f$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $36a7fa491e9e8b7f$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $36a7fa491e9e8b7f$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("cghsf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $8ed484c7b1a2ec30$var$x;
module.exports.y = $8ed484c7b1a2ec30$var$y;
function $8ed484c7b1a2ec30$var$x(p) {
    return p[0];
}
function $8ed484c7b1a2ec30$var$y(p) {
    return p[1];
}

});



parcelRegister("aczxg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $76d696f97fbdcd47$var$_default;

var $76d696f97fbdcd47$var$_array = $76d696f97fbdcd47$var$_interopRequireDefault((parcelRequire("jnGbx")));

var $76d696f97fbdcd47$var$_constant = $76d696f97fbdcd47$var$_interopRequireDefault((parcelRequire("40Sp7")));

var $76d696f97fbdcd47$var$_descending = $76d696f97fbdcd47$var$_interopRequireDefault((parcelRequire("1dfJ1")));

var $76d696f97fbdcd47$var$_identity = $76d696f97fbdcd47$var$_interopRequireDefault((parcelRequire("dVX6r")));

var $b9QWH = parcelRequire("b9QWH");
function $76d696f97fbdcd47$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76d696f97fbdcd47$var$_default() {
    var value = $76d696f97fbdcd47$var$_identity.default, sortValues = $76d696f97fbdcd47$var$_descending.default, sort = null, startAngle = (0, $76d696f97fbdcd47$var$_constant.default)(0), endAngle = (0, $76d696f97fbdcd47$var$_constant.default)($b9QWH.tau), padAngle = (0, $76d696f97fbdcd47$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $76d696f97fbdcd47$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($b9QWH.tau, Math.max(-$b9QWH.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $76d696f97fbdcd47$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $76d696f97fbdcd47$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $76d696f97fbdcd47$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $76d696f97fbdcd47$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("1dfJ1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e23340855c3f438$var$_default;
function $0e23340855c3f438$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("dVX6r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a24e71d1c5abe01e$var$_default;
function $a24e71d1c5abe01e$var$_default(d) {
    return d;
}

});


parcelRegister("femx9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b169a485261e15c2$var$_default;

var $b169a485261e15c2$var$_radial = $b169a485261e15c2$var$_interopRequireWildcard((parcelRequire("dYUyj")));

var $b169a485261e15c2$var$_area = $b169a485261e15c2$var$_interopRequireDefault((parcelRequire("6DxEi")));

var $fVRyJ = parcelRequire("fVRyJ");
function $b169a485261e15c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b169a485261e15c2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b169a485261e15c2$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b169a485261e15c2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b169a485261e15c2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b169a485261e15c2$var$_default() {
    var a = (0, $b169a485261e15c2$var$_area.default)().curve($b169a485261e15c2$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $fVRyJ.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $fVRyJ.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $fVRyJ.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $fVRyJ.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $b169a485261e15c2$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("dYUyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $a2dcbf17e85d1659$var$curveRadial;

var $a2dcbf17e85d1659$var$_linear = $a2dcbf17e85d1659$var$_interopRequireDefault((parcelRequire("MXslM")));
function $a2dcbf17e85d1659$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a2dcbf17e85d1659$var$curveRadialLinear = $a2dcbf17e85d1659$var$curveRadial($a2dcbf17e85d1659$var$_linear.default);
module.exports.curveRadialLinear = $a2dcbf17e85d1659$var$curveRadialLinear;
function $a2dcbf17e85d1659$var$Radial(curve) {
    this._curve = curve;
}
$a2dcbf17e85d1659$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $a2dcbf17e85d1659$var$curveRadial(curve) {
    function radial(context) {
        return new $a2dcbf17e85d1659$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("fVRyJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b995b9a67acb7d1f$var$_default;
module.exports.lineRadial = $b995b9a67acb7d1f$var$lineRadial;

var $b995b9a67acb7d1f$var$_radial = $b995b9a67acb7d1f$var$_interopRequireWildcard((parcelRequire("dYUyj")));

var $b995b9a67acb7d1f$var$_line = $b995b9a67acb7d1f$var$_interopRequireDefault((parcelRequire("4GVSg")));
function $b995b9a67acb7d1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b995b9a67acb7d1f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b995b9a67acb7d1f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b995b9a67acb7d1f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b995b9a67acb7d1f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b995b9a67acb7d1f$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $b995b9a67acb7d1f$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $b995b9a67acb7d1f$var$_default() {
    return $b995b9a67acb7d1f$var$lineRadial((0, $b995b9a67acb7d1f$var$_line.default)().curve($b995b9a67acb7d1f$var$_radial.curveRadialLinear));
}

});


parcelRegister("iB3kk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d89e435bd46bc56d$var$_default;
function $d89e435bd46bc56d$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("kPb3d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $f291248ebcd643bf$var$link;
module.exports.linkHorizontal = $f291248ebcd643bf$var$linkHorizontal;
module.exports.linkRadial = $f291248ebcd643bf$var$linkRadial;
module.exports.linkVertical = $f291248ebcd643bf$var$linkVertical;

var $97HR3 = parcelRequire("97HR3");

var $jnGbx = parcelRequire("jnGbx");

var $f291248ebcd643bf$var$_constant = $f291248ebcd643bf$var$_interopRequireDefault((parcelRequire("40Sp7")));

var $9sVWU = parcelRequire("9sVWU");

var $cghsf = parcelRequire("cghsf");
function $f291248ebcd643bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f291248ebcd643bf$var$linkSource(d) {
    return d.source;
}
function $f291248ebcd643bf$var$linkTarget(d) {
    return d.target;
}
function $f291248ebcd643bf$var$link(curve) {
    let source = $f291248ebcd643bf$var$linkSource;
    let target = $f291248ebcd643bf$var$linkTarget;
    let x = $cghsf.x;
    let y = $cghsf.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $jnGbx.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $97HR3.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $f291248ebcd643bf$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $f291248ebcd643bf$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $f291248ebcd643bf$var$linkHorizontal() {
    return $f291248ebcd643bf$var$link($9sVWU.bumpX);
}
function $f291248ebcd643bf$var$linkVertical() {
    return $f291248ebcd643bf$var$link($9sVWU.bumpY);
}
function $f291248ebcd643bf$var$linkRadial() {
    const l = $f291248ebcd643bf$var$link($9sVWU.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("9sVWU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $6e43ae18a773e9b7$var$bumpRadial;
module.exports.bumpX = $6e43ae18a773e9b7$var$bumpX;
module.exports.bumpY = $6e43ae18a773e9b7$var$bumpY;

var $6e43ae18a773e9b7$var$_pointRadial = $6e43ae18a773e9b7$var$_interopRequireDefault((parcelRequire("iB3kk")));
function $6e43ae18a773e9b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $6e43ae18a773e9b7$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $6e43ae18a773e9b7$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $6e43ae18a773e9b7$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $6e43ae18a773e9b7$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $6e43ae18a773e9b7$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $6e43ae18a773e9b7$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $6e43ae18a773e9b7$var$bumpX(context) {
    return new $6e43ae18a773e9b7$var$Bump(context, true);
}
function $6e43ae18a773e9b7$var$bumpY(context) {
    return new $6e43ae18a773e9b7$var$Bump(context, false);
}
function $6e43ae18a773e9b7$var$bumpRadial(context) {
    return new $6e43ae18a773e9b7$var$BumpRadial(context);
}

});


parcelRegister("7M2E1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5a8f113d2527a01d$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $97HR3 = parcelRequire("97HR3");

var $5a8f113d2527a01d$var$_constant = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("40Sp7")));

var $5a8f113d2527a01d$var$_asterisk = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("kEtuQ")));

var $5a8f113d2527a01d$var$_circle = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("bNo29")));

var $5a8f113d2527a01d$var$_cross = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("7Z6Yk")));

var $5a8f113d2527a01d$var$_diamond = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("PiW8f")));

var $5a8f113d2527a01d$var$_diamond2 = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("atdAI")));

var $5a8f113d2527a01d$var$_plus = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("bjvHG")));

var $5a8f113d2527a01d$var$_square = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("d0XgR")));

var $5a8f113d2527a01d$var$_square2 = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("1I1UW")));

var $5a8f113d2527a01d$var$_star = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("46umI")));

var $5a8f113d2527a01d$var$_triangle = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("kRKEh")));

var $5a8f113d2527a01d$var$_triangle2 = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("iQe2h")));

var $5a8f113d2527a01d$var$_wye = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("g8j4V")));

var $5a8f113d2527a01d$var$_x = $5a8f113d2527a01d$var$_interopRequireDefault((parcelRequire("kt2kr")));
function $5a8f113d2527a01d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $5a8f113d2527a01d$var$symbolsFill = [
    $5a8f113d2527a01d$var$_circle.default,
    $5a8f113d2527a01d$var$_cross.default,
    $5a8f113d2527a01d$var$_diamond.default,
    $5a8f113d2527a01d$var$_square.default,
    $5a8f113d2527a01d$var$_star.default,
    $5a8f113d2527a01d$var$_triangle.default,
    $5a8f113d2527a01d$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $5a8f113d2527a01d$var$symbolsFill;
const $5a8f113d2527a01d$var$symbolsStroke = [
    $5a8f113d2527a01d$var$_circle.default,
    $5a8f113d2527a01d$var$_plus.default,
    $5a8f113d2527a01d$var$_x.default,
    $5a8f113d2527a01d$var$_triangle2.default,
    $5a8f113d2527a01d$var$_asterisk.default,
    $5a8f113d2527a01d$var$_square2.default,
    $5a8f113d2527a01d$var$_diamond2.default
];
module.exports.symbolsStroke = $5a8f113d2527a01d$var$symbolsStroke;
function $5a8f113d2527a01d$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $5a8f113d2527a01d$var$_constant.default)(type || $5a8f113d2527a01d$var$_circle.default);
    size = typeof size === "function" ? size : (0, $5a8f113d2527a01d$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $97HR3.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $5a8f113d2527a01d$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $5a8f113d2527a01d$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("kEtuQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
const $f08e6c7af1db6b66$var$sqrt3 = (0, $b9QWH.sqrt)(3);
var $f08e6c7af1db6b66$var$_default = {
    draw (context, size) {
        const r = (0, $b9QWH.sqrt)(size + (0, $b9QWH.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $f08e6c7af1db6b66$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $f08e6c7af1db6b66$var$_default;

});

parcelRegister("bNo29", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
var $8966e9eb2fdccf7c$var$_default = {
    draw (context, size) {
        const r = (0, $b9QWH.sqrt)(size / $b9QWH.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $b9QWH.tau);
    }
};
module.exports.default = $8966e9eb2fdccf7c$var$_default;

});

parcelRegister("7Z6Yk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
var $5d03a369c5edea2e$var$_default = {
    draw (context, size) {
        const r = (0, $b9QWH.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $5d03a369c5edea2e$var$_default;

});

parcelRegister("PiW8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
const $09a373f3a1ab3c88$var$tan30 = (0, $b9QWH.sqrt)(1 / 3);
const $09a373f3a1ab3c88$var$tan30_2 = $09a373f3a1ab3c88$var$tan30 * 2;
var $09a373f3a1ab3c88$var$_default = {
    draw (context, size) {
        const y = (0, $b9QWH.sqrt)(size / $09a373f3a1ab3c88$var$tan30_2);
        const x = y * $09a373f3a1ab3c88$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $09a373f3a1ab3c88$var$_default;

});

parcelRegister("atdAI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
var $79f727c49d4c292d$var$_default = {
    draw (context, size) {
        const r = (0, $b9QWH.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $79f727c49d4c292d$var$_default;

});

parcelRegister("bjvHG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
var $83ca0fbd58dd2db4$var$_default = {
    draw (context, size) {
        const r = (0, $b9QWH.sqrt)(size - (0, $b9QWH.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $83ca0fbd58dd2db4$var$_default;

});

parcelRegister("d0XgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
var $9799406767770f61$var$_default = {
    draw (context, size) {
        const w = (0, $b9QWH.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $9799406767770f61$var$_default;

});

parcelRegister("1I1UW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
var $13eb633e5a2c5238$var$_default = {
    draw (context, size) {
        const r = (0, $b9QWH.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $13eb633e5a2c5238$var$_default;

});

parcelRegister("46umI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
const $2fcf46e7abf77ea4$var$ka = 0.89081309152928522810;
const $2fcf46e7abf77ea4$var$kr = (0, $b9QWH.sin)($b9QWH.pi / 10) / (0, $b9QWH.sin)(7 * $b9QWH.pi / 10);
const $2fcf46e7abf77ea4$var$kx = (0, $b9QWH.sin)($b9QWH.tau / 10) * $2fcf46e7abf77ea4$var$kr;
const $2fcf46e7abf77ea4$var$ky = -(0, $b9QWH.cos)($b9QWH.tau / 10) * $2fcf46e7abf77ea4$var$kr;
var $2fcf46e7abf77ea4$var$_default = {
    draw (context, size) {
        const r = (0, $b9QWH.sqrt)(size * $2fcf46e7abf77ea4$var$ka);
        const x = $2fcf46e7abf77ea4$var$kx * r;
        const y = $2fcf46e7abf77ea4$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $b9QWH.tau * i / 5;
            const c = (0, $b9QWH.cos)(a);
            const s = (0, $b9QWH.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $2fcf46e7abf77ea4$var$_default;

});

parcelRegister("kRKEh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
const $f30cf15d22b1f709$var$sqrt3 = (0, $b9QWH.sqrt)(3);
var $f30cf15d22b1f709$var$_default = {
    draw (context, size) {
        const y = -(0, $b9QWH.sqrt)(size / ($f30cf15d22b1f709$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$f30cf15d22b1f709$var$sqrt3 * y, -y);
        context.lineTo($f30cf15d22b1f709$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $f30cf15d22b1f709$var$_default;

});

parcelRegister("iQe2h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
const $db77f884d42448e6$var$sqrt3 = (0, $b9QWH.sqrt)(3);
var $db77f884d42448e6$var$_default = {
    draw (context, size) {
        const s = (0, $b9QWH.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $db77f884d42448e6$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $db77f884d42448e6$var$_default;

});

parcelRegister("g8j4V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
const $bbec3146fc58c408$var$c = -0.5;
const $bbec3146fc58c408$var$s = (0, $b9QWH.sqrt)(3) / 2;
const $bbec3146fc58c408$var$k = 1 / (0, $b9QWH.sqrt)(12);
const $bbec3146fc58c408$var$a = ($bbec3146fc58c408$var$k / 2 + 1) * 3;
var $bbec3146fc58c408$var$_default = {
    draw (context, size) {
        const r = (0, $b9QWH.sqrt)(size / $bbec3146fc58c408$var$a);
        const x0 = r / 2, y0 = r * $bbec3146fc58c408$var$k;
        const x1 = x0, y1 = r * $bbec3146fc58c408$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($bbec3146fc58c408$var$c * x0 - $bbec3146fc58c408$var$s * y0, $bbec3146fc58c408$var$s * x0 + $bbec3146fc58c408$var$c * y0);
        context.lineTo($bbec3146fc58c408$var$c * x1 - $bbec3146fc58c408$var$s * y1, $bbec3146fc58c408$var$s * x1 + $bbec3146fc58c408$var$c * y1);
        context.lineTo($bbec3146fc58c408$var$c * x2 - $bbec3146fc58c408$var$s * y2, $bbec3146fc58c408$var$s * x2 + $bbec3146fc58c408$var$c * y2);
        context.lineTo($bbec3146fc58c408$var$c * x0 + $bbec3146fc58c408$var$s * y0, $bbec3146fc58c408$var$c * y0 - $bbec3146fc58c408$var$s * x0);
        context.lineTo($bbec3146fc58c408$var$c * x1 + $bbec3146fc58c408$var$s * y1, $bbec3146fc58c408$var$c * y1 - $bbec3146fc58c408$var$s * x1);
        context.lineTo($bbec3146fc58c408$var$c * x2 + $bbec3146fc58c408$var$s * y2, $bbec3146fc58c408$var$c * y2 - $bbec3146fc58c408$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $bbec3146fc58c408$var$_default;

});

parcelRegister("kt2kr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9QWH = parcelRequire("b9QWH");
var $ee6852871eb6825f$var$_default = {
    draw (context, size) {
        const r = (0, $b9QWH.sqrt)(size - (0, $b9QWH.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $ee6852871eb6825f$var$_default;

});


parcelRegister("l6ND4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5e0a7d0a5fff73b$var$_default;

var $f5e0a7d0a5fff73b$var$_noop = $f5e0a7d0a5fff73b$var$_interopRequireDefault((parcelRequire("dckC4")));

var $5BVju = parcelRequire("5BVju");
function $f5e0a7d0a5fff73b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f5e0a7d0a5fff73b$var$BasisClosed(context) {
    this._context = context;
}
$f5e0a7d0a5fff73b$var$BasisClosed.prototype = {
    areaStart: $f5e0a7d0a5fff73b$var$_noop.default,
    areaEnd: $f5e0a7d0a5fff73b$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $5BVju.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $f5e0a7d0a5fff73b$var$_default(context) {
    return new $f5e0a7d0a5fff73b$var$BasisClosed(context);
}

});
parcelRegister("dckC4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $99bc62aec9870989$var$_default;
function $99bc62aec9870989$var$_default() {}

});

parcelRegister("5BVju", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $415cddad9c5b4c75$var$Basis;
module.exports.default = $415cddad9c5b4c75$var$_default;
module.exports.point = $415cddad9c5b4c75$var$point;
function $415cddad9c5b4c75$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $415cddad9c5b4c75$var$Basis(context) {
    this._context = context;
}
$415cddad9c5b4c75$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $415cddad9c5b4c75$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $415cddad9c5b4c75$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $415cddad9c5b4c75$var$_default(context) {
    return new $415cddad9c5b4c75$var$Basis(context);
}

});


parcelRegister("9DfCK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7033e02f36045e88$var$_default;

var $5BVju = parcelRequire("5BVju");
function $7033e02f36045e88$var$BasisOpen(context) {
    this._context = context;
}
$7033e02f36045e88$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $5BVju.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $7033e02f36045e88$var$_default(context) {
    return new $7033e02f36045e88$var$BasisOpen(context);
}

});

parcelRegister("3KhMk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5BVju = parcelRequire("5BVju");
function $2ba37563c75a8d8a$var$Bundle(context, beta) {
    this._basis = new $5BVju.Basis(context);
    this._beta = beta;
}
$2ba37563c75a8d8a$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $2ba37563c75a8d8a$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $5BVju.Basis(context) : new $2ba37563c75a8d8a$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $2ba37563c75a8d8a$var$_default;

});

parcelRegister("avZBL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $7a7c96b721fb9b38$var$CardinalClosed;
module.exports.default = void 0;

var $7a7c96b721fb9b38$var$_noop = $7a7c96b721fb9b38$var$_interopRequireDefault((parcelRequire("dckC4")));

var $hoF7M = parcelRequire("hoF7M");
function $7a7c96b721fb9b38$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7a7c96b721fb9b38$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$7a7c96b721fb9b38$var$CardinalClosed.prototype = {
    areaStart: $7a7c96b721fb9b38$var$_noop.default,
    areaEnd: $7a7c96b721fb9b38$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $hoF7M.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $7a7c96b721fb9b38$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $7a7c96b721fb9b38$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $7a7c96b721fb9b38$var$_default;

});
parcelRegister("hoF7M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $caa494031d70758e$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $caa494031d70758e$var$point;
function $caa494031d70758e$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $caa494031d70758e$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$caa494031d70758e$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $caa494031d70758e$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $caa494031d70758e$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $caa494031d70758e$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $caa494031d70758e$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $caa494031d70758e$var$_default;

});


parcelRegister("kl6Lw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $eceb0447a797f523$var$CardinalOpen;
module.exports.default = void 0;

var $hoF7M = parcelRequire("hoF7M");
function $eceb0447a797f523$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$eceb0447a797f523$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $hoF7M.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $eceb0447a797f523$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $eceb0447a797f523$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $eceb0447a797f523$var$_default;

});

parcelRegister("hUIrC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $avZBL = parcelRequire("avZBL");

var $d0aa245b2d08cafa$var$_noop = $d0aa245b2d08cafa$var$_interopRequireDefault((parcelRequire("dckC4")));

var $8uCUC = parcelRequire("8uCUC");
function $d0aa245b2d08cafa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d0aa245b2d08cafa$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$d0aa245b2d08cafa$var$CatmullRomClosed.prototype = {
    areaStart: $d0aa245b2d08cafa$var$_noop.default,
    areaEnd: $d0aa245b2d08cafa$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $8uCUC.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d0aa245b2d08cafa$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $d0aa245b2d08cafa$var$CatmullRomClosed(context, alpha) : new $avZBL.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $d0aa245b2d08cafa$var$_default;

});
parcelRegister("8uCUC", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $b9QWH = parcelRequire("b9QWH");

var $hoF7M = parcelRequire("hoF7M");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $b9QWH.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $b9QWH.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $hoF7M.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("8dwwA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kl6Lw = parcelRequire("kl6Lw");

var $8uCUC = parcelRequire("8uCUC");
function $5fb8c45a06e09078$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$5fb8c45a06e09078$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $8uCUC.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $5fb8c45a06e09078$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $5fb8c45a06e09078$var$CatmullRomOpen(context, alpha) : new $kl6Lw.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $5fb8c45a06e09078$var$_default;

});

parcelRegister("eLMRy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ac0b5b9fe17f1f14$var$_default;

var $ac0b5b9fe17f1f14$var$_noop = $ac0b5b9fe17f1f14$var$_interopRequireDefault((parcelRequire("dckC4")));
function $ac0b5b9fe17f1f14$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ac0b5b9fe17f1f14$var$LinearClosed(context) {
    this._context = context;
}
$ac0b5b9fe17f1f14$var$LinearClosed.prototype = {
    areaStart: $ac0b5b9fe17f1f14$var$_noop.default,
    areaEnd: $ac0b5b9fe17f1f14$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $ac0b5b9fe17f1f14$var$_default(context) {
    return new $ac0b5b9fe17f1f14$var$LinearClosed(context);
}

});

parcelRegister("kD2j0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $f0493d029082231c$var$monotoneX;
module.exports.monotoneY = $f0493d029082231c$var$monotoneY;
function $f0493d029082231c$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $f0493d029082231c$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($f0493d029082231c$var$sign(s0) + $f0493d029082231c$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $f0493d029082231c$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $f0493d029082231c$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $f0493d029082231c$var$MonotoneX(context) {
    this._context = context;
}
$f0493d029082231c$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $f0493d029082231c$var$point(this, this._t0, $f0493d029082231c$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $f0493d029082231c$var$point(this, $f0493d029082231c$var$slope2(this, t1 = $f0493d029082231c$var$slope3(this, x, y)), t1);
                break;
            default:
                $f0493d029082231c$var$point(this, this._t0, t1 = $f0493d029082231c$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $f0493d029082231c$var$MonotoneY(context) {
    this._context = new $f0493d029082231c$var$ReflectContext(context);
}
($f0493d029082231c$var$MonotoneY.prototype = Object.create($f0493d029082231c$var$MonotoneX.prototype)).point = function(x, y) {
    $f0493d029082231c$var$MonotoneX.prototype.point.call(this, y, x);
};
function $f0493d029082231c$var$ReflectContext(context) {
    this._context = context;
}
$f0493d029082231c$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $f0493d029082231c$var$monotoneX(context) {
    return new $f0493d029082231c$var$MonotoneX(context);
}
function $f0493d029082231c$var$monotoneY(context) {
    return new $f0493d029082231c$var$MonotoneY(context);
}

});

parcelRegister("fSTbn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b906b447b3a206ed$var$_default;
function $b906b447b3a206ed$var$Natural(context) {
    this._context = context;
}
$b906b447b3a206ed$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $b906b447b3a206ed$var$controlPoints(x), py = $b906b447b3a206ed$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $b906b447b3a206ed$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $b906b447b3a206ed$var$_default(context) {
    return new $b906b447b3a206ed$var$Natural(context);
}

});

parcelRegister("2YBU3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22ae961bef9230bb$var$_default;
module.exports.stepAfter = $22ae961bef9230bb$var$stepAfter;
module.exports.stepBefore = $22ae961bef9230bb$var$stepBefore;
function $22ae961bef9230bb$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$22ae961bef9230bb$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $22ae961bef9230bb$var$_default(context) {
    return new $22ae961bef9230bb$var$Step(context, 0.5);
}
function $22ae961bef9230bb$var$stepBefore(context) {
    return new $22ae961bef9230bb$var$Step(context, 0);
}
function $22ae961bef9230bb$var$stepAfter(context) {
    return new $22ae961bef9230bb$var$Step(context, 1);
}

});

parcelRegister("4iVum", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $32256fea14bd8e17$var$_default;

var $32256fea14bd8e17$var$_array = $32256fea14bd8e17$var$_interopRequireDefault((parcelRequire("jnGbx")));

var $32256fea14bd8e17$var$_constant = $32256fea14bd8e17$var$_interopRequireDefault((parcelRequire("40Sp7")));

var $32256fea14bd8e17$var$_none = $32256fea14bd8e17$var$_interopRequireDefault((parcelRequire("9SHyD")));

var $32256fea14bd8e17$var$_none2 = $32256fea14bd8e17$var$_interopRequireDefault((parcelRequire("63kfx")));
function $32256fea14bd8e17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $32256fea14bd8e17$var$stackValue(d, key) {
    return d[key];
}
function $32256fea14bd8e17$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $32256fea14bd8e17$var$_default() {
    var keys = (0, $32256fea14bd8e17$var$_constant.default)([]), order = $32256fea14bd8e17$var$_none2.default, offset = $32256fea14bd8e17$var$_none.default, value = $32256fea14bd8e17$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $32256fea14bd8e17$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $32256fea14bd8e17$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $32256fea14bd8e17$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $32256fea14bd8e17$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $32256fea14bd8e17$var$_none2.default : typeof _ === "function" ? _ : (0, $32256fea14bd8e17$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $32256fea14bd8e17$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("9SHyD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $731af1da957502b5$var$_default;
function $731af1da957502b5$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("63kfx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4682bb109a65a1c6$var$_default;
function $4682bb109a65a1c6$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("g0sra", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba72b4728354524a$var$_default;

var $ba72b4728354524a$var$_none = $ba72b4728354524a$var$_interopRequireDefault((parcelRequire("9SHyD")));
function $ba72b4728354524a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ba72b4728354524a$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $ba72b4728354524a$var$_none.default)(series, order);
}

});

parcelRegister("lXHNO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffd115ee32277998$var$_default;
function $ffd115ee32277998$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("cidns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f318aeac458f4e5$var$_default;

var $8f318aeac458f4e5$var$_none = $8f318aeac458f4e5$var$_interopRequireDefault((parcelRequire("9SHyD")));
function $8f318aeac458f4e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8f318aeac458f4e5$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $8f318aeac458f4e5$var$_none.default)(series, order);
}

});

parcelRegister("1Sge1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15d76b942f70a0f3$var$_default;

var $15d76b942f70a0f3$var$_none = $15d76b942f70a0f3$var$_interopRequireDefault((parcelRequire("9SHyD")));
function $15d76b942f70a0f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $15d76b942f70a0f3$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $15d76b942f70a0f3$var$_none.default)(series, order);
}

});

parcelRegister("3euJK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25aa859ca7bff82c$var$_default;

var $25aa859ca7bff82c$var$_none = $25aa859ca7bff82c$var$_interopRequireDefault((parcelRequire("63kfx")));
function $25aa859ca7bff82c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $25aa859ca7bff82c$var$_default(series) {
    var peaks = series.map($25aa859ca7bff82c$var$peak);
    return (0, $25aa859ca7bff82c$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $25aa859ca7bff82c$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("k0Mqh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9195e85b99d87bc$var$_default;
module.exports.sum = $e9195e85b99d87bc$var$sum;

var $e9195e85b99d87bc$var$_none = $e9195e85b99d87bc$var$_interopRequireDefault((parcelRequire("63kfx")));
function $e9195e85b99d87bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9195e85b99d87bc$var$_default(series) {
    var sums = series.map($e9195e85b99d87bc$var$sum);
    return (0, $e9195e85b99d87bc$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $e9195e85b99d87bc$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("avBc5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7a69a68dd1d79365$var$_default;

var $7a69a68dd1d79365$var$_ascending = $7a69a68dd1d79365$var$_interopRequireDefault((parcelRequire("k0Mqh")));
function $7a69a68dd1d79365$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7a69a68dd1d79365$var$_default(series) {
    return (0, $7a69a68dd1d79365$var$_ascending.default)(series).reverse();
}

});

parcelRegister("iagvH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d395f7c76e0de182$var$_default;

var $d395f7c76e0de182$var$_appearance = $d395f7c76e0de182$var$_interopRequireDefault((parcelRequire("3euJK")));

var $k0Mqh = parcelRequire("k0Mqh");
function $d395f7c76e0de182$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d395f7c76e0de182$var$_default(series) {
    var n = series.length, i, j, sums = series.map($k0Mqh.sum), order = (0, $d395f7c76e0de182$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("5Kx7I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $42faf1437752f81a$var$_default;

var $42faf1437752f81a$var$_none = $42faf1437752f81a$var$_interopRequireDefault((parcelRequire("63kfx")));
function $42faf1437752f81a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $42faf1437752f81a$var$_default(series) {
    return (0, $42faf1437752f81a$var$_none.default)(series).reverse();
}

});



parcelRegister("7jn8y", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $552c41436b50a8fd$var$PropTypes = $552c41436b50a8fd$var$_interopRequireWildcard((parcelRequire("1lj2q")));

var $552c41436b50a8fd$var$_addClass = $552c41436b50a8fd$var$_interopRequireDefault((parcelRequire("bGiW4")));

var $552c41436b50a8fd$var$_removeClass = $552c41436b50a8fd$var$_interopRequireDefault((parcelRequire("7HvU3")));

var $552c41436b50a8fd$var$_react = $552c41436b50a8fd$var$_interopRequireDefault((parcelRequire("5pP8j")));

var $552c41436b50a8fd$var$_Transition = $552c41436b50a8fd$var$_interopRequireDefault((parcelRequire("k6WUg")));

function $552c41436b50a8fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $552c41436b50a8fd$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $552c41436b50a8fd$var$_extends() {
    $552c41436b50a8fd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $552c41436b50a8fd$var$_extends.apply(this, arguments);
}
function $552c41436b50a8fd$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $552c41436b50a8fd$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $552c41436b50a8fd$var$_addClass.default)(node, c);
    });
};
var $552c41436b50a8fd$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $552c41436b50a8fd$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $552c41436b50a8fd$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $552c41436b50a8fd$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'), className = _this$getClassNames.className;
            _this.removeClasses(node, 'exit');
            $552c41436b50a8fd$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames('appear').doneClassName;
            var enterClassName = _this.getClassNames('enter').doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? 'appear' : 'enter');
            $552c41436b50a8fd$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames('exit'), className = _this$getClassNames3.className;
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            $552c41436b50a8fd$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames('exit'), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames('exit'), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, 'exit');
            $552c41436b50a8fd$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + '-' : '';
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
            var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $552c41436b50a8fd$var$removeClass(node, className);
        activeClassName && $552c41436b50a8fd$var$removeClass(node, activeClassName);
        doneClassName && $552c41436b50a8fd$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $552c41436b50a8fd$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $552c41436b50a8fd$var$_extends({}, this.props);
        delete props.classNames;
        return $552c41436b50a8fd$var$_react.default.createElement($552c41436b50a8fd$var$_Transition.default, $552c41436b50a8fd$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($552c41436b50a8fd$var$_react.default.Component);
$552c41436b50a8fd$var$CSSTransition.defaultProps = {
    classNames: ''
};
$552c41436b50a8fd$var$CSSTransition.propTypes = {};
var $552c41436b50a8fd$var$_default = $552c41436b50a8fd$var$CSSTransition;
module.exports.default = $552c41436b50a8fd$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("bGiW4", function(module, exports) {
"use strict";

var $eYEhQ = parcelRequire("eYEhQ");
module.exports.__esModule = true;
module.exports.default = $88124e29164c5dbe$var$addClass;

var $88124e29164c5dbe$var$_hasClass = $eYEhQ((parcelRequire("8dQPP")));
function $88124e29164c5dbe$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $88124e29164c5dbe$var$_hasClass.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + ' ' + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
    }
}
module.exports = module.exports["default"];

});
parcelRegister("eYEhQ", function(module, exports) {
function $ae75eb66a8994883$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $ae75eb66a8994883$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8dQPP", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $5fc8858b0462d28d$var$hasClass;
function $5fc8858b0462d28d$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRegister("7HvU3", function(module, exports) {
'use strict';
function $59b54bd2aa8dda51$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $59b54bd2aa8dda51$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $59b54bd2aa8dda51$var$replaceClassName(element.className && element.className.baseVal || '', className));
};

});

parcelRegister("k6WUg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $ea420fc68b32f161$export$1e511d4a378977f5; }, function (v) { return $ea420fc68b32f161$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $ea420fc68b32f161$export$2e2bcd8739ae039; }, function (v) { return $ea420fc68b32f161$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "EXITING", function () { return $ea420fc68b32f161$export$4aacc83d4d59139f; }, function (v) { return $ea420fc68b32f161$export$4aacc83d4d59139f = v; });
$parcel$export(module.exports, "ENTERED", function () { return $ea420fc68b32f161$export$78e9e6e3e014d60a; }, function (v) { return $ea420fc68b32f161$export$78e9e6e3e014d60a = v; });
$parcel$export(module.exports, "ENTERING", function () { return $ea420fc68b32f161$export$df38205c966be359; }, function (v) { return $ea420fc68b32f161$export$df38205c966be359 = v; });
$parcel$export(module.exports, "EXITED", function () { return $ea420fc68b32f161$export$84cbff306f539230; }, function (v) { return $ea420fc68b32f161$export$84cbff306f539230 = v; });
$parcel$export(module.exports, "UNMOUNTED", function () { return $ea420fc68b32f161$export$bb38bb9a1161268; }, function (v) { return $ea420fc68b32f161$export$bb38bb9a1161268 = v; });
var $ea420fc68b32f161$export$1e511d4a378977f5;
var $ea420fc68b32f161$export$2e2bcd8739ae039;
var $ea420fc68b32f161$export$4aacc83d4d59139f;
var $ea420fc68b32f161$export$78e9e6e3e014d60a;
var $ea420fc68b32f161$export$df38205c966be359;
var $ea420fc68b32f161$export$84cbff306f539230;
var $ea420fc68b32f161$export$bb38bb9a1161268;
"use strict";
$ea420fc68b32f161$export$1e511d4a378977f5 = true;
$ea420fc68b32f161$export$2e2bcd8739ae039 = $ea420fc68b32f161$export$4aacc83d4d59139f = $ea420fc68b32f161$export$78e9e6e3e014d60a = $ea420fc68b32f161$export$df38205c966be359 = $ea420fc68b32f161$export$84cbff306f539230 = $ea420fc68b32f161$export$bb38bb9a1161268 = void 0;

var $ea420fc68b32f161$var$PropTypes = $ea420fc68b32f161$var$_interopRequireWildcard((parcelRequire("1lj2q")));

var $ea420fc68b32f161$var$_react = $ea420fc68b32f161$var$_interopRequireDefault((parcelRequire("5pP8j")));

var $ea420fc68b32f161$var$_reactDom = $ea420fc68b32f161$var$_interopRequireDefault((parcelRequire("bzs0j")));

var $e7bed = parcelRequire("e7bed");

function $ea420fc68b32f161$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ea420fc68b32f161$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $ea420fc68b32f161$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ea420fc68b32f161$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $ea420fc68b32f161$var$UNMOUNTED = 'unmounted';
$ea420fc68b32f161$export$bb38bb9a1161268 = $ea420fc68b32f161$var$UNMOUNTED;
var $ea420fc68b32f161$var$EXITED = 'exited';
$ea420fc68b32f161$export$84cbff306f539230 = $ea420fc68b32f161$var$EXITED;
var $ea420fc68b32f161$var$ENTERING = 'entering';
$ea420fc68b32f161$export$df38205c966be359 = $ea420fc68b32f161$var$ENTERING;
var $ea420fc68b32f161$var$ENTERED = 'entered';
$ea420fc68b32f161$export$78e9e6e3e014d60a = $ea420fc68b32f161$var$ENTERED;
var $ea420fc68b32f161$var$EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $ea420fc68b32f161$export$4aacc83d4d59139f = $ea420fc68b32f161$var$EXITING;
var $ea420fc68b32f161$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $ea420fc68b32f161$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $ea420fc68b32f161$var$EXITED;
                _this.appearStatus = $ea420fc68b32f161$var$ENTERING;
            } else initialStatus = $ea420fc68b32f161$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $ea420fc68b32f161$var$UNMOUNTED;
        else initialStatus = $ea420fc68b32f161$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $ea420fc68b32f161$var$UNMOUNTED) return {
            status: $ea420fc68b32f161$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $ea420fc68b32f161$var$ENTERING && status !== $ea420fc68b32f161$var$ENTERED) nextStatus = $ea420fc68b32f161$var$ENTERING;
            } else if (status === $ea420fc68b32f161$var$ENTERING || status === $ea420fc68b32f161$var$ENTERED) nextStatus = $ea420fc68b32f161$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $ea420fc68b32f161$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $ea420fc68b32f161$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $ea420fc68b32f161$var$EXITED) this.setState({
            status: $ea420fc68b32f161$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $ea420fc68b32f161$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $ea420fc68b32f161$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $ea420fc68b32f161$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $ea420fc68b32f161$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $ea420fc68b32f161$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $ea420fc68b32f161$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $ea420fc68b32f161$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $ea420fc68b32f161$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') return children(status, childProps);
        var child = $ea420fc68b32f161$var$_react.default.Children.only(children);
        return $ea420fc68b32f161$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($ea420fc68b32f161$var$_react.default.Component);
$ea420fc68b32f161$var$Transition.contextTypes = {
    transitionGroup: $ea420fc68b32f161$var$PropTypes.object
};
$ea420fc68b32f161$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$ea420fc68b32f161$var$Transition.propTypes = {};
function $ea420fc68b32f161$var$noop() {}
$ea420fc68b32f161$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $ea420fc68b32f161$var$noop,
    onEntering: $ea420fc68b32f161$var$noop,
    onEntered: $ea420fc68b32f161$var$noop,
    onExit: $ea420fc68b32f161$var$noop,
    onExiting: $ea420fc68b32f161$var$noop,
    onExited: $ea420fc68b32f161$var$noop
};
$ea420fc68b32f161$var$Transition.UNMOUNTED = 0;
$ea420fc68b32f161$var$Transition.EXITED = 1;
$ea420fc68b32f161$var$Transition.ENTERING = 2;
$ea420fc68b32f161$var$Transition.ENTERED = 3;
$ea420fc68b32f161$var$Transition.EXITING = 4;
var $ea420fc68b32f161$var$_default = (0, $e7bed.polyfill)($ea420fc68b32f161$var$Transition);
$ea420fc68b32f161$export$2e2bcd8739ae039 = $ea420fc68b32f161$var$_default;

});
parcelRegister("e7bed", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $a46a6dd3039eedc3$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $a46a6dd3039eedc3$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $a46a6dd3039eedc3$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $a46a6dd3039eedc3$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$a46a6dd3039eedc3$var$componentWillMount.__suppressDeprecationWarning = true;
$a46a6dd3039eedc3$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$a46a6dd3039eedc3$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $a46a6dd3039eedc3$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $a46a6dd3039eedc3$var$componentWillMount;
        prototype.componentWillReceiveProps = $a46a6dd3039eedc3$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $a46a6dd3039eedc3$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("jiiJH", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $e0be3b5d5048b830$var$_propTypes = $e0be3b5d5048b830$var$_interopRequireDefault((parcelRequire("1lj2q")));

var $e0be3b5d5048b830$var$_react = $e0be3b5d5048b830$var$_interopRequireDefault((parcelRequire("5pP8j")));

var $bzs0j = parcelRequire("bzs0j");

var $e0be3b5d5048b830$var$_TransitionGroup = $e0be3b5d5048b830$var$_interopRequireDefault((parcelRequire("kH8E2")));
function $e0be3b5d5048b830$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e0be3b5d5048b830$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e0be3b5d5048b830$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $e0be3b5d5048b830$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $e0be3b5d5048b830$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle('onEnter', 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle('onEntering', 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle('onEntered', 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle('onExit', 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle('onExiting', 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle('onExited', 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $e0be3b5d5048b830$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $bzs0j.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $e0be3b5d5048b830$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $e0be3b5d5048b830$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $e0be3b5d5048b830$var$_react.default.createElement($e0be3b5d5048b830$var$_TransitionGroup.default, props, inProp ? $e0be3b5d5048b830$var$_react.default.cloneElement(first, {
            key: 'first',
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $e0be3b5d5048b830$var$_react.default.cloneElement(second, {
            key: 'second',
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($e0be3b5d5048b830$var$_react.default.Component);
$e0be3b5d5048b830$var$ReplaceTransition.propTypes = {};
var $e0be3b5d5048b830$var$_default = $e0be3b5d5048b830$var$ReplaceTransition;
module.exports.default = $e0be3b5d5048b830$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("kH8E2", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $f10e877601d0c743$var$_propTypes = $f10e877601d0c743$var$_interopRequireDefault((parcelRequire("1lj2q")));

var $f10e877601d0c743$var$_react = $f10e877601d0c743$var$_interopRequireDefault((parcelRequire("5pP8j")));

var $e7bed = parcelRequire("e7bed");

var $90b2G = parcelRequire("90b2G");
function $f10e877601d0c743$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f10e877601d0c743$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f10e877601d0c743$var$_extends() {
    $f10e877601d0c743$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f10e877601d0c743$var$_extends.apply(this, arguments);
}
function $f10e877601d0c743$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $f10e877601d0c743$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $f10e877601d0c743$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $f10e877601d0c743$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
var $f10e877601d0c743$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $f10e877601d0c743$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($f10e877601d0c743$var$_assertThisInitialized($f10e877601d0c743$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $90b2G.getInitialChildMapping)(nextProps, handleExited) : (0, $90b2G.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $90b2G.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $f10e877601d0c743$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $f10e877601d0c743$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $f10e877601d0c743$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $f10e877601d0c743$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($f10e877601d0c743$var$_react.default.Component);
$f10e877601d0c743$var$TransitionGroup.childContextTypes = {
    transitionGroup: $f10e877601d0c743$var$_propTypes.default.object.isRequired
};
$f10e877601d0c743$var$TransitionGroup.propTypes = {};
$f10e877601d0c743$var$TransitionGroup.defaultProps = $f10e877601d0c743$var$defaultProps;
var $f10e877601d0c743$var$_default = (0, $e7bed.polyfill)($f10e877601d0c743$var$TransitionGroup);
module.exports.default = $f10e877601d0c743$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("90b2G", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $68dcade7cbf492dc$export$bbc8a025727ea824; }, function (v) { return $68dcade7cbf492dc$export$bbc8a025727ea824 = v; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $68dcade7cbf492dc$export$fa71e2345c31d7a2; }, function (v) { return $68dcade7cbf492dc$export$fa71e2345c31d7a2 = v; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $68dcade7cbf492dc$export$36fd1af28d383ec0; }, function (v) { return $68dcade7cbf492dc$export$36fd1af28d383ec0 = v; });
var $68dcade7cbf492dc$export$1e511d4a378977f5;
var $68dcade7cbf492dc$export$bbc8a025727ea824;
var $68dcade7cbf492dc$export$7a874f95ccf533dd;
var $68dcade7cbf492dc$export$fa71e2345c31d7a2;
var $68dcade7cbf492dc$export$36fd1af28d383ec0;
"use strict";
$68dcade7cbf492dc$export$1e511d4a378977f5 = true;
$68dcade7cbf492dc$export$bbc8a025727ea824 = $68dcade7cbf492dc$var$getChildMapping;
$68dcade7cbf492dc$export$7a874f95ccf533dd = $68dcade7cbf492dc$var$mergeChildMappings;
$68dcade7cbf492dc$export$fa71e2345c31d7a2 = $68dcade7cbf492dc$var$getInitialChildMapping;
$68dcade7cbf492dc$export$36fd1af28d383ec0 = $68dcade7cbf492dc$var$getNextChildMapping;

var $5pP8j = parcelRequire("5pP8j");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $68dcade7cbf492dc$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $5pP8j.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $5pP8j.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $68dcade7cbf492dc$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $68dcade7cbf492dc$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $68dcade7cbf492dc$var$getInitialChildMapping(props, onExited) {
    return $68dcade7cbf492dc$var$getChildMapping(props.children, function(child) {
        return (0, $5pP8j.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $68dcade7cbf492dc$var$getProp(child, 'appear', props),
            enter: $68dcade7cbf492dc$var$getProp(child, 'enter', props),
            exit: $68dcade7cbf492dc$var$getProp(child, 'exit', props)
        });
    });
}
function $68dcade7cbf492dc$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $68dcade7cbf492dc$var$getChildMapping(nextProps.children);
    var children = $68dcade7cbf492dc$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $5pP8j.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $5pP8j.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $5pP8j.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $68dcade7cbf492dc$var$getProp(child, 'exit', nextProps),
            enter: $68dcade7cbf492dc$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $5pP8j.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $5pP8j.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $5pP8j.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $68dcade7cbf492dc$var$getProp(child, 'exit', nextProps),
            enter: $68dcade7cbf492dc$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});



parcelRegister("fKc9g", function(module, exports) {
var $b7649355fffc7068$var$minus = "-".charCodeAt(0);
var $b7649355fffc7068$var$plus = "+".charCodeAt(0);
var $b7649355fffc7068$var$dot = ".".charCodeAt(0);
var $b7649355fffc7068$var$exp = "e".charCodeAt(0);
var $b7649355fffc7068$var$EXP = "E".charCodeAt(0);
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var dotted = false;
    var sciPos = -1;
    var containsNumber = false;
    var code;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code >= 48 && code <= 57) containsNumber = true;
        else if (code === $b7649355fffc7068$var$exp || code === $b7649355fffc7068$var$EXP) {
            if (sciPos > -1) break;
            sciPos = pos;
        } else if (code === $b7649355fffc7068$var$dot) {
            if (dotted) break;
            dotted = true;
        } else if (code === $b7649355fffc7068$var$plus || code === $b7649355fffc7068$var$minus) {
            if (pos !== 0) break;
        } else break;
        pos += 1;
    }
    if (sciPos + 1 === pos) pos--;
    return containsNumber ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    } : false;
};

});

parcelRegister("fREfv", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("3P8S4"));

});
parcelRegister("3P8S4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $2c8d0424fae4152c$var$_tickFormat.default;
    }
});

var $2c8d0424fae4152c$var$_band = $2c8d0424fae4152c$var$_interopRequireWildcard((parcelRequire("7Frvu")));

var $2c8d0424fae4152c$var$_identity = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("7R0k2")));

var $2c8d0424fae4152c$var$_linear = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("6sFEr")));

var $2c8d0424fae4152c$var$_log = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("2OQ0i")));

var $2c8d0424fae4152c$var$_symlog = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("hd7e5")));

var $2c8d0424fae4152c$var$_ordinal = $2c8d0424fae4152c$var$_interopRequireWildcard((parcelRequire("157Hw")));

var $2c8d0424fae4152c$var$_pow = $2c8d0424fae4152c$var$_interopRequireWildcard((parcelRequire("kc2iA")));

var $2c8d0424fae4152c$var$_radial = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("hoOp3")));

var $2c8d0424fae4152c$var$_quantile = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("e5wNt")));

var $2c8d0424fae4152c$var$_quantize = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("lPC0x")));

var $2c8d0424fae4152c$var$_threshold = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("5fycC")));

var $2c8d0424fae4152c$var$_time = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("3MAjg")));

var $2c8d0424fae4152c$var$_utcTime = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("lmWOB")));

var $2c8d0424fae4152c$var$_sequential = $2c8d0424fae4152c$var$_interopRequireWildcard((parcelRequire("aVvrY")));

var $2c8d0424fae4152c$var$_sequentialQuantile = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("9TgbP")));

var $2c8d0424fae4152c$var$_diverging = $2c8d0424fae4152c$var$_interopRequireWildcard((parcelRequire("8SElv")));

var $2c8d0424fae4152c$var$_tickFormat = $2c8d0424fae4152c$var$_interopRequireDefault((parcelRequire("dwtsH")));
function $2c8d0424fae4152c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2c8d0424fae4152c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2c8d0424fae4152c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2c8d0424fae4152c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2c8d0424fae4152c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("7Frvu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5951b30b0c181a1d$var$band;
module.exports.point = $5951b30b0c181a1d$var$point;

var $chaAX = parcelRequire("chaAX");

var $1UgJT = parcelRequire("1UgJT");

var $5951b30b0c181a1d$var$_ordinal = $5951b30b0c181a1d$var$_interopRequireDefault((parcelRequire("157Hw")));
function $5951b30b0c181a1d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5951b30b0c181a1d$var$band() {
    var scale = (0, $5951b30b0c181a1d$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $chaAX.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $5951b30b0c181a1d$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $1UgJT.initRange.apply(rescale(), arguments);
}
function $5951b30b0c181a1d$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $5951b30b0c181a1d$var$pointish(copy());
    };
    return scale;
}
function $5951b30b0c181a1d$var$point() {
    return $5951b30b0c181a1d$var$pointish($5951b30b0c181a1d$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("chaAX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $8nctN.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $cByLA.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $cByLA.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $8nctN.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $8nctN.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $8eff4a847187b0d4$var$_zip.default;
    }
});

var $8eff4a847187b0d4$var$_bisect = $8eff4a847187b0d4$var$_interopRequireWildcard((parcelRequire("9wNsg")));

var $8eff4a847187b0d4$var$_ascending = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("281sk")));

var $8eff4a847187b0d4$var$_bisector = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("4Q8PG")));

var $8eff4a847187b0d4$var$_count = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("kYkMf")));

var $8eff4a847187b0d4$var$_cross = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("8PshD")));

var $8eff4a847187b0d4$var$_cumsum = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("4YwUm")));

var $8eff4a847187b0d4$var$_descending = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("3BBZc")));

var $8eff4a847187b0d4$var$_deviation = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("dQBw8")));

var $8eff4a847187b0d4$var$_extent = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("kuTNr")));

var $8nctN = parcelRequire("8nctN");

var $8eff4a847187b0d4$var$_group = $8eff4a847187b0d4$var$_interopRequireWildcard((parcelRequire("4gMDs")));

var $8eff4a847187b0d4$var$_groupSort = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("5Kh1u")));

var $8eff4a847187b0d4$var$_bin = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("eBRKL")));

var $8eff4a847187b0d4$var$_freedmanDiaconis = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("aEwAP")));

var $8eff4a847187b0d4$var$_scott = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("hm5YC")));

var $8eff4a847187b0d4$var$_sturges = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("bQBky")));

var $8eff4a847187b0d4$var$_max = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("e8x5V")));

var $8eff4a847187b0d4$var$_maxIndex = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("e2ntk")));

var $8eff4a847187b0d4$var$_mean = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("dxaxT")));

var $8eff4a847187b0d4$var$_median = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("5bOIG")));

var $8eff4a847187b0d4$var$_merge = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("hJKrm")));

var $8eff4a847187b0d4$var$_min = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("42m8P")));

var $8eff4a847187b0d4$var$_minIndex = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("3KVNh")));

var $8eff4a847187b0d4$var$_mode = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("hASx3")));

var $8eff4a847187b0d4$var$_nice = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("2bxeU")));

var $8eff4a847187b0d4$var$_pairs = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("eVHL7")));

var $8eff4a847187b0d4$var$_permute = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("3dXjY")));

var $8eff4a847187b0d4$var$_quantile = $8eff4a847187b0d4$var$_interopRequireWildcard((parcelRequire("gjroM")));

var $8eff4a847187b0d4$var$_quickselect = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("kaae3")));

var $8eff4a847187b0d4$var$_range = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("jyr25")));

var $8eff4a847187b0d4$var$_rank = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("ksEFt")));

var $8eff4a847187b0d4$var$_least = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("lXfCD")));

var $8eff4a847187b0d4$var$_leastIndex = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("kwPQO")));

var $8eff4a847187b0d4$var$_greatest = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("GO3gn")));

var $8eff4a847187b0d4$var$_greatestIndex = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("53KjN")));

var $8eff4a847187b0d4$var$_scan = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("gShNl")));

var $8eff4a847187b0d4$var$_shuffle = $8eff4a847187b0d4$var$_interopRequireWildcard((parcelRequire("2FJp6")));

var $8eff4a847187b0d4$var$_sum = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("fqtmA")));

var $8eff4a847187b0d4$var$_ticks = $8eff4a847187b0d4$var$_interopRequireWildcard((parcelRequire("8iLpk")));

var $8eff4a847187b0d4$var$_transpose = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("9cWjo")));

var $8eff4a847187b0d4$var$_variance = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("gP9JI")));

var $8eff4a847187b0d4$var$_zip = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("55YXP")));

var $8eff4a847187b0d4$var$_every = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("7pCvo")));

var $8eff4a847187b0d4$var$_some = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("4V1Ps")));

var $8eff4a847187b0d4$var$_filter = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("RaMNY")));

var $8eff4a847187b0d4$var$_map = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("kclwu")));

var $8eff4a847187b0d4$var$_reduce = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("6W6lV")));

var $8eff4a847187b0d4$var$_reverse = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("geHt0")));

var $8eff4a847187b0d4$var$_sort = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("brfkE")));

var $8eff4a847187b0d4$var$_difference = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("jzwUG")));

var $8eff4a847187b0d4$var$_disjoint = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("1Ia1T")));

var $8eff4a847187b0d4$var$_intersection = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("6O8gh")));

var $8eff4a847187b0d4$var$_subset = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("7vEbB")));

var $8eff4a847187b0d4$var$_superset = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("2uhDJ")));

var $8eff4a847187b0d4$var$_union = $8eff4a847187b0d4$var$_interopRequireDefault((parcelRequire("1jtDr")));

var $cByLA = parcelRequire("cByLA");
function $8eff4a847187b0d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8eff4a847187b0d4$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8eff4a847187b0d4$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8eff4a847187b0d4$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8eff4a847187b0d4$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("9wNsg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $6efd76e5a9e902aa$var$_ascending = $6efd76e5a9e902aa$var$_interopRequireDefault((parcelRequire("281sk")));

var $6efd76e5a9e902aa$var$_bisector = $6efd76e5a9e902aa$var$_interopRequireDefault((parcelRequire("4Q8PG")));

var $6efd76e5a9e902aa$var$_number = $6efd76e5a9e902aa$var$_interopRequireDefault((parcelRequire("932Ct")));
function $6efd76e5a9e902aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6efd76e5a9e902aa$var$ascendingBisect = (0, $6efd76e5a9e902aa$var$_bisector.default)($6efd76e5a9e902aa$var$_ascending.default);
const $6efd76e5a9e902aa$var$bisectRight = $6efd76e5a9e902aa$var$ascendingBisect.right;
module.exports.bisectRight = $6efd76e5a9e902aa$var$bisectRight;
const $6efd76e5a9e902aa$var$bisectLeft = $6efd76e5a9e902aa$var$ascendingBisect.left;
module.exports.bisectLeft = $6efd76e5a9e902aa$var$bisectLeft;
const $6efd76e5a9e902aa$var$bisectCenter = (0, $6efd76e5a9e902aa$var$_bisector.default)($6efd76e5a9e902aa$var$_number.default).center;
module.exports.bisectCenter = $6efd76e5a9e902aa$var$bisectCenter;
var $6efd76e5a9e902aa$var$_default = $6efd76e5a9e902aa$var$bisectRight;
module.exports.default = $6efd76e5a9e902aa$var$_default;

});
parcelRegister("281sk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18cd7539497893d4$var$ascending;
function $18cd7539497893d4$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("4Q8PG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3862deb62fc45281$var$bisector;

var $3862deb62fc45281$var$_ascending = $3862deb62fc45281$var$_interopRequireDefault((parcelRequire("281sk")));

var $3862deb62fc45281$var$_descending = $3862deb62fc45281$var$_interopRequireDefault((parcelRequire("3BBZc")));
function $3862deb62fc45281$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3862deb62fc45281$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $3862deb62fc45281$var$_ascending.default;
        compare2 = (d, x)=>(0, $3862deb62fc45281$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $3862deb62fc45281$var$_ascending.default || f === $3862deb62fc45281$var$_descending.default ? f : $3862deb62fc45281$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $3862deb62fc45281$var$zero() {
    return 0;
}

});
parcelRegister("3BBZc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a024b0ecbaa8bd8$var$descending;
function $2a024b0ecbaa8bd8$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("932Ct", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $69666d115490e532$var$number;
module.exports.numbers = $69666d115490e532$var$numbers;
function $69666d115490e532$var$number(x) {
    return x === null ? NaN : +x;
}
function* $69666d115490e532$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("kYkMf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f449872c190f6c34$var$count;
function $f449872c190f6c34$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("8PshD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $66d906a7604071c0$var$cross;
function $66d906a7604071c0$var$length(array) {
    return array.length | 0;
}
function $66d906a7604071c0$var$empty(length) {
    return !(length > 0);
}
function $66d906a7604071c0$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $66d906a7604071c0$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $66d906a7604071c0$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $66d906a7604071c0$var$reducer(values.pop());
    values = values.map($66d906a7604071c0$var$arrayify);
    const lengths = values.map($66d906a7604071c0$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($66d906a7604071c0$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("4YwUm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $39f64ae5423fe151$var$cumsum;
function $39f64ae5423fe151$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("dQBw8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a14d3bda88832593$var$deviation;

var $a14d3bda88832593$var$_variance = $a14d3bda88832593$var$_interopRequireDefault((parcelRequire("gP9JI")));
function $a14d3bda88832593$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a14d3bda88832593$var$deviation(values, valueof) {
    const v = (0, $a14d3bda88832593$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("gP9JI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c3f8f633441994fb$var$variance;
function $c3f8f633441994fb$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("kuTNr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eec1e4031ed76168$var$extent;
function $eec1e4031ed76168$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("8nctN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $618a26e0a1a77a08$var$fcumsum;
module.exports.fsum = $618a26e0a1a77a08$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $618a26e0a1a77a08$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $618a26e0a1a77a08$var$Adder;
function $618a26e0a1a77a08$var$fsum(values, valueof) {
    const adder = new $618a26e0a1a77a08$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $618a26e0a1a77a08$var$fcumsum(values, valueof) {
    const adder = new $618a26e0a1a77a08$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("4gMDs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31be6207f62f6d9d$var$group;
module.exports.flatGroup = $31be6207f62f6d9d$var$flatGroup;
module.exports.flatRollup = $31be6207f62f6d9d$var$flatRollup;
module.exports.groups = $31be6207f62f6d9d$var$groups;
module.exports.index = $31be6207f62f6d9d$var$index;
module.exports.indexes = $31be6207f62f6d9d$var$indexes;
module.exports.rollup = $31be6207f62f6d9d$var$rollup;
module.exports.rollups = $31be6207f62f6d9d$var$rollups;

var $cByLA = parcelRequire("cByLA");

var $31be6207f62f6d9d$var$_identity = $31be6207f62f6d9d$var$_interopRequireDefault((parcelRequire("itMJU")));
function $31be6207f62f6d9d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $31be6207f62f6d9d$var$group(values, ...keys) {
    return $31be6207f62f6d9d$var$nest(values, $31be6207f62f6d9d$var$_identity.default, $31be6207f62f6d9d$var$_identity.default, keys);
}
function $31be6207f62f6d9d$var$groups(values, ...keys) {
    return $31be6207f62f6d9d$var$nest(values, Array.from, $31be6207f62f6d9d$var$_identity.default, keys);
}
function $31be6207f62f6d9d$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $31be6207f62f6d9d$var$flatGroup(values, ...keys) {
    return $31be6207f62f6d9d$var$flatten($31be6207f62f6d9d$var$groups(values, ...keys), keys);
}
function $31be6207f62f6d9d$var$flatRollup(values, reduce, ...keys) {
    return $31be6207f62f6d9d$var$flatten($31be6207f62f6d9d$var$rollups(values, reduce, ...keys), keys);
}
function $31be6207f62f6d9d$var$rollup(values, reduce, ...keys) {
    return $31be6207f62f6d9d$var$nest(values, $31be6207f62f6d9d$var$_identity.default, reduce, keys);
}
function $31be6207f62f6d9d$var$rollups(values, reduce, ...keys) {
    return $31be6207f62f6d9d$var$nest(values, Array.from, reduce, keys);
}
function $31be6207f62f6d9d$var$index(values, ...keys) {
    return $31be6207f62f6d9d$var$nest(values, $31be6207f62f6d9d$var$_identity.default, $31be6207f62f6d9d$var$unique, keys);
}
function $31be6207f62f6d9d$var$indexes(values, ...keys) {
    return $31be6207f62f6d9d$var$nest(values, Array.from, $31be6207f62f6d9d$var$unique, keys);
}
function $31be6207f62f6d9d$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $31be6207f62f6d9d$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $cByLA.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("cByLA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $92d3e8a205102d6d$var$InternMap extends Map {
    constructor(entries, key = $92d3e8a205102d6d$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($92d3e8a205102d6d$var$intern_get(this, key));
    }
    has(key) {
        return super.has($92d3e8a205102d6d$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($92d3e8a205102d6d$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($92d3e8a205102d6d$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $92d3e8a205102d6d$var$InternMap;
class $92d3e8a205102d6d$var$InternSet extends Set {
    constructor(values, key = $92d3e8a205102d6d$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($92d3e8a205102d6d$var$intern_get(this, value));
    }
    add(value) {
        return super.add($92d3e8a205102d6d$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($92d3e8a205102d6d$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $92d3e8a205102d6d$var$InternSet;
function $92d3e8a205102d6d$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $92d3e8a205102d6d$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $92d3e8a205102d6d$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $92d3e8a205102d6d$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("itMJU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d740be163d6c6adb$var$identity;
function $d740be163d6c6adb$var$identity(x) {
    return x;
}

});


parcelRegister("5Kh1u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $42ee74087f737a69$var$groupSort;

var $42ee74087f737a69$var$_ascending = $42ee74087f737a69$var$_interopRequireDefault((parcelRequire("281sk")));

var $42ee74087f737a69$var$_group = $42ee74087f737a69$var$_interopRequireWildcard((parcelRequire("4gMDs")));

var $42ee74087f737a69$var$_sort = $42ee74087f737a69$var$_interopRequireDefault((parcelRequire("brfkE")));
function $42ee74087f737a69$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($42ee74087f737a69$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $42ee74087f737a69$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $42ee74087f737a69$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $42ee74087f737a69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $42ee74087f737a69$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $42ee74087f737a69$var$_sort.default)((0, $42ee74087f737a69$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $42ee74087f737a69$var$_ascending.default)(av, bv) || (0, $42ee74087f737a69$var$_ascending.default)(ak, bk)) : (0, $42ee74087f737a69$var$_sort.default)((0, $42ee74087f737a69$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $42ee74087f737a69$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("brfkE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $853e1bf22abc314d$var$ascendingDefined;
module.exports.compareDefined = $853e1bf22abc314d$var$compareDefined;
module.exports.default = $853e1bf22abc314d$var$sort;

var $853e1bf22abc314d$var$_ascending = $853e1bf22abc314d$var$_interopRequireDefault((parcelRequire("281sk")));

var $853e1bf22abc314d$var$_permute = $853e1bf22abc314d$var$_interopRequireDefault((parcelRequire("3dXjY")));
function $853e1bf22abc314d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $853e1bf22abc314d$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $853e1bf22abc314d$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$853e1bf22abc314d$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $853e1bf22abc314d$var$_permute.default)(values, index);
    }
    return values.sort($853e1bf22abc314d$var$compareDefined(f));
}
function $853e1bf22abc314d$var$compareDefined(compare = $853e1bf22abc314d$var$_ascending.default) {
    if (compare === $853e1bf22abc314d$var$_ascending.default) return $853e1bf22abc314d$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $853e1bf22abc314d$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("3dXjY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $259099ed10ab5b82$var$permute;
function $259099ed10ab5b82$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("eBRKL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aa2e37a5d962e02b$var$bin;

var $8gtLd = parcelRequire("8gtLd");

var $aa2e37a5d962e02b$var$_bisect = $aa2e37a5d962e02b$var$_interopRequireDefault((parcelRequire("9wNsg")));

var $aa2e37a5d962e02b$var$_constant = $aa2e37a5d962e02b$var$_interopRequireDefault((parcelRequire("jJosw")));

var $aa2e37a5d962e02b$var$_extent = $aa2e37a5d962e02b$var$_interopRequireDefault((parcelRequire("kuTNr")));

var $aa2e37a5d962e02b$var$_identity = $aa2e37a5d962e02b$var$_interopRequireDefault((parcelRequire("itMJU")));

var $aa2e37a5d962e02b$var$_nice = $aa2e37a5d962e02b$var$_interopRequireDefault((parcelRequire("2bxeU")));

var $aa2e37a5d962e02b$var$_ticks = $aa2e37a5d962e02b$var$_interopRequireWildcard((parcelRequire("8iLpk")));

var $aa2e37a5d962e02b$var$_sturges = $aa2e37a5d962e02b$var$_interopRequireDefault((parcelRequire("bQBky")));
function $aa2e37a5d962e02b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($aa2e37a5d962e02b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $aa2e37a5d962e02b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $aa2e37a5d962e02b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $aa2e37a5d962e02b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aa2e37a5d962e02b$var$bin() {
    var value = $aa2e37a5d962e02b$var$_identity.default, domain = $aa2e37a5d962e02b$var$_extent.default, threshold = $aa2e37a5d962e02b$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $aa2e37a5d962e02b$var$_extent.default) [x0, x1] = (0, $aa2e37a5d962e02b$var$_nice.default)(x0, x1, tn);
            tz = (0, $aa2e37a5d962e02b$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $aa2e37a5d962e02b$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $aa2e37a5d962e02b$var$_extent.default) {
                    const step = (0, $aa2e37a5d962e02b$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $aa2e37a5d962e02b$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $aa2e37a5d962e02b$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $aa2e37a5d962e02b$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $aa2e37a5d962e02b$var$_constant.default)($8gtLd.slice.call(_)) : (0, $aa2e37a5d962e02b$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("8gtLd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $6046e73378f21001$var$array = Array.prototype;
var $6046e73378f21001$var$slice = $6046e73378f21001$var$array.slice;
module.exports.slice = $6046e73378f21001$var$slice;
var $6046e73378f21001$var$map = $6046e73378f21001$var$array.map;
module.exports.map = $6046e73378f21001$var$map;

});

parcelRegister("jJosw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e5d531584371836d$var$constant;
function $e5d531584371836d$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("2bxeU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19766488314a6b46$var$nice;

var $8iLpk = parcelRequire("8iLpk");
function $19766488314a6b46$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $8iLpk.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("8iLpk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60b4c753b0ba83ff$var$ticks;
module.exports.tickIncrement = $60b4c753b0ba83ff$var$tickIncrement;
module.exports.tickStep = $60b4c753b0ba83ff$var$tickStep;
var $60b4c753b0ba83ff$var$e10 = Math.sqrt(50), $60b4c753b0ba83ff$var$e5 = Math.sqrt(10), $60b4c753b0ba83ff$var$e2 = Math.sqrt(2);
function $60b4c753b0ba83ff$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $60b4c753b0ba83ff$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $60b4c753b0ba83ff$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $60b4c753b0ba83ff$var$e10 ? 10 : error >= $60b4c753b0ba83ff$var$e5 ? 5 : error >= $60b4c753b0ba83ff$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $60b4c753b0ba83ff$var$e10 ? 10 : error >= $60b4c753b0ba83ff$var$e5 ? 5 : error >= $60b4c753b0ba83ff$var$e2 ? 2 : 1);
}
function $60b4c753b0ba83ff$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $60b4c753b0ba83ff$var$e10) step1 *= 10;
    else if (error >= $60b4c753b0ba83ff$var$e5) step1 *= 5;
    else if (error >= $60b4c753b0ba83ff$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("bQBky", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a018213e67ffacc$var$thresholdSturges;

var $8a018213e67ffacc$var$_count = $8a018213e67ffacc$var$_interopRequireDefault((parcelRequire("kYkMf")));
function $8a018213e67ffacc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8a018213e67ffacc$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $8a018213e67ffacc$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("aEwAP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $02005ea58ada9d7d$var$thresholdFreedmanDiaconis;

var $02005ea58ada9d7d$var$_count = $02005ea58ada9d7d$var$_interopRequireDefault((parcelRequire("kYkMf")));

var $02005ea58ada9d7d$var$_quantile = $02005ea58ada9d7d$var$_interopRequireDefault((parcelRequire("gjroM")));
function $02005ea58ada9d7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $02005ea58ada9d7d$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $02005ea58ada9d7d$var$_quantile.default)(values, 0.75) - (0, $02005ea58ada9d7d$var$_quantile.default)(values, 0.25)) * Math.pow((0, $02005ea58ada9d7d$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("gjroM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be03ac7d9dffda8f$var$quantile;
module.exports.quantileSorted = $be03ac7d9dffda8f$var$quantileSorted;

var $be03ac7d9dffda8f$var$_max = $be03ac7d9dffda8f$var$_interopRequireDefault((parcelRequire("e8x5V")));

var $be03ac7d9dffda8f$var$_min = $be03ac7d9dffda8f$var$_interopRequireDefault((parcelRequire("42m8P")));

var $be03ac7d9dffda8f$var$_quickselect = $be03ac7d9dffda8f$var$_interopRequireDefault((parcelRequire("kaae3")));

var $be03ac7d9dffda8f$var$_number = $be03ac7d9dffda8f$var$_interopRequireWildcard((parcelRequire("932Ct")));
function $be03ac7d9dffda8f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($be03ac7d9dffda8f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $be03ac7d9dffda8f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $be03ac7d9dffda8f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $be03ac7d9dffda8f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $be03ac7d9dffda8f$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $be03ac7d9dffda8f$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $be03ac7d9dffda8f$var$_min.default)(values);
    if (p >= 1) return (0, $be03ac7d9dffda8f$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $be03ac7d9dffda8f$var$_max.default)((0, $be03ac7d9dffda8f$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $be03ac7d9dffda8f$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $be03ac7d9dffda8f$var$quantileSorted(values, p, valueof = $be03ac7d9dffda8f$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("e8x5V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4ab7bed2892e927$var$max;
function $a4ab7bed2892e927$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("42m8P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f0886212946adae$var$min;
function $2f0886212946adae$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("kaae3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eadcac6a3e49f9f2$var$quickselect;

var $brfkE = parcelRequire("brfkE");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $eadcac6a3e49f9f2$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $brfkE.ascendingDefined : (0, $brfkE.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $eadcac6a3e49f9f2$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $eadcac6a3e49f9f2$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $eadcac6a3e49f9f2$var$swap(array, left, right);
        while(i < j){
            $eadcac6a3e49f9f2$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $eadcac6a3e49f9f2$var$swap(array, left, j);
        else ++j, $eadcac6a3e49f9f2$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $eadcac6a3e49f9f2$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("hm5YC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ca292091d2a2aac4$var$thresholdScott;

var $ca292091d2a2aac4$var$_count = $ca292091d2a2aac4$var$_interopRequireDefault((parcelRequire("kYkMf")));

var $ca292091d2a2aac4$var$_deviation = $ca292091d2a2aac4$var$_interopRequireDefault((parcelRequire("dQBw8")));
function $ca292091d2a2aac4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ca292091d2a2aac4$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $ca292091d2a2aac4$var$_count.default)(values)) / (3.49 * (0, $ca292091d2a2aac4$var$_deviation.default)(values)));
}

});

parcelRegister("e2ntk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a38375a48dfd14fd$var$maxIndex;
function $a38375a48dfd14fd$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("dxaxT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9da6898fdacf2f34$var$mean;
function $9da6898fdacf2f34$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("5bOIG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c7552b4370ecf82$var$median;

var $3c7552b4370ecf82$var$_quantile = $3c7552b4370ecf82$var$_interopRequireDefault((parcelRequire("gjroM")));
function $3c7552b4370ecf82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3c7552b4370ecf82$var$median(values, valueof) {
    return (0, $3c7552b4370ecf82$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("hJKrm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce9aa9b7e8b25bf2$var$merge;
function* $ce9aa9b7e8b25bf2$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $ce9aa9b7e8b25bf2$var$merge(arrays) {
    return Array.from($ce9aa9b7e8b25bf2$var$flatten(arrays));
}

});

parcelRegister("3KVNh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2bc27fa05c587b4f$var$minIndex;
function $2bc27fa05c587b4f$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("hASx3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccf01969a2c4c5c8$var$mode;

var $cByLA = parcelRequire("cByLA");
function $ccf01969a2c4c5c8$var$mode(values, valueof) {
    const counts = new $cByLA.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("eVHL7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ade8553120c5f9a9$var$pairs;
module.exports.pair = $ade8553120c5f9a9$var$pair;
function $ade8553120c5f9a9$var$pairs(values, pairof = $ade8553120c5f9a9$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $ade8553120c5f9a9$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("jyr25", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e3c629688a0173b4$var$range;
function $e3c629688a0173b4$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("ksEFt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee55f7f4836e1846$var$rank;

var $ee55f7f4836e1846$var$_ascending = $ee55f7f4836e1846$var$_interopRequireDefault((parcelRequire("281sk")));

var $brfkE = parcelRequire("brfkE");
function $ee55f7f4836e1846$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ee55f7f4836e1846$var$rank(values, valueof = $ee55f7f4836e1846$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $ee55f7f4836e1846$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $ee55f7f4836e1846$var$_ascending.default ? (i, j)=>(0, $brfkE.ascendingDefined)(V[i], V[j]) : (0, $brfkE.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("lXfCD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffbb39e2ae803f76$var$least;

var $ffbb39e2ae803f76$var$_ascending = $ffbb39e2ae803f76$var$_interopRequireDefault((parcelRequire("281sk")));
function $ffbb39e2ae803f76$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ffbb39e2ae803f76$var$least(values, compare = $ffbb39e2ae803f76$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $ffbb39e2ae803f76$var$_ascending.default)(value, minValue) < 0 : (0, $ffbb39e2ae803f76$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("kwPQO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef1f0448dcf104a5$var$leastIndex;

var $ef1f0448dcf104a5$var$_ascending = $ef1f0448dcf104a5$var$_interopRequireDefault((parcelRequire("281sk")));

var $ef1f0448dcf104a5$var$_minIndex = $ef1f0448dcf104a5$var$_interopRequireDefault((parcelRequire("3KVNh")));
function $ef1f0448dcf104a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef1f0448dcf104a5$var$leastIndex(values, compare = $ef1f0448dcf104a5$var$_ascending.default) {
    if (compare.length === 1) return (0, $ef1f0448dcf104a5$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("GO3gn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $080abf91f86114d0$var$greatest;

var $080abf91f86114d0$var$_ascending = $080abf91f86114d0$var$_interopRequireDefault((parcelRequire("281sk")));
function $080abf91f86114d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $080abf91f86114d0$var$greatest(values, compare = $080abf91f86114d0$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $080abf91f86114d0$var$_ascending.default)(value, maxValue) > 0 : (0, $080abf91f86114d0$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("53KjN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3af12968f33a2ac3$var$greatestIndex;

var $3af12968f33a2ac3$var$_ascending = $3af12968f33a2ac3$var$_interopRequireDefault((parcelRequire("281sk")));

var $3af12968f33a2ac3$var$_maxIndex = $3af12968f33a2ac3$var$_interopRequireDefault((parcelRequire("e2ntk")));
function $3af12968f33a2ac3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3af12968f33a2ac3$var$greatestIndex(values, compare = $3af12968f33a2ac3$var$_ascending.default) {
    if (compare.length === 1) return (0, $3af12968f33a2ac3$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("gShNl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c48f7e2bd03a8c96$var$scan;

var $c48f7e2bd03a8c96$var$_leastIndex = $c48f7e2bd03a8c96$var$_interopRequireDefault((parcelRequire("kwPQO")));
function $c48f7e2bd03a8c96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c48f7e2bd03a8c96$var$scan(values, compare) {
    const index = (0, $c48f7e2bd03a8c96$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("2FJp6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $1f22a15b43229556$var$shuffler;
var $1f22a15b43229556$var$_default = $1f22a15b43229556$var$shuffler(Math.random);
module.exports.default = $1f22a15b43229556$var$_default;
function $1f22a15b43229556$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("fqtmA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3b00fa45ccf7e5c$var$sum;
function $b3b00fa45ccf7e5c$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("9cWjo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b427793da900b48$var$transpose;

var $6b427793da900b48$var$_min = $6b427793da900b48$var$_interopRequireDefault((parcelRequire("42m8P")));
function $6b427793da900b48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6b427793da900b48$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $6b427793da900b48$var$_min.default)(matrix, $6b427793da900b48$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $6b427793da900b48$var$length(d) {
    return d.length;
}

});

parcelRegister("55YXP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b5cb590b90dd254$var$zip;

var $3b5cb590b90dd254$var$_transpose = $3b5cb590b90dd254$var$_interopRequireDefault((parcelRequire("9cWjo")));
function $3b5cb590b90dd254$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3b5cb590b90dd254$var$zip() {
    return (0, $3b5cb590b90dd254$var$_transpose.default)(arguments);
}

});

parcelRegister("7pCvo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5658bc94610a8709$var$every;
function $5658bc94610a8709$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("4V1Ps", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $394de7814798b970$var$some;
function $394de7814798b970$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("RaMNY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $09fd514324405269$var$filter;
function $09fd514324405269$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("kclwu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eb459fae9d737335$var$map;
function $eb459fae9d737335$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("6W6lV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $50cd165ebde6975a$var$reduce;
function $50cd165ebde6975a$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("geHt0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd1fabbb0e8a9256$var$reverse;
function $bd1fabbb0e8a9256$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("jzwUG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e3fad1114e43013a$var$difference;

var $cByLA = parcelRequire("cByLA");
function $e3fad1114e43013a$var$difference(values, ...others) {
    values = new $cByLA.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("1Ia1T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $13f1ae2ff828373a$var$disjoint;

var $cByLA = parcelRequire("cByLA");
function $13f1ae2ff828373a$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $cByLA.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("6O8gh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4f4dd22b8bce986e$var$intersection;

var $cByLA = parcelRequire("cByLA");
function $4f4dd22b8bce986e$var$intersection(values, ...others) {
    values = new $cByLA.InternSet(values);
    others = others.map($4f4dd22b8bce986e$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $4f4dd22b8bce986e$var$set(values) {
    return values instanceof $cByLA.InternSet ? values : new $cByLA.InternSet(values);
}

});

parcelRegister("7vEbB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $577a99cb86754747$var$subset;

var $577a99cb86754747$var$_superset = $577a99cb86754747$var$_interopRequireDefault((parcelRequire("2uhDJ")));
function $577a99cb86754747$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $577a99cb86754747$var$subset(values, other) {
    return (0, $577a99cb86754747$var$_superset.default)(other, values);
}

});
parcelRegister("2uhDJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1cfc1108f58755be$var$superset;
function $1cfc1108f58755be$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $1cfc1108f58755be$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $1cfc1108f58755be$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $1cfc1108f58755be$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("1jtDr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0f4e8db14a50a76b$var$union;

var $cByLA = parcelRequire("cByLA");
function $0f4e8db14a50a76b$var$union(...others) {
    const set = new $cByLA.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("1UgJT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $16380177d0620ef1$var$initInterpolator;
module.exports.initRange = $16380177d0620ef1$var$initRange;
function $16380177d0620ef1$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $16380177d0620ef1$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("157Hw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c9c3b502ef5d4cf$var$ordinal;
module.exports.implicit = void 0;

var $chaAX = parcelRequire("chaAX");

var $1UgJT = parcelRequire("1UgJT");
const $0c9c3b502ef5d4cf$var$implicit = Symbol("implicit");
module.exports.implicit = $0c9c3b502ef5d4cf$var$implicit;
function $0c9c3b502ef5d4cf$var$ordinal() {
    var index = new $chaAX.InternMap(), domain = [], range = [], unknown = $0c9c3b502ef5d4cf$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $0c9c3b502ef5d4cf$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $chaAX.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $0c9c3b502ef5d4cf$var$ordinal(domain, range).unknown(unknown);
    };
    $1UgJT.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("7R0k2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b7dbba40e2a7dc2$var$identity;

var $6sFEr = parcelRequire("6sFEr");

var $5b7dbba40e2a7dc2$var$_number = $5b7dbba40e2a7dc2$var$_interopRequireDefault((parcelRequire("hnPwu")));
function $5b7dbba40e2a7dc2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5b7dbba40e2a7dc2$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $5b7dbba40e2a7dc2$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $5b7dbba40e2a7dc2$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $5b7dbba40e2a7dc2$var$_number.default) : [
        0,
        1
    ];
    return (0, $6sFEr.linearish)(scale);
}

});
parcelRegister("6sFEr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b45aaae50ed32ad$var$linear;
module.exports.linearish = $4b45aaae50ed32ad$var$linearish;

var $chaAX = parcelRequire("chaAX");

var $4b45aaae50ed32ad$var$_continuous = $4b45aaae50ed32ad$var$_interopRequireWildcard((parcelRequire("jvFbg")));

var $1UgJT = parcelRequire("1UgJT");

var $4b45aaae50ed32ad$var$_tickFormat = $4b45aaae50ed32ad$var$_interopRequireDefault((parcelRequire("dwtsH")));
function $4b45aaae50ed32ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4b45aaae50ed32ad$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4b45aaae50ed32ad$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4b45aaae50ed32ad$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4b45aaae50ed32ad$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4b45aaae50ed32ad$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $chaAX.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $4b45aaae50ed32ad$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $chaAX.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $4b45aaae50ed32ad$var$linear() {
    var scale = (0, $4b45aaae50ed32ad$var$_continuous.default)();
    scale.copy = function() {
        return (0, $4b45aaae50ed32ad$var$_continuous.copy)(scale, $4b45aaae50ed32ad$var$linear());
    };
    $1UgJT.initRange.apply(scale, arguments);
    return $4b45aaae50ed32ad$var$linearish(scale);
}

});
parcelRegister("jvFbg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $e340db2d61ebc0a9$var$copy;
module.exports.default = $e340db2d61ebc0a9$var$continuous;
module.exports.identity = $e340db2d61ebc0a9$var$identity;
module.exports.transformer = $e340db2d61ebc0a9$var$transformer;

var $chaAX = parcelRequire("chaAX");

var $6xFxm = parcelRequire("6xFxm");

var $e340db2d61ebc0a9$var$_constant = $e340db2d61ebc0a9$var$_interopRequireDefault((parcelRequire("2z5eO")));

var $e340db2d61ebc0a9$var$_number = $e340db2d61ebc0a9$var$_interopRequireDefault((parcelRequire("hnPwu")));
function $e340db2d61ebc0a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e340db2d61ebc0a9$var$unit = [
    0,
    1
];
function $e340db2d61ebc0a9$var$identity(x) {
    return x;
}
function $e340db2d61ebc0a9$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $e340db2d61ebc0a9$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $e340db2d61ebc0a9$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $e340db2d61ebc0a9$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $e340db2d61ebc0a9$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $e340db2d61ebc0a9$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $e340db2d61ebc0a9$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $e340db2d61ebc0a9$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $chaAX.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $e340db2d61ebc0a9$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $e340db2d61ebc0a9$var$transformer() {
    var domain = $e340db2d61ebc0a9$var$unit, range = $e340db2d61ebc0a9$var$unit, interpolate = $6xFxm.interpolate, transform, untransform, unknown, clamp = $e340db2d61ebc0a9$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $e340db2d61ebc0a9$var$identity) clamp = $e340db2d61ebc0a9$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $e340db2d61ebc0a9$var$polymap : $e340db2d61ebc0a9$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $6xFxm.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $e340db2d61ebc0a9$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $6xFxm.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $e340db2d61ebc0a9$var$identity, rescale()) : clamp !== $e340db2d61ebc0a9$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $e340db2d61ebc0a9$var$continuous() {
    return $e340db2d61ebc0a9$var$transformer()($e340db2d61ebc0a9$var$identity, $e340db2d61ebc0a9$var$identity);
}

});
parcelRegister("6xFxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $am8Bg.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $am8Bg.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $4c360b851b3d92ba$var$_quantize.default;
    }
});

var $4c360b851b3d92ba$var$_value = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("fRVH6")));

var $4c360b851b3d92ba$var$_array = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("aPGyu")));

var $4c360b851b3d92ba$var$_basis = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("amUWz")));

var $4c360b851b3d92ba$var$_basisClosed = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("l0vYp")));

var $4c360b851b3d92ba$var$_date = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("5WTc6")));

var $4c360b851b3d92ba$var$_discrete = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("4ewaf")));

var $4c360b851b3d92ba$var$_hue = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("9nxoP")));

var $4c360b851b3d92ba$var$_number = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("4dzHz")));

var $4c360b851b3d92ba$var$_numberArray = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("f5iko")));

var $4c360b851b3d92ba$var$_object = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("eq4H4")));

var $4c360b851b3d92ba$var$_round = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("8jDdG")));

var $4c360b851b3d92ba$var$_string = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("cJNFC")));

var $am8Bg = parcelRequire("am8Bg");

var $4c360b851b3d92ba$var$_zoom = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("cFtAO")));

var $4c360b851b3d92ba$var$_rgb = $4c360b851b3d92ba$var$_interopRequireWildcard((parcelRequire("cDXSU")));

var $4c360b851b3d92ba$var$_hsl = $4c360b851b3d92ba$var$_interopRequireWildcard((parcelRequire("8ej5e")));

var $4c360b851b3d92ba$var$_lab = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("kLpAu")));

var $4c360b851b3d92ba$var$_hcl = $4c360b851b3d92ba$var$_interopRequireWildcard((parcelRequire("dHYoZ")));

var $4c360b851b3d92ba$var$_cubehelix = $4c360b851b3d92ba$var$_interopRequireWildcard((parcelRequire("9S3aS")));

var $4c360b851b3d92ba$var$_piecewise = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("fnyqt")));

var $4c360b851b3d92ba$var$_quantize = $4c360b851b3d92ba$var$_interopRequireDefault((parcelRequire("9dp0K")));
function $4c360b851b3d92ba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4c360b851b3d92ba$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4c360b851b3d92ba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4c360b851b3d92ba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4c360b851b3d92ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("fRVH6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b8d88f1c978c0d41$var$_default;

var $cOWDI = parcelRequire("cOWDI");

var $b8d88f1c978c0d41$var$_rgb = $b8d88f1c978c0d41$var$_interopRequireDefault((parcelRequire("cDXSU")));

var $aPGyu = parcelRequire("aPGyu");

var $b8d88f1c978c0d41$var$_date = $b8d88f1c978c0d41$var$_interopRequireDefault((parcelRequire("5WTc6")));

var $b8d88f1c978c0d41$var$_number = $b8d88f1c978c0d41$var$_interopRequireDefault((parcelRequire("4dzHz")));

var $b8d88f1c978c0d41$var$_object = $b8d88f1c978c0d41$var$_interopRequireDefault((parcelRequire("eq4H4")));

var $b8d88f1c978c0d41$var$_string = $b8d88f1c978c0d41$var$_interopRequireDefault((parcelRequire("cJNFC")));

var $b8d88f1c978c0d41$var$_constant = $b8d88f1c978c0d41$var$_interopRequireDefault((parcelRequire("1q1oW")));

var $b8d88f1c978c0d41$var$_numberArray = $b8d88f1c978c0d41$var$_interopRequireWildcard((parcelRequire("f5iko")));
function $b8d88f1c978c0d41$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b8d88f1c978c0d41$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b8d88f1c978c0d41$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b8d88f1c978c0d41$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b8d88f1c978c0d41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b8d88f1c978c0d41$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $b8d88f1c978c0d41$var$_constant.default)(b) : (t === "number" ? $b8d88f1c978c0d41$var$_number.default : t === "string" ? (c = (0, $cOWDI.color)(b)) ? (b = c, $b8d88f1c978c0d41$var$_rgb.default) : $b8d88f1c978c0d41$var$_string.default : b instanceof $cOWDI.color ? $b8d88f1c978c0d41$var$_rgb.default : b instanceof Date ? $b8d88f1c978c0d41$var$_date.default : (0, $b8d88f1c978c0d41$var$_numberArray.isNumberArray)(b) ? $b8d88f1c978c0d41$var$_numberArray.default : Array.isArray(b) ? $aPGyu.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $b8d88f1c978c0d41$var$_object.default : $b8d88f1c978c0d41$var$_number.default)(a, b);
}

});
parcelRegister("cOWDI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $9557a42914ac95a5$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $9557a42914ac95a5$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $9557a42914ac95a5$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $9557a42914ac95a5$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $9557a42914ac95a5$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $9557a42914ac95a5$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $9557a42914ac95a5$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $9557a42914ac95a5$var$_color.rgb;
    }
});

var $9557a42914ac95a5$var$_color = $9557a42914ac95a5$var$_interopRequireWildcard((parcelRequire("9mN5b")));

var $9557a42914ac95a5$var$_lab = $9557a42914ac95a5$var$_interopRequireWildcard((parcelRequire("7IoVv")));

var $9557a42914ac95a5$var$_cubehelix = $9557a42914ac95a5$var$_interopRequireDefault((parcelRequire("gxV64")));
function $9557a42914ac95a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9557a42914ac95a5$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9557a42914ac95a5$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9557a42914ac95a5$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9557a42914ac95a5$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("9mN5b", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("MUyO9")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("MUyO9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $09305b87af9ecd95$var$_default;
module.exports.extend = $09305b87af9ecd95$var$extend;
function $09305b87af9ecd95$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $09305b87af9ecd95$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("7IoVv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $59dffa57241d6653$var$Hcl;
module.exports.Lab = $59dffa57241d6653$var$Lab;
module.exports.default = $59dffa57241d6653$var$lab;
module.exports.gray = $59dffa57241d6653$var$gray;
module.exports.hcl = $59dffa57241d6653$var$hcl;
module.exports.lch = $59dffa57241d6653$var$lch;

var $59dffa57241d6653$var$_define = $59dffa57241d6653$var$_interopRequireWildcard((parcelRequire("MUyO9")));

var $9mN5b = parcelRequire("9mN5b");

var $eAz8F = parcelRequire("eAz8F");
function $59dffa57241d6653$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($59dffa57241d6653$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $59dffa57241d6653$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $59dffa57241d6653$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $59dffa57241d6653$var$K = 18, $59dffa57241d6653$var$Xn = 0.96422, $59dffa57241d6653$var$Yn = 1, $59dffa57241d6653$var$Zn = 0.82521, $59dffa57241d6653$var$t0 = 4 / 29, $59dffa57241d6653$var$t1 = 6 / 29, $59dffa57241d6653$var$t2 = 3 * $59dffa57241d6653$var$t1 * $59dffa57241d6653$var$t1, $59dffa57241d6653$var$t3 = $59dffa57241d6653$var$t1 * $59dffa57241d6653$var$t1 * $59dffa57241d6653$var$t1;
function $59dffa57241d6653$var$labConvert(o) {
    if (o instanceof $59dffa57241d6653$var$Lab) return new $59dffa57241d6653$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $59dffa57241d6653$var$Hcl) return $59dffa57241d6653$var$hcl2lab(o);
    if (!(o instanceof $9mN5b.Rgb)) o = (0, $9mN5b.rgbConvert)(o);
    var r = $59dffa57241d6653$var$rgb2lrgb(o.r), g = $59dffa57241d6653$var$rgb2lrgb(o.g), b = $59dffa57241d6653$var$rgb2lrgb(o.b), y = $59dffa57241d6653$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $59dffa57241d6653$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $59dffa57241d6653$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $59dffa57241d6653$var$Xn);
        z = $59dffa57241d6653$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $59dffa57241d6653$var$Zn);
    }
    return new $59dffa57241d6653$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $59dffa57241d6653$var$gray(l, opacity) {
    return new $59dffa57241d6653$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $59dffa57241d6653$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $59dffa57241d6653$var$labConvert(l) : new $59dffa57241d6653$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $59dffa57241d6653$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $59dffa57241d6653$var$_define.default)($59dffa57241d6653$var$Lab, $59dffa57241d6653$var$lab, (0, $59dffa57241d6653$var$_define.extend)($9mN5b.Color, {
    brighter (k) {
        return new $59dffa57241d6653$var$Lab(this.l + $59dffa57241d6653$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $59dffa57241d6653$var$Lab(this.l - $59dffa57241d6653$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $59dffa57241d6653$var$Xn * $59dffa57241d6653$var$lab2xyz(x);
        y = $59dffa57241d6653$var$Yn * $59dffa57241d6653$var$lab2xyz(y);
        z = $59dffa57241d6653$var$Zn * $59dffa57241d6653$var$lab2xyz(z);
        return new $9mN5b.Rgb($59dffa57241d6653$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $59dffa57241d6653$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $59dffa57241d6653$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $59dffa57241d6653$var$xyz2lab(t) {
    return t > $59dffa57241d6653$var$t3 ? Math.pow(t, 1 / 3) : t / $59dffa57241d6653$var$t2 + $59dffa57241d6653$var$t0;
}
function $59dffa57241d6653$var$lab2xyz(t) {
    return t > $59dffa57241d6653$var$t1 ? t * t * t : $59dffa57241d6653$var$t2 * (t - $59dffa57241d6653$var$t0);
}
function $59dffa57241d6653$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $59dffa57241d6653$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $59dffa57241d6653$var$hclConvert(o) {
    if (o instanceof $59dffa57241d6653$var$Hcl) return new $59dffa57241d6653$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $59dffa57241d6653$var$Lab)) o = $59dffa57241d6653$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $59dffa57241d6653$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $eAz8F.degrees;
    return new $59dffa57241d6653$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $59dffa57241d6653$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $59dffa57241d6653$var$hclConvert(l) : new $59dffa57241d6653$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $59dffa57241d6653$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $59dffa57241d6653$var$hclConvert(h) : new $59dffa57241d6653$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $59dffa57241d6653$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $59dffa57241d6653$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $59dffa57241d6653$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $eAz8F.radians;
    return new $59dffa57241d6653$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $59dffa57241d6653$var$_define.default)($59dffa57241d6653$var$Hcl, $59dffa57241d6653$var$hcl, (0, $59dffa57241d6653$var$_define.extend)($9mN5b.Color, {
    brighter (k) {
        return new $59dffa57241d6653$var$Hcl(this.h, this.c, this.l + $59dffa57241d6653$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $59dffa57241d6653$var$Hcl(this.h, this.c, this.l - $59dffa57241d6653$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $59dffa57241d6653$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("eAz8F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $a9efaf4c2bb96791$var$radians = Math.PI / 180;
module.exports.radians = $a9efaf4c2bb96791$var$radians;
const $a9efaf4c2bb96791$var$degrees = 180 / Math.PI;
module.exports.degrees = $a9efaf4c2bb96791$var$degrees;

});


parcelRegister("gxV64", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $c0bc04aa8a3ed54e$var$Cubehelix;
module.exports.default = $c0bc04aa8a3ed54e$var$cubehelix;

var $c0bc04aa8a3ed54e$var$_define = $c0bc04aa8a3ed54e$var$_interopRequireWildcard((parcelRequire("MUyO9")));

var $9mN5b = parcelRequire("9mN5b");

var $eAz8F = parcelRequire("eAz8F");
function $c0bc04aa8a3ed54e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c0bc04aa8a3ed54e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c0bc04aa8a3ed54e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c0bc04aa8a3ed54e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $c0bc04aa8a3ed54e$var$A = -0.14861, $c0bc04aa8a3ed54e$var$B = 1.78277, $c0bc04aa8a3ed54e$var$C = -0.29227, $c0bc04aa8a3ed54e$var$D = -0.90649, $c0bc04aa8a3ed54e$var$E = 1.97294, $c0bc04aa8a3ed54e$var$ED = $c0bc04aa8a3ed54e$var$E * $c0bc04aa8a3ed54e$var$D, $c0bc04aa8a3ed54e$var$EB = $c0bc04aa8a3ed54e$var$E * $c0bc04aa8a3ed54e$var$B, $c0bc04aa8a3ed54e$var$BC_DA = $c0bc04aa8a3ed54e$var$B * $c0bc04aa8a3ed54e$var$C - $c0bc04aa8a3ed54e$var$D * $c0bc04aa8a3ed54e$var$A;
function $c0bc04aa8a3ed54e$var$cubehelixConvert(o) {
    if (o instanceof $c0bc04aa8a3ed54e$var$Cubehelix) return new $c0bc04aa8a3ed54e$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $9mN5b.Rgb)) o = (0, $9mN5b.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($c0bc04aa8a3ed54e$var$BC_DA * b + $c0bc04aa8a3ed54e$var$ED * r - $c0bc04aa8a3ed54e$var$EB * g) / ($c0bc04aa8a3ed54e$var$BC_DA + $c0bc04aa8a3ed54e$var$ED - $c0bc04aa8a3ed54e$var$EB), bl = b - l, k = ($c0bc04aa8a3ed54e$var$E * (g - l) - $c0bc04aa8a3ed54e$var$C * bl) / $c0bc04aa8a3ed54e$var$D, s = Math.sqrt(k * k + bl * bl) / ($c0bc04aa8a3ed54e$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $eAz8F.degrees - 120 : NaN;
    return new $c0bc04aa8a3ed54e$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $c0bc04aa8a3ed54e$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $c0bc04aa8a3ed54e$var$cubehelixConvert(h) : new $c0bc04aa8a3ed54e$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $c0bc04aa8a3ed54e$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $c0bc04aa8a3ed54e$var$_define.default)($c0bc04aa8a3ed54e$var$Cubehelix, $c0bc04aa8a3ed54e$var$cubehelix, (0, $c0bc04aa8a3ed54e$var$_define.extend)($9mN5b.Color, {
    brighter (k) {
        k = k == null ? $9mN5b.brighter : Math.pow($9mN5b.brighter, k);
        return new $c0bc04aa8a3ed54e$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $9mN5b.darker : Math.pow($9mN5b.darker, k);
        return new $c0bc04aa8a3ed54e$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $eAz8F.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $9mN5b.Rgb(255 * (l + a * ($c0bc04aa8a3ed54e$var$A * cosh + $c0bc04aa8a3ed54e$var$B * sinh)), 255 * (l + a * ($c0bc04aa8a3ed54e$var$C * cosh + $c0bc04aa8a3ed54e$var$D * sinh)), 255 * (l + a * ($c0bc04aa8a3ed54e$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("cDXSU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $cOWDI = parcelRequire("cOWDI");

var $9347945e86f2d40e$var$_basis = $9347945e86f2d40e$var$_interopRequireDefault((parcelRequire("amUWz")));

var $9347945e86f2d40e$var$_basisClosed = $9347945e86f2d40e$var$_interopRequireDefault((parcelRequire("l0vYp")));

var $9347945e86f2d40e$var$_color = $9347945e86f2d40e$var$_interopRequireWildcard((parcelRequire("8OuYc")));
function $9347945e86f2d40e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9347945e86f2d40e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9347945e86f2d40e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9347945e86f2d40e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9347945e86f2d40e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9347945e86f2d40e$var$_default = function rgbGamma(y) {
    var color = (0, $9347945e86f2d40e$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $cOWDI.rgb)(start)).r, (end = (0, $cOWDI.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $9347945e86f2d40e$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $9347945e86f2d40e$var$_default;
function $9347945e86f2d40e$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $cOWDI.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $9347945e86f2d40e$var$rgbBasis = $9347945e86f2d40e$var$rgbSpline($9347945e86f2d40e$var$_basis.default);
module.exports.rgbBasis = $9347945e86f2d40e$var$rgbBasis;
var $9347945e86f2d40e$var$rgbBasisClosed = $9347945e86f2d40e$var$rgbSpline($9347945e86f2d40e$var$_basisClosed.default);
module.exports.rgbBasisClosed = $9347945e86f2d40e$var$rgbBasisClosed;

});
parcelRegister("amUWz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $78c8214d414072e2$var$basis;
module.exports.default = $78c8214d414072e2$var$_default;
function $78c8214d414072e2$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $78c8214d414072e2$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $78c8214d414072e2$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("l0vYp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4b266477259b9a7$var$_default;

var $amUWz = parcelRequire("amUWz");
function $f4b266477259b9a7$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $amUWz.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("8OuYc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $66ab043c05925363$var$nogamma;
module.exports.gamma = $66ab043c05925363$var$gamma;
module.exports.hue = $66ab043c05925363$var$hue;

var $66ab043c05925363$var$_constant = $66ab043c05925363$var$_interopRequireDefault((parcelRequire("1q1oW")));
function $66ab043c05925363$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $66ab043c05925363$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $66ab043c05925363$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $66ab043c05925363$var$hue(a, b) {
    var d = b - a;
    return d ? $66ab043c05925363$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $66ab043c05925363$var$_constant.default)(isNaN(a) ? b : a);
}
function $66ab043c05925363$var$gamma(y) {
    return (y = +y) === 1 ? $66ab043c05925363$var$nogamma : function(a, b) {
        return b - a ? $66ab043c05925363$var$exponential(a, b, y) : (0, $66ab043c05925363$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $66ab043c05925363$var$nogamma(a, b) {
    var d = b - a;
    return d ? $66ab043c05925363$var$linear(a, d) : (0, $66ab043c05925363$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("1q1oW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $10894e6e2ed239e5$var$_default = (x)=>()=>x;
module.exports.default = $10894e6e2ed239e5$var$_default;

});



parcelRegister("aPGyu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e2fad632fe93506$var$_default;
module.exports.genericArray = $7e2fad632fe93506$var$genericArray;

var $7e2fad632fe93506$var$_value = $7e2fad632fe93506$var$_interopRequireDefault((parcelRequire("fRVH6")));

var $7e2fad632fe93506$var$_numberArray = $7e2fad632fe93506$var$_interopRequireWildcard((parcelRequire("f5iko")));
function $7e2fad632fe93506$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7e2fad632fe93506$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7e2fad632fe93506$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7e2fad632fe93506$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $7e2fad632fe93506$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e2fad632fe93506$var$_default(a, b) {
    return ((0, $7e2fad632fe93506$var$_numberArray.isNumberArray)(b) ? $7e2fad632fe93506$var$_numberArray.default : $7e2fad632fe93506$var$genericArray)(a, b);
}
function $7e2fad632fe93506$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $7e2fad632fe93506$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("f5iko", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $afb58a3611d018b4$var$_default;
module.exports.isNumberArray = $afb58a3611d018b4$var$isNumberArray;
function $afb58a3611d018b4$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $afb58a3611d018b4$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("5WTc6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $454d2ef8a2ff4f98$var$_default;
function $454d2ef8a2ff4f98$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("4dzHz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $312411efc2468219$var$_default;
function $312411efc2468219$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("eq4H4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7f7227bee7d4824$var$_default;

var $a7f7227bee7d4824$var$_value = $a7f7227bee7d4824$var$_interopRequireDefault((parcelRequire("fRVH6")));
function $a7f7227bee7d4824$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a7f7227bee7d4824$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $a7f7227bee7d4824$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("cJNFC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94603776c9c9fdf8$var$_default;

var $94603776c9c9fdf8$var$_number = $94603776c9c9fdf8$var$_interopRequireDefault((parcelRequire("4dzHz")));
function $94603776c9c9fdf8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $94603776c9c9fdf8$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $94603776c9c9fdf8$var$reB = new RegExp($94603776c9c9fdf8$var$reA.source, "g");
function $94603776c9c9fdf8$var$zero(b) {
    return function() {
        return b;
    };
}
function $94603776c9c9fdf8$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $94603776c9c9fdf8$var$_default(a, b) {
    var bi = $94603776c9c9fdf8$var$reA.lastIndex = $94603776c9c9fdf8$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $94603776c9c9fdf8$var$reA.exec(a)) && (bm = $94603776c9c9fdf8$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $94603776c9c9fdf8$var$_number.default)(am, bm)
            });
        }
        bi = $94603776c9c9fdf8$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $94603776c9c9fdf8$var$one(q[0].x) : $94603776c9c9fdf8$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("4ewaf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31516b5f8fb8e125$var$_default;
function $31516b5f8fb8e125$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("9nxoP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d402b77dcf39aef$var$_default;

var $8OuYc = parcelRequire("8OuYc");
function $6d402b77dcf39aef$var$_default(a, b) {
    var i = (0, $8OuYc.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("8jDdG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60de854ba47dcd9b$var$_default;
function $60de854ba47dcd9b$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("am8Bg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $78a2a14255966b81$var$_number = $78a2a14255966b81$var$_interopRequireDefault((parcelRequire("4dzHz")));

var $5BqNb = parcelRequire("5BqNb");
function $78a2a14255966b81$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $78a2a14255966b81$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $78a2a14255966b81$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $78a2a14255966b81$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $78a2a14255966b81$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $78a2a14255966b81$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $78a2a14255966b81$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $78a2a14255966b81$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $78a2a14255966b81$var$interpolateTransformCss = $78a2a14255966b81$var$interpolateTransform($5BqNb.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $78a2a14255966b81$var$interpolateTransformCss;
var $78a2a14255966b81$var$interpolateTransformSvg = $78a2a14255966b81$var$interpolateTransform($5BqNb.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $78a2a14255966b81$var$interpolateTransformSvg;

});
parcelRegister("5BqNb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $414530dc8eaabb2a$var$parseCss;
module.exports.parseSvg = $414530dc8eaabb2a$var$parseSvg;

var $414530dc8eaabb2a$var$_decompose = $414530dc8eaabb2a$var$_interopRequireWildcard((parcelRequire("aKJjO")));
function $414530dc8eaabb2a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($414530dc8eaabb2a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $414530dc8eaabb2a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $414530dc8eaabb2a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $414530dc8eaabb2a$var$svgNode;
/* eslint-disable no-undef */ function $414530dc8eaabb2a$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $414530dc8eaabb2a$var$_decompose.identity : (0, $414530dc8eaabb2a$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $414530dc8eaabb2a$var$parseSvg(value) {
    if (value == null) return $414530dc8eaabb2a$var$_decompose.identity;
    if (!$414530dc8eaabb2a$var$svgNode) $414530dc8eaabb2a$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $414530dc8eaabb2a$var$svgNode.setAttribute("transform", value);
    if (!(value = $414530dc8eaabb2a$var$svgNode.transform.baseVal.consolidate())) return $414530dc8eaabb2a$var$_decompose.identity;
    value = value.matrix;
    return (0, $414530dc8eaabb2a$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("aKJjO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7d415a9ac20d4f8a$var$_default;
module.exports.identity = void 0;
var $7d415a9ac20d4f8a$var$degrees = 180 / Math.PI;
var $7d415a9ac20d4f8a$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $7d415a9ac20d4f8a$var$identity;
function $7d415a9ac20d4f8a$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $7d415a9ac20d4f8a$var$degrees,
        skewX: Math.atan(skewX) * $7d415a9ac20d4f8a$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("cFtAO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $939044da5df04bf0$var$epsilon2 = 1e-12;
function $939044da5df04bf0$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $939044da5df04bf0$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $939044da5df04bf0$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $939044da5df04bf0$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $939044da5df04bf0$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $939044da5df04bf0$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $939044da5df04bf0$var$tanh(rho * s + r0) - $939044da5df04bf0$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $939044da5df04bf0$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $939044da5df04bf0$var$_default;

});

parcelRegister("8ej5e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $cOWDI = parcelRequire("cOWDI");

var $5fde6f1fabbb0a75$var$_color = $5fde6f1fabbb0a75$var$_interopRequireWildcard((parcelRequire("8OuYc")));
function $5fde6f1fabbb0a75$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5fde6f1fabbb0a75$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5fde6f1fabbb0a75$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5fde6f1fabbb0a75$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5fde6f1fabbb0a75$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $cOWDI.hsl)(start)).h, (end = (0, $cOWDI.hsl)(end)).h), s = (0, $5fde6f1fabbb0a75$var$_color.default)(start.s, end.s), l = (0, $5fde6f1fabbb0a75$var$_color.default)(start.l, end.l), opacity = (0, $5fde6f1fabbb0a75$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $5fde6f1fabbb0a75$var$_default = $5fde6f1fabbb0a75$var$hsl($5fde6f1fabbb0a75$var$_color.hue);
module.exports.default = $5fde6f1fabbb0a75$var$_default;
var $5fde6f1fabbb0a75$var$hslLong = $5fde6f1fabbb0a75$var$hsl($5fde6f1fabbb0a75$var$_color.default);
module.exports.hslLong = $5fde6f1fabbb0a75$var$hslLong;

});

parcelRegister("kLpAu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1dc0b97c913ce94$var$lab;

var $cOWDI = parcelRequire("cOWDI");

var $f1dc0b97c913ce94$var$_color = $f1dc0b97c913ce94$var$_interopRequireDefault((parcelRequire("8OuYc")));
function $f1dc0b97c913ce94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f1dc0b97c913ce94$var$lab(start, end) {
    var l = (0, $f1dc0b97c913ce94$var$_color.default)((start = (0, $cOWDI.lab)(start)).l, (end = (0, $cOWDI.lab)(end)).l), a = (0, $f1dc0b97c913ce94$var$_color.default)(start.a, end.a), b = (0, $f1dc0b97c913ce94$var$_color.default)(start.b, end.b), opacity = (0, $f1dc0b97c913ce94$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("dHYoZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $cOWDI = parcelRequire("cOWDI");

var $9fae251535f9940b$var$_color = $9fae251535f9940b$var$_interopRequireWildcard((parcelRequire("8OuYc")));
function $9fae251535f9940b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9fae251535f9940b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9fae251535f9940b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9fae251535f9940b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9fae251535f9940b$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $cOWDI.hcl)(start)).h, (end = (0, $cOWDI.hcl)(end)).h), c = (0, $9fae251535f9940b$var$_color.default)(start.c, end.c), l = (0, $9fae251535f9940b$var$_color.default)(start.l, end.l), opacity = (0, $9fae251535f9940b$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $9fae251535f9940b$var$_default = $9fae251535f9940b$var$hcl($9fae251535f9940b$var$_color.hue);
module.exports.default = $9fae251535f9940b$var$_default;
var $9fae251535f9940b$var$hclLong = $9fae251535f9940b$var$hcl($9fae251535f9940b$var$_color.default);
module.exports.hclLong = $9fae251535f9940b$var$hclLong;

});

parcelRegister("9S3aS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $cOWDI = parcelRequire("cOWDI");

var $72fb9e94cc2c3de7$var$_color = $72fb9e94cc2c3de7$var$_interopRequireWildcard((parcelRequire("8OuYc")));
function $72fb9e94cc2c3de7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($72fb9e94cc2c3de7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $72fb9e94cc2c3de7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $72fb9e94cc2c3de7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $72fb9e94cc2c3de7$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $cOWDI.cubehelix)(start)).h, (end = (0, $cOWDI.cubehelix)(end)).h), s = (0, $72fb9e94cc2c3de7$var$_color.default)(start.s, end.s), l = (0, $72fb9e94cc2c3de7$var$_color.default)(start.l, end.l), opacity = (0, $72fb9e94cc2c3de7$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $72fb9e94cc2c3de7$var$_default = $72fb9e94cc2c3de7$var$cubehelix($72fb9e94cc2c3de7$var$_color.hue);
module.exports.default = $72fb9e94cc2c3de7$var$_default;
var $72fb9e94cc2c3de7$var$cubehelixLong = $72fb9e94cc2c3de7$var$cubehelix($72fb9e94cc2c3de7$var$_color.default);
module.exports.cubehelixLong = $72fb9e94cc2c3de7$var$cubehelixLong;

});

parcelRegister("fnyqt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b323b546bf7692b3$var$piecewise;

var $b323b546bf7692b3$var$_value = $b323b546bf7692b3$var$_interopRequireDefault((parcelRequire("fRVH6")));
function $b323b546bf7692b3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b323b546bf7692b3$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $b323b546bf7692b3$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("9dp0K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b58baa46707d2ba$var$_default;
function $6b58baa46707d2ba$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("2z5eO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1de2e9cb071f135e$var$constants;
function $1de2e9cb071f135e$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("hnPwu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ca7c8d079e4e5912$var$number;
function $ca7c8d079e4e5912$var$number(x) {
    return +x;
}

});


parcelRegister("dwtsH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d851e0fa1c8af25$var$tickFormat;

var $chaAX = parcelRequire("chaAX");

var $1zo3b = parcelRequire("1zo3b");
function $9d851e0fa1c8af25$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $chaAX.tickStep)(start, stop, count), precision;
    specifier = (0, $1zo3b.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $1zo3b.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $1zo3b.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $1zo3b.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $1zo3b.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $1zo3b.format)(specifier);
}

});
parcelRegister("1zo3b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $124bb7342d7d423a$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $124bb7342d7d423a$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $124bb7342d7d423a$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $124bb7342d7d423a$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $124bb7342d7d423a$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $124bb7342d7d423a$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $124bb7342d7d423a$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $124bb7342d7d423a$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $124bb7342d7d423a$var$_precisionRound.default;
    }
});

var $124bb7342d7d423a$var$_defaultLocale = $124bb7342d7d423a$var$_interopRequireWildcard((parcelRequire("h7YCe")));

var $124bb7342d7d423a$var$_locale = $124bb7342d7d423a$var$_interopRequireDefault((parcelRequire("etcos")));

var $124bb7342d7d423a$var$_formatSpecifier = $124bb7342d7d423a$var$_interopRequireWildcard((parcelRequire("3VJIv")));

var $124bb7342d7d423a$var$_precisionFixed = $124bb7342d7d423a$var$_interopRequireDefault((parcelRequire("OvB9i")));

var $124bb7342d7d423a$var$_precisionPrefix = $124bb7342d7d423a$var$_interopRequireDefault((parcelRequire("fT4fT")));

var $124bb7342d7d423a$var$_precisionRound = $124bb7342d7d423a$var$_interopRequireDefault((parcelRequire("lUrAv")));
function $124bb7342d7d423a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $124bb7342d7d423a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($124bb7342d7d423a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $124bb7342d7d423a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $124bb7342d7d423a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("h7YCe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7821c1974e49777$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $c7821c1974e49777$var$_locale = $c7821c1974e49777$var$_interopRequireDefault((parcelRequire("etcos")));
function $c7821c1974e49777$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c7821c1974e49777$var$locale;
var $c7821c1974e49777$var$format;
module.exports.format = $c7821c1974e49777$var$format;
var $c7821c1974e49777$var$formatPrefix;
module.exports.formatPrefix = $c7821c1974e49777$var$formatPrefix;
$c7821c1974e49777$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $c7821c1974e49777$var$defaultLocale(definition) {
    $c7821c1974e49777$var$locale = (0, $c7821c1974e49777$var$_locale.default)(definition);
    module.exports.format = $c7821c1974e49777$var$format = $c7821c1974e49777$var$locale.format;
    module.exports.formatPrefix = $c7821c1974e49777$var$formatPrefix = $c7821c1974e49777$var$locale.formatPrefix;
    return $c7821c1974e49777$var$locale;
}

});
parcelRegister("etcos", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a88d6339e9bfccf0$var$_default;

var $a88d6339e9bfccf0$var$_exponent = $a88d6339e9bfccf0$var$_interopRequireDefault((parcelRequire("bYmBo")));

var $a88d6339e9bfccf0$var$_formatGroup = $a88d6339e9bfccf0$var$_interopRequireDefault((parcelRequire("3FIRu")));

var $a88d6339e9bfccf0$var$_formatNumerals = $a88d6339e9bfccf0$var$_interopRequireDefault((parcelRequire("eEo2n")));

var $a88d6339e9bfccf0$var$_formatSpecifier = $a88d6339e9bfccf0$var$_interopRequireDefault((parcelRequire("3VJIv")));

var $a88d6339e9bfccf0$var$_formatTrim = $a88d6339e9bfccf0$var$_interopRequireDefault((parcelRequire("aGIMA")));

var $a88d6339e9bfccf0$var$_formatTypes = $a88d6339e9bfccf0$var$_interopRequireDefault((parcelRequire("cgm3U")));

var $3bGK0 = parcelRequire("3bGK0");

var $a88d6339e9bfccf0$var$_identity = $a88d6339e9bfccf0$var$_interopRequireDefault((parcelRequire("9JxFK")));
function $a88d6339e9bfccf0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a88d6339e9bfccf0$var$map = Array.prototype.map, $a88d6339e9bfccf0$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $a88d6339e9bfccf0$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $a88d6339e9bfccf0$var$_identity.default : (0, $a88d6339e9bfccf0$var$_formatGroup.default)($a88d6339e9bfccf0$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $a88d6339e9bfccf0$var$_identity.default : (0, $a88d6339e9bfccf0$var$_formatNumerals.default)($a88d6339e9bfccf0$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $a88d6339e9bfccf0$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$a88d6339e9bfccf0$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $a88d6339e9bfccf0$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $a88d6339e9bfccf0$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $a88d6339e9bfccf0$var$prefixes[8 + $3bGK0.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $a88d6339e9bfccf0$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $a88d6339e9bfccf0$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $a88d6339e9bfccf0$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("bYmBo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b76d49e31721ee1$var$_default;

var $16zf3 = parcelRequire("16zf3");
function $8b76d49e31721ee1$var$_default(x) {
    return x = (0, $16zf3.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("16zf3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0ce1b0430b1147e5$var$_default;
module.exports.formatDecimalParts = $0ce1b0430b1147e5$var$formatDecimalParts;
function $0ce1b0430b1147e5$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $0ce1b0430b1147e5$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("3FIRu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ac8000b2e76bb4b$var$_default;
function $2ac8000b2e76bb4b$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("eEo2n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aaa7726f4d1a4ca3$var$_default;
function $aaa7726f4d1a4ca3$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("3VJIv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $2dca285e6111ffd2$var$FormatSpecifier;
module.exports.default = $2dca285e6111ffd2$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $2dca285e6111ffd2$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $2dca285e6111ffd2$var$formatSpecifier(specifier) {
    if (!(match = $2dca285e6111ffd2$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $2dca285e6111ffd2$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$2dca285e6111ffd2$var$formatSpecifier.prototype = $2dca285e6111ffd2$var$FormatSpecifier.prototype; // instanceof
function $2dca285e6111ffd2$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$2dca285e6111ffd2$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("aGIMA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c8090860e7e02de$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $7c8090860e7e02de$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("cgm3U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ed817bbf22bbd8f$var$_formatDecimal = $8ed817bbf22bbd8f$var$_interopRequireDefault((parcelRequire("16zf3")));

var $8ed817bbf22bbd8f$var$_formatPrefixAuto = $8ed817bbf22bbd8f$var$_interopRequireDefault((parcelRequire("3bGK0")));

var $8ed817bbf22bbd8f$var$_formatRounded = $8ed817bbf22bbd8f$var$_interopRequireDefault((parcelRequire("jD7Ti")));
function $8ed817bbf22bbd8f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8ed817bbf22bbd8f$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $8ed817bbf22bbd8f$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $8ed817bbf22bbd8f$var$_formatRounded.default)(x * 100, p),
    "r": $8ed817bbf22bbd8f$var$_formatRounded.default,
    "s": $8ed817bbf22bbd8f$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $8ed817bbf22bbd8f$var$_default;

});
parcelRegister("3bGK0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25238da952657c8c$var$_default;
module.exports.prefixExponent = void 0;

var $16zf3 = parcelRequire("16zf3");
var $25238da952657c8c$var$prefixExponent;
module.exports.prefixExponent = $25238da952657c8c$var$prefixExponent;
function $25238da952657c8c$var$_default(x, p) {
    var d = (0, $16zf3.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $25238da952657c8c$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $16zf3.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("jD7Ti", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4a7c7c94a4590d6$var$_default;

var $16zf3 = parcelRequire("16zf3");
function $e4a7c7c94a4590d6$var$_default(x, p) {
    var d = (0, $16zf3.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("9JxFK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71626fa931300825$var$_default;
function $71626fa931300825$var$_default(x) {
    return x;
}

});



parcelRegister("OvB9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $097d2e5db07914bf$var$_default;

var $097d2e5db07914bf$var$_exponent = $097d2e5db07914bf$var$_interopRequireDefault((parcelRequire("bYmBo")));
function $097d2e5db07914bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $097d2e5db07914bf$var$_default(step) {
    return Math.max(0, -(0, $097d2e5db07914bf$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("fT4fT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b90f4b1683546974$var$_default;

var $b90f4b1683546974$var$_exponent = $b90f4b1683546974$var$_interopRequireDefault((parcelRequire("bYmBo")));
function $b90f4b1683546974$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b90f4b1683546974$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $b90f4b1683546974$var$_exponent.default)(value) / 3))) * 3 - (0, $b90f4b1683546974$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("lUrAv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ff343a493fa803fc$var$_default;

var $ff343a493fa803fc$var$_exponent = $ff343a493fa803fc$var$_interopRequireDefault((parcelRequire("bYmBo")));
function $ff343a493fa803fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ff343a493fa803fc$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $ff343a493fa803fc$var$_exponent.default)(max) - (0, $ff343a493fa803fc$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("2OQ0i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $20d89726013475eb$var$log;
module.exports.loggish = $20d89726013475eb$var$loggish;

var $chaAX = parcelRequire("chaAX");

var $1zo3b = parcelRequire("1zo3b");

var $20d89726013475eb$var$_nice = $20d89726013475eb$var$_interopRequireDefault((parcelRequire("9UZEH")));

var $jvFbg = parcelRequire("jvFbg");

var $1UgJT = parcelRequire("1UgJT");
function $20d89726013475eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $20d89726013475eb$var$transformLog(x) {
    return Math.log(x);
}
function $20d89726013475eb$var$transformExp(x) {
    return Math.exp(x);
}
function $20d89726013475eb$var$transformLogn(x) {
    return -Math.log(-x);
}
function $20d89726013475eb$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $20d89726013475eb$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $20d89726013475eb$var$powp(base) {
    return base === 10 ? $20d89726013475eb$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $20d89726013475eb$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $20d89726013475eb$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $20d89726013475eb$var$loggish(transform) {
    const scale = transform($20d89726013475eb$var$transformLog, $20d89726013475eb$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $20d89726013475eb$var$logp(base), pows = $20d89726013475eb$var$powp(base);
        if (domain()[0] < 0) {
            logs = $20d89726013475eb$var$reflect(logs), pows = $20d89726013475eb$var$reflect(pows);
            transform($20d89726013475eb$var$transformLogn, $20d89726013475eb$var$transformExpn);
        } else transform($20d89726013475eb$var$transformLog, $20d89726013475eb$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $chaAX.ticks)(u, v, n);
        } else z = (0, $chaAX.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $1zo3b.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $1zo3b.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $20d89726013475eb$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $20d89726013475eb$var$log() {
    const scale = $20d89726013475eb$var$loggish((0, $jvFbg.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $jvFbg.copy)(scale, $20d89726013475eb$var$log()).base(scale.base());
    $1UgJT.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("9UZEH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73892b8764031363$var$nice;
function $73892b8764031363$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("hd7e5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c879419079cacc49$var$symlog;
module.exports.symlogish = $c879419079cacc49$var$symlogish;

var $6sFEr = parcelRequire("6sFEr");

var $jvFbg = parcelRequire("jvFbg");

var $1UgJT = parcelRequire("1UgJT");
function $c879419079cacc49$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $c879419079cacc49$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $c879419079cacc49$var$symlogish(transform) {
    var c = 1, scale = transform($c879419079cacc49$var$transformSymlog(c), $c879419079cacc49$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($c879419079cacc49$var$transformSymlog(c = +_), $c879419079cacc49$var$transformSymexp(c)) : c;
    };
    return (0, $6sFEr.linearish)(scale);
}
function $c879419079cacc49$var$symlog() {
    var scale = $c879419079cacc49$var$symlogish((0, $jvFbg.transformer)());
    scale.copy = function() {
        return (0, $jvFbg.copy)(scale, $c879419079cacc49$var$symlog()).constant(scale.constant());
    };
    return $1UgJT.initRange.apply(scale, arguments);
}

});

parcelRegister("kc2iA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eb36b621d9049230$var$pow;
module.exports.powish = $eb36b621d9049230$var$powish;
module.exports.sqrt = $eb36b621d9049230$var$sqrt;

var $6sFEr = parcelRequire("6sFEr");

var $jvFbg = parcelRequire("jvFbg");

var $1UgJT = parcelRequire("1UgJT");
function $eb36b621d9049230$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $eb36b621d9049230$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $eb36b621d9049230$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $eb36b621d9049230$var$powish(transform) {
    var scale = transform($jvFbg.identity, $jvFbg.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($jvFbg.identity, $jvFbg.identity) : exponent === 0.5 ? transform($eb36b621d9049230$var$transformSqrt, $eb36b621d9049230$var$transformSquare) : transform($eb36b621d9049230$var$transformPow(exponent), $eb36b621d9049230$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $6sFEr.linearish)(scale);
}
function $eb36b621d9049230$var$pow() {
    var scale = $eb36b621d9049230$var$powish((0, $jvFbg.transformer)());
    scale.copy = function() {
        return (0, $jvFbg.copy)(scale, $eb36b621d9049230$var$pow()).exponent(scale.exponent());
    };
    $1UgJT.initRange.apply(scale, arguments);
    return scale;
}
function $eb36b621d9049230$var$sqrt() {
    return $eb36b621d9049230$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("hoOp3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $caabc694be17e738$var$radial;

var $caabc694be17e738$var$_continuous = $caabc694be17e738$var$_interopRequireDefault((parcelRequire("jvFbg")));

var $1UgJT = parcelRequire("1UgJT");

var $6sFEr = parcelRequire("6sFEr");

var $caabc694be17e738$var$_number = $caabc694be17e738$var$_interopRequireDefault((parcelRequire("hnPwu")));
function $caabc694be17e738$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $caabc694be17e738$var$square(x) {
    return Math.sign(x) * x * x;
}
function $caabc694be17e738$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $caabc694be17e738$var$radial() {
    var squared = (0, $caabc694be17e738$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $caabc694be17e738$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($caabc694be17e738$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $caabc694be17e738$var$_number.default)).map($caabc694be17e738$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $caabc694be17e738$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $1UgJT.initRange.apply(scale, arguments);
    return (0, $6sFEr.linearish)(scale);
}

});

parcelRegister("e5wNt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a41af91e7d21b483$var$quantile;

var $chaAX = parcelRequire("chaAX");

var $1UgJT = parcelRequire("1UgJT");
function $a41af91e7d21b483$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $chaAX.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $chaAX.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($chaAX.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $a41af91e7d21b483$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $1UgJT.initRange.apply(scale, arguments);
}

});

parcelRegister("lPC0x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fe4bd7ecf0547f22$var$quantize;

var $chaAX = parcelRequire("chaAX");

var $6sFEr = parcelRequire("6sFEr");

var $1UgJT = parcelRequire("1UgJT");
function $fe4bd7ecf0547f22$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $chaAX.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $fe4bd7ecf0547f22$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $1UgJT.initRange.apply((0, $6sFEr.linearish)(scale), arguments);
}

});

parcelRegister("5fycC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d28e264c4c84a58$var$threshold;

var $chaAX = parcelRequire("chaAX");

var $1UgJT = parcelRequire("1UgJT");
function $3d28e264c4c84a58$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $chaAX.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $3d28e264c4c84a58$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $1UgJT.initRange.apply(scale, arguments);
}

});

parcelRegister("3MAjg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $2c12052311d3d656$var$calendar;
module.exports.default = $2c12052311d3d656$var$time;

var $2XneA = parcelRequire("2XneA");

var $9D68L = parcelRequire("9D68L");

var $2c12052311d3d656$var$_continuous = $2c12052311d3d656$var$_interopRequireWildcard((parcelRequire("jvFbg")));

var $1UgJT = parcelRequire("1UgJT");

var $2c12052311d3d656$var$_nice = $2c12052311d3d656$var$_interopRequireDefault((parcelRequire("9UZEH")));
function $2c12052311d3d656$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2c12052311d3d656$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2c12052311d3d656$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2c12052311d3d656$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2c12052311d3d656$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2c12052311d3d656$var$date(t) {
    return new Date(t);
}
function $2c12052311d3d656$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $2c12052311d3d656$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $2c12052311d3d656$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $2c12052311d3d656$var$number)) : domain().map($2c12052311d3d656$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $2c12052311d3d656$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $2c12052311d3d656$var$_continuous.copy)(scale, $2c12052311d3d656$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $2c12052311d3d656$var$time() {
    return $1UgJT.initRange.apply($2c12052311d3d656$var$calendar($2XneA.timeTicks, $2XneA.timeTickInterval, $2XneA.timeYear, $2XneA.timeMonth, $2XneA.timeWeek, $2XneA.timeDay, $2XneA.timeHour, $2XneA.timeMinute, $2XneA.timeSecond, $9D68L.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("2XneA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $bb8aC.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $bb8aC.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $bb8aC.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $bb8aC.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $bb8aC.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $bb8aC.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $bb8aC.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $bb8aC.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $bb8aC.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $bb8aC.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $9sep5.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $9sep5.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $bb8aC.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $bb8aC.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $bb8aC.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $bb8aC.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $bb8aC.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $bb8aC.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $9sep5.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $9sep5.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $lvUZK.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $22731d5218001335$var$_utcYear.utcYears;
    }
});

var $22731d5218001335$var$_interval = $22731d5218001335$var$_interopRequireDefault((parcelRequire("gdn9X")));

var $22731d5218001335$var$_millisecond = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("9DFrW")));

var $22731d5218001335$var$_second = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("eKbdP")));

var $22731d5218001335$var$_minute = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("a9tGd")));

var $22731d5218001335$var$_hour = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("kbqBL")));

var $22731d5218001335$var$_day = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("bQQ6Z")));

var $bb8aC = parcelRequire("bb8aC");

var $22731d5218001335$var$_month = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("cMPrb")));

var $22731d5218001335$var$_year = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("iibFl")));

var $22731d5218001335$var$_utcMinute = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("2N5Fo")));

var $22731d5218001335$var$_utcHour = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("gJCFF")));

var $22731d5218001335$var$_utcDay = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("fQ352")));

var $lvUZK = parcelRequire("lvUZK");

var $22731d5218001335$var$_utcMonth = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("gf2Sp")));

var $22731d5218001335$var$_utcYear = $22731d5218001335$var$_interopRequireWildcard((parcelRequire("f6L2n")));

var $9sep5 = parcelRequire("9sep5");
function $22731d5218001335$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($22731d5218001335$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $22731d5218001335$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $22731d5218001335$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $22731d5218001335$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("gdn9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bcdfd3423b3773a7$var$newInterval;
var $bcdfd3423b3773a7$var$t0 = new Date(), $bcdfd3423b3773a7$var$t1 = new Date();
function $bcdfd3423b3773a7$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $bcdfd3423b3773a7$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $bcdfd3423b3773a7$var$t0.setTime(+start), $bcdfd3423b3773a7$var$t1.setTime(+end);
            floori($bcdfd3423b3773a7$var$t0), floori($bcdfd3423b3773a7$var$t1);
            return Math.floor(count($bcdfd3423b3773a7$var$t0, $bcdfd3423b3773a7$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("9DFrW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $7047e8a012399ea5$var$_interval = $7047e8a012399ea5$var$_interopRequireDefault((parcelRequire("gdn9X")));
function $7047e8a012399ea5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7047e8a012399ea5$var$millisecond = (0, $7047e8a012399ea5$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$7047e8a012399ea5$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $7047e8a012399ea5$var$millisecond;
    return (0, $7047e8a012399ea5$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $7047e8a012399ea5$var$_default = $7047e8a012399ea5$var$millisecond;
module.exports.default = $7047e8a012399ea5$var$_default;
var $7047e8a012399ea5$var$milliseconds = $7047e8a012399ea5$var$millisecond.range;
module.exports.milliseconds = $7047e8a012399ea5$var$milliseconds;

});

parcelRegister("eKbdP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $abbe110d40595633$var$_interval = $abbe110d40595633$var$_interopRequireDefault((parcelRequire("gdn9X")));

var $30HDJ = parcelRequire("30HDJ");
function $abbe110d40595633$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $abbe110d40595633$var$second = (0, $abbe110d40595633$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $30HDJ.durationSecond);
}, function(start, end) {
    return (end - start) / $30HDJ.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $abbe110d40595633$var$_default = $abbe110d40595633$var$second;
module.exports.default = $abbe110d40595633$var$_default;
var $abbe110d40595633$var$seconds = $abbe110d40595633$var$second.range;
module.exports.seconds = $abbe110d40595633$var$seconds;

});
parcelRegister("30HDJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $231339224d5bf7f0$var$durationSecond = 1000;
module.exports.durationSecond = $231339224d5bf7f0$var$durationSecond;
const $231339224d5bf7f0$var$durationMinute = $231339224d5bf7f0$var$durationSecond * 60;
module.exports.durationMinute = $231339224d5bf7f0$var$durationMinute;
const $231339224d5bf7f0$var$durationHour = $231339224d5bf7f0$var$durationMinute * 60;
module.exports.durationHour = $231339224d5bf7f0$var$durationHour;
const $231339224d5bf7f0$var$durationDay = $231339224d5bf7f0$var$durationHour * 24;
module.exports.durationDay = $231339224d5bf7f0$var$durationDay;
const $231339224d5bf7f0$var$durationWeek = $231339224d5bf7f0$var$durationDay * 7;
module.exports.durationWeek = $231339224d5bf7f0$var$durationWeek;
const $231339224d5bf7f0$var$durationMonth = $231339224d5bf7f0$var$durationDay * 30;
module.exports.durationMonth = $231339224d5bf7f0$var$durationMonth;
const $231339224d5bf7f0$var$durationYear = $231339224d5bf7f0$var$durationDay * 365;
module.exports.durationYear = $231339224d5bf7f0$var$durationYear;

});


parcelRegister("a9tGd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $7641c4743e5f4261$var$_interval = $7641c4743e5f4261$var$_interopRequireDefault((parcelRequire("gdn9X")));

var $30HDJ = parcelRequire("30HDJ");
function $7641c4743e5f4261$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7641c4743e5f4261$var$minute = (0, $7641c4743e5f4261$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $30HDJ.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $30HDJ.durationMinute);
}, function(start, end) {
    return (end - start) / $30HDJ.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $7641c4743e5f4261$var$_default = $7641c4743e5f4261$var$minute;
module.exports.default = $7641c4743e5f4261$var$_default;
var $7641c4743e5f4261$var$minutes = $7641c4743e5f4261$var$minute.range;
module.exports.minutes = $7641c4743e5f4261$var$minutes;

});

parcelRegister("kbqBL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $eb197986c8e7c156$var$_interval = $eb197986c8e7c156$var$_interopRequireDefault((parcelRequire("gdn9X")));

var $30HDJ = parcelRequire("30HDJ");
function $eb197986c8e7c156$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $eb197986c8e7c156$var$hour = (0, $eb197986c8e7c156$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $30HDJ.durationSecond - date.getMinutes() * $30HDJ.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $30HDJ.durationHour);
}, function(start, end) {
    return (end - start) / $30HDJ.durationHour;
}, function(date) {
    return date.getHours();
});
var $eb197986c8e7c156$var$_default = $eb197986c8e7c156$var$hour;
module.exports.default = $eb197986c8e7c156$var$_default;
var $eb197986c8e7c156$var$hours = $eb197986c8e7c156$var$hour.range;
module.exports.hours = $eb197986c8e7c156$var$hours;

});

parcelRegister("bQQ6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $8a0cf95be21c0496$var$_interval = $8a0cf95be21c0496$var$_interopRequireDefault((parcelRequire("gdn9X")));

var $30HDJ = parcelRequire("30HDJ");
function $8a0cf95be21c0496$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8a0cf95be21c0496$var$day = (0, $8a0cf95be21c0496$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $30HDJ.durationMinute) / $30HDJ.durationDay, (date)=>date.getDate() - 1);
var $8a0cf95be21c0496$var$_default = $8a0cf95be21c0496$var$day;
module.exports.default = $8a0cf95be21c0496$var$_default;
var $8a0cf95be21c0496$var$days = $8a0cf95be21c0496$var$day.range;
module.exports.days = $8a0cf95be21c0496$var$days;

});

parcelRegister("bb8aC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $82370f3c801342df$var$_interval = $82370f3c801342df$var$_interopRequireDefault((parcelRequire("gdn9X")));

var $30HDJ = parcelRequire("30HDJ");
function $82370f3c801342df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $82370f3c801342df$var$weekday(i) {
    return (0, $82370f3c801342df$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $30HDJ.durationMinute) / $30HDJ.durationWeek;
    });
}
var $82370f3c801342df$var$sunday = $82370f3c801342df$var$weekday(0);
module.exports.sunday = $82370f3c801342df$var$sunday;
var $82370f3c801342df$var$monday = $82370f3c801342df$var$weekday(1);
module.exports.monday = $82370f3c801342df$var$monday;
var $82370f3c801342df$var$tuesday = $82370f3c801342df$var$weekday(2);
module.exports.tuesday = $82370f3c801342df$var$tuesday;
var $82370f3c801342df$var$wednesday = $82370f3c801342df$var$weekday(3);
module.exports.wednesday = $82370f3c801342df$var$wednesday;
var $82370f3c801342df$var$thursday = $82370f3c801342df$var$weekday(4);
module.exports.thursday = $82370f3c801342df$var$thursday;
var $82370f3c801342df$var$friday = $82370f3c801342df$var$weekday(5);
module.exports.friday = $82370f3c801342df$var$friday;
var $82370f3c801342df$var$saturday = $82370f3c801342df$var$weekday(6);
module.exports.saturday = $82370f3c801342df$var$saturday;
var $82370f3c801342df$var$sundays = $82370f3c801342df$var$sunday.range;
module.exports.sundays = $82370f3c801342df$var$sundays;
var $82370f3c801342df$var$mondays = $82370f3c801342df$var$monday.range;
module.exports.mondays = $82370f3c801342df$var$mondays;
var $82370f3c801342df$var$tuesdays = $82370f3c801342df$var$tuesday.range;
module.exports.tuesdays = $82370f3c801342df$var$tuesdays;
var $82370f3c801342df$var$wednesdays = $82370f3c801342df$var$wednesday.range;
module.exports.wednesdays = $82370f3c801342df$var$wednesdays;
var $82370f3c801342df$var$thursdays = $82370f3c801342df$var$thursday.range;
module.exports.thursdays = $82370f3c801342df$var$thursdays;
var $82370f3c801342df$var$fridays = $82370f3c801342df$var$friday.range;
module.exports.fridays = $82370f3c801342df$var$fridays;
var $82370f3c801342df$var$saturdays = $82370f3c801342df$var$saturday.range;
module.exports.saturdays = $82370f3c801342df$var$saturdays;

});

parcelRegister("cMPrb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $94f1de233d21a885$var$_interval = $94f1de233d21a885$var$_interopRequireDefault((parcelRequire("gdn9X")));
function $94f1de233d21a885$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $94f1de233d21a885$var$month = (0, $94f1de233d21a885$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $94f1de233d21a885$var$_default = $94f1de233d21a885$var$month;
module.exports.default = $94f1de233d21a885$var$_default;
var $94f1de233d21a885$var$months = $94f1de233d21a885$var$month.range;
module.exports.months = $94f1de233d21a885$var$months;

});

parcelRegister("iibFl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $d512f504f9763331$var$_interval = $d512f504f9763331$var$_interopRequireDefault((parcelRequire("gdn9X")));
function $d512f504f9763331$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d512f504f9763331$var$year = (0, $d512f504f9763331$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$d512f504f9763331$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $d512f504f9763331$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $d512f504f9763331$var$_default = $d512f504f9763331$var$year;
module.exports.default = $d512f504f9763331$var$_default;
var $d512f504f9763331$var$years = $d512f504f9763331$var$year.range;
module.exports.years = $d512f504f9763331$var$years;

});

parcelRegister("2N5Fo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $20848da7ce555cf2$var$_interval = $20848da7ce555cf2$var$_interopRequireDefault((parcelRequire("gdn9X")));

var $30HDJ = parcelRequire("30HDJ");
function $20848da7ce555cf2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $20848da7ce555cf2$var$utcMinute = (0, $20848da7ce555cf2$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $30HDJ.durationMinute);
}, function(start, end) {
    return (end - start) / $30HDJ.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $20848da7ce555cf2$var$_default = $20848da7ce555cf2$var$utcMinute;
module.exports.default = $20848da7ce555cf2$var$_default;
var $20848da7ce555cf2$var$utcMinutes = $20848da7ce555cf2$var$utcMinute.range;
module.exports.utcMinutes = $20848da7ce555cf2$var$utcMinutes;

});

parcelRegister("gJCFF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $c2eed892a4edbe4a$var$_interval = $c2eed892a4edbe4a$var$_interopRequireDefault((parcelRequire("gdn9X")));

var $30HDJ = parcelRequire("30HDJ");
function $c2eed892a4edbe4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c2eed892a4edbe4a$var$utcHour = (0, $c2eed892a4edbe4a$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $30HDJ.durationHour);
}, function(start, end) {
    return (end - start) / $30HDJ.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $c2eed892a4edbe4a$var$_default = $c2eed892a4edbe4a$var$utcHour;
module.exports.default = $c2eed892a4edbe4a$var$_default;
var $c2eed892a4edbe4a$var$utcHours = $c2eed892a4edbe4a$var$utcHour.range;
module.exports.utcHours = $c2eed892a4edbe4a$var$utcHours;

});

parcelRegister("fQ352", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $b87e1a06c5c95b6d$var$_interval = $b87e1a06c5c95b6d$var$_interopRequireDefault((parcelRequire("gdn9X")));

var $30HDJ = parcelRequire("30HDJ");
function $b87e1a06c5c95b6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b87e1a06c5c95b6d$var$utcDay = (0, $b87e1a06c5c95b6d$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $30HDJ.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $b87e1a06c5c95b6d$var$_default = $b87e1a06c5c95b6d$var$utcDay;
module.exports.default = $b87e1a06c5c95b6d$var$_default;
var $b87e1a06c5c95b6d$var$utcDays = $b87e1a06c5c95b6d$var$utcDay.range;
module.exports.utcDays = $b87e1a06c5c95b6d$var$utcDays;

});

parcelRegister("lvUZK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $fa98b438ec88fc9a$var$_interval = $fa98b438ec88fc9a$var$_interopRequireDefault((parcelRequire("gdn9X")));

var $30HDJ = parcelRequire("30HDJ");
function $fa98b438ec88fc9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fa98b438ec88fc9a$var$utcWeekday(i) {
    return (0, $fa98b438ec88fc9a$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $30HDJ.durationWeek;
    });
}
var $fa98b438ec88fc9a$var$utcSunday = $fa98b438ec88fc9a$var$utcWeekday(0);
module.exports.utcSunday = $fa98b438ec88fc9a$var$utcSunday;
var $fa98b438ec88fc9a$var$utcMonday = $fa98b438ec88fc9a$var$utcWeekday(1);
module.exports.utcMonday = $fa98b438ec88fc9a$var$utcMonday;
var $fa98b438ec88fc9a$var$utcTuesday = $fa98b438ec88fc9a$var$utcWeekday(2);
module.exports.utcTuesday = $fa98b438ec88fc9a$var$utcTuesday;
var $fa98b438ec88fc9a$var$utcWednesday = $fa98b438ec88fc9a$var$utcWeekday(3);
module.exports.utcWednesday = $fa98b438ec88fc9a$var$utcWednesday;
var $fa98b438ec88fc9a$var$utcThursday = $fa98b438ec88fc9a$var$utcWeekday(4);
module.exports.utcThursday = $fa98b438ec88fc9a$var$utcThursday;
var $fa98b438ec88fc9a$var$utcFriday = $fa98b438ec88fc9a$var$utcWeekday(5);
module.exports.utcFriday = $fa98b438ec88fc9a$var$utcFriday;
var $fa98b438ec88fc9a$var$utcSaturday = $fa98b438ec88fc9a$var$utcWeekday(6);
module.exports.utcSaturday = $fa98b438ec88fc9a$var$utcSaturday;
var $fa98b438ec88fc9a$var$utcSundays = $fa98b438ec88fc9a$var$utcSunday.range;
module.exports.utcSundays = $fa98b438ec88fc9a$var$utcSundays;
var $fa98b438ec88fc9a$var$utcMondays = $fa98b438ec88fc9a$var$utcMonday.range;
module.exports.utcMondays = $fa98b438ec88fc9a$var$utcMondays;
var $fa98b438ec88fc9a$var$utcTuesdays = $fa98b438ec88fc9a$var$utcTuesday.range;
module.exports.utcTuesdays = $fa98b438ec88fc9a$var$utcTuesdays;
var $fa98b438ec88fc9a$var$utcWednesdays = $fa98b438ec88fc9a$var$utcWednesday.range;
module.exports.utcWednesdays = $fa98b438ec88fc9a$var$utcWednesdays;
var $fa98b438ec88fc9a$var$utcThursdays = $fa98b438ec88fc9a$var$utcThursday.range;
module.exports.utcThursdays = $fa98b438ec88fc9a$var$utcThursdays;
var $fa98b438ec88fc9a$var$utcFridays = $fa98b438ec88fc9a$var$utcFriday.range;
module.exports.utcFridays = $fa98b438ec88fc9a$var$utcFridays;
var $fa98b438ec88fc9a$var$utcSaturdays = $fa98b438ec88fc9a$var$utcSaturday.range;
module.exports.utcSaturdays = $fa98b438ec88fc9a$var$utcSaturdays;

});

parcelRegister("gf2Sp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $bd304742e1ae377b$var$_interval = $bd304742e1ae377b$var$_interopRequireDefault((parcelRequire("gdn9X")));
function $bd304742e1ae377b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bd304742e1ae377b$var$utcMonth = (0, $bd304742e1ae377b$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $bd304742e1ae377b$var$_default = $bd304742e1ae377b$var$utcMonth;
module.exports.default = $bd304742e1ae377b$var$_default;
var $bd304742e1ae377b$var$utcMonths = $bd304742e1ae377b$var$utcMonth.range;
module.exports.utcMonths = $bd304742e1ae377b$var$utcMonths;

});

parcelRegister("f6L2n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $affbe72c900c5e82$var$_interval = $affbe72c900c5e82$var$_interopRequireDefault((parcelRequire("gdn9X")));
function $affbe72c900c5e82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $affbe72c900c5e82$var$utcYear = (0, $affbe72c900c5e82$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$affbe72c900c5e82$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $affbe72c900c5e82$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $affbe72c900c5e82$var$_default = $affbe72c900c5e82$var$utcYear;
module.exports.default = $affbe72c900c5e82$var$_default;
var $affbe72c900c5e82$var$utcYears = $affbe72c900c5e82$var$utcYear.range;
module.exports.utcYears = $affbe72c900c5e82$var$utcYears;

});

parcelRegister("9sep5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $chaAX = parcelRequire("chaAX");

var $30HDJ = parcelRequire("30HDJ");

var $6e21e6d9e2e7409d$var$_millisecond = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("9DFrW")));

var $6e21e6d9e2e7409d$var$_second = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("eKbdP")));

var $6e21e6d9e2e7409d$var$_minute = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("a9tGd")));

var $6e21e6d9e2e7409d$var$_hour = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("kbqBL")));

var $6e21e6d9e2e7409d$var$_day = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("bQQ6Z")));

var $bb8aC = parcelRequire("bb8aC");

var $6e21e6d9e2e7409d$var$_month = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("cMPrb")));

var $6e21e6d9e2e7409d$var$_year = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("iibFl")));

var $6e21e6d9e2e7409d$var$_utcMinute = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("2N5Fo")));

var $6e21e6d9e2e7409d$var$_utcHour = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("gJCFF")));

var $6e21e6d9e2e7409d$var$_utcDay = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("fQ352")));

var $lvUZK = parcelRequire("lvUZK");

var $6e21e6d9e2e7409d$var$_utcMonth = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("gf2Sp")));

var $6e21e6d9e2e7409d$var$_utcYear = $6e21e6d9e2e7409d$var$_interopRequireDefault((parcelRequire("f6L2n")));
function $6e21e6d9e2e7409d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6e21e6d9e2e7409d$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $6e21e6d9e2e7409d$var$_second.default,
            1,
            $30HDJ.durationSecond
        ],
        [
            $6e21e6d9e2e7409d$var$_second.default,
            5,
            5 * $30HDJ.durationSecond
        ],
        [
            $6e21e6d9e2e7409d$var$_second.default,
            15,
            15 * $30HDJ.durationSecond
        ],
        [
            $6e21e6d9e2e7409d$var$_second.default,
            30,
            30 * $30HDJ.durationSecond
        ],
        [
            minute,
            1,
            $30HDJ.durationMinute
        ],
        [
            minute,
            5,
            5 * $30HDJ.durationMinute
        ],
        [
            minute,
            15,
            15 * $30HDJ.durationMinute
        ],
        [
            minute,
            30,
            30 * $30HDJ.durationMinute
        ],
        [
            hour,
            1,
            $30HDJ.durationHour
        ],
        [
            hour,
            3,
            3 * $30HDJ.durationHour
        ],
        [
            hour,
            6,
            6 * $30HDJ.durationHour
        ],
        [
            hour,
            12,
            12 * $30HDJ.durationHour
        ],
        [
            day,
            1,
            $30HDJ.durationDay
        ],
        [
            day,
            2,
            2 * $30HDJ.durationDay
        ],
        [
            week,
            1,
            $30HDJ.durationWeek
        ],
        [
            month,
            1,
            $30HDJ.durationMonth
        ],
        [
            month,
            3,
            3 * $30HDJ.durationMonth
        ],
        [
            year,
            1,
            $30HDJ.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $chaAX.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $chaAX.tickStep)(start / $30HDJ.durationYear, stop / $30HDJ.durationYear, count));
        if (i === 0) return $6e21e6d9e2e7409d$var$_millisecond.default.every(Math.max((0, $chaAX.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$6e21e6d9e2e7409d$var$utcTicks, $6e21e6d9e2e7409d$var$utcTickInterval] = $6e21e6d9e2e7409d$var$ticker($6e21e6d9e2e7409d$var$_utcYear.default, $6e21e6d9e2e7409d$var$_utcMonth.default, $lvUZK.utcSunday, $6e21e6d9e2e7409d$var$_utcDay.default, $6e21e6d9e2e7409d$var$_utcHour.default, $6e21e6d9e2e7409d$var$_utcMinute.default);
module.exports.utcTickInterval = $6e21e6d9e2e7409d$var$utcTickInterval;
module.exports.utcTicks = $6e21e6d9e2e7409d$var$utcTicks;
const [$6e21e6d9e2e7409d$var$timeTicks, $6e21e6d9e2e7409d$var$timeTickInterval] = $6e21e6d9e2e7409d$var$ticker($6e21e6d9e2e7409d$var$_year.default, $6e21e6d9e2e7409d$var$_month.default, $bb8aC.sunday, $6e21e6d9e2e7409d$var$_day.default, $6e21e6d9e2e7409d$var$_hour.default, $6e21e6d9e2e7409d$var$_minute.default);
module.exports.timeTickInterval = $6e21e6d9e2e7409d$var$timeTickInterval;
module.exports.timeTicks = $6e21e6d9e2e7409d$var$timeTicks;

});


parcelRegister("9D68L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $702c84e9b9927930$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $702c84e9b9927930$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $702c84e9b9927930$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $702c84e9b9927930$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $702c84e9b9927930$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $702c84e9b9927930$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $702c84e9b9927930$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $702c84e9b9927930$var$_defaultLocale.utcParse;
    }
});

var $702c84e9b9927930$var$_defaultLocale = $702c84e9b9927930$var$_interopRequireWildcard((parcelRequire("cys2m")));

var $702c84e9b9927930$var$_locale = $702c84e9b9927930$var$_interopRequireDefault((parcelRequire("2t1Yq")));

var $702c84e9b9927930$var$_isoFormat = $702c84e9b9927930$var$_interopRequireDefault((parcelRequire("2yu8k")));

var $702c84e9b9927930$var$_isoParse = $702c84e9b9927930$var$_interopRequireDefault((parcelRequire("dKACc")));
function $702c84e9b9927930$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $702c84e9b9927930$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($702c84e9b9927930$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $702c84e9b9927930$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $702c84e9b9927930$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("cys2m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $923e6891cc3f0f0f$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $923e6891cc3f0f0f$var$_locale = $923e6891cc3f0f0f$var$_interopRequireDefault((parcelRequire("2t1Yq")));
function $923e6891cc3f0f0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $923e6891cc3f0f0f$var$locale;
var $923e6891cc3f0f0f$var$timeFormat;
module.exports.timeFormat = $923e6891cc3f0f0f$var$timeFormat;
var $923e6891cc3f0f0f$var$timeParse;
module.exports.timeParse = $923e6891cc3f0f0f$var$timeParse;
var $923e6891cc3f0f0f$var$utcFormat;
module.exports.utcFormat = $923e6891cc3f0f0f$var$utcFormat;
var $923e6891cc3f0f0f$var$utcParse;
module.exports.utcParse = $923e6891cc3f0f0f$var$utcParse;
$923e6891cc3f0f0f$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $923e6891cc3f0f0f$var$defaultLocale(definition) {
    $923e6891cc3f0f0f$var$locale = (0, $923e6891cc3f0f0f$var$_locale.default)(definition);
    module.exports.timeFormat = $923e6891cc3f0f0f$var$timeFormat = $923e6891cc3f0f0f$var$locale.format;
    module.exports.timeParse = $923e6891cc3f0f0f$var$timeParse = $923e6891cc3f0f0f$var$locale.parse;
    module.exports.utcFormat = $923e6891cc3f0f0f$var$utcFormat = $923e6891cc3f0f0f$var$locale.utcFormat;
    module.exports.utcParse = $923e6891cc3f0f0f$var$utcParse = $923e6891cc3f0f0f$var$locale.utcParse;
    return $923e6891cc3f0f0f$var$locale;
}

});
parcelRegister("2t1Yq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1cbfd224b19e14cc$var$formatLocale;

var $2XneA = parcelRequire("2XneA");
function $1cbfd224b19e14cc$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $1cbfd224b19e14cc$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $1cbfd224b19e14cc$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $1cbfd224b19e14cc$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $1cbfd224b19e14cc$var$formatRe(locale_periods), periodLookup = $1cbfd224b19e14cc$var$formatLookup(locale_periods), weekdayRe = $1cbfd224b19e14cc$var$formatRe(locale_weekdays), weekdayLookup = $1cbfd224b19e14cc$var$formatLookup(locale_weekdays), shortWeekdayRe = $1cbfd224b19e14cc$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $1cbfd224b19e14cc$var$formatLookup(locale_shortWeekdays), monthRe = $1cbfd224b19e14cc$var$formatRe(locale_months), monthLookup = $1cbfd224b19e14cc$var$formatLookup(locale_months), shortMonthRe = $1cbfd224b19e14cc$var$formatRe(locale_shortMonths), shortMonthLookup = $1cbfd224b19e14cc$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $1cbfd224b19e14cc$var$formatDayOfMonth,
        "e": $1cbfd224b19e14cc$var$formatDayOfMonth,
        "f": $1cbfd224b19e14cc$var$formatMicroseconds,
        "g": $1cbfd224b19e14cc$var$formatYearISO,
        "G": $1cbfd224b19e14cc$var$formatFullYearISO,
        "H": $1cbfd224b19e14cc$var$formatHour24,
        "I": $1cbfd224b19e14cc$var$formatHour12,
        "j": $1cbfd224b19e14cc$var$formatDayOfYear,
        "L": $1cbfd224b19e14cc$var$formatMilliseconds,
        "m": $1cbfd224b19e14cc$var$formatMonthNumber,
        "M": $1cbfd224b19e14cc$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $1cbfd224b19e14cc$var$formatUnixTimestamp,
        "s": $1cbfd224b19e14cc$var$formatUnixTimestampSeconds,
        "S": $1cbfd224b19e14cc$var$formatSeconds,
        "u": $1cbfd224b19e14cc$var$formatWeekdayNumberMonday,
        "U": $1cbfd224b19e14cc$var$formatWeekNumberSunday,
        "V": $1cbfd224b19e14cc$var$formatWeekNumberISO,
        "w": $1cbfd224b19e14cc$var$formatWeekdayNumberSunday,
        "W": $1cbfd224b19e14cc$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $1cbfd224b19e14cc$var$formatYear,
        "Y": $1cbfd224b19e14cc$var$formatFullYear,
        "Z": $1cbfd224b19e14cc$var$formatZone,
        "%": $1cbfd224b19e14cc$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $1cbfd224b19e14cc$var$formatUTCDayOfMonth,
        "e": $1cbfd224b19e14cc$var$formatUTCDayOfMonth,
        "f": $1cbfd224b19e14cc$var$formatUTCMicroseconds,
        "g": $1cbfd224b19e14cc$var$formatUTCYearISO,
        "G": $1cbfd224b19e14cc$var$formatUTCFullYearISO,
        "H": $1cbfd224b19e14cc$var$formatUTCHour24,
        "I": $1cbfd224b19e14cc$var$formatUTCHour12,
        "j": $1cbfd224b19e14cc$var$formatUTCDayOfYear,
        "L": $1cbfd224b19e14cc$var$formatUTCMilliseconds,
        "m": $1cbfd224b19e14cc$var$formatUTCMonthNumber,
        "M": $1cbfd224b19e14cc$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $1cbfd224b19e14cc$var$formatUnixTimestamp,
        "s": $1cbfd224b19e14cc$var$formatUnixTimestampSeconds,
        "S": $1cbfd224b19e14cc$var$formatUTCSeconds,
        "u": $1cbfd224b19e14cc$var$formatUTCWeekdayNumberMonday,
        "U": $1cbfd224b19e14cc$var$formatUTCWeekNumberSunday,
        "V": $1cbfd224b19e14cc$var$formatUTCWeekNumberISO,
        "w": $1cbfd224b19e14cc$var$formatUTCWeekdayNumberSunday,
        "W": $1cbfd224b19e14cc$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $1cbfd224b19e14cc$var$formatUTCYear,
        "Y": $1cbfd224b19e14cc$var$formatUTCFullYear,
        "Z": $1cbfd224b19e14cc$var$formatUTCZone,
        "%": $1cbfd224b19e14cc$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $1cbfd224b19e14cc$var$parseDayOfMonth,
        "e": $1cbfd224b19e14cc$var$parseDayOfMonth,
        "f": $1cbfd224b19e14cc$var$parseMicroseconds,
        "g": $1cbfd224b19e14cc$var$parseYear,
        "G": $1cbfd224b19e14cc$var$parseFullYear,
        "H": $1cbfd224b19e14cc$var$parseHour24,
        "I": $1cbfd224b19e14cc$var$parseHour24,
        "j": $1cbfd224b19e14cc$var$parseDayOfYear,
        "L": $1cbfd224b19e14cc$var$parseMilliseconds,
        "m": $1cbfd224b19e14cc$var$parseMonthNumber,
        "M": $1cbfd224b19e14cc$var$parseMinutes,
        "p": parsePeriod,
        "q": $1cbfd224b19e14cc$var$parseQuarter,
        "Q": $1cbfd224b19e14cc$var$parseUnixTimestamp,
        "s": $1cbfd224b19e14cc$var$parseUnixTimestampSeconds,
        "S": $1cbfd224b19e14cc$var$parseSeconds,
        "u": $1cbfd224b19e14cc$var$parseWeekdayNumberMonday,
        "U": $1cbfd224b19e14cc$var$parseWeekNumberSunday,
        "V": $1cbfd224b19e14cc$var$parseWeekNumberISO,
        "w": $1cbfd224b19e14cc$var$parseWeekdayNumberSunday,
        "W": $1cbfd224b19e14cc$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $1cbfd224b19e14cc$var$parseYear,
        "Y": $1cbfd224b19e14cc$var$parseFullYear,
        "Z": $1cbfd224b19e14cc$var$parseZone,
        "%": $1cbfd224b19e14cc$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $1cbfd224b19e14cc$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $1cbfd224b19e14cc$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $1cbfd224b19e14cc$var$utcDate($1cbfd224b19e14cc$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $2XneA.utcMonday.ceil(week) : (0, $2XneA.utcMonday)(week);
                    week = $2XneA.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $1cbfd224b19e14cc$var$localDate($1cbfd224b19e14cc$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $2XneA.timeMonday.ceil(week) : (0, $2XneA.timeMonday)(week);
                    week = $2XneA.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $1cbfd224b19e14cc$var$utcDate($1cbfd224b19e14cc$var$newDate(d.y, 0, 1)).getUTCDay() : $1cbfd224b19e14cc$var$localDate($1cbfd224b19e14cc$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $1cbfd224b19e14cc$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $1cbfd224b19e14cc$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $1cbfd224b19e14cc$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $1cbfd224b19e14cc$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $1cbfd224b19e14cc$var$numberRe = /^\s*\d+/, // note: ignores next directive
$1cbfd224b19e14cc$var$percentRe = /^%/, $1cbfd224b19e14cc$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $1cbfd224b19e14cc$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $1cbfd224b19e14cc$var$requote(s) {
    return s.replace($1cbfd224b19e14cc$var$requoteRe, "\\$&");
}
function $1cbfd224b19e14cc$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($1cbfd224b19e14cc$var$requote).join("|") + ")", "i");
}
function $1cbfd224b19e14cc$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $1cbfd224b19e14cc$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseWeekNumberSunday(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseWeekNumberISO(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseWeekNumberMonday(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseFullYear(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseYear(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseQuarter(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseMonthNumber(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseDayOfMonth(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseDayOfYear(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseHour24(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseMinutes(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseSeconds(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseMilliseconds(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseMicroseconds(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseLiteralPercent(d, string, i) {
    var n = $1cbfd224b19e14cc$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $1cbfd224b19e14cc$var$parseUnixTimestamp(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $1cbfd224b19e14cc$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $1cbfd224b19e14cc$var$formatDayOfMonth(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getDate(), p, 2);
}
function $1cbfd224b19e14cc$var$formatHour24(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getHours(), p, 2);
}
function $1cbfd224b19e14cc$var$formatHour12(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $1cbfd224b19e14cc$var$formatDayOfYear(d, p) {
    return $1cbfd224b19e14cc$var$pad(1 + $2XneA.timeDay.count((0, $2XneA.timeYear)(d), d), p, 3);
}
function $1cbfd224b19e14cc$var$formatMilliseconds(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getMilliseconds(), p, 3);
}
function $1cbfd224b19e14cc$var$formatMicroseconds(d, p) {
    return $1cbfd224b19e14cc$var$formatMilliseconds(d, p) + "000";
}
function $1cbfd224b19e14cc$var$formatMonthNumber(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getMonth() + 1, p, 2);
}
function $1cbfd224b19e14cc$var$formatMinutes(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getMinutes(), p, 2);
}
function $1cbfd224b19e14cc$var$formatSeconds(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getSeconds(), p, 2);
}
function $1cbfd224b19e14cc$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $1cbfd224b19e14cc$var$formatWeekNumberSunday(d, p) {
    return $1cbfd224b19e14cc$var$pad($2XneA.timeSunday.count((0, $2XneA.timeYear)(d) - 1, d), p, 2);
}
function $1cbfd224b19e14cc$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $2XneA.timeThursday)(d) : $2XneA.timeThursday.ceil(d);
}
function $1cbfd224b19e14cc$var$formatWeekNumberISO(d, p) {
    d = $1cbfd224b19e14cc$var$dISO(d);
    return $1cbfd224b19e14cc$var$pad($2XneA.timeThursday.count((0, $2XneA.timeYear)(d), d) + ((0, $2XneA.timeYear)(d).getDay() === 4), p, 2);
}
function $1cbfd224b19e14cc$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $1cbfd224b19e14cc$var$formatWeekNumberMonday(d, p) {
    return $1cbfd224b19e14cc$var$pad($2XneA.timeMonday.count((0, $2XneA.timeYear)(d) - 1, d), p, 2);
}
function $1cbfd224b19e14cc$var$formatYear(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getFullYear() % 100, p, 2);
}
function $1cbfd224b19e14cc$var$formatYearISO(d, p) {
    d = $1cbfd224b19e14cc$var$dISO(d);
    return $1cbfd224b19e14cc$var$pad(d.getFullYear() % 100, p, 2);
}
function $1cbfd224b19e14cc$var$formatFullYear(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getFullYear() % 10000, p, 4);
}
function $1cbfd224b19e14cc$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $2XneA.timeThursday)(d) : $2XneA.timeThursday.ceil(d);
    return $1cbfd224b19e14cc$var$pad(d.getFullYear() % 10000, p, 4);
}
function $1cbfd224b19e14cc$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $1cbfd224b19e14cc$var$pad(z / 60 | 0, "0", 2) + $1cbfd224b19e14cc$var$pad(z % 60, "0", 2);
}
function $1cbfd224b19e14cc$var$formatUTCDayOfMonth(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getUTCDate(), p, 2);
}
function $1cbfd224b19e14cc$var$formatUTCHour24(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getUTCHours(), p, 2);
}
function $1cbfd224b19e14cc$var$formatUTCHour12(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $1cbfd224b19e14cc$var$formatUTCDayOfYear(d, p) {
    return $1cbfd224b19e14cc$var$pad(1 + $2XneA.utcDay.count((0, $2XneA.utcYear)(d), d), p, 3);
}
function $1cbfd224b19e14cc$var$formatUTCMilliseconds(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $1cbfd224b19e14cc$var$formatUTCMicroseconds(d, p) {
    return $1cbfd224b19e14cc$var$formatUTCMilliseconds(d, p) + "000";
}
function $1cbfd224b19e14cc$var$formatUTCMonthNumber(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $1cbfd224b19e14cc$var$formatUTCMinutes(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getUTCMinutes(), p, 2);
}
function $1cbfd224b19e14cc$var$formatUTCSeconds(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getUTCSeconds(), p, 2);
}
function $1cbfd224b19e14cc$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $1cbfd224b19e14cc$var$formatUTCWeekNumberSunday(d, p) {
    return $1cbfd224b19e14cc$var$pad($2XneA.utcSunday.count((0, $2XneA.utcYear)(d) - 1, d), p, 2);
}
function $1cbfd224b19e14cc$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $2XneA.utcThursday)(d) : $2XneA.utcThursday.ceil(d);
}
function $1cbfd224b19e14cc$var$formatUTCWeekNumberISO(d, p) {
    d = $1cbfd224b19e14cc$var$UTCdISO(d);
    return $1cbfd224b19e14cc$var$pad($2XneA.utcThursday.count((0, $2XneA.utcYear)(d), d) + ((0, $2XneA.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $1cbfd224b19e14cc$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $1cbfd224b19e14cc$var$formatUTCWeekNumberMonday(d, p) {
    return $1cbfd224b19e14cc$var$pad($2XneA.utcMonday.count((0, $2XneA.utcYear)(d) - 1, d), p, 2);
}
function $1cbfd224b19e14cc$var$formatUTCYear(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $1cbfd224b19e14cc$var$formatUTCYearISO(d, p) {
    d = $1cbfd224b19e14cc$var$UTCdISO(d);
    return $1cbfd224b19e14cc$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $1cbfd224b19e14cc$var$formatUTCFullYear(d, p) {
    return $1cbfd224b19e14cc$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $1cbfd224b19e14cc$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $2XneA.utcThursday)(d) : $2XneA.utcThursday.ceil(d);
    return $1cbfd224b19e14cc$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $1cbfd224b19e14cc$var$formatUTCZone() {
    return "+0000";
}
function $1cbfd224b19e14cc$var$formatLiteralPercent() {
    return "%";
}
function $1cbfd224b19e14cc$var$formatUnixTimestamp(d) {
    return +d;
}
function $1cbfd224b19e14cc$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("2yu8k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $cys2m = parcelRequire("cys2m");
var $1dc6219c85281541$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $1dc6219c85281541$var$isoSpecifier;
function $1dc6219c85281541$var$formatIsoNative(date) {
    return date.toISOString();
}
var $1dc6219c85281541$var$formatIso = Date.prototype.toISOString ? $1dc6219c85281541$var$formatIsoNative : (0, $cys2m.utcFormat)($1dc6219c85281541$var$isoSpecifier);
var $1dc6219c85281541$var$_default = $1dc6219c85281541$var$formatIso;
module.exports.default = $1dc6219c85281541$var$_default;

});

parcelRegister("dKACc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2yu8k = parcelRequire("2yu8k");

var $cys2m = parcelRequire("cys2m");
function $a02bf93ae64009e3$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $a02bf93ae64009e3$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $a02bf93ae64009e3$var$parseIsoNative : (0, $cys2m.utcParse)($2yu8k.isoSpecifier);
var $a02bf93ae64009e3$var$_default = $a02bf93ae64009e3$var$parseIso;
module.exports.default = $a02bf93ae64009e3$var$_default;

});



parcelRegister("lmWOB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8e946826e373efa$var$utcTime;

var $2XneA = parcelRequire("2XneA");

var $9D68L = parcelRequire("9D68L");

var $3MAjg = parcelRequire("3MAjg");

var $1UgJT = parcelRequire("1UgJT");
function $f8e946826e373efa$var$utcTime() {
    return $1UgJT.initRange.apply((0, $3MAjg.calendar)($2XneA.utcTicks, $2XneA.utcTickInterval, $2XneA.utcYear, $2XneA.utcMonth, $2XneA.utcWeek, $2XneA.utcDay, $2XneA.utcHour, $2XneA.utcMinute, $2XneA.utcSecond, $9D68L.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("aVvrY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $7f479f982e1bb4ea$var$copy;
module.exports.default = $7f479f982e1bb4ea$var$sequential;
module.exports.sequentialLog = $7f479f982e1bb4ea$var$sequentialLog;
module.exports.sequentialPow = $7f479f982e1bb4ea$var$sequentialPow;
module.exports.sequentialSqrt = $7f479f982e1bb4ea$var$sequentialSqrt;
module.exports.sequentialSymlog = $7f479f982e1bb4ea$var$sequentialSymlog;

var $6xFxm = parcelRequire("6xFxm");

var $jvFbg = parcelRequire("jvFbg");

var $1UgJT = parcelRequire("1UgJT");

var $6sFEr = parcelRequire("6sFEr");

var $2OQ0i = parcelRequire("2OQ0i");

var $hd7e5 = parcelRequire("hd7e5");

var $kc2iA = parcelRequire("kc2iA");
function $7f479f982e1bb4ea$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $jvFbg.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($6xFxm.interpolate);
    scale.rangeRound = range($6xFxm.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $7f479f982e1bb4ea$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $7f479f982e1bb4ea$var$sequential() {
    var scale = (0, $6sFEr.linearish)($7f479f982e1bb4ea$var$transformer()($jvFbg.identity));
    scale.copy = function() {
        return $7f479f982e1bb4ea$var$copy(scale, $7f479f982e1bb4ea$var$sequential());
    };
    return $1UgJT.initInterpolator.apply(scale, arguments);
}
function $7f479f982e1bb4ea$var$sequentialLog() {
    var scale = (0, $2OQ0i.loggish)($7f479f982e1bb4ea$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $7f479f982e1bb4ea$var$copy(scale, $7f479f982e1bb4ea$var$sequentialLog()).base(scale.base());
    };
    return $1UgJT.initInterpolator.apply(scale, arguments);
}
function $7f479f982e1bb4ea$var$sequentialSymlog() {
    var scale = (0, $hd7e5.symlogish)($7f479f982e1bb4ea$var$transformer());
    scale.copy = function() {
        return $7f479f982e1bb4ea$var$copy(scale, $7f479f982e1bb4ea$var$sequentialSymlog()).constant(scale.constant());
    };
    return $1UgJT.initInterpolator.apply(scale, arguments);
}
function $7f479f982e1bb4ea$var$sequentialPow() {
    var scale = (0, $kc2iA.powish)($7f479f982e1bb4ea$var$transformer());
    scale.copy = function() {
        return $7f479f982e1bb4ea$var$copy(scale, $7f479f982e1bb4ea$var$sequentialPow()).exponent(scale.exponent());
    };
    return $1UgJT.initInterpolator.apply(scale, arguments);
}
function $7f479f982e1bb4ea$var$sequentialSqrt() {
    return $7f479f982e1bb4ea$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("9TgbP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7335cf10f99b3931$var$sequentialQuantile;

var $chaAX = parcelRequire("chaAX");

var $jvFbg = parcelRequire("jvFbg");

var $1UgJT = parcelRequire("1UgJT");
function $7335cf10f99b3931$var$sequentialQuantile() {
    var domain = [], interpolator = $jvFbg.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $chaAX.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($chaAX.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $chaAX.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $7335cf10f99b3931$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $1UgJT.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("8SElv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6772a9b62384f0ea$var$diverging;
module.exports.divergingLog = $6772a9b62384f0ea$var$divergingLog;
module.exports.divergingPow = $6772a9b62384f0ea$var$divergingPow;
module.exports.divergingSqrt = $6772a9b62384f0ea$var$divergingSqrt;
module.exports.divergingSymlog = $6772a9b62384f0ea$var$divergingSymlog;

var $6xFxm = parcelRequire("6xFxm");

var $jvFbg = parcelRequire("jvFbg");

var $1UgJT = parcelRequire("1UgJT");

var $6sFEr = parcelRequire("6sFEr");

var $2OQ0i = parcelRequire("2OQ0i");

var $aVvrY = parcelRequire("aVvrY");

var $hd7e5 = parcelRequire("hd7e5");

var $kc2iA = parcelRequire("kc2iA");
function $6772a9b62384f0ea$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $jvFbg.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $6xFxm.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($6xFxm.interpolate);
    scale.rangeRound = range($6xFxm.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $6772a9b62384f0ea$var$diverging() {
    var scale = (0, $6sFEr.linearish)($6772a9b62384f0ea$var$transformer()($jvFbg.identity));
    scale.copy = function() {
        return (0, $aVvrY.copy)(scale, $6772a9b62384f0ea$var$diverging());
    };
    return $1UgJT.initInterpolator.apply(scale, arguments);
}
function $6772a9b62384f0ea$var$divergingLog() {
    var scale = (0, $2OQ0i.loggish)($6772a9b62384f0ea$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $aVvrY.copy)(scale, $6772a9b62384f0ea$var$divergingLog()).base(scale.base());
    };
    return $1UgJT.initInterpolator.apply(scale, arguments);
}
function $6772a9b62384f0ea$var$divergingSymlog() {
    var scale = (0, $hd7e5.symlogish)($6772a9b62384f0ea$var$transformer());
    scale.copy = function() {
        return (0, $aVvrY.copy)(scale, $6772a9b62384f0ea$var$divergingSymlog()).constant(scale.constant());
    };
    return $1UgJT.initInterpolator.apply(scale, arguments);
}
function $6772a9b62384f0ea$var$divergingPow() {
    var scale = (0, $kc2iA.powish)($6772a9b62384f0ea$var$transformer());
    scale.copy = function() {
        return (0, $aVvrY.copy)(scale, $6772a9b62384f0ea$var$divergingPow()).exponent(scale.exponent());
    };
    return $1UgJT.initInterpolator.apply(scale, arguments);
}
function $6772a9b62384f0ea$var$divergingSqrt() {
    return $6772a9b62384f0ea$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



/* @leny/bowlstats
 *
 * /src/app.tsx
 */ var $3604a940d8232154$exports = {};
'use strict';

$3604a940d8232154$exports = (parcelRequire("vTYgb"));






var $a685d0cc2ecaee5c$export$882461b6382ed46c;
var $a685d0cc2ecaee5c$export$757ceba2d55c277e;
'use strict';

var $bzs0j = parcelRequire("bzs0j");
var $a685d0cc2ecaee5c$var$i;
$a685d0cc2ecaee5c$export$882461b6382ed46c = $bzs0j.createRoot;
$a685d0cc2ecaee5c$export$757ceba2d55c277e = $bzs0j.hydrateRoot;


/* @leny/bowlstats
 *
 * /src/containers/root.tsx
 */ 

var $5pP8j = parcelRequire("5pP8j");
var $e223c7d74c4e7757$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if (0, $e223c7d74c4e7757$exports) {
        classNames.default = classNames;
        $e223c7d74c4e7757$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


/* @leny/bowlstats
 *
 * /src/components/header.tsx
 */ 

var $404ccd9e674a6806$exports = {};
$404ccd9e674a6806$exports = JSON.parse("{\"title\":\"Rosack Bowling Stats\",\"goals\":{}}");



var $1lj2q = parcelRequire("1lj2q");
var $a32594ab2df0a6bf$exports = {};
'use strict';
function $a32594ab2df0a6bf$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $5pP8j = parcelRequire("5pP8j");
var $a32594ab2df0a6bf$var$React__default = $a32594ab2df0a6bf$var$_interopDefault($5pP8j);
function $a32594ab2df0a6bf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a32594ab2df0a6bf$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $a32594ab2df0a6bf$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $a32594ab2df0a6bf$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $a32594ab2df0a6bf$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $a32594ab2df0a6bf$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($5pP8j.PureComponent);
        $a32594ab2df0a6bf$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $a32594ab2df0a6bf$var$_defineProperty(SideEffect, "canUseDOM", $a32594ab2df0a6bf$var$canUseDOM);
        return SideEffect;
    };
}
$a32594ab2df0a6bf$exports = $a32594ab2df0a6bf$var$withSideEffect;


var $51e817777742533f$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $51e817777742533f$var$hasElementType = typeof Element !== 'undefined';
var $51e817777742533f$var$hasMap = typeof Map === 'function';
var $51e817777742533f$var$hasSet = typeof Set === 'function';
var $51e817777742533f$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $51e817777742533f$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$51e817777742533f$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($51e817777742533f$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$51e817777742533f$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($51e817777742533f$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($51e817777742533f$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($51e817777742533f$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$51e817777742533f$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$51e817777742533f$exports = function isEqual(a, b) {
    try {
        return $51e817777742533f$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $5pP8j = parcelRequire("5pP8j");
var $36f0c57638f2ed9c$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $36f0c57638f2ed9c$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $36f0c57638f2ed9c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $36f0c57638f2ed9c$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $36f0c57638f2ed9c$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $36f0c57638f2ed9c$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$36f0c57638f2ed9c$exports = $36f0c57638f2ed9c$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $36f0c57638f2ed9c$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($36f0c57638f2ed9c$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($36f0c57638f2ed9c$var$getOwnPropertySymbols) {
            symbols = $36f0c57638f2ed9c$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($36f0c57638f2ed9c$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $2e98b80d453f50af$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $2e98b80d453f50af$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $2e98b80d453f50af$var$VALID_TAG_NAMES = Object.keys($2e98b80d453f50af$var$TAG_NAMES).map(function(name) {
    return $2e98b80d453f50af$var$TAG_NAMES[name];
});
var $2e98b80d453f50af$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $2e98b80d453f50af$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $2e98b80d453f50af$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $2e98b80d453f50af$var$HTML_TAG_MAP = Object.keys($2e98b80d453f50af$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$2e98b80d453f50af$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $2e98b80d453f50af$var$SELF_CLOSING_TAGS = [
    $2e98b80d453f50af$var$TAG_NAMES.NOSCRIPT,
    $2e98b80d453f50af$var$TAG_NAMES.SCRIPT,
    $2e98b80d453f50af$var$TAG_NAMES.STYLE
];
var $2e98b80d453f50af$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $2e98b80d453f50af$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $2e98b80d453f50af$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $2e98b80d453f50af$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $2e98b80d453f50af$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2e98b80d453f50af$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $2e98b80d453f50af$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $2e98b80d453f50af$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $2e98b80d453f50af$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $2e98b80d453f50af$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $2e98b80d453f50af$var$getInnermostProperty(propsList, $2e98b80d453f50af$var$TAG_NAMES.TITLE);
    var innermostTemplate = $2e98b80d453f50af$var$getInnermostProperty(propsList, $2e98b80d453f50af$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $2e98b80d453f50af$var$getInnermostProperty(propsList, $2e98b80d453f50af$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $2e98b80d453f50af$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $2e98b80d453f50af$var$getInnermostProperty(propsList, $2e98b80d453f50af$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $2e98b80d453f50af$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $2e98b80d453f50af$var$_extends({}, tagAttrs, current);
    }, {});
};
var $2e98b80d453f50af$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$2e98b80d453f50af$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$2e98b80d453f50af$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $2e98b80d453f50af$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $2e98b80d453f50af$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $2e98b80d453f50af$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $2e98b80d453f50af$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $2e98b80d453f50af$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $2e98b80d453f50af$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $2e98b80d453f50af$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $2e98b80d453f50af$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($36f0c57638f2ed9c$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $2e98b80d453f50af$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $2e98b80d453f50af$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $2e98b80d453f50af$var$getBaseTagFromPropsList([
            $2e98b80d453f50af$var$TAG_PROPERTIES.HREF,
            $2e98b80d453f50af$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $2e98b80d453f50af$var$getAttributesFromPropsList($2e98b80d453f50af$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $2e98b80d453f50af$var$getInnermostProperty(propsList, $2e98b80d453f50af$var$HELMET_PROPS.DEFER),
        encode: $2e98b80d453f50af$var$getInnermostProperty(propsList, $2e98b80d453f50af$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $2e98b80d453f50af$var$getAttributesFromPropsList($2e98b80d453f50af$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $2e98b80d453f50af$var$getTagsFromPropsList($2e98b80d453f50af$var$TAG_NAMES.LINK, [
            $2e98b80d453f50af$var$TAG_PROPERTIES.REL,
            $2e98b80d453f50af$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $2e98b80d453f50af$var$getTagsFromPropsList($2e98b80d453f50af$var$TAG_NAMES.META, [
            $2e98b80d453f50af$var$TAG_PROPERTIES.NAME,
            $2e98b80d453f50af$var$TAG_PROPERTIES.CHARSET,
            $2e98b80d453f50af$var$TAG_PROPERTIES.HTTPEQUIV,
            $2e98b80d453f50af$var$TAG_PROPERTIES.PROPERTY,
            $2e98b80d453f50af$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $2e98b80d453f50af$var$getTagsFromPropsList($2e98b80d453f50af$var$TAG_NAMES.NOSCRIPT, [
            $2e98b80d453f50af$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $2e98b80d453f50af$var$getOnChangeClientState(propsList),
        scriptTags: $2e98b80d453f50af$var$getTagsFromPropsList($2e98b80d453f50af$var$TAG_NAMES.SCRIPT, [
            $2e98b80d453f50af$var$TAG_PROPERTIES.SRC,
            $2e98b80d453f50af$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $2e98b80d453f50af$var$getTagsFromPropsList($2e98b80d453f50af$var$TAG_NAMES.STYLE, [
            $2e98b80d453f50af$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $2e98b80d453f50af$var$getTitleFromPropsList(propsList),
        titleAttributes: $2e98b80d453f50af$var$getAttributesFromPropsList($2e98b80d453f50af$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $2e98b80d453f50af$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $2e98b80d453f50af$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $2e98b80d453f50af$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $2e98b80d453f50af$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $2e98b80d453f50af$var$rafPolyfill : $parcel$global.requestAnimationFrame || $2e98b80d453f50af$var$rafPolyfill;
var $2e98b80d453f50af$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $2e98b80d453f50af$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $2e98b80d453f50af$var$cafPolyfill;
var $2e98b80d453f50af$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $2e98b80d453f50af$var$_helmetCallback = null;
var $2e98b80d453f50af$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($2e98b80d453f50af$var$_helmetCallback) $2e98b80d453f50af$var$cancelAnimationFrame($2e98b80d453f50af$var$_helmetCallback);
    if (newState.defer) $2e98b80d453f50af$var$_helmetCallback = $2e98b80d453f50af$var$requestAnimationFrame(function() {
        $2e98b80d453f50af$var$commitTagChanges(newState, function() {
            $2e98b80d453f50af$var$_helmetCallback = null;
        });
    });
    else {
        $2e98b80d453f50af$var$commitTagChanges(newState);
        $2e98b80d453f50af$var$_helmetCallback = null;
    }
};
var $2e98b80d453f50af$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $2e98b80d453f50af$var$updateAttributes($2e98b80d453f50af$var$TAG_NAMES.BODY, bodyAttributes);
    $2e98b80d453f50af$var$updateAttributes($2e98b80d453f50af$var$TAG_NAMES.HTML, htmlAttributes);
    $2e98b80d453f50af$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $2e98b80d453f50af$var$updateTags($2e98b80d453f50af$var$TAG_NAMES.BASE, baseTag),
        linkTags: $2e98b80d453f50af$var$updateTags($2e98b80d453f50af$var$TAG_NAMES.LINK, linkTags),
        metaTags: $2e98b80d453f50af$var$updateTags($2e98b80d453f50af$var$TAG_NAMES.META, metaTags),
        noscriptTags: $2e98b80d453f50af$var$updateTags($2e98b80d453f50af$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $2e98b80d453f50af$var$updateTags($2e98b80d453f50af$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $2e98b80d453f50af$var$updateTags($2e98b80d453f50af$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $2e98b80d453f50af$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $2e98b80d453f50af$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $2e98b80d453f50af$var$flattenArray(title);
    $2e98b80d453f50af$var$updateAttributes($2e98b80d453f50af$var$TAG_NAMES.TITLE, attributes);
};
var $2e98b80d453f50af$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($2e98b80d453f50af$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($2e98b80d453f50af$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($2e98b80d453f50af$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($2e98b80d453f50af$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $2e98b80d453f50af$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($2e98b80d453f50af$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $2e98b80d453f50af$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $2e98b80d453f50af$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $2e98b80d453f50af$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($2e98b80d453f50af$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $2e98b80d453f50af$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $2e98b80d453f50af$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $2e98b80d453f50af$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $2e98b80d453f50af$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $2e98b80d453f50af$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $2e98b80d453f50af$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $2e98b80d453f50af$var$HELMET_ATTRIBUTE + "=\"true\">" + $2e98b80d453f50af$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $2e98b80d453f50af$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $2e98b80d453f50af$var$TAG_PROPERTIES.INNER_HTML || attribute === $2e98b80d453f50af$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $2e98b80d453f50af$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $2e98b80d453f50af$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $2e98b80d453f50af$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $2e98b80d453f50af$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$2e98b80d453f50af$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $2e98b80d453f50af$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$2e98b80d453f50af$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $2e98b80d453f50af$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$2e98b80d453f50af$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $2e98b80d453f50af$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement($2e98b80d453f50af$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $2e98b80d453f50af$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$2e98b80d453f50af$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $2e98b80d453f50af$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $2e98b80d453f50af$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $2e98b80d453f50af$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement(type, mappedTag);
    });
};
var $2e98b80d453f50af$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $2e98b80d453f50af$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $2e98b80d453f50af$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $2e98b80d453f50af$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $2e98b80d453f50af$var$ATTRIBUTE_NAMES.BODY:
        case $2e98b80d453f50af$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $2e98b80d453f50af$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $2e98b80d453f50af$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $2e98b80d453f50af$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $2e98b80d453f50af$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $2e98b80d453f50af$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $2e98b80d453f50af$var$getMethodsForTag($2e98b80d453f50af$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $2e98b80d453f50af$var$getMethodsForTag($2e98b80d453f50af$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $2e98b80d453f50af$var$getMethodsForTag($2e98b80d453f50af$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $2e98b80d453f50af$var$getMethodsForTag($2e98b80d453f50af$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $2e98b80d453f50af$var$getMethodsForTag($2e98b80d453f50af$var$TAG_NAMES.META, metaTags, encode),
        noscript: $2e98b80d453f50af$var$getMethodsForTag($2e98b80d453f50af$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $2e98b80d453f50af$var$getMethodsForTag($2e98b80d453f50af$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $2e98b80d453f50af$var$getMethodsForTag($2e98b80d453f50af$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $2e98b80d453f50af$var$getMethodsForTag($2e98b80d453f50af$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $2e98b80d453f50af$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $2e98b80d453f50af$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $2e98b80d453f50af$var$classCallCheck(this, HelmetWrapper);
            return $2e98b80d453f50af$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($51e817777742533f$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $2e98b80d453f50af$var$TAG_NAMES.SCRIPT:
                case $2e98b80d453f50af$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $2e98b80d453f50af$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $2e98b80d453f50af$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $2e98b80d453f50af$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $2e98b80d453f50af$var$TAG_NAMES.TITLE:
                    return $2e98b80d453f50af$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $2e98b80d453f50af$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $2e98b80d453f50af$var$TAG_NAMES.BODY:
                    return $2e98b80d453f50af$var$_extends({}, newProps, {
                        bodyAttributes: $2e98b80d453f50af$var$_extends({}, newChildProps)
                    });
                case $2e98b80d453f50af$var$TAG_NAMES.HTML:
                    return $2e98b80d453f50af$var$_extends({}, newProps, {
                        htmlAttributes: $2e98b80d453f50af$var$_extends({}, newChildProps)
                    });
            }
            return $2e98b80d453f50af$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $2e98b80d453f50af$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $2e98b80d453f50af$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $2e98b80d453f50af$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $2e98b80d453f50af$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $2e98b80d453f50af$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $2e98b80d453f50af$var$TAG_NAMES.LINK:
                    case $2e98b80d453f50af$var$TAG_NAMES.META:
                    case $2e98b80d453f50af$var$TAG_NAMES.NOSCRIPT:
                    case $2e98b80d453f50af$var$TAG_NAMES.SCRIPT:
                    case $2e98b80d453f50af$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $2e98b80d453f50af$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $2e98b80d453f50af$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement(Component, newProps);
        };
        $2e98b80d453f50af$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $2e98b80d453f50af$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $2e98b80d453f50af$var$NullComponent = function NullComponent() {
    return null;
};
var $2e98b80d453f50af$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($a32594ab2df0a6bf$exports)))($2e98b80d453f50af$var$reducePropsToState, $2e98b80d453f50af$var$handleClientStateChange, $2e98b80d453f50af$var$mapStateOnServer)($2e98b80d453f50af$var$NullComponent);
var $2e98b80d453f50af$export$dcef8f9bb9a41431 = $2e98b80d453f50af$var$Helmet($2e98b80d453f50af$var$HelmetSideEffects);
$2e98b80d453f50af$export$dcef8f9bb9a41431.renderStatic = $2e98b80d453f50af$export$dcef8f9bb9a41431.rewind;
var $2e98b80d453f50af$export$2e2bcd8739ae039 = $2e98b80d453f50af$export$dcef8f9bb9a41431;


const $1fc4605f822514f8$var$Header = ({ mode: mode, onChangeMode: onChangeMode })=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $3604a940d8232154$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $2e98b80d453f50af$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("title", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($404ccd9e674a6806$exports))).title
                    }),
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("meta", {
                        name: "description",
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($404ccd9e674a6806$exports))).subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("header", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("hero", "is-small", "is-primary"),
                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("hero-body", "is-flex", "is-justify-content-space-between", "is-align-items-end"),
                    children: [
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-flex-1"),
                            children: [
                                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("h1", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("title"),
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($404ccd9e674a6806$exports))).title
                                }),
                                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("h2", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("subtitle"),
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($404ccd9e674a6806$exports))).subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-flex-1")
                        })
                    ]
                })
            })
        ]
    });
var $1fc4605f822514f8$export$2e2bcd8739ae039 = $1fc4605f822514f8$var$Header;


/* @leny/bowlstats
 *
 * /src/containers/games.tsx
 */ 

var $5pP8j = parcelRequire("5pP8j");

/* @leny/bowlstats
 *
 * /src/components/numbers.tsx
 */ 

/* @leny/bowlstats
 *
 * /src/core/hooks/use-data.js
 */ 
var $5pP8j = parcelRequire("5pP8j");
/* @leny/bowlstats
 *
 * /src/core/data-store.ts
 */ // NOTE: this is a "static" store, as the data will not change during the app lifecycle.

var $5pP8j = parcelRequire("5pP8j");
var $d25683810566fb38$exports = {};
$d25683810566fb38$exports = JSON.parse("{\"games\":[{\"id\":\"Mike:2023-04-30:1\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,2],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":28,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":68,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":88,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":108,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":126,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":134,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":143,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":152,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":152,\"pins\":94,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.7,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2023-04-30:2\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,1],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":25,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",6],\"cumulative\":31,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":51,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":78,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":97,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":106,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":125,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\",9],\"cumulative\":144,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":144,\"pins\":99,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":3,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-05-14:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":48,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":67,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,3],\"cumulative\":76,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":106,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":133,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":152,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":161,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\",9,\"/\"],\"cumulative\":181,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":181,\"pins\":97,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.9,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2023-05-14:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":36,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":53,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":73,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":93,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":113,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":132,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":141,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\",7,2],\"cumulative\":160,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":160,\"pins\":105,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":0,\"multiple\":4},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-06-11:1\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":38,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":66,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":85,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":94,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":124,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":153,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":172,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":181,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":181,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.4,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-06-11:2\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":39,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":69,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":129,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":156,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":175,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":184,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":192,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":201,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":201,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2023-08-27:1\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":28,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":47,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":56,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":65,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":82,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":92,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",8],\"cumulative\":100,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":118,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":126,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":135,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":135,\"pins\":93,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.6,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-08-27:2\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":49,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":68,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":77,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":95,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":103,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":111,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":129,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":147,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\",8],\"cumulative\":165,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":165,\"pins\":103,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":5,\"single\":2,\"multiple\":3},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2023-09-24:1\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":39,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":48,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":56,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":65,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":74,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":104,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":134,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":164,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",\"X\"],\"cumulative\":194,\"score\":30,\"pins\":30,\"split\":false,\"spare\":false,\"open\":false}],\"score\":194,\"pins\":115,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2023-09-24:2\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":38,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":58,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":78,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":107,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":126,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":135,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":154,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":163,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\",6],\"cumulative\":179,\"score\":16,\"pins\":16,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":179,\"pins\":103,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-10-08:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,1],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":38,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":68,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":96,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":115,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":124,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":131,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":151,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":171,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\",\"X\",8],\"cumulative\":199,\"score\":28,\"pins\":28,\"split\":false,\"spare\":false,\"open\":false}],\"score\":199,\"pins\":112,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2023-10-08:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":45,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":65,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":85,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":103,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":123,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":150,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":167,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":174,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":174,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":5,\"single\":1,\"multiple\":4},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2023-10-22:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":22},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":36,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,3],\"cumulative\":45,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":64,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":81,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":101,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":120,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":129,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":129,\"pins\":92,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2023-10-22:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":22},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":27,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":47,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":66,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":75,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":92,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":99,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":118,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":138,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\",7,\"/\"],\"cumulative\":158,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":158,\"pins\":93,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2023-10-29:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[1,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":40,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":57,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":76,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":95,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":113,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":122,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":142,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":161,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\",9],\"cumulative\":180,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":180,\"pins\":108,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":7,\"single\":5,\"multiple\":2},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2023-10-29:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":39,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":59,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":79,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":97,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":115,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":124,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":133,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":163,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",\"X\"],\"cumulative\":193,\"score\":30,\"pins\":30,\"split\":false,\"spare\":false,\"open\":false}],\"score\":193,\"pins\":118,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2023-11-26:1\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":38,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":47,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":55,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":63,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":72,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":81,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":90,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":106,\"score\":16,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":112,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":112,\"pins\":88,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.2,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2023-11-26:2\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":15,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":64,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":84,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":114,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":143,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":163,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":182,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\",\"X\"],\"cumulative\":202,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":202,\"pins\":105,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":3,\"single\":3,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2023-12-03:1\",\"date\":{\"year\":2023,\"month\":12,\"day\":3},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":60,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":90,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":120,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":149,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":169,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":188,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":207,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":226,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":235,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":235,\"pins\":99,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":3,\"single\":3,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2023-12-03:2\",\"date\":{\"year\":2023,\"month\":12,\"day\":3},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":60,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":89,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":108,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":117,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":146,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":165,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":174,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":193,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":202,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":202,\"pins\":97,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2024-01-07:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":43,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":52,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":71,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":81,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"-\",\"/\"],\"cumulative\":101,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":121,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\",\"X\"],\"cumulative\":141,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":141,\"pins\":104,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2024-01-07:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":38,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":47,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":66,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":83,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":102,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":121,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":140,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":159,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\",\"X\"],\"cumulative\":179,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":179,\"pins\":109,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":8,\"single\":5,\"multiple\":3},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2024-01-14:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":29,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":49,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":69,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":88,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":97,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":115,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":124,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":144,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\",9,\"-\"],\"cumulative\":163,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":163,\"pins\":106,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":4,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2024-01-14:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":39,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":48,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":78,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":108,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":138,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":166,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":185,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":194,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":203,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":203,\"pins\":97,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2024-03-31:1\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":35,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":55,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":75,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":93,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":102,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":109,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":137,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":156,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":165,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":165,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-03-31:2\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",7],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":14,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":33,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":52,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":61,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":119,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":137,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":145,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":145,\"pins\":90,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2024-03-31:3\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[5,3],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":28,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":65,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":84,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":93,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":123,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":153,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":181,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",8,1],\"cumulative\":200,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":200,\"pins\":106,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-05-19:1\",\"date\":{\"year\":2024,\"month\":5,\"day\":19},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":57,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":74,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":81,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":108,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":128,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":148,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":167,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,3],\"cumulative\":176,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\",9,\"/\"],\"cumulative\":196,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":196,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-05-19:2\",\"date\":{\"year\":2024,\"month\":5,\"day\":19},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":15,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":63,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":72,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":80,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":108,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":138,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",7],\"cumulative\":165,\"score\":27,\"pins\":27,\"split\":false,\"spare\":false,\"open\":false}],\"score\":165,\"pins\":108,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2024-07-07:1\",\"date\":{\"year\":2024,\"month\":7,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,2],\"cumulative\":24,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":54,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":80,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,3],\"cumulative\":108,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":116,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":124,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":154,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",7],\"cumulative\":181,\"score\":27,\"pins\":27,\"split\":false,\"spare\":false,\"open\":false}],\"score\":181,\"pins\":110,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-07-07:2\",\"date\":{\"year\":2024,\"month\":7,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":67,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":76,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":96,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":112,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":131,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":150,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":169,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\",7],\"cumulative\":186,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":186,\"pins\":106,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":6,\"single\":4,\"multiple\":2},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2024-08-04:1\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":24,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":44,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":64,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":82,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":102,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":122,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":138,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":144,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",\"X\"],\"cumulative\":164,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":164,\"pins\":103,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":6,\"single\":4,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2024-08-04:2\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":28,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":37,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":57,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":74,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":81,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":101,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":117,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[6,3],\"cumulative\":126,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":135,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":135,\"pins\":93,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":2,\"single\":2,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2024-12-01:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":44,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":63,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":82,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":91,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":121,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":151,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",7],\"cumulative\":178,\"score\":27,\"pins\":27,\"split\":false,\"spare\":false,\"open\":false}],\"score\":178,\"pins\":112,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":3,\"single\":3,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2024-12-01:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":33,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":63,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":93,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":123,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":150,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":170,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":187,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":196,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":196,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-12-08:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":56,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":73,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,1],\"cumulative\":80,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":108,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":116,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":136,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":153,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":161,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":161,\"pins\":92,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.7,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2024-12-08:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":35,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":55,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":85,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":115,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":145,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":175,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":205,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",6],\"cumulative\":231,\"score\":26,\"pins\":26,\"split\":false,\"spare\":false,\"open\":false}],\"score\":231,\"pins\":114,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2025-01-05:1\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":37,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":56,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":65,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":95,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":125,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":155,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":185,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":215,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",\"X\"],\"cumulative\":245,\"score\":30,\"pins\":30,\"split\":false,\"spare\":false,\"open\":false}],\"score\":245,\"pins\":119,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":9,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2025-01-05:2\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":48,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":77,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":97,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":116,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":125,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":155,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":184,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",9,\"-\"],\"cumulative\":203,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":203,\"pins\":107,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Mike:2025-02-16:1\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":29,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,\"/\"],\"cumulative\":46,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":53,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":73,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":91,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":99,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":129,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":159,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",8],\"cumulative\":187,\"score\":28,\"pins\":28,\"split\":false,\"spare\":false,\"open\":false}],\"score\":187,\"pins\":112,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":6,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2025-02-16:2\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":27,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":51,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":69,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":78,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":98,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":128,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":158,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":188,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",6],\"cumulative\":214,\"score\":26,\"pins\":26,\"split\":false,\"spare\":false,\"open\":false}],\"score\":214,\"pins\":112,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":2,\"single\":2,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2025-03-16:1\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":47,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":74,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":94,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":114,\"score\":20,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":132,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":140,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":148,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",\"X\"],\"cumulative\":168,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":168,\"pins\":103,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.9,\"splits\":{\"total\":3,\"converted\":1},\"strikes\":5,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2025-03-16:2\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":47,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":76,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":96,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":115,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":135,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":165,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":195,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",\"X\"],\"cumulative\":225,\"score\":30,\"pins\":30,\"split\":false,\"spare\":false,\"open\":false}],\"score\":225,\"pins\":119,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2025-04-27:1\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,2],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":35,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":42,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":62,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":90,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":109,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":118,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":127,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":135,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":135,\"pins\":90,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2025-04-27:2\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":36,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":43,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":73,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":100,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":119,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":128,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":148,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":168,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\",9,\"/\"],\"cumulative\":188,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":188,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":4,\"single\":4,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Mike:2025-05-11:1\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":56,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":76,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":93,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":112,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":121,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":148,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":165,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":172,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\",\"X\",9],\"cumulative\":201,\"score\":29,\"pins\":29,\"split\":false,\"spare\":false,\"open\":false}],\"score\":201,\"pins\":115,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.9,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2025-05-11:2\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":46,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":66,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":86,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":104,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,2],\"cumulative\":112,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":132,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":149,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":158,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":167,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":167,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2025-12-07:1\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":37,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":66,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":85,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":94,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":112,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,2],\"cumulative\":120,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\",7],\"cumulative\":137,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":137,\"pins\":101,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Mike:2025-12-07:2\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":26,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":46,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":63,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":82,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":102,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":122,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":142,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":172,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":202,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",7],\"cumulative\":229,\"score\":27,\"pins\":27,\"split\":false,\"spare\":false,\"open\":false}],\"score\":229,\"pins\":117,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2026-01-18:1\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":36,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":45,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":65,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":95,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":124,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":144,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":162,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":171,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":180,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":180,\"pins\":97,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Mike:2026-01-18:2\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":30,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":58,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":77,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":86,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":95,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":104,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":113,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":142,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":162,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\",9],\"cumulative\":181,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":181,\"pins\":105,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":3,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2026-03-01:1\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":20,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":49,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":69,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":89,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":119,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":149,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":179,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":208,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":228,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\",9],\"cumulative\":247,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":247,\"pins\":109,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":0,\"fouls\":0}},{\"id\":\"Mike:2026-03-01:2\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Mike\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,3],\"cumulative\":25,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":34,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":53,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":71,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":88,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":107,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":123,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[6,\"/\",9],\"cumulative\":142,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":142,\"pins\":105,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":6,\"single\":3,\"multiple\":3},\"misses\":1,\"fouls\":0}},{\"id\":\"Sara:2023-04-30:1\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":9,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":29,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":47,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":56,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":61,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":78,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":85,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":85,\"pins\":67,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":7,\"fouls\":0}},{\"id\":\"Sara:2023-04-30:2\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":10,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":19,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":26,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":35,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":63,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":83,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":103,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":123,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":133,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":142,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":142,\"pins\":94,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-05-07:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[5,\"-\"],\"cumulative\":5,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":12,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":21,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":30,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":39,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"/\"],\"cumulative\":55,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":71,\"score\":16,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,3],\"cumulative\":80,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":90,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":99,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":99,\"pins\":87,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.2,\"splits\":{\"total\":1,\"converted\":1},\"strikes\":0,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-05-07:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,8],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":54,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,\"/\"],\"cumulative\":73,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":82,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":100,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":110,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",1],\"cumulative\":111,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true}],\"score\":111,\"pins\":84,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2023-05-14:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",5],\"cumulative\":22,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":29,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,8],\"cumulative\":38,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":46,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":53,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":53,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":62,\"pins\":62,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":10,\"fouls\":0}},{\"id\":\"Sara:2023-05-14:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":28,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":35,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":38,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":47,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":56,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":64,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":82,\"score\":18,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":90,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":90,\"pins\":73,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.4,\"splits\":{\"total\":1,\"converted\":1},\"strikes\":0,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":8,\"fouls\":0}},{\"id\":\"Sara:2023-05-16:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":36,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",6],\"cumulative\":42,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":49,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":57,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":66,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":71,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",1],\"cumulative\":72,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true}],\"score\":72,\"pins\":72,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":8,\"fouls\":0}},{\"id\":\"Sara:2023-05-16:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":35,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":54,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":63,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":72,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"/\"],\"cumulative\":91,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":111,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":137,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":153,\"score\":16,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":159,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":159,\"pins\":90,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-06-11:1\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":38,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":58,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":86,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":105,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":114,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":123,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":141,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":150,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":150,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Sara:2023-06-11:2\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":16,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,6],\"cumulative\":23,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":32,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":51,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":60,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":79,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":98,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":107,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",9],\"cumulative\":126,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":126,\"pins\":99,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2023-08-27:1\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":34,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":42,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":59,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":66,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":81,\"score\":15,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[5,\"-\"],\"cumulative\":86,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",9],\"cumulative\":105,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":105,\"pins\":93,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":6,\"fouls\":0}},{\"id\":\"Sara:2023-08-27:2\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":29,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":46,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":54,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":83,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":103,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":121,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":138,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":145,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":153,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":153,\"pins\":92,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Sara:2023-09-24:1\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",9],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":26,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":35,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":41,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":50,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":70,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":80,\"score\":10,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":89,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":96,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":96,\"pins\":86,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":2,\"converted\":1},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":8,\"fouls\":0}},{\"id\":\"Sara:2023-09-24:2\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":30,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":39,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":45,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":52,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":59,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":68,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":77,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":80,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true}],\"score\":80,\"pins\":74,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":7,\"fouls\":0}},{\"id\":\"Sara:2023-10-08:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,2],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":43,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":52,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":61,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":90,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\",8],\"cumulative\":108,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":108,\"pins\":98,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2023-10-08:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"/\"],\"cumulative\":18,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",7],\"cumulative\":25,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"/\"],\"cumulative\":44,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":53,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":71,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":80,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":89,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":98,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":98,\"pins\":89,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":7,\"fouls\":0}},{\"id\":\"Sara:2023-10-29:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":46,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":56,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":65,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":74,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":94,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":111,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":118,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":118,\"pins\":84,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.7,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-10-29:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":17,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":32,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":51,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":60,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":80,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":99,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":108,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":117,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\",8],\"cumulative\":135,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":135,\"pins\":100,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-11-26:1\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":36,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":45,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":75,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":103,\"score\":28,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":122,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":131,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\",8,\"/\"],\"cumulative\":151,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":151,\"pins\":94,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.1,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2023-11-26:2\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[1,8],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":43,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":61,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":69,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":77,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":85,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":93,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",4],\"cumulative\":107,\"score\":14,\"pins\":14,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":107,\"pins\":91,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2024-01-07:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":29,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":57,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":76,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":85,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":102,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":110,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":139,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",9,\"-\"],\"cumulative\":158,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":158,\"pins\":104,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2024-01-07:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":35,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":53,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":61,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":88,\"score\":18,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":96,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":104,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":104,\"pins\":80,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.8,\"splits\":{\"total\":2,\"converted\":1},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":8,\"fouls\":0}},{\"id\":\"Sara:2024-01-14:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,2],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":25,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":44,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":53,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":70,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",1],\"cumulative\":71,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":90,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":99,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"/\",9],\"cumulative\":118,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":118,\"pins\":93,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.2,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2024-01-14:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":37,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":63,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":71,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,8],\"cumulative\":80,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":87,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":106,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":115,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":115,\"pins\":90,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.9,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2024-03-31:1\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":36,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":45,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":65,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":92,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":111,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":120,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":138,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":147,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":147,\"pins\":94,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":2,\"single\":2,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Sara:2024-03-31:2\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,2],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":52,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":72,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":91,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":100,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":129,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":149,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\",8],\"cumulative\":167,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":167,\"pins\":104,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Sara:2024-05-19:1\",\"date\":{\"year\":2024,\"month\":5,\"day\":19},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":51,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":60,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":78,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":87,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",4],\"cumulative\":91,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":100,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",8],\"cumulative\":118,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":118,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.3,\"splits\":{\"total\":3,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2024-05-19:2\",\"date\":{\"year\":2024,\"month\":5,\"day\":19},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":34,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":42,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"/\"],\"cumulative\":60,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":68,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":88,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":107,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":126,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":135,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":135,\"pins\":91,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.4,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2024-07-14:1\",\"date\":{\"year\":2024,\"month\":7,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[1,7],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":34,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":43,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":52,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":59,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":68,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":77,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":86,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":86,\"pins\":86,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.8,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2024-07-14:2\",\"date\":{\"year\":2024,\"month\":7,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[4,1],\"cumulative\":5,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":14,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":23,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":29,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":47,\"score\":18,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":55,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":64,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":83,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":92,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":101,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":101,\"pins\":84,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.6,\"splits\":{\"total\":2,\"converted\":1},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2024-08-04:1\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":43,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":61,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":77,\"score\":16,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":97,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":115,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,2],\"cumulative\":123,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,8],\"cumulative\":132,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":140,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":140,\"pins\":94,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.9,\"splits\":{\"total\":1,\"converted\":1},\"strikes\":1,\"spares\":{\"total\":5,\"single\":0,\"multiple\":5},\"misses\":2,\"fouls\":0}},{\"id\":\"Sara:2024-08-04:2\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[5,3],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":23,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,\"/\"],\"cumulative\":42,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":51,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":59,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":68,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":77,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":86,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":95,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\",\"X\",3],\"cumulative\":118,\"score\":23,\"pins\":23,\"split\":false,\"spare\":false,\"open\":false}],\"score\":118,\"pins\":104,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":3,\"fouls\":0}},{\"id\":\"Sara:2024-12-01:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":53,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":61,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":79,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":98,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":107,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",7],\"cumulative\":124,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":124,\"pins\":99,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":6,\"fouls\":0}},{\"id\":\"Sara:2024-12-01:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":29,\"score\":29,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":57,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":66,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":75,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":84,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":102,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":110,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":140,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",\"X\"],\"cumulative\":170,\"score\":30,\"pins\":30,\"split\":false,\"spare\":false,\"open\":false}],\"score\":170,\"pins\":114,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":9.2,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":7,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Sara:2024-12-08:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"/\"],\"cumulative\":47,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":67,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":86,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":95,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":103,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":111,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",8],\"cumulative\":129,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":129,\"pins\":100,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":6,\"fouls\":0}},{\"id\":\"Sara:2024-12-08:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"/\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":41,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":50,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":58,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":75,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":82,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":90,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":103,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,6],\"cumulative\":112,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":112,\"pins\":87,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2025-01-05:1\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[3,4],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":27,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":46,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":63,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":71,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":79,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":109,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":139,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",9],\"cumulative\":168,\"score\":29,\"pins\":29,\"split\":false,\"spare\":false,\"open\":false}],\"score\":168,\"pins\":109,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2025-01-05:2\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":37,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":72,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":79,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":96,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":116,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\",8,\"-\"],\"cumulative\":134,\"score\":18,\"pins\":18,\"split\":false,\"spare\":false,\"open\":false}],\"score\":134,\"pins\":101,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":6,\"fouls\":0}},{\"id\":\"Sara:2025-02-16:1\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":38,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":47,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":65,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":74,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\"],\"cumulative\":93,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":102,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":111,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":120,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",9],\"cumulative\":139,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":139,\"pins\":104,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":5,\"single\":3,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2025-02-16:2\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":40,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":49,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":62,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,\"/\"],\"cumulative\":80,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":96,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,2],\"cumulative\":104,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":113,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",8],\"cumulative\":131,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":131,\"pins\":100,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.2,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":5,\"single\":0,\"multiple\":5},\"misses\":1,\"fouls\":0}},{\"id\":\"Sara:2025-03-16:1\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[4,3],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":24,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":32,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":40,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":46,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":73,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":86,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,4],\"cumulative\":93,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":93,\"pins\":82,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2025-03-16:2\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,3],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":9,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":37,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":57,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":74,\"score\":17,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":81,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":108,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":126,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,1],\"cumulative\":134,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":134,\"pins\":82,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2025-04-27:1\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",3],\"cumulative\":3,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":10,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":19,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"/\"],\"cumulative\":45,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":52,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":60,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":69,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":88,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":97,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":97,\"pins\":81,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":7,\"fouls\":0}},{\"id\":\"Sara:2025-04-27:2\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":22,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,5],\"cumulative\":30,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":37,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":64,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":82,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[5,\"/\",7],\"cumulative\":99,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":99,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2025-05-11:1\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":16,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[6,\"/\"],\"cumulative\":26,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",8],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"/\"],\"cumulative\":44,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":53,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":72,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"-\",8],\"cumulative\":80,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[2,\"/\"],\"cumulative\":98,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":106,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":106,\"pins\":92,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.3,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":5,\"single\":2,\"multiple\":3},\"misses\":6,\"fouls\":0}},{\"id\":\"Sara:2025-05-11:2\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":27,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":40,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,4],\"cumulative\":47,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":66,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":85,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":94,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":101,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":109,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":118,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":118,\"pins\":89,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.4,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":4,\"single\":2,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Sara:2025-05-14:1\",\"date\":{\"year\":2025,\"month\":5,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":26,\"score\":26,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,2],\"cumulative\":52,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":72,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,\"/\"],\"cumulative\":90,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":103,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,3],\"cumulative\":109,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":117,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":131,\"score\":14,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[4,\"/\",\"X\"],\"cumulative\":151,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":151,\"pins\":102,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":4,\"spares\":{\"total\":4,\"single\":1,\"multiple\":3},\"misses\":1,\"fouls\":0}},{\"id\":\"Sara:2025-05-14:2\",\"date\":{\"year\":2025,\"month\":5,\"day\":14},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":14,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":23,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":42,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":51,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":68,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":75,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":94,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":103,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",8],\"cumulative\":121,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":121,\"pins\":96,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2025-12-07:1\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",8],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":35,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":53,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":82,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":112,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":142,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":172,\"score\":30,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",\"X\",8],\"cumulative\":200,\"score\":28,\"pins\":28,\"split\":false,\"spare\":false,\"open\":false}],\"score\":200,\"pins\":113,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":5,\"spares\":{\"total\":3,\"single\":3,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Sara:2025-12-07:2\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"/\"],\"cumulative\":37,\"score\":19,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":55,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":64,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":91,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":99,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":108,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":117,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\",\"-\",9],\"cumulative\":136,\"score\":19,\"pins\":19,\"split\":false,\"spare\":false,\"open\":false}],\"score\":136,\"pins\":103,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8.3,\"splits\":{\"total\":5,\"converted\":1},\"strikes\":2,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Sara:2026-01-18:1\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":21,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[5,2],\"cumulative\":28,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":46,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":54,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":63,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":83,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":101,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",8],\"cumulative\":109,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":118,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":118,\"pins\":87,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":5,\"fouls\":0}},{\"id\":\"Sara:2026-01-18:2\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"/\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":37,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":56,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":65,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":85,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":104,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":113,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":132,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":141,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":141,\"pins\":95,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":3,\"spares\":{\"total\":2,\"single\":1,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Sara:2026-03-01:1\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"/\"],\"cumulative\":10,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"-\",9],\"cumulative\":19,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":32,\"score\":13,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",3],\"cumulative\":35,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":44,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":54,\"score\":10,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",\"-\"],\"cumulative\":54,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":64,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[\"-\",8],\"cumulative\":72,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":81,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":81,\"pins\":78,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":2,\"single\":2,\"multiple\":0},\"misses\":7,\"fouls\":0}},{\"id\":\"Sara:2026-03-01:2\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Sara\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":27,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"/\"],\"cumulative\":46,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":72,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,1],\"cumulative\":80,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":88,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":97,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":106,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",9],\"cumulative\":125,\"score\":19,\"pins\":19,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":125,\"pins\":100,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.8,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":4,\"single\":3,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2023-04-30:1\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[1,3],\"cumulative\":4,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":11,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":19,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":26,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":33,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":42,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":48,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":56,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":62,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":65,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true}],\"score\":65,\"pins\":65,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2023-04-30:2\",\"date\":{\"year\":2023,\"month\":4,\"day\":30},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":15,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":24,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,\"/\"],\"cumulative\":41,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":48,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"/\"],\"cumulative\":66,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":75,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":82,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":90,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":97,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":97,\"pins\":82,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.1,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2023-05-07:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":24,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"-\"],\"cumulative\":28,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":47,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":56,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":64,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":71,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":79,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":86,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":86,\"pins\":77,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":6,\"fouls\":0}},{\"id\":\"Calvin:2023-05-07:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[4,4],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,7],\"cumulative\":24,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":33,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":42,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,2],\"cumulative\":47,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":53,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":59,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":65,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":72,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":72,\"pins\":72,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2023-05-14:1\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,5],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":29,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":37,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":44,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":52,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[4,\"-\"],\"cumulative\":56,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":64,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":71,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":71,\"pins\":71,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.9,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2023-05-14:2\",\"date\":{\"year\":2023,\"month\":5,\"day\":14},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,1],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":14,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":22,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":25,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":32,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":38,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":44,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":51,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":64,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,6],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":73,\"pins\":70,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-06-11:1\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,2],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":19,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":27,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":33,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":39,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":46,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":65,\"score\":19,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[9,\"-\"],\"cumulative\":74,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",8],\"cumulative\":92,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":92,\"pins\":83,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-06-11:2\",\"date\":{\"year\":2023,\"month\":6,\"day\":11},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,2],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":36,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":44,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":52,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":60,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":68,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":76,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":83,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":92,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":92,\"pins\":83,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-08-27:1\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":14,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":20,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":28,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":36,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":43,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":51,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":60,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":67,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":76,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true}],\"score\":76,\"pins\":76,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.9,\"splits\":{\"total\":3,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2023-08-27:2\",\"date\":{\"year\":2023,\"month\":8,\"day\":27},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,1],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"/\"],\"cumulative\":30,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,5],\"cumulative\":38,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":44,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":53,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":62,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":67,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":75,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\",7],\"cumulative\":92,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":92,\"pins\":89,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.2,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Calvin:2023-09-24:1\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,4],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":37,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,4],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":70,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,3],\"cumulative\":78,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":85,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\",9,\"/\"],\"cumulative\":105,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":105,\"pins\":85,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":1,\"fouls\":0}},{\"id\":\"Calvin:2023-09-24:2\",\"date\":{\"year\":2023,\"month\":9,\"day\":24},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\"],\"cumulative\":29,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,6],\"cumulative\":38,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":45,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":54,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":61,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":67,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":75,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\",7],\"cumulative\":92,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":92,\"pins\":89,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-10-08:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,4],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":25,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":32,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":41,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,1],\"cumulative\":46,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":52,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":60,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":67,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":74,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":74,\"pins\":74,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2023-10-08:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":8},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":25,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":32,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":40,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":46,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[2,5],\"cumulative\":53,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":59,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":66,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":75,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":75,\"pins\":75,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.2,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2023-10-22:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":22},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":26,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":35,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":41,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,4],\"cumulative\":50,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":59,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":67,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":76,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,3],\"cumulative\":83,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":92,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":92,\"pins\":85,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2023-10-22:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":22},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,2],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":15,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":21,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":30,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":45,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[5,\"-\"],\"cumulative\":50,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":58,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":67,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":70,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":78,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":78,\"pins\":73,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2023-10-29:1\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,\"-\"],\"cumulative\":3,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":11,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":19,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":27,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":34,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[1,7],\"cumulative\":42,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":49,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":55,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":62,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[1,5],\"cumulative\":68,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":68,\"pins\":68,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5,\"splits\":{\"total\":4,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-10-29:2\",\"date\":{\"year\":2023,\"month\":10,\"day\":29},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,\"-\"],\"cumulative\":3,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"/\"],\"cumulative\":20,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":27,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":43,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":59,\"score\":16,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,3],\"cumulative\":65,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":70,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":77,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,4],\"cumulative\":82,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true}],\"score\":82,\"pins\":69,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.8,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2023-11-26:1\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,1],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":12,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":32,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":48,\"score\":16,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,3],\"cumulative\":54,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":61,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":67,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":70,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":77,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":86,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":86,\"pins\":70,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2023-11-26:2\",\"date\":{\"year\":2023,\"month\":11,\"day\":26},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,2],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":12,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":19,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":36,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":43,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":50,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":59,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":65,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":71,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":71,\"pins\":71,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2023-12-03:1\",\"date\":{\"year\":2023,\"month\":12,\"day\":3},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":15,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":21,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":29,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":38,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":44,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":50,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":59,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":67,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":70,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true}],\"score\":70,\"pins\":70,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":6,\"fouls\":0}},{\"id\":\"Calvin:2023-12-03:2\",\"date\":{\"year\":2023,\"month\":12,\"day\":3},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,2],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":15,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,2],\"cumulative\":18,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":34,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[2,\"-\"],\"cumulative\":36,\"score\":2,\"pins\":2,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":42,\"score\":6,\"pins\":6,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":45,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":54,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\",7],\"cumulative\":71,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"single\",\"open\":false}],\"score\":71,\"pins\":71,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.1,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2024-01-07:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,2],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\"],\"cumulative\":23,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":29,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":38,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":46,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":52,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":60,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,1],\"cumulative\":64,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":81,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":81,\"pins\":75,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-01-07:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":22,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":29,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":37,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":46,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":55,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":62,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":71,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":80,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":80,\"pins\":80,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-01-14:1\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[4,\"-\"],\"cumulative\":4,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":11,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":18,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":32,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":39,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,2],\"cumulative\":44,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":51,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[2,1],\"cumulative\":54,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":62,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":62,\"pins\":62,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.5,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":1,\"fouls\":0}},{\"id\":\"Calvin:2024-01-14:2\",\"date\":{\"year\":2024,\"month\":1,\"day\":14},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,1],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":21,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,3],\"cumulative\":29,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,1],\"cumulative\":36,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":44,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":50,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":66,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,1],\"cumulative\":73,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":81,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[1,7],\"cumulative\":89,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":89,\"pins\":78,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":0,\"fouls\":0}},{\"id\":\"Calvin:2024-03-31:1\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,1],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":14,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":21,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":30,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":36,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":44,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":51,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":54,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"-\"],\"cumulative\":58,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\",\"X\"],\"cumulative\":78,\"score\":20,\"pins\":20,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":78,\"pins\":78,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.7,\"splits\":{\"total\":3,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2024-03-31:2\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":23,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":32,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":39,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":66,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":86,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":103,\"score\":17,\"pins\":10,\"split\":\"converted\",\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":120,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":129,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":129,\"pins\":88,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.1,\"splits\":{\"total\":1,\"converted\":1},\"strikes\":2,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-03-31:3\",\"date\":{\"year\":2024,\"month\":3,\"day\":31},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,2],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[8,1],\"cumulative\":53,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":68,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,\"-\"],\"cumulative\":73,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":81,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":90,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":97,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":97,\"pins\":83,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-07-07:1\",\"date\":{\"year\":2024,\"month\":7,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[4,2],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,2],\"cumulative\":13,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":21,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":29,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":36,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":39,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":52,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,3],\"cumulative\":58,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":71,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,4],\"cumulative\":78,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":78,\"pins\":72,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":2,\"single\":0,\"multiple\":2},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-07-07:2\",\"date\":{\"year\":2024,\"month\":7,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,6],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,3],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":23,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\"],\"cumulative\":39,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,3],\"cumulative\":48,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":54,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,1],\"cumulative\":59,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"/\"],\"cumulative\":76,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":91,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[5,\"-\"],\"cumulative\":96,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true}],\"score\":96,\"pins\":78,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":4.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-08-04:1\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[8,1],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":17,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":44,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":62,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,1],\"cumulative\":70,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,\"-\"],\"cumulative\":75,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":83,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":92,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":100,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":107,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":107,\"pins\":82,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":7.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2024-08-04:2\",\"date\":{\"year\":2024,\"month\":8,\"day\":4},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":15,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":21,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":27,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":35,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":43,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":49,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":58,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":75,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,2],\"cumulative\":84,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":84,\"pins\":77,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2024-12-01:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":24,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"/\"],\"cumulative\":40,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,\"-\"],\"cumulative\":46,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"/\"],\"cumulative\":59,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[3,4],\"cumulative\":66,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":89,\"score\":23,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":102,\"score\":13,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[3,\"-\"],\"cumulative\":105,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,4],\"cumulative\":112,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":112,\"pins\":80,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":3,\"single\":0,\"multiple\":3},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2024-12-01:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":1},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,2],\"cumulative\":12,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":23,\"score\":11,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[1,5],\"cumulative\":29,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":44,\"score\":15,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[5,3],\"cumulative\":52,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":59,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":67,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":75,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\",7],\"cumulative\":92,\"score\":17,\"pins\":17,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":92,\"pins\":86,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":3,\"single\":2,\"multiple\":1},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2024-12-08:1\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":13,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":22,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":30,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":38,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"/\"],\"cumulative\":54,\"score\":16,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[6,3],\"cumulative\":63,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":71,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":74,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,4],\"cumulative\":82,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":82,\"pins\":76,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":7,\"fouls\":0}},{\"id\":\"Calvin:2024-12-08:2\",\"date\":{\"year\":2024,\"month\":12,\"day\":8},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[\"X\"],\"cumulative\":19,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[6,3],\"cumulative\":28,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[5,1],\"cumulative\":34,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":47,\"score\":13,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[3,2],\"cumulative\":52,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":61,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":70,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":79,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":88,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":97,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":97,\"pins\":85,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.9,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":1,\"multiple\":0},\"misses\":0,\"fouls\":0}},{\"id\":\"Calvin:2025-01-05:1\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[5,4],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,6],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":27,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":36,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":55,\"score\":19,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[4,5],\"cumulative\":64,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":73,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":82,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":90,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":99,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":99,\"pins\":90,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.5,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":2,\"fouls\":0}},{\"id\":\"Calvin:2025-01-05:2\",\"date\":{\"year\":2025,\"month\":1,\"day\":5},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[3,\"/\"],\"cumulative\":18,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[8,\"-\"],\"cumulative\":26,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":35,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":41,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":49,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,4],\"cumulative\":54,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,2],\"cumulative\":60,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"/\"],\"cumulative\":78,\"score\":18,\"pins\":10,\"split\":false,\"spare\":\"single\",\"open\":false},{\"outcome\":[8,1],\"cumulative\":87,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",8],\"cumulative\":105,\"score\":18,\"pins\":18,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":105,\"pins\":89,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":3,\"single\":1,\"multiple\":2},\"misses\":3,\"fouls\":0}},{\"id\":\"Calvin:2025-02-16:1\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[6,1],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":15,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":23,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":30,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":33,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"/\"],\"cumulative\":50,\"score\":17,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[7,\"-\"],\"cumulative\":57,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":63,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":90,\"score\":27,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\",7,1],\"cumulative\":108,\"score\":18,\"pins\":18,\"split\":false,\"spare\":false,\"open\":false}],\"score\":108,\"pins\":84,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.7,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":5,\"fouls\":0}},{\"id\":\"Calvin:2025-02-16:2\",\"date\":{\"year\":2025,\"month\":2,\"day\":16},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Bumpers\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,2],\"cumulative\":25,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":32,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":40,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,2],\"cumulative\":45,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,2],\"cumulative\":53,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\"],\"cumulative\":73,\"score\":20,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":88,\"score\":15,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",5],\"cumulative\":93,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true}],\"score\":93,\"pins\":78,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":6.2,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":4,\"fouls\":0}},{\"id\":\"Calvin:2025-03-16:1\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",7],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",3],\"cumulative\":10,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":11,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":18,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":25,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true}],\"score\":25,\"pins\":25,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":0.1,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":15,\"fouls\":0}},{\"id\":\"Calvin:2025-03-16:2\",\"date\":{\"year\":2025,\"month\":3,\"day\":16},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",4],\"cumulative\":4,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":4,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":4,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":7,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,5],\"cumulative\":15,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":15,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":15,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":23,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":23,\"pins\":23,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":1.3,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":14,\"fouls\":0}},{\"id\":\"Calvin:2025-04-27:1\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":17,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":17,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":17,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":17,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":20,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":20,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true}],\"score\":20,\"pins\":20,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":17,\"fouls\":0}},{\"id\":\"Calvin:2025-04-27:2\",\"date\":{\"year\":2025,\"month\":4,\"day\":27},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",6],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":6,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":14,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":25,\"score\":11,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",1],\"cumulative\":26,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",6],\"cumulative\":32,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":32,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,3],\"cumulative\":41,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":41,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true}],\"score\":41,\"pins\":40,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":2.4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":1,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":12,\"fouls\":0}},{\"id\":\"Calvin:2025-05-11:1\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":13,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":13,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":14,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":23,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":23,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[4,\"-\"],\"cumulative\":27,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":30,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":37,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":43,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":43,\"pins\":43,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":3.6,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":12,\"fouls\":0}},{\"id\":\"Calvin:2025-05-11:2\",\"date\":{\"year\":2025,\"month\":5,\"day\":11},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":11,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":11,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":17,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":25,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":25,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",5],\"cumulative\":30,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":33,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":33,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true}],\"score\":33,\"pins\":33,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":2,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":14,\"fouls\":0}},{\"id\":\"Calvin:2025-12-07:1\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":6,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":7,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":16,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":23,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":43,\"score\":20,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"X\"],\"cumulative\":57,\"score\":14,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[\"-\",4],\"cumulative\":61,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":69,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",3],\"cumulative\":82,\"score\":13,\"pins\":13,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":82,\"pins\":68,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":7,\"fouls\":0}},{\"id\":\"Calvin:2025-12-07:2\",\"date\":{\"year\":2025,\"month\":12,\"day\":7},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[9,\"-\"],\"cumulative\":9,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,1],\"cumulative\":18,\"score\":9,\"pins\":9,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":18,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":33,\"score\":15,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[5,\"-\"],\"cumulative\":38,\"score\":5,\"pins\":5,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":47,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":56,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"X\"],\"cumulative\":74,\"score\":18,\"pins\":10,\"split\":false,\"spare\":false,\"open\":false},{\"outcome\":[7,1],\"cumulative\":82,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":90,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true}],\"score\":90,\"pins\":77,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":5.7,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":2,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":7,\"fouls\":0}},{\"id\":\"Calvin:2026-01-18:1\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":16,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":16,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",5],\"cumulative\":21,\"score\":5,\"pins\":5,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,\"-\"],\"cumulative\":24,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":32,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":39,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":39,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[9,\"-\"],\"cumulative\":48,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true}],\"score\":48,\"pins\":48,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":3.4,\"splits\":{\"total\":1,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":12,\"fouls\":0}},{\"id\":\"Calvin:2026-01-18:2\",\"date\":{\"year\":2026,\"month\":1,\"day\":18},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,1],\"cumulative\":8,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":8,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",7],\"cumulative\":15,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",9],\"cumulative\":24,\"score\":9,\"pins\":9,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":24,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":32,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"-\"],\"cumulative\":39,\"score\":7,\"pins\":7,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",2],\"cumulative\":41,\"score\":2,\"pins\":2,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",3],\"cumulative\":44,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":44,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true}],\"score\":44,\"pins\":44,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":1.4,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":12,\"fouls\":0}},{\"id\":\"Calvin:2026-03-01:1\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[7,\"-\"],\"cumulative\":7,\"score\":7,\"pins\":7,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":7,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":8,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[3,3],\"cumulative\":14,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":14,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":14,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":22,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,1],\"cumulative\":30,\"score\":8,\"pins\":8,\"split\":\"yes\",\"spare\":false,\"open\":true},{\"outcome\":[\"-\",4],\"cumulative\":34,\"score\":4,\"pins\":4,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[7,\"/\",\"-\"],\"cumulative\":44,\"score\":10,\"pins\":10,\"split\":false,\"spare\":\"multiple\",\"open\":false}],\"score\":44,\"pins\":44,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":3.3,\"splits\":{\"total\":2,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":1,\"single\":0,\"multiple\":1},\"misses\":11,\"fouls\":0}},{\"id\":\"Calvin:2026-03-01:2\",\"date\":{\"year\":2026,\"month\":3,\"day\":1},\"user\":\"Calvin\",\"ball\":\"Unknown\",\"oilPattern\":\"Typical House Shot\",\"frames\":[{\"outcome\":[\"-\",\"-\"],\"cumulative\":0,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[1,\"-\"],\"cumulative\":1,\"score\":1,\"pins\":1,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",8],\"cumulative\":9,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",\"-\"],\"cumulative\":9,\"score\":0,\"pins\":0,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[2,\"-\"],\"cumulative\":11,\"score\":2,\"pins\":2,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":19,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",3],\"cumulative\":22,\"score\":3,\"pins\":3,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[6,\"-\"],\"cumulative\":28,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[8,\"-\"],\"cumulative\":36,\"score\":8,\"pins\":8,\"split\":false,\"spare\":false,\"open\":true},{\"outcome\":[\"-\",6],\"cumulative\":42,\"score\":6,\"pins\":6,\"split\":false,\"spare\":false,\"open\":true}],\"score\":42,\"pins\":42,\"perfect\":false,\"stats\":{\"avgFirstBallPinfall\":2.5,\"splits\":{\"total\":0,\"converted\":0},\"strikes\":0,\"spares\":{\"total\":0,\"single\":0,\"multiple\":0},\"misses\":12,\"fouls\":0}}],\"leagues\":[]}");


const $474651c903ea0c46$var$allGames = (0, (/*@__PURE__*/$parcel$interopDefault($d25683810566fb38$exports))).games;
const $474651c903ea0c46$var$avgReducer = (acc, game)=>acc + game.score;
const $474651c903ea0c46$var$pinsReducer = (acc, game)=>acc + game.pins;
const $474651c903ea0c46$var$absDeviationReducer = (avg)=>(acc, game)=>acc + Math.abs(game.score - avg);
const $474651c903ea0c46$var$stdDeviationReducer = (avg)=>(acc, game)=>acc + Math.abs(game.score - avg) ** 2;
const $474651c903ea0c46$var$bestReducer = (acc, game)=>Math.max(acc, game.score);
const $474651c903ea0c46$var$worstReducer = (acc, game)=>Math.min(acc, game.score);
const $474651c903ea0c46$var$strikesReducer = (acc, game)=>acc + game.stats.strikes;
const $474651c903ea0c46$var$sparesReducer = (acc, game)=>acc + game.stats.spares.total;
const $474651c903ea0c46$var$avgFBPReducer = (acc, game)=>acc + game.stats.avgFirstBallPinfall;
const $474651c903ea0c46$export$431f78a03a8ddc84 = (user = "Mike", year = null, month = null, day = null, withHouseBallGames = true, withDryLaneGames = true)=>{
    const filteredGames = $474651c903ea0c46$var$allGames.filter((game)=>withHouseBallGames ? true : !game.ball.startsWith("H")).filter((game)=>withDryLaneGames ? true : !!game.oilPattern).filter((game)=>game.user === user);
    const games = filteredGames.filter((game)=>year === null ? true : game.date.year === year && (month === null ? true : game.date.month === month && (day === null ? true : game.date.day === day)));
    const avg = Math.round(games.reduce($474651c903ea0c46$var$avgReducer, 0) / games.length);
    return {
        games: games,
        leagues: (0, (/*@__PURE__*/$parcel$interopDefault($d25683810566fb38$exports))).leagues,
        filters: {
            year: year,
            month: month,
            day: day,
            lists: {
                years: filteredGames.reduce((acc, game)=>{
                    const set = new Set(acc);
                    set.add(game.date.year);
                    return Array.from(set);
                }, []),
                months: Array.from(new Array(12).keys()).filter((mnth)=>!!filteredGames.find((game)=>game.date.year === year && game.date.month === mnth + 1)),
                days: filteredGames.filter((game)=>game.date.year === year && game.date.month === month).reduce((acc, game)=>Array.from(new Set(acc).add(game.date.day)), [])
            },
            withHouseBallGames: withHouseBallGames,
            withDryLaneGames: withDryLaneGames
        },
        stats: {
            games: games.length,
            pins: games.reduce($474651c903ea0c46$var$pinsReducer, 0),
            avg: {
                value: avg,
                best: games.reduce($474651c903ea0c46$var$bestReducer, 0),
                worst: games.reduce($474651c903ea0c46$var$worstReducer, 300),
                stdDeviation: +Math.sqrt(games.reduce($474651c903ea0c46$var$stdDeviationReducer(avg), 0) / games.length).toFixed(2),
                absDeviation: +(games.reduce($474651c903ea0c46$var$absDeviationReducer(avg), 0) / avg).toFixed(2)
            },
            strikes: {
                value: +(games.reduce($474651c903ea0c46$var$strikesReducer, 0) / (games.length * 12) * 100).toFixed(2),
                best: +(Math.max(...games.map((game)=>game.stats.strikes)) / 12 * 100).toFixed(2)
            },
            spares: {
                value: +(games.reduce($474651c903ea0c46$var$sparesReducer, 0) / (games.length * 10) * 100).toFixed(2),
                best: +(Math.max(...games.map((game)=>game.stats.spares.total)) / 10 * 100).toFixed(2)
            },
            avgFirstBallPinfall: {
                value: +(games.reduce($474651c903ea0c46$var$avgFBPReducer, 0) / games.length).toFixed(2),
                best: +Math.max(...games.map((game)=>game.stats.avgFirstBallPinfall)).toFixed(2)
            }
        }
    };
};
const $474651c903ea0c46$export$129055f0840a203c = (0, $5pP8j.createContext)($474651c903ea0c46$export$431f78a03a8ddc84(true));
const $474651c903ea0c46$export$b514f4c5cf6dd8e6 = $474651c903ea0c46$export$129055f0840a203c.Provider;


const $5f382a079ec029d4$export$c1cf1cf4c5d51937 = ()=>(0, $5pP8j.useContext)((0, $474651c903ea0c46$export$129055f0840a203c));



const $8c32eeaed83a1a3d$var$BSP = "\u0020";
const $8c32eeaed83a1a3d$var$Numbers = ()=>{
    const { stats: stats } = (0, $5f382a079ec029d4$export$c1cf1cf4c5d51937)();
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("level", "is-align-items-start"),
        children: [
            [
                "Games",
                stats.games
            ],
            [
                "Avg Score",
                stats.avg.value,
                stats.avg.best,
                stats.avg.stdDeviation,
                (0, (/*@__PURE__*/$parcel$interopDefault($404ccd9e674a6806$exports))).goals.avgScorePerGame
            ],
            [
                "Avg First Ball Pinfall",
                stats.avgFirstBallPinfall.value,
                stats.avgFirstBallPinfall.best,
                null,
                (0, (/*@__PURE__*/$parcel$interopDefault($404ccd9e674a6806$exports))).goals.avgFirstBallPinfall
            ],
            [
                "Strikes",
                `${stats.strikes.value}%`,
                `${stats.strikes.best}%`
            ],
            [
                "Spares",
                `${stats.spares.value}%`,
                `${stats.spares.best}%`
            ],
            [
                "Pins",
                stats.pins
            ]
        ].map(([label, value, best, stdDeviation, goal])=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("level-item", "has-text-centered"),
                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("p", {
                            className: "heading",
                            children: label
                        }),
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("p", {
                            className: "title",
                            children: value
                        }),
                        !!(goal && value) && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-size-6"),
                            children: [
                                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("small", {
                                    className: "has-text-grey-light",
                                    style: {
                                        verticalAlign: 1
                                    },
                                    children: "goal:"
                                }),
                                $8c32eeaed83a1a3d$var$BSP,
                                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                                    className: value >= goal ? "has-text-success" : "has-text-danger",
                                    children: goal
                                })
                            ]
                        }),
                        !!stdDeviation && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-size-7"),
                            children: [
                                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("small", {
                                    className: "has-text-grey-light",
                                    style: {
                                        verticalAlign: 1
                                    },
                                    children: "std. deviation:"
                                }),
                                $8c32eeaed83a1a3d$var$BSP,
                                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                                    className: "has-text-info",
                                    children: stdDeviation
                                })
                            ]
                        }),
                        !!best && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-size-7"),
                            children: [
                                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("small", {
                                    className: "has-text-grey-light",
                                    style: {
                                        verticalAlign: 1
                                    },
                                    children: "best:"
                                }),
                                $8c32eeaed83a1a3d$var$BSP,
                                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("strong", {
                                    className: "has-text-success",
                                    children: [
                                        " ",
                                        best,
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, label))
    });
};
var $8c32eeaed83a1a3d$export$2e2bcd8739ae039 = $8c32eeaed83a1a3d$var$Numbers;


/* @leny/bowlstats
 *
 * /src/components/filters.tsx
 */ 



var $5pP8j = parcelRequire("5pP8j");
/* @leny/bowlstats
 *
 * /src/core/utils.ts
 */ /* eslint-disable @typescript-eslint/no-unused-expressions */ const $0bbe7c18ba863365$export$2fc09de897439556 = (outcome, isLastFrame = false)=>{
    if (!isLastFrame) {
        if (outcome.includes("X") || outcome.includes("/")) return 10;
        return outcome.reduce((acc, ball)=>acc + (typeof ball === "number" ? ball : 0), 0);
    }
    let pinsCount = 0;
    const [one, two, three] = outcome;
    if (one === "X") pinsCount += 10;
    else if (typeof one === "number" && two !== "/" && three !== "/") pinsCount += one;
    if (two === "/" || two === "X") pinsCount += 10;
    else if (typeof two === "number" && three !== "/") pinsCount += two;
    if (three === "/" || three === "X") pinsCount += 10;
    else if (typeof three === "number") pinsCount += three;
    return pinsCount;
};
const $0bbe7c18ba863365$export$fa3b29edae795ef4 = (handler, stopPropagation = false)=>(e)=>{
        e.preventDefault();
        stopPropagation && e.stopPropagation();
        handler(e);
    };


var $1038fe58d0f12ce6$exports = {};
!function(t, e) {
    $1038fe58d0f12ce6$exports = e();
}($1038fe58d0f12ce6$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


const $4f185fdd507ab799$var$currentYear = new Date().getFullYear();
const $4f185fdd507ab799$var$currentMonth = new Date().getMonth();
const $4f185fdd507ab799$var$NBSP = "\u00a0";
const $4f185fdd507ab799$var$Filters = ({ user: user, year: year, month: month, day: day, withHouseBallGames: withHouseBallGames, withDryLaneGames: withDryLaneGames, onYearChange: onYearChange, onMonthChange: onMonthChange, onDayChange: onDayChange, onUserChange: onUserChange, toggleHouseBallGames: toggleHouseBallGames, toggleDryLaneGames: toggleDryLaneGames })=>{
    const { filters: filters } = (0, $5f382a079ec029d4$export$c1cf1cf4c5d51937)();
    const years = (0, $5pP8j.useMemo)(()=>[
            "All",
            ...filters.lists.years.reverse()
        ], [
        filters
    ]);
    const months = (0, $5pP8j.useMemo)(()=>{
        if (year === null) return [];
        return [
            "All",
            ...filters.lists.months
        ];
    }, [
        year,
        filters
    ]);
    const days = (0, $5pP8j.useMemo)(()=>{
        if (year === null) return [];
        return [
            "All",
            ...filters.lists.days
        ];
    }, [
        year,
        filters
    ]);
    const users = [
        "Mike",
        "Sara",
        "Calvin"
    ];
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $3604a940d8232154$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("columns"),
                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("column"),
                    children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("tabs", "is-large"),
                        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("ul", {
                            children: users.map((u)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("li", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))(user === u && "is-active"),
                                    children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("a", {
                                        href: "#",
                                        onClick: (0, $0bbe7c18ba863365$export$fa3b29edae795ef4)(()=>{
                                            onUserChange(u);
                                        }),
                                        children: u
                                    })
                                }, u))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("columns"),
                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("column"),
                    children: [
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("tabs", "is-large"),
                            children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("ul", {
                                children: years.map((yr)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("li", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))((year === null && yr === "All" || year === yr) && "is-active"),
                                        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("a", {
                                            href: "#",
                                            onClick: (0, $0bbe7c18ba863365$export$fa3b29edae795ef4)(()=>{
                                                onYearChange(yr === "All" ? null : yr);
                                                onMonthChange(null);
                                                onDayChange(null);
                                            }),
                                            children: yr
                                        })
                                    }, yr))
                            })
                        }),
                        year !== null && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("tabs"),
                            children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("ul", {
                                children: months.map((i)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("li", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))((i === "All" && month === null || i + 1 === month) && "is-active"),
                                        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("a", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("px-3"),
                                            href: "#",
                                            onClick: (0, $0bbe7c18ba863365$export$fa3b29edae795ef4)(()=>{
                                                onMonthChange(i === "All" ? null : i + 1);
                                                onDayChange(null);
                                            }),
                                            children: i === "All" ? "All" : (0, (/*@__PURE__*/$parcel$interopDefault($1038fe58d0f12ce6$exports)))().set("month", i).format("MMM")
                                        })
                                    }, i))
                            })
                        }),
                        year !== null && month !== null && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("tabs", "is-small"),
                            children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("ul", {
                                children: days.map((i)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("li", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))((i === "All" && day === null || i === day) && "is-active"),
                                        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("a", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("px-1"),
                                            href: "#",
                                            onClick: (0, $0bbe7c18ba863365$export$fa3b29edae795ef4)(()=>{
                                                onDayChange(i === "All" ? null : i);
                                            }),
                                            children: i === "All" ? "All" : `${i}`.padStart(2, "0")
                                        })
                                    }, i))
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $4f185fdd507ab799$export$2e2bcd8739ae039 = $4f185fdd507ab799$var$Filters;


/* @leny/bowlstats
 *
 * /src/components/games.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.


var $5pP8j = parcelRequire("5pP8j");


/* @leny/bowlstats
 *
 * /src/components/game.tsx
 */ 

var $5pP8j = parcelRequire("5pP8j");

/* @leny/bowlstats
 *
 * /src/components/game-frames.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.

/* @leny/bowlstats
 *
 * /src/components/game-frame-outcome.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.


var $5pP8j = parcelRequire("5pP8j");

const $6f6dacfaebc58608$var$NBSP = "\u00a0";
const $6f6dacfaebc58608$var$ballStyles = {
    marginTop: -1,
    marginRight: -1,
    marginLeft: "auto"
};
const $6f6dacfaebc58608$var$GameFrameOutcome = ({ frame: frame, lastFrame: lastFrame, compact: compact = false })=>{
    // convert the outcome tuple to an array of strings
    const frameOutcome = (0, $5pP8j.useMemo)(()=>{
        let outcome = frame.outcome;
        if (lastFrame) {
            if (outcome.length === 2) outcome.push($6f6dacfaebc58608$var$NBSP);
        } else if (outcome.length === 1 && outcome[0] === "X") outcome = [
            $6f6dacfaebc58608$var$NBSP,
            "X"
        ];
        return outcome;
    }, [
        frame
    ]);
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("table", {
        style: $6f6dacfaebc58608$var$ballStyles,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("table", "is-bordered"),
        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("tbody", {
            children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("tr", {
                children: frameOutcome.map((outcome, index)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-family-monospace", "is-size-7", "py-1", "px-1", outcome === "X" && "has-text-success", outcome === "/" && "has-text-info", outcome === "F" && "has-text-danger", outcome === "-" && "has-text-danger", frame.split && index === 0 && "is-split-frame"),
                        children: outcome
                    }, index))
            })
        })
    });
};
var $6f6dacfaebc58608$export$2e2bcd8739ae039 = $6f6dacfaebc58608$var$GameFrameOutcome;



const $76bc3af6f0cb3e60$var$GameFrames = ({ frames: frames, scratch: scratch, handicap: handicap, score: score, compact: compact = false, hideHeader: hideHeader = false })=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("table", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("table", "is-bordered", "is-fullwidth", `mb-${compact ? 0 : 4}`),
        children: [
            !hideHeader && (compact || /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("tr", {
                    children: [
                        Array.from(new Array(10).keys()).map((i)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("th", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-centered", "has-text-grey-light", "py-1"),
                                width: i === 9 ? "11.25%" : "8.6%",
                                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("small", {
                                    children: i + 1
                                })
                            }, i)),
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("th", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-centered", "has-text-grey-light", "py-1"),
                            width: "11.2%",
                            children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("small", {
                                children: scratch ? "Result" : ""
                            })
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("tbody", {
                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("tr", {
                    children: [
                        frames.map((frame, index)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("td", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("p-0", "pb-1"),
                                width: index === 9 ? "11.25%" : "8.6%",
                                children: [
                                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-right", "mb-2"),
                                        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $6f6dacfaebc58608$export$2e2bcd8739ae039), {
                                            frame: frame,
                                            lastFrame: index === 9,
                                            compact: compact
                                        })
                                    }),
                                    compact || /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-centered", "is-block", "has-text-grey"),
                                        children: frame.cumulative
                                    })
                                ]
                            }, index)),
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("td", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-vcentered", "is-size-5", "has-text-centered", "has-text-weight-medium", scratch ? [
                                "pb-1",
                                "pt-0",
                                "pr-0",
                                "pl-2"
                            ] : compact && [
                                "py-1",
                                "px-2"
                            ]),
                            width: "11.2%",
                            children: [
                                scratch && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-right", "mb-2"),
                                    children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $6f6dacfaebc58608$export$2e2bcd8739ae039), {
                                        frame: {
                                            outcome: [
                                                scratch,
                                                handicap || 0
                                            ]
                                        },
                                        compact: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))(scratch && "pr-2"),
                                    children: score
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
var $76bc3af6f0cb3e60$export$2e2bcd8739ae039 = $76bc3af6f0cb3e60$var$GameFrames;


/* @leny/bowlstats
 *
 * /src/components/game-stats.tsx
 */ 

var $5pP8j = parcelRequire("5pP8j");

var $e151d7d4cf638963$exports = {};
var $15761e4e379c96ab$exports = {};
var $de179d6f42a5cc43$exports = {};

var $lAA3U = parcelRequire("lAA3U");
/** Built-in value references. */ var $de179d6f42a5cc43$var$Symbol = $lAA3U.Symbol;
$de179d6f42a5cc43$exports = $de179d6f42a5cc43$var$Symbol;


var $41efa5a941fc2ec7$exports = {};

/** Used for built-in method references. */ var $41efa5a941fc2ec7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $41efa5a941fc2ec7$var$hasOwnProperty = $41efa5a941fc2ec7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $41efa5a941fc2ec7$var$nativeObjectToString = $41efa5a941fc2ec7$var$objectProto.toString;
/** Built-in value references. */ var $41efa5a941fc2ec7$var$symToStringTag = $de179d6f42a5cc43$exports ? $de179d6f42a5cc43$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $41efa5a941fc2ec7$var$getRawTag(value) {
    var isOwn = $41efa5a941fc2ec7$var$hasOwnProperty.call(value, $41efa5a941fc2ec7$var$symToStringTag), tag = value[$41efa5a941fc2ec7$var$symToStringTag];
    try {
        value[$41efa5a941fc2ec7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $41efa5a941fc2ec7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$41efa5a941fc2ec7$var$symToStringTag] = tag;
        else delete value[$41efa5a941fc2ec7$var$symToStringTag];
    }
    return result;
}
$41efa5a941fc2ec7$exports = $41efa5a941fc2ec7$var$getRawTag;


var $3ce8cce359d1e92f$exports = {};
/** Used for built-in method references. */ var $3ce8cce359d1e92f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3ce8cce359d1e92f$var$nativeObjectToString = $3ce8cce359d1e92f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3ce8cce359d1e92f$var$objectToString(value) {
    return $3ce8cce359d1e92f$var$nativeObjectToString.call(value);
}
$3ce8cce359d1e92f$exports = $3ce8cce359d1e92f$var$objectToString;


/** `Object#toString` result references. */ var $15761e4e379c96ab$var$nullTag = '[object Null]', $15761e4e379c96ab$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $15761e4e379c96ab$var$symToStringTag = $de179d6f42a5cc43$exports ? $de179d6f42a5cc43$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $15761e4e379c96ab$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $15761e4e379c96ab$var$undefinedTag : $15761e4e379c96ab$var$nullTag;
    return $15761e4e379c96ab$var$symToStringTag && $15761e4e379c96ab$var$symToStringTag in Object(value) ? $41efa5a941fc2ec7$exports(value) : $3ce8cce359d1e92f$exports(value);
}
$15761e4e379c96ab$exports = $15761e4e379c96ab$var$baseGetTag;


var $0e1bd391425671ea$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $0e1bd391425671ea$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$0e1bd391425671ea$exports = $0e1bd391425671ea$var$isObject;


/** `Object#toString` result references. */ var $e151d7d4cf638963$var$asyncTag = '[object AsyncFunction]', $e151d7d4cf638963$var$funcTag = '[object Function]', $e151d7d4cf638963$var$genTag = '[object GeneratorFunction]', $e151d7d4cf638963$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e151d7d4cf638963$var$isFunction(value) {
    if (!$0e1bd391425671ea$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $15761e4e379c96ab$exports(value);
    return tag == $e151d7d4cf638963$var$funcTag || tag == $e151d7d4cf638963$var$genTag || tag == $e151d7d4cf638963$var$asyncTag || tag == $e151d7d4cf638963$var$proxyTag;
}
$e151d7d4cf638963$exports = $e151d7d4cf638963$var$isFunction;



var $5pP8j = parcelRequire("5pP8j");
var $cc70d38e3e17d56b$exports = {};
var $c42aa351ce1d5d03$exports = {};
var $8a458eb14ebc3f75$exports = {};
var $02148300ecce42f1$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $02148300ecce42f1$var$isArray = Array.isArray;
$02148300ecce42f1$exports = $02148300ecce42f1$var$isArray;


var $46c1bfc064ebc34b$exports = {};

var $cda1c6b7d8f0286a$exports = {};

var $713b03e77fe310b2$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $713b03e77fe310b2$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$713b03e77fe310b2$exports = $713b03e77fe310b2$var$isObjectLike;


/** `Object#toString` result references. */ var $cda1c6b7d8f0286a$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $cda1c6b7d8f0286a$var$isSymbol(value) {
    return typeof value == 'symbol' || $713b03e77fe310b2$exports(value) && $15761e4e379c96ab$exports(value) == $cda1c6b7d8f0286a$var$symbolTag;
}
$cda1c6b7d8f0286a$exports = $cda1c6b7d8f0286a$var$isSymbol;


/** Used to match property names within property paths. */ var $46c1bfc064ebc34b$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $46c1bfc064ebc34b$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $46c1bfc064ebc34b$var$isKey(value, object) {
    if ($02148300ecce42f1$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $cda1c6b7d8f0286a$exports(value)) return true;
    return $46c1bfc064ebc34b$var$reIsPlainProp.test(value) || !$46c1bfc064ebc34b$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$46c1bfc064ebc34b$exports = $46c1bfc064ebc34b$var$isKey;


var $dfec0fd811669f01$exports = {};
var $f4672a0b2c62c7db$exports = {};
var $c2e174f2c63f8bbf$exports = {};
var $893551625febb32a$exports = {};
var $fddcfccc2d3dbf5c$exports = {};
var $9952785e19499c4c$exports = {};
var $66510556b820f56d$exports = {};
var $4299e02697757a1a$exports = {};
var $db96872dbd237c27$exports = {};
var $f1e96472d505fca6$exports = {};

var $c75765649700074a$exports = {};
var $036f17ffe4d9f78d$exports = {};

var $lAA3U = parcelRequire("lAA3U");
/** Used to detect overreaching core-js shims. */ var $036f17ffe4d9f78d$var$coreJsData = $lAA3U["__core-js_shared__"];
$036f17ffe4d9f78d$exports = $036f17ffe4d9f78d$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $c75765649700074a$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($036f17ffe4d9f78d$exports && $036f17ffe4d9f78d$exports.keys && $036f17ffe4d9f78d$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $c75765649700074a$var$isMasked(func) {
    return !!$c75765649700074a$var$maskSrcKey && $c75765649700074a$var$maskSrcKey in func;
}
$c75765649700074a$exports = $c75765649700074a$var$isMasked;



var $0318cf147537afbe$exports = {};
/** Used for built-in method references. */ var $0318cf147537afbe$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $0318cf147537afbe$var$funcToString = $0318cf147537afbe$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $0318cf147537afbe$var$toSource(func) {
    if (func != null) {
        try {
            return $0318cf147537afbe$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$0318cf147537afbe$exports = $0318cf147537afbe$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $f1e96472d505fca6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $f1e96472d505fca6$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $f1e96472d505fca6$var$funcProto = Function.prototype, $f1e96472d505fca6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f1e96472d505fca6$var$funcToString = $f1e96472d505fca6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f1e96472d505fca6$var$hasOwnProperty = $f1e96472d505fca6$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $f1e96472d505fca6$var$reIsNative = RegExp('^' + $f1e96472d505fca6$var$funcToString.call($f1e96472d505fca6$var$hasOwnProperty).replace($f1e96472d505fca6$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $f1e96472d505fca6$var$baseIsNative(value) {
    if (!$0e1bd391425671ea$exports(value) || $c75765649700074a$exports(value)) return false;
    var pattern = $e151d7d4cf638963$exports(value) ? $f1e96472d505fca6$var$reIsNative : $f1e96472d505fca6$var$reIsHostCtor;
    return pattern.test($0318cf147537afbe$exports(value));
}
$f1e96472d505fca6$exports = $f1e96472d505fca6$var$baseIsNative;


var $d53a0bd154172680$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d53a0bd154172680$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d53a0bd154172680$exports = $d53a0bd154172680$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $db96872dbd237c27$var$getNative(object, key) {
    var value = $d53a0bd154172680$exports(object, key);
    return $f1e96472d505fca6$exports(value) ? value : undefined;
}
$db96872dbd237c27$exports = $db96872dbd237c27$var$getNative;


/* Built-in method references that are verified to be native. */ var $4299e02697757a1a$var$nativeCreate = $db96872dbd237c27$exports(Object, 'create');
$4299e02697757a1a$exports = $4299e02697757a1a$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $66510556b820f56d$var$hashClear() {
    this.__data__ = $4299e02697757a1a$exports ? $4299e02697757a1a$exports(null) : {};
    this.size = 0;
}
$66510556b820f56d$exports = $66510556b820f56d$var$hashClear;


var $fedd177f95e7cd1d$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fedd177f95e7cd1d$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$fedd177f95e7cd1d$exports = $fedd177f95e7cd1d$var$hashDelete;


var $20263323f4b2eec8$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $20263323f4b2eec8$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $20263323f4b2eec8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $20263323f4b2eec8$var$hasOwnProperty = $20263323f4b2eec8$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $20263323f4b2eec8$var$hashGet(key) {
    var data = this.__data__;
    if ($4299e02697757a1a$exports) {
        var result = data[key];
        return result === $20263323f4b2eec8$var$HASH_UNDEFINED ? undefined : result;
    }
    return $20263323f4b2eec8$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$20263323f4b2eec8$exports = $20263323f4b2eec8$var$hashGet;


var $f913db431a7b75ee$exports = {};

/** Used for built-in method references. */ var $f913db431a7b75ee$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f913db431a7b75ee$var$hasOwnProperty = $f913db431a7b75ee$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f913db431a7b75ee$var$hashHas(key) {
    var data = this.__data__;
    return $4299e02697757a1a$exports ? data[key] !== undefined : $f913db431a7b75ee$var$hasOwnProperty.call(data, key);
}
$f913db431a7b75ee$exports = $f913db431a7b75ee$var$hashHas;


var $c3f7a6787eb0c439$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $c3f7a6787eb0c439$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c3f7a6787eb0c439$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $4299e02697757a1a$exports && value === undefined ? $c3f7a6787eb0c439$var$HASH_UNDEFINED : value;
    return this;
}
$c3f7a6787eb0c439$exports = $c3f7a6787eb0c439$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9952785e19499c4c$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$9952785e19499c4c$var$Hash.prototype.clear = $66510556b820f56d$exports;
$9952785e19499c4c$var$Hash.prototype['delete'] = $fedd177f95e7cd1d$exports;
$9952785e19499c4c$var$Hash.prototype.get = $20263323f4b2eec8$exports;
$9952785e19499c4c$var$Hash.prototype.has = $f913db431a7b75ee$exports;
$9952785e19499c4c$var$Hash.prototype.set = $c3f7a6787eb0c439$exports;
$9952785e19499c4c$exports = $9952785e19499c4c$var$Hash;


var $1d347293a3e9bfaa$exports = {};
var $17e4b03588e07e93$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $17e4b03588e07e93$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$17e4b03588e07e93$exports = $17e4b03588e07e93$var$listCacheClear;


var $7a24301a5c2da31b$exports = {};
var $2035027cc97a15b7$exports = {};
var $05a5c93574ccef83$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $05a5c93574ccef83$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$05a5c93574ccef83$exports = $05a5c93574ccef83$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2035027cc97a15b7$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($05a5c93574ccef83$exports(array[length][0], key)) return length;
    }
    return -1;
}
$2035027cc97a15b7$exports = $2035027cc97a15b7$var$assocIndexOf;


/** Used for built-in method references. */ var $7a24301a5c2da31b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $7a24301a5c2da31b$var$splice = $7a24301a5c2da31b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7a24301a5c2da31b$var$listCacheDelete(key) {
    var data = this.__data__, index = $2035027cc97a15b7$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $7a24301a5c2da31b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$7a24301a5c2da31b$exports = $7a24301a5c2da31b$var$listCacheDelete;


var $d2cb8f884b6e7548$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d2cb8f884b6e7548$var$listCacheGet(key) {
    var data = this.__data__, index = $2035027cc97a15b7$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$d2cb8f884b6e7548$exports = $d2cb8f884b6e7548$var$listCacheGet;


var $ad833e3f350cc6dd$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ad833e3f350cc6dd$var$listCacheHas(key) {
    return $2035027cc97a15b7$exports(this.__data__, key) > -1;
}
$ad833e3f350cc6dd$exports = $ad833e3f350cc6dd$var$listCacheHas;


var $dec673e533f82794$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $dec673e533f82794$var$listCacheSet(key, value) {
    var data = this.__data__, index = $2035027cc97a15b7$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$dec673e533f82794$exports = $dec673e533f82794$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1d347293a3e9bfaa$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$1d347293a3e9bfaa$var$ListCache.prototype.clear = $17e4b03588e07e93$exports;
$1d347293a3e9bfaa$var$ListCache.prototype['delete'] = $7a24301a5c2da31b$exports;
$1d347293a3e9bfaa$var$ListCache.prototype.get = $d2cb8f884b6e7548$exports;
$1d347293a3e9bfaa$var$ListCache.prototype.has = $ad833e3f350cc6dd$exports;
$1d347293a3e9bfaa$var$ListCache.prototype.set = $dec673e533f82794$exports;
$1d347293a3e9bfaa$exports = $1d347293a3e9bfaa$var$ListCache;


var $300d1f2b91f79d61$exports = {};


var $lAA3U = parcelRequire("lAA3U");
/* Built-in method references that are verified to be native. */ var $300d1f2b91f79d61$var$Map = $db96872dbd237c27$exports($lAA3U, 'Map');
$300d1f2b91f79d61$exports = $300d1f2b91f79d61$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $fddcfccc2d3dbf5c$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $9952785e19499c4c$exports,
        'map': new ($300d1f2b91f79d61$exports || $1d347293a3e9bfaa$exports),
        'string': new $9952785e19499c4c$exports
    };
}
$fddcfccc2d3dbf5c$exports = $fddcfccc2d3dbf5c$var$mapCacheClear;


var $9516d5038a08558a$exports = {};
var $0c6ffd6d1dde61f4$exports = {};
var $1b6b9dc5cc30437f$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $1b6b9dc5cc30437f$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$1b6b9dc5cc30437f$exports = $1b6b9dc5cc30437f$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $0c6ffd6d1dde61f4$var$getMapData(map, key) {
    var data = map.__data__;
    return $1b6b9dc5cc30437f$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$0c6ffd6d1dde61f4$exports = $0c6ffd6d1dde61f4$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9516d5038a08558a$var$mapCacheDelete(key) {
    var result = $0c6ffd6d1dde61f4$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$9516d5038a08558a$exports = $9516d5038a08558a$var$mapCacheDelete;


var $edd091f02e823071$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $edd091f02e823071$var$mapCacheGet(key) {
    return $0c6ffd6d1dde61f4$exports(this, key).get(key);
}
$edd091f02e823071$exports = $edd091f02e823071$var$mapCacheGet;


var $f778ef1bcfd62aeb$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f778ef1bcfd62aeb$var$mapCacheHas(key) {
    return $0c6ffd6d1dde61f4$exports(this, key).has(key);
}
$f778ef1bcfd62aeb$exports = $f778ef1bcfd62aeb$var$mapCacheHas;


var $b640d1d787e969c4$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b640d1d787e969c4$var$mapCacheSet(key, value) {
    var data = $0c6ffd6d1dde61f4$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$b640d1d787e969c4$exports = $b640d1d787e969c4$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $893551625febb32a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$893551625febb32a$var$MapCache.prototype.clear = $fddcfccc2d3dbf5c$exports;
$893551625febb32a$var$MapCache.prototype['delete'] = $9516d5038a08558a$exports;
$893551625febb32a$var$MapCache.prototype.get = $edd091f02e823071$exports;
$893551625febb32a$var$MapCache.prototype.has = $f778ef1bcfd62aeb$exports;
$893551625febb32a$var$MapCache.prototype.set = $b640d1d787e969c4$exports;
$893551625febb32a$exports = $893551625febb32a$var$MapCache;


/** Error message constants. */ var $c2e174f2c63f8bbf$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c2e174f2c63f8bbf$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($c2e174f2c63f8bbf$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($c2e174f2c63f8bbf$var$memoize.Cache || $893551625febb32a$exports);
    return memoized;
}
// Expose `MapCache`.
$c2e174f2c63f8bbf$var$memoize.Cache = $893551625febb32a$exports;
$c2e174f2c63f8bbf$exports = $c2e174f2c63f8bbf$var$memoize;


/** Used as the maximum memoize cache size. */ var $f4672a0b2c62c7db$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $f4672a0b2c62c7db$var$memoizeCapped(func) {
    var result = $c2e174f2c63f8bbf$exports(func, function(key) {
        if (cache.size === $f4672a0b2c62c7db$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$f4672a0b2c62c7db$exports = $f4672a0b2c62c7db$var$memoizeCapped;


/** Used to match property names within property paths. */ var $dfec0fd811669f01$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $dfec0fd811669f01$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $dfec0fd811669f01$var$stringToPath = $f4672a0b2c62c7db$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($dfec0fd811669f01$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($dfec0fd811669f01$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$dfec0fd811669f01$exports = $dfec0fd811669f01$var$stringToPath;


var $165b64b7880c80b3$exports = {};
var $6e9b27fe1e9134a1$exports = {};

var $7fae7c98af7b4a49$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7fae7c98af7b4a49$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$7fae7c98af7b4a49$exports = $7fae7c98af7b4a49$var$arrayMap;




/** Used as references for various `Number` constants. */ var $6e9b27fe1e9134a1$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $6e9b27fe1e9134a1$var$symbolProto = $de179d6f42a5cc43$exports ? $de179d6f42a5cc43$exports.prototype : undefined, $6e9b27fe1e9134a1$var$symbolToString = $6e9b27fe1e9134a1$var$symbolProto ? $6e9b27fe1e9134a1$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $6e9b27fe1e9134a1$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($02148300ecce42f1$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $7fae7c98af7b4a49$exports(value, $6e9b27fe1e9134a1$var$baseToString) + '';
    if ($cda1c6b7d8f0286a$exports(value)) return $6e9b27fe1e9134a1$var$symbolToString ? $6e9b27fe1e9134a1$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$6e9b27fe1e9134a1$var$INFINITY ? '-0' : result;
}
$6e9b27fe1e9134a1$exports = $6e9b27fe1e9134a1$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $165b64b7880c80b3$var$toString(value) {
    return value == null ? '' : $6e9b27fe1e9134a1$exports(value);
}
$165b64b7880c80b3$exports = $165b64b7880c80b3$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $8a458eb14ebc3f75$var$castPath(value, object) {
    if ($02148300ecce42f1$exports(value)) return value;
    return $46c1bfc064ebc34b$exports(value, object) ? [
        value
    ] : $dfec0fd811669f01$exports($165b64b7880c80b3$exports(value));
}
$8a458eb14ebc3f75$exports = $8a458eb14ebc3f75$var$castPath;


var $65afc6c762889cde$exports = {};

/** Used as references for various `Number` constants. */ var $65afc6c762889cde$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $65afc6c762889cde$var$toKey(value) {
    if (typeof value == 'string' || $cda1c6b7d8f0286a$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$65afc6c762889cde$var$INFINITY ? '-0' : result;
}
$65afc6c762889cde$exports = $65afc6c762889cde$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $c42aa351ce1d5d03$var$baseGet(object, path) {
    path = $8a458eb14ebc3f75$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$65afc6c762889cde$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$c42aa351ce1d5d03$exports = $c42aa351ce1d5d03$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $cc70d38e3e17d56b$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $c42aa351ce1d5d03$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$cc70d38e3e17d56b$exports = $cc70d38e3e17d56b$var$get;



var $821a6471b94b95a0$exports = {};
var $1c529367c0b8df41$exports = {};


/** `Object#toString` result references. */ var $1c529367c0b8df41$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $1c529367c0b8df41$var$isNumber(value) {
    return typeof value == 'number' || $713b03e77fe310b2$exports(value) && $15761e4e379c96ab$exports(value) == $1c529367c0b8df41$var$numberTag;
}
$1c529367c0b8df41$exports = $1c529367c0b8df41$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $821a6471b94b95a0$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $1c529367c0b8df41$exports(value) && value != +value;
}
$821a6471b94b95a0$exports = $821a6471b94b95a0$var$isNaN;



var $08d6e520370fa038$exports = {};



/** `Object#toString` result references. */ var $08d6e520370fa038$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $08d6e520370fa038$var$isString(value) {
    return typeof value == 'string' || !$02148300ecce42f1$exports(value) && $713b03e77fe310b2$exports(value) && $15761e4e379c96ab$exports(value) == $08d6e520370fa038$var$stringTag;
}
$08d6e520370fa038$exports = $08d6e520370fa038$var$isString;


var $e6a593df52d5e247$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $e6a593df52d5e247$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($08d6e520370fa038$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $e6a593df52d5e247$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1c529367c0b8df41$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($821a6471b94b95a0$exports)))(value);
};
var $e6a593df52d5e247$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $e6a593df52d5e247$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($08d6e520370fa038$exports)))(value);
};
var $e6a593df52d5e247$var$idCounter = 0;
var $e6a593df52d5e247$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$e6a593df52d5e247$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $e6a593df52d5e247$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$e6a593df52d5e247$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($08d6e520370fa038$exports)))(percent)) return defaultValue;
    var value;
    if ($e6a593df52d5e247$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($821a6471b94b95a0$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $e6a593df52d5e247$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $e6a593df52d5e247$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $e6a593df52d5e247$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($e6a593df52d5e247$export$7e4aa119212bc614(numberA) && $e6a593df52d5e247$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $e6a593df52d5e247$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $e6a593df52d5e247$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};






var $9ee5d1df64411cfe$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $9ee5d1df64411cfe$var$isNil(value) {
    return value == null;
}
$9ee5d1df64411cfe$exports = $9ee5d1df64411cfe$var$isNil;




var $5pP8j = parcelRequire("5pP8j");
var $15f46d4f66ab185c$exports = {};
'use strict';

$15f46d4f66ab185c$exports = (parcelRequire("5v15z"));



function $208f2e6420654b95$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}




var $5pP8j = parcelRequire("5pP8j");
function $0e1d5f7291a98e27$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0e1d5f7291a98e27$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0e1d5f7291a98e27$var$_typeof(obj);
}
//
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $0e1d5f7291a98e27$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $0e1d5f7291a98e27$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $0e1d5f7291a98e27$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $0e1d5f7291a98e27$export$2b22758266a6fa48 = {
    svg: $0e1d5f7291a98e27$var$SVGContainerPropKeys,
    polygon: $0e1d5f7291a98e27$var$PolyElementKeys,
    polyline: $0e1d5f7291a98e27$var$PolyElementKeys
};
var $0e1d5f7291a98e27$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $0e1d5f7291a98e27$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $5pP8j.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0e1bd391425671ea$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($0e1d5f7291a98e27$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $0e1d5f7291a98e27$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $0e1d5f7291a98e27$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0e1bd391425671ea$exports)))(props) || $0e1d5f7291a98e27$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($0e1d5f7291a98e27$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $0e1d5f7291a98e27$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $f43486451a1e41f4$var$_excluded = [
    "children"
], $f43486451a1e41f4$var$_excluded2 = [
    "children"
];
function $f43486451a1e41f4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f43486451a1e41f4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f43486451a1e41f4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f43486451a1e41f4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f43486451a1e41f4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f43486451a1e41f4$var$_typeof(obj);
}
var $f43486451a1e41f4$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart'
};
var $f43486451a1e41f4$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $f43486451a1e41f4$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $f43486451a1e41f4$export$59a4d7d024cf1025 = [
    'none'
];
var $f43486451a1e41f4$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $f43486451a1e41f4$var$lastChildren = null;
var $f43486451a1e41f4$var$lastResult = null;
var $f43486451a1e41f4$export$45b10814cc054894 = function toArray(children) {
    if (children === $f43486451a1e41f4$var$lastChildren && (0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))($f43486451a1e41f4$var$lastResult)) return $f43486451a1e41f4$var$lastResult;
    var result = [];
    (0, $5pP8j.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(child)) return;
        if ((0, $15f46d4f66ab185c$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $f43486451a1e41f4$var$lastResult = result;
    $f43486451a1e41f4$var$lastChildren = children;
    return result;
};
function $f43486451a1e41f4$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(type)) types = type.map(function(t) {
        return $f43486451a1e41f4$export$be63e0664592e141(t);
    });
    else types = [
        $f43486451a1e41f4$export$be63e0664592e141(type)
    ];
    $f43486451a1e41f4$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $f43486451a1e41f4$export$64c61536a2b72e0f(children, type) {
    var result = $f43486451a1e41f4$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $f43486451a1e41f4$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(type)) types = type.map(function(t) {
        return $f43486451a1e41f4$export$be63e0664592e141(t);
    });
    else types = [
        $f43486451a1e41f4$export$be63e0664592e141(type)
    ];
    $f43486451a1e41f4$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $f43486451a1e41f4$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $e6a593df52d5e247$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $f43486451a1e41f4$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $f43486451a1e41f4$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($08d6e520370fa038$exports)))(child.type) && $f43486451a1e41f4$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $f43486451a1e41f4$export$e78c5929b986eef9 = function isDotProps(dot) {
    return dot && $f43486451a1e41f4$var$_typeof(dot) === 'object' && 'cx' in dot && 'cy' in dot && 'r' in dot;
};
var $f43486451a1e41f4$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $0e1d5f7291a98e27$export$2b22758266a6fa48) === null || (0, $0e1d5f7291a98e27$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $0e1d5f7291a98e27$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $0e1d5f7291a98e27$export$190f430946f96110).includes(key)) || includeEvents && (0, $0e1d5f7291a98e27$export$f30789245f2c4d11).includes(key);
};
var $f43486451a1e41f4$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $f43486451a1e41f4$export$45b10814cc054894(children).forEach(function(entry) {
        if ($f43486451a1e41f4$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $f43486451a1e41f4$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $5pP8j.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0e1bd391425671ea$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($f43486451a1e41f4$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $f43486451a1e41f4$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $5pP8j.Children).count(nextChildren);
    if (count !== (0, $5pP8j.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $f43486451a1e41f4$export$96bceecf65400492((0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(nextChildren) ? nextChildren[0] : nextChildren, (0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(nextChild) || (0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$f43486451a1e41f4$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $f43486451a1e41f4$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $f43486451a1e41f4$var$_objectWithoutProperties(_ref, $f43486451a1e41f4$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $f43486451a1e41f4$var$_objectWithoutProperties(_ref2, $f43486451a1e41f4$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $208f2e6420654b95$export$d36bdfa510afb180)(nextProps, prevProps) && $f43486451a1e41f4$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $208f2e6420654b95$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $f43486451a1e41f4$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $f43486451a1e41f4$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($f43486451a1e41f4$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $f43486451a1e41f4$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $f43486451a1e41f4$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $f43486451a1e41f4$var$REACT_BROWSER_EVENT_MAP[type]) return $f43486451a1e41f4$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $f43486451a1e41f4$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $f43486451a1e41f4$export$45b10814cc054894(children).indexOf(child);
};


var $2b0870b1d8efc404$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
];
function $2b0870b1d8efc404$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2b0870b1d8efc404$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2b0870b1d8efc404$var$_typeof(obj);
}
function $2b0870b1d8efc404$var$_extends() {
    $2b0870b1d8efc404$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2b0870b1d8efc404$var$_extends.apply(this, arguments);
}
function $2b0870b1d8efc404$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2b0870b1d8efc404$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2b0870b1d8efc404$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2b0870b1d8efc404$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2b0870b1d8efc404$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2b0870b1d8efc404$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2b0870b1d8efc404$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2b0870b1d8efc404$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2b0870b1d8efc404$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2b0870b1d8efc404$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2b0870b1d8efc404$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2b0870b1d8efc404$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2b0870b1d8efc404$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2b0870b1d8efc404$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2b0870b1d8efc404$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2b0870b1d8efc404$var$_setPrototypeOf(subClass, superClass);
}
function $2b0870b1d8efc404$var$_setPrototypeOf(o, p) {
    $2b0870b1d8efc404$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2b0870b1d8efc404$var$_setPrototypeOf(o, p);
}
function $2b0870b1d8efc404$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2b0870b1d8efc404$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2b0870b1d8efc404$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2b0870b1d8efc404$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2b0870b1d8efc404$var$_possibleConstructorReturn(this, result);
    };
}
function $2b0870b1d8efc404$var$_possibleConstructorReturn(self, call) {
    if (call && ($2b0870b1d8efc404$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2b0870b1d8efc404$var$_assertThisInitialized(self);
}
function $2b0870b1d8efc404$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2b0870b1d8efc404$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2b0870b1d8efc404$var$_getPrototypeOf(o) {
    $2b0870b1d8efc404$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2b0870b1d8efc404$var$_getPrototypeOf(o);
}
function $2b0870b1d8efc404$var$_defineProperty(obj, key, value) {
    key = $2b0870b1d8efc404$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2b0870b1d8efc404$var$_toPropertyKey(arg) {
    var key = $2b0870b1d8efc404$var$_toPrimitive(arg, "string");
    return $2b0870b1d8efc404$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2b0870b1d8efc404$var$_toPrimitive(input, hint) {
    if ($2b0870b1d8efc404$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2b0870b1d8efc404$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2b0870b1d8efc404$export$6440e27b9f186856 = /*#__PURE__*/ function(_PureComponent) {
    $2b0870b1d8efc404$var$_inherits(CartesianGrid, _PureComponent);
    var _super = $2b0870b1d8efc404$var$_createSuper(CartesianGrid);
    function CartesianGrid() {
        $2b0870b1d8efc404$var$_classCallCheck(this, CartesianGrid);
        return _super.apply(this, arguments);
    }
    $2b0870b1d8efc404$var$_createClass(CartesianGrid, [
        {
            key: "renderHorizontal",
            value: /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */ function renderHorizontal(horizontalPoints) {
                var _this = this;
                var _this$props = this.props, x = _this$props.x, width = _this$props.width, horizontal = _this$props.horizontal;
                if (!horizontalPoints || !horizontalPoints.length) return null;
                var items = horizontalPoints.map(function(entry, i) {
                    var props = $2b0870b1d8efc404$var$_objectSpread($2b0870b1d8efc404$var$_objectSpread({}, _this.props), {}, {
                        x1: x,
                        y1: entry,
                        x2: x + width,
                        y2: entry,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(horizontal, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("g", {
                    className: "recharts-cartesian-grid-horizontal"
                }, items);
            }
        },
        {
            key: "renderVertical",
            value: function renderVertical(verticalPoints) {
                var _this2 = this;
                var _this$props2 = this.props, y = _this$props2.y, height = _this$props2.height, vertical = _this$props2.vertical;
                if (!verticalPoints || !verticalPoints.length) return null;
                var items = verticalPoints.map(function(entry, i) {
                    var props = $2b0870b1d8efc404$var$_objectSpread($2b0870b1d8efc404$var$_objectSpread({}, _this2.props), {}, {
                        x1: entry,
                        y1: y,
                        x2: entry,
                        y2: y + height,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(vertical, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("g", {
                    className: "recharts-cartesian-grid-vertical"
                }, items);
            }
        },
        {
            key: "renderVerticalStripes",
            value: function renderVerticalStripes(verticalPoints) {
                var verticalFill = this.props.verticalFill;
                if (!verticalFill || !verticalFill.length) return null;
                var _this$props3 = this.props, fillOpacity = _this$props3.fillOpacity, x = _this$props3.x, y = _this$props3.y, width = _this$props3.width, height = _this$props3.height;
                var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
                    return Math.round(e + x - x);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
                var items = roundedSortedVerticalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedVerticalPoints[i + 1];
                    var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
                    if (lineWidth <= 0) return null;
                    var colorIndex = i % verticalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        x: entry,
                        y: y,
                        width: lineWidth,
                        height: height,
                        stroke: "none",
                        fill: verticalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-vertical"
                }, items);
            }
        },
        {
            key: "renderHorizontalStripes",
            value: function renderHorizontalStripes(horizontalPoints) {
                var horizontalFill = this.props.horizontalFill;
                if (!horizontalFill || !horizontalFill.length) return null;
                var _this$props4 = this.props, fillOpacity = _this$props4.fillOpacity, x = _this$props4.x, y = _this$props4.y, width = _this$props4.width, height = _this$props4.height;
                var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
                    return Math.round(e + y - y);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
                var items = roundedSortedHorizontalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedHorizontalPoints[i + 1];
                    var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
                    if (lineHeight <= 0) return null;
                    var colorIndex = i % horizontalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        y: entry,
                        x: x,
                        height: lineHeight,
                        width: width,
                        stroke: "none",
                        fill: horizontalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-horizontal"
                }, items);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var fill = this.props.fill;
                if (!fill || fill === 'none') return null;
                var _this$props5 = this.props, fillOpacity = _this$props5.fillOpacity, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    stroke: "none",
                    fill: fill,
                    fillOpacity: fillOpacity,
                    className: "recharts-cartesian-grid-bg"
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, horizontal = _this$props6.horizontal, vertical = _this$props6.vertical, horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator, verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, offset = _this$props6.offset, chartWidth = _this$props6.chartWidth, chartHeight = _this$props6.chartHeight;
                if (!(0, $e6a593df52d5e247$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(x) || x !== +x || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(y) || y !== +y) return null;
                var _this$props7 = this.props, horizontalPoints = _this$props7.horizontalPoints, verticalPoints = _this$props7.verticalPoints;
                // No horizontal points are specified
                if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(horizontalCoordinatesGenerator)) horizontalPoints = horizontalCoordinatesGenerator({
                    yAxis: yAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                // No vertical points are specified
                if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(verticalCoordinatesGenerator)) verticalPoints = verticalCoordinatesGenerator({
                    xAxis: xAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("g", {
                    className: "recharts-cartesian-grid"
                }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
            }
        }
    ], [
        {
            key: "renderLineItem",
            value: function renderLineItem(option, props) {
                var lineItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(option)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) lineItem = option(props);
                else {
                    var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $2b0870b1d8efc404$var$_objectWithoutProperties(props, $2b0870b1d8efc404$var$_excluded);
                    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("line", $2b0870b1d8efc404$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(others), {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        fill: "none",
                        key: key
                    }));
                }
                return lineItem;
            }
        }
    ]);
    return CartesianGrid;
}((0, $5pP8j.PureComponent));
$2b0870b1d8efc404$var$_defineProperty($2b0870b1d8efc404$export$6440e27b9f186856, "displayName", 'CartesianGrid');
$2b0870b1d8efc404$var$_defineProperty($2b0870b1d8efc404$export$6440e27b9f186856, "defaultProps", {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
});


var $738fb70c14187a7b$exports = {};
var $57b9695ad40eb80b$exports = {};
var $d8ff935cdddcc93b$exports = {};
var $d269c225280998cd$exports = {};
var $9b47e8b7de524543$exports = {};

var $3236ded3cb16f373$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $3236ded3cb16f373$var$stackClear() {
    this.__data__ = new $1d347293a3e9bfaa$exports;
    this.size = 0;
}
$3236ded3cb16f373$exports = $3236ded3cb16f373$var$stackClear;


var $553df1c2314bdf1b$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $553df1c2314bdf1b$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$553df1c2314bdf1b$exports = $553df1c2314bdf1b$var$stackDelete;


var $cb88a95c8333fdf0$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cb88a95c8333fdf0$var$stackGet(key) {
    return this.__data__.get(key);
}
$cb88a95c8333fdf0$exports = $cb88a95c8333fdf0$var$stackGet;


var $84718fac4dda5ce1$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $84718fac4dda5ce1$var$stackHas(key) {
    return this.__data__.has(key);
}
$84718fac4dda5ce1$exports = $84718fac4dda5ce1$var$stackHas;


var $ae1216155ea023a9$exports = {};



/** Used as the size to enable large array optimizations. */ var $ae1216155ea023a9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $ae1216155ea023a9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $1d347293a3e9bfaa$exports) {
        var pairs = data.__data__;
        if (!$300d1f2b91f79d61$exports || pairs.length < $ae1216155ea023a9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $893551625febb32a$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$ae1216155ea023a9$exports = $ae1216155ea023a9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9b47e8b7de524543$var$Stack(entries) {
    var data = this.__data__ = new $1d347293a3e9bfaa$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$9b47e8b7de524543$var$Stack.prototype.clear = $3236ded3cb16f373$exports;
$9b47e8b7de524543$var$Stack.prototype['delete'] = $553df1c2314bdf1b$exports;
$9b47e8b7de524543$var$Stack.prototype.get = $cb88a95c8333fdf0$exports;
$9b47e8b7de524543$var$Stack.prototype.has = $84718fac4dda5ce1$exports;
$9b47e8b7de524543$var$Stack.prototype.set = $ae1216155ea023a9$exports;
$9b47e8b7de524543$exports = $9b47e8b7de524543$var$Stack;


var $f90d3d5a86fda739$exports = {};
var $bbc6f7cab0e589bd$exports = {};

var $0dd60b4e5714b013$exports = {};
var $156383994405af5e$exports = {};

var $4c62e943f8067757$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $4c62e943f8067757$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $4c62e943f8067757$var$setCacheAdd(value) {
    this.__data__.set(value, $4c62e943f8067757$var$HASH_UNDEFINED);
    return this;
}
$4c62e943f8067757$exports = $4c62e943f8067757$var$setCacheAdd;


var $90432743a74b7bb4$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $90432743a74b7bb4$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$90432743a74b7bb4$exports = $90432743a74b7bb4$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $156383994405af5e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $893551625febb32a$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$156383994405af5e$var$SetCache.prototype.add = $156383994405af5e$var$SetCache.prototype.push = $4c62e943f8067757$exports;
$156383994405af5e$var$SetCache.prototype.has = $90432743a74b7bb4$exports;
$156383994405af5e$exports = $156383994405af5e$var$SetCache;


var $9cd3582e4cfd7a82$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $9cd3582e4cfd7a82$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$9cd3582e4cfd7a82$exports = $9cd3582e4cfd7a82$var$arraySome;


var $84ee6c011867b0a6$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $84ee6c011867b0a6$var$cacheHas(cache, key) {
    return cache.has(key);
}
$84ee6c011867b0a6$exports = $84ee6c011867b0a6$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $0dd60b4e5714b013$var$COMPARE_PARTIAL_FLAG = 1, $0dd60b4e5714b013$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $0dd60b4e5714b013$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $0dd60b4e5714b013$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $0dd60b4e5714b013$var$COMPARE_UNORDERED_FLAG ? new $156383994405af5e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$9cd3582e4cfd7a82$exports(other, function(othValue, othIndex) {
                if (!$84ee6c011867b0a6$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$0dd60b4e5714b013$exports = $0dd60b4e5714b013$var$equalArrays;


var $fb8197b2ef3193a5$exports = {};

var $ab437ba40d5618b2$exports = {};

var $lAA3U = parcelRequire("lAA3U");
/** Built-in value references. */ var $ab437ba40d5618b2$var$Uint8Array = $lAA3U.Uint8Array;
$ab437ba40d5618b2$exports = $ab437ba40d5618b2$var$Uint8Array;




var $5dcb1f219edf5f64$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $5dcb1f219edf5f64$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$5dcb1f219edf5f64$exports = $5dcb1f219edf5f64$var$mapToArray;


var $86d99a8ec878a441$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $86d99a8ec878a441$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$86d99a8ec878a441$exports = $86d99a8ec878a441$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $fb8197b2ef3193a5$var$COMPARE_PARTIAL_FLAG = 1, $fb8197b2ef3193a5$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $fb8197b2ef3193a5$var$boolTag = '[object Boolean]', $fb8197b2ef3193a5$var$dateTag = '[object Date]', $fb8197b2ef3193a5$var$errorTag = '[object Error]', $fb8197b2ef3193a5$var$mapTag = '[object Map]', $fb8197b2ef3193a5$var$numberTag = '[object Number]', $fb8197b2ef3193a5$var$regexpTag = '[object RegExp]', $fb8197b2ef3193a5$var$setTag = '[object Set]', $fb8197b2ef3193a5$var$stringTag = '[object String]', $fb8197b2ef3193a5$var$symbolTag = '[object Symbol]';
var $fb8197b2ef3193a5$var$arrayBufferTag = '[object ArrayBuffer]', $fb8197b2ef3193a5$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $fb8197b2ef3193a5$var$symbolProto = $de179d6f42a5cc43$exports ? $de179d6f42a5cc43$exports.prototype : undefined, $fb8197b2ef3193a5$var$symbolValueOf = $fb8197b2ef3193a5$var$symbolProto ? $fb8197b2ef3193a5$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $fb8197b2ef3193a5$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $fb8197b2ef3193a5$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $fb8197b2ef3193a5$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $ab437ba40d5618b2$exports(object), new $ab437ba40d5618b2$exports(other))) return false;
            return true;
        case $fb8197b2ef3193a5$var$boolTag:
        case $fb8197b2ef3193a5$var$dateTag:
        case $fb8197b2ef3193a5$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $05a5c93574ccef83$exports(+object, +other);
        case $fb8197b2ef3193a5$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $fb8197b2ef3193a5$var$regexpTag:
        case $fb8197b2ef3193a5$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $fb8197b2ef3193a5$var$mapTag:
            var convert = $5dcb1f219edf5f64$exports;
        case $fb8197b2ef3193a5$var$setTag:
            var isPartial = bitmask & $fb8197b2ef3193a5$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $86d99a8ec878a441$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $fb8197b2ef3193a5$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $0dd60b4e5714b013$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $fb8197b2ef3193a5$var$symbolTag:
            if ($fb8197b2ef3193a5$var$symbolValueOf) return $fb8197b2ef3193a5$var$symbolValueOf.call(object) == $fb8197b2ef3193a5$var$symbolValueOf.call(other);
    }
    return false;
}
$fb8197b2ef3193a5$exports = $fb8197b2ef3193a5$var$equalByTag;


var $ad448c868fbc7f3a$exports = {};
var $6c22f9f67498070b$exports = {};
var $db70bd748683214c$exports = {};
var $97f3c27c5ae8b289$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $97f3c27c5ae8b289$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$97f3c27c5ae8b289$exports = $97f3c27c5ae8b289$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $db70bd748683214c$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $02148300ecce42f1$exports(object) ? result : $97f3c27c5ae8b289$exports(result, symbolsFunc(object));
}
$db70bd748683214c$exports = $db70bd748683214c$var$baseGetAllKeys;


var $6acd831ec04f3138$exports = {};
var $0d91a6f818847362$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $0d91a6f818847362$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$0d91a6f818847362$exports = $0d91a6f818847362$var$arrayFilter;


var $c24880ce203cd32a$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $c24880ce203cd32a$var$stubArray() {
    return [];
}
$c24880ce203cd32a$exports = $c24880ce203cd32a$var$stubArray;


/** Used for built-in method references. */ var $6acd831ec04f3138$var$objectProto = Object.prototype;
/** Built-in value references. */ var $6acd831ec04f3138$var$propertyIsEnumerable = $6acd831ec04f3138$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6acd831ec04f3138$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6acd831ec04f3138$var$getSymbols = !$6acd831ec04f3138$var$nativeGetSymbols ? $c24880ce203cd32a$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $0d91a6f818847362$exports($6acd831ec04f3138$var$nativeGetSymbols(object), function(symbol) {
        return $6acd831ec04f3138$var$propertyIsEnumerable.call(object, symbol);
    });
};
$6acd831ec04f3138$exports = $6acd831ec04f3138$var$getSymbols;


var $02cff874f3633c30$exports = {};
var $e4f4ede8ce2e063e$exports = {};
var $d20a1ae620f5b29a$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $d20a1ae620f5b29a$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$d20a1ae620f5b29a$exports = $d20a1ae620f5b29a$var$baseTimes;


var $e05e41dcd042be4a$exports = {};
var $37fe8daded21f1e6$exports = {};


/** `Object#toString` result references. */ var $37fe8daded21f1e6$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $37fe8daded21f1e6$var$baseIsArguments(value) {
    return $713b03e77fe310b2$exports(value) && $15761e4e379c96ab$exports(value) == $37fe8daded21f1e6$var$argsTag;
}
$37fe8daded21f1e6$exports = $37fe8daded21f1e6$var$baseIsArguments;



/** Used for built-in method references. */ var $e05e41dcd042be4a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e05e41dcd042be4a$var$hasOwnProperty = $e05e41dcd042be4a$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $e05e41dcd042be4a$var$propertyIsEnumerable = $e05e41dcd042be4a$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $e05e41dcd042be4a$var$isArguments = $37fe8daded21f1e6$exports(function() {
    return arguments;
}()) ? $37fe8daded21f1e6$exports : function(value) {
    return $713b03e77fe310b2$exports(value) && $e05e41dcd042be4a$var$hasOwnProperty.call(value, 'callee') && !$e05e41dcd042be4a$var$propertyIsEnumerable.call(value, 'callee');
};
$e05e41dcd042be4a$exports = $e05e41dcd042be4a$var$isArguments;




var $b9KbE = parcelRequire("b9KbE");
var $03453f782b5e5aeb$exports = {};
/** Used as references for various `Number` constants. */ var $03453f782b5e5aeb$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $03453f782b5e5aeb$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $03453f782b5e5aeb$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $03453f782b5e5aeb$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $03453f782b5e5aeb$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$03453f782b5e5aeb$exports = $03453f782b5e5aeb$var$isIndex;


var $743798eec4cb9899$exports = {};
var $55957cbbe89f84f5$exports = {};

var $ba591a6cf5a76eae$exports = {};
/** Used as references for various `Number` constants. */ var $ba591a6cf5a76eae$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $ba591a6cf5a76eae$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $ba591a6cf5a76eae$var$MAX_SAFE_INTEGER;
}
$ba591a6cf5a76eae$exports = $ba591a6cf5a76eae$var$isLength;



/** `Object#toString` result references. */ var $55957cbbe89f84f5$var$argsTag = '[object Arguments]', $55957cbbe89f84f5$var$arrayTag = '[object Array]', $55957cbbe89f84f5$var$boolTag = '[object Boolean]', $55957cbbe89f84f5$var$dateTag = '[object Date]', $55957cbbe89f84f5$var$errorTag = '[object Error]', $55957cbbe89f84f5$var$funcTag = '[object Function]', $55957cbbe89f84f5$var$mapTag = '[object Map]', $55957cbbe89f84f5$var$numberTag = '[object Number]', $55957cbbe89f84f5$var$objectTag = '[object Object]', $55957cbbe89f84f5$var$regexpTag = '[object RegExp]', $55957cbbe89f84f5$var$setTag = '[object Set]', $55957cbbe89f84f5$var$stringTag = '[object String]', $55957cbbe89f84f5$var$weakMapTag = '[object WeakMap]';
var $55957cbbe89f84f5$var$arrayBufferTag = '[object ArrayBuffer]', $55957cbbe89f84f5$var$dataViewTag = '[object DataView]', $55957cbbe89f84f5$var$float32Tag = '[object Float32Array]', $55957cbbe89f84f5$var$float64Tag = '[object Float64Array]', $55957cbbe89f84f5$var$int8Tag = '[object Int8Array]', $55957cbbe89f84f5$var$int16Tag = '[object Int16Array]', $55957cbbe89f84f5$var$int32Tag = '[object Int32Array]', $55957cbbe89f84f5$var$uint8Tag = '[object Uint8Array]', $55957cbbe89f84f5$var$uint8ClampedTag = '[object Uint8ClampedArray]', $55957cbbe89f84f5$var$uint16Tag = '[object Uint16Array]', $55957cbbe89f84f5$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $55957cbbe89f84f5$var$typedArrayTags = {};
$55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$float32Tag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$float64Tag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$int8Tag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$int16Tag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$int32Tag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$uint8Tag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$uint8ClampedTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$uint16Tag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$uint32Tag] = true;
$55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$argsTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$arrayTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$arrayBufferTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$boolTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$dataViewTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$dateTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$errorTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$funcTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$mapTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$numberTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$objectTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$regexpTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$setTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$stringTag] = $55957cbbe89f84f5$var$typedArrayTags[$55957cbbe89f84f5$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $55957cbbe89f84f5$var$baseIsTypedArray(value) {
    return $713b03e77fe310b2$exports(value) && $ba591a6cf5a76eae$exports(value.length) && !!$55957cbbe89f84f5$var$typedArrayTags[$15761e4e379c96ab$exports(value)];
}
$55957cbbe89f84f5$exports = $55957cbbe89f84f5$var$baseIsTypedArray;


var $73e2d6e9aed45cd0$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $73e2d6e9aed45cd0$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$73e2d6e9aed45cd0$exports = $73e2d6e9aed45cd0$var$baseUnary;



var $8xkF4 = parcelRequire("8xkF4");
/* Node.js helper references. */ var $743798eec4cb9899$var$nodeIsTypedArray = $8xkF4 && $8xkF4.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $743798eec4cb9899$var$isTypedArray = $743798eec4cb9899$var$nodeIsTypedArray ? $73e2d6e9aed45cd0$exports($743798eec4cb9899$var$nodeIsTypedArray) : $55957cbbe89f84f5$exports;
$743798eec4cb9899$exports = $743798eec4cb9899$var$isTypedArray;


/** Used for built-in method references. */ var $e4f4ede8ce2e063e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e4f4ede8ce2e063e$var$hasOwnProperty = $e4f4ede8ce2e063e$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $e4f4ede8ce2e063e$var$arrayLikeKeys(value, inherited) {
    var isArr = $02148300ecce42f1$exports(value), isArg = !isArr && $e05e41dcd042be4a$exports(value), isBuff = !isArr && !isArg && $b9KbE(value), isType = !isArr && !isArg && !isBuff && $743798eec4cb9899$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $d20a1ae620f5b29a$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $e4f4ede8ce2e063e$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $03453f782b5e5aeb$exports(key, length)))) result.push(key);
    return result;
}
$e4f4ede8ce2e063e$exports = $e4f4ede8ce2e063e$var$arrayLikeKeys;


var $c535cc65cdda1f1c$exports = {};
var $9e356cd3e263df3e$exports = {};
/** Used for built-in method references. */ var $9e356cd3e263df3e$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $9e356cd3e263df3e$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $9e356cd3e263df3e$var$objectProto;
    return value === proto;
}
$9e356cd3e263df3e$exports = $9e356cd3e263df3e$var$isPrototype;


var $4f4be1cf1b987c5c$exports = {};
var $5cb26720a8e9501b$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5cb26720a8e9501b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$5cb26720a8e9501b$exports = $5cb26720a8e9501b$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $4f4be1cf1b987c5c$var$nativeKeys = $5cb26720a8e9501b$exports(Object.keys, Object);
$4f4be1cf1b987c5c$exports = $4f4be1cf1b987c5c$var$nativeKeys;


/** Used for built-in method references. */ var $c535cc65cdda1f1c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c535cc65cdda1f1c$var$hasOwnProperty = $c535cc65cdda1f1c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c535cc65cdda1f1c$var$baseKeys(object) {
    if (!$9e356cd3e263df3e$exports(object)) return $4f4be1cf1b987c5c$exports(object);
    var result = [];
    for(var key in Object(object))if ($c535cc65cdda1f1c$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$c535cc65cdda1f1c$exports = $c535cc65cdda1f1c$var$baseKeys;


var $d78b82d99e6058d9$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $d78b82d99e6058d9$var$isArrayLike(value) {
    return value != null && $ba591a6cf5a76eae$exports(value.length) && !$e151d7d4cf638963$exports(value);
}
$d78b82d99e6058d9$exports = $d78b82d99e6058d9$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $02cff874f3633c30$var$keys(object) {
    return $d78b82d99e6058d9$exports(object) ? $e4f4ede8ce2e063e$exports(object) : $c535cc65cdda1f1c$exports(object);
}
$02cff874f3633c30$exports = $02cff874f3633c30$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6c22f9f67498070b$var$getAllKeys(object) {
    return $db70bd748683214c$exports(object, $02cff874f3633c30$exports, $6acd831ec04f3138$exports);
}
$6c22f9f67498070b$exports = $6c22f9f67498070b$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ad448c868fbc7f3a$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ad448c868fbc7f3a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ad448c868fbc7f3a$var$hasOwnProperty = $ad448c868fbc7f3a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ad448c868fbc7f3a$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ad448c868fbc7f3a$var$COMPARE_PARTIAL_FLAG, objProps = $6c22f9f67498070b$exports(object), objLength = objProps.length, othProps = $6c22f9f67498070b$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ad448c868fbc7f3a$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$ad448c868fbc7f3a$exports = $ad448c868fbc7f3a$var$equalObjects;


var $4418bc62172ae5e8$exports = {};
var $a3fc448f45951e42$exports = {};


var $lAA3U = parcelRequire("lAA3U");
/* Built-in method references that are verified to be native. */ var $a3fc448f45951e42$var$DataView = $db96872dbd237c27$exports($lAA3U, 'DataView');
$a3fc448f45951e42$exports = $a3fc448f45951e42$var$DataView;



var $f80cc62c07b3b9ee$exports = {};


var $lAA3U = parcelRequire("lAA3U");
/* Built-in method references that are verified to be native. */ var $f80cc62c07b3b9ee$var$Promise = $db96872dbd237c27$exports($lAA3U, 'Promise');
$f80cc62c07b3b9ee$exports = $f80cc62c07b3b9ee$var$Promise;


var $b5ea3bc2202e4fab$exports = {};


var $lAA3U = parcelRequire("lAA3U");
/* Built-in method references that are verified to be native. */ var $b5ea3bc2202e4fab$var$Set = $db96872dbd237c27$exports($lAA3U, 'Set');
$b5ea3bc2202e4fab$exports = $b5ea3bc2202e4fab$var$Set;


var $caf342d52205aa31$exports = {};


var $lAA3U = parcelRequire("lAA3U");
/* Built-in method references that are verified to be native. */ var $caf342d52205aa31$var$WeakMap = $db96872dbd237c27$exports($lAA3U, 'WeakMap');
$caf342d52205aa31$exports = $caf342d52205aa31$var$WeakMap;




/** `Object#toString` result references. */ var $4418bc62172ae5e8$var$mapTag = '[object Map]', $4418bc62172ae5e8$var$objectTag = '[object Object]', $4418bc62172ae5e8$var$promiseTag = '[object Promise]', $4418bc62172ae5e8$var$setTag = '[object Set]', $4418bc62172ae5e8$var$weakMapTag = '[object WeakMap]';
var $4418bc62172ae5e8$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $4418bc62172ae5e8$var$dataViewCtorString = $0318cf147537afbe$exports($a3fc448f45951e42$exports), $4418bc62172ae5e8$var$mapCtorString = $0318cf147537afbe$exports($300d1f2b91f79d61$exports), $4418bc62172ae5e8$var$promiseCtorString = $0318cf147537afbe$exports($f80cc62c07b3b9ee$exports), $4418bc62172ae5e8$var$setCtorString = $0318cf147537afbe$exports($b5ea3bc2202e4fab$exports), $4418bc62172ae5e8$var$weakMapCtorString = $0318cf147537afbe$exports($caf342d52205aa31$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $4418bc62172ae5e8$var$getTag = $15761e4e379c96ab$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($a3fc448f45951e42$exports && $4418bc62172ae5e8$var$getTag(new $a3fc448f45951e42$exports(new ArrayBuffer(1))) != $4418bc62172ae5e8$var$dataViewTag || $300d1f2b91f79d61$exports && $4418bc62172ae5e8$var$getTag(new $300d1f2b91f79d61$exports) != $4418bc62172ae5e8$var$mapTag || $f80cc62c07b3b9ee$exports && $4418bc62172ae5e8$var$getTag($f80cc62c07b3b9ee$exports.resolve()) != $4418bc62172ae5e8$var$promiseTag || $b5ea3bc2202e4fab$exports && $4418bc62172ae5e8$var$getTag(new $b5ea3bc2202e4fab$exports) != $4418bc62172ae5e8$var$setTag || $caf342d52205aa31$exports && $4418bc62172ae5e8$var$getTag(new $caf342d52205aa31$exports) != $4418bc62172ae5e8$var$weakMapTag) $4418bc62172ae5e8$var$getTag = function(value) {
    var result = $15761e4e379c96ab$exports(value), Ctor = result == $4418bc62172ae5e8$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $0318cf147537afbe$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $4418bc62172ae5e8$var$dataViewCtorString:
            return $4418bc62172ae5e8$var$dataViewTag;
        case $4418bc62172ae5e8$var$mapCtorString:
            return $4418bc62172ae5e8$var$mapTag;
        case $4418bc62172ae5e8$var$promiseCtorString:
            return $4418bc62172ae5e8$var$promiseTag;
        case $4418bc62172ae5e8$var$setCtorString:
            return $4418bc62172ae5e8$var$setTag;
        case $4418bc62172ae5e8$var$weakMapCtorString:
            return $4418bc62172ae5e8$var$weakMapTag;
    }
    return result;
};
$4418bc62172ae5e8$exports = $4418bc62172ae5e8$var$getTag;




var $b9KbE = parcelRequire("b9KbE");

/** Used to compose bitmasks for value comparisons. */ var $bbc6f7cab0e589bd$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $bbc6f7cab0e589bd$var$argsTag = '[object Arguments]', $bbc6f7cab0e589bd$var$arrayTag = '[object Array]', $bbc6f7cab0e589bd$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $bbc6f7cab0e589bd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bbc6f7cab0e589bd$var$hasOwnProperty = $bbc6f7cab0e589bd$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $bbc6f7cab0e589bd$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $02148300ecce42f1$exports(object), othIsArr = $02148300ecce42f1$exports(other), objTag = objIsArr ? $bbc6f7cab0e589bd$var$arrayTag : $4418bc62172ae5e8$exports(object), othTag = othIsArr ? $bbc6f7cab0e589bd$var$arrayTag : $4418bc62172ae5e8$exports(other);
    objTag = objTag == $bbc6f7cab0e589bd$var$argsTag ? $bbc6f7cab0e589bd$var$objectTag : objTag;
    othTag = othTag == $bbc6f7cab0e589bd$var$argsTag ? $bbc6f7cab0e589bd$var$objectTag : othTag;
    var objIsObj = objTag == $bbc6f7cab0e589bd$var$objectTag, othIsObj = othTag == $bbc6f7cab0e589bd$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $b9KbE(object)) {
        if (!$b9KbE(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $9b47e8b7de524543$exports);
        return objIsArr || $743798eec4cb9899$exports(object) ? $0dd60b4e5714b013$exports(object, other, bitmask, customizer, equalFunc, stack) : $fb8197b2ef3193a5$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $bbc6f7cab0e589bd$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $bbc6f7cab0e589bd$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $bbc6f7cab0e589bd$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $9b47e8b7de524543$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $9b47e8b7de524543$exports);
    return $ad448c868fbc7f3a$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$bbc6f7cab0e589bd$exports = $bbc6f7cab0e589bd$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f90d3d5a86fda739$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$713b03e77fe310b2$exports(value) && !$713b03e77fe310b2$exports(other)) return value !== value && other !== other;
    return $bbc6f7cab0e589bd$exports(value, other, bitmask, customizer, $f90d3d5a86fda739$var$baseIsEqual, stack);
}
$f90d3d5a86fda739$exports = $f90d3d5a86fda739$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $d269c225280998cd$var$COMPARE_PARTIAL_FLAG = 1, $d269c225280998cd$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $d269c225280998cd$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $9b47e8b7de524543$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $f90d3d5a86fda739$exports(srcValue, objValue, $d269c225280998cd$var$COMPARE_PARTIAL_FLAG | $d269c225280998cd$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$d269c225280998cd$exports = $d269c225280998cd$var$baseIsMatch;


var $c500d987ae1c7ad0$exports = {};
var $efbecaf1f1563274$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $efbecaf1f1563274$var$isStrictComparable(value) {
    return value === value && !$0e1bd391425671ea$exports(value);
}
$efbecaf1f1563274$exports = $efbecaf1f1563274$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $c500d987ae1c7ad0$var$getMatchData(object) {
    var result = $02cff874f3633c30$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $efbecaf1f1563274$exports(value)
        ];
    }
    return result;
}
$c500d987ae1c7ad0$exports = $c500d987ae1c7ad0$var$getMatchData;


var $f12966aef95afe61$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f12966aef95afe61$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$f12966aef95afe61$exports = $f12966aef95afe61$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $d8ff935cdddcc93b$var$baseMatches(source) {
    var matchData = $c500d987ae1c7ad0$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $f12966aef95afe61$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $d269c225280998cd$exports(object, source, matchData);
    };
}
$d8ff935cdddcc93b$exports = $d8ff935cdddcc93b$var$baseMatches;


var $1653be322f85eb57$exports = {};


var $91b9e2c137a341d3$exports = {};
var $1d97cbbdecc24beb$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $1d97cbbdecc24beb$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$1d97cbbdecc24beb$exports = $1d97cbbdecc24beb$var$baseHasIn;


var $2028ca9ad177c260$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $2028ca9ad177c260$var$hasPath(object, path, hasFunc) {
    path = $8a458eb14ebc3f75$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $65afc6c762889cde$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $ba591a6cf5a76eae$exports(length) && $03453f782b5e5aeb$exports(key, length) && ($02148300ecce42f1$exports(object) || $e05e41dcd042be4a$exports(object));
}
$2028ca9ad177c260$exports = $2028ca9ad177c260$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $91b9e2c137a341d3$var$hasIn(object, path) {
    return object != null && $2028ca9ad177c260$exports(object, path, $1d97cbbdecc24beb$exports);
}
$91b9e2c137a341d3$exports = $91b9e2c137a341d3$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $1653be322f85eb57$var$COMPARE_PARTIAL_FLAG = 1, $1653be322f85eb57$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1653be322f85eb57$var$baseMatchesProperty(path, srcValue) {
    if ($46c1bfc064ebc34b$exports(path) && $efbecaf1f1563274$exports(srcValue)) return $f12966aef95afe61$exports($65afc6c762889cde$exports(path), srcValue);
    return function(object) {
        var objValue = $cc70d38e3e17d56b$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $91b9e2c137a341d3$exports(object, path) : $f90d3d5a86fda739$exports(srcValue, objValue, $1653be322f85eb57$var$COMPARE_PARTIAL_FLAG | $1653be322f85eb57$var$COMPARE_UNORDERED_FLAG);
    };
}
$1653be322f85eb57$exports = $1653be322f85eb57$var$baseMatchesProperty;


var $ca900a7526c42750$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $ca900a7526c42750$var$identity(value) {
    return value;
}
$ca900a7526c42750$exports = $ca900a7526c42750$var$identity;



var $aaea8fdcd5e33f3b$exports = {};
var $c3cc24f35cf65496$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $c3cc24f35cf65496$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$c3cc24f35cf65496$exports = $c3cc24f35cf65496$var$baseProperty;


var $e4955d4a4f7be605$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e4955d4a4f7be605$var$basePropertyDeep(path) {
    return function(object) {
        return $c42aa351ce1d5d03$exports(object, path);
    };
}
$e4955d4a4f7be605$exports = $e4955d4a4f7be605$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $aaea8fdcd5e33f3b$var$property(path) {
    return $46c1bfc064ebc34b$exports(path) ? $c3cc24f35cf65496$exports($65afc6c762889cde$exports(path)) : $e4955d4a4f7be605$exports(path);
}
$aaea8fdcd5e33f3b$exports = $aaea8fdcd5e33f3b$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $57b9695ad40eb80b$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $ca900a7526c42750$exports;
    if (typeof value == 'object') return $02148300ecce42f1$exports(value) ? $1653be322f85eb57$exports(value[0], value[1]) : $d8ff935cdddcc93b$exports(value);
    return $aaea8fdcd5e33f3b$exports(value);
}
$57b9695ad40eb80b$exports = $57b9695ad40eb80b$var$baseIteratee;


var $3c2d563a04f02180$exports = {};

var $5d44c7776e1c870d$exports = {};
var $aeb87a027a095f46$exports = {};
var $e8fce87ad95c4015$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e8fce87ad95c4015$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$e8fce87ad95c4015$exports = $e8fce87ad95c4015$var$baseFindIndex;


var $f894c3a0941dbbb5$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $f894c3a0941dbbb5$var$baseIsNaN(value) {
    return value !== value;
}
$f894c3a0941dbbb5$exports = $f894c3a0941dbbb5$var$baseIsNaN;


var $88ec9e87453102c5$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $88ec9e87453102c5$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$88ec9e87453102c5$exports = $88ec9e87453102c5$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $aeb87a027a095f46$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $88ec9e87453102c5$exports(array, value, fromIndex) : $e8fce87ad95c4015$exports(array, $f894c3a0941dbbb5$exports, fromIndex);
}
$aeb87a027a095f46$exports = $aeb87a027a095f46$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5d44c7776e1c870d$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $aeb87a027a095f46$exports(array, value, 0) > -1;
}
$5d44c7776e1c870d$exports = $5d44c7776e1c870d$var$arrayIncludes;


var $7df697f8f7c6eccf$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $7df697f8f7c6eccf$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$7df697f8f7c6eccf$exports = $7df697f8f7c6eccf$var$arrayIncludesWith;



var $5616a60ac49fb476$exports = {};

var $77423042a4821fb1$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $77423042a4821fb1$var$noop() {
// No operation performed.
}
$77423042a4821fb1$exports = $77423042a4821fb1$var$noop;



/** Used as references for various `Number` constants. */ var $5616a60ac49fb476$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $5616a60ac49fb476$var$createSet = !($b5ea3bc2202e4fab$exports && 1 / $86d99a8ec878a441$exports(new $b5ea3bc2202e4fab$exports([
    ,
    -0
]))[1] == $5616a60ac49fb476$var$INFINITY) ? $77423042a4821fb1$exports : function(values) {
    return new $b5ea3bc2202e4fab$exports(values);
};
$5616a60ac49fb476$exports = $5616a60ac49fb476$var$createSet;



/** Used as the size to enable large array optimizations. */ var $3c2d563a04f02180$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $3c2d563a04f02180$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $5d44c7776e1c870d$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $7df697f8f7c6eccf$exports;
    } else if (length >= $3c2d563a04f02180$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $5616a60ac49fb476$exports(array);
        if (set) return $86d99a8ec878a441$exports(set);
        isCommon = false;
        includes = $84ee6c011867b0a6$exports;
        seen = new $156383994405af5e$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$3c2d563a04f02180$exports = $3c2d563a04f02180$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $738fb70c14187a7b$var$uniqBy(array, iteratee) {
    return array && array.length ? $3c2d563a04f02180$exports(array, $57b9695ad40eb80b$exports(iteratee, 2)) : [];
}
$738fb70c14187a7b$exports = $738fb70c14187a7b$var$uniqBy;



var $5pP8j = parcelRequire("5pP8j");

var $5pP8j = parcelRequire("5pP8j");


var $5pP8j = parcelRequire("5pP8j");


var $774ffa3fa11358b1$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style"
];
function $774ffa3fa11358b1$var$_extends() {
    $774ffa3fa11358b1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $774ffa3fa11358b1$var$_extends.apply(this, arguments);
}
function $774ffa3fa11358b1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $774ffa3fa11358b1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $774ffa3fa11358b1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $774ffa3fa11358b1$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, others = $774ffa3fa11358b1$var$_objectWithoutProperties(props, $774ffa3fa11358b1$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("svg", $774ffa3fa11358b1$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("title", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("desc", null, props.desc), children);
}


var $f754ad19e6141c59$exports = {};
var $2a3554fd53ad6a70$exports = {};
var $3bc9c2ba70cf17e8$exports = {};
var $0d0c14b6a2e8f3b3$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $0d0c14b6a2e8f3b3$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$0d0c14b6a2e8f3b3$exports = $0d0c14b6a2e8f3b3$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $3bc9c2ba70cf17e8$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $0d0c14b6a2e8f3b3$exports(array, start, end);
}
$3bc9c2ba70cf17e8$exports = $3bc9c2ba70cf17e8$var$castSlice;


var $499b15e538945bef$exports = {};
/** Used to compose unicode character classes. */ var $499b15e538945bef$var$rsAstralRange = '\\ud800-\\udfff', $499b15e538945bef$var$rsComboMarksRange = '\\u0300-\\u036f', $499b15e538945bef$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $499b15e538945bef$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $499b15e538945bef$var$rsComboRange = $499b15e538945bef$var$rsComboMarksRange + $499b15e538945bef$var$reComboHalfMarksRange + $499b15e538945bef$var$rsComboSymbolsRange, $499b15e538945bef$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $499b15e538945bef$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $499b15e538945bef$var$reHasUnicode = RegExp('[' + $499b15e538945bef$var$rsZWJ + $499b15e538945bef$var$rsAstralRange + $499b15e538945bef$var$rsComboRange + $499b15e538945bef$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $499b15e538945bef$var$hasUnicode(string) {
    return $499b15e538945bef$var$reHasUnicode.test(string);
}
$499b15e538945bef$exports = $499b15e538945bef$var$hasUnicode;


var $f15bc442c95a8acf$exports = {};
var $fbf92f6e79bd3ba2$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $fbf92f6e79bd3ba2$var$asciiToArray(string) {
    return string.split('');
}
$fbf92f6e79bd3ba2$exports = $fbf92f6e79bd3ba2$var$asciiToArray;



var $1ee052f13f0c17d4$exports = {};
/** Used to compose unicode character classes. */ var $1ee052f13f0c17d4$var$rsAstralRange = '\\ud800-\\udfff', $1ee052f13f0c17d4$var$rsComboMarksRange = '\\u0300-\\u036f', $1ee052f13f0c17d4$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $1ee052f13f0c17d4$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $1ee052f13f0c17d4$var$rsComboRange = $1ee052f13f0c17d4$var$rsComboMarksRange + $1ee052f13f0c17d4$var$reComboHalfMarksRange + $1ee052f13f0c17d4$var$rsComboSymbolsRange, $1ee052f13f0c17d4$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $1ee052f13f0c17d4$var$rsAstral = '[' + $1ee052f13f0c17d4$var$rsAstralRange + ']', $1ee052f13f0c17d4$var$rsCombo = '[' + $1ee052f13f0c17d4$var$rsComboRange + ']', $1ee052f13f0c17d4$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $1ee052f13f0c17d4$var$rsModifier = '(?:' + $1ee052f13f0c17d4$var$rsCombo + '|' + $1ee052f13f0c17d4$var$rsFitz + ')', $1ee052f13f0c17d4$var$rsNonAstral = '[^' + $1ee052f13f0c17d4$var$rsAstralRange + ']', $1ee052f13f0c17d4$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $1ee052f13f0c17d4$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $1ee052f13f0c17d4$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $1ee052f13f0c17d4$var$reOptMod = $1ee052f13f0c17d4$var$rsModifier + '?', $1ee052f13f0c17d4$var$rsOptVar = '[' + $1ee052f13f0c17d4$var$rsVarRange + ']?', $1ee052f13f0c17d4$var$rsOptJoin = '(?:' + $1ee052f13f0c17d4$var$rsZWJ + '(?:' + [
    $1ee052f13f0c17d4$var$rsNonAstral,
    $1ee052f13f0c17d4$var$rsRegional,
    $1ee052f13f0c17d4$var$rsSurrPair
].join('|') + ')' + $1ee052f13f0c17d4$var$rsOptVar + $1ee052f13f0c17d4$var$reOptMod + ')*', $1ee052f13f0c17d4$var$rsSeq = $1ee052f13f0c17d4$var$rsOptVar + $1ee052f13f0c17d4$var$reOptMod + $1ee052f13f0c17d4$var$rsOptJoin, $1ee052f13f0c17d4$var$rsSymbol = '(?:' + [
    $1ee052f13f0c17d4$var$rsNonAstral + $1ee052f13f0c17d4$var$rsCombo + '?',
    $1ee052f13f0c17d4$var$rsCombo,
    $1ee052f13f0c17d4$var$rsRegional,
    $1ee052f13f0c17d4$var$rsSurrPair,
    $1ee052f13f0c17d4$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $1ee052f13f0c17d4$var$reUnicode = RegExp($1ee052f13f0c17d4$var$rsFitz + '(?=' + $1ee052f13f0c17d4$var$rsFitz + ')|' + $1ee052f13f0c17d4$var$rsSymbol + $1ee052f13f0c17d4$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $1ee052f13f0c17d4$var$unicodeToArray(string) {
    return string.match($1ee052f13f0c17d4$var$reUnicode) || [];
}
$1ee052f13f0c17d4$exports = $1ee052f13f0c17d4$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f15bc442c95a8acf$var$stringToArray(string) {
    return $499b15e538945bef$exports(string) ? $1ee052f13f0c17d4$exports(string) : $fbf92f6e79bd3ba2$exports(string);
}
$f15bc442c95a8acf$exports = $f15bc442c95a8acf$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $2a3554fd53ad6a70$var$createCaseFirst(methodName) {
    return function(string) {
        string = $165b64b7880c80b3$exports(string);
        var strSymbols = $499b15e538945bef$exports(string) ? $f15bc442c95a8acf$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $3bc9c2ba70cf17e8$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$2a3554fd53ad6a70$exports = $2a3554fd53ad6a70$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $f754ad19e6141c59$var$upperFirst = $2a3554fd53ad6a70$exports('toUpperCase');
$f754ad19e6141c59$exports = $f754ad19e6141c59$var$upperFirst;



var $5pP8j = parcelRequire("5pP8j");
var $1ff5105c1693678c$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$1ff5105c1693678c$exports = (parcelRequire("e80qp"));




function $314ce5e1c1a9b04e$var$_extends() {
    $314ce5e1c1a9b04e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $314ce5e1c1a9b04e$var$_extends.apply(this, arguments);
}
var $314ce5e1c1a9b04e$var$symbolFactories = {
    symbolCircle: (0, $1ff5105c1693678c$exports.symbolCircle),
    symbolCross: (0, $1ff5105c1693678c$exports.symbolCross),
    symbolDiamond: (0, $1ff5105c1693678c$exports.symbolDiamond),
    symbolSquare: (0, $1ff5105c1693678c$exports.symbolSquare),
    symbolStar: (0, $1ff5105c1693678c$exports.symbolStar),
    symbolTriangle: (0, $1ff5105c1693678c$exports.symbolTriangle),
    symbolWye: (0, $1ff5105c1693678c$exports.symbolWye)
};
var $314ce5e1c1a9b04e$var$RADIAN = Math.PI / 180;
var $314ce5e1c1a9b04e$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($f754ad19e6141c59$exports)))(type));
    return $314ce5e1c1a9b04e$var$symbolFactories[name] || (0, $1ff5105c1693678c$exports.symbolCircle);
};
var $314ce5e1c1a9b04e$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $314ce5e1c1a9b04e$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $314ce5e1c1a9b04e$var$symbolsDefaultProps = {
    type: 'circle',
    size: 64,
    sizeType: 'area'
};
var $314ce5e1c1a9b04e$var$registerSymbol = function registerSymbol(key, factory) {
    $314ce5e1c1a9b04e$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($f754ad19e6141c59$exports)))(key))] = factory;
};
var $314ce5e1c1a9b04e$export$fa456266707bf4e4 = function Symbols(props) {
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var size = props.size, sizeType = props.sizeType, type = props.type;
        var symbolFactory = $314ce5e1c1a9b04e$var$getSymbolFactory(type);
        var symbol = (0, $1ff5105c1693678c$exports.symbol)().type(symbolFactory).size($314ce5e1c1a9b04e$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy, size = props.size;
    var filteredProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("path", $314ce5e1c1a9b04e$var$_extends({}, filteredProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$314ce5e1c1a9b04e$export$fa456266707bf4e4.defaultProps = $314ce5e1c1a9b04e$var$symbolsDefaultProps;
$314ce5e1c1a9b04e$export$fa456266707bf4e4.registerSymbol = $314ce5e1c1a9b04e$var$registerSymbol;



function $ef6ac09a095c0161$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ef6ac09a095c0161$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ef6ac09a095c0161$var$_typeof(obj);
}
function $ef6ac09a095c0161$var$_extends() {
    $ef6ac09a095c0161$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ef6ac09a095c0161$var$_extends.apply(this, arguments);
}
function $ef6ac09a095c0161$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ef6ac09a095c0161$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ef6ac09a095c0161$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ef6ac09a095c0161$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ef6ac09a095c0161$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ef6ac09a095c0161$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ef6ac09a095c0161$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ef6ac09a095c0161$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ef6ac09a095c0161$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ef6ac09a095c0161$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ef6ac09a095c0161$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ef6ac09a095c0161$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ef6ac09a095c0161$var$_setPrototypeOf(subClass, superClass);
}
function $ef6ac09a095c0161$var$_setPrototypeOf(o, p) {
    $ef6ac09a095c0161$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ef6ac09a095c0161$var$_setPrototypeOf(o, p);
}
function $ef6ac09a095c0161$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ef6ac09a095c0161$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ef6ac09a095c0161$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ef6ac09a095c0161$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ef6ac09a095c0161$var$_possibleConstructorReturn(this, result);
    };
}
function $ef6ac09a095c0161$var$_possibleConstructorReturn(self, call) {
    if (call && ($ef6ac09a095c0161$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ef6ac09a095c0161$var$_assertThisInitialized(self);
}
function $ef6ac09a095c0161$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ef6ac09a095c0161$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ef6ac09a095c0161$var$_getPrototypeOf(o) {
    $ef6ac09a095c0161$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ef6ac09a095c0161$var$_getPrototypeOf(o);
}
function $ef6ac09a095c0161$var$_defineProperty(obj, key, value) {
    key = $ef6ac09a095c0161$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ef6ac09a095c0161$var$_toPropertyKey(arg) {
    var key = $ef6ac09a095c0161$var$_toPrimitive(arg, "string");
    return $ef6ac09a095c0161$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ef6ac09a095c0161$var$_toPrimitive(input, hint) {
    if ($ef6ac09a095c0161$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ef6ac09a095c0161$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $ef6ac09a095c0161$var$SIZE = 32;
var $ef6ac09a095c0161$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $ef6ac09a095c0161$var$_inherits(DefaultLegendContent, _PureComponent);
    var _super = $ef6ac09a095c0161$var$_createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        $ef6ac09a095c0161$var$_classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    $ef6ac09a095c0161$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $ef6ac09a095c0161$var$SIZE / 2;
                var sixthSize = $ef6ac09a095c0161$var$SIZE / 6;
                var thirdSize = $ef6ac09a095c0161$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $ef6ac09a095c0161$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($ef6ac09a095c0161$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($ef6ac09a095c0161$var$SIZE / 8, "h").concat($ef6ac09a095c0161$var$SIZE, "v").concat($ef6ac09a095c0161$var$SIZE * 3 / 4, "h").concat(-$ef6ac09a095c0161$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(data.legendIcon)) {
                    var iconProps = $ef6ac09a095c0161$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $314ce5e1c1a9b04e$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $ef6ac09a095c0161$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $ef6ac09a095c0161$var$SIZE,
                    height: $ef6ac09a095c0161$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _classNames;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))((_classNames = {
                        'recharts-legend-item': true
                    }, $ef6ac09a095c0161$var$_defineProperty(_classNames, "legend-item-".concat(i), true), $ef6ac09a095c0161$var$_defineProperty(_classNames, "inactive", entry.inactive), _classNames));
                    if (entry.type === 'none') return null;
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("li", $ef6ac09a095c0161$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $0e1d5f7291a98e27$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $774ffa3fa11358b1$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $5pP8j.PureComponent));
$ef6ac09a095c0161$var$_defineProperty($ef6ac09a095c0161$export$99f8d96ed0cededa, "displayName", 'Legend');
$ef6ac09a095c0161$var$_defineProperty($ef6ac09a095c0161$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



function $785732b572ee5e11$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $785732b572ee5e11$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $785732b572ee5e11$var$_typeof(obj);
}
var $785732b572ee5e11$var$_excluded = [
    "ref"
];
function $785732b572ee5e11$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $785732b572ee5e11$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $785732b572ee5e11$var$ownKeys(Object(source), !0).forEach(function(key) {
            $785732b572ee5e11$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $785732b572ee5e11$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $785732b572ee5e11$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $785732b572ee5e11$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $785732b572ee5e11$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $785732b572ee5e11$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $785732b572ee5e11$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $785732b572ee5e11$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $785732b572ee5e11$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $785732b572ee5e11$var$_setPrototypeOf(subClass, superClass);
}
function $785732b572ee5e11$var$_setPrototypeOf(o, p) {
    $785732b572ee5e11$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $785732b572ee5e11$var$_setPrototypeOf(o, p);
}
function $785732b572ee5e11$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $785732b572ee5e11$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $785732b572ee5e11$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $785732b572ee5e11$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $785732b572ee5e11$var$_possibleConstructorReturn(this, result);
    };
}
function $785732b572ee5e11$var$_possibleConstructorReturn(self, call) {
    if (call && ($785732b572ee5e11$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $785732b572ee5e11$var$_assertThisInitialized(self);
}
function $785732b572ee5e11$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $785732b572ee5e11$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $785732b572ee5e11$var$_getPrototypeOf(o) {
    $785732b572ee5e11$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $785732b572ee5e11$var$_getPrototypeOf(o);
}
function $785732b572ee5e11$var$_defineProperty(obj, key, value) {
    key = $785732b572ee5e11$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $785732b572ee5e11$var$_toPropertyKey(arg) {
    var key = $785732b572ee5e11$var$_toPrimitive(arg, "string");
    return $785732b572ee5e11$var$_typeof(key) === "symbol" ? key : String(key);
}
function $785732b572ee5e11$var$_toPrimitive(input, hint) {
    if ($785732b572ee5e11$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($785732b572ee5e11$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $785732b572ee5e11$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $785732b572ee5e11$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $785732b572ee5e11$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $785732b572ee5e11$var$defaultUniqBy(entry) {
    return entry.value;
}
function $785732b572ee5e11$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($738fb70c14187a7b$exports)))(payload, $785732b572ee5e11$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($738fb70c14187a7b$exports)))(payload, option);
    return payload;
}
function $785732b572ee5e11$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement(content, props);
    var ref = props.ref, otherProps = $785732b572ee5e11$var$_objectWithoutProperties(props, $785732b572ee5e11$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $ef6ac09a095c0161$export$99f8d96ed0cededa), otherProps);
}
var $785732b572ee5e11$var$EPS = 1;
var $785732b572ee5e11$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $785732b572ee5e11$var$_inherits(Legend, _PureComponent);
    var _super = $785732b572ee5e11$var$_createSuper(Legend);
    function Legend() {
        var _this;
        $785732b572ee5e11$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $785732b572ee5e11$var$_defineProperty($785732b572ee5e11$var$_assertThisInitialized(_this), "state", {
            boxWidth: -1,
            boxHeight: -1
        });
        return _this;
    }
    $785732b572ee5e11$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                var _this$state = this.state, boxWidth = _this$state.boxWidth, boxHeight = _this$state.boxHeight;
                if (boxWidth >= 0 && boxHeight >= 0) return {
                    width: boxWidth,
                    height: boxHeight
                };
                return null;
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var _box = this.getBBoxSnapshot() || {
                            width: 0
                        };
                        hPos = {
                            left: ((chartWidth || 0) - _box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box2 = this.getBBoxSnapshot() || {
                            height: 0
                        };
                        vPos = {
                            top: ((chartHeight || 0) - _box2.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $785732b572ee5e11$var$_objectSpread($785732b572ee5e11$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var _this$state2 = this.state, boxWidth = _this$state2.boxWidth, boxHeight = _this$state2.boxHeight;
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box3 = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box3.width - boxWidth) > $785732b572ee5e11$var$EPS || Math.abs(_box3.height - boxHeight) > $785732b572ee5e11$var$EPS) this.setState({
                        boxWidth: _box3.width,
                        boxHeight: _box3.height
                    }, function() {
                        if (onBBoxUpdate) onBBoxUpdate(_box3);
                    });
                } else if (boxWidth !== -1 || boxHeight !== -1) this.setState({
                    boxWidth: -1,
                    boxHeight: -1
                }, function() {
                    if (onBBoxUpdate) onBBoxUpdate(null);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $785732b572ee5e11$var$_objectSpread($785732b572ee5e11$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $785732b572ee5e11$var$renderContent(content, $785732b572ee5e11$var$_objectSpread($785732b572ee5e11$var$_objectSpread({}, this.props), {}, {
                    payload: $785732b572ee5e11$var$getUniqPayload(payloadUniqBy, payload)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === 'vertical' && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $5pP8j.PureComponent));
$785732b572ee5e11$var$_defineProperty($785732b572ee5e11$export$ed247974535929c7, "displayName", 'Legend');
$785732b572ee5e11$var$_defineProperty($785732b572ee5e11$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});

var $a5dab8b3c935330c$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $a5dab8b3c935330c$var$isEqual(value, other) {
    return $f90d3d5a86fda739$exports(value, other);
}
$a5dab8b3c935330c$exports = $a5dab8b3c935330c$var$isEqual;





var $5pP8j = parcelRequire("5pP8j");

var $5pP8j = parcelRequire("5pP8j");

var $1lj2q = parcelRequire("1lj2q");
var $fe39782544e5b1e1$exports = {};
(function(global, factory) {
    factory($fe39782544e5b1e1$exports);
})($fe39782544e5b1e1$exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== 'object' || typeof b !== 'object') return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $cb44eef74a05e311$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $cb44eef74a05e311$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $cb44eef74a05e311$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $54c42fa029e49b8d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $54c42fa029e49b8d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $54c42fa029e49b8d$var$_typeof(obj);
}
function $54c42fa029e49b8d$var$_toArray(arr) {
    return $54c42fa029e49b8d$var$_arrayWithHoles(arr) || $54c42fa029e49b8d$var$_iterableToArray(arr) || $54c42fa029e49b8d$var$_unsupportedIterableToArray(arr) || $54c42fa029e49b8d$var$_nonIterableRest();
}
function $54c42fa029e49b8d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $54c42fa029e49b8d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $54c42fa029e49b8d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $54c42fa029e49b8d$var$_arrayLikeToArray(o, minLen);
}
function $54c42fa029e49b8d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $54c42fa029e49b8d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $54c42fa029e49b8d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $54c42fa029e49b8d$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $54c42fa029e49b8d$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $cb44eef74a05e311$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $cb44eef74a05e311$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($54c42fa029e49b8d$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $5446dcdb4677b7d9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5446dcdb4677b7d9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5446dcdb4677b7d9$var$_typeof(obj);
}
function $5446dcdb4677b7d9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5446dcdb4677b7d9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5446dcdb4677b7d9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5446dcdb4677b7d9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5446dcdb4677b7d9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5446dcdb4677b7d9$var$_defineProperty(obj, key, value) {
    key = $5446dcdb4677b7d9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5446dcdb4677b7d9$var$_toPropertyKey(arg) {
    var key = $5446dcdb4677b7d9$var$_toPrimitive(arg, "string");
    return $5446dcdb4677b7d9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5446dcdb4677b7d9$var$_toPrimitive(input, hint) {
    if ($5446dcdb4677b7d9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5446dcdb4677b7d9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint no-console: 0 */ var $5446dcdb4677b7d9$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $5446dcdb4677b7d9$var$IN_LINE_PREFIX_LIST = [
    '-webkit-',
    '-moz-',
    '-o-',
    '-ms-'
];
var $5446dcdb4677b7d9$var$IN_COMPATIBLE_PROPERTY = [
    'transform',
    'transformOrigin',
    'transition'
];
var $5446dcdb4677b7d9$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $5446dcdb4677b7d9$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $5446dcdb4677b7d9$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $5446dcdb4677b7d9$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if ($5446dcdb4677b7d9$var$IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return $5446dcdb4677b7d9$var$_defineProperty({}, name, Number.isNaN(value) ? 0 : value);
    var isTransition = name === 'transition';
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return $5446dcdb4677b7d9$var$PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat($5446dcdb4677b7d9$var$IN_LINE_PREFIX_LIST[i], "$1"));
        return $5446dcdb4677b7d9$var$_objectSpread($5446dcdb4677b7d9$var$_objectSpread({}, result), {}, $5446dcdb4677b7d9$var$_defineProperty({}, property + camelName, styleVal));
    }, {});
};
var $5446dcdb4677b7d9$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $5446dcdb4677b7d9$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $5446dcdb4677b7d9$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $5446dcdb4677b7d9$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $5446dcdb4677b7d9$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $5446dcdb4677b7d9$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $5446dcdb4677b7d9$var$_objectSpread($5446dcdb4677b7d9$var$_objectSpread({}, res), {}, $5446dcdb4677b7d9$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $5446dcdb4677b7d9$export$ff9926a5d1daa67c = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return $5446dcdb4677b7d9$var$_objectSpread($5446dcdb4677b7d9$var$_objectSpread({}, res), $5446dcdb4677b7d9$export$4a9169b65825efee(key, res[key]));
    }, style);
};
var $5446dcdb4677b7d9$export$f672e0b6f7222cd7 = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return $5446dcdb4677b7d9$export$f0954fd7d5368655;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $5446dcdb4677b7d9$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($5446dcdb4677b7d9$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $5446dcdb4677b7d9$var$isDev = false;
var $5446dcdb4677b7d9$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($5446dcdb4677b7d9$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $2141177ccfe03366$var$_slicedToArray(arr, i) {
    return $2141177ccfe03366$var$_arrayWithHoles(arr) || $2141177ccfe03366$var$_iterableToArrayLimit(arr, i) || $2141177ccfe03366$var$_unsupportedIterableToArray(arr, i) || $2141177ccfe03366$var$_nonIterableRest();
}
function $2141177ccfe03366$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2141177ccfe03366$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $2141177ccfe03366$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2141177ccfe03366$var$_toConsumableArray(arr) {
    return $2141177ccfe03366$var$_arrayWithoutHoles(arr) || $2141177ccfe03366$var$_iterableToArray(arr) || $2141177ccfe03366$var$_unsupportedIterableToArray(arr) || $2141177ccfe03366$var$_nonIterableSpread();
}
function $2141177ccfe03366$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2141177ccfe03366$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2141177ccfe03366$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2141177ccfe03366$var$_arrayLikeToArray(o, minLen);
}
function $2141177ccfe03366$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $2141177ccfe03366$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2141177ccfe03366$var$_arrayLikeToArray(arr);
}
function $2141177ccfe03366$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $2141177ccfe03366$var$ACCURACY = 1e-4;
var $2141177ccfe03366$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $2141177ccfe03366$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $2141177ccfe03366$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $2141177ccfe03366$var$cubicBezierFactor(c1, c2);
        return $2141177ccfe03366$var$multyTime(params, t);
    };
};
var $2141177ccfe03366$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $2141177ccfe03366$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($2141177ccfe03366$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $2141177ccfe03366$var$multyTime(newParams, t);
    };
};
var $2141177ccfe03366$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $2141177ccfe03366$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $5446dcdb4677b7d9$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $5446dcdb4677b7d9$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $2141177ccfe03366$var$cubicBezier(x1, x2);
    var curveY = $2141177ccfe03366$var$cubicBezier(y1, y2);
    var derCurveX = $2141177ccfe03366$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $2141177ccfe03366$var$ACCURACY || derVal < $2141177ccfe03366$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $2141177ccfe03366$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $2141177ccfe03366$var$ACCURACY && Math.abs(newV) < $2141177ccfe03366$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $2141177ccfe03366$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $2141177ccfe03366$export$56c51296f72f0592(easing);
        case 'spring':
            return $2141177ccfe03366$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $2141177ccfe03366$export$56c51296f72f0592(easing);
            (0, $5446dcdb4677b7d9$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $5446dcdb4677b7d9$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $1c992115736c0a66$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1c992115736c0a66$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1c992115736c0a66$var$_typeof(obj);
}
function $1c992115736c0a66$var$_toConsumableArray(arr) {
    return $1c992115736c0a66$var$_arrayWithoutHoles(arr) || $1c992115736c0a66$var$_iterableToArray(arr) || $1c992115736c0a66$var$_unsupportedIterableToArray(arr) || $1c992115736c0a66$var$_nonIterableSpread();
}
function $1c992115736c0a66$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1c992115736c0a66$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1c992115736c0a66$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1c992115736c0a66$var$_arrayLikeToArray(arr);
}
function $1c992115736c0a66$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c992115736c0a66$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1c992115736c0a66$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1c992115736c0a66$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1c992115736c0a66$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1c992115736c0a66$var$_defineProperty(obj, key, value) {
    key = $1c992115736c0a66$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1c992115736c0a66$var$_toPropertyKey(arg) {
    var key = $1c992115736c0a66$var$_toPrimitive(arg, "string");
    return $1c992115736c0a66$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1c992115736c0a66$var$_toPrimitive(input, hint) {
    if ($1c992115736c0a66$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1c992115736c0a66$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1c992115736c0a66$var$_slicedToArray(arr, i) {
    return $1c992115736c0a66$var$_arrayWithHoles(arr) || $1c992115736c0a66$var$_iterableToArrayLimit(arr, i) || $1c992115736c0a66$var$_unsupportedIterableToArray(arr, i) || $1c992115736c0a66$var$_nonIterableRest();
}
function $1c992115736c0a66$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1c992115736c0a66$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1c992115736c0a66$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1c992115736c0a66$var$_arrayLikeToArray(o, minLen);
}
function $1c992115736c0a66$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1c992115736c0a66$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $1c992115736c0a66$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $1c992115736c0a66$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $1c992115736c0a66$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $1c992115736c0a66$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $5446dcdb4677b7d9$export$d6051a0f7a227332)(function(key, val) {
        if ($1c992115736c0a66$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $1c992115736c0a66$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $1c992115736c0a66$var$_objectSpread($1c992115736c0a66$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $5446dcdb4677b7d9$export$d6051a0f7a227332)(function(key, val) {
        if ($1c992115736c0a66$var$needContinue(val)) return $1c992115736c0a66$var$_objectSpread($1c992115736c0a66$var$_objectSpread({}, val), {}, {
            velocity: $1c992115736c0a66$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $1c992115736c0a66$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$1c992115736c0a66$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $5446dcdb4677b7d9$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $1c992115736c0a66$var$_objectSpread($1c992115736c0a66$var$_objectSpread({}, res), {}, $1c992115736c0a66$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $1c992115736c0a66$var$_objectSpread($1c992115736c0a66$var$_objectSpread({}, res), {}, $1c992115736c0a66$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $5446dcdb4677b7d9$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($1c992115736c0a66$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $1c992115736c0a66$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($1c992115736c0a66$var$_objectSpread($1c992115736c0a66$var$_objectSpread($1c992115736c0a66$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $5446dcdb4677b7d9$export$d6051a0f7a227332)(function(key, val) {
            return $1c992115736c0a66$var$alpha.apply(void 0, $1c992115736c0a66$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($1c992115736c0a66$var$_objectSpread($1c992115736c0a66$var$_objectSpread($1c992115736c0a66$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $5446dcdb4677b7d9$export$d6051a0f7a227332)(function(key, val) {
                return $1c992115736c0a66$var$alpha.apply(void 0, $1c992115736c0a66$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($1c992115736c0a66$var$_objectSpread($1c992115736c0a66$var$_objectSpread($1c992115736c0a66$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $1120bb5d50244153$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1120bb5d50244153$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1120bb5d50244153$var$_typeof(obj);
}
var $1120bb5d50244153$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $1120bb5d50244153$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1120bb5d50244153$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1120bb5d50244153$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1120bb5d50244153$var$_toConsumableArray(arr) {
    return $1120bb5d50244153$var$_arrayWithoutHoles(arr) || $1120bb5d50244153$var$_iterableToArray(arr) || $1120bb5d50244153$var$_unsupportedIterableToArray(arr) || $1120bb5d50244153$var$_nonIterableSpread();
}
function $1120bb5d50244153$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1120bb5d50244153$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1120bb5d50244153$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1120bb5d50244153$var$_arrayLikeToArray(o, minLen);
}
function $1120bb5d50244153$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1120bb5d50244153$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1120bb5d50244153$var$_arrayLikeToArray(arr);
}
function $1120bb5d50244153$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1120bb5d50244153$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1120bb5d50244153$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1120bb5d50244153$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1120bb5d50244153$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1120bb5d50244153$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1120bb5d50244153$var$_defineProperty(obj, key, value) {
    key = $1120bb5d50244153$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1120bb5d50244153$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1120bb5d50244153$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1120bb5d50244153$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1120bb5d50244153$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1120bb5d50244153$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1120bb5d50244153$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1120bb5d50244153$var$_toPropertyKey(arg) {
    var key = $1120bb5d50244153$var$_toPrimitive(arg, "string");
    return $1120bb5d50244153$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1120bb5d50244153$var$_toPrimitive(input, hint) {
    if ($1120bb5d50244153$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1120bb5d50244153$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1120bb5d50244153$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1120bb5d50244153$var$_setPrototypeOf(subClass, superClass);
}
function $1120bb5d50244153$var$_setPrototypeOf(o, p) {
    $1120bb5d50244153$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1120bb5d50244153$var$_setPrototypeOf(o, p);
}
function $1120bb5d50244153$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1120bb5d50244153$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1120bb5d50244153$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1120bb5d50244153$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1120bb5d50244153$var$_possibleConstructorReturn(this, result);
    };
}
function $1120bb5d50244153$var$_possibleConstructorReturn(self, call) {
    if (call && ($1120bb5d50244153$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1120bb5d50244153$var$_assertThisInitialized(self);
}
function $1120bb5d50244153$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1120bb5d50244153$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1120bb5d50244153$var$_getPrototypeOf(o) {
    $1120bb5d50244153$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1120bb5d50244153$var$_getPrototypeOf(o);
}
var $1120bb5d50244153$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $1120bb5d50244153$var$_inherits(Animate, _PureComponent);
    var _super = $1120bb5d50244153$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $1120bb5d50244153$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($1120bb5d50244153$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($1120bb5d50244153$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $1120bb5d50244153$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $1120bb5d50244153$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $1120bb5d50244153$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $1120bb5d50244153$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $1120bb5d50244153$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $fe39782544e5b1e1$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $1120bb5d50244153$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && [
                        attributeName
                    ] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($1120bb5d50244153$var$_objectSpread($1120bb5d50244153$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $1c992115736c0a66$export$2e2bcd8739ae039)(from, to, (0, $2141177ccfe03366$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($1120bb5d50244153$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $5446dcdb4677b7d9$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $1120bb5d50244153$var$_objectSpread($1120bb5d50244153$var$_objectSpread($1120bb5d50244153$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($1120bb5d50244153$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $5446dcdb4677b7d9$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($1120bb5d50244153$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $54c42fa029e49b8d$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $1120bb5d50244153$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $5446dcdb4677b7d9$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $1120bb5d50244153$var$_objectSpread($1120bb5d50244153$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $1120bb5d50244153$var$_objectWithoutProperties(_this$props4, $1120bb5d50244153$var$_excluded);
                var count = (0, $5pP8j.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = (0, $5446dcdb4677b7d9$export$ff9926a5d1daa67c)(this.state.style);
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $5pP8j.cloneElement)(container, $1120bb5d50244153$var$_objectSpread($1120bb5d50244153$var$_objectSpread({}, others), {}, {
                        style: $1120bb5d50244153$var$_objectSpread($1120bb5d50244153$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $5pP8j.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("div", null, (0, $5pP8j.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $5pP8j.PureComponent));
$1120bb5d50244153$var$Animate.displayName = 'Animate';
$1120bb5d50244153$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$1120bb5d50244153$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).func
};
var $1120bb5d50244153$export$2e2bcd8739ae039 = $1120bb5d50244153$var$Animate;





var $5pP8j = parcelRequire("5pP8j");
var $b9947f6d96a95512$exports = {};
"use strict";

var $b9947f6d96a95512$var$_CSSTransition = $b9947f6d96a95512$var$_interopRequireDefault((parcelRequire("7jn8y")));

var $b9947f6d96a95512$var$_ReplaceTransition = $b9947f6d96a95512$var$_interopRequireDefault((parcelRequire("jiiJH")));

var $b9947f6d96a95512$var$_TransitionGroup = $b9947f6d96a95512$var$_interopRequireDefault((parcelRequire("kH8E2")));

var $b9947f6d96a95512$var$_Transition = $b9947f6d96a95512$var$_interopRequireDefault((parcelRequire("k6WUg")));
function $b9947f6d96a95512$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$b9947f6d96a95512$exports = {
    Transition: $b9947f6d96a95512$var$_Transition.default,
    TransitionGroup: $b9947f6d96a95512$var$_TransitionGroup.default,
    ReplaceTransition: $b9947f6d96a95512$var$_ReplaceTransition.default,
    CSSTransition: $b9947f6d96a95512$var$_CSSTransition.default
};



var $1lj2q = parcelRequire("1lj2q");

var $5pP8j = parcelRequire("5pP8j");


var $1lj2q = parcelRequire("1lj2q");

var $ffb6a768d05a747d$var$_excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function $ffb6a768d05a747d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ffb6a768d05a747d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ffb6a768d05a747d$var$_typeof(obj);
}
function $ffb6a768d05a747d$var$_extends() {
    $ffb6a768d05a747d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ffb6a768d05a747d$var$_extends.apply(this, arguments);
}
function $ffb6a768d05a747d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ffb6a768d05a747d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ffb6a768d05a747d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ffb6a768d05a747d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ffb6a768d05a747d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ffb6a768d05a747d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ffb6a768d05a747d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ffb6a768d05a747d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ffb6a768d05a747d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ffb6a768d05a747d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ffb6a768d05a747d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ffb6a768d05a747d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ffb6a768d05a747d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ffb6a768d05a747d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ffb6a768d05a747d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ffb6a768d05a747d$var$_setPrototypeOf(subClass, superClass);
}
function $ffb6a768d05a747d$var$_setPrototypeOf(o, p) {
    $ffb6a768d05a747d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ffb6a768d05a747d$var$_setPrototypeOf(o, p);
}
function $ffb6a768d05a747d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ffb6a768d05a747d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ffb6a768d05a747d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ffb6a768d05a747d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ffb6a768d05a747d$var$_possibleConstructorReturn(this, result);
    };
}
function $ffb6a768d05a747d$var$_possibleConstructorReturn(self, call) {
    if (call && ($ffb6a768d05a747d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ffb6a768d05a747d$var$_assertThisInitialized(self);
}
function $ffb6a768d05a747d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ffb6a768d05a747d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ffb6a768d05a747d$var$_getPrototypeOf(o) {
    $ffb6a768d05a747d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ffb6a768d05a747d$var$_getPrototypeOf(o);
}
function $ffb6a768d05a747d$var$_defineProperty(obj, key, value) {
    key = $ffb6a768d05a747d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ffb6a768d05a747d$var$_toPropertyKey(arg) {
    var key = $ffb6a768d05a747d$var$_toPrimitive(arg, "string");
    return $ffb6a768d05a747d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ffb6a768d05a747d$var$_toPrimitive(input, hint) {
    if ($ffb6a768d05a747d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ffb6a768d05a747d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === 'number' && isFinite(value);
};
var $ffb6a768d05a747d$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $ffb6a768d05a747d$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $ffb6a768d05a747d$var$_inherits(AnimateGroupChild, _Component);
    var _super = $ffb6a768d05a747d$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $ffb6a768d05a747d$var$_classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        $ffb6a768d05a747d$var$_defineProperty($ffb6a768d05a747d$var$_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        $ffb6a768d05a747d$var$_defineProperty($ffb6a768d05a747d$var$_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    $ffb6a768d05a747d$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($ffb6a768d05a747d$var$_objectSpread($ffb6a768d05a747d$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $ffb6a768d05a747d$var$parseDurationOfSingleTransition(appearOptions) + $ffb6a768d05a747d$var$parseDurationOfSingleTransition(enterOptions) + $ffb6a768d05a747d$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $ffb6a768d05a747d$var$_objectWithoutProperties(_this$props3, $ffb6a768d05a747d$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $b9947f6d96a95512$exports.Transition), $ffb6a768d05a747d$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $1120bb5d50244153$export$2e2bcd8739ae039), _this2.state, (0, $5pP8j.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $5pP8j.Component));
$ffb6a768d05a747d$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).element
};
var $ffb6a768d05a747d$export$2e2bcd8739ae039 = $ffb6a768d05a747d$var$AnimateGroupChild;


function $1cf58bdabda94cc6$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $b9947f6d96a95512$exports.TransitionGroup), {
        component: component
    }, (0, $5pP8j.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $ffb6a768d05a747d$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$1cf58bdabda94cc6$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($1lj2q))).any
};
$1cf58bdabda94cc6$var$AnimateGroup.defaultProps = {
    component: 'span'
};
var $1cf58bdabda94cc6$export$2e2bcd8739ae039 = $1cf58bdabda94cc6$var$AnimateGroup;


var $ee2bc8c876b1194a$export$2e2bcd8739ae039 = (0, $1120bb5d50244153$export$2e2bcd8739ae039);







var $5pP8j = parcelRequire("5pP8j");





function $7eb448ddfde98505$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7eb448ddfde98505$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7eb448ddfde98505$var$_typeof(obj);
}
function $7eb448ddfde98505$var$_extends() {
    $7eb448ddfde98505$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7eb448ddfde98505$var$_extends.apply(this, arguments);
}
function $7eb448ddfde98505$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7eb448ddfde98505$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7eb448ddfde98505$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7eb448ddfde98505$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7eb448ddfde98505$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7eb448ddfde98505$var$_defineProperty(obj, key, value) {
    key = $7eb448ddfde98505$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7eb448ddfde98505$var$_toPropertyKey(arg) {
    var key = $7eb448ddfde98505$var$_toPrimitive(arg, "string");
    return $7eb448ddfde98505$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7eb448ddfde98505$var$_toPrimitive(input, hint) {
    if ($7eb448ddfde98505$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7eb448ddfde98505$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7eb448ddfde98505$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $1ff5105c1693678c$exports.curveBasisClosed),
    curveBasisOpen: (0, $1ff5105c1693678c$exports.curveBasisOpen),
    curveBasis: (0, $1ff5105c1693678c$exports.curveBasis),
    curveBumpX: (0, $1ff5105c1693678c$exports.curveBumpX),
    curveBumpY: (0, $1ff5105c1693678c$exports.curveBumpY),
    curveLinearClosed: (0, $1ff5105c1693678c$exports.curveLinearClosed),
    curveLinear: (0, $1ff5105c1693678c$exports.curveLinear),
    curveMonotoneX: (0, $1ff5105c1693678c$exports.curveMonotoneX),
    curveMonotoneY: (0, $1ff5105c1693678c$exports.curveMonotoneY),
    curveNatural: (0, $1ff5105c1693678c$exports.curveNatural),
    curveStep: (0, $1ff5105c1693678c$exports.curveStep),
    curveStepAfter: (0, $1ff5105c1693678c$exports.curveStepAfter),
    curveStepBefore: (0, $1ff5105c1693678c$exports.curveStepBefore)
};
var $7eb448ddfde98505$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $7eb448ddfde98505$var$getX = function getX(p) {
    return p.x;
};
var $7eb448ddfde98505$var$getY = function getY(p) {
    return p.y;
};
var $7eb448ddfde98505$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($f754ad19e6141c59$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $7eb448ddfde98505$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $7eb448ddfde98505$var$CURVE_FACTORIES[name] || (0, $1ff5105c1693678c$exports.curveLinear);
};
/**
 * Calculate the path of curve
 * @return {String} path
 */ var $7eb448ddfde98505$var$getPath = function getPath(_ref) {
    var type = _ref.type, points = _ref.points, baseLine = _ref.baseLine, layout = _ref.layout, connectNulls = _ref.connectNulls;
    var curveFactory = $7eb448ddfde98505$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $7eb448ddfde98505$var$defined(entry);
    }) : points;
    var lineFunction;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $7eb448ddfde98505$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $7eb448ddfde98505$var$_objectSpread($7eb448ddfde98505$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $1ff5105c1693678c$exports.area)().y($7eb448ddfde98505$var$getY).x1($7eb448ddfde98505$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $1ff5105c1693678c$exports.area)().x($7eb448ddfde98505$var$getX).y1($7eb448ddfde98505$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($7eb448ddfde98505$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $1ff5105c1693678c$exports.area)().y($7eb448ddfde98505$var$getY).x1($7eb448ddfde98505$var$getX).x0(baseLine);
    else if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $1ff5105c1693678c$exports.area)().x($7eb448ddfde98505$var$getX).y1($7eb448ddfde98505$var$getY).y0(baseLine);
    else lineFunction = (0, $1ff5105c1693678c$exports.line)().x($7eb448ddfde98505$var$getX).y($7eb448ddfde98505$var$getY);
    lineFunction.defined($7eb448ddfde98505$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $7eb448ddfde98505$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $7eb448ddfde98505$var$getPath(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("path", $7eb448ddfde98505$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props), (0, $0e1d5f7291a98e27$export$7c4c290a4a9c1b1e)(props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};
$7eb448ddfde98505$export$b0e83c3ef8d2db1.defaultProps = {
    type: 'linear',
    points: [],
    connectNulls: false
};



var $5pP8j = parcelRequire("5pP8j");



function $bb16faa3019e11e8$var$_extends() {
    $bb16faa3019e11e8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bb16faa3019e11e8$var$_extends.apply(this, arguments);
}
var $bb16faa3019e11e8$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("circle", $bb16faa3019e11e8$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props), (0, $0e1d5f7291a98e27$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};



var $5pP8j = parcelRequire("5pP8j");


var $a69f4be7c5584c1e$var$_excluded = [
    "children",
    "className"
];
function $a69f4be7c5584c1e$var$_extends() {
    $a69f4be7c5584c1e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a69f4be7c5584c1e$var$_extends.apply(this, arguments);
}
function $a69f4be7c5584c1e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a69f4be7c5584c1e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a69f4be7c5584c1e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a69f4be7c5584c1e$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $a69f4be7c5584c1e$var$_objectWithoutProperties(props, $a69f4be7c5584c1e$var$_excluded);
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("g", $a69f4be7c5584c1e$var$_extends({
        className: layerClass
    }, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});





var $3d1cab1292d40359$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $3d1cab1292d40359$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$3d1cab1292d40359$exports = $3d1cab1292d40359$var$last;




var $5pP8j = parcelRequire("5pP8j");




var $5pP8j = parcelRequire("5pP8j");



var $5pP8j = parcelRequire("5pP8j");
var $a426e75e0f206812$exports = {};
'use strict';
Object.defineProperty($a426e75e0f206812$exports, "__esModule", {
    value: true
});
var $5c76a01bb10f66e8$exports = {};
var $724851b5f390d71f$exports = {};
var $724851b5f390d71f$var$openParentheses = "(".charCodeAt(0);
var $724851b5f390d71f$var$closeParentheses = ")".charCodeAt(0);
var $724851b5f390d71f$var$singleQuote = "'".charCodeAt(0);
var $724851b5f390d71f$var$doubleQuote = '"'.charCodeAt(0);
var $724851b5f390d71f$var$backslash = "\\".charCodeAt(0);
var $724851b5f390d71f$var$slash = "/".charCodeAt(0);
var $724851b5f390d71f$var$comma = ",".charCodeAt(0);
var $724851b5f390d71f$var$colon = ":".charCodeAt(0);
var $724851b5f390d71f$var$star = "*".charCodeAt(0);
$724851b5f390d71f$exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === $724851b5f390d71f$var$closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") prev.after = token;
            else if (code === $724851b5f390d71f$var$comma || code === $724851b5f390d71f$var$colon || code === $724851b5f390d71f$var$slash && value.charCodeAt(next + 1) !== $724851b5f390d71f$var$star) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === $724851b5f390d71f$var$singleQuote || code === $724851b5f390d71f$var$doubleQuote) {
            next = pos;
            quote = code === $724851b5f390d71f$var$singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === $724851b5f390d71f$var$backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === $724851b5f390d71f$var$slash && value.charCodeAt(pos + 1) === $724851b5f390d71f$var$star) {
            token = {
                type: "comment",
                sourceIndex: pos
            };
            next = value.indexOf("*/", pos);
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === $724851b5f390d71f$var$slash || code === $724851b5f390d71f$var$comma || code === $724851b5f390d71f$var$colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if ($724851b5f390d71f$var$openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(pos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== $724851b5f390d71f$var$singleQuote && code !== $724851b5f390d71f$var$doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $724851b5f390d71f$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (pos !== whitespacePos + 1) token.nodes = [
                    {
                        type: "word",
                        sourceIndex: pos,
                        value: value.slice(pos, whitespacePos + 1)
                    }
                ];
                else token.nodes = [];
                if (token.unclosed && whitespacePos + 1 !== next) {
                    token.after = "";
                    token.nodes.push({
                        type: "space",
                        sourceIndex: whitespacePos + 1,
                        value: value.slice(whitespacePos + 1, next)
                    });
                } else token.after = value.slice(whitespacePos + 1, next);
                pos = next + 1;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if ($724851b5f390d71f$var$closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            after = "";
            balanced -= 1;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === $724851b5f390d71f$var$backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === $724851b5f390d71f$var$singleQuote || code === $724851b5f390d71f$var$doubleQuote || code === $724851b5f390d71f$var$comma || code === $724851b5f390d71f$var$colon || code === $724851b5f390d71f$var$slash || code === $724851b5f390d71f$var$openParentheses || code === $724851b5f390d71f$var$closeParentheses && balanced));
            token = value.slice(pos, next);
            if ($724851b5f390d71f$var$openParentheses === code) name = token;
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1)stack[pos].unclosed = true;
    return stack[0].nodes;
};


var $3f21ff928716d0cd$exports = {};
$3f21ff928716d0cd$exports = function walk(nodes, cb, bubble) {
    var i, max, node, result;
    for(i = 0, max = nodes.length; i < max; i += 1){
        node = nodes[i];
        if (!bubble) result = cb(node, i, nodes);
        if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
        if (bubble) cb(node, i, nodes);
    }
};


var $22351ee8ded5ea31$exports = {};
function $22351ee8ded5ea31$var$stringifyNode(node, custom) {
    var type = node.type;
    var value = node.value;
    var buf;
    var customResult;
    if (custom && (customResult = custom(node)) !== undefined) return customResult;
    else if (type === "word" || type === "space") return value;
    else if (type === "string") {
        buf = node.quote || "";
        return buf + value + (node.unclosed ? "" : buf);
    } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
    else if (type === "div") return (node.before || "") + value + (node.after || "");
    else if (Array.isArray(node.nodes)) {
        buf = $22351ee8ded5ea31$var$stringify(node.nodes);
        if (type !== "function") return buf;
        return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
    }
    return value;
}
function $22351ee8ded5ea31$var$stringify(nodes, custom) {
    var result, i;
    if (Array.isArray(nodes)) {
        result = "";
        for(i = nodes.length - 1; ~i; i -= 1)result = $22351ee8ded5ea31$var$stringifyNode(nodes[i], custom) + result;
        return result;
    }
    return $22351ee8ded5ea31$var$stringifyNode(nodes, custom);
}
$22351ee8ded5ea31$exports = $22351ee8ded5ea31$var$stringify;


function $5c76a01bb10f66e8$var$ValueParser(value) {
    if (this instanceof $5c76a01bb10f66e8$var$ValueParser) {
        this.nodes = $724851b5f390d71f$exports(value);
        return this;
    }
    return new $5c76a01bb10f66e8$var$ValueParser(value);
}
$5c76a01bb10f66e8$var$ValueParser.prototype.toString = function() {
    return Array.isArray(this.nodes) ? $22351ee8ded5ea31$exports(this.nodes) : "";
};
$5c76a01bb10f66e8$var$ValueParser.prototype.walk = function(cb, bubble) {
    $3f21ff928716d0cd$exports(this.nodes, cb, bubble);
    return this;
};

$5c76a01bb10f66e8$var$ValueParser.unit = (parcelRequire("fKc9g"));
$5c76a01bb10f66e8$var$ValueParser.walk = $3f21ff928716d0cd$exports;
$5c76a01bb10f66e8$var$ValueParser.stringify = $22351ee8ded5ea31$exports;
$5c76a01bb10f66e8$exports = $5c76a01bb10f66e8$var$ValueParser;


var $a426e75e0f206812$var$_postcssValueParser2 = $a426e75e0f206812$var$_interopRequireDefault($5c76a01bb10f66e8$exports);
/* parser generated by jison 0.6.1-215 */ /*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var $df9fd8a8e4983507$export$8f49e4af10703ce3;
var $df9fd8a8e4983507$export$7acfa6ed01010e37;
var $df9fd8a8e4983507$export$98e6a39c04603d36;
var $df9fd8a8e4983507$var$parser = function() {
    // See also:
    // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
    // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
    // with userland code which might access the derived class in a 'classic' way.
    function JisonParserError(msg, hash) {
        Object.defineProperty(this, 'name', {
            enumerable: false,
            writable: false,
            value: 'JisonParserError'
        });
        if (msg == null) msg = '???';
        Object.defineProperty(this, 'message', {
            enumerable: false,
            writable: true,
            value: msg
        });
        this.hash = hash;
        var stacktrace;
        if (hash && hash.exception instanceof Error) {
            var ex2 = hash.exception;
            this.message = ex2.message || msg;
            stacktrace = ex2.stack;
        }
        if (!stacktrace) {
            if (Error.hasOwnProperty('captureStackTrace')) Error.captureStackTrace(this, this.constructor);
            else stacktrace = new Error(msg).stack;
        }
        if (stacktrace) Object.defineProperty(this, 'stack', {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
    if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
    else JisonParserError.prototype = Object.create(Error.prototype);
    JisonParserError.prototype.constructor = JisonParserError;
    JisonParserError.prototype.name = 'JisonParserError';
    // helper: reconstruct the productions[] table
    function bp(s) {
        var rv = [];
        var p = s.pop;
        var r = s.rule;
        for(var i = 0, l = p.length; i < l; i++)rv.push([
            p[i],
            r[i]
        ]);
        return rv;
    }
    // helper: reconstruct the defaultActions[] table
    function bda(s) {
        var rv = {};
        var d = s.idx;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var j = d[i];
            rv[j] = g[i];
        }
        return rv;
    }
    // helper: reconstruct the 'goto' table
    function bt(s) {
        var rv = [];
        var d = s.len;
        var y = s.symbol;
        var t = s.type;
        var a = s.state;
        var m = s.mode;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var n = d[i];
            var q = {};
            for(var j = 0; j < n; j++){
                var z = y.shift();
                switch(t.shift()){
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;
                    case 0:
                        q[z] = a.shift();
                        break;
                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                }
            }
            rv.push(q);
        }
        return rv;
    }
    // helper: runlength encoding with increment step: code, length: step (default step = 0)
    // `this` references an array
    function s(c, l, a) {
        a = a || 0;
        for(var i = 0; i < l; i++){
            this.push(c);
            c += a;
        }
    }
    // helper: duplicate sequence from *relative* offset and length.
    // `this` references an array
    function c(i, l) {
        i = this.length - i;
        for(l += i; i < l; i++)this.push(this[i]);
    }
    // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
    function u(a) {
        var rv = [];
        for(var i = 0, l = a.length; i < l; i++){
            var e = a[i];
            // Is this entry a helper function?
            if (typeof e === 'function') {
                i++;
                e.apply(rv, a[i]);
            } else rv.push(e);
        }
        return rv;
    }
    var parser = {
        // Code Generator Information Report
        // ---------------------------------
        //
        // Options:
        //
        //   default action mode: ............. ["classic","merge"]
        //   test-compile action mode: ........ "parser:*,lexer:*"
        //   try..catch: ...................... true
        //   default resolve on conflict: ..... true
        //   on-demand look-ahead: ............ false
        //   error recovery token skip maximum: 3
        //   yyerror in parse actions is: ..... NOT recoverable,
        //   yyerror in lexer actions and other non-fatal lexer are:
        //   .................................. NOT recoverable,
        //   debug grammar/output: ............ false
        //   has partial LR conflict upgrade:   true
        //   rudimentary token-stack support:   false
        //   parser table compression mode: ... 2
        //   export debug tables: ............. false
        //   export *all* tables: ............. false
        //   module type: ..................... commonjs
        //   parser engine type: .............. lalr
        //   output main() in the module: ..... true
        //   has user-specified main(): ....... false
        //   has user-specified require()/import modules for main():
        //   .................................. false
        //   number of expected conflicts: .... 0
        //
        //
        // Parser Analysis flags:
        //
        //   no significant actions (parser is a language matcher only):
        //   .................................. false
        //   uses yyleng: ..................... false
        //   uses yylineno: ................... false
        //   uses yytext: ..................... false
        //   uses yylloc: ..................... false
        //   uses ParseError API: ............. false
        //   uses YYERROR: .................... false
        //   uses YYRECOVERING: ............... false
        //   uses YYERROK: .................... false
        //   uses YYCLEARIN: .................. false
        //   tracks rule values: .............. true
        //   assigns rule values: ............. true
        //   uses location tracking: .......... false
        //   assigns location: ................ false
        //   uses yystack: .................... false
        //   uses yysstack: ................... false
        //   uses yysp: ....................... true
        //   uses yyrulelength: ............... false
        //   uses yyMergeLocationInfo API: .... false
        //   has error recovery: .............. false
        //   has error reporting: ............. false
        //
        // --------- END OF REPORT -----------
        trace: function no_op_trace() {},
        JisonParserError: JisonParserError,
        yy: {},
        options: {
            type: "lalr",
            hasPartialLrUpgradeOnConflict: true,
            errorRecoveryTokenDiscardCount: 3
        },
        symbols_: {
            "$accept": 0,
            "$end": 1,
            "ADD": 3,
            "ANGLE": 16,
            "CHS": 22,
            "COMMA": 14,
            "CSS_CPROP": 13,
            "CSS_VAR": 12,
            "DIV": 6,
            "EMS": 20,
            "EOF": 1,
            "EXS": 21,
            "FREQ": 18,
            "LENGTH": 15,
            "LPAREN": 7,
            "MUL": 5,
            "NESTED_CALC": 9,
            "NUMBER": 11,
            "PERCENTAGE": 28,
            "PREFIX": 10,
            "REMS": 23,
            "RES": 19,
            "RPAREN": 8,
            "SUB": 4,
            "TIME": 17,
            "VHS": 24,
            "VMAXS": 27,
            "VMINS": 26,
            "VWS": 25,
            "css_value": 33,
            "css_variable": 32,
            "error": 2,
            "expression": 29,
            "math_expression": 30,
            "value": 31
        },
        terminals_: {
            1: "EOF",
            2: "error",
            3: "ADD",
            4: "SUB",
            5: "MUL",
            6: "DIV",
            7: "LPAREN",
            8: "RPAREN",
            9: "NESTED_CALC",
            10: "PREFIX",
            11: "NUMBER",
            12: "CSS_VAR",
            13: "CSS_CPROP",
            14: "COMMA",
            15: "LENGTH",
            16: "ANGLE",
            17: "TIME",
            18: "FREQ",
            19: "RES",
            20: "EMS",
            21: "EXS",
            22: "CHS",
            23: "REMS",
            24: "VHS",
            25: "VWS",
            26: "VMINS",
            27: "VMAXS",
            28: "PERCENTAGE"
        },
        TERROR: 2,
        EOF: 1,
        // internals: defined here so the object *structure* doesn't get modified by parse() et al,
        // thus helping JIT compilers like Chrome V8.
        originalQuoteName: null,
        originalParseError: null,
        cleanupAfterParse: null,
        constructParseErrorInfo: null,
        yyMergeLocationInfo: null,
        __reentrant_call_depth: 0,
        __error_infos: [],
        __error_recovery_infos: [],
        // APIs which will be set up depending on user action code analysis:
        //yyRecovering: 0,
        //yyErrOk: 0,
        //yyClearIn: 0,
        // Helper APIs
        // -----------
        // Helper function which can be overridden by user code later on: put suitable quotes around
        // literal IDs in a description string.
        quoteName: function parser_quoteName(id_str) {
            return '"' + id_str + '"';
        },
        // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
        //
        // Return NULL when the symbol is unknown to the parser.
        getSymbolName: function parser_getSymbolName(symbol) {
            if (this.terminals_[symbol]) return this.terminals_[symbol];
            // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
            //
            // An example of this may be where a rule's action code contains a call like this:
            //
            //      parser.getSymbolName(#$)
            //
            // to obtain a human-readable name of the current grammar rule.
            var s = this.symbols_;
            for(var key in s){
                if (s[key] === symbol) return key;
            }
            return null;
        },
        // Return a more-or-less human-readable description of the given symbol, when available,
        // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
        //
        // Return NULL when the symbol is unknown to the parser.
        describeSymbol: function parser_describeSymbol(symbol) {
            if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) return this.terminal_descriptions_[symbol];
            else if (symbol === this.EOF) return 'end of input';
            var id = this.getSymbolName(symbol);
            if (id) return this.quoteName(id);
            return null;
        },
        // Produce a (more or less) human-readable list of expected tokens at the point of failure.
        //
        // The produced list may contain token or token set descriptions instead of the tokens
        // themselves to help turning this output into something that easier to read by humans
        // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
        // expected terminals and nonterminals is produced.
        //
        // The returned list (array) will not contain any duplicate entries.
        collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
            var TERROR = this.TERROR;
            var tokenset = [];
            var check = {};
            // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
            // If so, use that one instead of the less palatable token set.
            if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) return [
                this.state_descriptions_[state]
            ];
            for(var p in this.table[state]){
                p = +p;
                if (p !== TERROR) {
                    var d = do_not_describe ? p : this.describeSymbol(p);
                    if (d && !check[d]) {
                        tokenset.push(d);
                        check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
                    }
                }
            }
            return tokenset;
        },
        productions_: bp({
            pop: u([
                29,
                s,
                [
                    30,
                    10
                ],
                31,
                31,
                32,
                32,
                s,
                [
                    33,
                    15
                ]
            ]),
            rule: u([
                2,
                s,
                [
                    3,
                    5
                ],
                4,
                7,
                s,
                [
                    1,
                    4
                ],
                2,
                4,
                6,
                s,
                [
                    1,
                    14
                ],
                2
            ])
        }),
        performAction: function parser__PerformAction(yystate /* action[1] */ , yysp, yyvstack) {
            /* this == yyval */ // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
            var yy = this.yy;
            var yyparser = yy.parser;
            var yylexer = yy.lexer;
            switch(yystate){
                case 0:
                    /*! Production::    $accept : expression $end */ // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    break;
                case 1:
                    /*! Production::    expression : math_expression EOF */ // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
                    return yyvstack[yysp - 1];
                case 2:
                /*! Production::    math_expression : math_expression ADD math_expression */ case 3:
                /*! Production::    math_expression : math_expression SUB math_expression */ case 4:
                /*! Production::    math_expression : math_expression MUL math_expression */ case 5:
                    /*! Production::    math_expression : math_expression DIV math_expression */ this.$ = {
                        type: 'MathExpression',
                        operator: yyvstack[yysp - 1],
                        left: yyvstack[yysp - 2],
                        right: yyvstack[yysp]
                    };
                    break;
                case 6:
                    /*! Production::    math_expression : LPAREN math_expression RPAREN */ this.$ = yyvstack[yysp - 1];
                    break;
                case 7:
                    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: 'Calc',
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 8:
                    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: 'Calc',
                        value: yyvstack[yysp - 1],
                        prefix: yyvstack[yysp - 5]
                    };
                    break;
                case 9:
                /*! Production::    math_expression : css_variable */ case 10:
                /*! Production::    math_expression : css_value */ case 11:
                    /*! Production::    math_expression : value */ this.$ = yyvstack[yysp];
                    break;
                case 12:
                    /*! Production::    value : NUMBER */ this.$ = {
                        type: 'Value',
                        value: parseFloat(yyvstack[yysp])
                    };
                    break;
                case 13:
                    /*! Production::    value : SUB NUMBER */ this.$ = {
                        type: 'Value',
                        value: parseFloat(yyvstack[yysp]) * -1
                    };
                    break;
                case 14:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */ this.$ = {
                        type: 'CssVariable',
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 15:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */ this.$ = {
                        type: 'CssVariable',
                        value: yyvstack[yysp - 3],
                        fallback: yyvstack[yysp - 1]
                    };
                    break;
                case 16:
                    /*! Production::    css_value : LENGTH */ this.$ = {
                        type: 'LengthValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 17:
                    /*! Production::    css_value : ANGLE */ this.$ = {
                        type: 'AngleValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 18:
                    /*! Production::    css_value : TIME */ this.$ = {
                        type: 'TimeValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 19:
                    /*! Production::    css_value : FREQ */ this.$ = {
                        type: 'FrequencyValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 20:
                    /*! Production::    css_value : RES */ this.$ = {
                        type: 'ResolutionValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 21:
                    /*! Production::    css_value : EMS */ this.$ = {
                        type: 'EmValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'em'
                    };
                    break;
                case 22:
                    /*! Production::    css_value : EXS */ this.$ = {
                        type: 'ExValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'ex'
                    };
                    break;
                case 23:
                    /*! Production::    css_value : CHS */ this.$ = {
                        type: 'ChValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'ch'
                    };
                    break;
                case 24:
                    /*! Production::    css_value : REMS */ this.$ = {
                        type: 'RemValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'rem'
                    };
                    break;
                case 25:
                    /*! Production::    css_value : VHS */ this.$ = {
                        type: 'VhValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vh'
                    };
                    break;
                case 26:
                    /*! Production::    css_value : VWS */ this.$ = {
                        type: 'VwValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vw'
                    };
                    break;
                case 27:
                    /*! Production::    css_value : VMINS */ this.$ = {
                        type: 'VminValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vmin'
                    };
                    break;
                case 28:
                    /*! Production::    css_value : VMAXS */ this.$ = {
                        type: 'VmaxValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vmax'
                    };
                    break;
                case 29:
                    /*! Production::    css_value : PERCENTAGE */ this.$ = {
                        type: 'PercentageValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: '%'
                    };
                    break;
                case 30:
                    /*! Production::    css_value : SUB css_value */ var prev = yyvstack[yysp];
                    prev.value *= -1;
                    this.$ = prev;
                    break;
            }
        },
        table: bt({
            len: u([
                24,
                1,
                5,
                23,
                1,
                18,
                s,
                [
                    0,
                    3
                ],
                1,
                s,
                [
                    0,
                    16
                ],
                s,
                [
                    23,
                    4
                ],
                c,
                [
                    28,
                    3
                ],
                0,
                0,
                16,
                1,
                6,
                6,
                s,
                [
                    0,
                    3
                ],
                5,
                1,
                2,
                c,
                [
                    37,
                    3
                ],
                c,
                [
                    20,
                    3
                ],
                5,
                0,
                0
            ]),
            symbol: u([
                4,
                7,
                9,
                11,
                12,
                s,
                [
                    15,
                    19,
                    1
                ],
                1,
                1,
                s,
                [
                    3,
                    4,
                    1
                ],
                c,
                [
                    30,
                    19
                ],
                c,
                [
                    29,
                    4
                ],
                7,
                4,
                10,
                11,
                c,
                [
                    22,
                    14
                ],
                c,
                [
                    19,
                    3
                ],
                c,
                [
                    43,
                    22
                ],
                c,
                [
                    23,
                    69
                ],
                c,
                [
                    139,
                    4
                ],
                8,
                c,
                [
                    51,
                    24
                ],
                4,
                c,
                [
                    138,
                    15
                ],
                13,
                c,
                [
                    186,
                    5
                ],
                8,
                c,
                [
                    6,
                    6
                ],
                c,
                [
                    5,
                    5
                ],
                9,
                8,
                14,
                c,
                [
                    159,
                    47
                ],
                c,
                [
                    60,
                    10
                ]
            ]),
            type: u([
                s,
                [
                    2,
                    19
                ],
                s,
                [
                    0,
                    5
                ],
                1,
                s,
                [
                    2,
                    24
                ],
                s,
                [
                    0,
                    4
                ],
                c,
                [
                    22,
                    19
                ],
                c,
                [
                    43,
                    42
                ],
                c,
                [
                    23,
                    70
                ],
                c,
                [
                    28,
                    25
                ],
                c,
                [
                    45,
                    25
                ],
                c,
                [
                    113,
                    54
                ]
            ]),
            state: u([
                1,
                2,
                8,
                6,
                7,
                30,
                c,
                [
                    4,
                    3
                ],
                33,
                37,
                c,
                [
                    5,
                    3
                ],
                38,
                c,
                [
                    4,
                    3
                ],
                39,
                c,
                [
                    4,
                    3
                ],
                40,
                c,
                [
                    4,
                    3
                ],
                42,
                c,
                [
                    21,
                    4
                ],
                50,
                c,
                [
                    5,
                    3
                ],
                51,
                c,
                [
                    4,
                    3
                ]
            ]),
            mode: u([
                s,
                [
                    1,
                    179
                ],
                s,
                [
                    2,
                    3
                ],
                c,
                [
                    5,
                    5
                ],
                c,
                [
                    6,
                    4
                ],
                s,
                [
                    1,
                    57
                ]
            ]),
            goto: u([
                5,
                3,
                4,
                24,
                s,
                [
                    9,
                    15,
                    1
                ],
                s,
                [
                    25,
                    5,
                    1
                ],
                c,
                [
                    24,
                    19
                ],
                31,
                35,
                32,
                34,
                c,
                [
                    18,
                    14
                ],
                36,
                c,
                [
                    38,
                    19
                ],
                c,
                [
                    19,
                    57
                ],
                c,
                [
                    118,
                    4
                ],
                41,
                c,
                [
                    24,
                    19
                ],
                43,
                35,
                c,
                [
                    16,
                    14
                ],
                44,
                s,
                [
                    2,
                    3
                ],
                28,
                29,
                2,
                s,
                [
                    3,
                    3
                ],
                28,
                29,
                3,
                c,
                [
                    53,
                    4
                ],
                s,
                [
                    45,
                    5,
                    1
                ],
                c,
                [
                    100,
                    42
                ],
                52,
                c,
                [
                    5,
                    4
                ],
                53
            ])
        }),
        defaultActions: bda({
            idx: u([
                6,
                7,
                8,
                s,
                [
                    10,
                    16,
                    1
                ],
                33,
                34,
                39,
                40,
                41,
                45,
                47,
                52,
                53
            ]),
            goto: u([
                9,
                10,
                11,
                s,
                [
                    16,
                    14,
                    1
                ],
                12,
                1,
                30,
                13,
                s,
                [
                    4,
                    4,
                    1
                ],
                14,
                15,
                8
            ])
        }),
        parseError: function parseError(str, hash, ExceptionClass) {
            if (hash.recoverable) {
                if (typeof this.trace === 'function') this.trace(str);
                hash.destroy(); // destroy... well, *almost*!
            } else {
                if (typeof this.trace === 'function') this.trace(str);
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                throw new ExceptionClass(str, hash);
            }
        },
        parse: function parse(input) {
            var self = this;
            var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)
            var sstack = new Array(128); // state stack: stores states (column storage)
            var vstack = new Array(128); // semantic value stack
            var table = this.table;
            var sp = 0; // 'stack pointer': index into the stacks
            var symbol = 0;
            var TERROR = this.TERROR;
            var EOF = this.EOF;
            var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = this.options.errorRecoveryTokenDiscardCount | 0 || 3;
            var NO_ACTION = [
                0,
                54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */ 
            ];
            var lexer;
            if (this.__lexer__) lexer = this.__lexer__;
            else lexer = this.__lexer__ = Object.create(this.lexer);
            var sharedState_yy = {
                parseError: undefined,
                quoteName: undefined,
                lexer: undefined,
                parser: undefined,
                pre_parse: undefined,
                post_parse: undefined,
                pre_lex: undefined,
                post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
            };
            var ASSERT;
            if (typeof assert !== 'function') ASSERT = function JisonAssert(cond, msg) {
                if (!cond) throw new Error('assertion failed: ' + (msg || '***'));
            };
            else ASSERT = assert;
            this.yyGetSharedState = function yyGetSharedState() {
                return sharedState_yy;
            };
            function shallow_copy_noclobber(dst, src) {
                for(var k in src)if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k];
            }
            // copy state
            shallow_copy_noclobber(sharedState_yy, this.yy);
            sharedState_yy.lexer = lexer;
            sharedState_yy.parser = this;
            // Does the shared state override the default `parseError` that already comes with this instance?
            if (typeof sharedState_yy.parseError === 'function') this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
            };
            else this.parseError = this.originalParseError;
            // Does the shared state override the default `quoteName` that already comes with this instance?
            if (typeof sharedState_yy.quoteName === 'function') this.quoteName = function quoteNameAlt(id_str) {
                return sharedState_yy.quoteName.call(this, id_str);
            };
            else this.quoteName = this.originalQuoteName;
            // set up the cleanup function; make it an API so that external code can re-use this one in case of
            // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
            // case this parse() API method doesn't come with a `finally { ... }` block any more!
            //
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `sharedState`, etc. references will be *wrong*!
            this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
                var rv;
                if (invoke_post_methods) {
                    var hash;
                    if (sharedState_yy.post_parse || this.post_parse) // create an error hash info instance: we re-use this API in a **non-error situation**
                    // as this one delivers all parser internals ready for access by userland code.
                    hash = this.constructParseErrorInfo(null, null, null, false);
                    if (sharedState_yy.post_parse) {
                        rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== 'undefined') resultValue = rv;
                    }
                    if (this.post_parse) {
                        rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== 'undefined') resultValue = rv;
                    }
                    // cleanup:
                    if (hash && hash.destroy) hash.destroy();
                }
                if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
                // clean up the lingering lexer structures as well:
                if (lexer.cleanupAfterLex) lexer.cleanupAfterLex(do_not_nuke_errorinfos);
                // prevent lingering circular references from causing memory leaks:
                if (sharedState_yy) {
                    sharedState_yy.lexer = undefined;
                    sharedState_yy.parser = undefined;
                    if (lexer.yy === sharedState_yy) lexer.yy = undefined;
                }
                sharedState_yy = undefined;
                this.parseError = this.originalParseError;
                this.quoteName = this.originalQuoteName;
                // nuke the vstack[] array at least as that one will still reference obsoleted user values.
                // To be safe, we nuke the other internal stack columns as well...
                stack.length = 0; // fastest way to nuke an array without overly bothering the GC
                sstack.length = 0;
                vstack.length = 0;
                sp = 0;
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === 'function') el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return resultValue;
            };
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
            this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
                var pei = {
                    errStr: msg,
                    exception: ex,
                    text: lexer.match,
                    value: lexer.yytext,
                    token: this.describeSymbol(symbol) || symbol,
                    token_id: symbol,
                    line: lexer.yylineno,
                    expected: expected,
                    recoverable: recoverable,
                    state: state,
                    action: action,
                    new_state: newState,
                    symbol_stack: stack,
                    state_stack: sstack,
                    value_stack: vstack,
                    stack_pointer: sp,
                    yy: sharedState_yy,
                    lexer: lexer,
                    parser: this,
                    // and make sure the error info doesn't stay due to potential
                    // ref cycle via userland code manipulations.
                    // These would otherwise all be memory leak opportunities!
                    //
                    // Note that only array and object references are nuked as those
                    // constitute the set of elements which can produce a cyclic ref.
                    // The rest of the members is kept intact as they are harmless.
                    destroy: function destructParseErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // info.value = null;
                        // info.value_stack = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            };
            function getNonTerminalFromCode(symbol) {
                var tokenName = self.getSymbolName(symbol);
                if (!tokenName) tokenName = symbol;
                return tokenName;
            }
            function stdLex() {
                var token = lexer.lex();
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token || EOF;
            }
            function fastLex() {
                var token = lexer.fastLex();
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token || EOF;
            }
            var lex = stdLex;
            var state, action, r, t;
            var yyval = {
                $: true,
                _$: undefined,
                yy: sharedState_yy
            };
            var p;
            var yyrulelen;
            var this_production;
            var newState;
            var retval = false;
            try {
                this.__reentrant_call_depth++;
                lexer.setInput(input, sharedState_yy);
                // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
                // this initial `setInput()` call: hence we can now check and decide
                // whether we'll go with the standard, slower, lex() API or the
                // `fast_lex()` one:
                if (typeof lexer.canIUse === 'function') {
                    var lexerInfo = lexer.canIUse();
                    if (lexerInfo.fastLex && typeof fastLex === 'function') lex = fastLex;
                }
                vstack[sp] = null;
                sstack[sp] = 0;
                stack[sp] = 0;
                ++sp;
                if (this.pre_parse) this.pre_parse.call(this, sharedState_yy);
                if (sharedState_yy.pre_parse) sharedState_yy.pre_parse.call(this, sharedState_yy);
                newState = sstack[sp - 1];
                for(;;){
                    // retrieve state number from top of stack
                    state = newState; // sstack[sp - 1];
                    // use default actions if available
                    if (this.defaultActions[state]) {
                        action = 2;
                        newState = this.defaultActions[state];
                    } else {
                        // The single `==` condition below covers both these `===` comparisons in a single
                        // operation:
                        //
                        //     if (symbol === null || typeof symbol === 'undefined') ...
                        if (!symbol) symbol = lex();
                        // read action for current state and first input
                        t = table[state] && table[state][symbol] || NO_ACTION;
                        newState = t[1];
                        action = t[0];
                        // handle parse error
                        if (!action) {
                            var errStr;
                            var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                            var expected = this.collect_expected_token_set(state);
                            // Report error
                            if (typeof lexer.yylineno === 'number') errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
                            else errStr = 'Parse error: ';
                            if (typeof lexer.showPosition === 'function') errStr += '\n' + lexer.showPosition(69, 10) + '\n';
                            if (expected.length) errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
                            else errStr += 'Unexpected ' + errSymbolDescr;
                            // we cannot recover from the error!
                            p = this.constructParseErrorInfo(errStr, null, expected, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== 'undefined') retval = r;
                            break;
                        }
                    }
                    switch(action){
                        // catch misc. parse failures:
                        default:
                            // this shouldn't happen, unless resolve defaults are off
                            if (action instanceof Array) {
                                p = this.constructParseErrorInfo('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol, null, null, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== 'undefined') retval = r;
                                break;
                            }
                            // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                            // or a buggy LUT (LookUp Table):
                            p = this.constructParseErrorInfo('Parsing halted. No viable error recovery approach available due to internal system failure.', null, null, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== 'undefined') retval = r;
                            break;
                        // shift:
                        case 1:
                            stack[sp] = symbol;
                            vstack[sp] = lexer.yytext;
                            sstack[sp] = newState; // push state
                            ++sp;
                            symbol = 0;
                            continue;
                        // reduce:
                        case 2:
                            this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                            yyrulelen = this_production[1];
                            r = this.performAction.call(yyval, newState, sp - 1, vstack);
                            if (typeof r !== 'undefined') {
                                retval = r;
                                break;
                            }
                            // pop off stack
                            sp -= yyrulelen;
                            // don't overwrite the `symbol` variable: use a local var to speed things up:
                            var ntsymbol = this_production[0]; // push nonterminal (reduce)
                            stack[sp] = ntsymbol;
                            vstack[sp] = yyval.$;
                            // goto new state = table[STATE][NONTERMINAL]
                            newState = table[sstack[sp - 1]][ntsymbol];
                            sstack[sp] = newState;
                            ++sp;
                            continue;
                        // accept:
                        case 3:
                            if (sp !== -2) {
                                retval = true;
                                // Return the `$accept` rule's `$$` result, if available.
                                //
                                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                                // default, action):
                                //
                                //     $accept: <startSymbol> $end
                                //                  %{ $$ = $1; @$ = @1; %}
                                //
                                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                                //
                                // In code:
                                //
                                //                  %{
                                //                      @$ = @1;            // if location tracking support is included
                                //                      if (typeof $1 !== 'undefined')
                                //                          return $1;
                                //                      else
                                //                          return true;           // the default parse result if the rule actions don't produce anything
                                //                  %}
                                sp--;
                                if (typeof vstack[sp] !== 'undefined') retval = vstack[sp];
                            }
                            break;
                    }
                    break;
                }
            } catch (ex) {
                // report exceptions through the parseError callback too, but keep the exception intact
                // if it is a known parser or lexer error which has been thrown by parseError() already:
                if (ex instanceof this.JisonParserError) throw ex;
                else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) throw ex;
                p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
                retval = false;
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== 'undefined') retval = r;
            } finally{
                retval = this.cleanupAfterParse(retval, true, true);
                this.__reentrant_call_depth--;
            } // /finally
            return retval;
        }
    };
    parser.originalParseError = parser.parseError;
    parser.originalQuoteName = parser.quoteName;
    /* lexer generated by jison-lex 0.6.1-215 */ /*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var lexer = function() {
        /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */ function JisonLexerError(msg, hash) {
            Object.defineProperty(this, 'name', {
                enumerable: false,
                writable: false,
                value: 'JisonLexerError'
            });
            if (msg == null) msg = '???';
            Object.defineProperty(this, 'message', {
                enumerable: false,
                writable: true,
                value: msg
            });
            this.hash = hash;
            var stacktrace;
            if (hash && hash.exception instanceof Error) {
                var ex2 = hash.exception;
                this.message = ex2.message || msg;
                stacktrace = ex2.stack;
            }
            if (!stacktrace) {
                if (Error.hasOwnProperty('captureStackTrace')) // V8
                Error.captureStackTrace(this, this.constructor);
                else stacktrace = new Error(msg).stack;
            }
            if (stacktrace) Object.defineProperty(this, 'stack', {
                enumerable: false,
                writable: false,
                value: stacktrace
            });
        }
        if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
        else JisonLexerError.prototype = Object.create(Error.prototype);
        JisonLexerError.prototype.constructor = JisonLexerError;
        JisonLexerError.prototype.name = 'JisonLexerError';
        var lexer = {
            // Code Generator Information Report
            // ---------------------------------
            //
            // Options:
            //
            //   backtracking: .................... false
            //   location.ranges: ................. false
            //   location line+column tracking: ... true
            //
            //
            // Forwarded Parser Analysis flags:
            //
            //   uses yyleng: ..................... false
            //   uses yylineno: ................... false
            //   uses yytext: ..................... false
            //   uses yylloc: ..................... false
            //   uses lexer values: ............... true / true
            //   location tracking: ............... false
            //   location assignment: ............. false
            //
            //
            // Lexer Analysis flags:
            //
            //   uses yyleng: ..................... ???
            //   uses yylineno: ................... ???
            //   uses yytext: ..................... ???
            //   uses yylloc: ..................... ???
            //   uses ParseError API: ............. ???
            //   uses yyerror: .................... ???
            //   uses location tracking & editing:  ???
            //   uses more() API: ................. ???
            //   uses unput() API: ................ ???
            //   uses reject() API: ............... ???
            //   uses less() API: ................. ???
            //   uses display APIs pastInput(), upcomingInput(), showPosition():
            //        ............................. ???
            //   uses describeYYLLOC() API: ....... ???
            //
            // --------- END OF REPORT -----------
            EOF: 1,
            ERROR: 2,
            // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
            // options: {},                             /// <-- injected by the code generator
            // yy: ...,                                 /// <-- injected by setInput()
            __currentRuleSet__: null,
            __error_infos: [],
            __decompressed: false,
            done: false,
            _backtrack: false,
            _input: '',
            _more: false,
            _signaled_error_token: false,
            conditionStack: [],
            match: '',
            matched: '',
            matches: false,
            yytext: '',
            offset: 0,
            yyleng: 0,
            yylineno: 0,
            yylloc: null,
            /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */ constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
                msg = '' + msg;
                // heuristic to determine if the error message already contains a (partial) source code dump
                // as produced by either `showPosition()` or `prettyPrintRange()`:
                if (show_input_position == undefined) show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
                if (this.yylloc && show_input_position) {
                    if (typeof this.prettyPrintRange === 'function') {
                        var pretty_src = this.prettyPrintRange(this.yylloc);
                        if (!/\n\s*$/.test(msg)) msg += '\n';
                        msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
                    } else if (typeof this.showPosition === 'function') {
                        var pos_str = this.showPosition();
                        if (pos_str) {
                            if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') msg += '\n' + pos_str;
                            else msg += pos_str;
                        }
                    }
                }
                /** @constructor */ var pei = {
                    errStr: msg,
                    recoverable: !!recoverable,
                    text: this.match,
                    token: null,
                    line: this.yylineno,
                    loc: this.yylloc,
                    yy: this.yy,
                    lexer: this,
                    /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */ destroy: function destructLexErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            },
            /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */ parseError: function lexer_parseError(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonLexerError;
                if (this.yy) {
                    if (this.yy.parser && typeof this.yy.parser.parseError === 'function') return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                    else if (typeof this.yy.parseError === 'function') return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                }
                throw new ExceptionClass(str, hash);
            },
            /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */ yyerror: function yyError(str /*, ...args */ ) {
                var lineno_msg = '';
                if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': ' + str, this.options.lexerErrorsAreRecoverable);
                // Add any extra args to the hash under the name `extra_error_attributes`:
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length) p.extra_error_attributes = args;
                return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
            },
            /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */ cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
                // prevent lingering circular references from causing memory leaks:
                this.setInput('', {});
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === 'function') el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return this;
            },
            /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */ clear: function lexer_clear() {
                this.yytext = '';
                this.yyleng = 0;
                this.match = '';
                // - DO NOT reset `this.matched`
                this.matches = false;
                this._more = false;
                this._backtrack = false;
                var col = this.yylloc ? this.yylloc.last_column : 0;
                this.yylloc = {
                    first_line: this.yylineno + 1,
                    first_column: col,
                    last_line: this.yylineno + 1,
                    last_column: col,
                    range: [
                        this.offset,
                        this.offset
                    ]
                };
            },
            /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */ setInput: function lexer_setInput(input, yy) {
                this.yy = yy || this.yy || {};
                // also check if we've fully initialized the lexer instance,
                // including expansion work to be done to go from a loaded
                // lexer to a usable lexer:
                if (!this.__decompressed) {
                    // step 1: decompress the regex list:
                    var rules = this.rules;
                    for(var i = 0, len = rules.length; i < len; i++){
                        var rule_re = rules[i];
                        // compression: is the RE an xref to another RE slot in the rules[] table?
                        if (typeof rule_re === 'number') rules[i] = rules[rule_re];
                    }
                    // step 2: unfold the conditions[] set to make these ready for use:
                    var conditions = this.conditions;
                    for(var k in conditions){
                        var spec = conditions[k];
                        var rule_ids = spec.rules;
                        var len = rule_ids.length;
                        var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
                        var rule_new_ids = new Array(len + 1);
                        for(var i = 0; i < len; i++){
                            var idx = rule_ids[i];
                            var rule_re = rules[idx];
                            rule_regexes[i + 1] = rule_re;
                            rule_new_ids[i + 1] = idx;
                        }
                        spec.rules = rule_new_ids;
                        spec.__rule_regexes = rule_regexes;
                        spec.__rule_count = len;
                    }
                    this.__decompressed = true;
                }
                this._input = input || '';
                this.clear();
                this._signaled_error_token = false;
                this.done = false;
                this.yylineno = 0;
                this.matched = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.__currentRuleSet__ = null;
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                this.offset = 0;
                return this;
            },
            /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */ editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
                var rv = callback.call(this, this._input, cpsArg);
                if (typeof rv !== 'string') {
                    if (rv) this._input = '' + rv;
                } else this._input = rv;
                return this;
            },
            /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */ input: function lexer_input() {
                if (!this._input) //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
                return null;
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                // Count the linenumber up when we hit the LF (or a stand-alone CR).
                // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
                // and we advance immediately past the LF as well, returning both together as if
                // it was all a single 'character' only.
                var slice_len = 1;
                var lines = false;
                if (ch === '\n') lines = true;
                else if (ch === '\r') {
                    lines = true;
                    var ch2 = this._input[1];
                    if (ch2 === '\n') {
                        slice_len++;
                        ch += ch2;
                        this.yytext += ch2;
                        this.yyleng++;
                        this.offset++;
                        this.match += ch2;
                        this.matched += ch2;
                        this.yylloc.range[1]++;
                    }
                }
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                    this.yylloc.last_column = 0;
                } else this.yylloc.last_column++;
                this.yylloc.range[1]++;
                this._input = this._input.slice(slice_len);
                return ch;
            },
            /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */ unput: function lexer_unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                this.yyleng = this.yytext.length;
                this.offset -= len;
                this.match = this.match.substr(0, this.match.length - len);
                this.matched = this.matched.substr(0, this.matched.length - len);
                if (lines.length > 1) {
                    this.yylineno -= lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    // Get last entirely matched line into the `pre_lines[]` array's
                    // last index slot; we don't mind when other previously 
                    // matched lines end up in the array too. 
                    var pre = this.match;
                    var pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    if (pre_lines.length === 1) {
                        pre = this.matched;
                        pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    }
                    this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
                } else this.yylloc.last_column -= len;
                this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
                this.done = false;
                return this;
            },
            /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */ more: function lexer_more() {
                this._more = true;
                return this;
            },
            /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */ reject: function lexer_reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else {
                    // when the `parseError()` call returns, we MUST ensure that the error is registered.
                    // We accomplish this by signaling an 'error' token to be produced for the current
                    // `.lex()` run.
                    var lineno_msg = '';
                    if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).', false);
                    this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                }
                return this;
            },
            /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */ less: function lexer_less(n) {
                return this.unput(this.match.slice(n));
            },
            /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */ pastInput: function lexer_pastInput(maxSize, maxLines) {
                var past = this.matched.substring(0, this.matched.length - this.match.length);
                if (maxSize < 0) maxSize = past.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substr` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                past = past.substr(-maxSize * 2 - 2);
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = past.replace(/\r\n|\r/g, '\n').split('\n');
                a = a.slice(-maxLines);
                past = a.join('\n');
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis prefix...
                if (past.length > maxSize) past = '...' + past.substr(-maxSize);
                return past;
            },
            /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */ upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
                var next = this.match;
                if (maxSize < 0) maxSize = next.length + this._input.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substring` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                if (next.length < maxSize * 2 + 2) next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = next.replace(/\r\n|\r/g, '\n').split('\n');
                a = a.slice(0, maxLines);
                next = a.join('\n');
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis postfix...
                if (next.length > maxSize) next = next.substring(0, maxSize) + '...';
                return next;
            },
            /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */ showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
                var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
                var c = new Array(pre.length + 1).join('-');
                return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
            },
            /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */ deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
                var loc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                if (actual) {
                    loc.first_line = actual.first_line | 0;
                    loc.last_line = actual.last_line | 0;
                    loc.first_column = actual.first_column | 0;
                    loc.last_column = actual.last_column | 0;
                    if (actual.range) {
                        loc.range[0] = actual.range[0] | 0;
                        loc.range[1] = actual.range[1] | 0;
                    }
                }
                if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
                    // plan B: heuristic using preceding and following:
                    if (loc.first_line <= 0 && preceding) {
                        loc.first_line = preceding.last_line | 0;
                        loc.first_column = preceding.last_column | 0;
                        if (preceding.range) loc.range[0] = actual.range[1] | 0;
                    }
                    if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
                        loc.last_line = following.first_line | 0;
                        loc.last_column = following.first_column | 0;
                        if (following.range) loc.range[1] = actual.range[0] | 0;
                    }
                    // plan C?: see if the 'current' location is useful/sane too:
                    if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
                        loc.first_line = current.first_line | 0;
                        loc.first_column = current.first_column | 0;
                        if (current.range) loc.range[0] = current.range[0] | 0;
                    }
                    if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
                        loc.last_line = current.last_line | 0;
                        loc.last_column = current.last_column | 0;
                        if (current.range) loc.range[1] = current.range[1] | 0;
                    }
                }
                // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
                // or plan D heuristics to produce a 'sensible' last_line value:
                if (loc.last_line <= 0) {
                    if (loc.first_line <= 0) {
                        loc.first_line = this.yylloc.first_line;
                        loc.last_line = this.yylloc.last_line;
                        loc.first_column = this.yylloc.first_column;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[0] = this.yylloc.range[0];
                        loc.range[1] = this.yylloc.range[1];
                    } else {
                        loc.last_line = this.yylloc.last_line;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[1] = this.yylloc.range[1];
                    }
                }
                if (loc.first_line <= 0) {
                    loc.first_line = loc.last_line;
                    loc.first_column = 0; // loc.last_column; 
                    loc.range[1] = loc.range[0];
                }
                if (loc.first_column < 0) loc.first_column = 0;
                if (loc.last_column < 0) loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
                return loc;
            },
            /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */ prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
                loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
                const CONTEXT = 3;
                const CONTEXT_TAIL = 1;
                const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
                var input = this.matched + this._input;
                var lines = input.split('\n');
                var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
                var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
                var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
                var ws_prefix = new Array(lineno_display_width).join(' ');
                var nonempty_line_indexes = [];
                var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
                    var lno = index + l0;
                    var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
                    var rv = lno_pfx + ': ' + line;
                    var errpfx = new Array(lineno_display_width + 1).join('^');
                    var offset = 3;
                    var len = 0;
                    if (lno === loc.first_line) {
                        offset += loc.first_column;
                        len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
                    } else if (lno === loc.last_line) len = Math.max(2, loc.last_column + 1);
                    else if (lno > loc.first_line && lno < loc.last_line) len = Math.max(2, line.length + 1);
                    if (len) {
                        var lead = new Array(offset).join('.');
                        var mark = new Array(len).join('^');
                        rv += '\n' + errpfx + lead + mark;
                        if (line.trim().length > 0) nonempty_line_indexes.push(index);
                    }
                    rv = rv.replace(/\t/g, ' ');
                    return rv;
                });
                // now make sure we don't print an overly large amount of error area: limit it 
                // to the top and bottom line count:
                if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
                    var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
                    var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
                    var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
                    intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
                    rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
                }
                return rv.join('\n');
            },
            /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */ describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
                var l1 = yylloc.first_line;
                var l2 = yylloc.last_line;
                var c1 = yylloc.first_column;
                var c2 = yylloc.last_column;
                var dl = l2 - l1;
                var dc = c2 - c1;
                var rv;
                if (dl === 0) {
                    rv = 'line ' + l1 + ', ';
                    if (dc <= 1) rv += 'column ' + c1;
                    else rv += 'columns ' + c1 + ' .. ' + c2;
                } else rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
                if (yylloc.range && display_range_too) {
                    var r1 = yylloc.range[0];
                    var r2 = yylloc.range[1] - 1;
                    if (r2 <= r1) rv += ' {String Offset: ' + r1 + '}';
                    else rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
                }
                return rv;
            },
            /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */ test_match: function lexer_test_match(match, indexed_rule) {
                var token, lines, backup, match_str, match_str_len;
                if (this.options.backtrack_lexer) // save context
                backup = {
                    yylineno: this.yylineno,
                    yylloc: {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylloc.last_line,
                        first_column: this.yylloc.first_column,
                        last_column: this.yylloc.last_column,
                        range: this.yylloc.range.slice(0)
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    //_signaled_error_token: this._signaled_error_token,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                };
                match_str = match[0];
                match_str_len = match_str.length;
                // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
                lines = match_str.split(/(?:\r\n?|\n)/g);
                if (lines.length > 1) {
                    this.yylineno += lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    this.yylloc.last_column = lines[lines.length - 1].length;
                } else this.yylloc.last_column += match_str_len;
                // }
                this.yytext += match_str;
                this.match += match_str;
                this.matched += match_str;
                this.matches = match;
                this.yyleng = this.yytext.length;
                this.yylloc.range[1] += match_str_len;
                // previous lex rules MAY have invoked the `more()` API rather than producing a token:
                // those rules will already have moved this `offset` forward matching their match lengths,
                // hence we must only add our own match length now:
                this.offset += match_str_len;
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match_str_len);
                // calling this method:
                //
                //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
                token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                // otherwise, when the action codes are all simple return token statements:
                //token = this.simpleCaseActionClusters[indexed_rule];
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    this.__currentRuleSet__ = null;
                    return false; // rule action called reject() implying the next rule should be tested instead. 
                } else if (this._signaled_error_token) {
                    // produce one 'error' token as `.parseError()` in `reject()`
                    // did not guarantee a failure signal by throwing an exception!
                    token = this._signaled_error_token;
                    this._signaled_error_token = false;
                    return token;
                }
                return false;
            },
            /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */ next: function lexer_next() {
                if (this.done) {
                    this.clear();
                    return this.EOF;
                }
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) this.clear();
                var spec = this.__currentRuleSet__;
                if (!spec) {
                    // Update the ruleset cache as we apparently encountered a state change or just started lexing.
                    // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
                    // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
                    // speed up those activities a tiny bit.
                    spec = this.__currentRuleSet__ = this._currentRules();
                    // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
                    // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
                    if (!spec || !spec.rules) {
                        var lineno_msg = '';
                        if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo('Internal lexer engine error' + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false);
                        // produce one 'error' token until this situation has been resolved, most probably by parse termination!
                        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    }
                }
                var rule_ids = spec.rules;
                var regexes = spec.__rule_regexes;
                var len = spec.__rule_count;
                // Note: the arrays are 1-based, while `len` itself is a valid index,
                // hence the non-standard less-or-equal check in the next loop condition!
                for(var i = 1; i <= len; i++){
                    tempMatch = this._input.match(regexes[i]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rule_ids[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = undefined;
                                continue; // rule action called reject() implying a rule MISmatch. 
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rule_ids[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (!this._input) {
                    this.done = true;
                    this.clear();
                    return this.EOF;
                } else {
                    var lineno_msg = '';
                    if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': Unrecognized text.', this.options.lexerErrorsAreRecoverable);
                    var pendingInput = this._input;
                    var activeCondition = this.topState();
                    var conditionStackDepth = this.conditionStack.length;
                    token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    if (token === this.ERROR) // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
                    // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
                    // has not consumed/modified any pending input or changed state in the error handler:
                    {
                        if (!this.matches && // and make sure the input has been modified/consumed ...
                        pendingInput === this._input && // ...or the lexer state has been modified significantly enough
                        // to merit a non-consuming error handling action right now.
                        activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) this.input();
                    }
                    return token;
                }
            },
            /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */ lex: function lexer_lex() {
                var r;
                // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
                if (typeof this.pre_lex === 'function') r = this.pre_lex.call(this, 0);
                if (typeof this.options.pre_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.pre_lex.call(this, r) || r;
                if (this.yy && typeof this.yy.pre_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.pre_lex.call(this, r) || r;
                while(!r)r = this.next();
                if (this.yy && typeof this.yy.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.post_lex.call(this, r) || r;
                if (typeof this.options.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.post_lex.call(this, r) || r;
                if (typeof this.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.post_lex.call(this, r) || r;
                return r;
            },
            /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */ fastLex: function lexer_fastLex() {
                var r;
                while(!r)r = this.next();
                return r;
            },
            /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */ canIUse: function lexer_canIUse() {
                var rv = {
                    fastLex: !(typeof this.pre_lex === 'function' || typeof this.options.pre_lex === 'function' || this.yy && typeof this.yy.pre_lex === 'function' || this.yy && typeof this.yy.post_lex === 'function' || typeof this.options.post_lex === 'function' || typeof this.post_lex === 'function') && typeof this.fastLex === 'function'
                };
                return rv;
            },
            /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */ begin: function lexer_begin(condition) {
                return this.pushState(condition);
            },
            /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */ pushState: function lexer_pushState(condition) {
                this.conditionStack.push(condition);
                this.__currentRuleSet__ = null;
                return this;
            },
            /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */ popState: function lexer_popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    this.__currentRuleSet__ = null;
                    return this.conditionStack.pop();
                } else return this.conditionStack[0];
            },
            /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */ topState: function lexer_topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return 'INITIAL';
            },
            /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */ _currentRules: function lexer__currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
                else return this.conditions['INITIAL'];
            },
            /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */ stateStackSize: function lexer_stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                trackPosition: true
            },
            JisonLexerError: JisonLexerError,
            performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
                var yy_ = this;
                var YYSTATE = YY_START;
                switch(yyrulenumber){
                    case 1:
                        break;
                    default:
                        return this.simpleCaseActionClusters[yyrulenumber];
                }
            },
            simpleCaseActionClusters: {
                /*! Conditions:: INITIAL */ /*! Rule::       (--[0-9a-z-A-Z-]*) */ 0: 13,
                /*! Conditions:: INITIAL */ /*! Rule::       \* */ 2: 5,
                /*! Conditions:: INITIAL */ /*! Rule::       \/ */ 3: 6,
                /*! Conditions:: INITIAL */ /*! Rule::       \+ */ 4: 3,
                /*! Conditions:: INITIAL */ /*! Rule::       - */ 5: 4,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */ 6: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */ 7: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */ 8: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */ 9: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */ 10: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */ 11: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */ 12: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */ 13: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */ 14: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */ 15: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */ 16: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */ 17: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */ 18: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */ 19: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */ 20: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */ 21: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */ 22: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */ 23: 20,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */ 24: 21,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */ 25: 22,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */ 26: 23,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */ 27: 25,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */ 28: 24,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */ 29: 26,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */ 30: 27,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */ 31: 28,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */ 32: 11,
                /*! Conditions:: INITIAL */ /*! Rule::       (calc) */ 33: 9,
                /*! Conditions:: INITIAL */ /*! Rule::       (var) */ 34: 12,
                /*! Conditions:: INITIAL */ /*! Rule::       ([a-z]+) */ 35: 10,
                /*! Conditions:: INITIAL */ /*! Rule::       \( */ 36: 7,
                /*! Conditions:: INITIAL */ /*! Rule::       \) */ 37: 8,
                /*! Conditions:: INITIAL */ /*! Rule::       , */ 38: 14,
                /*! Conditions:: INITIAL */ /*! Rule::       $ */ 39: 1
            },
            rules: [
                /*  0: */ /^(?:(--[\d\-A-Za-z]*))/,
                /*  1: */ /^(?:\s+)/,
                /*  2: */ /^(?:\*)/,
                /*  3: */ /^(?:\/)/,
                /*  4: */ /^(?:\+)/,
                /*  5: */ /^(?:-)/,
                /*  6: */ /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
                /*  7: */ /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
                /*  8: */ /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
                /*  9: */ /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
                /* 10: */ /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
                /* 11: */ /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
                /* 12: */ /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
                /* 13: */ /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
                /* 14: */ /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
                /* 15: */ /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
                /* 16: */ /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
                /* 17: */ /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
                /* 18: */ /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
                /* 19: */ /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
                /* 20: */ /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
                /* 21: */ /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
                /* 22: */ /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
                /* 23: */ /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
                /* 24: */ /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
                /* 25: */ /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
                /* 26: */ /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
                /* 27: */ /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
                /* 28: */ /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
                /* 29: */ /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
                /* 30: */ /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
                /* 31: */ /^(?:(\d+(\.\d*)?|\.\d+)%)/,
                /* 32: */ /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
                /* 33: */ /^(?:(calc))/,
                /* 34: */ /^(?:(var))/,
                /* 35: */ /^(?:([a-z]+))/,
                /* 36: */ /^(?:\()/,
                /* 37: */ /^(?:\))/,
                /* 38: */ /^(?:,)/,
                /* 39: */ /^(?:$)/
            ],
            conditions: {
                'INITIAL': {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
$df9fd8a8e4983507$export$8f49e4af10703ce3 = $df9fd8a8e4983507$var$parser;
$df9fd8a8e4983507$export$7acfa6ed01010e37 = $df9fd8a8e4983507$var$parser.Parser;
$df9fd8a8e4983507$export$98e6a39c04603d36 = function() {
    return $df9fd8a8e4983507$var$parser.parse.apply($df9fd8a8e4983507$var$parser, arguments);
};


var $fe2474af4e6b1bb3$exports = {};
"use strict";
Object.defineProperty($fe2474af4e6b1bb3$exports, "__esModule", {
    value: true
});
$fe2474af4e6b1bb3$exports.flip = $fe2474af4e6b1bb3$var$flip;
var $7a986c59779a6a78$exports = {};
'use strict';
Object.defineProperty($7a986c59779a6a78$exports, "__esModule", {
    value: true
});
var $966f549835bc4f16$exports = {};
var $966f549835bc4f16$var$conversions = {
    // length
    'px': {
        'px': 1,
        'cm': 96.0 / 2.54,
        'mm': 96.0 / 25.4,
        'in': 96,
        'pt': 96.0 / 72.0,
        'pc': 16
    },
    'cm': {
        'px': 2.54 / 96.0,
        'cm': 1,
        'mm': 0.1,
        'in': 2.54,
        'pt': 2.54 / 72.0,
        'pc': 2.54 / 6.0
    },
    'mm': {
        'px': 25.4 / 96.0,
        'cm': 10,
        'mm': 1,
        'in': 25.4,
        'pt': 25.4 / 72.0,
        'pc': 25.4 / 6.0
    },
    'in': {
        'px': 1.0 / 96.0,
        'cm': 1.0 / 2.54,
        'mm': 1.0 / 25.4,
        'in': 1,
        'pt': 1.0 / 72.0,
        'pc': 1.0 / 6.0
    },
    'pt': {
        'px': 0.75,
        'cm': 72.0 / 2.54,
        'mm': 72.0 / 25.4,
        'in': 72,
        'pt': 1,
        'pc': 12
    },
    'pc': {
        'px': 0.0625,
        'cm': 6.0 / 2.54,
        'mm': 6.0 / 25.4,
        'in': 6,
        'pt': 6.0 / 72.0,
        'pc': 1
    },
    // angle
    'deg': {
        'deg': 1,
        'grad': 0.9,
        'rad': 180 / Math.PI,
        'turn': 360
    },
    'grad': {
        'deg': 400 / 360,
        'grad': 1,
        'rad': 200 / Math.PI,
        'turn': 400
    },
    'rad': {
        'deg': Math.PI / 180,
        'grad': Math.PI / 200,
        'rad': 1,
        'turn': Math.PI * 2
    },
    'turn': {
        'deg': 1 / 360,
        'grad': 1 / 400,
        'rad': 0.5 / Math.PI,
        'turn': 1
    },
    // time
    's': {
        's': 1,
        'ms': 0.001
    },
    'ms': {
        's': 1000,
        'ms': 1
    },
    // frequency
    'Hz': {
        'Hz': 1,
        'kHz': 1000
    },
    'kHz': {
        'Hz': 0.001,
        'kHz': 1
    },
    // resolution
    'dpi': {
        'dpi': 1,
        'dpcm': 1.0 / 2.54,
        'dppx': 1 / 96
    },
    'dpcm': {
        'dpi': 2.54,
        'dpcm': 1,
        'dppx': 2.54 / 96.0
    },
    'dppx': {
        'dpi': 96,
        'dpcm': 96.0 / 2.54,
        'dppx': 1
    }
};
$966f549835bc4f16$exports = function(value, sourceUnit, targetUnit, precision) {
    if (!$966f549835bc4f16$var$conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
    if (!$966f549835bc4f16$var$conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    var converted = $966f549835bc4f16$var$conversions[targetUnit][sourceUnit] * value;
    if (precision !== false) {
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round(converted * precision) / precision;
    }
    return converted;
};


var $7a986c59779a6a78$var$_cssUnitConverter2 = $7a986c59779a6a78$var$_interopRequireDefault($966f549835bc4f16$exports);
function $7a986c59779a6a78$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7a986c59779a6a78$var$convertNodes(left, right, precision) {
    switch(left.type){
        case 'LengthValue':
        case 'AngleValue':
        case 'TimeValue':
        case 'FrequencyValue':
        case 'ResolutionValue':
            return $7a986c59779a6a78$var$convertAbsoluteLength(left, right, precision);
        default:
            return {
                left: left,
                right: right
            };
    }
}
function $7a986c59779a6a78$var$convertAbsoluteLength(left, right, precision) {
    if (right.type === left.type) right = {
        type: left.type,
        value: (0, $7a986c59779a6a78$var$_cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
        unit: left.unit
    };
    return {
        left: left,
        right: right
    };
}
$7a986c59779a6a78$exports.default = $7a986c59779a6a78$var$convertNodes;
$7a986c59779a6a78$exports = $7a986c59779a6a78$exports['default'];


var $fe2474af4e6b1bb3$var$_convert2 = $fe2474af4e6b1bb3$var$_interopRequireDefault($7a986c59779a6a78$exports);
function $fe2474af4e6b1bb3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fe2474af4e6b1bb3$var$reduce(node, precision) {
    if (node.type === "MathExpression") return $fe2474af4e6b1bb3$var$reduceMathExpression(node, precision);
    if (node.type === "Calc") return $fe2474af4e6b1bb3$var$reduce(node.value, precision);
    return node;
}
function $fe2474af4e6b1bb3$var$isEqual(left, right) {
    return left.type === right.type && left.value === right.value;
}
function $fe2474af4e6b1bb3$var$isValueType(type) {
    switch(type){
        case 'LengthValue':
        case 'AngleValue':
        case 'TimeValue':
        case 'FrequencyValue':
        case 'ResolutionValue':
        case 'EmValue':
        case 'ExValue':
        case 'ChValue':
        case 'RemValue':
        case 'VhValue':
        case 'VwValue':
        case 'VminValue':
        case 'VmaxValue':
        case 'PercentageValue':
        case 'Value':
            return true;
    }
    return false;
}
function $fe2474af4e6b1bb3$var$convertMathExpression(node, precision) {
    var nodes = (0, $fe2474af4e6b1bb3$var$_convert2.default)(node.left, node.right, precision);
    var left = $fe2474af4e6b1bb3$var$reduce(nodes.left, precision);
    var right = $fe2474af4e6b1bb3$var$reduce(nodes.right, precision);
    if (left.type === "MathExpression" && right.type === "MathExpression") {
        if (left.operator === '/' && right.operator === '*' || left.operator === '-' && right.operator === '+' || left.operator === '*' && right.operator === '/' || left.operator === '+' && right.operator === '-') {
            if ($fe2474af4e6b1bb3$var$isEqual(left.right, right.right)) nodes = (0, $fe2474af4e6b1bb3$var$_convert2.default)(left.left, right.left, precision);
            else if ($fe2474af4e6b1bb3$var$isEqual(left.right, right.left)) nodes = (0, $fe2474af4e6b1bb3$var$_convert2.default)(left.left, right.right, precision);
            left = $fe2474af4e6b1bb3$var$reduce(nodes.left, precision);
            right = $fe2474af4e6b1bb3$var$reduce(nodes.right, precision);
        }
    }
    node.left = left;
    node.right = right;
    return node;
}
function $fe2474af4e6b1bb3$var$flip(operator) {
    return operator === '+' ? '-' : '+';
}
function $fe2474af4e6b1bb3$var$flipValue(node) {
    if ($fe2474af4e6b1bb3$var$isValueType(node.type)) node.value = -node.value;
    else if (node.type == 'MathExpression') {
        node.left = $fe2474af4e6b1bb3$var$flipValue(node.left);
        node.right = $fe2474af4e6b1bb3$var$flipValue(node.right);
    }
    return node;
}
function $fe2474af4e6b1bb3$var$reduceAddSubExpression(node, precision) {
    var _node = node, left = _node.left, right = _node.right, op = _node.operator;
    if (left.type === 'CssVariable' || right.type === 'CssVariable') return node;
    // something + 0 => something
    // something - 0 => something
    if (right.value === 0) return left;
    // 0 + something => something
    if (left.value === 0 && op === "+") return right;
    // 0 - something => -something
    if (left.value === 0 && op === "-") return $fe2474af4e6b1bb3$var$flipValue(right);
    // value + value
    // value - value
    if (left.type === right.type && $fe2474af4e6b1bb3$var$isValueType(left.type)) {
        node = Object.assign({}, left);
        if (op === "+") node.value = left.value + right.value;
        else node.value = left.value - right.value;
    }
    // value <op> (expr)
    if ($fe2474af4e6b1bb3$var$isValueType(left.type) && (right.operator === '+' || right.operator === '-') && right.type === 'MathExpression') {
        // value + (value + something) => (value + value) + something
        // value + (value - something) => (value + value) - something
        // value - (value + something) => (value - value) - something
        // value - (value - something) => (value - value) + something
        if (left.type === right.left.type) {
            node = Object.assign({}, node);
            node.left = $fe2474af4e6b1bb3$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left,
                right: right.left
            }, precision);
            node.right = right.right;
            node.operator = op === '-' ? $fe2474af4e6b1bb3$var$flip(right.operator) : right.operator;
            return $fe2474af4e6b1bb3$var$reduce(node, precision);
        } else if (left.type === right.right.type) {
            node = Object.assign({}, node);
            node.left = $fe2474af4e6b1bb3$var$reduce({
                type: 'MathExpression',
                operator: op === '-' ? $fe2474af4e6b1bb3$var$flip(right.operator) : right.operator,
                left: left,
                right: right.right
            }, precision);
            node.right = right.left;
            return $fe2474af4e6b1bb3$var$reduce(node, precision);
        }
    }
    // (expr) <op> value
    if (left.type === 'MathExpression' && (left.operator === '+' || left.operator === '-') && $fe2474af4e6b1bb3$var$isValueType(right.type)) {
        // (value + something) + value => (value + value) + something
        // (value - something) + value => (value + value) - something
        // (value + something) - value => (value - value) + something
        // (value - something) - value => (value - value) - something
        if (right.type === left.left.type) {
            node = Object.assign({}, left);
            node.left = $fe2474af4e6b1bb3$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left.left,
                right: right
            }, precision);
            return $fe2474af4e6b1bb3$var$reduce(node, precision);
        } else if (right.type === left.right.type) {
            node = Object.assign({}, left);
            if (left.operator === '-') {
                node.right = $fe2474af4e6b1bb3$var$reduce({
                    type: 'MathExpression',
                    operator: op === '-' ? '+' : '-',
                    left: right,
                    right: left.right
                }, precision);
                node.operator = op === '-' ? '-' : '+';
            } else node.right = $fe2474af4e6b1bb3$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left.right,
                right: right
            }, precision);
            if (node.right.value < 0) {
                node.right.value *= -1;
                node.operator = node.operator === '-' ? '+' : '-';
            }
            return $fe2474af4e6b1bb3$var$reduce(node, precision);
        }
    }
    return node;
}
function $fe2474af4e6b1bb3$var$reduceDivisionExpression(node, precision) {
    if (!$fe2474af4e6b1bb3$var$isValueType(node.right.type)) return node;
    if (node.right.type !== 'Value') throw new Error("Cannot divide by \"" + node.right.unit + "\", number expected");
    if (node.right.value === 0) throw new Error('Cannot divide by zero');
    // (expr) / value
    if (node.left.type === 'MathExpression') {
        if ($fe2474af4e6b1bb3$var$isValueType(node.left.left.type) && $fe2474af4e6b1bb3$var$isValueType(node.left.right.type)) {
            node.left.left.value /= node.right.value;
            node.left.right.value /= node.right.value;
            return $fe2474af4e6b1bb3$var$reduce(node.left, precision);
        }
        return node;
    } else if ($fe2474af4e6b1bb3$var$isValueType(node.left.type)) {
        node.left.value /= node.right.value;
        return node.left;
    }
    return node;
}
function $fe2474af4e6b1bb3$var$reduceMultiplicationExpression(node) {
    // (expr) * value
    if (node.left.type === 'MathExpression' && node.right.type === 'Value') {
        if ($fe2474af4e6b1bb3$var$isValueType(node.left.left.type) && $fe2474af4e6b1bb3$var$isValueType(node.left.right.type)) {
            node.left.left.value *= node.right.value;
            node.left.right.value *= node.right.value;
            return node.left;
        }
    } else if ($fe2474af4e6b1bb3$var$isValueType(node.left.type) && node.right.type === 'Value') {
        node.left.value *= node.right.value;
        return node.left;
    } else if (node.left.type === 'Value' && node.right.type === 'MathExpression') {
        if ($fe2474af4e6b1bb3$var$isValueType(node.right.left.type) && $fe2474af4e6b1bb3$var$isValueType(node.right.right.type)) {
            node.right.left.value *= node.left.value;
            node.right.right.value *= node.left.value;
            return node.right;
        }
    } else if (node.left.type === 'Value' && $fe2474af4e6b1bb3$var$isValueType(node.right.type)) {
        node.right.value *= node.left.value;
        return node.right;
    }
    return node;
}
function $fe2474af4e6b1bb3$var$reduceMathExpression(node, precision) {
    node = $fe2474af4e6b1bb3$var$convertMathExpression(node, precision);
    switch(node.operator){
        case "+":
        case "-":
            return $fe2474af4e6b1bb3$var$reduceAddSubExpression(node, precision);
        case "/":
            return $fe2474af4e6b1bb3$var$reduceDivisionExpression(node, precision);
        case "*":
            return $fe2474af4e6b1bb3$var$reduceMultiplicationExpression(node);
    }
    return node;
}
$fe2474af4e6b1bb3$exports.default = $fe2474af4e6b1bb3$var$reduce;


var $a426e75e0f206812$var$_reducer2 = $a426e75e0f206812$var$_interopRequireDefault($fe2474af4e6b1bb3$exports);
var $cb854bff52c8b4d4$exports = {};
"use strict";
Object.defineProperty($cb854bff52c8b4d4$exports, "__esModule", {
    value: true
});
$cb854bff52c8b4d4$exports.default = function(calc, node, precision) {
    var str = $cb854bff52c8b4d4$var$stringify(node, precision);
    if (node.type === "MathExpression") // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
    return str;
};

var $cb854bff52c8b4d4$var$order = {
    "*": 0,
    "/": 0,
    "+": 1,
    "-": 1
};
function $cb854bff52c8b4d4$var$round(value, prec) {
    if (prec !== false) {
        var precision = Math.pow(10, prec);
        return Math.round(value * precision) / precision;
    }
    return value;
}
function $cb854bff52c8b4d4$var$stringify(node, prec) {
    switch(node.type){
        case "MathExpression":
            var left = node.left, right = node.right, op = node.operator;
            var str = "";
            if (left.type === 'MathExpression' && $cb854bff52c8b4d4$var$order[op] < $cb854bff52c8b4d4$var$order[left.operator]) str += "(" + $cb854bff52c8b4d4$var$stringify(left, prec) + ")";
            else str += $cb854bff52c8b4d4$var$stringify(left, prec);
            str += " " + node.operator + " ";
            if (right.type === 'MathExpression' && $cb854bff52c8b4d4$var$order[op] < $cb854bff52c8b4d4$var$order[right.operator]) str += "(" + $cb854bff52c8b4d4$var$stringify(right, prec) + ")";
            else if (right.type === 'MathExpression' && op === "-" && [
                "+",
                "-"
            ].includes(right.operator)) {
                // fix #52 : a-(b+c) = a-b-c
                right.operator = (0, $fe2474af4e6b1bb3$exports.flip)(right.operator);
                str += $cb854bff52c8b4d4$var$stringify(right, prec);
            } else str += $cb854bff52c8b4d4$var$stringify(right, prec);
            return str;
        case "Value":
            return $cb854bff52c8b4d4$var$round(node.value, prec);
        case 'CssVariable':
            if (node.fallback) return "var(" + node.value + ", " + $cb854bff52c8b4d4$var$stringify(node.fallback, prec, true) + ")";
            return "var(" + node.value + ")";
        case 'Calc':
            if (node.prefix) return "-" + node.prefix + "-calc(" + $cb854bff52c8b4d4$var$stringify(node.value, prec) + ")";
            return "calc(" + $cb854bff52c8b4d4$var$stringify(node.value, prec) + ")";
        default:
            return $cb854bff52c8b4d4$var$round(node.value, prec) + node.unit;
    }
}
$cb854bff52c8b4d4$exports = $cb854bff52c8b4d4$exports["default"];


var $a426e75e0f206812$var$_stringifier2 = $a426e75e0f206812$var$_interopRequireDefault($cb854bff52c8b4d4$exports);
function $a426e75e0f206812$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eslint-disable-line
var $a426e75e0f206812$var$MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
$a426e75e0f206812$exports.default = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    return (0, $a426e75e0f206812$var$_postcssValueParser2.default)(value).walk(function(node) {
        // skip anything which isn't a calc() function
        if (node.type !== 'function' || !$a426e75e0f206812$var$MATCH_CALC.test(node.value)) return;
        // stringify calc expression and produce an AST
        var contents = $a426e75e0f206812$var$_postcssValueParser2.default.stringify(node.nodes);
        // skip constant() and env()
        if (contents.indexOf('constant') >= 0 || contents.indexOf('env') >= 0) return;
        var ast = $df9fd8a8e4983507$export$8f49e4af10703ce3.parse(contents);
        // reduce AST to its simplest form, that is, either to a single value
        // or a simplified calc expression
        var reducedAst = (0, $a426e75e0f206812$var$_reducer2.default)(ast, precision);
        // stringify AST and write it back
        node.type = 'word';
        node.value = (0, $a426e75e0f206812$var$_stringifier2.default)(node.value, reducedAst, precision);
    }, true).toString();
};
$a426e75e0f206812$exports = $a426e75e0f206812$exports['default'];




var $b477b0447f10d549$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $b477b0447f10d549$export$98f03c5d19621d70 = {
    isSsr: $b477b0447f10d549$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $b477b0447f10d549$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $b477b0447f10d549$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $b477b0447f10d549$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $009d73de260549c1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $009d73de260549c1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $009d73de260549c1$var$_typeof(obj);
}
function $009d73de260549c1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $009d73de260549c1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $009d73de260549c1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $009d73de260549c1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $009d73de260549c1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $009d73de260549c1$var$_defineProperty(obj, key, value) {
    key = $009d73de260549c1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $009d73de260549c1$var$_toPropertyKey(arg) {
    var key = $009d73de260549c1$var$_toPrimitive(arg, "string");
    return $009d73de260549c1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $009d73de260549c1$var$_toPrimitive(input, hint) {
    if ($009d73de260549c1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($009d73de260549c1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $009d73de260549c1$var$_toConsumableArray(arr) {
    return $009d73de260549c1$var$_arrayWithoutHoles(arr) || $009d73de260549c1$var$_iterableToArray(arr) || $009d73de260549c1$var$_unsupportedIterableToArray(arr) || $009d73de260549c1$var$_nonIterableSpread();
}
function $009d73de260549c1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $009d73de260549c1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $009d73de260549c1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $009d73de260549c1$var$_arrayLikeToArray(o, minLen);
}
function $009d73de260549c1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $009d73de260549c1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $009d73de260549c1$var$_arrayLikeToArray(arr);
}
function $009d73de260549c1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $009d73de260549c1$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $009d73de260549c1$var$MAX_CACHE_NUM = 2000;
var $009d73de260549c1$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $009d73de260549c1$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $009d73de260549c1$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $009d73de260549c1$var$autoCompleteStyle(name, value) {
    if ($009d73de260549c1$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $009d73de260549c1$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($009d73de260549c1$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($009d73de260549c1$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $009d73de260549c1$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($009d73de260549c1$var$camelToMiddleLine(s), ":").concat($009d73de260549c1$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
var $009d73de260549c1$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $b477b0447f10d549$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var str = "".concat(text);
    var styleString = $009d73de260549c1$export$9a2c38fb88d8e30(style);
    var cacheKey = "".concat(str, "-").concat(styleString);
    if ($009d73de260549c1$var$stringCache.widthCache[cacheKey]) return $009d73de260549c1$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($009d73de260549c1$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $009d73de260549c1$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $009d73de260549c1$var$_objectSpread($009d73de260549c1$var$_objectSpread({}, $009d73de260549c1$var$SPAN_STYLE), style);
        Object.keys(measurementSpanStyle).map(function(styleKey) {
            measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
            return styleKey;
        });
        measurementSpan.textContent = str;
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $009d73de260549c1$var$stringCache.widthCache[cacheKey] = result;
        if (++$009d73de260549c1$var$stringCache.cacheCount > $009d73de260549c1$var$MAX_CACHE_NUM) {
            $009d73de260549c1$var$stringCache.cacheCount = 0;
            $009d73de260549c1$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $009d73de260549c1$export$622cea445a1c5b7d = function getOffset(el) {
    var html = el.ownerDocument.documentElement;
    var box = {
        top: 0,
        left: 0
    };
    // If we don't have gBCR, just use 0,0 rather than error
    // BlackBerry 5, iOS 3 (original iPhone)
    if (typeof el.getBoundingClientRect !== 'undefined') box = el.getBoundingClientRect();
    return {
        top: box.top + window.pageYOffset - html.clientTop,
        left: box.left + window.pageXOffset - html.clientLeft
    };
};
var $009d73de260549c1$export$f209e6c32ad3d02e = function calculateChartCoordinate(event, offset) {
    return {
        chartX: Math.round(event.pageX - offset.left),
        chartY: Math.round(event.pageY - offset.top)
    };
};


var $9356d3eb5e25660c$var$_excluded = [
    "dx",
    "dy",
    "textAnchor",
    "verticalAnchor",
    "scaleToFit",
    "angle",
    "lineHeight",
    "capHeight",
    "className",
    "breakAll"
];
function $9356d3eb5e25660c$var$_extends() {
    $9356d3eb5e25660c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9356d3eb5e25660c$var$_extends.apply(this, arguments);
}
function $9356d3eb5e25660c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9356d3eb5e25660c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9356d3eb5e25660c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9356d3eb5e25660c$var$_slicedToArray(arr, i) {
    return $9356d3eb5e25660c$var$_arrayWithHoles(arr) || $9356d3eb5e25660c$var$_iterableToArrayLimit(arr, i) || $9356d3eb5e25660c$var$_unsupportedIterableToArray(arr, i) || $9356d3eb5e25660c$var$_nonIterableRest();
}
function $9356d3eb5e25660c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9356d3eb5e25660c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9356d3eb5e25660c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9356d3eb5e25660c$var$_arrayLikeToArray(o, minLen);
}
function $9356d3eb5e25660c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9356d3eb5e25660c$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $9356d3eb5e25660c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $9356d3eb5e25660c$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $9356d3eb5e25660c$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($9356d3eb5e25660c$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $009d73de260549c1$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $009d73de260549c1$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $9356d3eb5e25660c$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $e6a593df52d5e247$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $9356d3eb5e25660c$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $9356d3eb5e25660c$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $9356d3eb5e25660c$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $9356d3eb5e25660c$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(children) ? children.toString().split($9356d3eb5e25660c$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $9356d3eb5e25660c$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $b477b0447f10d549$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $9356d3eb5e25660c$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $9356d3eb5e25660c$var$getWordsWithoutCalculate(children);
        return $9356d3eb5e25660c$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $9356d3eb5e25660c$var$getWordsWithoutCalculate(children);
};
var $9356d3eb5e25660c$var$textDefaultProps = {
    x: 0,
    y: 0,
    lineHeight: '1em',
    capHeight: '0.71em',
    // Magic number from d3
    scaleToFit: false,
    textAnchor: 'start',
    verticalAnchor: 'end',
    // Maintain compat with existing charts / default SVG behavior
    fill: '#808080'
};
var $9356d3eb5e25660c$export$5f1af8db9871e1d6 = function Text(props) {
    var wordsByLines = (0, $5pP8j.useMemo)(function() {
        return $9356d3eb5e25660c$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: props.scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        props.scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, textAnchor = props.textAnchor, verticalAnchor = props.verticalAnchor, scaleToFit = props.scaleToFit, angle = props.angle, lineHeight = props.lineHeight, capHeight = props.capHeight, className = props.className, breakAll = props.breakAll, textProps = $9356d3eb5e25660c$var$_objectWithoutProperties(props, $9356d3eb5e25660c$var$_excluded);
    if (!(0, $e6a593df52d5e247$export$402a499e1ea44294)(textProps.x) || !(0, $e6a593df52d5e247$export$402a499e1ea44294)(textProps.y)) return null;
    var x = textProps.x + ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = textProps.y + ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($a426e75e0f206812$exports)))("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($a426e75e0f206812$exports)))("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($a426e75e0f206812$exports)))("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $e6a593df52d5e247$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("text", $9356d3eb5e25660c$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-text', className),
        textAnchor: textAnchor,
        fill: textProps.fill.includes('url') ? $9356d3eb5e25660c$var$textDefaultProps.fill : textProps.fill
    }), wordsByLines.map(function(line, index) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: index
        }, line.words.join(breakAll ? '' : ' ')));
    }));
};
$9356d3eb5e25660c$export$5f1af8db9871e1d6.defaultProps = $9356d3eb5e25660c$var$textDefaultProps;







var $08d5ce8e0c21d402$exports = {};
var $af6bc59fca254b53$exports = {};

var $8fd7020ab71027a6$exports = {};



/** Built-in value references. */ var $8fd7020ab71027a6$var$spreadableSymbol = $de179d6f42a5cc43$exports ? $de179d6f42a5cc43$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $8fd7020ab71027a6$var$isFlattenable(value) {
    return $02148300ecce42f1$exports(value) || $e05e41dcd042be4a$exports(value) || !!($8fd7020ab71027a6$var$spreadableSymbol && value && value[$8fd7020ab71027a6$var$spreadableSymbol]);
}
$8fd7020ab71027a6$exports = $8fd7020ab71027a6$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $af6bc59fca254b53$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $8fd7020ab71027a6$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $af6bc59fca254b53$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $97f3c27c5ae8b289$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$af6bc59fca254b53$exports = $af6bc59fca254b53$var$baseFlatten;


var $f792a27558d7f4a8$exports = {};



var $055603bce0be7bb1$exports = {};
var $81fbac4887fc9905$exports = {};
var $01e866c044204682$exports = {};
var $f4d6dc03cbfde676$exports = {};
var $dd1e2bf8b6b0dac8$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $dd1e2bf8b6b0dac8$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$dd1e2bf8b6b0dac8$exports = $dd1e2bf8b6b0dac8$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $f4d6dc03cbfde676$var$baseFor = $dd1e2bf8b6b0dac8$exports();
$f4d6dc03cbfde676$exports = $f4d6dc03cbfde676$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $01e866c044204682$var$baseForOwn(object, iteratee) {
    return object && $f4d6dc03cbfde676$exports(object, iteratee, $02cff874f3633c30$exports);
}
$01e866c044204682$exports = $01e866c044204682$var$baseForOwn;


var $6d0dc324009492e3$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6d0dc324009492e3$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$d78b82d99e6058d9$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$6d0dc324009492e3$exports = $6d0dc324009492e3$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $81fbac4887fc9905$var$baseEach = $6d0dc324009492e3$exports($01e866c044204682$exports);
$81fbac4887fc9905$exports = $81fbac4887fc9905$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $055603bce0be7bb1$var$baseMap(collection, iteratee) {
    var index = -1, result = $d78b82d99e6058d9$exports(collection) ? Array(collection.length) : [];
    $81fbac4887fc9905$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$055603bce0be7bb1$exports = $055603bce0be7bb1$var$baseMap;


var $5b975df8fc58e84e$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $5b975df8fc58e84e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$5b975df8fc58e84e$exports = $5b975df8fc58e84e$var$baseSortBy;



var $e3a4289aeecb7e7b$exports = {};
var $43a80bc616f1a412$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $43a80bc616f1a412$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $cda1c6b7d8f0286a$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $cda1c6b7d8f0286a$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$43a80bc616f1a412$exports = $43a80bc616f1a412$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $e3a4289aeecb7e7b$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $43a80bc616f1a412$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$e3a4289aeecb7e7b$exports = $e3a4289aeecb7e7b$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $f792a27558d7f4a8$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $7fae7c98af7b4a49$exports(iteratees, function(iteratee) {
        if ($02148300ecce42f1$exports(iteratee)) return function(value) {
            return $c42aa351ce1d5d03$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $ca900a7526c42750$exports
    ];
    var index = -1;
    iteratees = $7fae7c98af7b4a49$exports(iteratees, $73e2d6e9aed45cd0$exports($57b9695ad40eb80b$exports));
    var result = $055603bce0be7bb1$exports(collection, function(value, key, collection) {
        var criteria = $7fae7c98af7b4a49$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $5b975df8fc58e84e$exports(result, function(object, other) {
        return $e3a4289aeecb7e7b$exports(object, other, orders);
    });
}
$f792a27558d7f4a8$exports = $f792a27558d7f4a8$var$baseOrderBy;


var $a7e18b77cdf28dc6$exports = {};

var $57debf8aeec9bb3a$exports = {};
var $25b178fcace8aabb$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $25b178fcace8aabb$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$25b178fcace8aabb$exports = $25b178fcace8aabb$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $57debf8aeec9bb3a$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $57debf8aeec9bb3a$var$overRest(func, start, transform) {
    start = $57debf8aeec9bb3a$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $57debf8aeec9bb3a$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $25b178fcace8aabb$exports(func, this, otherArgs);
    };
}
$57debf8aeec9bb3a$exports = $57debf8aeec9bb3a$var$overRest;


var $d77062625ddc4a05$exports = {};
var $68b2b3b3dd4cd098$exports = {};
var $e827e627057d3755$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $e827e627057d3755$var$constant(value) {
    return function() {
        return value;
    };
}
$e827e627057d3755$exports = $e827e627057d3755$var$constant;


var $6ea96b6ce2080d0a$exports = {};

var $6ea96b6ce2080d0a$var$defineProperty = function() {
    try {
        var func = $db96872dbd237c27$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$6ea96b6ce2080d0a$exports = $6ea96b6ce2080d0a$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $68b2b3b3dd4cd098$var$baseSetToString = !$6ea96b6ce2080d0a$exports ? $ca900a7526c42750$exports : function(func, string) {
    return $6ea96b6ce2080d0a$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $e827e627057d3755$exports(string),
        'writable': true
    });
};
$68b2b3b3dd4cd098$exports = $68b2b3b3dd4cd098$var$baseSetToString;


var $621c54377bf075a6$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $621c54377bf075a6$var$HOT_COUNT = 800, $621c54377bf075a6$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $621c54377bf075a6$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $621c54377bf075a6$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $621c54377bf075a6$var$nativeNow(), remaining = $621c54377bf075a6$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $621c54377bf075a6$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$621c54377bf075a6$exports = $621c54377bf075a6$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d77062625ddc4a05$var$setToString = $621c54377bf075a6$exports($68b2b3b3dd4cd098$exports);
$d77062625ddc4a05$exports = $d77062625ddc4a05$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $a7e18b77cdf28dc6$var$baseRest(func, start) {
    return $d77062625ddc4a05$exports($57debf8aeec9bb3a$exports(func, start, $ca900a7526c42750$exports), func + '');
}
$a7e18b77cdf28dc6$exports = $a7e18b77cdf28dc6$var$baseRest;


var $ce13c7d955cccc00$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $ce13c7d955cccc00$var$isIterateeCall(value, index, object) {
    if (!$0e1bd391425671ea$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $d78b82d99e6058d9$exports(object) && $03453f782b5e5aeb$exports(index, object.length) : type == 'string' && index in object) return $05a5c93574ccef83$exports(object[index], value);
    return false;
}
$ce13c7d955cccc00$exports = $ce13c7d955cccc00$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $08d5ce8e0c21d402$var$sortBy = $a7e18b77cdf28dc6$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $ce13c7d955cccc00$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $ce13c7d955cccc00$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $f792a27558d7f4a8$exports(collection, $af6bc59fca254b53$exports(iteratees, 1), []);
});
$08d5ce8e0c21d402$exports = $08d5ce8e0c21d402$var$sortBy;






var $7e6c76b555606c86$exports = {};
var $99810a5d8a139bcd$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $99810a5d8a139bcd$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$cda1c6b7d8f0286a$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$99810a5d8a139bcd$exports = $99810a5d8a139bcd$var$baseExtremum;


var $9ee1c91445a57167$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $9ee1c91445a57167$var$baseGt(value, other) {
    return value > other;
}
$9ee1c91445a57167$exports = $9ee1c91445a57167$var$baseGt;



/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $7e6c76b555606c86$var$max(array) {
    return array && array.length ? $99810a5d8a139bcd$exports(array, $ca900a7526c42750$exports, $9ee1c91445a57167$exports) : undefined;
}
$7e6c76b555606c86$exports = $7e6c76b555606c86$var$max;


var $1c8f1fb0e9f3e461$exports = {};

var $f06f967f8ac47c1e$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $f06f967f8ac47c1e$var$baseLt(value, other) {
    return value < other;
}
$f06f967f8ac47c1e$exports = $f06f967f8ac47c1e$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $1c8f1fb0e9f3e461$var$min(array) {
    return array && array.length ? $99810a5d8a139bcd$exports(array, $ca900a7526c42750$exports, $f06f967f8ac47c1e$exports) : undefined;
}
$1c8f1fb0e9f3e461$exports = $1c8f1fb0e9f3e461$var$min;


var $defd055904e01055$exports = {};

var $ccd8c0c9826373c7$exports = {};




/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $ccd8c0c9826373c7$var$map(collection, iteratee) {
    var func = $02148300ecce42f1$exports(collection) ? $7fae7c98af7b4a49$exports : $055603bce0be7bb1$exports;
    return func(collection, $57b9695ad40eb80b$exports(iteratee, 3));
}
$ccd8c0c9826373c7$exports = $ccd8c0c9826373c7$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $defd055904e01055$var$flatMap(collection, iteratee) {
    return $af6bc59fca254b53$exports($ccd8c0c9826373c7$exports(collection, iteratee), 1);
}
$defd055904e01055$exports = $defd055904e01055$var$flatMap;





var $51dab9abc55fde57$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$51dab9abc55fde57$exports = (parcelRequire("fREfv"));



var $6969c7c4504a1818$exports = {};
(function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $6969c7c4504a1818$exports) $6969c7c4504a1818$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($6969c7c4504a1818$exports);


function $9e5131ceef6bc025$var$_toConsumableArray(arr) {
    return $9e5131ceef6bc025$var$_arrayWithoutHoles(arr) || $9e5131ceef6bc025$var$_iterableToArray(arr) || $9e5131ceef6bc025$var$_unsupportedIterableToArray(arr) || $9e5131ceef6bc025$var$_nonIterableSpread();
}
function $9e5131ceef6bc025$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e5131ceef6bc025$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9e5131ceef6bc025$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e5131ceef6bc025$var$_arrayLikeToArray(o, minLen);
}
function $9e5131ceef6bc025$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $9e5131ceef6bc025$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9e5131ceef6bc025$var$_arrayLikeToArray(arr);
}
function $9e5131ceef6bc025$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $9e5131ceef6bc025$var$identity = function identity(i) {
    return i;
};
var $9e5131ceef6bc025$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $9e5131ceef6bc025$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $9e5131ceef6bc025$export$ca73b6d700d0505;
};
var $9e5131ceef6bc025$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $9e5131ceef6bc025$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $9e5131ceef6bc025$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $9e5131ceef6bc025$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $9e5131ceef6bc025$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $9e5131ceef6bc025$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $9e5131ceef6bc025$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $9e5131ceef6bc025$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $9e5131ceef6bc025$export$c3095a23b368d1f2 = function curry(fn) {
    return $9e5131ceef6bc025$var$curryN(fn.length, fn);
};
var $9e5131ceef6bc025$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $9e5131ceef6bc025$export$871de8747c9eaa88 = $9e5131ceef6bc025$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $9e5131ceef6bc025$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $9e5131ceef6bc025$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $9e5131ceef6bc025$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $9e5131ceef6bc025$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $de6a0356360206b9$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $de6a0356360206b9$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $de6a0356360206b9$var$interpolateNumber = (0, $9e5131ceef6bc025$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $de6a0356360206b9$var$uninterpolateNumber = (0, $9e5131ceef6bc025$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $de6a0356360206b9$var$uninterpolateTruncation = (0, $9e5131ceef6bc025$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $de6a0356360206b9$export$2e2bcd8739ae039 = {
    rangeStep: $de6a0356360206b9$var$rangeStep,
    getDigitCount: $de6a0356360206b9$var$getDigitCount,
    interpolateNumber: $de6a0356360206b9$var$interpolateNumber,
    uninterpolateNumber: $de6a0356360206b9$var$uninterpolateNumber,
    uninterpolateTruncation: $de6a0356360206b9$var$uninterpolateTruncation
};


function $4aa941a8c5a76343$var$_toConsumableArray(arr) {
    return $4aa941a8c5a76343$var$_arrayWithoutHoles(arr) || $4aa941a8c5a76343$var$_iterableToArray(arr) || $4aa941a8c5a76343$var$_unsupportedIterableToArray(arr) || $4aa941a8c5a76343$var$_nonIterableSpread();
}
function $4aa941a8c5a76343$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4aa941a8c5a76343$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $4aa941a8c5a76343$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4aa941a8c5a76343$var$_arrayLikeToArray(arr);
}
function $4aa941a8c5a76343$var$_slicedToArray(arr, i) {
    return $4aa941a8c5a76343$var$_arrayWithHoles(arr) || $4aa941a8c5a76343$var$_iterableToArrayLimit(arr, i) || $4aa941a8c5a76343$var$_unsupportedIterableToArray(arr, i) || $4aa941a8c5a76343$var$_nonIterableRest();
}
function $4aa941a8c5a76343$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4aa941a8c5a76343$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4aa941a8c5a76343$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4aa941a8c5a76343$var$_arrayLikeToArray(o, minLen);
}
function $4aa941a8c5a76343$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4aa941a8c5a76343$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4aa941a8c5a76343$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $4aa941a8c5a76343$var$getValidInterval(_ref) {
    var _ref2 = $4aa941a8c5a76343$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $4aa941a8c5a76343$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(0);
    var digitCount = (0, $de6a0356360206b9$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $4aa941a8c5a76343$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(10).pow((0, $de6a0356360206b9$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $9e5131ceef6bc025$export$f672e0b6f7222cd7)((0, $9e5131ceef6bc025$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $9e5131ceef6bc025$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $4aa941a8c5a76343$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $4aa941a8c5a76343$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $4aa941a8c5a76343$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $4aa941a8c5a76343$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $4aa941a8c5a76343$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $4aa941a8c5a76343$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $4aa941a8c5a76343$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($4aa941a8c5a76343$var$_toConsumableArray((0, $9e5131ceef6bc025$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($4aa941a8c5a76343$var$_toConsumableArray((0, $9e5131ceef6bc025$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $9e5131ceef6bc025$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $4aa941a8c5a76343$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $4aa941a8c5a76343$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $de6a0356360206b9$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $9e5131ceef6bc025$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $4aa941a8c5a76343$var$getTickValuesFn(_ref5) {
    var _ref6 = $4aa941a8c5a76343$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $4aa941a8c5a76343$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $4aa941a8c5a76343$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $4aa941a8c5a76343$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $4aa941a8c5a76343$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $9e5131ceef6bc025$export$f672e0b6f7222cd7)((0, $9e5131ceef6bc025$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(n).mul(step)).toNumber();
    }), (0, $9e5131ceef6bc025$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $9e5131ceef6bc025$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $4aa941a8c5a76343$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $4aa941a8c5a76343$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $4aa941a8c5a76343$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $4aa941a8c5a76343$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $4aa941a8c5a76343$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($4aa941a8c5a76343$var$_toConsumableArray((0, $de6a0356360206b9$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($6969c7c4504a1818$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $9e5131ceef6bc025$export$66c1ae025e96b4bc)(values) : values;
}
var $4aa941a8c5a76343$export$b84e75ccbfe6a612 = (0, $9e5131ceef6bc025$export$fc10aeed3a532e2a)($4aa941a8c5a76343$var$getNiceTickValuesFn);
var $4aa941a8c5a76343$export$4cc7a216492b1f53 = (0, $9e5131ceef6bc025$export$fc10aeed3a532e2a)($4aa941a8c5a76343$var$getTickValuesFn);
var $4aa941a8c5a76343$export$e9d28da780436e98 = (0, $9e5131ceef6bc025$export$fc10aeed3a532e2a)($4aa941a8c5a76343$var$getTickValuesFixedDomainFn);





var $5pP8j = parcelRequire("5pP8j");


var $6acdc3c09f8074d5$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $6acdc3c09f8074d5$var$_extends() {
    $6acdc3c09f8074d5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6acdc3c09f8074d5$var$_extends.apply(this, arguments);
}
function $6acdc3c09f8074d5$var$_slicedToArray(arr, i) {
    return $6acdc3c09f8074d5$var$_arrayWithHoles(arr) || $6acdc3c09f8074d5$var$_iterableToArrayLimit(arr, i) || $6acdc3c09f8074d5$var$_unsupportedIterableToArray(arr, i) || $6acdc3c09f8074d5$var$_nonIterableRest();
}
function $6acdc3c09f8074d5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6acdc3c09f8074d5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6acdc3c09f8074d5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6acdc3c09f8074d5$var$_arrayLikeToArray(o, minLen);
}
function $6acdc3c09f8074d5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6acdc3c09f8074d5$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $6acdc3c09f8074d5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6acdc3c09f8074d5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6acdc3c09f8074d5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6acdc3c09f8074d5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6acdc3c09f8074d5$export$4f4d7676bdf949e5(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = $6acdc3c09f8074d5$var$_objectWithoutProperties(props, $6acdc3c09f8074d5$var$_excluded);
    var svgProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(others);
    var errorBars = data.map(function(entry, i) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = $6acdc3c09f8074d5$var$_slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === 'vertical') {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === 'horizontal') {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), $6acdc3c09f8074d5$var$_extends({
            className: "recharts-errorBar",
            key: "bar-".concat(i)
        }, svgProps), lineCoordinates.map(function(coordinates, index) {
            return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("line", $6acdc3c09f8074d5$var$_extends({}, coordinates, {
                key: "line-".concat(index)
            })));
        })));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
        className: "recharts-errorBars"
    }, errorBars);
}
$6acdc3c09f8074d5$export$4f4d7676bdf949e5.defaultProps = {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
};
$6acdc3c09f8074d5$export$4f4d7676bdf949e5.displayName = 'ErrorBar';





function $de5fcafa56f48e7f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $de5fcafa56f48e7f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $de5fcafa56f48e7f$var$_typeof(obj);
}
function $de5fcafa56f48e7f$var$_toConsumableArray(arr) {
    return $de5fcafa56f48e7f$var$_arrayWithoutHoles(arr) || $de5fcafa56f48e7f$var$_iterableToArray(arr) || $de5fcafa56f48e7f$var$_unsupportedIterableToArray(arr) || $de5fcafa56f48e7f$var$_nonIterableSpread();
}
function $de5fcafa56f48e7f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $de5fcafa56f48e7f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $de5fcafa56f48e7f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $de5fcafa56f48e7f$var$_arrayLikeToArray(o, minLen);
}
function $de5fcafa56f48e7f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $de5fcafa56f48e7f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $de5fcafa56f48e7f$var$_arrayLikeToArray(arr);
}
function $de5fcafa56f48e7f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $de5fcafa56f48e7f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $de5fcafa56f48e7f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $de5fcafa56f48e7f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $de5fcafa56f48e7f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $de5fcafa56f48e7f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $de5fcafa56f48e7f$var$_defineProperty(obj, key, value) {
    key = $de5fcafa56f48e7f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $de5fcafa56f48e7f$var$_toPropertyKey(arg) {
    var key = $de5fcafa56f48e7f$var$_toPrimitive(arg, "string");
    return $de5fcafa56f48e7f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $de5fcafa56f48e7f$var$_toPrimitive(input, hint) {
    if ($de5fcafa56f48e7f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($de5fcafa56f48e7f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $de5fcafa56f48e7f$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(dataKey)) return defaultValue;
    if ((0, $e6a593df52d5e247$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $de5fcafa56f48e7f$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($defd055904e01055$exports)))(data, function(entry) {
        return $de5fcafa56f48e7f$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        var domain = flattenData.filter(function(entry) {
            return (0, $e6a593df52d5e247$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($1c8f1fb0e9f3e461$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($7e6c76b555606c86$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(entry);
    }) : flattenData;
    // 支持Date类型的x轴
    return validateData.map(function(entry) {
        return (0, $e6a593df52d5e247$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $de5fcafa56f48e7f$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $e6a593df52d5e247$export$9d334328eb75e624)(cur - before) !== (0, $e6a593df52d5e247$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $e6a593df52d5e247$export$9d334328eb75e624)(after - cur) === (0, $e6a593df52d5e247$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var min = Math.min(before, after);
                var max = Math.max(before, after);
                if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $de5fcafa56f48e7f$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $de5fcafa56f48e7f$export$8f9424d123c36aa = function getLegendProps(_ref2) {
    var children = _ref2.children, formattedGraphicalItems = _ref2.formattedGraphicalItems, legendWidth = _ref2.legendWidth, legendContent = _ref2.legendContent;
    var legendItem = (0, $f43486451a1e41f4$export$64c61536a2b72e0f)(children, (0, $785732b572ee5e11$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref3) {
        var item = _ref3.item, props = _ref3.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref4) {
        var item = _ref4.item;
        var _item$props2 = item.props, dataKey = _item$props2.dataKey, name = _item$props2.name, legendType = _item$props2.legendType, hide = _item$props2.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || 'square',
            color: $de5fcafa56f48e7f$export$ec6cab5a7a3b93bf(item),
            value: name || dataKey,
            payload: item.props
        };
    });
    return $de5fcafa56f48e7f$var$_objectSpread($de5fcafa56f48e7f$var$_objectSpread($de5fcafa56f48e7f$var$_objectSpread({}, legendItem.props), (0, $785732b572ee5e11$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};
var $de5fcafa56f48e7f$export$570d306bee26c748 = function getBarSizeList(_ref5) {
    var globalSize = _ref5.barSize, _ref5$stackGroups = _ref5.stackGroups, stackGroups = _ref5$stackGroups === void 0 ? {} : _ref5$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $f43486451a1e41f4$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var $de5fcafa56f48e7f$export$d36834ecd87f906b = function getBarPosition(_ref6) {
    var barGap = _ref6.barGap, barCategoryGap = _ref6.barCategoryGap, bandSize = _ref6.bandSize, _ref6$sizeList = _ref6.sizeList, sizeList = _ref6$sizeList === void 0 ? [] : _ref6$sizeList, maxBarSize = _ref6.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $e6a593df52d5e247$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newRes = [].concat($de5fcafa56f48e7f$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: prev.offset + prev.size + realBarGap,
                        size: useFull ? fullBarSize : entry.barSize
                    }
                }
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, []);
    } else {
        var _offset = (0, $e6a593df52d5e247$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($de5fcafa56f48e7f$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, []);
    }
    return result;
};
var $de5fcafa56f48e7f$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, items, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    // const legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
    var legendProps = $de5fcafa56f48e7f$export$8f9424d123c36aa({
        children: children,
        legendWidth: legendWidth
    });
    var newOffset = offset;
    if (legendProps) {
        var box = legendBox || {};
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(offset[align])) newOffset = $de5fcafa56f48e7f$var$_objectSpread($de5fcafa56f48e7f$var$_objectSpread({}, offset), {}, $de5fcafa56f48e7f$var$_defineProperty({}, align, newOffset[align] + (box.width || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(offset[verticalAlign])) newOffset = $de5fcafa56f48e7f$var$_objectSpread($de5fcafa56f48e7f$var$_objectSpread({}, offset), {}, $de5fcafa56f48e7f$var$_defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
    return newOffset;
};
var $de5fcafa56f48e7f$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $de5fcafa56f48e7f$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, (0, $6acdc3c09f8074d5$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $de5fcafa56f48e7f$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $de5fcafa56f48e7f$export$f97fc4a450f29a(entry, dataKey, 0);
            var mainValue = (0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($1c8f1fb0e9f3e461$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($7e6c76b555606c86$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $de5fcafa56f48e7f$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $de5fcafa56f48e7f$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $de5fcafa56f48e7f$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $de5fcafa56f48e7f$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $de5fcafa56f48e7f$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $de5fcafa56f48e7f$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $de5fcafa56f48e7f$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)if (!tag[entry[i]]) {
            tag[entry[i]] = true;
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $de5fcafa56f48e7f$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $de5fcafa56f48e7f$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, min, max) {
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === min) hasMin = true;
        if (entry.coordinate === max) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(min);
    if (!hasMax) values.push(max);
    return values;
};
var $de5fcafa56f48e7f$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $e6a593df52d5e247$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($821a6471b94b95a0$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
var $de5fcafa56f48e7f$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
    var customizedHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(childHandler)) customizedHandler = childHandler;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(parentHandler)) customizedHandler = parentHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(defaultHandler) || customizedHandler) return function(arg1, arg2, arg3, arg4) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(defaultHandler)) defaultHandler(arg1, arg2, arg3, arg4);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(customizedHandler)) customizedHandler(arg1, arg2, arg3, arg4);
    };
    return null;
};
var $de5fcafa56f48e7f$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $51dab9abc55fde57$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $51dab9abc55fde57$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $51dab9abc55fde57$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $51dab9abc55fde57$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $51dab9abc55fde57$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($08d6e520370fa038$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($f754ad19e6141c59$exports)))(scale));
        return {
            scale: ($51dab9abc55fde57$exports[name] || $51dab9abc55fde57$exports.scalePoint)(),
            realScaleType: $51dab9abc55fde57$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $51dab9abc55fde57$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $de5fcafa56f48e7f$var$EPS = 1e-4;
var $de5fcafa56f48e7f$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var min = Math.min(range[0], range[1]) - $de5fcafa56f48e7f$var$EPS;
    var max = Math.max(range[0], range[1]) + $de5fcafa56f48e7f$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < min || first > max || last < min || last > max) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $de5fcafa56f48e7f$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $de5fcafa56f48e7f$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(domain[0]) || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(domain[1])) return value;
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $e6a593df52d5e247$export$7e4aa119212bc614)(value[0]) || value[0] < min) result[0] = min;
    if (!(0, $e6a593df52d5e247$export$7e4aa119212bc614)(value[1]) || value[1] > max) result[1] = max;
    if (result[0] > max) result[0] = max;
    if (result[1] < min) result[1] = min;
    return result;
};
var $de5fcafa56f48e7f$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($821a6471b94b95a0$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $de5fcafa56f48e7f$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($821a6471b94b95a0$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $de5fcafa56f48e7f$var$STACK_OFFSET_MAP = {
    sign: $de5fcafa56f48e7f$export$3104c513558164c1,
    expand: (0, $1ff5105c1693678c$exports.stackOffsetExpand),
    none: (0, $1ff5105c1693678c$exports.stackOffsetNone),
    silhouette: (0, $1ff5105c1693678c$exports.stackOffsetSilhouette),
    wiggle: (0, $1ff5105c1693678c$exports.stackOffsetWiggle),
    positive: $de5fcafa56f48e7f$export$9f2c6ead70935022
};
var $de5fcafa56f48e7f$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var stack = (0, $1ff5105c1693678c$exports.stack)().keys(dataKeys).value(function(d, key) {
        return +$de5fcafa56f48e7f$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $1ff5105c1693678c$exports.stackOrderNone)).offset($de5fcafa56f48e7f$var$STACK_OFFSET_MAP[offsetType]);
    return stack(data);
};
var $de5fcafa56f48e7f$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var stackGroups = items.reduce(function(result, item) {
        var _item$props3 = item.props, stackId = _item$props3.stackId, hide = _item$props3.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $e6a593df52d5e247$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $e6a593df52d5e247$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $de5fcafa56f48e7f$var$_objectSpread($de5fcafa56f48e7f$var$_objectSpread({}, result), {}, $de5fcafa56f48e7f$var$_defineProperty({}, axisId, parentGroup));
    }, {});
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
            var g = group.stackGroups[stackId];
            return $de5fcafa56f48e7f$var$_objectSpread($de5fcafa56f48e7f$var$_objectSpread({}, res), {}, $de5fcafa56f48e7f$var$_defineProperty({}, stackId, {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: g.items,
                stackedData: $de5fcafa56f48e7f$export$c2170542cfc0177c(data, g.items, offsetType)
            }));
        }, {});
        return $de5fcafa56f48e7f$var$_objectSpread($de5fcafa56f48e7f$var$_objectSpread({}, result), {}, $de5fcafa56f48e7f$var$_defineProperty({}, axisId, group));
    }, {});
};
var $de5fcafa56f48e7f$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $4aa941a8c5a76343$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($1c8f1fb0e9f3e461$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($7e6c76b555606c86$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $4aa941a8c5a76343$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var $de5fcafa56f48e7f$export$6e87f3defb83c3f = function getCateCoordinateOfLine(_ref7) {
    var axis = _ref7.axis, ticks = _ref7.ticks, bandSize = _ref7.bandSize, entry = _ref7.entry, index = _ref7.index, dataKey = _ref7.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(entry[axis.dataKey])) {
            var matchedTick = (0, $e6a593df52d5e247$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $de5fcafa56f48e7f$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(value) ? axis.scale(value) : null;
};
var $de5fcafa56f48e7f$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref8) {
    var axis = _ref8.axis, ticks = _ref8.ticks, offset = _ref8.offset, bandSize = _ref8.bandSize, entry = _ref8.entry, index = _ref8.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $de5fcafa56f48e7f$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $de5fcafa56f48e7f$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref9) {
    var numericAxis = _ref9.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var min = Math.min(domain[0], domain[1]);
        var max = Math.max(domain[0], domain[1]);
        if (min <= 0 && max >= 0) return 0;
        if (max < 0) return max;
        return min;
    }
    return domain[0];
};
var $de5fcafa56f48e7f$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $e6a593df52d5e247$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group && group.items.length) {
            var itemIndex = -1;
            for(var i = 0, len = group.items.length; i < len; i++)if (group.items[i] === item) {
                itemIndex = i;
                break;
            }
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $de5fcafa56f48e7f$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($1c8f1fb0e9f3e461$exports)))(entry.concat([
                result[0]
            ]).filter((0, $e6a593df52d5e247$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7e6c76b555606c86$exports)))(entry.concat([
                result[1]
            ]).filter((0, $e6a593df52d5e247$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $de5fcafa56f48e7f$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $de5fcafa56f48e7f$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $de5fcafa56f48e7f$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $de5fcafa56f48e7f$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $de5fcafa56f48e7f$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($de5fcafa56f48e7f$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$de5fcafa56f48e7f$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($de5fcafa56f48e7f$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$de5fcafa56f48e7f$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $de5fcafa56f48e7f$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($08d5ce8e0c21d402$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $de5fcafa56f48e7f$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5dab8b3c935330c$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $de5fcafa56f48e7f$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType;
    return $de5fcafa56f48e7f$var$_objectSpread($de5fcafa56f48e7f$var$_objectSpread({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(graphicalItem)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $de5fcafa56f48e7f$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $de5fcafa56f48e7f$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType
    });
};


function $0c9962d1b1acbd9a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0c9962d1b1acbd9a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0c9962d1b1acbd9a$var$_typeof(obj);
}
function $0c9962d1b1acbd9a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0c9962d1b1acbd9a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0c9962d1b1acbd9a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0c9962d1b1acbd9a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0c9962d1b1acbd9a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0c9962d1b1acbd9a$var$_defineProperty(obj, key, value) {
    key = $0c9962d1b1acbd9a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0c9962d1b1acbd9a$var$_toPropertyKey(arg) {
    var key = $0c9962d1b1acbd9a$var$_toPrimitive(arg, "string");
    return $0c9962d1b1acbd9a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0c9962d1b1acbd9a$var$_toPrimitive(input, hint) {
    if ($0c9962d1b1acbd9a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0c9962d1b1acbd9a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0c9962d1b1acbd9a$var$_slicedToArray(arr, i) {
    return $0c9962d1b1acbd9a$var$_arrayWithHoles(arr) || $0c9962d1b1acbd9a$var$_iterableToArrayLimit(arr, i) || $0c9962d1b1acbd9a$var$_unsupportedIterableToArray(arr, i) || $0c9962d1b1acbd9a$var$_nonIterableRest();
}
function $0c9962d1b1acbd9a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0c9962d1b1acbd9a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0c9962d1b1acbd9a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0c9962d1b1acbd9a$var$_arrayLikeToArray(o, minLen);
}
function $0c9962d1b1acbd9a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0c9962d1b1acbd9a$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $0c9962d1b1acbd9a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $0c9962d1b1acbd9a$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $0c9962d1b1acbd9a$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $0c9962d1b1acbd9a$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $0c9962d1b1acbd9a$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$0c9962d1b1acbd9a$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$0c9962d1b1acbd9a$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $0c9962d1b1acbd9a$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $0c9962d1b1acbd9a$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $e6a593df52d5e247$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $e6a593df52d5e247$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $0c9962d1b1acbd9a$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $e6a593df52d5e247$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $e6a593df52d5e247$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $0c9962d1b1acbd9a$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $de5fcafa56f48e7f$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $de5fcafa56f48e7f$export$9d80152e23bae434)(scale);
        var ticks = (0, $de5fcafa56f48e7f$export$ac086aaa4358d590)(scale, $0c9962d1b1acbd9a$var$_objectSpread($0c9962d1b1acbd9a$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $0c9962d1b1acbd9a$var$_objectSpread($0c9962d1b1acbd9a$var$_objectSpread($0c9962d1b1acbd9a$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $0c9962d1b1acbd9a$var$_objectSpread($0c9962d1b1acbd9a$var$_objectSpread({}, result), {}, $0c9962d1b1acbd9a$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $0c9962d1b1acbd9a$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $0c9962d1b1acbd9a$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $0c9962d1b1acbd9a$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $0c9962d1b1acbd9a$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $0c9962d1b1acbd9a$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $0c9962d1b1acbd9a$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $0c9962d1b1acbd9a$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $0c9962d1b1acbd9a$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $0c9962d1b1acbd9a$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $0c9962d1b1acbd9a$var$_objectSpread($0c9962d1b1acbd9a$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $0c9962d1b1acbd9a$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};


function $cd5c1f753edd459d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cd5c1f753edd459d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cd5c1f753edd459d$var$_typeof(obj);
}
function $cd5c1f753edd459d$var$_toConsumableArray(arr) {
    return $cd5c1f753edd459d$var$_arrayWithoutHoles(arr) || $cd5c1f753edd459d$var$_iterableToArray(arr) || $cd5c1f753edd459d$var$_unsupportedIterableToArray(arr) || $cd5c1f753edd459d$var$_nonIterableSpread();
}
function $cd5c1f753edd459d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cd5c1f753edd459d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cd5c1f753edd459d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cd5c1f753edd459d$var$_arrayLikeToArray(o, minLen);
}
function $cd5c1f753edd459d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cd5c1f753edd459d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cd5c1f753edd459d$var$_arrayLikeToArray(arr);
}
function $cd5c1f753edd459d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cd5c1f753edd459d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cd5c1f753edd459d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cd5c1f753edd459d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cd5c1f753edd459d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cd5c1f753edd459d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cd5c1f753edd459d$var$_defineProperty(obj, key, value) {
    key = $cd5c1f753edd459d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cd5c1f753edd459d$var$_toPropertyKey(arg) {
    var key = $cd5c1f753edd459d$var$_toPrimitive(arg, "string");
    return $cd5c1f753edd459d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cd5c1f753edd459d$var$_toPrimitive(input, hint) {
    if ($cd5c1f753edd459d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cd5c1f753edd459d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $cd5c1f753edd459d$var$_extends() {
    $cd5c1f753edd459d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd5c1f753edd459d$var$_extends.apply(this, arguments);
}
var $cd5c1f753edd459d$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(formatter)) return formatter(label);
    return label;
};
var $cd5c1f753edd459d$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $e6a593df52d5e247$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $cd5c1f753edd459d$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $cd5c1f753edd459d$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(labelProps.id) ? (0, $e6a593df52d5e247$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("text", $cd5c1f753edd459d$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $cd5c1f753edd459d$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $cd5c1f753edd459d$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $cd5c1f753edd459d$var$_objectSpread($cd5c1f753edd459d$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $cd5c1f753edd459d$var$_objectSpread($cd5c1f753edd459d$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $cd5c1f753edd459d$var$_objectSpread($cd5c1f753edd459d$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $cd5c1f753edd459d$var$_objectSpread($cd5c1f753edd459d$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $cd5c1f753edd459d$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $cd5c1f753edd459d$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $cd5c1f753edd459d$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $cd5c1f753edd459d$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $cd5c1f753edd459d$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $cd5c1f753edd459d$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $cd5c1f753edd459d$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $cd5c1f753edd459d$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0e1bd391425671ea$exports)))(position) && ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(position.x) || (0, $e6a593df52d5e247$export$e50269385c77c348)(position.x)) && ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(position.y) || (0, $e6a593df52d5e247$export$e50269385c77c348)(position.y))) return $cd5c1f753edd459d$var$_objectSpread({
        x: x + (0, $e6a593df52d5e247$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $e6a593df52d5e247$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $cd5c1f753edd459d$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $cd5c1f753edd459d$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(viewBox.cx);
};
function $cd5c1f753edd459d$export$b04be29aa201d4f5(props) {
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(children) && !/*#__PURE__*/ (0, $5pP8j.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $5pP8j.isValidElement)(content)) return /*#__PURE__*/ (0, $5pP8j.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(content)) {
        label = /*#__PURE__*/ (0, $5pP8j.createElement)(content, props);
        if (/*#__PURE__*/ (0, $5pP8j.isValidElement)(label)) return label;
    } else label = $cd5c1f753edd459d$var$getLabel(props);
    var isPolarLabel = $cd5c1f753edd459d$var$isPolar(viewBox);
    var attrs = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $cd5c1f753edd459d$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $cd5c1f753edd459d$var$getAttrsOfPolarLabel(props) : $cd5c1f753edd459d$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $9356d3eb5e25660c$export$5f1af8db9871e1d6), $cd5c1f753edd459d$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$cd5c1f753edd459d$export$b04be29aa201d4f5.displayName = 'Label';
$cd5c1f753edd459d$export$b04be29aa201d4f5.defaultProps = {
    offset: 5
};
var $cd5c1f753edd459d$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(width) && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(height)) {
        if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(x) && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(top) && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(x) && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(cx) && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $cd5c1f753edd459d$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement($cd5c1f753edd459d$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $e6a593df52d5e247$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement($cd5c1f753edd459d$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $5pP8j.isValidElement)(label)) {
        if (label.type === $cd5c1f753edd459d$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $5pP8j.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement($cd5c1f753edd459d$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement($cd5c1f753edd459d$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0e1bd391425671ea$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement($cd5c1f753edd459d$export$b04be29aa201d4f5, $cd5c1f753edd459d$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $cd5c1f753edd459d$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $cd5c1f753edd459d$var$parseViewBox(parentProps);
    var explicitChildren = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, $cd5c1f753edd459d$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $5pP8j.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $cd5c1f753edd459d$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($cd5c1f753edd459d$var$_toConsumableArray(explicitChildren));
};
$cd5c1f753edd459d$export$b04be29aa201d4f5.parseViewBox = $cd5c1f753edd459d$var$parseViewBox;
$cd5c1f753edd459d$export$b04be29aa201d4f5.renderCallByParent = $cd5c1f753edd459d$var$renderCallByParent;





function $18e58544181e4986$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $18e58544181e4986$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $18e58544181e4986$var$_typeof(obj);
}
var $18e58544181e4986$var$_excluded = [
    "data",
    "valueAccessor",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $18e58544181e4986$var$_toConsumableArray(arr) {
    return $18e58544181e4986$var$_arrayWithoutHoles(arr) || $18e58544181e4986$var$_iterableToArray(arr) || $18e58544181e4986$var$_unsupportedIterableToArray(arr) || $18e58544181e4986$var$_nonIterableSpread();
}
function $18e58544181e4986$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $18e58544181e4986$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $18e58544181e4986$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $18e58544181e4986$var$_arrayLikeToArray(o, minLen);
}
function $18e58544181e4986$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $18e58544181e4986$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $18e58544181e4986$var$_arrayLikeToArray(arr);
}
function $18e58544181e4986$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $18e58544181e4986$var$_extends() {
    $18e58544181e4986$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $18e58544181e4986$var$_extends.apply(this, arguments);
}
function $18e58544181e4986$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $18e58544181e4986$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $18e58544181e4986$var$ownKeys(Object(source), !0).forEach(function(key) {
            $18e58544181e4986$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $18e58544181e4986$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $18e58544181e4986$var$_defineProperty(obj, key, value) {
    key = $18e58544181e4986$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $18e58544181e4986$var$_toPropertyKey(arg) {
    var key = $18e58544181e4986$var$_toPrimitive(arg, "string");
    return $18e58544181e4986$var$_typeof(key) === "symbol" ? key : String(key);
}
function $18e58544181e4986$var$_toPrimitive(input, hint) {
    if ($18e58544181e4986$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($18e58544181e4986$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $18e58544181e4986$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $18e58544181e4986$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $18e58544181e4986$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $18e58544181e4986$var$defaultProps = {
    valueAccessor: function valueAccessor(entry) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($3d1cab1292d40359$exports)))(entry.value) : entry.value;
    }
};
function $18e58544181e4986$export$835fcf23ab7bf88(props) {
    var data = props.data, valueAccessor = props.valueAccessor, dataKey = props.dataKey, clockWise = props.clockWise, id = props.id, textBreakAll = props.textBreakAll, others = $18e58544181e4986$var$_objectWithoutProperties(props, $18e58544181e4986$var$_excluded);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $cd5c1f753edd459d$export$b04be29aa201d4f5), $18e58544181e4986$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            index: index,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $cd5c1f753edd459d$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(clockWise) ? entry : $18e58544181e4986$var$_objectSpread($18e58544181e4986$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
        }));
    }));
}
$18e58544181e4986$export$835fcf23ab7bf88.displayName = 'LabelList';
function $18e58544181e4986$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement($18e58544181e4986$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement($18e58544181e4986$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0e1bd391425671ea$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement($18e58544181e4986$export$835fcf23ab7bf88, $18e58544181e4986$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $18e58544181e4986$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, $18e58544181e4986$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $5pP8j.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $18e58544181e4986$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($18e58544181e4986$var$_toConsumableArray(explicitChildren));
}
$18e58544181e4986$export$835fcf23ab7bf88.renderCallByParent = $18e58544181e4986$var$renderCallByParent;
$18e58544181e4986$export$835fcf23ab7bf88.defaultProps = $18e58544181e4986$var$defaultProps;







var $22e4f653bf728fd5$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
];
function $22e4f653bf728fd5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $22e4f653bf728fd5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $22e4f653bf728fd5$var$_typeof(obj);
}
function $22e4f653bf728fd5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $22e4f653bf728fd5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $22e4f653bf728fd5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $22e4f653bf728fd5$var$_extends() {
    $22e4f653bf728fd5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $22e4f653bf728fd5$var$_extends.apply(this, arguments);
}
function $22e4f653bf728fd5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $22e4f653bf728fd5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $22e4f653bf728fd5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $22e4f653bf728fd5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $22e4f653bf728fd5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $22e4f653bf728fd5$var$_toConsumableArray(arr) {
    return $22e4f653bf728fd5$var$_arrayWithoutHoles(arr) || $22e4f653bf728fd5$var$_iterableToArray(arr) || $22e4f653bf728fd5$var$_unsupportedIterableToArray(arr) || $22e4f653bf728fd5$var$_nonIterableSpread();
}
function $22e4f653bf728fd5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $22e4f653bf728fd5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $22e4f653bf728fd5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $22e4f653bf728fd5$var$_arrayLikeToArray(o, minLen);
}
function $22e4f653bf728fd5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $22e4f653bf728fd5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $22e4f653bf728fd5$var$_arrayLikeToArray(arr);
}
function $22e4f653bf728fd5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $22e4f653bf728fd5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $22e4f653bf728fd5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $22e4f653bf728fd5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $22e4f653bf728fd5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $22e4f653bf728fd5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $22e4f653bf728fd5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $22e4f653bf728fd5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $22e4f653bf728fd5$var$_setPrototypeOf(subClass, superClass);
}
function $22e4f653bf728fd5$var$_setPrototypeOf(o, p) {
    $22e4f653bf728fd5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $22e4f653bf728fd5$var$_setPrototypeOf(o, p);
}
function $22e4f653bf728fd5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $22e4f653bf728fd5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $22e4f653bf728fd5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $22e4f653bf728fd5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $22e4f653bf728fd5$var$_possibleConstructorReturn(this, result);
    };
}
function $22e4f653bf728fd5$var$_possibleConstructorReturn(self, call) {
    if (call && ($22e4f653bf728fd5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $22e4f653bf728fd5$var$_assertThisInitialized(self);
}
function $22e4f653bf728fd5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $22e4f653bf728fd5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $22e4f653bf728fd5$var$_getPrototypeOf(o) {
    $22e4f653bf728fd5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $22e4f653bf728fd5$var$_getPrototypeOf(o);
}
function $22e4f653bf728fd5$var$_defineProperty(obj, key, value) {
    key = $22e4f653bf728fd5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $22e4f653bf728fd5$var$_toPropertyKey(arg) {
    var key = $22e4f653bf728fd5$var$_toPrimitive(arg, "string");
    return $22e4f653bf728fd5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $22e4f653bf728fd5$var$_toPrimitive(input, hint) {
    if ($22e4f653bf728fd5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($22e4f653bf728fd5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $22e4f653bf728fd5$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    $22e4f653bf728fd5$var$_inherits(Line, _PureComponent);
    var _super = $22e4f653bf728fd5$var$_createSuper(Line);
    function Line() {
        var _this;
        $22e4f653bf728fd5$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $22e4f653bf728fd5$var$_defineProperty($22e4f653bf728fd5$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $22e4f653bf728fd5$var$_defineProperty($22e4f653bf728fd5$var$_assertThisInitialized(_this), "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0;; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($22e4f653bf728fd5$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($22e4f653bf728fd5$var$_toConsumableArray(Line.repeat(lines, count)), $22e4f653bf728fd5$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(', ');
        });
        $22e4f653bf728fd5$var$_defineProperty($22e4f653bf728fd5$var$_assertThisInitialized(_this), "id", (0, $e6a593df52d5e247$export$8b15d37bc3f197d4)('recharts-line-'));
        $22e4f653bf728fd5$var$_defineProperty($22e4f653bf728fd5$var$_assertThisInitialized(_this), "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $22e4f653bf728fd5$var$_defineProperty($22e4f653bf728fd5$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $22e4f653bf728fd5$var$_defineProperty($22e4f653bf728fd5$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $22e4f653bf728fd5$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, (0, $6acdc3c09f8074d5$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(item, {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "bar-".concat(i),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $22e4f653bf728fd5$var$_objectSpread($22e4f653bf728fd5$var$_objectSpread($22e4f653bf728fd5$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        value: entry.value,
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        payload: entry.payload
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), $22e4f653bf728fd5$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $22e4f653bf728fd5$var$_objectWithoutProperties(_this$props3, $22e4f653bf728fd5$var$_excluded);
                var curveProps = $22e4f653bf728fd5$var$_objectSpread($22e4f653bf728fd5$var$_objectSpread($22e4f653bf728fd5$var$_objectSpread({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: 'none',
                    className: 'recharts-line-curve',
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $7eb448ddfde98505$export$b0e83c3ef8d2db1), $22e4f653bf728fd5$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $ee2bc8c876b1194a$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $22e4f653bf728fd5$var$_objectSpread($22e4f653bf728fd5$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $22e4f653bf728fd5$var$_objectSpread($22e4f653bf728fd5$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $22e4f653bf728fd5$var$_objectSpread($22e4f653bf728fd5$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($a5dab8b3c935330c$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-line', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $f43486451a1e41f4$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $18e58544181e4986$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($22e4f653bf728fd5$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($22e4f653bf728fd5$var$_toConsumableArray(result), $22e4f653bf728fd5$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) dotItem = option(props);
                else {
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-line-dot', option ? option.className : '');
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $bb16faa3019e11e8$export$d046b3c4a416f60d), $22e4f653bf728fd5$var$_extends({}, props, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
    return Line;
}((0, $5pP8j.PureComponent));
$22e4f653bf728fd5$var$_defineProperty($22e4f653bf728fd5$export$17d680238e50603e, "displayName", 'Line');
$22e4f653bf728fd5$var$_defineProperty($22e4f653bf728fd5$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    fill: '#fff',
    points: [],
    isAnimationActive: !(0, $b477b0447f10d549$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $22e4f653bf728fd5$var$_defineProperty($22e4f653bf728fd5$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === 'horizontal') return {
            x: (0, $de5fcafa56f48e7f$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $de5fcafa56f48e7f$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $22e4f653bf728fd5$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Line Chart
 */ var $3d4edc1cc2097bee$exports = {};
var $9c332cd82d575124$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $9c332cd82d575124$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$9c332cd82d575124$exports = $9c332cd82d575124$var$arrayEvery;


var $5ea6dbf1cff7126c$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $5ea6dbf1cff7126c$var$baseEvery(collection, predicate) {
    var result = true;
    $81fbac4887fc9905$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$5ea6dbf1cff7126c$exports = $5ea6dbf1cff7126c$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $3d4edc1cc2097bee$var$every(collection, predicate, guard) {
    var func = $02148300ecce42f1$exports(collection) ? $9c332cd82d575124$exports : $5ea6dbf1cff7126c$exports;
    if (guard && $ce13c7d955cccc00$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $57b9695ad40eb80b$exports(predicate, 3));
}
$3d4edc1cc2097bee$exports = $3d4edc1cc2097bee$var$every;


var $feb20e15be29a340$exports = {};
var $cf3720847a481641$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $cf3720847a481641$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$d78b82d99e6058d9$exports(collection)) {
            var iteratee = $57b9695ad40eb80b$exports(predicate, 3);
            collection = $02cff874f3633c30$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$cf3720847a481641$exports = $cf3720847a481641$var$createFind;


var $487c6542cb4b1f82$exports = {};


var $4fc0b69714f3b386$exports = {};
var $c2a11fd0cc4058ae$exports = {};
var $c4c081b3b4e615e6$exports = {};
var $0775c6f5412e93e0$exports = {};
var $4932bb90281f8eab$exports = {};
/** Used to match a single whitespace character. */ var $4932bb90281f8eab$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $4932bb90281f8eab$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $4932bb90281f8eab$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$4932bb90281f8eab$exports = $4932bb90281f8eab$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0775c6f5412e93e0$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0775c6f5412e93e0$var$baseTrim(string) {
    return string ? string.slice(0, $4932bb90281f8eab$exports(string) + 1).replace($0775c6f5412e93e0$var$reTrimStart, '') : string;
}
$0775c6f5412e93e0$exports = $0775c6f5412e93e0$var$baseTrim;




/** Used as references for various `Number` constants. */ var $c4c081b3b4e615e6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $c4c081b3b4e615e6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $c4c081b3b4e615e6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $c4c081b3b4e615e6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $c4c081b3b4e615e6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $c4c081b3b4e615e6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($cda1c6b7d8f0286a$exports(value)) return $c4c081b3b4e615e6$var$NAN;
    if ($0e1bd391425671ea$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $0e1bd391425671ea$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $0775c6f5412e93e0$exports(value);
    var isBinary = $c4c081b3b4e615e6$var$reIsBinary.test(value);
    return isBinary || $c4c081b3b4e615e6$var$reIsOctal.test(value) ? $c4c081b3b4e615e6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $c4c081b3b4e615e6$var$reIsBadHex.test(value) ? $c4c081b3b4e615e6$var$NAN : +value;
}
$c4c081b3b4e615e6$exports = $c4c081b3b4e615e6$var$toNumber;


/** Used as references for various `Number` constants. */ var $c2a11fd0cc4058ae$var$INFINITY = 1 / 0, $c2a11fd0cc4058ae$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $c2a11fd0cc4058ae$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $c4c081b3b4e615e6$exports(value);
    if (value === $c2a11fd0cc4058ae$var$INFINITY || value === -$c2a11fd0cc4058ae$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $c2a11fd0cc4058ae$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$c2a11fd0cc4058ae$exports = $c2a11fd0cc4058ae$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $4fc0b69714f3b386$var$toInteger(value) {
    var result = $c2a11fd0cc4058ae$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$4fc0b69714f3b386$exports = $4fc0b69714f3b386$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $487c6542cb4b1f82$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $487c6542cb4b1f82$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $4fc0b69714f3b386$exports(fromIndex);
    if (index < 0) index = $487c6542cb4b1f82$var$nativeMax(length + index, 0);
    return $e8fce87ad95c4015$exports(array, $57b9695ad40eb80b$exports(predicate, 3), index);
}
$487c6542cb4b1f82$exports = $487c6542cb4b1f82$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $feb20e15be29a340$var$find = $cf3720847a481641$exports($487c6542cb4b1f82$exports);
$feb20e15be29a340$exports = $feb20e15be29a340$var$find;



var $574b3c6076bd0804$exports = {};
var $d2f219afab8c4bb7$exports = {};

var $ef2cf4807460a0b1$exports = {};

var $lAA3U = parcelRequire("lAA3U");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ef2cf4807460a0b1$var$now = function() {
    return $lAA3U.Date.now();
};
$ef2cf4807460a0b1$exports = $ef2cf4807460a0b1$var$now;



/** Error message constants. */ var $d2f219afab8c4bb7$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d2f219afab8c4bb7$var$nativeMax = Math.max, $d2f219afab8c4bb7$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d2f219afab8c4bb7$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($d2f219afab8c4bb7$var$FUNC_ERROR_TEXT);
    wait = $c4c081b3b4e615e6$exports(wait) || 0;
    if ($0e1bd391425671ea$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $d2f219afab8c4bb7$var$nativeMax($c4c081b3b4e615e6$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d2f219afab8c4bb7$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ef2cf4807460a0b1$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ef2cf4807460a0b1$exports());
    }
    function debounced() {
        var time = $ef2cf4807460a0b1$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$d2f219afab8c4bb7$exports = $d2f219afab8c4bb7$var$debounce;



/** Error message constants. */ var $574b3c6076bd0804$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $574b3c6076bd0804$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($574b3c6076bd0804$var$FUNC_ERROR_TEXT);
    if ($0e1bd391425671ea$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $d2f219afab8c4bb7$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$574b3c6076bd0804$exports = $574b3c6076bd0804$var$throttle;




var $803301859424e115$exports = {};
var $246fa1a9f519b0fb$exports = {};
var $2982d09533ef7488$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2982d09533ef7488$var$nativeCeil = Math.ceil, $2982d09533ef7488$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $2982d09533ef7488$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $2982d09533ef7488$var$nativeMax($2982d09533ef7488$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$2982d09533ef7488$exports = $2982d09533ef7488$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $246fa1a9f519b0fb$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $ce13c7d955cccc00$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $c2a11fd0cc4058ae$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $c2a11fd0cc4058ae$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $c2a11fd0cc4058ae$exports(step);
        return $2982d09533ef7488$exports(start, end, step, fromRight);
    };
}
$246fa1a9f519b0fb$exports = $246fa1a9f519b0fb$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $803301859424e115$var$range = $246fa1a9f519b0fb$exports();
$803301859424e115$exports = $803301859424e115$var$range;



var $3b672836ef8ff84f$exports = {};


/** `Object#toString` result references. */ var $3b672836ef8ff84f$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $3b672836ef8ff84f$var$isBoolean(value) {
    return value === true || value === false || $713b03e77fe310b2$exports(value) && $15761e4e379c96ab$exports(value) == $3b672836ef8ff84f$var$boolTag;
}
$3b672836ef8ff84f$exports = $3b672836ef8ff84f$var$isBoolean;




var $5pP8j = parcelRequire("5pP8j");





/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $621dbabf8ec7f8f2$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}



var $ea7837f6b06acb6b$exports = {};
var $35ec8886f0beeeb5$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $35ec8886f0beeeb5$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $6ea96b6ce2080d0a$exports) $6ea96b6ce2080d0a$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$35ec8886f0beeeb5$exports = $35ec8886f0beeeb5$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $ea7837f6b06acb6b$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $57b9695ad40eb80b$exports(iteratee, 3);
    $01e866c044204682$exports(object, function(value, key, object) {
        $35ec8886f0beeeb5$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$ea7837f6b06acb6b$exports = $ea7837f6b06acb6b$var$mapValues;










var $5pP8j = parcelRequire("5pP8j");



var $5pP8j = parcelRequire("5pP8j");



function $0313ad10ec3b9e9b$var$_extends() {
    $0313ad10ec3b9e9b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0313ad10ec3b9e9b$var$_extends.apply(this, arguments);
}
function $0313ad10ec3b9e9b$var$_slicedToArray(arr, i) {
    return $0313ad10ec3b9e9b$var$_arrayWithHoles(arr) || $0313ad10ec3b9e9b$var$_iterableToArrayLimit(arr, i) || $0313ad10ec3b9e9b$var$_unsupportedIterableToArray(arr, i) || $0313ad10ec3b9e9b$var$_nonIterableRest();
}
function $0313ad10ec3b9e9b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0313ad10ec3b9e9b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0313ad10ec3b9e9b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0313ad10ec3b9e9b$var$_arrayLikeToArray(o, minLen);
}
function $0313ad10ec3b9e9b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0313ad10ec3b9e9b$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $0313ad10ec3b9e9b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $0313ad10ec3b9e9b$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $0313ad10ec3b9e9b$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $0313ad10ec3b9e9b$export$4617fb02663045ef = function Rectangle(props) {
    var pathRef = (0, $5pP8j.useRef)();
    var _useState = (0, $5pP8j.useState)(-1), _useState2 = $0313ad10ec3b9e9b$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $5pP8j.useLayoutEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("path", $0313ad10ec3b9e9b$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $0313ad10ec3b9e9b$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $ee2bc8c876b1194a$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $ee2bc8c876b1194a$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("path", $0313ad10ec3b9e9b$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $0313ad10ec3b9e9b$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};
$0313ad10ec3b9e9b$export$4617fb02663045ef.defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};




/**
 * @fileOverview Cross
 */ var $3249132f30d1cfdc$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$3249132f30d1cfdc$export$f6f0c3fe4ec306ea.displayName = 'Cell';








var $3629e45b25eceda8$var$_excluded = [
    "value",
    "background"
];
function $3629e45b25eceda8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3629e45b25eceda8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3629e45b25eceda8$var$_typeof(obj);
}
function $3629e45b25eceda8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3629e45b25eceda8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3629e45b25eceda8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3629e45b25eceda8$var$_extends() {
    $3629e45b25eceda8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3629e45b25eceda8$var$_extends.apply(this, arguments);
}
function $3629e45b25eceda8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3629e45b25eceda8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3629e45b25eceda8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3629e45b25eceda8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3629e45b25eceda8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3629e45b25eceda8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3629e45b25eceda8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3629e45b25eceda8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3629e45b25eceda8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3629e45b25eceda8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3629e45b25eceda8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3629e45b25eceda8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3629e45b25eceda8$var$_setPrototypeOf(subClass, superClass);
}
function $3629e45b25eceda8$var$_setPrototypeOf(o, p) {
    $3629e45b25eceda8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3629e45b25eceda8$var$_setPrototypeOf(o, p);
}
function $3629e45b25eceda8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3629e45b25eceda8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3629e45b25eceda8$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3629e45b25eceda8$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3629e45b25eceda8$var$_possibleConstructorReturn(this, result);
    };
}
function $3629e45b25eceda8$var$_possibleConstructorReturn(self, call) {
    if (call && ($3629e45b25eceda8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3629e45b25eceda8$var$_assertThisInitialized(self);
}
function $3629e45b25eceda8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3629e45b25eceda8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3629e45b25eceda8$var$_getPrototypeOf(o) {
    $3629e45b25eceda8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3629e45b25eceda8$var$_getPrototypeOf(o);
}
function $3629e45b25eceda8$var$_defineProperty(obj, key, value) {
    key = $3629e45b25eceda8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3629e45b25eceda8$var$_toPropertyKey(arg) {
    var key = $3629e45b25eceda8$var$_toPrimitive(arg, "string");
    return $3629e45b25eceda8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3629e45b25eceda8$var$_toPrimitive(input, hint) {
    if ($3629e45b25eceda8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3629e45b25eceda8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3629e45b25eceda8$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    $3629e45b25eceda8$var$_inherits(Bar, _PureComponent);
    var _super = $3629e45b25eceda8$var$_createSuper(Bar);
    function Bar() {
        var _this;
        $3629e45b25eceda8$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $3629e45b25eceda8$var$_defineProperty($3629e45b25eceda8$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $3629e45b25eceda8$var$_defineProperty($3629e45b25eceda8$var$_assertThisInitialized(_this), "id", (0, $e6a593df52d5e247$export$8b15d37bc3f197d4)('recharts-bar-'));
        $3629e45b25eceda8$var$_defineProperty($3629e45b25eceda8$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $3629e45b25eceda8$var$_defineProperty($3629e45b25eceda8$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $3629e45b25eceda8$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var shape = this.props.shape;
                var baseProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props);
                return data && data.map(function(entry, i) {
                    var props = $3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread({}, baseProps), entry), {}, {
                        index: i
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), $3629e45b25eceda8$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $0e1d5f7291a98e27$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key
                    }), Bar.renderRectangle(shape, props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props = this.props, data = _this$props.data, layout = _this$props.layout, isAnimationActive = _this$props.isAnimationActive, animationBegin = _this$props.animationBegin, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, animationId = _this$props.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $ee2bc8c876b1194a$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props2 = this.props, data = _this$props2.data, isAnimationActive = _this$props2.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($a5dab8b3c935330c$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var data = this.props.data;
                var backgroundProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props.background);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $3629e45b25eceda8$var$_objectWithoutProperties(entry, $3629e45b25eceda8$var$_excluded);
                    if (!background) return null;
                    var props = $3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $0e1d5f7291a98e27$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        index: i,
                        key: "background-bar-".concat(i),
                        className: 'recharts-bar-background-rectangle'
                    });
                    return Bar.renderRectangle(_this4.props.background, props);
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props3 = this.props, data = _this$props3.data, xAxis = _this$props3.xAxis, yAxis = _this$props3.yAxis, layout = _this$props3.layout, children = _this$props3.children;
                var errorBarItems = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, (0, $6acdc3c09f8074d5$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(item, {
                        key: "error-bar-".concat(i),
                        // eslint-disable-line react/no-array-index-key
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, hide = _this$props4.hide, data = _this$props4.data, className = _this$props4.className, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, left = _this$props4.left, top = _this$props4.top, width = _this$props4.width, height = _this$props4.height, isAnimationActive = _this$props4.isAnimationActive, background = _this$props4.background, id = _this$props4.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $18e58544181e4986$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        },
        {
            key: "renderRectangle",
            value: function renderRectangle(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) rectangle = option(props);
                else rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $0313ad10ec3b9e9b$export$4617fb02663045ef), props);
                return rectangle;
            }
        }
    ]);
    return Bar;
}((0, $5pP8j.PureComponent));
$3629e45b25eceda8$var$_defineProperty($3629e45b25eceda8$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$3629e45b25eceda8$var$_defineProperty($3629e45b25eceda8$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    // data of bar
    data: [],
    layout: 'vertical',
    isAnimationActive: !(0, $b477b0447f10d549$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $3629e45b25eceda8$var$_defineProperty($3629e45b25eceda8$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $de5fcafa56f48e7f$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSize = _item$props.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $de5fcafa56f48e7f$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, (0, $3249132f30d1cfdc$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $de5fcafa56f48e7f$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(entry, dataKey);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(value)) value = [
                baseValue,
                value
            ];
        }
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $de5fcafa56f48e7f$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $e6a593df52d5e247$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $de5fcafa56f48e7f$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $e6a593df52d5e247$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread($3629e45b25eceda8$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $de5fcafa56f48e7f$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $3629e45b25eceda8$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $6854f7e630297740$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6854f7e630297740$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6854f7e630297740$var$_typeof(obj);
}
function $6854f7e630297740$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6854f7e630297740$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6854f7e630297740$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6854f7e630297740$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6854f7e630297740$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6854f7e630297740$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6854f7e630297740$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6854f7e630297740$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6854f7e630297740$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6854f7e630297740$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6854f7e630297740$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6854f7e630297740$var$_defineProperty(obj, key, value) {
    key = $6854f7e630297740$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6854f7e630297740$var$_toPropertyKey(arg) {
    var key = $6854f7e630297740$var$_toPrimitive(arg, "string");
    return $6854f7e630297740$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6854f7e630297740$var$_toPrimitive(input, hint) {
    if ($6854f7e630297740$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6854f7e630297740$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $6854f7e630297740$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $f43486451a1e41f4$export$64c61536a2b72e0f)(children, (0, $3629e45b25eceda8$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
            if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === 'no-gap') {
                var gap = (0, $e6a593df52d5e247$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $de5fcafa56f48e7f$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $de5fcafa56f48e7f$export$9d80152e23bae434)(scale);
        var ticks = (0, $de5fcafa56f48e7f$export$ac086aaa4358d590)(scale, $6854f7e630297740$var$_objectSpread($6854f7e630297740$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $6854f7e630297740$var$_objectSpread($6854f7e630297740$var$_objectSpread($6854f7e630297740$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $de5fcafa56f48e7f$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $6854f7e630297740$var$_objectSpread($6854f7e630297740$var$_objectSpread({}, result), {}, $6854f7e630297740$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $6854f7e630297740$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $6854f7e630297740$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $6854f7e630297740$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $6854f7e630297740$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $6854f7e630297740$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    $6854f7e630297740$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$6854f7e630297740$var$_defineProperty($6854f7e630297740$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $6854f7e630297740$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $6854f7e630297740$var$_objectSpread($6854f7e630297740$var$_objectSpread({}, res), {}, $6854f7e630297740$var$_defineProperty({}, key, $6854f7e630297740$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $6854f7e630297740$var$_objectSpread($6854f7e630297740$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($ea7837f6b06acb6b$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($3d4edc1cc2097bee$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $6854f7e630297740$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $6854f7e630297740$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $6854f7e630297740$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


function $2605f80636cee3c4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2605f80636cee3c4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2605f80636cee3c4$var$_typeof(obj);
}
function $2605f80636cee3c4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2605f80636cee3c4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2605f80636cee3c4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2605f80636cee3c4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2605f80636cee3c4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2605f80636cee3c4$var$_defineProperty(obj, key, value) {
    key = $2605f80636cee3c4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2605f80636cee3c4$var$_toPropertyKey(arg) {
    var key = $2605f80636cee3c4$var$_toPrimitive(arg, "string");
    return $2605f80636cee3c4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2605f80636cee3c4$var$_toPrimitive(input, hint) {
    if ($2605f80636cee3c4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2605f80636cee3c4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2605f80636cee3c4$export$8d7cd2cadfe08ccd(ticks) {
    var N = 1;
    var previous = (0, $621dbabf8ec7f8f2$export$41514b9f058a6886)(ticks, N, function(tickItem) {
        return tickItem.isShow;
    });
    while(N <= ticks.length){
        if (previous !== undefined) return previous;
        N++;
        previous = (0, $621dbabf8ec7f8f2$export$41514b9f058a6886)(ticks, N, function(tickItem) {
            return tickItem.isShow;
        });
    }
    return ticks.slice(0, 1);
}
function $2605f80636cee3c4$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $621dbabf8ec7f8f2$export$41514b9f058a6886)(ticks, interval + 1);
}
function $2605f80636cee3c4$var$getAngledTickWidth(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $6854f7e630297740$export$3ee78d51cffc2b68)(size, angle);
}
function $2605f80636cee3c4$var$getTicksEnd(_ref) {
    var angle = _ref.angle, ticks = _ref.ticks, tickFormatter = _ref.tickFormatter, viewBox = _ref.viewBox, orientation = _ref.orientation, minTickGap = _ref.minTickGap, unit = _ref.unit, fontSize = _ref.fontSize, letterSpacing = _ref.letterSpacing;
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    // we need add the width of 'unit' only when sizeKey === 'width'
    var unitSize = unit && sizeKey === 'width' ? (0, $009d73de260549c1$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var result = (ticks || []).slice();
    var len = result.length;
    var sign = len >= 2 ? (0, $e6a593df52d5e247$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
    var start, end;
    if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
    } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
    }
    for(var i = len - 1; i >= 0; i--){
        var entry = result[i];
        var content = (0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(tickFormatter) ? tickFormatter(entry.value, len - i - 1) : entry.value;
        // Recharts only supports angles when sizeKey === 'width'
        var size = sizeKey === 'width' ? $2605f80636cee3c4$var$getAngledTickWidth((0, $009d73de260549c1$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $009d73de260549c1$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * size / 2 - end);
            result[i] = entry = $2605f80636cee3c4$var$_objectSpread($2605f80636cee3c4$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $2605f80636cee3c4$var$_objectSpread($2605f80636cee3c4$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
        if (isShow) {
            end = entry.tickCoord - sign * (size / 2 + minTickGap);
            result[i] = $2605f80636cee3c4$var$_objectSpread($2605f80636cee3c4$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    }
    return result;
}
function $2605f80636cee3c4$var$getTicksStart(_ref2, preserveEnd) {
    var angle = _ref2.angle, ticks = _ref2.ticks, tickFormatter = _ref2.tickFormatter, viewBox = _ref2.viewBox, orientation = _ref2.orientation, minTickGap = _ref2.minTickGap, unit = _ref2.unit, fontSize = _ref2.fontSize, letterSpacing = _ref2.letterSpacing;
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var result = (ticks || []).slice();
    // we need add the width of 'unit' only when sizeKey === 'width'
    var unitSize = unit && sizeKey === 'width' ? (0, $009d73de260549c1$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var len = result.length;
    var sign = len >= 2 ? (0, $e6a593df52d5e247$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
    var start, end;
    if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
    } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
    }
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailContent = (0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(tickFormatter) ? tickFormatter(tail.value, len - 1) : tail.value;
        // Recharts only supports angles when sizeKey === 'width'
        var tailSize = sizeKey === 'width' ? $2605f80636cee3c4$var$getAngledTickWidth((0, $009d73de260549c1$export$e5560531f057ad5d)(tailContent, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $009d73de260549c1$export$e5560531f057ad5d)(tailContent, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $2605f80636cee3c4$var$_objectSpread($2605f80636cee3c4$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $2605f80636cee3c4$var$_objectSpread($2605f80636cee3c4$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    for(var i = 0; i < count; i++){
        var entry = result[i];
        var content = (0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value;
        var size = sizeKey === 'width' ? $2605f80636cee3c4$var$getAngledTickWidth((0, $009d73de260549c1$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $009d73de260549c1$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * size / 2 - start);
            result[i] = entry = $2605f80636cee3c4$var$_objectSpread($2605f80636cee3c4$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $2605f80636cee3c4$var$_objectSpread($2605f80636cee3c4$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
        if (isShow) {
            start = entry.tickCoord + sign * (size / 2 + minTickGap);
            result[i] = $2605f80636cee3c4$var$_objectSpread($2605f80636cee3c4$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    }
    return result;
}
function $2605f80636cee3c4$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(interval) || (0, $b477b0447f10d549$export$98f03c5d19621d70).isSsr) return $2605f80636cee3c4$export$beeebbe3ff1b306b(ticks, typeof interval === 'number' && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    if (interval === 'equidistantPreserveStart') {
        candidates = $2605f80636cee3c4$var$getTicksStart({
            angle: angle,
            ticks: ticks,
            tickFormatter: tickFormatter,
            viewBox: viewBox,
            orientation: orientation,
            minTickGap: minTickGap,
            unit: unit,
            fontSize: fontSize,
            letterSpacing: letterSpacing
        });
        return $2605f80636cee3c4$export$8d7cd2cadfe08ccd(candidates);
    }
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $2605f80636cee3c4$var$getTicksStart({
        angle: angle,
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit,
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }, interval === 'preserveStartEnd');
    else candidates = $2605f80636cee3c4$var$getTicksEnd({
        angle: angle,
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit,
        fontSize: fontSize,
        letterSpacing: letterSpacing
    });
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}








var $5pP8j = parcelRequire("5pP8j");






var $5pP8j = parcelRequire("5pP8j");


/**
 * @fileOverview Default Tooltip Content
 */ function $a6b6635a5b5b3529$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a6b6635a5b5b3529$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a6b6635a5b5b3529$var$_typeof(obj);
}
function $a6b6635a5b5b3529$var$_slicedToArray(arr, i) {
    return $a6b6635a5b5b3529$var$_arrayWithHoles(arr) || $a6b6635a5b5b3529$var$_iterableToArrayLimit(arr, i) || $a6b6635a5b5b3529$var$_unsupportedIterableToArray(arr, i) || $a6b6635a5b5b3529$var$_nonIterableRest();
}
function $a6b6635a5b5b3529$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a6b6635a5b5b3529$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a6b6635a5b5b3529$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a6b6635a5b5b3529$var$_arrayLikeToArray(o, minLen);
}
function $a6b6635a5b5b3529$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a6b6635a5b5b3529$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $a6b6635a5b5b3529$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a6b6635a5b5b3529$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a6b6635a5b5b3529$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a6b6635a5b5b3529$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a6b6635a5b5b3529$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a6b6635a5b5b3529$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a6b6635a5b5b3529$var$_defineProperty(obj, key, value) {
    key = $a6b6635a5b5b3529$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a6b6635a5b5b3529$var$_toPropertyKey(arg) {
    var key = $a6b6635a5b5b3529$var$_toPrimitive(arg, "string");
    return $a6b6635a5b5b3529$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a6b6635a5b5b3529$var$_toPrimitive(input, hint) {
    if ($a6b6635a5b5b3529$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a6b6635a5b5b3529$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a6b6635a5b5b3529$var$defaultFormatter(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(value) && (0, $e6a593df52d5e247$export$402a499e1ea44294)(value[0]) && (0, $e6a593df52d5e247$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $a6b6635a5b5b3529$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($08d5ce8e0c21d402$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $a6b6635a5b5b3529$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $a6b6635a5b5b3529$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $a6b6635a5b5b3529$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $e6a593df52d5e247$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $e6a593df52d5e247$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $a6b6635a5b5b3529$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $a6b6635a5b5b3529$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("div", {
        className: wrapperCN,
        style: finalStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};




function $c5e462fb264ac9e5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c5e462fb264ac9e5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c5e462fb264ac9e5$var$_typeof(obj);
}
function $c5e462fb264ac9e5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c5e462fb264ac9e5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c5e462fb264ac9e5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c5e462fb264ac9e5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c5e462fb264ac9e5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c5e462fb264ac9e5$var$_defineProperty(obj, key, value) {
    key = $c5e462fb264ac9e5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c5e462fb264ac9e5$var$_toPropertyKey(arg) {
    var key = $c5e462fb264ac9e5$var$_toPrimitive(arg, "string");
    return $c5e462fb264ac9e5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c5e462fb264ac9e5$var$_toPrimitive(input, hint) {
    if ($c5e462fb264ac9e5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c5e462fb264ac9e5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c5e462fb264ac9e5$var$_slicedToArray(arr, i) {
    return $c5e462fb264ac9e5$var$_arrayWithHoles(arr) || $c5e462fb264ac9e5$var$_iterableToArrayLimit(arr, i) || $c5e462fb264ac9e5$var$_unsupportedIterableToArray(arr, i) || $c5e462fb264ac9e5$var$_nonIterableRest();
}
function $c5e462fb264ac9e5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c5e462fb264ac9e5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c5e462fb264ac9e5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c5e462fb264ac9e5$var$_arrayLikeToArray(o, minLen);
}
function $c5e462fb264ac9e5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c5e462fb264ac9e5$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $c5e462fb264ac9e5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c5e462fb264ac9e5$var$CLS_PREFIX = 'recharts-tooltip-wrapper';
var $c5e462fb264ac9e5$var$EPS = 1;
function $c5e462fb264ac9e5$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $c5e462fb264ac9e5$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($738fb70c14187a7b$exports)))(payload, $c5e462fb264ac9e5$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($738fb70c14187a7b$exports)))(payload, option);
    return payload;
}
function $c5e462fb264ac9e5$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a6b6635a5b5b3529$export$6fe33945eebf9ac8), props);
}
var $c5e462fb264ac9e5$var$tooltipDefaultProps = {
    active: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    reverseDirection: {
        x: false,
        y: false
    },
    offset: 10,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    coordinate: {
        x: 0,
        y: 0
    },
    // this doesn't exist on TooltipProps
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    cursorStyle: {},
    separator: ' : ',
    wrapperStyle: {},
    contentStyle: {},
    itemStyle: {},
    labelStyle: {},
    cursor: true,
    trigger: 'hover',
    isAnimationActive: !(0, $b477b0447f10d549$export$98f03c5d19621d70).isSsr,
    animationEasing: 'ease',
    animationDuration: 400,
    filterNull: true,
    useTranslate3d: false
};
var $c5e462fb264ac9e5$export$28c660c63b792dea = function Tooltip(props) {
    var _classNames;
    var _useState = (0, $5pP8j.useState)(-1), _useState2 = $c5e462fb264ac9e5$var$_slicedToArray(_useState, 2), boxWidth = _useState2[0], setBoxWidth = _useState2[1];
    var _useState3 = (0, $5pP8j.useState)(-1), _useState4 = $c5e462fb264ac9e5$var$_slicedToArray(_useState3, 2), boxHeight = _useState4[0], setBoxHeight = _useState4[1];
    var _useState5 = (0, $5pP8j.useState)(false), _useState6 = $c5e462fb264ac9e5$var$_slicedToArray(_useState5, 2), dismissed = _useState6[0], setDismissed = _useState6[1];
    var _useState7 = (0, $5pP8j.useState)({
        x: 0,
        y: 0
    }), _useState8 = $c5e462fb264ac9e5$var$_slicedToArray(_useState7, 2), dismissedAtCoordinate = _useState8[0], setDismissedAtCoordinate = _useState8[1];
    var wrapperNode = (0, $5pP8j.useRef)();
    var allowEscapeViewBox = props.allowEscapeViewBox, reverseDirection = props.reverseDirection, coordinate = props.coordinate, offset = props.offset, position = props.position, viewBox = props.viewBox;
    var handleKeyDown = (0, $5pP8j.useCallback)(function(event) {
        if (event.key === 'Escape') {
            setDismissed(true);
            setDismissedAtCoordinate(function(prev) {
                return $c5e462fb264ac9e5$var$_objectSpread($c5e462fb264ac9e5$var$_objectSpread({}, prev), {}, {
                    x: coordinate === null || coordinate === void 0 ? void 0 : coordinate.x,
                    y: coordinate === null || coordinate === void 0 ? void 0 : coordinate.y
                });
            });
        }
    }, [
        coordinate === null || coordinate === void 0 ? void 0 : coordinate.x,
        coordinate === null || coordinate === void 0 ? void 0 : coordinate.y
    ]);
    (0, $5pP8j.useEffect)(function() {
        var updateBBox = function updateBBox() {
            if (dismissed) {
                document.removeEventListener('keydown', handleKeyDown);
                if ((coordinate === null || coordinate === void 0 ? void 0 : coordinate.x) !== dismissedAtCoordinate.x || (coordinate === null || coordinate === void 0 ? void 0 : coordinate.y) !== dismissedAtCoordinate.y) setDismissed(false);
            } else document.addEventListener('keydown', handleKeyDown);
            if (wrapperNode.current && wrapperNode.current.getBoundingClientRect) {
                var box = wrapperNode.current.getBoundingClientRect();
                if (Math.abs(box.width - boxWidth) > $c5e462fb264ac9e5$var$EPS || Math.abs(box.height - boxHeight) > $c5e462fb264ac9e5$var$EPS) {
                    setBoxWidth(box.width);
                    setBoxHeight(box.height);
                }
            } else if (boxWidth !== -1 || boxHeight !== -1) {
                setBoxWidth(-1);
                setBoxHeight(-1);
            }
        };
        updateBBox();
        return function() {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        boxHeight,
        boxWidth,
        coordinate,
        dismissed,
        dismissedAtCoordinate.x,
        dismissedAtCoordinate.y,
        handleKeyDown
    ]);
    var getTranslate = function getTranslate(_ref) {
        var key = _ref.key, tooltipDimension = _ref.tooltipDimension, viewBoxDimension = _ref.viewBoxDimension;
        if (position && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(position[key])) return position[key];
        var negative = coordinate[key] - tooltipDimension - offset;
        var positive = coordinate[key] + offset;
        if (allowEscapeViewBox !== null && allowEscapeViewBox !== void 0 && allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
        if (reverseDirection !== null && reverseDirection !== void 0 && reverseDirection[key]) {
            var _tooltipBoundary = negative;
            var _viewBoxBoundary = viewBox[key];
            if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
            return Math.max(negative, viewBox[key]);
        }
        var tooltipBoundary = positive + tooltipDimension;
        var viewBoxBoundary = viewBox[key] + viewBoxDimension;
        if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
        return Math.max(positive, viewBox[key]);
    };
    var payload = props.payload, payloadUniqBy = props.payloadUniqBy, filterNull = props.filterNull, active = props.active, wrapperStyle = props.wrapperStyle, useTranslate3d = props.useTranslate3d, isAnimationActive = props.isAnimationActive, animationDuration = props.animationDuration, animationEasing = props.animationEasing;
    var finalPayload = $c5e462fb264ac9e5$var$getUniqPayload(payloadUniqBy, filterNull && payload && payload.length ? payload.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(entry.value);
    }) : payload);
    var hasPayload = finalPayload && finalPayload.length;
    var content = props.content;
    var outerStyle = $c5e462fb264ac9e5$var$_objectSpread({
        pointerEvents: 'none',
        visibility: !dismissed && active && hasPayload ? 'visible' : 'hidden',
        position: 'absolute',
        top: 0,
        left: 0
    }, wrapperStyle);
    var translateX, translateY;
    if (position && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(position.x) && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(position.y)) {
        translateX = position.x;
        translateY = position.y;
    } else if (boxWidth > 0 && boxHeight > 0 && coordinate) {
        translateX = getTranslate({
            key: 'x',
            tooltipDimension: boxWidth,
            viewBoxDimension: viewBox.width
        });
        translateY = getTranslate({
            key: 'y',
            tooltipDimension: boxHeight,
            viewBoxDimension: viewBox.height
        });
    } else outerStyle.visibility = 'hidden';
    outerStyle = $c5e462fb264ac9e5$var$_objectSpread($c5e462fb264ac9e5$var$_objectSpread({}, (0, $5446dcdb4677b7d9$export$ff9926a5d1daa67c)({
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    })), outerStyle);
    if (isAnimationActive && active) outerStyle = $c5e462fb264ac9e5$var$_objectSpread($c5e462fb264ac9e5$var$_objectSpread({}, (0, $5446dcdb4677b7d9$export$ff9926a5d1daa67c)({
        transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
    })), outerStyle);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))($c5e462fb264ac9e5$var$CLS_PREFIX, (_classNames = {}, $c5e462fb264ac9e5$var$_defineProperty(_classNames, "".concat($c5e462fb264ac9e5$var$CLS_PREFIX, "-right"), (0, $e6a593df52d5e247$export$7e4aa119212bc614)(translateX) && coordinate && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), $c5e462fb264ac9e5$var$_defineProperty(_classNames, "".concat($c5e462fb264ac9e5$var$CLS_PREFIX, "-left"), (0, $e6a593df52d5e247$export$7e4aa119212bc614)(translateX) && coordinate && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), $c5e462fb264ac9e5$var$_defineProperty(_classNames, "".concat($c5e462fb264ac9e5$var$CLS_PREFIX, "-bottom"), (0, $e6a593df52d5e247$export$7e4aa119212bc614)(translateY) && coordinate && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), $c5e462fb264ac9e5$var$_defineProperty(_classNames, "".concat($c5e462fb264ac9e5$var$CLS_PREFIX, "-top"), (0, $e6a593df52d5e247$export$7e4aa119212bc614)(translateY) && coordinate && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y), _classNames));
    return(/*#__PURE__*/ // ESLint is disabled to allow listening to the `Escape` key. Refer to
    // https://github.com/recharts/recharts/pull/2925
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("div", {
        tabIndex: -1,
        role: "dialog",
        className: cls,
        style: outerStyle,
        ref: wrapperNode
    }, $c5e462fb264ac9e5$var$renderContent(content, $c5e462fb264ac9e5$var$_objectSpread($c5e462fb264ac9e5$var$_objectSpread({}, props), {}, {
        payload: finalPayload
    }))));
};
// needs to be set so that renderByOrder can find the correct handler function
$c5e462fb264ac9e5$export$28c660c63b792dea.displayName = 'Tooltip';
/**
 * needs to be set so that renderByOrder can access an have default values for
 * children.props when there are no props set by the consumer
 * doesn't work if using default parameters
 */ $c5e462fb264ac9e5$export$28c660c63b792dea.defaultProps = $c5e462fb264ac9e5$var$tooltipDefaultProps;





var $5pP8j = parcelRequire("5pP8j");



function $e46bd84c753d945f$var$_extends() {
    $e46bd84c753d945f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e46bd84c753d945f$var$_extends.apply(this, arguments);
}
var $e46bd84c753d945f$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $e46bd84c753d945f$export$3c877bb842c36952 = function Cross(props) {
    var x = props.x, y = props.y, width = props.width, height = props.height, top = props.top, left = props.left, className = props.className;
    if (!(0, $e6a593df52d5e247$export$7e4aa119212bc614)(x) || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(y) || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(width) || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(height) || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(top) || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("path", $e46bd84c753d945f$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props, true), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-cross', className),
        d: $e46bd84c753d945f$var$getPath(x, y, width, height, top, left)
    }));
};
$e46bd84c753d945f$export$3c877bb842c36952.defaultProps = {
    x: 0,
    y: 0,
    top: 0,
    left: 0,
    width: 0,
    height: 0
};



var $5pP8j = parcelRequire("5pP8j");




function $73ad33dbab9fd7d1$var$_extends() {
    $73ad33dbab9fd7d1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $73ad33dbab9fd7d1$var$_extends.apply(this, arguments);
}
var $73ad33dbab9fd7d1$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $e6a593df52d5e247$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $73ad33dbab9fd7d1$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $0c9962d1b1acbd9a$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $0c9962d1b1acbd9a$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $73ad33dbab9fd7d1$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $73ad33dbab9fd7d1$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $73ad33dbab9fd7d1$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $e6a593df52d5e247$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $73ad33dbab9fd7d1$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $73ad33dbab9fd7d1$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $73ad33dbab9fd7d1$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $73ad33dbab9fd7d1$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $73ad33dbab9fd7d1$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $73ad33dbab9fd7d1$export$e98c2c7eb2b14f45 = function Sector(props) {
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $e6a593df52d5e247$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $73ad33dbab9fd7d1$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $73ad33dbab9fd7d1$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("path", $73ad33dbab9fd7d1$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};
$73ad33dbab9fd7d1$export$e98c2c7eb2b14f45.defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};








var $5pP8j = parcelRequire("5pP8j");









var $580ac068e92093ad$var$_excluded = [
    "viewBox"
], $580ac068e92093ad$var$_excluded2 = [
    "viewBox"
], $580ac068e92093ad$var$_excluded3 = [
    "ticks"
];
function $580ac068e92093ad$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $580ac068e92093ad$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $580ac068e92093ad$var$_typeof(obj);
}
function $580ac068e92093ad$var$_extends() {
    $580ac068e92093ad$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $580ac068e92093ad$var$_extends.apply(this, arguments);
}
function $580ac068e92093ad$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $580ac068e92093ad$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $580ac068e92093ad$var$ownKeys(Object(source), !0).forEach(function(key) {
            $580ac068e92093ad$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $580ac068e92093ad$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $580ac068e92093ad$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $580ac068e92093ad$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $580ac068e92093ad$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $580ac068e92093ad$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $580ac068e92093ad$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $580ac068e92093ad$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $580ac068e92093ad$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $580ac068e92093ad$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $580ac068e92093ad$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $580ac068e92093ad$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $580ac068e92093ad$var$_setPrototypeOf(subClass, superClass);
}
function $580ac068e92093ad$var$_setPrototypeOf(o, p) {
    $580ac068e92093ad$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $580ac068e92093ad$var$_setPrototypeOf(o, p);
}
function $580ac068e92093ad$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $580ac068e92093ad$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $580ac068e92093ad$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $580ac068e92093ad$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $580ac068e92093ad$var$_possibleConstructorReturn(this, result);
    };
}
function $580ac068e92093ad$var$_possibleConstructorReturn(self, call) {
    if (call && ($580ac068e92093ad$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $580ac068e92093ad$var$_assertThisInitialized(self);
}
function $580ac068e92093ad$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $580ac068e92093ad$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $580ac068e92093ad$var$_getPrototypeOf(o) {
    $580ac068e92093ad$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $580ac068e92093ad$var$_getPrototypeOf(o);
}
function $580ac068e92093ad$var$_defineProperty(obj, key, value) {
    key = $580ac068e92093ad$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $580ac068e92093ad$var$_toPropertyKey(arg) {
    var key = $580ac068e92093ad$var$_toPrimitive(arg, "string");
    return $580ac068e92093ad$var$_typeof(key) === "symbol" ? key : String(key);
}
function $580ac068e92093ad$var$_toPrimitive(input, hint) {
    if ($580ac068e92093ad$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($580ac068e92093ad$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $580ac068e92093ad$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $580ac068e92093ad$var$_inherits(CartesianAxis, _Component);
    var _super = $580ac068e92093ad$var$_createSuper(CartesianAxis);
    function CartesianAxis(props) {
        var _this;
        $580ac068e92093ad$var$_classCallCheck(this, CartesianAxis);
        _this = _super.call(this, props);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $580ac068e92093ad$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $580ac068e92093ad$var$_objectWithoutProperties(_ref, $580ac068e92093ad$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $580ac068e92093ad$var$_objectWithoutProperties(_this$props, $580ac068e92093ad$var$_excluded2);
                return !(0, $208f2e6420654b95$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $208f2e6420654b95$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $208f2e6420654b95$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $e6a593df52d5e247$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $580ac068e92093ad$var$_objectSpread($580ac068e92093ad$var$_objectSpread($580ac068e92093ad$var$_objectSpread({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props)), (0, $f43486451a1e41f4$export$d697c39a2985a4c)(axisLine)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $580ac068e92093ad$var$_objectSpread($580ac068e92093ad$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $580ac068e92093ad$var$_objectSpread($580ac068e92093ad$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("line", $580ac068e92093ad$var$_extends({}, props, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $2605f80636cee3c4$export$3d27d42b1034de5c)($580ac068e92093ad$var$_objectSpread($580ac068e92093ad$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props);
                var customTickProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(tick);
                var tickLineProps = $580ac068e92093ad$var$_objectSpread($580ac068e92093ad$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(tickLine));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $580ac068e92093ad$var$_objectSpread($580ac068e92093ad$var$_objectSpread($580ac068e92093ad$var$_objectSpread($580ac068e92093ad$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), $580ac068e92093ad$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $0e1d5f7291a98e27$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("line", $580ac068e92093ad$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $580ac068e92093ad$var$_objectWithoutProperties(_this$props8, $580ac068e92093ad$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $cd5c1f753edd459d$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $9356d3eb5e25660c$export$5f1af8db9871e1d6), $580ac068e92093ad$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $5pP8j.Component));
$580ac068e92093ad$var$_defineProperty($580ac068e92093ad$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$580ac068e92093ad$var$_defineProperty($580ac068e92093ad$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});





var $5pP8j = parcelRequire("5pP8j");






function $3b9c1939d4e614b7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3b9c1939d4e614b7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3b9c1939d4e614b7$var$_typeof(obj);
}
function $3b9c1939d4e614b7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3b9c1939d4e614b7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3b9c1939d4e614b7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3b9c1939d4e614b7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3b9c1939d4e614b7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3b9c1939d4e614b7$var$_defineProperty(obj, key, value) {
    key = $3b9c1939d4e614b7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3b9c1939d4e614b7$var$_toPropertyKey(arg) {
    var key = $3b9c1939d4e614b7$var$_toPrimitive(arg, "string");
    return $3b9c1939d4e614b7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3b9c1939d4e614b7$var$_toPrimitive(input, hint) {
    if ($3b9c1939d4e614b7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3b9c1939d4e614b7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3b9c1939d4e614b7$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $3b9c1939d4e614b7$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $3b9c1939d4e614b7$var$PREFIX_LIST.reduce(function(res, entry) {
        return $3b9c1939d4e614b7$var$_objectSpread($3b9c1939d4e614b7$var$_objectSpread({}, res), {}, $3b9c1939d4e614b7$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $dff7be68fd51578d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $dff7be68fd51578d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dff7be68fd51578d$var$_typeof(obj);
}
function $dff7be68fd51578d$var$_extends() {
    $dff7be68fd51578d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dff7be68fd51578d$var$_extends.apply(this, arguments);
}
function $dff7be68fd51578d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dff7be68fd51578d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $dff7be68fd51578d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $dff7be68fd51578d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $dff7be68fd51578d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dff7be68fd51578d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dff7be68fd51578d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $dff7be68fd51578d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $dff7be68fd51578d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dff7be68fd51578d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dff7be68fd51578d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $dff7be68fd51578d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $dff7be68fd51578d$var$_setPrototypeOf(subClass, superClass);
}
function $dff7be68fd51578d$var$_setPrototypeOf(o, p) {
    $dff7be68fd51578d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dff7be68fd51578d$var$_setPrototypeOf(o, p);
}
function $dff7be68fd51578d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dff7be68fd51578d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $dff7be68fd51578d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $dff7be68fd51578d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $dff7be68fd51578d$var$_possibleConstructorReturn(this, result);
    };
}
function $dff7be68fd51578d$var$_possibleConstructorReturn(self, call) {
    if (call && ($dff7be68fd51578d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $dff7be68fd51578d$var$_assertThisInitialized(self);
}
function $dff7be68fd51578d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $dff7be68fd51578d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dff7be68fd51578d$var$_getPrototypeOf(o) {
    $dff7be68fd51578d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dff7be68fd51578d$var$_getPrototypeOf(o);
}
function $dff7be68fd51578d$var$_defineProperty(obj, key, value) {
    key = $dff7be68fd51578d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dff7be68fd51578d$var$_toPropertyKey(arg) {
    var key = $dff7be68fd51578d$var$_toPrimitive(arg, "string");
    return $dff7be68fd51578d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $dff7be68fd51578d$var$_toPrimitive(input, hint) {
    if ($dff7be68fd51578d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($dff7be68fd51578d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $dff7be68fd51578d$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $51dab9abc55fde57$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($803301859424e115$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $dff7be68fd51578d$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $dff7be68fd51578d$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $dff7be68fd51578d$var$_inherits(Brush, _PureComponent);
    var _super = $dff7be68fd51578d$var$_createSuper(Brush);
    function Brush(props) {
        var _this;
        $dff7be68fd51578d$var$_classCallCheck(this, Brush);
        _this = _super.call(this, props);
        $dff7be68fd51578d$var$_defineProperty($dff7be68fd51578d$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $dff7be68fd51578d$var$_defineProperty($dff7be68fd51578d$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $dff7be68fd51578d$var$_defineProperty($dff7be68fd51578d$var$_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            });
            _this.detachDragEndListener();
        });
        $dff7be68fd51578d$var$_defineProperty($dff7be68fd51578d$var$_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $dff7be68fd51578d$var$_defineProperty($dff7be68fd51578d$var$_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $dff7be68fd51578d$var$_defineProperty($dff7be68fd51578d$var$_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $dff7be68fd51578d$var$_defineProperty($dff7be68fd51578d$var$_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = $dff7be68fd51578d$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($dff7be68fd51578d$var$_assertThisInitialized(_this), 'startX'),
            endX: _this.handleTravellerDragStart.bind($dff7be68fd51578d$var$_assertThisInitialized(_this), 'endX')
        };
        _this.state = {};
        return _this;
    }
    $dff7be68fd51578d$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props = this.props, gap = _this$props.gap, data = _this$props.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props2 = this.props, data = _this$props2.data, tickFormatter = _this$props2.tickFormatter, dataKey = _this$props2.dataKey;
                var text = (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props3 = this.props, x = _this$props3.x, width = _this$props3.width, travellerWidth = _this$props3.travellerWidth, startIndex = _this$props3.startIndex, endIndex = _this$props3.endIndex, onChange = _this$props3.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $dff7be68fd51578d$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, onChange = _this$props4.onChange, gap = _this$props4.gap, data = _this$props4.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, $dff7be68fd51578d$var$_defineProperty(_this$setState, movingTravellerId, prevValue + delta), $dff7be68fd51578d$var$_defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, fill = _this$props5.fill, stroke = _this$props5.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, data = _this$props6.data, children = _this$props6.children, padding = _this$props6.padding;
                var chartElement = (0, $5pP8j.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this$props7 = this.props, y = _this$props7.y, travellerWidth = _this$props7.travellerWidth, height = _this$props7.height, traveller = _this$props7.traveller;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $dff7be68fd51578d$var$_objectSpread($dff7be68fd51578d$var$_objectSpread({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props8 = this.props, y = _this$props8.y, height = _this$props8.height, stroke = _this$props8.stroke, travellerWidth = _this$props8.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props9 = this.props, startIndex = _this$props9.startIndex, endIndex = _this$props9.endIndex, y = _this$props9.y, height = _this$props9.height, travellerWidth = _this$props9.travellerWidth, stroke = _this$props9.stroke;
                var _this$state3 = this.state, startX = _this$state3.startX, endX = _this$state3.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $9356d3eb5e25660c$export$5f1af8db9871e1d6), $dff7be68fd51578d$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $9356d3eb5e25660c$export$5f1af8db9871e1d6), $dff7be68fd51578d$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props10 = this.props, data = _this$props10.data, className = _this$props10.className, children = _this$props10.children, x = _this$props10.x, y = _this$props10.y, width = _this$props10.width, height = _this$props10.height, alwaysShowText = _this$props10.alwaysShowText;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX, isTextActive = _this$state4.isTextActive, isSlideMoving = _this$state4.isSlideMoving, isTravellerMoving = _this$state4.isTravellerMoving;
                if (!data || !data.length || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(x) || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(y) || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(width) || !(0, $e6a593df52d5e247$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).Children.count(children) === 1;
                var style = (0, $3b9c1939d4e614b7$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $dff7be68fd51578d$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $dff7be68fd51578d$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(range, x) {
                var len = range.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (range[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= range[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $5pP8j.PureComponent));
$dff7be68fd51578d$var$_defineProperty($dff7be68fd51578d$export$59bc2e3533b384a0, "displayName", 'Brush');
$dff7be68fd51578d$var$_defineProperty($dff7be68fd51578d$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});







var $5pP8j = parcelRequire("5pP8j");





var $d3540ee1ada08492$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};



/* eslint no-console: 0 */ var $026af532d502bce7$var$isDev = false;
var $026af532d502bce7$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($026af532d502bce7$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



function $e8508a4063aa8bc5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e8508a4063aa8bc5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e8508a4063aa8bc5$var$_typeof(obj);
}
function $e8508a4063aa8bc5$var$_extends() {
    $e8508a4063aa8bc5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8508a4063aa8bc5$var$_extends.apply(this, arguments);
}
function $e8508a4063aa8bc5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e8508a4063aa8bc5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e8508a4063aa8bc5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e8508a4063aa8bc5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e8508a4063aa8bc5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e8508a4063aa8bc5$var$_defineProperty(obj, key, value) {
    key = $e8508a4063aa8bc5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e8508a4063aa8bc5$var$_toPropertyKey(arg) {
    var key = $e8508a4063aa8bc5$var$_toPrimitive(arg, "string");
    return $e8508a4063aa8bc5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e8508a4063aa8bc5$var$_toPrimitive(input, hint) {
    if ($e8508a4063aa8bc5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e8508a4063aa8bc5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $e8508a4063aa8bc5$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $6854f7e630297740$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $d3540ee1ada08492$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
function $e8508a4063aa8bc5$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $e6a593df52d5e247$export$402a499e1ea44294)(x);
    var isY = (0, $e6a593df52d5e247$export$402a499e1ea44294)(y);
    (0, $026af532d502bce7$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $e8508a4063aa8bc5$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $d3540ee1ada08492$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $e8508a4063aa8bc5$var$_objectSpread($e8508a4063aa8bc5$var$_objectSpread({
        clipPath: clipPath
    }, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-reference-dot', className)
    }, $e8508a4063aa8bc5$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $cd5c1f753edd459d$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$e8508a4063aa8bc5$export$aa7f0b0106bff39.displayName = 'ReferenceDot';
$e8508a4063aa8bc5$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
};
$e8508a4063aa8bc5$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $bb16faa3019e11e8$export$d046b3c4a416f60d), $e8508a4063aa8bc5$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};


var $25930f85d049a3b3$exports = {};


var $46579a2f162169e2$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $46579a2f162169e2$var$baseSome(collection, predicate) {
    var result;
    $81fbac4887fc9905$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$46579a2f162169e2$exports = $46579a2f162169e2$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $25930f85d049a3b3$var$some(collection, predicate, guard) {
    var func = $02148300ecce42f1$exports(collection) ? $9cd3582e4cfd7a82$exports : $46579a2f162169e2$exports;
    if (guard && $ce13c7d955cccc00$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $57b9695ad40eb80b$exports(predicate, 3));
}
$25930f85d049a3b3$exports = $25930f85d049a3b3$var$some;




var $5pP8j = parcelRequire("5pP8j");








function $8fcf83dc2a93007f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8fcf83dc2a93007f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8fcf83dc2a93007f$var$_typeof(obj);
}
function $8fcf83dc2a93007f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8fcf83dc2a93007f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8fcf83dc2a93007f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8fcf83dc2a93007f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8fcf83dc2a93007f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8fcf83dc2a93007f$var$_defineProperty(obj, key, value) {
    key = $8fcf83dc2a93007f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8fcf83dc2a93007f$var$_toPropertyKey(arg) {
    var key = $8fcf83dc2a93007f$var$_toPrimitive(arg, "string");
    return $8fcf83dc2a93007f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8fcf83dc2a93007f$var$_toPrimitive(input, hint) {
    if ($8fcf83dc2a93007f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8fcf83dc2a93007f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8fcf83dc2a93007f$var$_slicedToArray(arr, i) {
    return $8fcf83dc2a93007f$var$_arrayWithHoles(arr) || $8fcf83dc2a93007f$var$_iterableToArrayLimit(arr, i) || $8fcf83dc2a93007f$var$_unsupportedIterableToArray(arr, i) || $8fcf83dc2a93007f$var$_nonIterableRest();
}
function $8fcf83dc2a93007f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8fcf83dc2a93007f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8fcf83dc2a93007f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8fcf83dc2a93007f$var$_arrayLikeToArray(o, minLen);
}
function $8fcf83dc2a93007f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8fcf83dc2a93007f$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $8fcf83dc2a93007f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8fcf83dc2a93007f$var$_extends() {
    $8fcf83dc2a93007f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8fcf83dc2a93007f$var$_extends.apply(this, arguments);
}
var $8fcf83dc2a93007f$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("line", $8fcf83dc2a93007f$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
// TODO: ScaleHelper
var $8fcf83dc2a93007f$var$getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
    var _props$viewBox = props.viewBox, x = _props$viewBox.x, y = _props$viewBox.y, width = _props$viewBox.width, height = _props$viewBox.height, position = props.position;
    if (isFixedY) {
        var yCoord = props.y, orientation = props.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $d3540ee1ada08492$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return orientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x, _orientation = props.xAxis.orientation;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $d3540ee1ada08492$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return _orientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $d3540ee1ada08492$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($25930f85d049a3b3$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $8fcf83dc2a93007f$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxis = props.xAxis, yAxis = props.yAxis, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $026af532d502bce7$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $6854f7e630297740$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $e6a593df52d5e247$export$402a499e1ea44294)(fixedX);
    var isY = (0, $e6a593df52d5e247$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $8fcf83dc2a93007f$var$getEndPoints(scales, isX, isY, isSegment, props);
    if (!endPoints) return null;
    var _endPoints = $8fcf83dc2a93007f$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $d3540ee1ada08492$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $8fcf83dc2a93007f$var$_objectSpread($8fcf83dc2a93007f$var$_objectSpread({
        clipPath: clipPath
    }, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-reference-line', className)
    }, $8fcf83dc2a93007f$var$renderLine(shape, lineProps), (0, $cd5c1f753edd459d$export$b04be29aa201d4f5).renderCallByParent(props, (0, $6854f7e630297740$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$8fcf83dc2a93007f$export$b2f28e248e7838eb.displayName = 'ReferenceLine';
$8fcf83dc2a93007f$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
};




var $5pP8j = parcelRequire("5pP8j");









function $dd11ceff634a1616$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $dd11ceff634a1616$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dd11ceff634a1616$var$_typeof(obj);
}
function $dd11ceff634a1616$var$_extends() {
    $dd11ceff634a1616$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd11ceff634a1616$var$_extends.apply(this, arguments);
}
function $dd11ceff634a1616$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dd11ceff634a1616$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $dd11ceff634a1616$var$ownKeys(Object(source), !0).forEach(function(key) {
            $dd11ceff634a1616$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $dd11ceff634a1616$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dd11ceff634a1616$var$_defineProperty(obj, key, value) {
    key = $dd11ceff634a1616$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dd11ceff634a1616$var$_toPropertyKey(arg) {
    var key = $dd11ceff634a1616$var$_toPrimitive(arg, "string");
    return $dd11ceff634a1616$var$_typeof(key) === "symbol" ? key : String(key);
}
function $dd11ceff634a1616$var$_toPrimitive(input, hint) {
    if ($dd11ceff634a1616$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($dd11ceff634a1616$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $dd11ceff634a1616$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $6854f7e630297740$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $d3540ee1ada08492$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $6854f7e630297740$export$c7964a5b9439ae62)(p1, p2);
};
function $dd11ceff634a1616$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $026af532d502bce7$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $e6a593df52d5e247$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $e6a593df52d5e247$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $e6a593df52d5e247$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $e6a593df52d5e247$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $dd11ceff634a1616$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $d3540ee1ada08492$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-reference-area', className)
    }, $dd11ceff634a1616$export$b4ec4f050ce240b9.renderRect(shape, $dd11ceff634a1616$var$_objectSpread($dd11ceff634a1616$var$_objectSpread({
        clipPath: clipPath
    }, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(props, true)), rect)), (0, $cd5c1f753edd459d$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$dd11ceff634a1616$export$b4ec4f050ce240b9.displayName = 'ReferenceArea';
$dd11ceff634a1616$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
};
$dd11ceff634a1616$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $0313ad10ec3b9e9b$export$4617fb02663045ef), $dd11ceff634a1616$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





function $4506e8bdc0caf667$var$_toConsumableArray(arr) {
    return $4506e8bdc0caf667$var$_arrayWithoutHoles(arr) || $4506e8bdc0caf667$var$_iterableToArray(arr) || $4506e8bdc0caf667$var$_unsupportedIterableToArray(arr) || $4506e8bdc0caf667$var$_nonIterableSpread();
}
function $4506e8bdc0caf667$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4506e8bdc0caf667$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4506e8bdc0caf667$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4506e8bdc0caf667$var$_arrayLikeToArray(o, minLen);
}
function $4506e8bdc0caf667$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4506e8bdc0caf667$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4506e8bdc0caf667$var$_arrayLikeToArray(arr);
}
function $4506e8bdc0caf667$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $4506e8bdc0caf667$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, (0, $8fcf83dc2a93007f$export$b2f28e248e7838eb));
    var dots = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, (0, $e8508a4063aa8bc5$export$aa7f0b0106bff39));
    var elements = [].concat($4506e8bdc0caf667$var$_toConsumableArray(lines), $4506e8bdc0caf667$var$_toConsumableArray(dots));
    var areas = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, (0, $dd11ceff634a1616$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $d3540ee1ada08492$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $d3540ee1ada08492$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(el.props[key1]) && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $890f206d66ccb7fe$exports = {};
'use strict';
var $890f206d66ccb7fe$var$has = Object.prototype.hasOwnProperty, $890f206d66ccb7fe$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $890f206d66ccb7fe$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $890f206d66ccb7fe$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $890f206d66ccb7fe$var$Events().__proto__) $890f206d66ccb7fe$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $890f206d66ccb7fe$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $890f206d66ccb7fe$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $890f206d66ccb7fe$var$EE(fn, context || emitter, once), evt = $890f206d66ccb7fe$var$prefix ? $890f206d66ccb7fe$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $890f206d66ccb7fe$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $890f206d66ccb7fe$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $890f206d66ccb7fe$var$EventEmitter() {
    this._events = new $890f206d66ccb7fe$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $890f206d66ccb7fe$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($890f206d66ccb7fe$var$has.call(events, name)) names.push($890f206d66ccb7fe$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $890f206d66ccb7fe$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $890f206d66ccb7fe$var$prefix ? $890f206d66ccb7fe$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $890f206d66ccb7fe$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $890f206d66ccb7fe$var$prefix ? $890f206d66ccb7fe$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $890f206d66ccb7fe$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $890f206d66ccb7fe$var$prefix ? $890f206d66ccb7fe$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $890f206d66ccb7fe$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $890f206d66ccb7fe$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $890f206d66ccb7fe$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $890f206d66ccb7fe$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $890f206d66ccb7fe$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $890f206d66ccb7fe$var$prefix ? $890f206d66ccb7fe$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $890f206d66ccb7fe$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $890f206d66ccb7fe$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $890f206d66ccb7fe$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $890f206d66ccb7fe$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $890f206d66ccb7fe$var$prefix ? $890f206d66ccb7fe$var$prefix + event : event;
        if (this._events[evt]) $890f206d66ccb7fe$var$clearEvent(this, evt);
    } else {
        this._events = new $890f206d66ccb7fe$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$890f206d66ccb7fe$var$EventEmitter.prototype.off = $890f206d66ccb7fe$var$EventEmitter.prototype.removeListener;
$890f206d66ccb7fe$var$EventEmitter.prototype.addListener = $890f206d66ccb7fe$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$890f206d66ccb7fe$var$EventEmitter.prefixed = $890f206d66ccb7fe$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$890f206d66ccb7fe$var$EventEmitter.EventEmitter = $890f206d66ccb7fe$var$EventEmitter;
$890f206d66ccb7fe$exports = $890f206d66ccb7fe$var$EventEmitter;


var $1d768fe0c9a21d68$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($890f206d66ccb7fe$exports)))();
if ($1d768fe0c9a21d68$export$9bcdfe5f29bb33.setMaxListeners) $1d768fe0c9a21d68$export$9bcdfe5f29bb33.setMaxListeners(10);
var $1d768fe0c9a21d68$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $470af37f6b8ba77d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $470af37f6b8ba77d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $470af37f6b8ba77d$var$_typeof(obj);
}
function $470af37f6b8ba77d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $470af37f6b8ba77d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $470af37f6b8ba77d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $470af37f6b8ba77d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $470af37f6b8ba77d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $470af37f6b8ba77d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $470af37f6b8ba77d$var$_defineProperty(obj, key, value) {
    key = $470af37f6b8ba77d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $470af37f6b8ba77d$var$_toPropertyKey(arg) {
    var key = $470af37f6b8ba77d$var$_toPrimitive(arg, "string");
    return $470af37f6b8ba77d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $470af37f6b8ba77d$var$_toPrimitive(input, hint) {
    if ($470af37f6b8ba77d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($470af37f6b8ba77d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $470af37f6b8ba77d$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $470af37f6b8ba77d$var$_classCallCheck(this, AccessibilityManager);
        $470af37f6b8ba77d$var$_defineProperty(this, "activeIndex", 0);
        $470af37f6b8ba77d$var$_defineProperty(this, "coordinateList", []);
        $470af37f6b8ba77d$var$_defineProperty(this, "layout", 'horizontal');
    }
    $470af37f6b8ba77d$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? [] : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList;
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var pageX = x + coordinate;
                var pageY = y + this.offset.top;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();


var $297828d4c9eb7748$var$_excluded = [
    "item"
], $297828d4c9eb7748$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $297828d4c9eb7748$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $297828d4c9eb7748$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $297828d4c9eb7748$var$_typeof(obj);
}
function $297828d4c9eb7748$var$_slicedToArray(arr, i) {
    return $297828d4c9eb7748$var$_arrayWithHoles(arr) || $297828d4c9eb7748$var$_iterableToArrayLimit(arr, i) || $297828d4c9eb7748$var$_unsupportedIterableToArray(arr, i) || $297828d4c9eb7748$var$_nonIterableRest();
}
function $297828d4c9eb7748$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $297828d4c9eb7748$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $297828d4c9eb7748$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $297828d4c9eb7748$var$_extends() {
    $297828d4c9eb7748$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $297828d4c9eb7748$var$_extends.apply(this, arguments);
}
function $297828d4c9eb7748$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $297828d4c9eb7748$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $297828d4c9eb7748$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $297828d4c9eb7748$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $297828d4c9eb7748$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $297828d4c9eb7748$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $297828d4c9eb7748$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $297828d4c9eb7748$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $297828d4c9eb7748$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $297828d4c9eb7748$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $297828d4c9eb7748$var$_setPrototypeOf(subClass, superClass);
}
function $297828d4c9eb7748$var$_setPrototypeOf(o, p) {
    $297828d4c9eb7748$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $297828d4c9eb7748$var$_setPrototypeOf(o, p);
}
function $297828d4c9eb7748$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $297828d4c9eb7748$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $297828d4c9eb7748$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $297828d4c9eb7748$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $297828d4c9eb7748$var$_possibleConstructorReturn(this, result);
    };
}
function $297828d4c9eb7748$var$_possibleConstructorReturn(self, call) {
    if (call && ($297828d4c9eb7748$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $297828d4c9eb7748$var$_assertThisInitialized(self);
}
function $297828d4c9eb7748$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $297828d4c9eb7748$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $297828d4c9eb7748$var$_getPrototypeOf(o) {
    $297828d4c9eb7748$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $297828d4c9eb7748$var$_getPrototypeOf(o);
}
function $297828d4c9eb7748$var$_toConsumableArray(arr) {
    return $297828d4c9eb7748$var$_arrayWithoutHoles(arr) || $297828d4c9eb7748$var$_iterableToArray(arr) || $297828d4c9eb7748$var$_unsupportedIterableToArray(arr) || $297828d4c9eb7748$var$_nonIterableSpread();
}
function $297828d4c9eb7748$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $297828d4c9eb7748$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $297828d4c9eb7748$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $297828d4c9eb7748$var$_arrayLikeToArray(o, minLen);
}
function $297828d4c9eb7748$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $297828d4c9eb7748$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $297828d4c9eb7748$var$_arrayLikeToArray(arr);
}
function $297828d4c9eb7748$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $297828d4c9eb7748$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $297828d4c9eb7748$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $297828d4c9eb7748$var$ownKeys(Object(source), !0).forEach(function(key) {
            $297828d4c9eb7748$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $297828d4c9eb7748$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $297828d4c9eb7748$var$_defineProperty(obj, key, value) {
    key = $297828d4c9eb7748$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $297828d4c9eb7748$var$_toPropertyKey(arg) {
    var key = $297828d4c9eb7748$var$_toPrimitive(arg, "string");
    return $297828d4c9eb7748$var$_typeof(key) === "symbol" ? key : String(key);
}
function $297828d4c9eb7748$var$_toPrimitive(input, hint) {
    if ($297828d4c9eb7748$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($297828d4c9eb7748$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $297828d4c9eb7748$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $297828d4c9eb7748$var$originCoordinate = {
    x: 0,
    y: 0
};
// use legacy isFinite only if there is a problem (aka IE)
// eslint-disable-next-line no-restricted-globals
var $297828d4c9eb7748$var$isFinit = Number.isFinite ? Number.isFinite : isFinite;
var $297828d4c9eb7748$var$defer = // eslint-disable-next-line no-nested-ternary
typeof requestAnimationFrame === 'function' ? requestAnimationFrame : typeof setImmediate === 'function' ? setImmediate : setTimeout;
var $297828d4c9eb7748$var$deferClear = // eslint-disable-next-line no-nested-ternary
typeof cancelAnimationFrame === 'function' ? cancelAnimationFrame : typeof clearImmediate === 'function' ? clearImmediate : clearTimeout;
var $297828d4c9eb7748$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $297828d4c9eb7748$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, rangeObj), (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, rangeObj), (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $297828d4c9eb7748$var$originCoordinate;
};
var $297828d4c9eb7748$var$getDisplayedData = function getDisplayedData(data, _ref, item) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems || []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($297828d4c9eb7748$var$_toConsumableArray(result), $297828d4c9eb7748$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData && itemsData.length > 0) return itemsData;
    if (item && item.props && item.props.data && item.props.data.length > 0) return item.props.data;
    if (data && data.length && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(dataStartIndex) && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
/**
 * Takes a domain and user props to determine whether he provided the domain via props or if we need to calculate it.
 * @param   {AxisDomain}  domain              The potential domain from props
 * @param   {Boolean}     allowDataOverflow   from props
 * @param   {String}      axisType            from props
 * @returns {Boolean}                         `true` if domain is specified by user
 */ function $297828d4c9eb7748$var$isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(domainStart) && (0, $e6a593df52d5e247$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}
function $297828d4c9eb7748$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $297828d4c9eb7748$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $297828d4c9eb7748$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var hide = child.props.hide;
        if (hide) return result;
        var data = child.props.data;
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $e6a593df52d5e247$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($297828d4c9eb7748$var$_toConsumableArray(result), [
            (0, $de5fcafa56f48e7f$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $297828d4c9eb7748$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $297828d4c9eb7748$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $de5fcafa56f48e7f$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $297828d4c9eb7748$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $297828d4c9eb7748$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $297828d4c9eb7748$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $de5fcafa56f48e7f$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    var axisMap = axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $297828d4c9eb7748$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ($297828d4c9eb7748$var$isDomainSpecifiedByUser(child.props.domain, allowDataOverflow, type)) {
            domain = (0, $de5fcafa56f48e7f$export$a0bc8660980558a0)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $de5fcafa56f48e7f$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $297828d4c9eb7748$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $de5fcafa56f48e7f$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $e6a593df52d5e247$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($803301859424e115$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $de5fcafa56f48e7f$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($297828d4c9eb7748$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $de5fcafa56f48e7f$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(entry) ? finalDomain : [].concat($297828d4c9eb7748$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $de5fcafa56f48e7f$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $de5fcafa56f48e7f$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($803301859424e115$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $de5fcafa56f48e7f$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $de5fcafa56f48e7f$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $4506e8bdc0caf667$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $de5fcafa56f48e7f$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, result), {}, $297828d4c9eb7748$var$_defineProperty({}, axisId, $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
    return axisMap;
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $297828d4c9eb7748$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $297828d4c9eb7748$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $de5fcafa56f48e7f$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    var axisMap = graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = $297828d4c9eb7748$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($803301859424e115$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $de5fcafa56f48e7f$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $4506e8bdc0caf667$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $de5fcafa56f48e7f$export$a0bc8660980558a0)(originalDomain, (0, $de5fcafa56f48e7f$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $4506e8bdc0caf667$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, result), {}, $297828d4c9eb7748$var$_defineProperty({}, axisId, $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))($297828d4c9eb7748$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
    return axisMap;
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $297828d4c9eb7748$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $297828d4c9eb7748$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $297828d4c9eb7748$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $297828d4c9eb7748$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $e6a593df52d5e247$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $de5fcafa56f48e7f$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($08d5ce8e0c21d402$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $de5fcafa56f48e7f$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */ var $297828d4c9eb7748$var$createDefaultState = function createDefaultState(props) {
    var _brushItem$props, _brushItem$props2;
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $f43486451a1e41f4$export$64c61536a2b72e0f)(children, (0, $dff7be68fd51578d$export$59bc2e3533b384a0));
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = (brushItem === null || brushItem === void 0 ? void 0 : (_brushItem$props = brushItem.props) === null || _brushItem$props === void 0 ? void 0 : _brushItem$props.endIndex) !== undefined ? brushItem === null || brushItem === void 0 ? void 0 : (_brushItem$props2 = brushItem.props) === null || _brushItem$props2 === void 0 ? void 0 : _brushItem$props2.endIndex : props.data && props.data.length - 1 || 0;
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(defaultShowTooltip) ? defaultShowTooltip : false
    };
};
var $297828d4c9eb7748$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $f43486451a1e41f4$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $297828d4c9eb7748$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} props          Latest props
 * graphicalItems The instances of item
 * xAxisMap       The configuration of x-axis
 * yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox          the boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $297828d4c9eb7748$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $f43486451a1e41f4$export$64c61536a2b72e0f)(children, (0, $dff7be68fd51578d$export$59bc2e3533b384a0));
    var legendItem = (0, $f43486451a1e41f4$export$64c61536a2b72e0f)(children, (0, $785732b572ee5e11$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, result), {}, $297828d4c9eb7748$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, result), {}, $297828d4c9eb7748$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $dff7be68fd51578d$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) offset = (0, $de5fcafa56f48e7f$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        width: width - offset.left - offset.right,
        height: height - offset.top - offset.bottom
    });
};
var $297828d4c9eb7748$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _class;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $297828d4c9eb7748$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $297828d4c9eb7748$var$hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, $de5fcafa56f48e7f$export$570d306bee26c748)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $297828d4c9eb7748$var$getDisplayedData(props.data, {
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }, item);
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _objectSpread6;
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                var id = item.props["".concat(entry.axisType, "Id")];
                var axis = axisMap && axisMap[id];
                return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, result), {}, (_objectSpread6 = {}, $297828d4c9eb7748$var$_defineProperty(_objectSpread6, entry.axisType, axis), $297828d4c9eb7748$var$_defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, $de5fcafa56f48e7f$export$c829ee42daf7f66d)(axis)), _objectSpread6));
            }, {});
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $de5fcafa56f48e7f$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $f43486451a1e41f4$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $de5fcafa56f48e7f$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $de5fcafa56f48e7f$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $de5fcafa56f48e7f$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, pos), {}, {
                        position: $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, composedFn($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, $297828d4c9eb7748$var$_defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), $297828d4c9eb7748$var$_defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), $297828d4c9eb7748$var$_defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, $f43486451a1e41f4$export$857ca101f741953)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $f43486451a1e41f4$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $297828d4c9eb7748$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $de5fcafa56f48e7f$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, result), {}, $297828d4c9eb7748$var$_defineProperty({}, name, $297828d4c9eb7748$var$getAxisMap(props, $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $297828d4c9eb7748$var$calculateOffset($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $297828d4c9eb7748$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _class = /*#__PURE__*/ function(_Component) {
        $297828d4c9eb7748$var$_inherits(CategoricalChartWrapper, _Component);
        var _super = $297828d4c9eb7748$var$_createSuper(CategoricalChartWrapper);
        function CategoricalChartWrapper(_props) {
            var _this;
            $297828d4c9eb7748$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "accessibilityManager", new (0, $470af37f6b8ba77d$export$a2c2de1efa8671eb)());
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "clearDeferId", function() {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(_this.deferId) && $297828d4c9eb7748$var$deferClear) $297828d4c9eb7748$var$deferClear(_this.deferId);
                _this.deferId = null;
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($297828d4c9eb7748$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, chartId, data) {
                var syncId = _this.props.syncId;
                if (syncId === cId && chartId !== _this.uniqueChartId) {
                    _this.clearDeferId();
                    _this.deferId = $297828d4c9eb7748$var$defer && $297828d4c9eb7748$var$defer(_this.applySyncEvent.bind($297828d4c9eb7748$var$_assertThisInitialized(_this), data));
                }
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $297828d4c9eb7748$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var onMouseEnter = _this.props.onMouseEnter;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var onMouseMove = _this.props.onMouseMove;
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {Object} e        Event object
       * @return {Null} no return
       */ $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleMouseMove", function(e) {
                if (e && (0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(e.persist)) e.persist();
                _this.triggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                var onMouseLeave = _this.props.onMouseLeave;
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
                _this.cancelThrottledTriggerAfterMouseMove();
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, $f43486451a1e41f4$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(event)) {
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    var handler = event;
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    handler(mouse, e);
                }
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleClick", function(e) {
                var onClick = _this.props.onClick;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseMove(e.changedTouches[0]);
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "verticalCoordinatesGenerator", function(_ref10) {
                var xAxis = _ref10.xAxis, width = _ref10.width, height = _ref10.height, offset = _ref10.offset;
                return (0, $de5fcafa56f48e7f$export$846dc5ac5fecff74)((0, $2605f80636cee3c4$export$3d27d42b1034de5c)($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, (0, $580ac068e92093ad$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
                    ticks: (0, $de5fcafa56f48e7f$export$c829ee42daf7f66d)(xAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.left, offset.left + offset.width);
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "horizontalCoordinatesGenerator", function(_ref11) {
                var yAxis = _ref11.yAxis, width = _ref11.width, height = _ref11.height, offset = _ref11.offset;
                return (0, $de5fcafa56f48e7f$export$846dc5ac5fecff74)((0, $2605f80636cee3c4$export$3d27d42b1034de5c)($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, (0, $580ac068e92093ad$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
                    ticks: (0, $de5fcafa56f48e7f$export$c829ee42daf7f66d)(yAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.top, offset.top + offset.height);
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "axesTicksGenerator", function(axis) {
                return (0, $de5fcafa56f48e7f$export$c829ee42daf7f66d)(axis, true);
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderCursor", function(element) {
                var _this$state2 = _this.state, isTooltipActive = _this$state2.isTooltipActive, activeCoordinate = _this$state2.activeCoordinate, activePayload = _this$state2.activePayload, offset = _this$state2.offset, activeTooltipIndex = _this$state2.activeTooltipIndex;
                var tooltipEventType = _this.getTooltipEventType();
                if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
                var layout = _this.props.layout;
                var restProps;
                var cursorComp = (0, $7eb448ddfde98505$export$b0e83c3ef8d2db1);
                if (chartName === 'ScatterChart') {
                    restProps = activeCoordinate;
                    cursorComp = (0, $e46bd84c753d945f$export$3c877bb842c36952);
                } else if (chartName === 'BarChart') {
                    restProps = _this.getCursorRectangle();
                    cursorComp = (0, $0313ad10ec3b9e9b$export$4617fb02663045ef);
                } else if (layout === 'radial') {
                    var _this$getCursorPoints = _this.getCursorPoints(), cx = _this$getCursorPoints.cx, cy = _this$getCursorPoints.cy, radius = _this$getCursorPoints.radius, startAngle = _this$getCursorPoints.startAngle, endAngle = _this$getCursorPoints.endAngle;
                    restProps = {
                        cx: cx,
                        cy: cy,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        innerRadius: radius,
                        outerRadius: radius
                    };
                    cursorComp = (0, $73ad33dbab9fd7d1$export$e98c2c7eb2b14f45);
                } else {
                    restProps = {
                        points: _this.getCursorPoints()
                    };
                    cursorComp = (0, $7eb448ddfde98505$export$b0e83c3ef8d2db1);
                }
                var key = element.key || '_recharts-cursor';
                var cursorProps = $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({
                    stroke: '#ccc',
                    pointerEvents: 'none'
                }, offset), restProps), (0, $f43486451a1e41f4$export$d697c39a2985a4c)(element.props.cursor)), {}, {
                    payload: activePayload,
                    payloadIndex: activeTooltipIndex,
                    key: key,
                    className: 'recharts-tooltip-cursor'
                });
                return /*#__PURE__*/ (0, $5pP8j.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $5pP8j.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $5pP8j.createElement)(cursorComp, cursorProps);
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $5pP8j.cloneElement)(element, $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $de5fcafa56f48e7f$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderXAxis", function(element, displayName, index) {
                var xAxisMap = _this.state.xAxisMap;
                var axisObj = xAxisMap[element.props.xAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderYAxis", function(element, displayName, index) {
                var yAxisMap = _this.state.yAxisMap;
                var axisObj = yAxisMap[element.props.yAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */ $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderGrid", function(element) {
                var _this$state3 = _this.state, xAxisMap = _this$state3.xAxisMap, yAxisMap = _this$state3.yAxisMap, offset = _this$state3.offset;
                var _this$props = _this.props, width = _this$props.width, height = _this$props.height;
                var xAxis = (0, $e6a593df52d5e247$export$b88993f0aa0bf776)(xAxisMap);
                var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($feb20e15be29a340$exports)))(yAxisMap, function(axis) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3d4edc1cc2097bee$exports)))(axis.domain, $297828d4c9eb7748$var$isFinit);
                });
                var yAxis = yAxisWithFiniteDomain || (0, $e6a593df52d5e247$export$b88993f0aa0bf776)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, $5pP8j.cloneElement)(element, {
                    key: element.key || 'grid',
                    x: (0, $e6a593df52d5e247$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
                    y: (0, $e6a593df52d5e247$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
                    width: (0, $e6a593df52d5e247$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
                    height: (0, $e6a593df52d5e247$export$7e4aa119212bc614)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    offset: offset,
                    chartWidth: width,
                    chartHeight: height,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
                });
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $e6a593df52d5e247$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $e6a593df52d5e247$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $5pP8j.cloneElement)(element, {
                    polarAngles: (0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(polarAngles) ? polarAngles : (0, $de5fcafa56f48e7f$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: (0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(polarRadius) ? polarRadius : (0, $de5fcafa56f48e7f$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $de5fcafa56f48e7f$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $297828d4c9eb7748$var$_objectWithoutProperties(props, $297828d4c9eb7748$var$_excluded);
                return /*#__PURE__*/ (0, $5pP8j.cloneElement)(item, $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    ref: function ref(legend) {
                        _this.legendInstance = legend;
                    },
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderTooltip", function() {
                var children = _this.props.children;
                var tooltipItem = (0, $f43486451a1e41f4$export$64c61536a2b72e0f)(children, (0, $c5e462fb264ac9e5$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                return /*#__PURE__*/ (0, $5pP8j.cloneElement)(tooltipItem, {
                    viewBox: $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isTooltipActive,
                    label: activeLabel,
                    payload: isTooltipActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props3 = _this.props, margin = _this$props3.margin, data = _this$props3.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $5pP8j.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $de5fcafa56f48e7f$export$760ec406ba47bace)(_this.handleBrushChange, null, element.props.onChange),
                    data: data,
                    x: (0, $e6a593df52d5e247$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $e6a593df52d5e247$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $e6a593df52d5e247$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $297828d4c9eb7748$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $5pP8j.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderActivePoints", function(_ref12) {
                var item = _ref12.item, activePoint = _ref12.activePoint, basePoint = _ref12.basePoint, childIndex = _ref12.childIndex, isRange = _ref12.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $de5fcafa56f48e7f$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(activeDot)), (0, $0e1d5f7291a98e27$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $f43486451a1e41f4$export$64c61536a2b72e0f)(children, (0, $c5e462fb264ac9e5$export$28c660c63b792dea));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide;
                var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $de5fcafa56f48e7f$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onCLick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $de5fcafa56f48e7f$export$760ec406ba47bace)(_this.handleItemMouseLeave, null, element.props.onMouseLeave),
                    onMouseEnter: (0, $de5fcafa56f48e7f$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $5pP8j.cloneElement)(element, $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    var activePoint, basePoint;
                    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                        // number transform to string
                        var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                        activePoint = (0, $e6a593df52d5e247$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                        basePoint = isRange && baseLine && (0, $e6a593df52d5e247$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                    } else {
                        activePoint = points[activeTooltipIndex];
                        basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                    }
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(activePoint)) return [
                        graphicalItem
                    ].concat($297828d4c9eb7748$var$_toConsumableArray(_this.renderActivePoints({
                        item: item,
                        activePoint: activePoint,
                        basePoint: basePoint,
                        childIndex: activeTooltipIndex,
                        isRange: isRange
                    })));
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $297828d4c9eb7748$var$_defineProperty($297828d4c9eb7748$var$_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $5pP8j.cloneElement)(element, $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            _this.uniqueChartId = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(_props.id) ? (0, $e6a593df52d5e247$export$8b15d37bc3f197d4)('recharts') : _props.id;
            _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
            if (_props.throttleDelay) _this.triggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($574b3c6076bd0804$exports)))(_this.triggeredAfterMouseMove, _props.throttleDelay);
            _this.state = {};
            return _this;
        }
        $297828d4c9eb7748$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(this.props.syncId)) this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.handleMouseMove,
                        layout: this.props.layout
                    });
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // add syncId
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(prevProps.syncId) && !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(this.props.syncId)) this.addListener();
                    // remove syncId
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(prevProps.syncId) && (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(this.props.syncId)) this.removeListener();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDeferId();
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(this.props.syncId)) this.removeListener();
                    this.cancelThrottledTriggerAfterMouseMove();
                }
            },
            {
                key: "cancelThrottledTriggerAfterMouseMove",
                value: function cancelThrottledTriggerAfterMouseMove() {
                    if (typeof this.triggeredAfterMouseMove.cancel === 'function') this.triggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $f43486451a1e41f4$export$64c61536a2b72e0f)(this.props.children, (0, $c5e462fb264ac9e5$export$28c660c63b792dea));
                    if (tooltipItem && (0, (/*@__PURE__*/$parcel$interopDefault($3b672836ef8ff84f$exports)))(tooltipItem.props.shared)) {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var containerOffset = (0, $009d73de260549c1$export$622cea445a1c5b7d)(this.container);
                    var e = (0, $009d73de260549c1$export$f209e6c32ad3d02e)(event, containerOffset);
                    var rangeObj = this.inRange(e.chartX, e.chartY);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $e6a593df52d5e247$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $e6a593df52d5e247$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $297828d4c9eb7748$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "getCursorRectangle",
                value: function getCursorRectangle() {
                    var layout = this.props.layout;
                    var _this$state10 = this.state, activeCoordinate = _this$state10.activeCoordinate, offset = _this$state10.offset, tooltipAxisBandSize = _this$state10.tooltipAxisBandSize;
                    var halfSize = tooltipAxisBandSize / 2;
                    return {
                        stroke: 'none',
                        fill: '#ccc',
                        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
                        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
                        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
                        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
                    };
                }
            },
            {
                key: "getCursorPoints",
                value: function getCursorPoints() {
                    var layout = this.props.layout;
                    var _this$state11 = this.state, activeCoordinate = _this$state11.activeCoordinate, offset = _this$state11.offset;
                    var x1, y1, x2, y2;
                    if (layout === 'horizontal') {
                        x1 = activeCoordinate.x;
                        x2 = x1;
                        y1 = offset.top;
                        y2 = offset.top + offset.height;
                    } else if (layout === 'vertical') {
                        y1 = activeCoordinate.y;
                        y2 = y1;
                        x1 = offset.left;
                        x2 = offset.left + offset.width;
                    } else if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(activeCoordinate.cx) || !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(activeCoordinate.cy)) {
                        if (layout === 'centric') {
                            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
                            var innerPoint = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
                            var outerPoint = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
                            x1 = innerPoint.x;
                            y1 = innerPoint.y;
                            x2 = outerPoint.x;
                            y2 = outerPoint.y;
                        } else {
                            var _cx = activeCoordinate.cx, _cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
                            var startPoint = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(_cx, _cy, radius, startAngle);
                            var endPoint = (0, $0c9962d1b1acbd9a$export$5c9a959bb3fc7749)(_cx, _cy, radius, endAngle);
                            return {
                                points: [
                                    startPoint,
                                    endPoint
                                ],
                                cx: _cx,
                                cy: _cy,
                                radius: radius,
                                startAngle: startAngle,
                                endAngle: endAngle
                            };
                        }
                    }
                    return [
                        {
                            x: x1,
                            y: y1
                        },
                        {
                            x: x2,
                            y: y2
                        }
                    ];
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var layout = this.props.layout;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
                        return isInRange ? {
                            x: x,
                            y: y
                        } : null;
                    }
                    var _this$state12 = this.state, angleAxisMap = _this$state12.angleAxisMap, radiusAxisMap = _this$state12.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $e6a593df52d5e247$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $0c9962d1b1acbd9a$export$e85a2bf8cd31c504)({
                            x: x,
                            y: y
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $f43486451a1e41f4$export$64c61536a2b72e0f)(children, (0, $c5e462fb264ac9e5$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    var outerEvents = (0, $0e1d5f7291a98e27$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33).on((0, $1d768fe0c9a21d68$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33).setMaxListeners && (0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33)._maxListeners) (0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33).setMaxListeners((0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33)._maxListeners + 1);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33).removeListener((0, $1d768fe0c9a21d68$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33).setMaxListeners && (0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33)._maxListeners) (0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33).setMaxListeners((0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33)._maxListeners - 1);
                }
            },
            {
                key: "triggerSyncEvent",
                value: function triggerSyncEvent(data) {
                    var syncId = this.props.syncId;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(syncId)) (0, $1d768fe0c9a21d68$export$9bcdfe5f29bb33).emit((0, $1d768fe0c9a21d68$export$ff9a08f6d0c38b8f), syncId, this.uniqueChartId, data);
                }
            },
            {
                key: "applySyncEvent",
                value: function applySyncEvent(data) {
                    var _this$props4 = this.props, layout = _this$props4.layout, syncMethod = _this$props4.syncMethod;
                    var updateId = this.state.updateId;
                    var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(data.dataStartIndex) || !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(data.dataEndIndex)) this.setState($297828d4c9eb7748$var$_objectSpread({
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, this.state)));
                    else if (!(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(data.activeTooltipIndex)) {
                        var chartX = data.chartX, chartY = data.chartY;
                        var activeTooltipIndex = data.activeTooltipIndex;
                        var _this$state13 = this.state, offset = _this$state13.offset, tooltipTicks = _this$state13.tooltipTicks;
                        if (!offset) return;
                        if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                        activeTooltipIndex = syncMethod(tooltipTicks, data);
                        else if (syncMethod === 'value') {
                            // Set activeTooltipIndex to the index with the same value as data.activeLabel
                            // For loop instead of findIndex because the latter is very slow in some browsers
                            activeTooltipIndex = -1; // in case we cannot find the element
                            for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                                activeTooltipIndex = i;
                                break;
                            }
                        }
                        var viewBox = $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, offset), {}, {
                            x: offset.left,
                            y: offset.top
                        });
                        // When a categorical chart is combined with another chart, the value of chartX
                        // and chartY may beyond the boundaries.
                        var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                        var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                        var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                        var activePayload = $297828d4c9eb7748$var$getTooltipContent(this.state, this.props.data, activeTooltipIndex);
                        var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                            x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                            y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                        } : $297828d4c9eb7748$var$originCoordinate;
                        this.setState($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, data), {}, {
                            activeLabel: activeLabel,
                            activeCoordinate: activeCoordinate,
                            activePayload: activePayload,
                            activeTooltipIndex: activeTooltipIndex
                        }));
                    } else this.setState(data);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $f43486451a1e41f4$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderAxis",
                value: /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */ function renderAxis(axisOptions, element, displayName, index) {
                    var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $580ac068e92093ad$export$bdd99f2cdf352bae), $297828d4c9eb7748$var$_extends({}, axisOptions, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
                        key: element.key || "".concat(displayName, "-").concat(index),
                        viewBox: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        ticksGenerator: this.axesTicksGenerator
                    }));
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $297828d4c9eb7748$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, res), {}, $297828d4c9eb7748$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $297828d4c9eb7748$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, res), {}, $297828d4c9eb7748$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap, _this$state$xAxisMap$;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 ? void 0 : (_this$state$xAxisMap$ = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap$ === void 0 ? void 0 : _this$state$xAxisMap$.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap, _this$state$yAxisMap$;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 ? void 0 : (_this$state$yAxisMap$ = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap$ === void 0 ? void 0 : _this$state$yAxisMap$.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $f43486451a1e41f4$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $0313ad10ec3b9e9b$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $0c9962d1b1acbd9a$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $f43486451a1e41f4$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $297828d4c9eb7748$var$_objectWithoutProperties(_this$props6, $297828d4c9eb7748$var$_excluded2);
                    var attrs = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(others);
                    var map = {
                        CartesianGrid: {
                            handler: this.renderGrid,
                            once: true
                        },
                        ReferenceArea: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceLine: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceDot: {
                            handler: this.renderReferenceElement
                        },
                        XAxis: {
                            handler: this.renderXAxis
                        },
                        YAxis: {
                            handler: this.renderYAxis
                        },
                        Brush: {
                            handler: this.renderBrush,
                            once: true
                        },
                        Bar: {
                            handler: this.renderGraphicChild
                        },
                        Line: {
                            handler: this.renderGraphicChild
                        },
                        Area: {
                            handler: this.renderGraphicChild
                        },
                        Radar: {
                            handler: this.renderGraphicChild
                        },
                        RadialBar: {
                            handler: this.renderGraphicChild
                        },
                        Scatter: {
                            handler: this.renderGraphicChild
                        },
                        Pie: {
                            handler: this.renderGraphicChild
                        },
                        Funnel: {
                            handler: this.renderGraphicChild
                        },
                        Tooltip: {
                            handler: this.renderCursor,
                            once: true
                        },
                        PolarGrid: {
                            handler: this.renderPolarGrid,
                            once: true
                        },
                        PolarAngleAxis: {
                            handler: this.renderPolarAxis
                        },
                        PolarRadiusAxis: {
                            handler: this.renderPolarAxis
                        },
                        Customized: {
                            handler: this.renderCustomized
                        }
                    };
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $774ffa3fa11358b1$export$7b92b459e668cb21), $297828d4c9eb7748$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $f43486451a1e41f4$export$a98d6da55570cb82)(children, map));
                    if (this.props.accessibilityLayer) {
                        var _2, _img;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_2 = 0, _2 !== void 0) ? _2 : this.props.tabIndex;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_img = 'img', _img !== void 0) ? _img : this.props.role;
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("div", $297828d4c9eb7748$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-wrapper', className),
                        style: $297828d4c9eb7748$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        },
                        role: "region"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $774ffa3fa11358b1$export$7b92b459e668cb21), $297828d4c9eb7748$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $f43486451a1e41f4$export$a98d6da55570cb82)(children, map)), this.renderLegend(), this.renderTooltip());
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $5pP8j.Component)), $297828d4c9eb7748$var$_defineProperty(_class, "displayName", chartName), $297828d4c9eb7748$var$_defineProperty(_class, "defaultProps", $297828d4c9eb7748$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps)), $297828d4c9eb7748$var$_defineProperty(_class, "getDerivedStateFromProps", function(nextProps, prevState) {
        var data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(prevState.updateId)) {
            var defaultState = $297828d4c9eb7748$var$createDefaultState(nextProps);
            return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $208f2e6420654b95$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $297828d4c9eb7748$var$createDefaultState(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, $297828d4c9eb7748$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($297828d4c9eb7748$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $f43486451a1e41f4$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(data);
            var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
            return $297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($297828d4c9eb7748$var$_objectSpread($297828d4c9eb7748$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId
            }), prevState)), {}, {
                prevChildren: children
            });
        }
        return null;
    }), $297828d4c9eb7748$var$_defineProperty(_class, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $5pP8j.isValidElement)(option)) dot = /*#__PURE__*/ (0, $5pP8j.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $bb16faa3019e11e8$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _class;
};



/**
 * @fileOverview X Axis
 */ /** Define of XAxis props */ var $9a749d09d49d3786$export$ea77231de273b52d = function XAxis() {
    return null;
};
$9a749d09d49d3786$export$ea77231de273b52d.displayName = 'XAxis';
$9a749d09d49d3786$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
};


/**
 * @fileOverview Y Axis
 */ var $00767df24e29675e$export$f96c4024c52de8f4 = function YAxis() {
    return null;
};
$00767df24e29675e$export$f96c4024c52de8f4.displayName = 'YAxis';
$00767df24e29675e$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
};



var $7f0fb55201fb489a$export$54d0e8420ac838ac = (0, $297828d4c9eb7748$export$77871aede60e6838)({
    chartName: 'LineChart',
    GraphicalChild: (0, $22e4f653bf728fd5$export$17d680238e50603e),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $9a749d09d49d3786$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $00767df24e29675e$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $6854f7e630297740$export$ece7de1383db5ac)
});



var $5pP8j = parcelRequire("5pP8j");

var $5pP8j = parcelRequire("5pP8j");

var $bzs0j = parcelRequire("bzs0j");


/* global Reflect, Promise */ var $3bb90c7181319278$var$extendStatics = function(d, b) {
    $3bb90c7181319278$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3bb90c7181319278$var$extendStatics(d, b);
};
function $3bb90c7181319278$var$__extends(d, b) {
    $3bb90c7181319278$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3bb90c7181319278$var$__assign = function() {
    $3bb90c7181319278$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3bb90c7181319278$var$__assign.apply(this, arguments);
};
function $3bb90c7181319278$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $3bb90c7181319278$var$patchResizeHandler = function(resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch(refreshMode){
        case 'debounce':
            return (0, (/*@__PURE__*/$parcel$interopDefault($d2f219afab8c4bb7$exports)))(resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return (0, (/*@__PURE__*/$parcel$interopDefault($574b3c6076bd0804$exports)))(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var $3bb90c7181319278$var$isFunction = function(fn) {
    return typeof fn === 'function';
};
var $3bb90c7181319278$var$isSSR = function() {
    return typeof window === 'undefined';
};
var $3bb90c7181319278$var$isDOMElement = function(element) {
    return element instanceof Element || element instanceof HTMLDocument;
};
var $3bb90c7181319278$var$createNotifier = function(setSize, handleWidth, handleHeight) {
    return function(_a) {
        var width = _a.width, height = _a.height;
        setSize(function(prev) {
            if (prev.width === width && prev.height === height) // skip if dimensions haven't changed
            return prev;
            if (prev.width === width && !handleHeight || prev.height === height && !handleWidth) // process `handleHeight/handleWidth` props
            return prev;
            return {
                width: width,
                height: height
            };
        });
    };
};
var $3bb90c7181319278$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $3bb90c7181319278$var$__extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function() {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function() {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if ($3bb90c7181319278$var$isSSR()) return;
            if (targetRef && targetRef.current) _this.targetRef.current = targetRef.current;
            var element = _this.getElement();
            if (!element) // can't find element to observe
            return;
            if (_this.observableElement && _this.observableElement === element) // element is already observed
            return;
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function() {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if ($3bb90c7181319278$var$isSSR()) return null;
            // in case we pass a querySelector
            if (querySelector) return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && $3bb90c7181319278$var$isDOMElement(targetDomEl)) return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && $3bb90c7181319278$var$isDOMElement(_this.targetRef.current)) return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = (0, $bzs0j.findDOMNode)(_this);
            if (!currentElement) return null;
            var renderType = _this.getRenderType();
            switch(renderType){
                case 'renderProp':
                    return currentElement;
                case 'childFunction':
                    return currentElement;
                case 'child':
                    return currentElement;
                case 'childArray':
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function(entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight) return;
            var notifyResize = $3bb90c7181319278$var$createNotifier(function(setStateFunc) {
                return _this.setState(setStateFunc, function() {
                    return onResize === null || onResize === void 0 ? void 0 : onResize(_this.state.width, _this.state.height);
                });
            }, handleWidth, handleHeight);
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !$3bb90c7181319278$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function() {
            var _a = _this.props, render = _a.render, children = _a.children;
            if ($3bb90c7181319278$var$isFunction(render)) // DEPRECATED. Use `Child Function Pattern` instead
            return 'renderProp';
            if ($3bb90c7181319278$var$isFunction(children)) return 'childFunction';
            if ((0, $5pP8j.isValidElement)(children)) return 'child';
            if (Array.isArray(children)) // DEPRECATED. Wrap children with a single parent
            return 'childArray';
            // DEPRECATED. Use `Child Function Pattern` instead
            return 'parent';
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = (0, $5pP8j.createRef)();
        _this.observableElement = null;
        if ($3bb90c7181319278$var$isSSR()) return _this;
        _this.resizeHandler = $3bb90c7181319278$var$patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function() {
        if ($3bb90c7181319278$var$isSSR()) return;
        this.observableElement = null;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function() {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? 'div' : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = {
            width: width,
            height: height,
            targetRef: this.targetRef
        };
        var renderType = this.getRenderType();
        switch(renderType){
            case 'renderProp':
                return render === null || render === void 0 ? void 0 : render(childProps);
            case 'childFunction':
                var childFunction = children;
                return childFunction === null || childFunction === void 0 ? void 0 : childFunction(childProps);
            case 'child':
                // @TODO bug prone logic
                var child = children;
                if (child.type && typeof child.type === 'string') {
                    // child is a native DOM elements such as div, span etc
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    childProps.targetRef;
                    var nativeProps = $3bb90c7181319278$var$__rest(childProps, [
                        "targetRef"
                    ]);
                    return (0, $5pP8j.cloneElement)(child, nativeProps);
                }
                // class or functional component otherwise
                return (0, $5pP8j.cloneElement)(child, childProps);
            case 'childArray':
                var childArray = children;
                return childArray.map(function(el) {
                    return !!el && (0, $5pP8j.cloneElement)(el, childProps);
                });
            default:
                return (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}((0, $5pP8j.PureComponent));
function $3bb90c7181319278$export$fa0519968090da40(ComponentInner, options) {
    if (options === void 0) options = {};
    var ResizeDetectorHOC = /** @class */ function(_super) {
        $3bb90c7181319278$var$__extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = (0, $5pP8j.createRef)();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function() {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = $3bb90c7181319278$var$__rest(_a, [
                "forwardedRef"
            ]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement($3bb90c7181319278$export$2e2bcd8739ae039, $3bb90c7181319278$var$__assign({}, options, {
                targetRef: targetRef
            }), (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement(ComponentInner, $3bb90c7181319278$var$__assign({
                targetRef: targetRef
            }, rest)));
        };
        return ResizeDetectorHOC;
    }((0, $5pP8j.Component));
    function forwardRefWrapper(props, ref) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement(ResizeDetectorHOC, $3bb90c7181319278$var$__assign({}, props, {
            forwardedRef: ref
        }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return (0, $5pP8j.forwardRef)(forwardRefWrapper);
}
var $3bb90c7181319278$var$useEnhancedEffect = $3bb90c7181319278$var$isSSR() ? (0, $5pP8j.useEffect) : (0, $5pP8j.useLayoutEffect);
function $3bb90c7181319278$export$453c3d1cba18d800(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.skipOnMount, skipOnMount = _c === void 0 ? false : _c, refreshMode = _b.refreshMode, _d = _b.refreshRate, refreshRate = _d === void 0 ? 1000 : _d, refreshOptions = _b.refreshOptions, _e = _b.handleWidth, handleWidth = _e === void 0 ? true : _e, _f = _b.handleHeight, handleHeight = _f === void 0 ? true : _f, targetRef = _b.targetRef, observerOptions = _b.observerOptions, onResize = _b.onResize;
    var skipResize = (0, $5pP8j.useRef)(skipOnMount);
    var localRef = (0, $5pP8j.useRef)(null);
    var resizeHandler = (0, $5pP8j.useRef)();
    var ref = targetRef !== null && targetRef !== void 0 ? targetRef : localRef;
    var _g = (0, $5pP8j.useState)({
        width: undefined,
        height: undefined
    }), size = _g[0], setSize = _g[1];
    $3bb90c7181319278$var$useEnhancedEffect(function() {
        if (!handleWidth && !handleHeight) return;
        var notifyResize = $3bb90c7181319278$var$createNotifier(setSize, handleWidth, handleHeight);
        var resizeCallback = function(entries) {
            if (!handleWidth && !handleHeight) return;
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current;
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                skipResize.current = false;
            });
        };
        resizeHandler.current = $3bb90c7181319278$var$patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new window.ResizeObserver(resizeHandler.current);
        if (ref.current) resizeObserver.observe(ref.current, observerOptions);
        return function() {
            var _a, _b;
            resizeObserver.disconnect();
            (_b = (_a = resizeHandler.current).cancel) === null || _b === void 0 || _b.call(_a);
        };
    }, [
        refreshMode,
        refreshRate,
        refreshOptions,
        handleWidth,
        handleHeight,
        observerOptions,
        ref.current
    ]);
    (0, $5pP8j.useEffect)(function() {
        onResize === null || onResize === void 0 || onResize(size.width, size.height);
    }, [
        size
    ]);
    return $3bb90c7181319278$var$__assign({
        ref: ref
    }, size);
}




function $de9890f82317f82e$var$_extends() {
    $de9890f82317f82e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $de9890f82317f82e$var$_extends.apply(this, arguments);
}
function $de9890f82317f82e$var$_slicedToArray(arr, i) {
    return $de9890f82317f82e$var$_arrayWithHoles(arr) || $de9890f82317f82e$var$_iterableToArrayLimit(arr, i) || $de9890f82317f82e$var$_unsupportedIterableToArray(arr, i) || $de9890f82317f82e$var$_nonIterableRest();
}
function $de9890f82317f82e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $de9890f82317f82e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $de9890f82317f82e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $de9890f82317f82e$var$_arrayLikeToArray(o, minLen);
}
function $de9890f82317f82e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $de9890f82317f82e$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $de9890f82317f82e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $de9890f82317f82e$export$e60a4704009a0009 = /*#__PURE__*/ (0, $5pP8j.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize;
    var _useState = (0, $5pP8j.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $de9890f82317f82e$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var containerRef = (0, $5pP8j.useRef)(null);
    (0, $5pP8j.useImperativeHandle)(ref, function() {
        return containerRef;
    }, [
        containerRef
    ]);
    var getContainerSize = (0, $5pP8j.useCallback)(function() {
        if (!containerRef.current) return null;
        return {
            containerWidth: containerRef.current.clientWidth,
            containerHeight: containerRef.current.clientHeight
        };
    }, []);
    var updateDimensionsImmediate = (0, $5pP8j.useCallback)(function() {
        var newSize = getContainerSize();
        if (newSize) {
            var containerWidth = newSize.containerWidth, containerHeight = newSize.containerHeight;
            if (onResize) onResize(containerWidth, containerHeight);
            setSizes(function(currentSizes) {
                var oldWidth = currentSizes.containerWidth, oldHeight = currentSizes.containerHeight;
                if (containerWidth !== oldWidth || containerHeight !== oldHeight) return {
                    containerWidth: containerWidth,
                    containerHeight: containerHeight
                };
                return currentSizes;
            });
        }
    }, [
        getContainerSize,
        onResize
    ]);
    var chartContent = (0, $5pP8j.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $026af532d502bce7$export$c106dd0671a0fc2d)((0, $e6a593df52d5e247$export$e50269385c77c348)(width) || (0, $e6a593df52d5e247$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $026af532d502bce7$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $e6a593df52d5e247$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $e6a593df52d5e247$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $026af532d502bce7$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        return /*#__PURE__*/ (0, $5pP8j.cloneElement)(children, {
            width: calculatedWidth,
            height: calculatedHeight
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    (0, $5pP8j.useEffect)(function() {
        var size = getContainerSize();
        if (size) setSizes(size);
    }, [
        getContainerSize
    ]);
    var style = {
        width: width,
        height: height,
        minWidth: minWidth,
        minHeight: minHeight,
        maxHeight: maxHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $3bb90c7181319278$export$2e2bcd8739ae039), {
        handleWidth: true,
        handleHeight: true,
        onResize: updateDimensionsImmediate,
        targetRef: containerRef,
        refreshMode: debounce > 0 ? 'debounce' : undefined,
        refreshRate: debounce
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("div", $de9890f82317f82e$var$_extends({}, id != null ? {
        id: "".concat(id)
    } : {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-responsive-container', className),
        style: style,
        ref: containerRef
    }), chartContent));
});



const $8813f4b74079bc8c$var$NBSP = "\u00a0";
const $8813f4b74079bc8c$var$GameStats = ({ game: game })=>{
    const scoreData = (0, $5pP8j.useMemo)(()=>game.frames.map(({ score: score, outcome: outcome }, i)=>({
                name: i + 1,
                score: score,
                pins: (0, $0bbe7c18ba863365$export$2fc09de897439556)(outcome, i === 9)
            })), [
        game
    ]);
    const stats = (0, $5pP8j.useMemo)(()=>{
        const results = {
            Pins: game.pins,
            Strikes: game.stats.strikes,
            Spares: {
                total: game.stats.spares.total,
                "single pin": game.stats.spares.single,
                "multiple pins": game.stats.spares.multiple
            }
        };
        if (game.stats.splits.total) results.Splits = `${game.stats.splits.total} ${game.stats.splits.converted ? `(${game.stats.splits.converted} converted)` : ""}`;
        if (game.stats.fouls) results.Fouls = game.stats.fouls;
        results.Misses = game.stats.misses;
        results["Avg First Ball Pinfall"] = game.stats.avgFirstBallPinfall;
        return results;
    }, [
        game
    ]);
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("columns", "is-fluid"),
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("column"),
                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("ul", {
                    children: Object.entries(stats).map(([key, value])=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                                    children: `${key}:`
                                }),
                                $8813f4b74079bc8c$var$NBSP,
                                [
                                    "number",
                                    "string"
                                ].includes(typeof value) ? /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                    children: value
                                }) : /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $3604a940d8232154$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                            children: value.total
                                        }),
                                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("ul", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("ml-3", "is-size-7"),
                                            children: Object.entries(value).filter(([k])=>k !== "total").map(([k, v])=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-grey"),
                                                            children: `${k}:`
                                                        }),
                                                        $8813f4b74079bc8c$var$NBSP,
                                                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                                            children: v
                                                        })
                                                    ]
                                                }, k))
                                        })
                                    ]
                                })
                            ]
                        }, key))
                })
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("column", "is-three-fifths"),
                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $de9890f82317f82e$export$e60a4704009a0009), {
                    height: 175,
                    children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $7f0fb55201fb489a$export$54d0e8420ac838ac), {
                        data: scoreData,
                        margin: {
                            top: 10,
                            right: 0,
                            left: 0,
                            bottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $2b0870b1d8efc404$export$6440e27b9f186856), {
                                strokeDasharray: "2 2"
                            }),
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $9a749d09d49d3786$export$ea77231de273b52d), {
                                dataKey: "name",
                                padding: {
                                    left: 10,
                                    right: 10
                                }
                            }),
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $00767df24e29675e$export$f96c4024c52de8f4), {
                                interval: 0,
                                scale: "linear",
                                name: "Pins",
                                yAxisId: "pins",
                                orientation: "left",
                                domain: [
                                    0,
                                    10
                                ]
                            }),
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $00767df24e29675e$export$f96c4024c52de8f4), {
                                interval: 0,
                                scale: "linear",
                                name: "Score",
                                yAxisId: "score",
                                orientation: "right",
                                domain: [
                                    0,
                                    30
                                ]
                            }),
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $785732b572ee5e11$export$ed247974535929c7), {}),
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $22e4f653bf728fd5$export$17d680238e50603e), {
                                name: "Pins per frame",
                                type: "monotone",
                                yAxisId: "pins",
                                dataKey: "pins",
                                stroke: "#209cee"
                            }),
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $22e4f653bf728fd5$export$17d680238e50603e), {
                                name: "Score per frame",
                                type: "monotone",
                                yAxisId: "score",
                                dataKey: "score",
                                stroke: "#23d160"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $8813f4b74079bc8c$export$2e2bcd8739ae039 = $8813f4b74079bc8c$var$GameStats;


/* @leny/bowlstats
 *
 * /src/components/game-date.tsx
 */ 

const $6a7a9394089289ec$var$NBSP = "\u00a0";
const $6a7a9394089289ec$var$GameDate = ({ date: date, showYear: showYear = false })=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("mr-2"),
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-block", "has-background-danger", "has-text-white", "is-size-7", "px-2", "has-text-centered", "has-text-weight-semibold", "is-uppercase"),
                children: date.format("MMM")
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-block", "has-text-centered", "has-text-black", "has-text-weight-bold", "has-background-white"),
                style: {
                    border: "1px solid #dbdbdb",
                    borderTop: 0,
                    borderBottom: "1px solid #dbdbdb"
                },
                children: date.date()
            }),
            showYear && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-block", "has-text-black", "is-size-8", "px-2", "has-text-weight-semibold", "is-uppercase", "has-background-white"),
                style: {
                    border: "1px solid #dbdbdb",
                    borderTop: 0,
                    borderBottom: "1px solid #dbdbdb"
                },
                children: date.format("YYYY")
            })
        ]
    });
var $6a7a9394089289ec$export$2e2bcd8739ae039 = $6a7a9394089289ec$var$GameDate;



const $e0f21a15a1bb08e2$var$NBSP = "\u00a0";
const $e0f21a15a1bb08e2$var$getBallColor = (ball)=>{
    switch(ball.slice(ball.startsWith("H") ? 1 : 0)){
        case "6":
            return "#f8362f";
        case "7":
            return "#c6c20d";
        case "8":
            return "#c81108";
        case "9":
            return "#46435a";
        case "10":
            return "#9b2527";
        case "11":
            return "#1b417d";
        case "12":
            return "#1b6626";
        case "13":
            return "#1f3c7c";
        case "14":
            return "#0aa025";
        case "15":
            return "#262b4b";
        case "16":
            return "#983d28";
        default:
            return "black";
    }
};
const $e0f21a15a1bb08e2$var$Game = ({ game: game, isBest: isBest, isWorst: isWorst, showYear: showYear = false })=>{
    const [showDetails, setShowDetails] = (0, $5pP8j.useState)(false);
    const date = (0, $5pP8j.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1038fe58d0f12ce6$exports)))(new Date(game.date.year, game.date.month - 1, game.date.day)), [
        game
    ]);
    const toggleDetails = (0, $5pP8j.useCallback)(()=>{
        setShowDetails(!showDetails);
    }, [
        showDetails
    ]);
    const $date = /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $6a7a9394089289ec$export$2e2bcd8739ae039), {
        date: date,
        showYear: showYear
    });
    if (!showDetails) return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("notification", "is-light", isBest && "is-primary", isWorst && "is-danger", "is-flex", "is-justify-content-space-between", "is-align-content-center", "px-5", "is-unselectable", "is-clickable"),
        onClick: toggleDetails,
        children: [
            $date,
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $76bc3af6f0cb3e60$export$2e2bcd8739ae039), {
                score: game.score,
                frames: game.frames,
                compact: true
            })
        ]
    });
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("notification", "is-light", isBest && "is-primary", isWorst && "is-danger", "px-5"),
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-flex", "mb-3", "is-justify-content-space-between", "is-align-content-center"),
                children: [
                    $date,
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-flex", "is-relative", "is-justify-content-center", "is-align-items-center", "has-text-weight-bold", "is-family-secondary", "is-size-5", "has-text-white"),
                        style: {
                            width: 40,
                            height: 40,
                            borderRadius: "100%",
                            backgroundColor: $e0f21a15a1bb08e2$var$getBallColor(game.ball)
                        },
                        "data-tooltip": `Played with ${game.ball.slice(game.ball.startsWith("H") ? 1 : 0)}lbs ball ${game.ball.startsWith("H") ? "(house ball)" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-block"),
                                children: game.ball.slice(game.ball.startsWith("H") ? 1 : 0)
                            }),
                            game.ball.startsWith("H") && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-light"),
                                style: {
                                    position: "absolute",
                                    bottom: -1,
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    fontSize: 9
                                },
                                children: "H"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("button", {
                        type: "button",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("delete"),
                        onClick: toggleDetails,
                        children: "(hide details)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $76bc3af6f0cb3e60$export$2e2bcd8739ae039), {
                score: game.score,
                frames: game.frames
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))(game.note ? "mb-1" : "mb-3"),
                children: [
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                        children: "Lane Oil Pattern:"
                    }),
                    $e0f21a15a1bb08e2$var$NBSP,
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-italic"),
                        children: game.oilPattern || "none/dry"
                    })
                ]
            }),
            game.note && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("mb-3"),
                children: [
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                        children: "Note:"
                    }),
                    $e0f21a15a1bb08e2$var$NBSP,
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-italic"),
                        children: game.note
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $8813f4b74079bc8c$export$2e2bcd8739ae039), {
                game: game
            })
        ]
    });
};
var $e0f21a15a1bb08e2$export$2e2bcd8739ae039 = $e0f21a15a1bb08e2$var$Game;



const $fe2c876f96d55def$var$NBSP = "\u00a0";
const $fe2c876f96d55def$var$Games = ()=>{
    const { games: games, filters: filters, stats: stats } = (0, $5f382a079ec029d4$export$c1cf1cf4c5d51937)();
    const [reverseOrder, setReverseOrder] = (0, $5pP8j.useState)(true);
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $3604a940d8232154$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("subtitle", "is-flex", "is-flex-direction-row", "is-justify-content-space-between", "is-align-items-center"),
                children: [
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("span", {
                        children: [
                            "Games",
                            $fe2c876f96d55def$var$NBSP,
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("small", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-size-7", "is-va-middle", "has-text-grey"),
                                children: `(${games.length})`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("a", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-size-7", "is-va-middle"),
                        href: "#",
                        onClick: (0, $0bbe7c18ba863365$export$fa3b29edae795ef4)(()=>{
                            setReverseOrder(!reverseOrder);
                        }),
                        children: "(\u21C5 reverse order)"
                    })
                ]
            }),
            (reverseOrder ? Array.from(games).reverse() : games).map((game, i)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $e0f21a15a1bb08e2$export$2e2bcd8739ae039), {
                    game: game,
                    isBest: stats.avg.best === game.score,
                    isWorst: stats.avg.worst === game.score,
                    showYear: filters.year === null
                }, `${Object.values(game.date).join("-")}-${i}`))
        ]
    });
};
var $fe2c876f96d55def$export$2e2bcd8739ae039 = $fe2c876f96d55def$var$Games;


/* @leny/bowlstats
 *
 * /src/components/graphs/index.tsx
 */ 
/* @leny/bowlstats
 *
 * /src/components/graphs/score.tsx
 */ 


var $5pP8j = parcelRequire("5pP8j");
/* @leny/bowlstats
 *
 * /src/components/graphs/base.tsx
 */ 
/**
 * @fileOverview Composed Chart
 */ 








var $5pP8j = parcelRequire("5pP8j");










var $d68fcfd353925196$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
];
function $d68fcfd353925196$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d68fcfd353925196$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d68fcfd353925196$var$_typeof(obj);
}
function $d68fcfd353925196$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d68fcfd353925196$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d68fcfd353925196$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d68fcfd353925196$var$_extends() {
    $d68fcfd353925196$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d68fcfd353925196$var$_extends.apply(this, arguments);
}
function $d68fcfd353925196$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d68fcfd353925196$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d68fcfd353925196$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d68fcfd353925196$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d68fcfd353925196$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d68fcfd353925196$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d68fcfd353925196$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d68fcfd353925196$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d68fcfd353925196$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d68fcfd353925196$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d68fcfd353925196$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d68fcfd353925196$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d68fcfd353925196$var$_setPrototypeOf(subClass, superClass);
}
function $d68fcfd353925196$var$_setPrototypeOf(o, p) {
    $d68fcfd353925196$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d68fcfd353925196$var$_setPrototypeOf(o, p);
}
function $d68fcfd353925196$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d68fcfd353925196$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d68fcfd353925196$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d68fcfd353925196$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d68fcfd353925196$var$_possibleConstructorReturn(this, result);
    };
}
function $d68fcfd353925196$var$_possibleConstructorReturn(self, call) {
    if (call && ($d68fcfd353925196$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d68fcfd353925196$var$_assertThisInitialized(self);
}
function $d68fcfd353925196$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d68fcfd353925196$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d68fcfd353925196$var$_getPrototypeOf(o) {
    $d68fcfd353925196$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d68fcfd353925196$var$_getPrototypeOf(o);
}
function $d68fcfd353925196$var$_defineProperty(obj, key, value) {
    key = $d68fcfd353925196$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d68fcfd353925196$var$_toPropertyKey(arg) {
    var key = $d68fcfd353925196$var$_toPrimitive(arg, "string");
    return $d68fcfd353925196$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d68fcfd353925196$var$_toPrimitive(input, hint) {
    if ($d68fcfd353925196$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d68fcfd353925196$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d68fcfd353925196$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    $d68fcfd353925196$var$_inherits(Area, _PureComponent);
    var _super = $d68fcfd353925196$var$_createSuper(Area);
    function Area() {
        var _this;
        $d68fcfd353925196$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d68fcfd353925196$var$_defineProperty($d68fcfd353925196$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true
        });
        $d68fcfd353925196$var$_defineProperty($d68fcfd353925196$var$_assertThisInitialized(_this), "id", (0, $e6a593df52d5e247$export$8b15d37bc3f197d4)('recharts-area-'));
        $d68fcfd353925196$var$_defineProperty($d68fcfd353925196$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $d68fcfd353925196$var$_defineProperty($d68fcfd353925196$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $d68fcfd353925196$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $d68fcfd353925196$var$_objectSpread($d68fcfd353925196$var$_objectSpread($d68fcfd353925196$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        value: entry.value,
                        payload: entry.payload
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), $d68fcfd353925196$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($7e6c76b555606c86$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxY = Math.max(baseLine, maxY);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($7e6c76b555606c86$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($7e6c76b555606c86$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxX = Math.max(baseLine, maxX);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($7e6c76b555606c86$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === 'vertical') return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $d68fcfd353925196$var$_objectWithoutProperties(_this$props4, $d68fcfd353925196$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $7eb448ddfde98505$export$b0e83c3ef8d2db1), $d68fcfd353925196$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== 'none' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $7eb448ddfde98505$export$b0e83c3ef8d2db1), $d68fcfd353925196$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== 'none' && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $7eb448ddfde98505$export$b0e83c3ef8d2db1), $d68fcfd353925196$var$_extends({}, (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = _.isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $ee2bc8c876b1194a$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $d68fcfd353925196$var$_objectSpread($d68fcfd353925196$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') {
                            var interpolator = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($821a6471b94b95a0$exports)))(baseLine)) {
                            var _interpolator = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $d68fcfd353925196$var$_objectSpread($d68fcfd353925196$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($a5dab8b3c935330c$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($a5dab8b3c935330c$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-area', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $f43486451a1e41f4$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $18e58544181e4986$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
    return Area;
}((0, $5pP8j.PureComponent));
$d68fcfd353925196$var$_defineProperty($d68fcfd353925196$export$ea1a111407f37557, "displayName", 'Area');
$d68fcfd353925196$var$_defineProperty($d68fcfd353925196$export$ea1a111407f37557, "defaultProps", {
    stroke: '#3182bd',
    fill: '#3182bd',
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'line',
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $b477b0447f10d549$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
});
$d68fcfd353925196$var$_defineProperty($d68fcfd353925196$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $e6a593df52d5e247$export$7e4aa119212bc614)(baseValue) && typeof baseValue === 'number') return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var max = Math.max(domain[0], domain[1]);
        var min = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return min;
        if (baseValue === 'dataMax') return max;
        return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
});
$d68fcfd353925196$var$_defineProperty($d68fcfd353925196$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $d68fcfd353925196$export$ea1a111407f37557.getBaseValue(props, item, xAxis, yAxis);
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var originalValue = (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(entry, dataKey);
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = originalValue;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($02148300ecce42f1$exports)))(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(value[1]) || hasStack && (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(originalValue);
        if (layout === 'horizontal') return {
            x: (0, $de5fcafa56f48e7f$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $de5fcafa56f48e7f$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        if (layout === 'horizontal') return {
            x: entry.x,
            y: !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(entry, 'value[0]')) && !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(entry, 'y')) ? yAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(entry, 'value[0]')) : null
        };
        return {
            x: !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(entry, 'value[0]')) ? xAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($cc70d38e3e17d56b$exports)))(entry, 'value[0]')) : null,
            y: entry.y
        };
    });
    else if (layout === 'horizontal') baseLine = yAxis.scale(baseValue);
    else baseLine = xAxis.scale(baseValue);
    return $d68fcfd353925196$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$d68fcfd353925196$var$_defineProperty($d68fcfd353925196$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) dotItem = option(props);
    else dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $bb16faa3019e11e8$export$d046b3c4a416f60d), $d68fcfd353925196$var$_extends({}, props, {
        className: "recharts-area-dot"
    }));
    return dotItem;
});








var $5pP8j = parcelRequire("5pP8j");






/**
 * @fileOverview Z Axis
 */ var $d5f4afe2a4bd1f27$export$2363a7fa7edfe988 = function ZAxis() {
    return null;
};
$d5f4afe2a4bd1f27$export$2363a7fa7edfe988.displayName = 'ZAxis';
$d5f4afe2a4bd1f27$export$2363a7fa7edfe988.defaultProps = {
    zAxisId: 0,
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number'
};









function $41808cc75790078b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $41808cc75790078b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $41808cc75790078b$var$_typeof(obj);
}
function $41808cc75790078b$var$_extends() {
    $41808cc75790078b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $41808cc75790078b$var$_extends.apply(this, arguments);
}
function $41808cc75790078b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $41808cc75790078b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $41808cc75790078b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $41808cc75790078b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $41808cc75790078b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $41808cc75790078b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $41808cc75790078b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $41808cc75790078b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $41808cc75790078b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $41808cc75790078b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $41808cc75790078b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $41808cc75790078b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $41808cc75790078b$var$_setPrototypeOf(subClass, superClass);
}
function $41808cc75790078b$var$_setPrototypeOf(o, p) {
    $41808cc75790078b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $41808cc75790078b$var$_setPrototypeOf(o, p);
}
function $41808cc75790078b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $41808cc75790078b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $41808cc75790078b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $41808cc75790078b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $41808cc75790078b$var$_possibleConstructorReturn(this, result);
    };
}
function $41808cc75790078b$var$_possibleConstructorReturn(self, call) {
    if (call && ($41808cc75790078b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $41808cc75790078b$var$_assertThisInitialized(self);
}
function $41808cc75790078b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $41808cc75790078b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $41808cc75790078b$var$_getPrototypeOf(o) {
    $41808cc75790078b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $41808cc75790078b$var$_getPrototypeOf(o);
}
function $41808cc75790078b$var$_defineProperty(obj, key, value) {
    key = $41808cc75790078b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $41808cc75790078b$var$_toPropertyKey(arg) {
    var key = $41808cc75790078b$var$_toPrimitive(arg, "string");
    return $41808cc75790078b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $41808cc75790078b$var$_toPrimitive(input, hint) {
    if ($41808cc75790078b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($41808cc75790078b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $41808cc75790078b$export$1c460fb4285edadc = /*#__PURE__*/ function(_PureComponent) {
    $41808cc75790078b$var$_inherits(Scatter, _PureComponent);
    var _super = $41808cc75790078b$var$_createSuper(Scatter);
    function Scatter() {
        var _this;
        $41808cc75790078b$var$_classCallCheck(this, Scatter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $41808cc75790078b$var$_defineProperty($41808cc75790078b$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $41808cc75790078b$var$_defineProperty($41808cc75790078b$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
        });
        $41808cc75790078b$var$_defineProperty($41808cc75790078b$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
        });
        $41808cc75790078b$var$_defineProperty($41808cc75790078b$var$_assertThisInitialized(_this), "id", (0, $e6a593df52d5e247$export$8b15d37bc3f197d4)('recharts-scatter-'));
        return _this;
    }
    $41808cc75790078b$var$_createClass(Scatter, [
        {
            key: "renderSymbolsStatically",
            value: function renderSymbolsStatically(points) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, activeShape = _this$props.activeShape, activeIndex = _this$props.activeIndex;
                var baseProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props);
                return points.map(function(entry, i) {
                    var props = $41808cc75790078b$var$_objectSpread($41808cc75790078b$var$_objectSpread({
                        key: "symbol-".concat(i)
                    }, baseProps), entry);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), $41808cc75790078b$var$_extends({
                        className: "recharts-scatter-symbol"
                    }, (0, $0e1d5f7291a98e27$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        role: "img"
                    }), Scatter.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
                });
            }
        },
        {
            key: "renderSymbolsWithAnimation",
            value: function renderSymbolsWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, points = _this$props2.points, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevPoints = this.state.prevPoints;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $ee2bc8c876b1194a$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = points.map(function(entry, index) {
                        var prev = prevPoints && prevPoints[index];
                        if (prev) {
                            var interpolatorCx = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.cx, entry.cx);
                            var interpolatorCy = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.cy, entry.cy);
                            var interpolatorSize = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(prev.size, entry.size);
                            return $41808cc75790078b$var$_objectSpread($41808cc75790078b$var$_objectSpread({}, entry), {}, {
                                cx: interpolatorCx(t),
                                cy: interpolatorCy(t),
                                size: interpolatorSize(t)
                            });
                        }
                        var interpolator = (0, $e6a593df52d5e247$export$d871d53bd7eeb390)(0, entry.size);
                        return $41808cc75790078b$var$_objectSpread($41808cc75790078b$var$_objectSpread({}, entry), {}, {
                            size: interpolator(t)
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), null, _this3.renderSymbolsStatically(stepData));
                });
            }
        },
        {
            key: "renderSymbols",
            value: function renderSymbols() {
                var _this$props3 = this.props, points = _this$props3.points, isAnimationActive = _this$props3.isAnimationActive;
                var prevPoints = this.state.prevPoints;
                if (isAnimationActive && points && points.length && (!prevPoints || !(0, (/*@__PURE__*/$parcel$interopDefault($a5dab8b3c935330c$exports)))(prevPoints, points))) return this.renderSymbolsWithAnimation();
                return this.renderSymbolsStatically(points);
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar() {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props4 = this.props, points = _this$props4.points, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, children = _this$props4.children;
                var errorBarItems = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(children, (0, $6acdc3c09f8074d5$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                return errorBarItems.map(function(item, i) {
                    var direction = item.props.direction;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(item, {
                        key: i,
                        // eslint-disable-line react/no-array-index-key
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: direction === 'x' ? 'vertical' : 'horizontal',
                        dataPointFormatter: function dataPointFormatter(dataPoint, dataKey) {
                            return {
                                x: dataPoint.cx,
                                y: dataPoint.cy,
                                value: direction === 'x' ? +dataPoint.node.x : +dataPoint.node.y,
                                errorVal: (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(dataPoint, dataKey)
                            };
                        }
                    });
                });
            }
        },
        {
            key: "renderLine",
            value: function renderLine() {
                var _this$props5 = this.props, points = _this$props5.points, line = _this$props5.line, lineType = _this$props5.lineType, lineJointType = _this$props5.lineJointType;
                var scatterProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(this.props);
                var customLineProps = (0, $f43486451a1e41f4$export$d697c39a2985a4c)(line);
                var linePoints, lineItem;
                if (lineType === 'joint') linePoints = points.map(function(entry) {
                    return {
                        x: entry.cx,
                        y: entry.cy
                    };
                });
                else if (lineType === 'fitting') {
                    var _getLinearRegression = (0, $e6a593df52d5e247$export$484982720961754e)(points), xmin = _getLinearRegression.xmin, xmax = _getLinearRegression.xmax, a = _getLinearRegression.a, b = _getLinearRegression.b;
                    var linearExp = function linearExp(x) {
                        return a * x + b;
                    };
                    linePoints = [
                        {
                            x: xmin,
                            y: linearExp(xmin)
                        },
                        {
                            x: xmax,
                            y: linearExp(xmax)
                        }
                    ];
                }
                var lineProps = $41808cc75790078b$var$_objectSpread($41808cc75790078b$var$_objectSpread($41808cc75790078b$var$_objectSpread({}, scatterProps), {}, {
                    fill: 'none',
                    stroke: scatterProps && scatterProps.fill
                }, customLineProps), {}, {
                    points: linePoints
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(line)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(line, lineProps);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(line)) lineItem = line(lineProps);
                else lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $7eb448ddfde98505$export$b0e83c3ef8d2db1), $41808cc75790078b$var$_extends({}, lineProps, {
                    type: lineJointType
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    className: "recharts-scatter-line",
                    key: "recharts-scatter-line"
                }, lineItem);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, points = _this$props6.points, line = _this$props6.line, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, id = _this$props6.id, isAnimationActive = _this$props6.isAnimationActive;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))('recharts-scatter', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    className: layerClass,
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $a69f4be7c5584c1e$export$936d0764594b6eb3), {
                    key: "recharts-scatter-symbols"
                }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && (0, $18e58544181e4986$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "renderSymbolItem",
            value: function renderSymbolItem(option, props) {
                var symbol;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).isValidElement(option)) symbol = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($e151d7d4cf638963$exports)))(option)) symbol = option(props);
                else if (typeof option === 'string') symbol = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5pP8j))).createElement((0, $314ce5e1c1a9b04e$export$fa456266707bf4e4), $41808cc75790078b$var$_extends({}, props, {
                    type: option
                }));
                return symbol;
            }
        }
    ]);
    return Scatter;
}((0, $5pP8j.PureComponent));
$41808cc75790078b$var$_defineProperty($41808cc75790078b$export$1c460fb4285edadc, "displayName", 'Scatter');
$41808cc75790078b$var$_defineProperty($41808cc75790078b$export$1c460fb4285edadc, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    zAxisId: 0,
    legendType: 'circle',
    lineType: 'joint',
    lineJointType: 'linear',
    data: [],
    shape: 'circle',
    hide: false,
    isAnimationActive: !(0, $b477b0447f10d549$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'linear'
});
/**
 * Compose the data of each group
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $41808cc75790078b$var$_defineProperty($41808cc75790078b$export$1c460fb4285edadc, "getComposedData", function(_ref2) {
    var xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, zAxis = _ref2.zAxis, item = _ref2.item, displayedData = _ref2.displayedData, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, offset = _ref2.offset;
    var tooltipType = item.props.tooltipType;
    var cells = (0, $f43486451a1e41f4$export$fdd5e64c0e8495bb)(item.props.children, (0, $3249132f30d1cfdc$export$f6f0c3fe4ec306ea));
    var xAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
    var yAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
    var zAxisDataKey = zAxis && zAxis.dataKey;
    var defaultRangeZ = zAxis ? zAxis.range : (0, $d5f4afe2a4bd1f27$export$2363a7fa7edfe988).defaultProps.range;
    var defaultZ = defaultRangeZ && defaultRangeZ[0];
    var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
    var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
    var points = displayedData.map(function(entry, index) {
        var x = (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(entry, xAxisDataKey);
        var y = (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(entry, yAxisDataKey);
        var z = !(0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(zAxisDataKey) && (0, $de5fcafa56f48e7f$export$f97fc4a450f29a)(entry, zAxisDataKey) || '-';
        var tooltipPayload = [
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
                unit: xAxis.unit || '',
                value: x,
                payload: entry,
                dataKey: xAxisDataKey,
                type: tooltipType
            },
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($9ee5d1df64411cfe$exports)))(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
                unit: yAxis.unit || '',
                value: y,
                payload: entry,
                dataKey: yAxisDataKey,
                type: tooltipType
            }
        ];
        if (z !== '-') tooltipPayload.push({
            name: zAxis.name || zAxis.dataKey,
            unit: zAxis.unit || '',
            value: z,
            payload: entry,
            dataKey: zAxisDataKey,
            type: tooltipType
        });
        var cx = (0, $de5fcafa56f48e7f$export$6e87f3defb83c3f)({
            axis: xAxis,
            ticks: xAxisTicks,
            bandSize: xBandSize,
            entry: entry,
            index: index,
            dataKey: xAxisDataKey
        });
        var cy = (0, $de5fcafa56f48e7f$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: yBandSize,
            entry: entry,
            index: index,
            dataKey: yAxisDataKey
        });
        var size = z !== '-' ? zAxis.scale(z) : defaultZ;
        var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
        return $41808cc75790078b$var$_objectSpread($41808cc75790078b$var$_objectSpread({}, entry), {}, {
            cx: cx,
            cy: cy,
            x: cx - radius,
            y: cy - radius,
            xAxis: xAxis,
            yAxis: yAxis,
            zAxis: zAxis,
            width: 2 * radius,
            height: 2 * radius,
            size: size,
            node: {
                x: x,
                y: y,
                z: z
            },
            tooltipPayload: tooltipPayload,
            tooltipPosition: {
                x: cx,
                y: cy
            },
            payload: entry
        }, cells && cells[index] && cells[index].props);
    });
    return $41808cc75790078b$var$_objectSpread({
        points: points
    }, offset);
});






var $9211be4831e82141$export$f881f4f9e4007a57 = (0, $297828d4c9eb7748$export$77871aede60e6838)({
    chartName: 'ComposedChart',
    GraphicalChild: [
        (0, $22e4f653bf728fd5$export$17d680238e50603e),
        (0, $d68fcfd353925196$export$ea1a111407f37557),
        (0, $3629e45b25eceda8$export$bbc6c6369b38e3d1),
        (0, $41808cc75790078b$export$1c460fb4285edadc)
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $9a749d09d49d3786$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $00767df24e29675e$export$f96c4024c52de8f4)
        },
        {
            axisType: 'zAxis',
            AxisComp: (0, $d5f4afe2a4bd1f27$export$2363a7fa7edfe988)
        }
    ],
    formatAxisMap: (0, $6854f7e630297740$export$ece7de1383db5ac)
});


const $caac9d2ccb3531a4$var$BaseGraph = ({ data: data, axisId: axisId, axisLabel: axisLabel, domain: domain, padding: padding, referenceLine: referenceLine, hideBall: hideBall = false })=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $de9890f82317f82e$export$e60a4704009a0009), {
        width: "100%",
        height: 350,
        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $9211be4831e82141$export$f881f4f9e4007a57), {
            width: 500,
            height: 500,
            data: data,
            margin: {
                top: 10,
                right: 5,
                left: 0,
                bottom: 5
            },
            children: [
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $2b0870b1d8efc404$export$6440e27b9f186856), {
                    strokeDasharray: "2 2"
                }),
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $785732b572ee5e11$export$ed247974535929c7), {}),
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $9a749d09d49d3786$export$ea77231de273b52d), {
                    dataKey: "name",
                    padding: {
                        left: 20,
                        right: 20
                    }
                }),
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $00767df24e29675e$export$f96c4024c52de8f4), {
                    yAxisId: axisId,
                    domain: domain,
                    interval: "equidistantPreserveStart",
                    orientation: "left",
                    padding: padding
                }),
                referenceLine && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $8fcf83dc2a93007f$export$b2f28e248e7838eb), {
                    yAxisId: axisId,
                    y: referenceLine,
                    stroke: "#257942"
                }),
                !hideBall && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $3604a940d8232154$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $00767df24e29675e$export$f96c4024c52de8f4), {
                            yAxisId: "ball",
                            domain: [
                                6,
                                16
                            ],
                            orientation: "right",
                            tickCount: 6
                        }),
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $3629e45b25eceda8$export$bbc6c6369b38e3d1), {
                            name: "Ball Weight",
                            dataKey: "ball",
                            yAxisId: "ball",
                            barSize: 20,
                            fill: "#33993366",
                            children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $18e58544181e4986$export$835fcf23ab7bf88), {
                                dataKey: "ball",
                                position: "insideBottom"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $22e4f653bf728fd5$export$17d680238e50603e), {
                    name: "Average",
                    type: "monotone",
                    dataKey: "avg",
                    yAxisId: axisId,
                    stroke: "#ff3860",
                    dot: false
                }),
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $22e4f653bf728fd5$export$17d680238e50603e), {
                    name: axisLabel,
                    type: "monotone",
                    dataKey: axisId,
                    yAxisId: axisId,
                    stroke: "#209cee"
                })
            ]
        })
    });
var $caac9d2ccb3531a4$export$2e2bcd8739ae039 = $caac9d2ccb3531a4$var$BaseGraph;



const $6d4da33f336f5e60$var$ScoreGraph = ({ games: games, goal: goal, hideBall: hideBall = false })=>{
    const { stats: { avg: { best: best, worst: worst } } } = (0, $5f382a079ec029d4$export$c1cf1cf4c5d51937)();
    const data = (0, $5pP8j.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                score: game.score,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.score : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $3604a940d8232154$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("subtitle"),
                children: "Score"
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $caac9d2ccb3531a4$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Score per game",
                axisId: "score",
                domain: [
                    Math.max(0, worst),
                    Math.min(300, best)
                ],
                padding: {
                    top: 30,
                    bottom: 30
                },
                referenceLine: goal
            })
        ]
    });
};
var $6d4da33f336f5e60$export$2e2bcd8739ae039 = $6d4da33f336f5e60$var$ScoreGraph;


/* @leny/bowlstats
 *
 * /src/components/graphs/strikes.tsx
 */ 

var $5pP8j = parcelRequire("5pP8j");


const $38da032495b85464$var$StrikesGraph = ({ games: games, hideBall: hideBall = false })=>{
    const data = (0, $5pP8j.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                strikes: game.stats.strikes,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.stats.strikes : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $3604a940d8232154$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("subtitle", "mt-5"),
                children: "Strikes"
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $caac9d2ccb3531a4$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Strikes per game",
                axisId: "strikes",
                domain: [
                    0,
                    12
                ],
                padding: {
                    top: 30,
                    bottom: 30
                }
            })
        ]
    });
};
var $38da032495b85464$export$2e2bcd8739ae039 = $38da032495b85464$var$StrikesGraph;


/* @leny/bowlstats
 *
 * /src/components/graphs/spares.tsx
 */ 

var $5pP8j = parcelRequire("5pP8j");


const $9a5931f82c78cbbb$var$SparesGraph = ({ games: games, hideBall: hideBall = false })=>{
    const data = (0, $5pP8j.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                spares: game.stats.spares.total,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.stats.spares.total : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $3604a940d8232154$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("subtitle", "mt-5"),
                children: "Spares"
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $caac9d2ccb3531a4$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Spares per game",
                axisId: "spares",
                domain: [
                    0,
                    10
                ],
                padding: {
                    top: 30,
                    bottom: 30
                }
            })
        ]
    });
};
var $9a5931f82c78cbbb$export$2e2bcd8739ae039 = $9a5931f82c78cbbb$var$SparesGraph;


/* @leny/bowlstats
 *
 * /src/components/graphs/avg-first-ball-pinfall.tsx
 */ 

var $5pP8j = parcelRequire("5pP8j");


const $4c22257ef97f1866$var$AvgFirstBallPinfallGraph = ({ games: games, goal: goal, hideBall: hideBall = false })=>{
    const data = (0, $5pP8j.useMemo)(()=>games.map((game, idx, arr)=>({
                name: `${game.date.day}/${String(game.date.month).padStart(2, "0")}`,
                afbp: game.stats.avgFirstBallPinfall,
                ball: +(game.ball.startsWith("H") ? game.ball.slice(1) : game.ball),
                avg: arr.reduce((acc, gm, i)=>acc + (i <= idx ? gm.stats.avgFirstBallPinfall : 0), 0) / (idx + 1)
            })), [
        games
    ]);
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $3604a940d8232154$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("subtitle", "mt-5"),
                children: "Average First Ball Pinfall"
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $caac9d2ccb3531a4$export$2e2bcd8739ae039), {
                data: data,
                hideBall: hideBall,
                axisLabel: "Avg First Ball Pinfall",
                axisId: "afbp",
                domain: [
                    3,
                    10
                ],
                padding: {
                    top: 30,
                    bottom: 30
                },
                referenceLine: goal
            })
        ]
    });
};
var $4c22257ef97f1866$export$2e2bcd8739ae039 = $4c22257ef97f1866$var$AvgFirstBallPinfallGraph;




const $811cbbccaf80f662$var$NBSP = "\u00a0";
const $811cbbccaf80f662$var$Graphs = ()=>{
    const { games: games } = (0, $5f382a079ec029d4$export$c1cf1cf4c5d51937)();
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)((0, $3604a940d8232154$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $6d4da33f336f5e60$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true,
                goal: (0, (/*@__PURE__*/$parcel$interopDefault($404ccd9e674a6806$exports))).goals.avgScorePerGame
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $4c22257ef97f1866$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true,
                goal: (0, (/*@__PURE__*/$parcel$interopDefault($404ccd9e674a6806$exports))).goals.avgFirstBallPinfall
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $38da032495b85464$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $9a5931f82c78cbbb$export$2e2bcd8739ae039), {
                games: games,
                hideBall: true
            })
        ]
    });
};
var $811cbbccaf80f662$export$2e2bcd8739ae039 = $811cbbccaf80f662$var$Graphs;



const $1953592a355583a3$var$GamesContainer = ()=>{
    const [user, setUser] = (0, $5pP8j.useState)('Mike');
    const [year, setYear] = (0, $5pP8j.useState)(null);
    const [month, setMonth] = (0, $5pP8j.useState)(null);
    const [day, setDay] = (0, $5pP8j.useState)(null);
    const [withHouseBallGames, setWithHouseBallGames] = (0, $5pP8j.useState)(false);
    const [withDryLaneGames, setWithDryLaneGames] = (0, $5pP8j.useState)(false);
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $474651c903ea0c46$export$b514f4c5cf6dd8e6), {
        value: (0, $474651c903ea0c46$export$431f78a03a8ddc84)(user, year, month, day, withHouseBallGames, withDryLaneGames),
        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("container", "mx-auto"),
            children: [
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("hero"),
                    children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("hero-body"),
                        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("h3", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("title", "is-size-3"),
                            children: "Games"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("section", "pt-1"),
                    children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $4f185fdd507ab799$export$2e2bcd8739ae039), {
                        user: user,
                        year: year,
                        month: month,
                        day: day,
                        withHouseBallGames: withHouseBallGames,
                        withDryLaneGames: withDryLaneGames,
                        onYearChange: (y)=>{
                            setYear(y);
                        },
                        onMonthChange: (m)=>{
                            setMonth(m);
                        },
                        onDayChange: (d)=>{
                            setDay(d);
                        },
                        onUserChange: (u)=>setUser(u),
                        toggleHouseBallGames: (b)=>{
                            setWithHouseBallGames(b);
                        },
                        toggleDryLaneGames: (b)=>{
                            setWithDryLaneGames(b);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("section"),
                    children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $8c32eeaed83a1a3d$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("section", "columns"),
                    children: [
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("column"),
                            children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $fe2c876f96d55def$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("column"),
                            children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $811cbbccaf80f662$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            ]
        })
    });
};
var $1953592a355583a3$export$2e2bcd8739ae039 = $1953592a355583a3$var$GamesContainer;


/* @leny/bowlstats
 *
 * /src/containers/leagues.tsx
 */ 


/* @leny/bowlstats
 *
 * /src/components/leagues.tsx
 */ /* eslint-disable react/no-array-index-key */ // consistency is guaranteed here.


var $5pP8j = parcelRequire("5pP8j");



/* @leny/bowlstats
 *
 * /src/components/league-day.tsx
 */ 




var $5pP8j = parcelRequire("5pP8j");

const $221fb9b883d75111$var$NBSP = "\u00a0";
const $221fb9b883d75111$var$LeagueDay = ({ day: day })=>{
    const date = (0, $5pP8j.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1038fe58d0f12ce6$exports)))(new Date(day.date.year, day.date.month - 1, day.date.day)), [
        day
    ]);
    const $date = /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $6a7a9394089289ec$export$2e2bcd8739ae039), {
        date: date,
        showYear: true
    });
    const $dayTitle = /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("columns", "mb-2"),
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("column", "is-one-fifth"),
                children: [
                    "Day",
                    $221fb9b883d75111$var$NBSP,
                    day.dayIndex
                ]
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("h5", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("column", "is-flex", "is-justify-content-space-between", "is-align-items-center"),
                children: [
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                        children: day.team
                    }),
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-size-7", "has-text-grey"),
                        children: "vs"
                    }),
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                        children: day.vs
                    })
                ]
            })
        ]
    });
    if (day.bye) return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("notification", "is-light", "is-flex", "is-justify-content-space-between", "is-align-content-start", "px-5", "is-unselectable"),
        children: [
            $date,
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-flex-1", "is-flex", "is-flex-direction-column", "is-justify-content-center"),
                children: [
                    $dayTitle,
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-italic", "has-text-centered", "my-5"),
                        children: "bye"
                    }),
                    day.note && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("mb-3"),
                        children: [
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                                children: "Note:"
                            }),
                            $221fb9b883d75111$var$NBSP,
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-italic"),
                                children: day.note
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("notification", "is-light", "is-flex", "is-justify-content-space-between", "is-align-content-start", "px-5", "is-unselectable"),
        children: [
            $date,
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-flex-1", "is-flex", "is-flex-direction-column", "is-justify-content-center"),
                children: [
                    $dayTitle,
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("ol", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-no-list"),
                        children: day.games.map((game, idx)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("li", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("mb-2"),
                                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $76bc3af6f0cb3e60$export$2e2bcd8739ae039), {
                                    scratch: game.scratch,
                                    handicap: game.handicap,
                                    score: game.score,
                                    frames: game.frames,
                                    hideHeader: idx > 0
                                })
                            }, game.id))
                    }),
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("ul", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("mb-3"),
                        children: [
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-grey"),
                                        children: `Oil patterns (left, right):`
                                    }),
                                    $221fb9b883d75111$var$NBSP,
                                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                        children: day.oilPatterns.join(", ")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-grey"),
                                        children: `Average:`
                                    }),
                                    $221fb9b883d75111$var$NBSP,
                                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                        children: day.avg
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-grey"),
                                        children: `Handicap:`
                                    }),
                                    $221fb9b883d75111$var$NBSP,
                                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                        children: day.handicap
                                    })
                                ]
                            })
                        ]
                    }),
                    day.note && /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("mb-3"),
                        children: [
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                                children: "Note:"
                            }),
                            $221fb9b883d75111$var$NBSP,
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-italic"),
                                children: day.note
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $221fb9b883d75111$export$2e2bcd8739ae039 = $221fb9b883d75111$var$LeagueDay;


const $896475feb599bcc4$var$Leagues = ()=>{
    const { leagues: leagues } = (0, $5f382a079ec029d4$export$c1cf1cf4c5d51937)();
    const [selectedLeague, setSelectedLeague] = (0, $5pP8j.useState)(leagues[0]);
    if (!leagues.length) return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("section", "py-6"),
        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("p", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("has-text-centered", "has-text-grey", "my-6", "py-6"),
            children: "No leagues yet."
        })
    });
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("section", "columns", "pt-1"),
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("column", "is-one-fifth"),
                children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("ul", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("pt-6"),
                    children: leagues.map((league)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("li", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("mb-2"),
                            children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("a", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("button", "is-fullwidth", selectedLeague.name === league.name && "is-primary"),
                                onClick: (0, $0bbe7c18ba863365$export$fa3b29edae795ef4)(()=>{
                                    setSelectedLeague(league);
                                }),
                                children: league.name
                            })
                        }, league.name))
                })
            }),
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("column", "is-three-fifths"),
                children: [
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("h4", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("is-size-4", "mb-4"),
                        children: selectedLeague.name
                    }),
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
                        children: Array.from(selectedLeague.days).reverse().map((day, index)=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $221fb9b883d75111$export$2e2bcd8739ae039), {
                                day: day
                            }, `league-${selectedLeague.name}-day-${day}-idx-${index}`))
                    })
                ]
            })
        ]
    });
};
var $896475feb599bcc4$export$2e2bcd8739ae039 = $896475feb599bcc4$var$Leagues;


const $cb1182218c420b1f$var$LeaguesContainer = ()=>{
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $474651c903ea0c46$export$b514f4c5cf6dd8e6), {
        value: (0, $474651c903ea0c46$export$431f78a03a8ddc84)(),
        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("container", "mx-auto"),
            children: [
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("section", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("hero"),
                    children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("hero-body"),
                        children: [
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("h3", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("title", "is-size-3"),
                                children: "Leagues"
                            }),
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("h4", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("subtitle", "is-size-5", "has-text-grey"),
                                children: "Records of my league nights."
                            }),
                            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("p", {
                                children: "Those records are only my scores, and not the whole team's."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $896475feb599bcc4$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $cb1182218c420b1f$export$2e2bcd8739ae039 = $cb1182218c420b1f$var$LeaguesContainer;


/* @leny/bowlstats
 *
 * /src/components/footer.tsx
 */ 

const $a0d8d7bcb20b67fd$var$BSP = "\u0020";
const $a0d8d7bcb20b67fd$var$Footer = ()=>/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("footer", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("footer", "mt-6", "pb-6"),
        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("content", "has-text-centered"),
            children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("a", {
                        href: "https://github.com/leny/bowlstats",
                        target: "_new",
                        children: /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("strong", {
                            children: "bowlstats"
                        })
                    }),
                    $a0d8d7bcb20b67fd$var$BSP,
                    "by",
                    $a0d8d7bcb20b67fd$var$BSP,
                    /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)("a", {
                        href: "https://leny.me",
                        target: "_new",
                        children: "leny"
                    })
                ]
            })
        })
    });
var $a0d8d7bcb20b67fd$export$2e2bcd8739ae039 = $a0d8d7bcb20b67fd$var$Footer;


const $4c4e5f823e009087$var$RootContainer = ()=>{
    const [mode, setMode] = (0, $5pP8j.useState)("games");
    const $content = mode === "games" ? /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $1953592a355583a3$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $cb1182218c420b1f$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $3604a940d8232154$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e223c7d74c4e7757$exports)))("container", "is-fluid", "px-0"),
        children: [
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $1fc4605f822514f8$export$2e2bcd8739ae039), {
                mode: mode,
                onChangeMode: (v)=>{
                    setMode(v);
                }
            }),
            $content,
            /*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $a0d8d7bcb20b67fd$export$2e2bcd8739ae039), {})
        ]
    });
};
var $4c4e5f823e009087$export$2e2bcd8739ae039 = $4c4e5f823e009087$var$RootContainer;


const $0f75551d853dd57e$var$container = document.querySelector("#root");
(0, $a685d0cc2ecaee5c$export$882461b6382ed46c)($0f75551d853dd57e$var$container).render(/*#__PURE__*/ (0, $3604a940d8232154$exports.jsx)((0, $4c4e5f823e009087$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.8c08d12b.js.map
